export const statesData = [
  "Alaska",
  "Alabama",
  "Arkansas",
  "American Samoa",
  "Arizona",
  "California",
  "Colorado",
  "Connecticut",
  "District of Columbia",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Iowa",
  "Idaho",
  "Illinois",
  "Indiana",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Massachusetts",
  "Maryland",
  "Maine",
  "Michigan",
  "Minnesota",
  "Missouri",
  "Mississippi",
  "Montana",
  "North Carolina",
  "North Dakota",
  "Nebraska",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "Nevada",
  "New York",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Virginia",
  "Virgin Islands",
  "Vermont",
  "Washington",
  "Wisconsin",
  "West Virginia",
  "Wyoming",
];

export const timeZones = [
  "(UTC-05:00) Eastern Time (US and Canada)",
  "(UTC-06:00) Central Time (US and Canada)",
  "(UTC-08:00) Pacific Time (US and Canada)",
  "(UTC+00:00) Greenwich Mean Time, Dublin, London",
  "(UTC+01:00) Central European Time, Berlin, Paris",
  "(UTC+02:00) Eastern European Time, Athens, Bucharest",
  "(UTC+03:00) Moscow, Riyadh",
  "(UTC+09:00) Japan Standard Time, Tokyo",
  "(UTC+08:00) China Standard Time, Beijing, Singapore",
  "(UTC+10:00) Australian Eastern Time, Sydney",
  "(UTC+05:30) India Standard Time, New Delhi",
  "(UTC-03:00) Buenos Aires, Georgetown",
];

export const orgTypeData = ["nonprofit", "brand"];

export const orgSize = ["1-10", "11-50", "51-100", "100-1000", "1001+"];
//  export const naicsData = [
//    {
//      title:
//        'Radio and Television Broadcasting and Wireless Communications Equipment Manufacturing',
//      code: '334200',
//    },
//    { title: 'Electronic Computer Manufacturing', code: '334111' },
//    { title: 'Computer & Peripheral Equipment Mfg', code: '334110' },
//    { title: 'Computer & Peripheral Equipment Mfg', code: '334110' },
//  ];

export const registrationStatus = [
  "Registered",
  "Not Registered",
  "Pending Registration",
  "Other (Please Specify)",
];
export const orgIndustryNonProfits = [
  "Animal Welfare and Protection",
  "Arts, Culture, and Humanities",
  "Civil Rights and Advocacy",
  "Community and Economic Development",
  "Education and Research",
  "Environmental and Conservation",
  "Health and Wellness",
  "Human Services",
  "International Development and Relief",
  "Philanthropy, Grantmaking, and Foundations",
  "Religious and Spiritual",
  "Social and Public Policy",
  "Sports and Recreation",
  "Youth Development and Empowerment",
  "Business and Professional Associations",
  "Charity and Voluntary Organizations",
  "Child Welfare and Family Services",
  "Community Foundations",
  "Disability Services",
  "Emergency and Disaster Relief",
  "Employment and Training",
  "Housing and Homelessness",
  "Legal Services",
  "Mental Health and Counseling",
  "Veterans and Military Support",
  "Women's and Gender Issues",
  "Aging and Senior Services",
  "Arts Education and Instruction",
  "Cultural Heritage and Preservation",
  "Historical Societies and Museums",
  "Performing Arts",
  "Visual Arts and Crafts",
  "Research and Policy Institutes",
  "Environmental Conservation and Protection",
  "Natural Resource Management",
  "Wildlife and Animal Conservation",
  "Health Research and Education",
  "Disease Prevention and Treatment",
  "Rehabilitation and Therapy Services",
  "Food Security and Nutrition",
  "Humanitarian Aid and Assistance",
  "Poverty Alleviation and Economic Empowerment",
  "Education Policy and Advocacy",
  "Academic Research Institutes",
  "Science and Technology Education",
  "International Human Rights",
  "Refugee and Migrant Support",
  "Gender Equality and Women's Rights",
  "LGBTQ+ Advocacy and Support",
  "Social Justice and Equity",
];

export const test = ["test"];
export const orgIndustryBrands = [
  "Accommodation and Food Services",
  "Administration, Business Support and Waste Management Services",
  "Agriculture, Forestry, Fishing and Hunting",
  "Arts, Entertainment and Recreation",
  "Construction",
  "Educational Services",
  "Finance and Insurance",
  "Healthcare and Social Assistance",
  "Information",
  "Manufacturing",
  "Mining",
  "Other Services except Public Administration",
  "Professional, Scientific and Technical Services",
  "Real Estate and Rental and Leasing",
  "Retail Trade",
  "Transportation and Warehousing",
  "Utilities",
  "Wholesale Trade",
  "Advisory and Financial Services",
  "Business Franchises",
  "Consumer Goods and Services",
  "Industrial Machinery, Gas and Chemicals",
  "Life Sciences",
  "Online Retail",
  "Retail Market Reports",
  "Specialist Engineering, Infrastructure and Contractors",
  "Technology",
];

// export const orgIndustryBrands = [
//   "Advertising and Marketing",
//   "Agriculture and Farming",
//   "Airlines and Aviation",
//   "Automotive",
//   "Beauty and Personal Care",
//   "Biotechnology and Pharmaceuticals",
//   "Business Services",
//   "Chemicals and Materials",
//   "Construction and Contracting",
//   "Consulting and Advisory",
//   "Consumer Electronics",
//   "E-commerce and Online Retail",
//   "Education and Training",
//   "Energy and Utilities",
//   "Engineering and Manufacturing",
//   "Fashion and Apparel",
//   "Financial Services and Banking",
//   "Food and Beverage",
//   "Gaming and Entertainment",
//   "Healthcare and Medical Services",
//   "Hospitality and Tourism",
//   "Information Technology and Software",
//   "Insurance",
//   "Legal Services",
//   "Logistics and Supply Chain",
//   "Media and Publishing",
//   "Real Estate and Property",
//   "Retail and Consumer Goods",
//   "Sports and Recreation",
//   "Telecommunications",
//   "Transportation and Logistics",
//   "Travel and Hospitality",
//   "Other (Please Specify)",
// ];

// comannd right Arrow
// option shift i

export const countryData = [
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bangladesh",
  "Barbados",
  "Bahamas",
  "Bahrain",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "British Indian Ocean Territory",
  "British Virgin Islands",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burma",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo-Brazzaville",
  "Congo-Kinshasa",
  "Cook Islands",
  "Costa Rica",
  "$_[",
  "Croatia",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "El Salvador",
  "Egypt",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Federated States of Micronesia",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard and McDonald Islands",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn Islands",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Réunion",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthélemy",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre and Miquelon",
  "Saint Vincent",
  "Samoa",
  "San Marino",
  "São Tomé and Príncipe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Swaziland",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Vietnam",
  "Venezuela",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const naicsData = [
  {
    code: "111110",
    title: "Soybean farming, field and seed production",
  },
  {
    code: "111120",
    title: "Canola farming, field and seed production",
  },
  {
    code: "111120",
    title: "Flaxseed farming, field and seed production",
  },
  {
    code: "111120",
    title: "Mustard seed farming, field and seed production",
  },
  {
    code: "111120",
    title: "Oilseed farming (except soybean), field and seed production",
  },
  {
    code: "111120",
    title: "Rapeseed farming, field and seed production",
  },
  {
    code: "111120",
    title: "Safflower farming, field and seed production",
  },
  {
    code: "111120",
    title: "Sesame farming, field and seed production",
  },
  {
    code: "111120",
    title: "Sunflower farming, field and seed production",
  },
  {
    code: "111130",
    title: "Bean farming, dry, field and seed production",
  },
  {
    code: "111130",
    title: "Cowpea farming, dry, field and seed production",
  },
  {
    code: "111130",
    title: "Garbanzo farming, dry, field and seed production",
  },
  {
    code: "111130",
    title: "Lentil farming, dry, field and seed production",
  },
  {
    code: "111130",
    title: "Lima bean farming, dry, field and seed production",
  },
  {
    code: "111130",
    title: "Pea farming, dry, field and seed production",
  },
  {
    code: "111140",
    title: "Wheat farming, field and seed production",
  },
  {
    code: "111150",
    title: "Corn farming (except sweet corn), field and seed production",
  },
  {
    code: "111150",
    title: "Popcorn farming, field and seed production",
  },
  {
    code: "111160",
    title: "Rice (except wild rice) farming, field and seed production",
  },
  {
    code: "111191",
    title: "Oilseed and grain combination farming, field and seed production",
  },
  {
    code: "111199",
    title: "Barley farming, field and seed production",
  },
  {
    code: "111199",
    title: "Broomcorn farming",
  },
  {
    code: "111199",
    title: "Buckwheat farming",
  },
  {
    code: "111199",
    title: "Milo farming, field and seed production",
  },
  {
    code: "111199",
    title: "Oat farming, field and seed production",
  },
  {
    code: "111199",
    title: "Rye farming, field and seed production",
  },
  {
    code: "111199",
    title: "Sorghum farming, field and seed production",
  },
  {
    code: "111199",
    title: "Wild rice farming, field and seed production",
  },
  {
    code: "111211",
    title: "Potato farming, field and seed potato production",
  },
  {
    code: "111211",
    title: "Sweet potato farming, field and seed potato production",
  },
  {
    code: "111211",
    title:
      "Vegetable and melon farming, potato dominant crop, field and seed production",
  },
  {
    code: "111211",
    title:
      "Vegetable and potato farming, potato dominant crop, field and seed potato production",
  },
  {
    code: "111211",
    title: "Yam farming, field and seed production",
  },
  {
    code: "111219",
    title: "Acorn squash farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Artichoke farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Asparagus farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Bean (except dry) farming, field and seed production",
  },
  {
    code: "111219",
    title:
      "Beet farming (except sugar beets), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Broccoli farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Brussel sprout farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Butternut squash farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Cabbage farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Cantaloupe farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Carrot farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Casaba melon farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Cassava farming, field and seed production",
  },
  {
    code: "111219",
    title: "Cauliflower farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Celery farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Chinese pea farming, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Chive farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Collard farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Cowpea (except dry) farming, field and seed production",
  },
  {
    code: "111219",
    title: "Crenshaw melon farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Cucumber farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Dill farming, field and seed production",
  },
  {
    code: "111219",
    title:
      "Eggplant farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Endive farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "English pea farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Escarole farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Garlic farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Gingerroot farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Ginseng farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Green bean farming, field and seed production",
  },
  {
    code: "111219",
    title: "Green cowpea farming, field and seed production",
  },
  {
    code: "111219",
    title: "Green lima bean farming, field and seed production",
  },
  {
    code: "111219",
    title: "Green pea farming, field and seed production",
  },
  {
    code: "111219",
    title: "Honeydew melon farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Kale farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Leek farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Lettuce farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Melon farming (e.g., cantaloupe, casaba, honeydew, watermelon), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Muskmelon farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Okra farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Onion farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Parsley farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Parsnip farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Pea (except dry) farming, field and seed production",
  },
  {
    code: "111219",
    title: "Pepper (e.g., bell, chili, green, hot, red, sweet) farming",
  },
  {
    code: "111219",
    title: "Pumpkin farming, field and seed production",
  },
  {
    code: "111219",
    title: "Radish farming, field and seed production",
  },
  {
    code: "111219",
    title: "Rhubarb farming, field and seed production",
  },
  {
    code: "111219",
    title: "Romaine lettuce farming, field and seed production",
  },
  {
    code: "111219",
    title: "Rutabaga farming, field and seed production",
  },
  {
    code: "111219",
    title: "Shallot farming, field and seed production",
  },
  {
    code: "111219",
    title: "Snap bean farming (i.e., bush and pole), field and seed production",
  },
  {
    code: "111219",
    title: "Snow pea farming, field and seed production",
  },
  {
    code: "111219",
    title: "Spaghetti squash farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Spinach farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Squash farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "String bean farming, field and seed production",
  },
  {
    code: "111219",
    title: "Sweet corn farming, field and seed production",
  },
  {
    code: "111219",
    title: "Sweet pepper farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Taro farming, field and seed production",
  },
  {
    code: "111219",
    title:
      "Tomato farming (except under cover), field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Truck farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Turnip farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title:
      "Vegetable and melon farming, vegetable (except potato) and melon dominant crops, field, bedding plants and seed production",
  },
  {
    code: "111219",
    title:
      "Vegetable and potato farming, vegetable (except potato) dominant crops, field, bedding plants and seed production",
  },
  {
    code: "111219",
    title: "Watermelon farming, field, bedding plant and seed production",
  },
  {
    code: "111219",
    title: "Zucchini farming, field, bedding plant and seed production",
  },
  {
    code: "111310",
    title: "Orange groves",
  },
  {
    code: "111320",
    title: "Citrus groves (except orange)",
  },
  {
    code: "111320",
    title: "Grapefruit groves",
  },
  {
    code: "111320",
    title: "Lemon groves",
  },
  {
    code: "111320",
    title: "Lime groves",
  },
  {
    code: "111320",
    title: "Mandarin groves",
  },
  {
    code: "111320",
    title: "Tangelo groves",
  },
  {
    code: "111320",
    title: "Tangerine groves",
  },
  {
    code: "111331",
    title: "Apple orchards",
  },
  {
    code: "111332",
    title: "Grape farming without making wine",
  },
  {
    code: "111332",
    title: "Raisin farming",
  },
  {
    code: "111333",
    title: "Strawberry farming",
  },
  {
    code: "111334",
    title: "Berry (except strawberry) farming",
  },
  {
    code: "111334",
    title: "Blackberry farming",
  },
  {
    code: "111334",
    title: "Blueberry farming",
  },
  {
    code: "111334",
    title: "Boysenberry farming",
  },
  {
    code: "111334",
    title: "Cranberry farming",
  },
  {
    code: "111334",
    title: "Currant farming",
  },
  {
    code: "111334",
    title: "Dewberry farming",
  },
  {
    code: "111334",
    title: "Gooseberry farming",
  },
  {
    code: "111334",
    title: "Huckleberry farming",
  },
  {
    code: "111334",
    title: "Loganberry farming",
  },
  {
    code: "111334",
    title: "Raspberry farming",
  },
  {
    code: "111334",
    title: "Youngberry farming",
  },
  {
    code: "111335",
    title: "Almond farming",
  },
  {
    code: "111335",
    title: "Brazil nut farming",
  },
  {
    code: "111335",
    title: "Cashew farming",
  },
  {
    code: "111335",
    title: "Filbert farming",
  },
  {
    code: "111335",
    title: "Hazelnut farming",
  },
  {
    code: "111335",
    title: "Macadamia farming",
  },
  {
    code: "111335",
    title: "Pecan farming",
  },
  {
    code: "111335",
    title: "Pistachio farming",
  },
  {
    code: "111335",
    title: "Tree nut farming",
  },
  {
    code: "111335",
    title: "Walnut farming",
  },
  {
    code: "111336",
    title: "Fruit and tree nut combination farming",
  },
  {
    code: "111339",
    title: "Apricot farming",
  },
  {
    code: "111339",
    title: "Avocado farming",
  },
  {
    code: "111339",
    title: "Banana farming",
  },
  {
    code: "111339",
    title: "Cactus fruit farming",
  },
  {
    code: "111339",
    title: "Cherry farming",
  },
  {
    code: "111339",
    title: "Coconut tree farming",
  },
  {
    code: "111339",
    title: "Coffee farming",
  },
  {
    code: "111339",
    title: "Date farming",
  },
  {
    code: "111339",
    title: "Deciduous tree fruit (except apples, citrus) farming",
  },
  {
    code: "111339",
    title: "Fig farming",
  },
  {
    code: "111339",
    title: "Guava farming",
  },
  {
    code: "111339",
    title: "Kiwi fruit farming",
  },
  {
    code: "111339",
    title: "Mango farming",
  },
  {
    code: "111339",
    title: "Nectarine farming",
  },
  {
    code: "111339",
    title: "Noncitrus fruit farming",
  },
  {
    code: "111339",
    title: "Olive farming",
  },
  {
    code: "111339",
    title: "Papaya farming",
  },
  {
    code: "111339",
    title: "Passion fruit farming",
  },
  {
    code: "111339",
    title: "Peach farming",
  },
  {
    code: "111339",
    title: "Pear farming",
  },
  {
    code: "111339",
    title: "Persimmon farming",
  },
  {
    code: "111339",
    title: "Pineapple farming",
  },
  {
    code: "111339",
    title: "Plantain farming",
  },
  {
    code: "111339",
    title: "Plum farming",
  },
  {
    code: "111339",
    title: "Pomegranate farming",
  },
  {
    code: "111339",
    title: "Prickly pear farming",
  },
  {
    code: "111339",
    title: "Prune farming",
  },
  {
    code: "111339",
    title: "Quince farming",
  },
  {
    code: "111411",
    title: "Mushroom farming",
  },
  {
    code: "111411",
    title: "Mushroom spawn farming",
  },
  {
    code: "111411",
    title: "Shitake mushroom farming",
  },
  {
    code: "111419",
    title: "Alfalfa sprout farming, grown under cover",
  },
  {
    code: "111419",
    title: "Bean sprout farming,  grown under cover",
  },
  {
    code: "111419",
    title: "Cannabis, grown under cover",
  },
  {
    code: "111419",
    title: "Cucumber farming, grown under cover",
  },
  {
    code: "111419",
    title: "Eggplant farming, grown under cover",
  },
  {
    code: "111419",
    title: "Endive farming, grown under cover",
  },
  {
    code: "111419",
    title: "English pea farming, grown under cover",
  },
  {
    code: "111419",
    title: "Escarole farming, grown under cover",
  },
  {
    code: "111419",
    title: "Fruit farming, grown under cover",
  },
  {
    code: "111419",
    title: "Garlic farming, grown under cover",
  },
  {
    code: "111419",
    title: "Gingerroot farming, grown under cover",
  },
  {
    code: "111419",
    title: "Ginseng farming, grown under cover",
  },
  {
    code: "111419",
    title: "Hemp, grown under cover",
  },
  {
    code: "111419",
    title: "Herb farming, grown under cover",
  },
  {
    code: "111419",
    title: "Hydroponic crop farming",
  },
  {
    code: "111419",
    title: "Marijuana, grown under cover",
  },
  {
    code: "111419",
    title: "Melon farming, grown under cover",
  },
  {
    code: "111419",
    title: "Rhubarb, grown under cover",
  },
  {
    code: "111419",
    title: "Spice farming, grown under cover",
  },
  {
    code: "111419",
    title: "Tomato farming, grown under cover",
  },
  {
    code: "111419",
    title: "Truffles farming, grown under cover",
  },
  {
    code: "111419",
    title: "Vegetable farming, grown under cover",
  },
  {
    code: "111421",
    title: "Azalea farming",
  },
  {
    code: "111421",
    title: "Christmas tree growing",
  },
  {
    code: "111421",
    title: "Corms farming",
  },
  {
    code: "111421",
    title: "Field nurseries (i.e., growing of flowers and shrubbery)",
  },
  {
    code: "111421",
    title: "Flower bulb growing",
  },
  {
    code: "111421",
    title: "Fruit stock (e.g., plants, seedlings, trees) growing",
  },
  {
    code: "111421",
    title: "Herbaceous perennial growing",
  },
  {
    code: "111421",
    title: "Nursery stock growing",
  },
  {
    code: "111421",
    title: "Nursery with tree production (except for reforestation)",
  },
  {
    code: "111421",
    title: "Preseeded mat farming",
  },
  {
    code: "111421",
    title: "Propagation material farming",
  },
  {
    code: "111421",
    title: "Rose bush growing",
  },
  {
    code: "111421",
    title:
      "Short rotation woody tree growing (i.e., growing and harvesting cycle ten years or less)",
  },
  {
    code: "111421",
    title: "Shrubbery farming",
  },
  {
    code: "111421",
    title: "Sod farming",
  },
  {
    code: "111421",
    title: "Tissue culture farming",
  },
  {
    code: "111421",
    title:
      "Tree crop farming (except forestry), short rotation growing and harvesting cycle",
  },
  {
    code: "111421",
    title: "Turf farming",
  },
  {
    code: "111422",
    title: "Bedding plant growing (except vegetable and melon bedding plants)",
  },
  {
    code: "111422",
    title: "Cultivated florist greens growing",
  },
  {
    code: "111422",
    title: "Cut flower growing",
  },
  {
    code: "111422",
    title: "Cut rose growing",
  },
  {
    code: "111422",
    title: "Cuttings farming",
  },
  {
    code: "111422",
    title: "Flower growing",
  },
  {
    code: "111422",
    title: "Flower seed production",
  },
  {
    code: "111422",
    title: "Foliage growing",
  },
  {
    code: "111422",
    title: "Hanging basket plant growing",
  },
  {
    code: "111422",
    title: "House plant growing",
  },
  {
    code: "111422",
    title: "Ornamental plant growing",
  },
  {
    code: "111422",
    title: "Plant, ornamental, growing",
  },
  {
    code: "111422",
    title: "Plant, potted flower and foliage, growing",
  },
  {
    code: "111422",
    title: "Plug (i.e., floriculture products) growing",
  },
  {
    code: "111910",
    title: "Tobacco farming, field and seed production",
  },
  {
    code: "111920",
    title: "Cotton farming, field and seed production",
  },
  {
    code: "111920",
    title: "Cottonseed farming",
  },
  {
    code: "111930",
    title: "Cane farming, sugar, field production",
  },
  {
    code: "111930",
    title: "Sugarcane farming, field production",
  },
  {
    code: "111940",
    title: "Alfalfa hay farming",
  },
  {
    code: "111940",
    title: "Clover hay farming",
  },
  {
    code: "111940",
    title: "Grass hay farming",
  },
  {
    code: "111940",
    title: "Hay farming (e.g., alfalfa hay, clover hay, grass hay)",
  },
  {
    code: "111940",
    title: "Mixed hay farming",
  },
  {
    code: "111991",
    title: "Sugar beet farming",
  },
  {
    code: "111992",
    title: "Peanut farming",
  },
  {
    code: "111998",
    title: "Agave farming",
  },
  {
    code: "111998",
    title: "Alfalfa seed farming",
  },
  {
    code: "111998",
    title: "Aloe farming",
  },
  {
    code: "111998",
    title: "Amaranth farming",
  },
  {
    code: "111998",
    title: "Bentgrass seed farming",
  },
  {
    code: "111998",
    title: "Bluegrass-Kentucky seed farming",
  },
  {
    code: "111998",
    title: "Cannabis, grown in an open field",
  },
  {
    code: "111998",
    title: "Chicory farming",
  },
  {
    code: "111998",
    title: "Clover seed farming",
  },
  {
    code: "111998",
    title: "Crimson cloves seed farming",
  },
  {
    code: "111998",
    title: "Fescue seed farming",
  },
  {
    code: "111998",
    title:
      "General combination crop farming (except fruit and nut combinations, oilseed and grain, vegetable)",
  },
  {
    code: "111998",
    title: "Grass seed farming",
  },
  {
    code: "111998",
    title: "Guar farming",
  },
  {
    code: "111998",
    title: "Hay seed farming",
  },
  {
    code: "111998",
    title: "Hemp, grown in an open field",
  },
  {
    code: "111998",
    title: "Herb farming, open field",
  },
  {
    code: "111998",
    title: "Hop farming",
  },
  {
    code: "111998",
    title: "Jojoba farming",
  },
  {
    code: "111998",
    title: "Kenaf farming",
  },
  {
    code: "111998",
    title:
      "Maple sap concentrating (i.e., producing pure maple syrup in the field)",
  },
  {
    code: "111998",
    title: "Maple sap gathering",
  },
  {
    code: "111998",
    title: "Maple syrup (i.e., maple sap reducing)",
  },
  {
    code: "111998",
    title: "Marijuana, grown in an open field",
  },
  {
    code: "111998",
    title: "Mint farming",
  },
  {
    code: "111998",
    title: "Orchard grass seed farming",
  },
  {
    code: "111998",
    title: "Ryegrass seed farming",
  },
  {
    code: "111998",
    title: "Sorghum sudan seed farming",
  },
  {
    code: "111998",
    title: "Spice farming",
  },
  {
    code: "111998",
    title: "Syrup, pure maple (i.e., maple syrup reducing)",
  },
  {
    code: "111998",
    title: "Tea farming",
  },
  {
    code: "112111",
    title: "Backgrounding, cattle",
  },
  {
    code: "112111",
    title: "Beef cattle ranching or farming",
  },
  {
    code: "112111",
    title: "Calf (e.g., feeder, stocker, veal) production",
  },
  {
    code: "112111",
    title: "Cattle conditioning operations",
  },
  {
    code: "112111",
    title: "Cattle farming or ranching",
  },
  {
    code: "112111",
    title: "Dairy heifer replacement production",
  },
  {
    code: "112111",
    title: "Feeder calf production",
  },
  {
    code: "112111",
    title: "Stocker calf production",
  },
  {
    code: "112111",
    title: "Veal calf production",
  },
  {
    code: "112112",
    title: "Beef cattle feedlots (except stockyards for transportation)",
  },
  {
    code: "112112",
    title: "Cattle feedlots (except stockyards for transportation)",
  },
  {
    code: "112112",
    title: "Fattening cattle",
  },
  {
    code: "112112",
    title: "Feed yards (except stockyards for transportation), cattle",
  },
  {
    code: "112112",
    title: "Feedlots (except stockyards for transportation), cattle",
  },
  {
    code: "112120",
    title: "Dairy cattle farming",
  },
  {
    code: "112120",
    title: "Milk production, dairy cattle",
  },
  {
    code: "112120",
    title: "Milking dairy cattle",
  },
  {
    code: "112210",
    title: "Farrow-to-finish operations",
  },
  {
    code: "112210",
    title: "Feeder pig farming",
  },
  {
    code: "112210",
    title: "Feedlots (except stockyards for transportation), hog",
  },
  {
    code: "112210",
    title:
      "Hog and pig (including breeding, farrowing, nursery, and finishing activities) farming",
  },
  {
    code: "112210",
    title: "Hog feedlots (except stockyards for transportation)",
  },
  {
    code: "112210",
    title: "Pig farming",
  },
  {
    code: "112210",
    title: "Swine farming",
  },
  {
    code: "112210",
    title: "Weaning pig operations",
  },
  {
    code: "112310",
    title: "Chicken egg production",
  },
  {
    code: "112310",
    title: "Chicken eggs (table, hatching) production",
  },
  {
    code: "112310",
    title: "Cull hen production",
  },
  {
    code: "112310",
    title: "Egg production, chicken",
  },
  {
    code: "112310",
    title: "Eggs, chicken (table, hatching) production",
  },
  {
    code: "112310",
    title: "Layer-type chicken production",
  },
  {
    code: "112310",
    title: "Started pullet production",
  },
  {
    code: "112320",
    title: "Broiler chicken production",
  },
  {
    code: "112320",
    title: "Chicken production (except egg laying)",
  },
  {
    code: "112320",
    title: "Cornish hen production",
  },
  {
    code: "112320",
    title: "Fryer chicken production",
  },
  {
    code: "112320",
    title: "Roaster chicken production",
  },
  {
    code: "112330",
    title: "Egg production, turkey",
  },
  {
    code: "112330",
    title: "Turkey egg production",
  },
  {
    code: "112330",
    title: "Turkey production",
  },
  {
    code: "112340",
    title: "Chicken hatcheries",
  },
  {
    code: "112340",
    title: "Egg hatcheries, poultry",
  },
  {
    code: "112340",
    title: "Hatcheries, poultry",
  },
  {
    code: "112340",
    title: "Poultry hatcheries",
  },
  {
    code: "112340",
    title: "Turkey hatcheries",
  },
  {
    code: "112390",
    title: "Chukar partridge production",
  },
  {
    code: "112390",
    title: "Duck production",
  },
  {
    code: "112390",
    title: "Emu production",
  },
  {
    code: "112390",
    title: "Geese production",
  },
  {
    code: "112390",
    title: "Hungarian partridge production",
  },
  {
    code: "112390",
    title: "Ostrich production",
  },
  {
    code: "112390",
    title: "Partridge production",
  },
  {
    code: "112390",
    title: "Pheasant production",
  },
  {
    code: "112390",
    title: "Quail production",
  },
  {
    code: "112390",
    title: "Ratite production",
  },
  {
    code: "112410",
    title: "Dairy sheep farming",
  },
  {
    code: "112410",
    title: "Feedlots (except stockyards for transportation), lamb",
  },
  {
    code: "112410",
    title: "Lamb feedlots (except stockyards for transportation)",
  },
  {
    code: "112410",
    title: "Milking dairy sheep",
  },
  {
    code: "112410",
    title: "Sheep farming (e.g., meat, milk, wool production)",
  },
  {
    code: "112420",
    title: "Angora goat farming",
  },
  {
    code: "112420",
    title: "Dairy goat farming",
  },
  {
    code: "112420",
    title: "Goat farming (e.g., meat, milk, mohair production)",
  },
  {
    code: "112420",
    title: "Milking dairy goat",
  },
  {
    code: "112420",
    title: "Mohair farming",
  },
  {
    code: "112511",
    title: "Baitfish production, farm raising",
  },
  {
    code: "112511",
    title: "Catfish production, farm raising",
  },
  {
    code: "112511",
    title: "Finfish production, farm raising",
  },
  {
    code: "112511",
    title: "Finfish, hatcheries",
  },
  {
    code: "112511",
    title: "Fish farms, finfish",
  },
  {
    code: "112511",
    title: "Goldfish production, farm raising",
  },
  {
    code: "112511",
    title: "Hatcheries, finfish",
  },
  {
    code: "112511",
    title: "Hybrid striped bass production",
  },
  {
    code: "112511",
    title: "Minnow production, farm raising",
  },
  {
    code: "112511",
    title: "Ornamental fish production, farm raising",
  },
  {
    code: "112511",
    title: "Tilapia production",
  },
  {
    code: "112511",
    title: "Tropical fish production, farm raising",
  },
  {
    code: "112511",
    title: "Trout production, farm raising",
  },
  {
    code: "112512",
    title: "Clam production, farm raising",
  },
  {
    code: "112512",
    title: "Crawfish production, farm raising",
  },
  {
    code: "112512",
    title: "Crustacean production, farm raising",
  },
  {
    code: "112512",
    title: "Cultured pearl production, farm raising",
  },
  {
    code: "112512",
    title: "Fish farms, shellfish",
  },
  {
    code: "112512",
    title: "Hatcheries, shellfish",
  },
  {
    code: "112512",
    title: "Mollusk production, farm raising",
  },
  {
    code: "112512",
    title: "Mussel production, farm raising",
  },
  {
    code: "112512",
    title: "Oyster production, farm raising",
  },
  {
    code: "112512",
    title: "Shellfish hatcheries",
  },
  {
    code: "112512",
    title: "Shrimp production, farm raising",
  },
  {
    code: "112519",
    title: "Algae farming",
  },
  {
    code: "112519",
    title: "Alligator production, farm raising",
  },
  {
    code: "112519",
    title: "Animal aquaculture (except finfish, shellfish)",
  },
  {
    code: "112519",
    title: "Frog production, farm raising",
  },
  {
    code: "112519",
    title: "Plant aquaculture",
  },
  {
    code: "112519",
    title: "Sea plant agriculture",
  },
  {
    code: "112519",
    title: "Seaweed farming",
  },
  {
    code: "112519",
    title: "Turtle production, farm raising",
  },
  {
    code: "112910",
    title: "Bee pollen collection",
  },
  {
    code: "112910",
    title: "Bee production (i.e., apiculture)",
  },
  {
    code: "112910",
    title: "Beeswax production",
  },
  {
    code: "112910",
    title: "Honey bee production",
  },
  {
    code: "112910",
    title: "Propolis production, bees",
  },
  {
    code: "112910",
    title: "Queen bee production",
  },
  {
    code: "112910",
    title: "Royal jelly production, bees",
  },
  {
    code: "112920",
    title: "Burro production",
  },
  {
    code: "112920",
    title: "Donkey production",
  },
  {
    code: "112920",
    title: "Horse (including thoroughbreds) production",
  },
  {
    code: "112920",
    title: "Mule production",
  },
  {
    code: "112920",
    title: "Pony production",
  },
  {
    code: "112930",
    title: "Chinchilla production",
  },
  {
    code: "112930",
    title: "Fox production",
  },
  {
    code: "112930",
    title: "Fur-bearing animal production",
  },
  {
    code: "112930",
    title: "Mink production",
  },
  {
    code: "112930",
    title: "Rabbit production",
  },
  {
    code: "112990",
    title: "Alpaca production",
  },
  {
    code: "112990",
    title: "Aviaries (i.e., raising birds for sale)",
  },
  {
    code: "112990",
    title: "Bird production (e.g., canaries, love birds, parakeets, parrots)",
  },
  {
    code: "112990",
    title: "Bison production",
  },
  {
    code: "112990",
    title: "Breeding of butterflies",
  },
  {
    code: "112990",
    title: "Breeding of pets (e.g., birds, cats, dogs)",
  },
  {
    code: "112990",
    title: "Buffalo production",
  },
  {
    code: "112990",
    title: "Cat production",
  },
  {
    code: "112990",
    title: "Combination livestock farming (except dairy, poultry)",
  },
  {
    code: "112990",
    title:
      "Companion animals production (e.g., cats, dogs, parakeets, parrots)",
  },
  {
    code: "112990",
    title: "Cricket production",
  },
  {
    code: "112990",
    title: "Deer production",
  },
  {
    code: "112990",
    title: "Dog production",
  },
  {
    code: "112990",
    title: "Earthworm hatcheries",
  },
  {
    code: "112990",
    title: "Elk production",
  },
  {
    code: "112990",
    title: "General combination animal farming",
  },
  {
    code: "112990",
    title: "Kennels, breeding and raising stock for sale",
  },
  {
    code: "112990",
    title: "Laboratory animal production (e.g., guinea pigs, mice, rats)",
  },
  {
    code: "112990",
    title: "Llama production",
  },
  {
    code: "112990",
    title: "Raising swans, peacocks, flamingos, or other adornment birds",
  },
  {
    code: "112990",
    title: "Rattlesnake production",
  },
  {
    code: "112990",
    title: "Worm production",
  },
  {
    code: "113110",
    title: "Timber tract operations",
  },
  {
    code: "113210",
    title: "Aromatic wood gathering",
  },
  {
    code: "113210",
    title: "Balsam needles gathering",
  },
  {
    code: "113210",
    title: "Bark gathering",
  },
  {
    code: "113210",
    title: "Cherry gum, gathering",
  },
  {
    code: "113210",
    title: "Chestnut gum, gathering",
  },
  {
    code: "113210",
    title: "Forest nurseries for reforestation, growing trees",
  },
  {
    code: "113210",
    title: "Gathering of forest products (e.g., barks, gums, needles, seeds)",
  },
  {
    code: "113210",
    title: "Gathering, extracting, and selling tree seeds",
  },
  {
    code: "113210",
    title: "Ginseng gathering",
  },
  {
    code: "113210",
    title: "Gum (i.e., forest product) gathering",
  },
  {
    code: "113210",
    title: "Harvesting berries or nuts from native and non-cultivated plants",
  },
  {
    code: "113210",
    title: "Hemlock gum gathering",
  },
  {
    code: "113210",
    title: "Huckleberry greens, gathering of",
  },
  {
    code: "113210",
    title: "Moss gathering",
  },
  {
    code: "113210",
    title: "Nurseries for reforestation growing trees",
  },
  {
    code: "113210",
    title: "Pine gum extracting",
  },
  {
    code: "113210",
    title: "Spanish moss gathering",
  },
  {
    code: "113210",
    title: "Sphagnum moss gathering",
  },
  {
    code: "113210",
    title: "Spruce gum gathering",
  },
  {
    code: "113210",
    title: "Teaberries gathering",
  },
  {
    code: "113210",
    title: "Tree seed extracting",
  },
  {
    code: "113210",
    title: "Tree seed gathering",
  },
  {
    code: "113210",
    title: "Tree seed growing for reforestation",
  },
  {
    code: "113210",
    title: "Truffles gathering",
  },
  {
    code: "113310",
    title: "Cutting and transporting timber",
  },
  {
    code: "113310",
    title: "Cutting timber",
  },
  {
    code: "113310",
    title: "Log harvesting",
  },
  {
    code: "113310",
    title: "Logging",
  },
  {
    code: "113310",
    title: "Pulpwood logging camps",
  },
  {
    code: "113310",
    title: "Rails, rough wood, manufacturing",
  },
  {
    code: "113310",
    title: "Stump removing in the field",
  },
  {
    code: "113310",
    title: "Timber piling",
  },
  {
    code: "113310",
    title: "Timber pole cutting",
  },
  {
    code: "113310",
    title: "Tree chipping in the field",
  },
  {
    code: "113310",
    title: "Wood chipping in the field",
  },
  {
    code: "114111",
    title: "Anchovy fishing",
  },
  {
    code: "114111",
    title: "Bluefish fishing",
  },
  {
    code: "114111",
    title: "Cod catching",
  },
  {
    code: "114111",
    title: "Cod fishing",
  },
  {
    code: "114111",
    title: "Croaker fishing",
  },
  {
    code: "114111",
    title: "Dolphin fishing",
  },
  {
    code: "114111",
    title: "Eel fishing",
  },
  {
    code: "114111",
    title: "Finfish fishing (e.g., flounder, salmon, trout)",
  },
  {
    code: "114111",
    title: "Fisheries, finfish",
  },
  {
    code: "114111",
    title: "Flounder fishing",
  },
  {
    code: "114111",
    title: "Grouper fishing",
  },
  {
    code: "114111",
    title: "Haddock fishing",
  },
  {
    code: "114111",
    title: "Hake fishing",
  },
  {
    code: "114111",
    title: "Halibut fishing",
  },
  {
    code: "114111",
    title: "Herring fishing",
  },
  {
    code: "114111",
    title: "Lingcod fishing",
  },
  {
    code: "114111",
    title: "Mackerel fishing",
  },
  {
    code: "114111",
    title: "Mahimahi fishing",
  },
  {
    code: "114111",
    title: "Menhaden fishing",
  },
  {
    code: "114111",
    title: "Mullet fishing",
  },
  {
    code: "114111",
    title: "Perch fishing",
  },
  {
    code: "114111",
    title: "Pilchard fishing",
  },
  {
    code: "114111",
    title: "Pollock fishing",
  },
  {
    code: "114111",
    title: "Porgy fishing",
  },
  {
    code: "114111",
    title: "Ray fishing",
  },
  {
    code: "114111",
    title: "Rockfish fishing",
  },
  {
    code: "114111",
    title: "Sablefish fishing",
  },
  {
    code: "114111",
    title: "Salmon fishing",
  },
  {
    code: "114111",
    title: "Sea bass fishing",
  },
  {
    code: "114111",
    title: "Sea herring fishing",
  },
  {
    code: "114111",
    title: "Sea trout fishing",
  },
  {
    code: "114111",
    title: "Shark fishing",
  },
  {
    code: "114111",
    title: "Snapper fishing",
  },
  {
    code: "114111",
    title: "Swordfish fishing",
  },
  {
    code: "114111",
    title: "Tilefish fishing",
  },
  {
    code: "114111",
    title: "Trout fishing",
  },
  {
    code: "114111",
    title: "Tuna fishing",
  },
  {
    code: "114111",
    title: "Whiting fishing",
  },
  {
    code: "114112",
    title: "Clam digging",
  },
  {
    code: "114112",
    title: "Crabbing",
  },
  {
    code: "114112",
    title: "Crayfish fishing",
  },
  {
    code: "114112",
    title: "Fisheries, shellfish",
  },
  {
    code: "114112",
    title: "Lobster fishing",
  },
  {
    code: "114112",
    title: "Mussel fishing",
  },
  {
    code: "114112",
    title: "Octopus fishing",
  },
  {
    code: "114112",
    title: "Oyster dredging",
  },
  {
    code: "114112",
    title: "Scallop fishing",
  },
  {
    code: "114112",
    title: "Sea urchin fishing",
  },
  {
    code: "114112",
    title: "Shellfish fishing (e.g., clam, crab, oyster, shrimp)",
  },
  {
    code: "114112",
    title: "Shrimp fishing",
  },
  {
    code: "114112",
    title: "Squid fishing",
  },
  {
    code: "114119",
    title: "Frog fishing",
  },
  {
    code: "114119",
    title: "Seaweed gathering",
  },
  {
    code: "114119",
    title: "Sponge gathering",
  },
  {
    code: "114119",
    title: "Terrapin fishing",
  },
  {
    code: "114119",
    title: "Turtle fishing",
  },
  {
    code: "114210",
    title: "Animal trapping, commercial",
  },
  {
    code: "114210",
    title: "Fishing preserves",
  },
  {
    code: "114210",
    title: "Game preserves, commercial",
  },
  {
    code: "114210",
    title: "Game propagation",
  },
  {
    code: "114210",
    title: "Game retreats",
  },
  {
    code: "114210",
    title: "Hunting preserves",
  },
  {
    code: "115111",
    title: "Cotton ginning",
  },
  {
    code: "115111",
    title: "Ginning cotton",
  },
  {
    code: "115112",
    title:
      "Aerial crop dusting or spraying (i.e., using specialized or dedicated aircraft)",
  },
  {
    code: "115112",
    title: "Bracing of orchard trees and vines",
  },
  {
    code: "115112",
    title: "Chemical treatment of soil for crops",
  },
  {
    code: "115112",
    title: "Citrus grove cultivation services",
  },
  {
    code: "115112",
    title: "Crop dusting",
  },
  {
    code: "115112",
    title: "Crop spraying",
  },
  {
    code: "115112",
    title: "Cultivation services",
  },
  {
    code: "115112",
    title: "Detasseling corn",
  },
  {
    code: "115112",
    title: "Disease control for crops",
  },
  {
    code: "115112",
    title: "Dusting crops",
  },
  {
    code: "115112",
    title: "Entomological service, agricultural",
  },
  {
    code: "115112",
    title: "Fertilizer application for crops",
  },
  {
    code: "115112",
    title: "Hoeing",
  },
  {
    code: "115112",
    title: "Insect control for crops",
  },
  {
    code: "115112",
    title:
      "Orchard cultivation services (e.g., bracing, planting, pruning, removal, spraying, surgery)",
  },
  {
    code: "115112",
    title: "Pest control services, agricultural",
  },
  {
    code: "115112",
    title: "Planting crops",
  },
  {
    code: "115112",
    title: "Plowing",
  },
  {
    code: "115112",
    title: "Pollinating",
  },
  {
    code: "115112",
    title: "Pruning of orchard trees and vines",
  },
  {
    code: "115112",
    title: "Seed bed preparing",
  },
  {
    code: "115112",
    title: "Seeding crops",
  },
  {
    code: "115112",
    title: "Spraying crops",
  },
  {
    code: "115112",
    title: "Spreading lime for crops",
  },
  {
    code: "115112",
    title: "Surgery on trees and vines",
  },
  {
    code: "115112",
    title: "Thinning of crops, mechanical and chemical",
  },
  {
    code: "115112",
    title: "Transplanting services",
  },
  {
    code: "115112",
    title: "Vineyard cultivation services",
  },
  {
    code: "115112",
    title: "Weed control services for crops",
  },
  {
    code: "115113",
    title: "Berries, machine harvesting",
  },
  {
    code: "115113",
    title: "Chopping and silo filling",
  },
  {
    code: "115113",
    title: "Combining, agricultural",
  },
  {
    code: "115113",
    title: "Cotton, machine harvesting",
  },
  {
    code: "115113",
    title: "Fruit, machine harvesting",
  },
  {
    code: "115113",
    title: "Grain, machine harvesting",
  },
  {
    code: "115113",
    title: "Hay mowing, raking, baling, and chopping",
  },
  {
    code: "115113",
    title: "Nuts, machine harvesting",
  },
  {
    code: "115113",
    title: "Peanut, machine harvesting",
  },
  {
    code: "115113",
    title: "Sugar beets, machine harvesting",
  },
  {
    code: "115113",
    title: "Sugarcane, machine harvesting",
  },
  {
    code: "115113",
    title: "Threshing service",
  },
  {
    code: "115113",
    title: "Vegetables, machine harvesting",
  },
  {
    code: "115114",
    title: "Almond hulling and shelling",
  },
  {
    code: "115114",
    title: "Banana ripening",
  },
  {
    code: "115114",
    title: "Bean cleaning",
  },
  {
    code: "115114",
    title: "Corn drying",
  },
  {
    code: "115114",
    title: "Corn shelling",
  },
  {
    code: "115114",
    title: "Crop cleaning",
  },
  {
    code: "115114",
    title: "Decorticating flax",
  },
  {
    code: "115114",
    title: "Delinting cottonseed",
  },
  {
    code: "115114",
    title: "Filbert hulling and shelling",
  },
  {
    code: "115114",
    title: "Fruit precooling",
  },
  {
    code: "115114",
    title: "Fruit sorting, grading, and packing",
  },
  {
    code: "115114",
    title: "Fruit, sun drying",
  },
  {
    code: "115114",
    title: "Fruit, vacuum cooling",
  },
  {
    code: "115114",
    title: "Fumigating grain",
  },
  {
    code: "115114",
    title: "Grain cleaning",
  },
  {
    code: "115114",
    title: "Grain drying",
  },
  {
    code: "115114",
    title: "Grain fumigation",
  },
  {
    code: "115114",
    title: "Grain grinding (except custom grinding for animal feed)",
  },
  {
    code: "115114",
    title: "Hulling and shelling of nuts",
  },
  {
    code: "115114",
    title: "Irradiation of fruits and vegetables",
  },
  {
    code: "115114",
    title: "Nut hulling and shelling",
  },
  {
    code: "115114",
    title: "Packaging fresh or farm-dried fruits and vegetables",
  },
  {
    code: "115114",
    title: "Packing fruits and vegetables",
  },
  {
    code: "115114",
    title: "Peanut shelling",
  },
  {
    code: "115114",
    title: "Pecan hulling and shelling",
  },
  {
    code: "115114",
    title: "Potato curing",
  },
  {
    code: "115114",
    title: "Retting flax",
  },
  {
    code: "115114",
    title: "Rice drying",
  },
  {
    code: "115114",
    title: "Seed cleaning",
  },
  {
    code: "115114",
    title: "Seed processing, postharvest for propagation",
  },
  {
    code: "115114",
    title: "Sorting, grading, cleaning, and packing of fruits and vegetables",
  },
  {
    code: "115114",
    title: "Sun drying of dates, prunes, raisins, and olives",
  },
  {
    code: "115114",
    title: "Sun drying of fruits and vegetables",
  },
  {
    code: "115114",
    title: "Sun drying of tomatoes",
  },
  {
    code: "115114",
    title: "Sweet potato curing",
  },
  {
    code: "115114",
    title: "Tobacco grading",
  },
  {
    code: "115114",
    title: "Vegetable precooling",
  },
  {
    code: "115114",
    title: "Vegetable sorting, grading, and packing",
  },
  {
    code: "115114",
    title: "Vegetable sun drying",
  },
  {
    code: "115114",
    title: "Vegetable vacuum cooling",
  },
  {
    code: "115114",
    title: "Walnut hulling and shelling",
  },
  {
    code: "115114",
    title: "Waxing, fruits or vegetables",
  },
  {
    code: "115115",
    title: "Agriculture production or harvesting crews",
  },
  {
    code: "115115",
    title: "Crew leaders, farm labor",
  },
  {
    code: "115115",
    title: "Farm labor contractors",
  },
  {
    code: "115115",
    title: "Labor contractors, farm",
  },
  {
    code: "115116",
    title: "Farm management services",
  },
  {
    code: "115116",
    title: "Management services, farm",
  },
  {
    code: "115210",
    title: "Animal semen banks",
  },
  {
    code: "115210",
    title: "Artificial insemination services for livestock",
  },
  {
    code: "115210",
    title: "Artificial insemination services for pets",
  },
  {
    code: "115210",
    title: "Boarding horses (except racehorses)",
  },
  {
    code: "115210",
    title: "Branding",
  },
  {
    code: "115210",
    title: "Breeding, animal, services",
  },
  {
    code: "115210",
    title: "Bull testing stations",
  },
  {
    code: "115210",
    title: "Cattle spraying",
  },
  {
    code: "115210",
    title: "Cleaning poultry houses",
  },
  {
    code: "115210",
    title: "Corralling, drovers",
  },
  {
    code: "115210",
    title: "Dairy herd improvement associations",
  },
  {
    code: "115210",
    title: "Equine boarding",
  },
  {
    code: "115210",
    title: "Farriers",
  },
  {
    code: "115210",
    title: "Hoof trimming",
  },
  {
    code: "115210",
    title: "Horses (except racehorses), boarding",
  },
  {
    code: "115210",
    title: "Horses, training (except racehorses)",
  },
  {
    code: "115210",
    title: "Horseshoeing",
  },
  {
    code: "115210",
    title: "Livestock breeding services (except consulting)",
  },
  {
    code: "115210",
    title: "Livestock spraying",
  },
  {
    code: "115210",
    title: "Milk testing for butterfat and milk solids",
  },
  {
    code: "115210",
    title: "Pedigree (i.e., livestock, pets, poultry) record services",
  },
  {
    code: "115210",
    title: "Poultry catching services",
  },
  {
    code: "115210",
    title: "Reproductive flushing services for animals",
  },
  {
    code: "115210",
    title: "Semen collection",
  },
  {
    code: "115210",
    title: "Sexing services for poultry (e.g., separating males/females)",
  },
  {
    code: "115210",
    title: "Sheep dipping and shearing",
  },
  {
    code: "115210",
    title: "Showing of cattle, hogs, sheep, goats, and poultry",
  },
  {
    code: "115210",
    title: "Stud services",
  },
  {
    code: "115210",
    title: "Training horses (except racehorses)",
  },
  {
    code: "115210",
    title: "Vaccinating livestock (except by veterinarians)",
  },
  {
    code: "115310",
    title: "Aerial forest firefighting",
  },
  {
    code: "115310",
    title: "Aerial forest mulching or seeding",
  },
  {
    code: "115310",
    title: "Aerial wildland firefighting",
  },
  {
    code: "115310",
    title: "Cruising timber",
  },
  {
    code: "115310",
    title: "Estimating timber",
  },
  {
    code: "115310",
    title: "Fire prevention, forest",
  },
  {
    code: "115310",
    title: "Firefighting, forest",
  },
  {
    code: "115310",
    title: "Forest management plans preparation",
  },
  {
    code: "115310",
    title: "Forest thinning",
  },
  {
    code: "115310",
    title: "Forestry services",
  },
  {
    code: "115310",
    title: "Pest control services, forestry",
  },
  {
    code: "115310",
    title: "Reforestation (except forest nurseries)",
  },
  {
    code: "115310",
    title: "Timber valuation",
  },
  {
    code: "211120",
    title: "Crude petroleum from oil sand",
  },
  {
    code: "211120",
    title: "Crude petroleum from oil shale",
  },
  {
    code: "211120",
    title: "Crude petroleum lease condensate production",
  },
  {
    code: "211120",
    title: "Crude petroleum production",
  },
  {
    code: "211120",
    title: "Kerogen processing",
  },
  {
    code: "211120",
    title: "Offshore crude petroleum production",
  },
  {
    code: "211120",
    title: "Oil field development for own account",
  },
  {
    code: "211120",
    title: "Oil field exploration for own account",
  },
  {
    code: "211120",
    title: "Oil shale mining and/or beneficiating",
  },
  {
    code: "211120",
    title:
      "Operating crude petroleum field gathering lines, except on a contract basis",
  },
  {
    code: "211120",
    title: "Petroleum, crude, production (i.e., extraction)",
  },
  {
    code: "211120",
    title: "Shale, oil, mining and/or beneficiating",
  },
  {
    code: "211120",
    title: "Stripper oil well production",
  },
  {
    code: "211120",
    title: "Tar sands mining",
  },
  {
    code: "211130",
    title: "Butane, natural, mining",
  },
  {
    code: "211130",
    title: "Casing-head butane and propane production",
  },
  {
    code: "211130",
    title: "Coal gasification at mine site",
  },
  {
    code: "211130",
    title: "Coal liquefaction at mine site",
  },
  {
    code: "211130",
    title: "Coal pyrolysis",
  },
  {
    code: "211130",
    title: "Condensate, cycle, natural gas production",
  },
  {
    code: "211130",
    title: "Cycle condensate production",
  },
  {
    code: "211130",
    title: "Ethane recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Fractionating natural gas liquids",
  },
  {
    code: "211130",
    title: "Gas field development for own account",
  },
  {
    code: "211130",
    title: "Gas field exploration for own account",
  },
  {
    code: "211130",
    title: "Gas, natural liquefied petroleum, extraction",
  },
  {
    code: "211130",
    title: "Gas, natural, extraction",
  },
  {
    code: "211130",
    title: "Gas, natural, liquids, extraction",
  },
  {
    code: "211130",
    title: "Gas, residue, extraction",
  },
  {
    code: "211130",
    title: "Gases, petroleum, liquefied, extraction",
  },
  {
    code: "211130",
    title: "Gasoline, natural, production",
  },
  {
    code: "211130",
    title: "Isobutane recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Isopentane recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Liquefied petroleum gases (LPG), natural",
  },
  {
    code: "211130",
    title: "Liquid hydrocarbons recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title:
      "Liquids, natural gas (e.g., ethane, isobutane, natural gasoline, propane) recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Natural gas liquid lease condensate production",
  },
  {
    code: "211130",
    title:
      "Natural gas liquids (e.g., ethane, isobutane, natural gasoline, propane) recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Natural gas production",
  },
  {
    code: "211130",
    title: "Natural gas, offshore production",
  },
  {
    code: "211130",
    title: "Natural gasoline recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Offshore natural gas production",
  },
  {
    code: "211130",
    title: "Oil line drip, natural gas liquid",
  },
  {
    code: "211130",
    title:
      "Operating natural gas liquid field gathering lines, except on a contract basis",
  },
  {
    code: "211130",
    title:
      "Petroleum gases, liquefied, recovering from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Propane recovered from oil and gas field gases",
  },
  {
    code: "211130",
    title: "Residue gas production",
  },
  {
    code: "211130",
    title: "Stripper gas well production",
  },
  {
    code: "211130",
    title: "Sulfur recovered from natural gas",
  },
  {
    code: "212114",
    title:
      "Bituminous coal, lignite, or anthracite beneficiating (e.g., cleaning, crushing, screening, washing, sizing)",
  },
  {
    code: "212114",
    title:
      "Bituminous coal, lignite, or anthracite surface mine site development for own account",
  },
  {
    code: "212114",
    title:
      "Bituminous coal, lignite, or anthracite surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title: "Brown coal mining and/or beneficiating",
  },
  {
    code: "212114",
    title:
      "Coal beneficiating plants (e.g., cleaning, crushing, screening, washing)",
  },
  {
    code: "212114",
    title: "Coal stripping (except on a contract, fee, or other basis)",
  },
  {
    code: "212114",
    title:
      "Coal, bituminous, lignite, or anthracite, surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title: "Coal, brown, mining and/or beneficiating",
  },
  {
    code: "212114",
    title:
      "Culm bank recovery, bituminous coal, lignite, or anthracite (except on a contract basis)",
  },
  {
    code: "212114",
    title: "Hard coal (i.e., anthracite) surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title: "Lignite surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title: "Preparation plants, coal",
  },
  {
    code: "212114",
    title: "Semianthracite surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title: "Semibituminous coal surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title:
      "Strip mining, bituminous coal, lignite, or anthracite, on own account",
  },
  {
    code: "212114",
    title: "Subbituminous coal surface mining and/or beneficiating",
  },
  {
    code: "212114",
    title: "Tipple operation, bituminous coal mining and/or beneficiating",
  },
  {
    code: "212115",
    title:
      "Bituminous coal or anthracite underground mine site development for own account",
  },
  {
    code: "212115",
    title: "Bituminous coal or anthracite underground mining",
  },
  {
    code: "212115",
    title: "Coal, bituminous or anthracite, underground mining",
  },
  {
    code: "212115",
    title: "Hard coal (i.e., anthracite) underground mining",
  },
  {
    code: "212115",
    title: "Semianthracite underground mining",
  },
  {
    code: "212115",
    title: "Semibituminous coal underground mining",
  },
  {
    code: "212115",
    title: "Subbituminous coal underground mining",
  },
  {
    code: "212210",
    title: "Agglomerates, iron ore, beneficiating",
  },
  {
    code: "212210",
    title: "Briquets, iron, mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Brown ore mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Hematite mining and/or beneficiating",
  },
  {
    code: "212210",
    title:
      "Iron ore (e.g., hematite, magnetite, siderite, taconite) mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Iron ore agglomerates mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Iron ore beneficiating plants (e.g., agglomeration, sintering)",
  },
  {
    code: "212210",
    title: "Iron ore mine site development for own account",
  },
  {
    code: "212210",
    title: "Iron ore, blocked, mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Limonite mining and/or beneficiating",
  },
  {
    code: "212210",
    title:
      "Manganiferous ores valued for iron content, mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Siderite mining and/or beneficiating",
  },
  {
    code: "212210",
    title: "Sintered iron ore produced at the mine",
  },
  {
    code: "212210",
    title: "Taconite concentrates or agglomerates beneficiating",
  },
  {
    code: "212210",
    title: "Taconite ores mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Bullion, gold, produced at the mine",
  },
  {
    code: "212220",
    title: "Bullion, silver, produced at the mine",
  },
  {
    code: "212220",
    title: "Calaverite mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Gold lode mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Gold ore mine site development for own account",
  },
  {
    code: "212220",
    title: "Gold ore mining and/or beneficiating plants",
  },
  {
    code: "212220",
    title:
      "Gold ores, concentrates, bullion, and/or precipitates mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Gold placer mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Lode gold mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Placer gold mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Placer silver mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Silver ore mine site development for own account",
  },
  {
    code: "212220",
    title: "Silver ores mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Sylvanite mining and/or beneficiating",
  },
  {
    code: "212220",
    title: "Telluride (gold) mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Blende (zinc) mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Calamine mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Cerussite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Chalcocite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Chalcopyrite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Copper beneficiating plants",
  },
  {
    code: "212230",
    title: "Copper ore concentrates recovery",
  },
  {
    code: "212230",
    title: "Copper ore mine site development for own account",
  },
  {
    code: "212230",
    title: "Copper ores mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Copper-water precipitates",
  },
  {
    code: "212230",
    title: "Cuprite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Galena mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Lead ore mine site development for own account",
  },
  {
    code: "212230",
    title: "Lead ore mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Lead-zinc ore mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Nickel concentrates recovery",
  },
  {
    code: "212230",
    title: "Nickel ore beneficiating plants",
  },
  {
    code: "212230",
    title: "Nickel ore mine site development for own account",
  },
  {
    code: "212230",
    title: "Nickel ores mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Smithsonite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Sphalerite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Willemite mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Zinc ore mine site development for own account",
  },
  {
    code: "212230",
    title: "Zinc ores mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Zinc-blende (sphalerite) mining and/or beneficiating",
  },
  {
    code: "212230",
    title: "Zincite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Antimony concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Antimony ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Bastnaesite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Bauxite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Beryl mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Beryllium concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Beryllium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Carnotite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Cerium concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Cerium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Chromite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Chromium concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Chromium ore mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Cinnabar mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Cobalt concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Cobalt ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Columbite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Columbium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Ferberite ores and concentrates mining and/or beneficiating",
  },
  {
    code: "212290",
    title:
      "Ferroalloy ores (e.g., chromium, columbium, molybdenum, tungsten) mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Hafnium mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Huebnerite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Ilmenite ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Iridium mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Leaching of uranium, radium, or vanadium ores",
  },
  {
    code: "212290",
    title: "Manganese concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Manganese ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title:
      "Manganiferous ores (not valued for iron content) mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Manganite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Mercury (quicksilver) mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Mercury ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Microlite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Molybdenite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Molybdenum ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Molybdite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Monazite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Osmium mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Palladium mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Pitchblende mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Platinum mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Psilomelane mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Pyrolusite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Quicksilver ores and metal mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Radium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Rare earth metal concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Rare earth metal ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Rhodium mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Rhodochrosite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Roscoelite (vanadium hydromica) mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Ruthenium ore mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Rutile mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Scheelite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Tantalite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Tantalum ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Thallium mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Thorite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Thorium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Tin metal concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Tin metal ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title:
      "Titaniferous-magnetite ores, valued chiefly for titanium content, mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Titanium concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Titanium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Tungsten concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Tungsten ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Tyuyamunite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Uraninite (pitchblende) mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Uranium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Uranium-radium-vanadium ore mine site development for own account",
  },
  {
    code: "212290",
    title: "Uranium-radium-vanadium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Vanadium ores mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Wolframite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Wulfenite mining and/or beneficiating",
  },
  {
    code: "212290",
    title: "Zirconium concentrates beneficiating",
  },
  {
    code: "212290",
    title: "Zirconium ores mining and/or beneficiating",
  },
  {
    code: "212311",
    title: "Argillite mining or quarrying",
  },
  {
    code: "212311",
    title: "Basalt mining or quarrying",
  },
  {
    code: "212311",
    title: "Bluestone mining or quarrying",
  },
  {
    code: "212311",
    title: "Calcareous tufa mining or quarrying",
  },
  {
    code: "212311",
    title: "Diabase mining or quarrying",
  },
  {
    code: "212311",
    title: "Dimension stone mining or quarrying",
  },
  {
    code: "212311",
    title: "Diorite mining or quarrying",
  },
  {
    code: "212311",
    title: "Dolomite mining or quarrying",
  },
  {
    code: "212311",
    title: "Dolomitic marble mining or quarrying",
  },
  {
    code: "212311",
    title: "Flagstone mining or quarrying",
  },
  {
    code: "212311",
    title: "Gabbro mining or quarrying",
  },
  {
    code: "212311",
    title: "Gneiss mining or quarrying",
  },
  {
    code: "212311",
    title: "Granite mining or quarrying",
  },
  {
    code: "212311",
    title: "Greenstone mining or quarrying",
  },
  {
    code: "212311",
    title: "Limestone mining or quarrying",
  },
  {
    code: "212311",
    title: "Marble mining or quarrying",
  },
  {
    code: "212311",
    title: "Mica schist mining or quarrying",
  },
  {
    code: "212311",
    title: "Onyx marble mining or quarrying",
  },
  {
    code: "212311",
    title: "Quartzite dimension stone mining or quarrying",
  },
  {
    code: "212311",
    title: "Sandstone mining or quarrying",
  },
  {
    code: "212311",
    title: "Schist, mica, mining or quarrying",
  },
  {
    code: "212311",
    title: "Serpentine mining or quarrying",
  },
  {
    code: "212311",
    title: "Slate mining or quarrying",
  },
  {
    code: "212311",
    title: "Stone, dimension, mining or quarrying",
  },
  {
    code: "212311",
    title: "Syenite (except nepheline) mining or quarrying",
  },
  {
    code: "212311",
    title: "Trap rock mining or quarrying",
  },
  {
    code: "212311",
    title: "Travertine mining or quarrying",
  },
  {
    code: "212311",
    title: "Tufa, calcareous, mining or quarrying",
  },
  {
    code: "212311",
    title: "Verde' antique mining or quarrying",
  },
  {
    code: "212311",
    title: "Volcanic rock, mining or quarrying",
  },
  {
    code: "212312",
    title: "Agricultural limestone mining and/or beneficiating",
  },
  {
    code: "212312",
    title:
      "Calcareous tufa crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Cement rock crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Chalk crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Chalk, ground or otherwise treated, mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Dolomite crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Lime rock, ground, mining and/or beneficiating",
  },
  {
    code: "212312",
    title:
      "Limestone (except bituminous) crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Limestone beneficiating plants (e.g., grinding or pulverizing)",
  },
  {
    code: "212312",
    title: "Marl crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Riprap, limestone, mining or quarrying",
  },
  {
    code: "212312",
    title: "Riprap, limestone, preparation plants",
  },
  {
    code: "212312",
    title: "Travertine crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212312",
    title:
      "Tufa, calcareous, crushed and broken stone, mining and/or beneficiating",
  },
  {
    code: "212312",
    title: "Whiting crushed and broken stone, mining and/or beneficiating",
  },
  {
    code: "212313",
    title: "Diorite crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212313",
    title: "Gneiss crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212313",
    title: "Granite beneficiating plants (e.g., grinding or pulverizing)",
  },
  {
    code: "212313",
    title: "Granite crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212313",
    title: "Riprap, granite, mining or quarrying",
  },
  {
    code: "212313",
    title: "Riprap, granite, preparation plants",
  },
  {
    code: "212313",
    title:
      "Syenite (except nepheline) crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Basalt crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Bituminous limestone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Bituminous sandstone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Boulder crushed and broken mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Diabase crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title:
      "Dolomitic marble crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Gabbro crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Ganister crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Granules, slate, mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Grits crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Limestone, bituminous, mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Marble crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Mica schist crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Onyx marble crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Quartzite crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Riprap (except granite, limestone) preparation plants",
  },
  {
    code: "212319",
    title: "Riprap (except limestone and granite) mining or quarrying",
  },
  {
    code: "212319",
    title: "Sandstone crushed and broken stone mining",
  },
  {
    code: "212319",
    title:
      "Schist, mica, crushed and broken stone, mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Serpentine crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Slate crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title:
      "Stone (except limestone and granite) beneficiating plants (e.g., grinding)",
  },
  {
    code: "212319",
    title:
      "Stone, crushed and broken (except granite or limestone), mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Trap rock crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title:
      "Verde' antique crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212319",
    title: "Volcanic rock crushed and broken stone mining and/or beneficiating",
  },
  {
    code: "212321",
    title: "Common sand quarrying and/or beneficiating",
  },
  {
    code: "212321",
    title:
      "Construction sand and gravel beneficiating (e.g., grinding, screening, washing)",
  },
  {
    code: "212321",
    title: "Construction sand or gravel dredging",
  },
  {
    code: "212321",
    title: "Gravel quarrying and/or beneficiating",
  },
  {
    code: "212321",
    title: "Pebbles (except grinding) mining and/or beneficiating",
  },
  {
    code: "212321",
    title:
      "Sand and gravel quarrying (i.e., construction grade) and/or beneficiating",
  },
  {
    code: "212321",
    title: "Sand, construction grade, quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Abrasive sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Blast sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Enamel sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Filtration sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Foundry sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Glass sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Grinding sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Industrial sand beneficiating (e.g., screening, washing)",
  },
  {
    code: "212322",
    title: "Industrial sand sandpits and dredging",
  },
  {
    code: "212322",
    title: "Molding sand quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Sand, blast, quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title:
      "Sand, industrial (e.g., engine, filtration, glass grinding, proppant), quarrying and/or beneficiating",
  },
  {
    code: "212322",
    title: "Silica mining and/or beneficiating",
  },
  {
    code: "212322",
    title: "Silica sand quarrying and/or beneficiating",
  },
  {
    code: "212323",
    title: "Andalusite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Aplite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Ball clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Bentonite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Bleaching clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Brucite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Burley mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "China clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Clay bleaching",
  },
  {
    code: "212323",
    title: "Clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Clay, ball, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Clay, ceramic and refractory minerals, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Clay, fire, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Clay, natural, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Common clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Common shale mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Cornwall stone mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Cyanite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Diaspore mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Dumortierite mining and/or beneficiating",
  },
  {
    code: "212323",
    title:
      "Earth, fuller's (e.g., all natural bleaching clays), mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Feldspar mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Fire clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Flint clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Fuller's earth mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Kaolin mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Kyanite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Laterite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Magnesite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Nepheline syenite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Olivine, non-gem, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Paper clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Pegmatite, feldspar, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Pinite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Plastic fire clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Refractory minerals mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Rubber clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Shale (except oil shale) mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Sillimanite mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Slip clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Stoneware clay mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Syenite, nepheline, mining and/or beneficiating",
  },
  {
    code: "212323",
    title: "Topaz, non-gem, mining and/or beneficiating",
  },
  {
    code: "212390",
    title:
      "Abrasive stones (e.g., emery, grindstones, hones, pumice) mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Abrasives, natural (except sand), mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Agate mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Alabaster mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Alum, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Alunite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Amblygonite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Amethyst mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Apatite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Arsenic mineral mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Asbestos mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Ash, volcanic, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Asphalt rock mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Asphalt, native, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Barite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Barium ores mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Barytes mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Borate, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Borax, crude, ground or pulverized, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Boron compounds prepared at beneficiating plants",
  },
  {
    code: "212390",
    title: "Boron mineral mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Brimstone mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Burrstones, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Calcined phosphate rock mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Calcite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Catlinite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Celestite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Chasers mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Colemanite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Corundum mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Cryolite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Diamonds, industrial, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Diatomaceous earth mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Diatomite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Dragstones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Dried phosphate rock mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Earth, diatomaceous, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Emery mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Fertilizer minerals, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Fill dirt pits mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Fluorite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Fluorspar mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Garnet mining and/or beneficiating",
  },
  {
    code: "212390",
    title:
      "Gem stone (e.g., amethyst, garnet, agate, ruby, sapphire, jade) mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Gilsonite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Glauber's salt mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Grahamite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Graphite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Greensand mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Grinding pebbles mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Grindstones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Guano mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Gypsite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Gypsum mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Hones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Humus, peat, mining and/or beneficiating",
  },
  {
    code: "212390",
    title:
      "Iceland spar (i.e., optical grade calcite), mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Jade mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Kernite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Lepidolite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Lithium mineral mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Marcasite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Meerschaum mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Mica mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Millstones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Mineral pigments, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Muriate of potash, mining",
  },
  {
    code: "212390",
    title: "Muscovite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Native asphalt mining and/or beneficiating",
  },
  {
    code: "212390",
    title:
      "Natural abrasives (e.g., emery, grindstones, hones, pumice) (except sand) mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Ocher mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Oilstones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Optical grade calcite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Ozokerite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pavers mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Peat grinding",
  },
  {
    code: "212390",
    title: "Peat humus mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Peat mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pebbles grinding",
  },
  {
    code: "212390",
    title: "Perlite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Phlogopite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Phosphate rock mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pigments, natural, mineral, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pipestones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Potash mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Potassium bromide, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Potassium chloride mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Potassium compounds prepared at beneficiating plants",
  },
  {
    code: "212390",
    title: "Potassium compounds, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Potassium salts, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pozzolana mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Precious stones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Probertite mining and/or quarrying",
  },
  {
    code: "212390",
    title: "Pulpstones, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pumice mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pumicite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pyrite concentrates mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pyrite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pyrophyllite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Pyrrhotite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Quartz crystal, pure, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Reed peat mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Rock salt mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Rubbing stones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Ruby mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Salines mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Salt, common, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Salt, rock, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sapphire mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Scoria mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Screening peat",
  },
  {
    code: "212390",
    title: "Scythestones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sedge peat mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Selenite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Semiprecious stones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Shell mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Shredding peat mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sienna mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sintered phosphate rock mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Soapstone mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Soda ash mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Soda ash, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sodium borates, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sodium carbonates, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sodium chloride, rock salt, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sodium compounds prepared at beneficiating plants",
  },
  {
    code: "212390",
    title: "Sodium compounds, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sodium sulfate, natural, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Spar, iceland, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Spodumene mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Staurolite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Steatite mining and/or beneficiating",
  },
  {
    code: "212390",
    title:
      "Stones, abrasive (e.g., emery, grindstones, hones, pumice), mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Strontianite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Strontium mineral mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sulfate, sodium, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sulfur mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Sulfur, native, mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Talc mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Tripoli mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Trona mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Turquoise mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Ulexite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Umber mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Vermiculite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Volcanic ash mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Whetstones mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Wollastonite mining and/or beneficiating",
  },
  {
    code: "212390",
    title: "Wurtzilite mining and/or beneficiating",
  },
  {
    code: "213111",
    title: "Directional drilling of oil and gas wells on a contract basis",
  },
  {
    code: "213111",
    title: "Drilling directional oil and gas field wells on a contract basis",
  },
  {
    code: "213111",
    title: "Drilling for gas on a contract basis",
  },
  {
    code: "213111",
    title: "Drilling for oil on a contract basis",
  },
  {
    code: "213111",
    title: "Drilling gas and oil field wells on a contract basis",
  },
  {
    code: "213111",
    title: "Drilling oil and gas field service wells on a contract basis",
  },
  {
    code: "213111",
    title: "Drilling water intake wells, oil and gas field on a contract basis",
  },
  {
    code: "213111",
    title: "Gas well drilling on a contract basis",
  },
  {
    code: "213111",
    title:
      "Oil and gas well drilling services (redrilling, spudding, tailing) on a contract basis",
  },
  {
    code: "213111",
    title: "Oil well drilling on a contract basis",
  },
  {
    code: "213111",
    title: "Reconditioning oil and gas field wells on a contract basis",
  },
  {
    code: "213111",
    title: "Reworking oil and gas wells on a contract basis",
  },
  {
    code: "213111",
    title: "Service well drilling on a contract basis",
  },
  {
    code: "213111",
    title: "Spudding in oil and gas wells on a contract basis",
  },
  {
    code: "213111",
    title: "Tailing in oil and gas field wells on a contract basis",
  },
  {
    code: "213111",
    title: "Water intake well drilling, oil and gas field on a contract basis",
  },
  {
    code: "213111",
    title:
      "Well drilling (i.e., oil, gas, water intake wells) on a contract basis",
  },
  {
    code: "213111",
    title: "Workover of oil and gas wells on a contract basis",
  },
  {
    code: "213112",
    title: "Acidizing oil and gas field wells on a contract basis",
  },
  {
    code: "213112",
    title: "Building oil and gas well foundations on a contract basis",
  },
  {
    code: "213112",
    title:
      "Building, erecting, repairing, and dismantling oil and gas field rigs and derricks on a contract basis",
  },
  {
    code: "213112",
    title: "Cementing oil and gas well casings on a contract basis",
  },
  {
    code: "213112",
    title:
      "Chemically treating oil and gas wells (e.g., acidizing, bailing, swabbing) on a contract basis",
  },
  {
    code: "213112",
    title: "Cleaning oil and gas field lease tanks on a contract basis",
  },
  {
    code: "213112",
    title:
      "Cleaning out (e.g., bailing out, steam cleaning, swabbing) wells on a contract basis",
  },
  {
    code: "213112",
    title: "Cleaning wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Cleaning, repairing, and dismantling oil and gas field lease tanks on a contract basis",
  },
  {
    code: "213112",
    title:
      "Contract services (except geophysical surveying and mapping, site preparation, construction, and transportation activities) for oil and gas fields",
  },
  {
    code: "213112",
    title: "Core cutting in oil and gas wells, on a contract basis",
  },
  {
    code: "213112",
    title: "Core drilling, exploration services, oil and gas field",
  },
  {
    code: "213112",
    title: "Cutting cores in oil and gas wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Derrick building, repairing, and dismantling at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title: "Dismantling of oil well rigs on a contract basis",
  },
  {
    code: "213112",
    title:
      "Drilling rat holes and mouse holes at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title: "Drilling shot holes at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title:
      "Drilling site preparation at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title:
      "Drill-stem testing in oil, gas, dry, and service well drilling on a contract basis",
  },
  {
    code: "213112",
    title:
      "Excavating mud pits, slush pits, and cellars at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title:
      "Exploration services for oil and gas (except geophysical surveying and mapping) on a contract basis",
  },
  {
    code: "213112",
    title: "Fishing for tools at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title:
      "Gas well rig building, repairing, and dismantling on a contract basis",
  },
  {
    code: "213112",
    title: "Gas, compressing natural, in the field on a contract basis",
  },
  {
    code: "213112",
    title:
      "Geological exploration (except surveying) for oil and gas on a contract basis",
  },
  {
    code: "213112",
    title:
      "Geophysical exploration (except surveying) for oil and gas on a contract basis",
  },
  {
    code: "213112",
    title: "Hard banding oil and gas field service on a contract basis",
  },
  {
    code: "213112",
    title: "Hot oil treating of oil field tanks on a contract basis",
  },
  {
    code: "213112",
    title: "Hot shot oil field services (on- and off-road) on a contract basis",
  },
  {
    code: "213112",
    title: "Hydraulic fracturing wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Impounding and storing salt water in connection with petroleum production",
  },
  {
    code: "213112",
    title:
      "Installing production equipment at the oil or gas field on a contract basis",
  },
  {
    code: "213112",
    title: "Lease tank cleaning and repairing on a contract basis",
  },
  {
    code: "213112",
    title: "Logging wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Mouse hole and rat hole drilling at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title: "Mud service for oil field drilling on a contract basis",
  },
  {
    code: "213112",
    title:
      "Oil and gas field services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213112",
    title: "Oil field exploration (except surveying) on a contract basis",
  },
  {
    code: "213112",
    title: "Oil sampling services on a contract basis",
  },
  {
    code: "213112",
    title: "Oil well logging on a contract basis",
  },
  {
    code: "213112",
    title:
      "Oil well rig building, repairing, and dismantling, on a contract basis",
  },
  {
    code: "213112",
    title:
      "Operating condensate gasoline field gathering lines on a contract basis",
  },
  {
    code: "213112",
    title: "Paraffin services, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Perforating oil and gas well casings on a contract basis",
  },
  {
    code: "213112",
    title: "Pipe testing services, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Plugging and abandoning wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Preparation of oil and gas field drilling sites (except site preparation and related construction contractor activities) on a contract basis",
  },
  {
    code: "213112",
    title:
      "Pulling oil and gas field casings, tubes, or rods on a contract basis",
  },
  {
    code: "213112",
    title: "Pumping oil and gas wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Rathole and mousehole drilling at oil and gas fields on a contract basis",
  },
  {
    code: "213112",
    title: "Rig skidding, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Roustabout mining services, on a contract basis",
  },
  {
    code: "213112",
    title:
      "Salt water disposal systems, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title:
      "Sandblasting pipelines on lease, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title:
      "Seismograph exploration (except surveying) for oil and gas on a contract basis",
  },
  {
    code: "213112",
    title: "Servicing oil and gas wells on a contract basis",
  },
  {
    code: "213112",
    title: "Shot hole drilling, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Skidding of rigs, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Slush pits and cellars, excavation of, on a contract basis",
  },
  {
    code: "213112",
    title: "Steam cleaning oil and gas wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Stratigraphic drilling, oil and gas field exploration on a contract basis",
  },
  {
    code: "213112",
    title:
      "Surveying (except seismographic) oil or gas wells on a contract basis",
  },
  {
    code: "213112",
    title: "Swabbing oil or gas wells on a contract basis",
  },
  {
    code: "213112",
    title:
      "Well casing running, cutting and pulling, oil and gas field on a contract basis",
  },
  {
    code: "213112",
    title: "Well logging, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Well plugging, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Well pumping, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Well servicing, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Well surveying, oil and gas field, on a contract basis",
  },
  {
    code: "213112",
    title: "Wireline services, oil and gas field, on a contract basis",
  },
  {
    code: "213113",
    title: "Anthracite mine tunneling on a contract basis",
  },
  {
    code: "213113",
    title:
      "Anthracite mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213113",
    title:
      "Auger coal mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213113",
    title:
      "Bituminous coal mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213113",
    title:
      "Bituminous coal or lignite surface mine site development (except site preparation and related construction contractor activities) on a contract basis",
  },
  {
    code: "213113",
    title: "Bituminous coal stripping service on a contract basis",
  },
  {
    code: "213113",
    title: "Bituminous or lignite auger mining service on a contract basis",
  },
  {
    code: "213113",
    title: "Blasting services, coal mining, on a contract basis",
  },
  {
    code: "213113",
    title:
      "Coal mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213113",
    title:
      "Coal mining support services on a contract basis (e.g., tunneling, blasting, training, overburden removal) (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213113",
    title: "Culm bank recovery, anthracite, on a contract basis",
  },
  {
    code: "213113",
    title: "Culm bank recovery, coal, on a contract basis",
  },
  {
    code: "213113",
    title: "Draining or pumping coal mines on a contract basis",
  },
  {
    code: "213113",
    title: "Drilling services for coal mining on a contract basis",
  },
  {
    code: "213113",
    title:
      "Exploration services for coal (except geophysical surveying and mapping) on a contract basis",
  },
  {
    code: "213113",
    title:
      "Lignite mining services on a contract basis (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213113",
    title: "Mine shaft sinking services for coal mining on a contract basis",
  },
  {
    code: "213113",
    title: "Mine tunneling services for coal mining on a contract basis",
  },
  {
    code: "213113",
    title: "Overburden removal for coal mining on a contract basis",
  },
  {
    code: "213113",
    title:
      "Prospect and test drilling services for coal mining on contract basis",
  },
  {
    code: "213113",
    title: "Pumping or draining coal mines on a contract basis",
  },
  {
    code: "213113",
    title: "Removal of overburden for coal mining on a contract basis",
  },
  {
    code: "213113",
    title: "Shaft sinking for coal mines on a contract basis",
  },
  {
    code: "213113",
    title: "Sinking shafts for coal mining on a contract basis",
  },
  {
    code: "213113",
    title: "Stripping overburden services for coal mining on a contract basis",
  },
  {
    code: "213113",
    title: "Tunneling services for coal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Blasting services, metal mining, on a contract basis",
  },
  {
    code: "213114",
    title: "Boring test holes for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Draining or pumping of metal mines on a contract basis",
  },
  {
    code: "213114",
    title: "Drilling services for metal mining on a contract basis",
  },
  {
    code: "213114",
    title:
      "Exploration services for metal (except geophysical surveying and mapping) on a contract basis",
  },
  {
    code: "213114",
    title:
      "Metal mining support services on a contract basis (e.g., shaft sinking, tunneling, blasting) (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213114",
    title:
      "Mine development (except site preparation and related construction contractor activities) for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Mine shaft sinking services for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Mine tunneling services for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Overburden removal for metal mining on a contract basis",
  },
  {
    code: "213114",
    title:
      "Prospect and test drilling services for metal mining on contract basis",
  },
  {
    code: "213114",
    title: "Pumping or draining metal mines on a contract basis",
  },
  {
    code: "213114",
    title: "Removal of overburden for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Shaft sinking for metal mines on a contract basis",
  },
  {
    code: "213114",
    title: "Sinking shafts for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Stripping overburden services for metal mining on a contract basis",
  },
  {
    code: "213114",
    title: "Test drilling for metal mining on a contract basis",
  },
  {
    code: "213115",
    title:
      "Blasting services, nonmetallic minerals mining (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Boring test holes for nonmetallic minerals mining (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Draining or pumping of nonmetallic mineral mines (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Drilling services for nonmetallic mineral (except fuels) mining on a contract basis",
  },
  {
    code: "213115",
    title:
      "Exploration services for nonmetallic minerals (except geophysical surveying and mapping) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Mine shaft sinking services for nonmetallic minerals (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Mine tunneling services for nonmetallic minerals (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Nonmetallic minerals mine development on a contract basis (except site preparation and related construction activities)",
  },
  {
    code: "213115",
    title:
      "Nonmetallic minerals mining support services on a contract basis (e.g., blasting, shaft sinking, tunneling) (except geophysical surveying and mapping, site preparation, construction, and transportation activities)",
  },
  {
    code: "213115",
    title:
      "Overburden removal for nonmetallic minerals mining (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Prospect and test drilling services for nonmetallic mineral mining (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Pumping or draining nonmetallic mineral mines (except fuel) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Removal of overburden for nonmetallic minerals mining (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Stripping overburden services for nonmetallic minerals mining (except fuels) on a contract basis",
  },
  {
    code: "213115",
    title:
      "Test drilling for nonmetallic minerals mining (except fuel) on a contract basis",
  },
  {
    code: "221111",
    title: "Electric power generation, hydroelectric",
  },
  {
    code: "221111",
    title: "Hydroelectric power generation",
  },
  {
    code: "221111",
    title: "Power generation, hydroelectric",
  },
  {
    code: "221112",
    title: "Electric power generation, fossil fuel (e.g., coal, oil, gas)",
  },
  {
    code: "221112",
    title: "Power generation, fossil fuel (e.g., coal, gas, oil), electric",
  },
  {
    code: "221113",
    title: "Electric power generation, nuclear",
  },
  {
    code: "221113",
    title: "Power generation, nuclear electric",
  },
  {
    code: "221114",
    title: "Electric power generation, solar  ",
  },
  {
    code: "221114",
    title: "Power generation, solar electric",
  },
  {
    code: "221114",
    title: "Solar farms",
  },
  {
    code: "221115",
    title: "Electric power generation, wind",
  },
  {
    code: "221115",
    title: "Power generation, wind electric",
  },
  {
    code: "221116",
    title: "Electric power generation, geothermal",
  },
  {
    code: "221116",
    title: "Geothermal electric power generation",
  },
  {
    code: "221116",
    title: "Power generation, geothermal",
  },
  {
    code: "221117",
    title: "Biomass electric power generation",
  },
  {
    code: "221117",
    title: "Electric power generation, biomass",
  },
  {
    code: "221117",
    title: "Power generation, biomass",
  },
  {
    code: "221118",
    title: "Electric power generation, tidal",
  },
  {
    code: "221118",
    title: "Power generation, tidal electric",
  },
  {
    code: "221121",
    title: "Electric power control",
  },
  {
    code: "221121",
    title: "Electric power transmission systems",
  },
  {
    code: "221121",
    title: "Transmission of electric power",
  },
  {
    code: "221122",
    title: "Distribution of electric power",
  },
  {
    code: "221122",
    title: "Electric power brokers",
  },
  {
    code: "221122",
    title: "Electric power distribution systems",
  },
  {
    code: "221210",
    title: "Blue gas, carbureted, distribution",
  },
  {
    code: "221210",
    title: "Coke oven gas distribution",
  },
  {
    code: "221210",
    title: "Distribution of manufactured gas",
  },
  {
    code: "221210",
    title: "Distribution of natural gas",
  },
  {
    code: "221210",
    title: "Distribution of renewable natural gas (RNG)",
  },
  {
    code: "221210",
    title: "Gas, manufactured, distribution",
  },
  {
    code: "221210",
    title: "Gas, mixed natural and manufactured, distribution",
  },
  {
    code: "221210",
    title: "Gas, natural, distribution",
  },
  {
    code: "221210",
    title: "Liquefied petroleum gas (LPG) distribution through mains",
  },
  {
    code: "221210",
    title: "Manufactured gas distribution",
  },
  {
    code: "221210",
    title: "Natural gas brokers",
  },
  {
    code: "221210",
    title: "Natural gas distribution systems",
  },
  {
    code: "221210",
    title: "Natural gas distribution with transmission",
  },
  {
    code: "221210",
    title: "Natural gas marketers",
  },
  {
    code: "221310",
    title: "Canal, irrigation",
  },
  {
    code: "221310",
    title: "Filtration plant, water",
  },
  {
    code: "221310",
    title: "Impounding reservoirs, irrigation",
  },
  {
    code: "221310",
    title: "Irrigation system operation",
  },
  {
    code: "221310",
    title: "Water distribution (except irrigation)",
  },
  {
    code: "221310",
    title: "Water distribution for irrigation",
  },
  {
    code: "221310",
    title: "Water filtration plant operation",
  },
  {
    code: "221310",
    title: "Water supply systems",
  },
  {
    code: "221310",
    title: "Water treatment and distribution",
  },
  {
    code: "221310",
    title: "Water treatment plants",
  },
  {
    code: "221320",
    title:
      "Collection, treatment, and disposal of waste through a sewer system",
  },
  {
    code: "221320",
    title: "Sewage disposal plants",
  },
  {
    code: "221320",
    title: "Sewage treatment plants or facilities",
  },
  {
    code: "221320",
    title: "Sewer systems",
  },
  {
    code: "221320",
    title: "Waste collection, treatment, and disposal through a sewer system",
  },
  {
    code: "221330",
    title: "Air-conditioning supply",
  },
  {
    code: "221330",
    title: "Cooled air distribution",
  },
  {
    code: "221330",
    title: "Distribution of cooled air",
  },
  {
    code: "221330",
    title: "Distribution of heated air",
  },
  {
    code: "221330",
    title: "Distribution of steam heat",
  },
  {
    code: "221330",
    title: "Geothermal steam production",
  },
  {
    code: "221330",
    title: "Heat, steam, distribution",
  },
  {
    code: "221330",
    title: "Heated air distribution",
  },
  {
    code: "221330",
    title: "Heating steam (suppliers of heat) providers",
  },
  {
    code: "221330",
    title: "Steam heat distribution",
  },
  {
    code: "221330",
    title: "Steam heating systems (i.e., suppliers of heat)",
  },
  {
    code: "221330",
    title: "Steam production and distribution",
  },
  {
    code: "221330",
    title: "Steam supply systems, including geothermal",
  },
  {
    code: "236115",
    title: "Cabin construction general contractors",
  },
  {
    code: "236115",
    title: "Condominium, single-family, construction general contractors",
  },
  {
    code: "236115",
    title: "Construction management, single-family building",
  },
  {
    code: "236115",
    title: "Cottage construction general contractors",
  },
  {
    code: "236115",
    title: "Custom builders (except for-sale), single-family home",
  },
  {
    code: "236115",
    title: "Duplex (i.e., side-by-side) construction general contractors",
  },
  {
    code: "236115",
    title: "Home builders (except for-sale), single-family",
  },
  {
    code: "236115",
    title: "Housing, single-family, construction general contractors",
  },
  {
    code: "236115",
    title: "Log home construction general contractors",
  },
  {
    code: "236115",
    title:
      "Low income housing, single-family, construction general contractors",
  },
  {
    code: "236115",
    title:
      "Modular single-family housing assembled on site by general contractors",
  },
  {
    code: "236115",
    title:
      "Panelized single-family housing assembled on site by general contractors",
  },
  {
    code: "236115",
    title:
      "Precut single-family housing assembled on site by general contractors",
  },
  {
    code: "236115",
    title: "Prefabricated residential building erection, single-family",
  },
  {
    code: "236115",
    title:
      "Premanufactured single-family housing assembled on site by general contractors",
  },
  {
    code: "236115",
    title: "Residential construction, single-family, general contractors",
  },
  {
    code: "236115",
    title:
      "Row house (i.e., single-family type) construction general contractors",
  },
  {
    code: "236115",
    title: "Single-family attached housing construction general contractors",
  },
  {
    code: "236115",
    title: "Single-family detached housing construction general contractors",
  },
  {
    code: "236115",
    title:
      "Single-family homes built on land owned by others, general contractors of",
  },
  {
    code: "236115",
    title: "Single-family house construction by general contractors",
  },
  {
    code: "236115",
    title: "Time-share condominium construction general contractors",
  },
  {
    code: "236115",
    title:
      "Town house (i.e., single-family type) construction by general contractors",
  },
  {
    code: "236115",
    title: "Vacation home, single-family, construction by general contractors",
  },
  {
    code: "236116",
    title: "Apartment building construction general contractors",
  },
  {
    code: "236116",
    title: "Condominium, multifamily, construction general contractors",
  },
  {
    code: "236116",
    title: "Construction management, multifamily building",
  },
  {
    code: "236116",
    title: "Cooperative apartment, construction general contractors",
  },
  {
    code: "236116",
    title: "Custom builders (except for-sale), multifamily buildings",
  },
  {
    code: "236116",
    title:
      "Duplex (i.e., one unit above the other), construction general contractors",
  },
  {
    code: "236116",
    title: "Garden apartment construction general contractors",
  },
  {
    code: "236116",
    title: "High-rise apartment construction general contractors",
  },
  {
    code: "236116",
    title: "Home builders (except for-sale), multifamily",
  },
  {
    code: "236116",
    title: "Housing, multifamily, construction general contractors",
  },
  {
    code: "236116",
    title: "Low income housing, multifamily, construction general contractors",
  },
  {
    code: "236116",
    title: "Low-rise apartment  construction general contractors",
  },
  {
    code: "236116",
    title: "Multifamily building construction general contractors",
  },
  {
    code: "236116",
    title:
      "Panelized multifamily housing assembled on site by general contractors",
  },
  {
    code: "236116",
    title:
      "Precut multifamily housing assembled on site by general contractors",
  },
  {
    code: "236116",
    title: "Prefabricated residential building erection, multifamily",
  },
  {
    code: "236116",
    title: "Residential construction, multifamily, general contractors",
  },
  {
    code: "236117",
    title: "Apartment building for-sale builders",
  },
  {
    code: "236117",
    title: "Cabin for-sale builders",
  },
  {
    code: "236117",
    title: "Condominium for-sale builders",
  },
  {
    code: "236117",
    title: "Cooperative apartment for-sale builders",
  },
  {
    code: "236117",
    title: "Cottage for-sale builders",
  },
  {
    code: "236117",
    title: "Custom builders, for-sale builders, multifamily buildings",
  },
  {
    code: "236117",
    title: "Custom builders, for-sale builders, single-family home",
  },
  {
    code: "236117",
    title: "Duplex for-sale builders",
  },
  {
    code: "236117",
    title:
      "For-sale builders (i.e., building on own land, for sale), residential",
  },
  {
    code: "236117",
    title:
      "For-sale builders (i.e., building on own land, for sale), single-family housing",
  },
  {
    code: "236117",
    title: "Garden apartment for-sale builders",
  },
  {
    code: "236117",
    title: "High-rise apartment for-sale builders",
  },
  {
    code: "236117",
    title: "Home builders, for-sale",
  },
  {
    code: "236117",
    title: "Housing construction, for-sale builder",
  },
  {
    code: "236117",
    title: "Housing construction, merchant builder",
  },
  {
    code: "236117",
    title: "Log home for-sale builders",
  },
  {
    code: "236117",
    title: "Low income housing construction for-sale builders",
  },
  {
    code: "236117",
    title: "Low-rise apartment for-sale builders",
  },
  {
    code: "236117",
    title:
      "Merchant builders (i.e., building on own land, for sale), residential",
  },
  {
    code: "236117",
    title:
      "Modular housing, residential, assembled on site by for-sale builders",
  },
  {
    code: "236117",
    title: "Multifamily building for-sale builders",
  },
  {
    code: "236117",
    title:
      "Panelized housing, residential, assembled on site by for-sale builders",
  },
  {
    code: "236117",
    title:
      "Panelized multifamily housing assembled on site by for-sale builders",
  },
  {
    code: "236117",
    title:
      "Precut housing, residential, assembled on site by for-sale builders",
  },
  {
    code: "236117",
    title: "Premanufactured housing assembled on site by for-sale builders",
  },
  {
    code: "236117",
    title: "Residential for-sale builders",
  },
  {
    code: "236117",
    title: "Row house construction for-sale builders",
  },
  {
    code: "236117",
    title:
      "Single-family housing built on own land for sale (i.e., for-sale builders)",
  },
  {
    code: "236117",
    title: "Single-family housing construction for-sale builders",
  },
  {
    code: "236117",
    title:
      "Speculative builders (i.e., building on own land, for sale), multifamily housing",
  },
  {
    code: "236117",
    title:
      "Speculative builders (i.e., building on own land, for sale), residential",
  },
  {
    code: "236117",
    title:
      "Speculative builders (i.e., building on own land, for sale), single-family housing",
  },
  {
    code: "236117",
    title: "Time-share condominium construction for-sale builders",
  },
  {
    code: "236117",
    title: "Town house construction for-sale builders",
  },
  {
    code: "236117",
    title: "Vacation housing construction for-sale builders",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation (i.e., construction), multifamily building",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation (i.e., construction), residential building",
  },
  {
    code: "236118",
    title: "Addition, alteration and renovation of single-family dwellings",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation, multifamily building, for-sale builders",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation, multifamily building, general contractors",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation, residential building, for-sale builders",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation, residential building, general contractors",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation, single-family housing, for-sale builders",
  },
  {
    code: "236118",
    title:
      "Addition, alteration and renovation, single-family housing, general contractors",
  },
  {
    code: "236118",
    title: "Building, residential, addition, alteration and renovation",
  },
  {
    code: "236118",
    title: "Construction management, residential remodeling",
  },
  {
    code: "236118",
    title:
      "Fire and flood restoration, multifamily building, general contractors",
  },
  {
    code: "236118",
    title:
      "Fire and flood restoration, single-family housing, general contractors",
  },
  {
    code: "236118",
    title: "Handyman construction service, residential building",
  },
  {
    code: "236118",
    title: "Home improvement (e.g., adding on, remodeling, renovating)",
  },
  {
    code: "236118",
    title:
      "Home improvement (e.g., adding on, remodeling, renovating), multifamily building, for-sale builders",
  },
  {
    code: "236118",
    title:
      "Home improvement (e.g., adding on, remodeling, renovating), multifamily building, general contractors",
  },
  {
    code: "236118",
    title:
      "Home improvement (e.g., adding on, remodeling, renovating), single-family housing, for-sale builders",
  },
  {
    code: "236118",
    title:
      "Home improvement (e.g., adding on, remodeling, renovating), single-family housing, general contractors",
  },
  {
    code: "236118",
    title: "Home renovation",
  },
  {
    code: "236118",
    title: "Porch construction, residential-type",
  },
  {
    code: "236118",
    title: "Remodeling and renovating for-sale builders",
  },
  {
    code: "236118",
    title:
      "Remodeling and renovating general contractors, multifamily building",
  },
  {
    code: "236118",
    title: "Remodeling and renovating general contractors, residential",
  },
  {
    code: "236118",
    title:
      "Remodeling and renovating general contractors, single-family housing",
  },
  {
    code: "236118",
    title: "Remodeling and renovating single-family housing",
  },
  {
    code: "236118",
    title: "Remodeling and renovating, residential building",
  },
  {
    code: "236118",
    title: "Sunroom additions, residential",
  },
  {
    code: "236210",
    title: "Acid plant construction",
  },
  {
    code: "236210",
    title:
      "Addition, alteration and renovation, for-sale builders, industrial building (except warehouses)",
  },
  {
    code: "236210",
    title:
      "Addition, alteration and renovation, general contractors, industrial building (except warehouses)",
  },
  {
    code: "236210",
    title:
      "Addition, alteration and renovation, industrial building (except warehouses)",
  },
  {
    code: "236210",
    title: "Aluminum plant construction",
  },
  {
    code: "236210",
    title: "Ammonium plant construction",
  },
  {
    code: "236210",
    title: "Assembly plant construction",
  },
  {
    code: "236210",
    title: "Blast furnace construction",
  },
  {
    code: "236210",
    title: "Cannery construction",
  },
  {
    code: "236210",
    title: "Cement plant construction",
  },
  {
    code: "236210",
    title: "Chemical (except petrochemical process-type) plant construction",
  },
  {
    code: "236210",
    title: "Clean room construction",
  },
  {
    code: "236210",
    title: "Construction management, industrial building (except warehouses)",
  },
  {
    code: "236210",
    title: "Factory construction",
  },
  {
    code: "236210",
    title: "Fish processing plant construction",
  },
  {
    code: "236210",
    title: "Food processing plant construction",
  },
  {
    code: "236210",
    title:
      "For-sale builders (i.e., building on own land, for sale), industrial building (except warehouses)",
  },
  {
    code: "236210",
    title: "Foundry construction",
  },
  {
    code: "236210",
    title: "Furnace (i.e., industrial plant structure) construction",
  },
  {
    code: "236210",
    title: "Garbage disposal plant construction",
  },
  {
    code: "236210",
    title: "Incinerator, mass-burn type, construction",
  },
  {
    code: "236210",
    title: "Incinerator, municipal waste disposal, construction",
  },
  {
    code: "236210",
    title: "Industrial building (except warehouses) construction",
  },
  {
    code: "236210",
    title:
      "Industrial building (except warehouses) construction, for-sale builders",
  },
  {
    code: "236210",
    title:
      "Industrial building (except warehouses) construction, general contractors",
  },
  {
    code: "236210",
    title: "Kiln construction",
  },
  {
    code: "236210",
    title: "Manufacturing building construction",
  },
  {
    code: "236210",
    title: "Materials recovery facility construction",
  },
  {
    code: "236210",
    title: "Metal processing plant construction",
  },
  {
    code: "236210",
    title: "Mine loading and discharging station construction",
  },
  {
    code: "236210",
    title: "Motor vehicle assembly plant construction",
  },
  {
    code: "236210",
    title: "Ore and metal refinery construction",
  },
  {
    code: "236210",
    title: "Oven, industrial plant, construction",
  },
  {
    code: "236210",
    title: "Paper or pulp mill construction",
  },
  {
    code: "236210",
    title: "Pharmaceutical manufacturing plant construction",
  },
  {
    code: "236210",
    title: "Prefabricated industrial building (except warehouses) erection",
  },
  {
    code: "236210",
    title: "Printing plant construction",
  },
  {
    code: "236210",
    title: "Refuse disposal plant (except sewage treatment) construction",
  },
  {
    code: "236210",
    title: "Smelter construction",
  },
  {
    code: "236210",
    title:
      "Speculative builders (i.e., building on own land, for sale), industrial building (except warehouses)",
  },
  {
    code: "236210",
    title: "Steel mill construction",
  },
  {
    code: "236210",
    title: "Textile mill construction",
  },
  {
    code: "236210",
    title: "Tipple, mining, construction",
  },
  {
    code: "236210",
    title: "Washery, mining, construction",
  },
  {
    code: "236210",
    title: "Waste disposal plant (except sewage treatment) construction",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, commercial and institutional building",
  },
  {
    code: "236220",
    title: "Addition, alteration and renovation, commercial warehouse",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, for-sale builders, commercial and institutional building",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, for-sale builders, commercial warehouse",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, for-sale builders, hotel and motel",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, for-sale builders, industrial warehouse",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, general contractors, commercial and institutional building",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, general contractors, commercial warehouse",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, general contractors, hotel and motel",
  },
  {
    code: "236220",
    title:
      "Addition, alteration and renovation, general contractors, industrial warehouse",
  },
  {
    code: "236220",
    title: "Addition, alteration and renovation, hotel and motel",
  },
  {
    code: "236220",
    title: "Addition, alteration and renovation, industrial warehouse",
  },
  {
    code: "236220",
    title: "Administration building construction",
  },
  {
    code: "236220",
    title: "Airport building construction",
  },
  {
    code: "236220",
    title: "Airport terminal construction",
  },
  {
    code: "236220",
    title: "Amusement facility construction",
  },
  {
    code: "236220",
    title: "Animal shelter and clinic construction",
  },
  {
    code: "236220",
    title: "Arena construction",
  },
  {
    code: "236220",
    title: "Armory construction",
  },
  {
    code: "236220",
    title: "Athletic court, indoor, construction",
  },
  {
    code: "236220",
    title: "Auditorium construction",
  },
  {
    code: "236220",
    title: "Bank building construction",
  },
  {
    code: "236220",
    title: "Barber shop construction",
  },
  {
    code: "236220",
    title: "Barrack construction",
  },
  {
    code: "236220",
    title: "Beauty salon construction",
  },
  {
    code: "236220",
    title: "Broadcasting station construction",
  },
  {
    code: "236220",
    title: "Bunkhouse construction",
  },
  {
    code: "236220",
    title: "Bus shelter construction",
  },
  {
    code: "236220",
    title: "Bus terminal construction",
  },
  {
    code: "236220",
    title: "Casino construction",
  },
  {
    code: "236220",
    title: "Cinema construction",
  },
  {
    code: "236220",
    title: "Civic center construction",
  },
  {
    code: "236220",
    title: "Clinic construction",
  },
  {
    code: "236220",
    title: "Cold storage plant construction",
  },
  {
    code: "236220",
    title: "Commercial building construction",
  },
  {
    code: "236220",
    title: "Commercial building construction for-sale builders",
  },
  {
    code: "236220",
    title: "Commercial building construction general contractors",
  },
  {
    code: "236220",
    title: "Construction management, commercial and institutional building",
  },
  {
    code: "236220",
    title: "Data center construction",
  },
  {
    code: "236220",
    title: "Dormitory construction",
  },
  {
    code: "236220",
    title: "Drycleaning plant construction",
  },
  {
    code: "236220",
    title: "Educational building construction",
  },
  {
    code: "236220",
    title: "Farm building construction",
  },
  {
    code: "236220",
    title:
      "Fire and flood restoration of commercial and institutional buildings",
  },
  {
    code: "236220",
    title: "Fire station construction",
  },
  {
    code: "236220",
    title:
      "For-sale builders (i.e., building on own land, for sale), commercial and institutional building",
  },
  {
    code: "236220",
    title: "Garage and service station, commercial, construction",
  },
  {
    code: "236220",
    title: "Grain bin construction",
  },
  {
    code: "236220",
    title: "Grain elevator construction",
  },
  {
    code: "236220",
    title:
      "Handyman construction service, commercial and institutional building",
  },
  {
    code: "236220",
    title: "Hangar construction",
  },
  {
    code: "236220",
    title: "Hatchery construction",
  },
  {
    code: "236220",
    title: "Health and athletic club construction",
  },
  {
    code: "236220",
    title: "Hospital construction",
  },
  {
    code: "236220",
    title: "Hotel construction",
  },
  {
    code: "236220",
    title: "Ice rink, indoor, construction",
  },
  {
    code: "236220",
    title: "Indoor swimming pool construction",
  },
  {
    code: "236220",
    title: "Institutional building construction",
  },
  {
    code: "236220",
    title: "Institutional building construction for-sale builders",
  },
  {
    code: "236220",
    title: "Institutional building construction general contractors",
  },
  {
    code: "236220",
    title: "Jail construction",
  },
  {
    code: "236220",
    title: "Laboratory construction",
  },
  {
    code: "236220",
    title: "Library construction",
  },
  {
    code: "236220",
    title: "Logging camp construction",
  },
  {
    code: "236220",
    title: "Mausoleum (i.e., building) construction",
  },
  {
    code: "236220",
    title: "Monument (i.e., building) construction",
  },
  {
    code: "236220",
    title: "Motel construction",
  },
  {
    code: "236220",
    title: "Museum construction",
  },
  {
    code: "236220",
    title: "Office building construction",
  },
  {
    code: "236220",
    title: "Parking garage construction",
  },
  {
    code: "236220",
    title: "Penitentiary construction",
  },
  {
    code: "236220",
    title: "Post office construction",
  },
  {
    code: "236220",
    title: "Prefabricated commercial building erection",
  },
  {
    code: "236220",
    title: "Prefabricated institutional building erection",
  },
  {
    code: "236220",
    title: "Prison construction",
  },
  {
    code: "236220",
    title: "Public warehouse construction",
  },
  {
    code: "236220",
    title: "Radio and television broadcast studio construction",
  },
  {
    code: "236220",
    title: "Radio station construction",
  },
  {
    code: "236220",
    title: "Railway station construction",
  },
  {
    code: "236220",
    title: "Recreational facility building construction",
  },
  {
    code: "236220",
    title:
      "Religious building (e.g., church, synagogue, mosque, temple) construction",
  },
  {
    code: "236220",
    title: "Restaurant construction",
  },
  {
    code: "236220",
    title: "Salon construction",
  },
  {
    code: "236220",
    title: "School building construction",
  },
  {
    code: "236220",
    title: "Self-storage facility construction",
  },
  {
    code: "236220",
    title: "Service station construction",
  },
  {
    code: "236220",
    title: "Shopping center construction",
  },
  {
    code: "236220",
    title: "Shopping mall construction",
  },
  {
    code: "236220",
    title: "Silo construction",
  },
  {
    code: "236220",
    title:
      "Speculative builders (i.e., building on own land, for sale), commercial and institutional building",
  },
  {
    code: "236220",
    title: "Stadium and arena construction",
  },
  {
    code: "236220",
    title: "Storage elevator construction",
  },
  {
    code: "236220",
    title: "Store construction",
  },
  {
    code: "236220",
    title: "Swimming facility, indoor, construction",
  },
  {
    code: "236220",
    title: "Television station construction",
  },
  {
    code: "236220",
    title: "Tennis court, indoor, construction",
  },
  {
    code: "236220",
    title: "Theater construction",
  },
  {
    code: "236220",
    title: "Truck terminal construction",
  },
  {
    code: "236220",
    title:
      "Warehouse construction (e.g., commercial, industrial, manufacturing, private)",
  },
  {
    code: "236220",
    title: "Warehouse, commercial and institutional, construction",
  },
  {
    code: "236220",
    title: "Warehouse, industrial, construction",
  },
  {
    code: "237110",
    title: "Aqueduct construction",
  },
  {
    code: "237110",
    title: "Artesian well construction",
  },
  {
    code: "237110",
    title: "Capping of water wells",
  },
  {
    code: "237110",
    title: "Construction management, water and sewage treatment plant",
  },
  {
    code: "237110",
    title: "Construction management, water and sewer line",
  },
  {
    code: "237110",
    title: "Distribution line, sewer and water, construction",
  },
  {
    code: "237110",
    title:
      "Drilling water wells (except water intake wells in oil and gas fields)",
  },
  {
    code: "237110",
    title: "Fire hydrant installation",
  },
  {
    code: "237110",
    title: "Geothermal drilling",
  },
  {
    code: "237110",
    title: "Hydrant and flushing hydrant installation",
  },
  {
    code: "237110",
    title: "Irrigation project construction (except lawn)",
  },
  {
    code: "237110",
    title: "Lagoon, sewage treatment construction",
  },
  {
    code: "237110",
    title: "Pumping station, water and sewage system, construction",
  },
  {
    code: "237110",
    title: "Reservoir construction",
  },
  {
    code: "237110",
    title: "Sanitary sewer construction",
  },
  {
    code: "237110",
    title: "Sewage collection and disposal line construction",
  },
  {
    code: "237110",
    title: "Sewage disposal plant construction",
  },
  {
    code: "237110",
    title: "Sewage treatment plant construction",
  },
  {
    code: "237110",
    title: "Sewer construction",
  },
  {
    code: "237110",
    title: "Sewer main, pipe and connection, construction",
  },
  {
    code: "237110",
    title: "Storm sewer construction",
  },
  {
    code: "237110",
    title: "Utility line (i.e., sewer, water), construction",
  },
  {
    code: "237110",
    title: "Water desalination plant construction",
  },
  {
    code: "237110",
    title: "Water filtration plant construction",
  },
  {
    code: "237110",
    title: "Water main and line construction",
  },
  {
    code: "237110",
    title: "Water pumping or lift station construction",
  },
  {
    code: "237110",
    title: "Water sampling station installation",
  },
  {
    code: "237110",
    title: "Water system storage tank and tower construction",
  },
  {
    code: "237110",
    title: "Water treatment plant construction",
  },
  {
    code: "237110",
    title:
      "Water well drilling, digging, boring or sinking (except water intake wells in oil and gas fields)",
  },
  {
    code: "237110",
    title: "Water well pump and well piping system installation",
  },
  {
    code: "237120",
    title:
      "Compressor, metering and pumping station, gas and oil pipeline, construction",
  },
  {
    code: "237120",
    title: "Construction management, oil and gas pipeline",
  },
  {
    code: "237120",
    title: "Construction management, oil refinery and petrochemical complex",
  },
  {
    code: "237120",
    title: "Corrosion protection, underground pipeline and oil storage tank",
  },
  {
    code: "237120",
    title: "Distribution line, gas and oil, construction",
  },
  {
    code: "237120",
    title: "Gas main construction",
  },
  {
    code: "237120",
    title: "Gathering line, gas and oil field, construction",
  },
  {
    code: "237120",
    title: "Manhole, oil and gas, construction",
  },
  {
    code: "237120",
    title: "Natural gas pipeline construction",
  },
  {
    code: "237120",
    title: "Natural gas processing plant construction",
  },
  {
    code: "237120",
    title: "Oil and gas field distribution line construction",
  },
  {
    code: "237120",
    title: "Oil pipeline construction",
  },
  {
    code: "237120",
    title: "Oil refinery construction",
  },
  {
    code: "237120",
    title: "Petrochemical plant construction",
  },
  {
    code: "237120",
    title: "Petroleum refinery construction",
  },
  {
    code: "237120",
    title: "Pipe lining (except thermal insulating) contractors",
  },
  {
    code: "237120",
    title:
      "Pipeline construction on oil and gas field gathering lines to point of distribution on a contract basis",
  },
  {
    code: "237120",
    title: "Pipeline rehabilitation contractors",
  },
  {
    code: "237120",
    title: "Pipeline wrapping contractors",
  },
  {
    code: "237120",
    title: "Pipeline, gas and oil, construction",
  },
  {
    code: "237120",
    title: "Pumping station, gas and oil transmission, construction",
  },
  {
    code: "237120",
    title: "Refinery, petroleum, construction",
  },
  {
    code: "237120",
    title: "Service line, gas and oil, construction",
  },
  {
    code: "237120",
    title: "Storage tank, natural gas or oil, tank farm or field, construction",
  },
  {
    code: "237130",
    title:
      "Alternative energy (e.g., geothermal, ocean wave, solar, wind) structure construction",
  },
  {
    code: "237130",
    title:
      "Cable laying (e.g., fiber optic, electricity, marine, telephone, cable television), including underground",
  },
  {
    code: "237130",
    title: "Cellular phone tower construction",
  },
  {
    code: "237130",
    title: "Co-generation plant construction",
  },
  {
    code: "237130",
    title: "Communication antenna construction",
  },
  {
    code: "237130",
    title: "Communication tower construction",
  },
  {
    code: "237130",
    title: "Construction management, power and communication transmission line",
  },
  {
    code: "237130",
    title: "Electric light and power plant (except hydroelectric) construction",
  },
  {
    code: "237130",
    title: "Electric power transmission line and tower construction",
  },
  {
    code: "237130",
    title: "Electricity generating plant (except hydroelectric) construction",
  },
  {
    code: "237130",
    title: "Fiber optic cable transmission line construction",
  },
  {
    code: "237130",
    title: "Microwave relay tower construction",
  },
  {
    code: "237130",
    title: "Nuclear power plant construction",
  },
  {
    code: "237130",
    title: "Pole line construction",
  },
  {
    code: "237130",
    title: "Power line stringing",
  },
  {
    code: "237130",
    title: "Power plant (except hydroelectric) construction",
  },
  {
    code: "237130",
    title: "Radio transmitting tower construction",
  },
  {
    code: "237130",
    title: "Satellite receiving station construction",
  },
  {
    code: "237130",
    title: "Solar power structure construction",
  },
  {
    code: "237130",
    title:
      "Substation and switching station, power transmission line, construction",
  },
  {
    code: "237130",
    title: "Telephone line construction",
  },
  {
    code: "237130",
    title: "Telephone line stringing",
  },
  {
    code: "237130",
    title: "Television transmitting tower construction",
  },
  {
    code: "237130",
    title: "Thermal power plant construction",
  },
  {
    code: "237130",
    title: "Tower, power distribution and communication, construction",
  },
  {
    code: "237130",
    title: "Transformer station and substation, electric power, construction",
  },
  {
    code: "237130",
    title: "Transmission and distribution line construction",
  },
  {
    code: "237130",
    title:
      "Underground cable (e.g., fiber optic, electricity, telephone, cable television) laying",
  },
  {
    code: "237130",
    title: "Utility line (i.e., communication, electric power), construction",
  },
  {
    code: "237130",
    title: "Wind power structure construction",
  },
  {
    code: "237210",
    title: "Building lot subdividing",
  },
  {
    code: "237210",
    title: "Land (except cemeteries) subdividers",
  },
  {
    code: "237210",
    title: "Land acquisition, assembling and subdividing",
  },
  {
    code: "237210",
    title: "Land developers (i.e., subdividing and installing infrastructure)",
  },
  {
    code: "237210",
    title:
      "Land subdividing and utility installation (e.g., electric, sewer and water)",
  },
  {
    code: "237210",
    title: "Preparing and subdividing land for sale",
  },
  {
    code: "237210",
    title: "Real estate (except cemeteries) subdividers",
  },
  {
    code: "237210",
    title: "Real property (except cemeteries) subdivision",
  },
  {
    code: "237210",
    title: "Subdividers, real estate",
  },
  {
    code: "237210",
    title: "Subdividing and preparing land owned by others",
  },
  {
    code: "237210",
    title: "Subdividing real estate",
  },
  {
    code: "237310",
    title: "Abutment construction",
  },
  {
    code: "237310",
    title: "Airport runway construction",
  },
  {
    code: "237310",
    title: "Airport runway line painting (e.g., striping)",
  },
  {
    code: "237310",
    title: "Asphalt paving (i.e., highway, road, street, public sidewalk)",
  },
  {
    code: "237310",
    title: "Bridge approach construction",
  },
  {
    code: "237310",
    title: "Bridge construction",
  },
  {
    code: "237310",
    title: "Bridge decking construction",
  },
  {
    code: "237310",
    title: "Causeway construction",
  },
  {
    code: "237310",
    title: "Concrete paving (i.e., highway, road, street, public sidewalk)",
  },
  {
    code: "237310",
    title: "Construction management, highway, road, street and bridge",
  },
  {
    code: "237310",
    title: "Culverts, highway, road and street, construction",
  },
  {
    code: "237310",
    title: "Curbs and street gutters, highway, road and street, construction",
  },
  {
    code: "237310",
    title: "Elevated highway construction",
  },
  {
    code: "237310",
    title: "Grading, highway, road, street and airport runway",
  },
  {
    code: "237310",
    title: "Guardrail construction",
  },
  {
    code: "237310",
    title: "Highway construction",
  },
  {
    code: "237310",
    title: "Highway line painting",
  },
  {
    code: "237310",
    title: "Logging road construction",
  },
  {
    code: "237310",
    title: "Oil field road construction",
  },
  {
    code: "237310",
    title: "Overpass construction",
  },
  {
    code: "237310",
    title: "Painting lines on highways, streets and bridges",
  },
  {
    code: "237310",
    title: "Painting traffic lanes or parking lots",
  },
  {
    code: "237310",
    title: "Parking lot marking and line painting",
  },
  {
    code: "237310",
    title: "Parkway construction",
  },
  {
    code: "237310",
    title:
      "Pavement, highway, road, street, bridge or airport runway, construction",
  },
  {
    code: "237310",
    title: "Pothole filling, highway, road, street or bridge",
  },
  {
    code: "237310",
    title: "Repair, highway, road, street, bridge or airport runway",
  },
  {
    code: "237310",
    title: "Resurfacing, highway, road, street, bridge or airport runway",
  },
  {
    code: "237310",
    title: "Road construction",
  },
  {
    code: "237310",
    title: "Runway, airport, line painting (e.g., striping)",
  },
  {
    code: "237310",
    title: "Sidewalk, public, construction",
  },
  {
    code: "237310",
    title: "Sign erection, highway, road, street, or bridge",
  },
  {
    code: "237310",
    title: "Street construction",
  },
  {
    code: "237310",
    title: "Surfacing, highway, road, street, bridge or airport runway",
  },
  {
    code: "237310",
    title: "Tarring roads",
  },
  {
    code: "237310",
    title: "Traffic lane painting",
  },
  {
    code: "237310",
    title: "Trestle construction",
  },
  {
    code: "237310",
    title: "Underpass construction",
  },
  {
    code: "237990",
    title: "Anchored earth retention contractors",
  },
  {
    code: "237990",
    title: "Athletic field (except stadium) construction",
  },
  {
    code: "237990",
    title:
      "Avalanche, rockslide, mudslide, or roadside protection construction",
  },
  {
    code: "237990",
    title: "Breakwater construction",
  },
  {
    code: "237990",
    title: "Bridle path construction",
  },
  {
    code: "237990",
    title: "Bulkhead wall or embankment construction",
  },
  {
    code: "237990",
    title: "Caisson (i.e., marine or pneumatic structures) construction",
  },
  {
    code: "237990",
    title: "Canal construction",
  },
  {
    code: "237990",
    title: "Channel construction",
  },
  {
    code: "237990",
    title: "Cofferdam construction",
  },
  {
    code: "237990",
    title: "Construction management, dam",
  },
  {
    code: "237990",
    title: "Construction management, marine structure",
  },
  {
    code: "237990",
    title: "Construction management, mass transit",
  },
  {
    code: "237990",
    title: "Construction management, outdoor recreation facility",
  },
  {
    code: "237990",
    title: "Construction management, tunnel",
  },
  {
    code: "237990",
    title: "Cribbing (i.e., shore protection), construction",
  },
  {
    code: "237990",
    title: "Dam construction",
  },
  {
    code: "237990",
    title: "Dike and other flood control structure construction",
  },
  {
    code: "237990",
    title: "Dock construction",
  },
  {
    code: "237990",
    title: "Drainage canal and ditch construction",
  },
  {
    code: "237990",
    title: "Drainage project construction",
  },
  {
    code: "237990",
    title: "Dredging (e.g., canal, channel, ditch, waterway)",
  },
  {
    code: "237990",
    title: "Drive-in movie facility construction",
  },
  {
    code: "237990",
    title: "Earth retention system construction",
  },
  {
    code: "237990",
    title: "Earth-filled dam construction",
  },
  {
    code: "237990",
    title: "Electricity generating plant, hydroelectric, construction",
  },
  {
    code: "237990",
    title: "Embankment construction",
  },
  {
    code: "237990",
    title: "Farm drainage tile installation",
  },
  {
    code: "237990",
    title: "Flood control project construction",
  },
  {
    code: "237990",
    title: "Floodway canal and ditch construction",
  },
  {
    code: "237990",
    title: "Gabion construction",
  },
  {
    code: "237990",
    title: "Golf course construction",
  },
  {
    code: "237990",
    title: "Harbor construction",
  },
  {
    code: "237990",
    title: "Helical pier (i.e., marine or pneumatic structures) construction",
  },
  {
    code: "237990",
    title:
      "Horizontal drilling (e.g., underground cable, pipeline, sewer installation)",
  },
  {
    code: "237990",
    title: "Hydroelectric generating facility construction",
  },
  {
    code: "237990",
    title: "Ice rink (except indoor) construction",
  },
  {
    code: "237990",
    title: "Jetty construction",
  },
  {
    code: "237990",
    title: "Land drainage contractors",
  },
  {
    code: "237990",
    title: "Levee construction",
  },
  {
    code: "237990",
    title: "Light rail system construction",
  },
  {
    code: "237990",
    title: "Lock and waterway construction",
  },
  {
    code: "237990",
    title: "Marine construction",
  },
  {
    code: "237990",
    title: "Microtunneling contractors",
  },
  {
    code: "237990",
    title: "Missile facility construction",
  },
  {
    code: "237990",
    title: "Monorail construction",
  },
  {
    code: "237990",
    title: "Nuclear waste disposal site construction",
  },
  {
    code: "237990",
    title: "Outdoor recreation facility construction",
  },
  {
    code: "237990",
    title: "Park and recreational open space improvement construction",
  },
  {
    code: "237990",
    title: "Pier construction",
  },
  {
    code: "237990",
    title: "Pile driving, marine",
  },
  {
    code: "237990",
    title: "Pipe-jacking contractors",
  },
  {
    code: "237990",
    title: "Playground construction",
  },
  {
    code: "237990",
    title: "Port facility construction",
  },
  {
    code: "237990",
    title: "Power plant, hydroelectric, construction",
  },
  {
    code: "237990",
    title: "Railroad construction",
  },
  {
    code: "237990",
    title: "Railway construction (e.g., interlocker, roadbed, signal, track)",
  },
  {
    code: "237990",
    title: "Railway roadbed construction",
  },
  {
    code: "237990",
    title: "Recreation area, open space, construction",
  },
  {
    code: "237990",
    title: "Recreational vehicle park construction",
  },
  {
    code: "237990",
    title:
      "Retaining walls, anchored (e.g., with piles, soil nails, tieback anchors), construction",
  },
  {
    code: "237990",
    title: "Revetment construction",
  },
  {
    code: "237990",
    title: "Riprap installation",
  },
  {
    code: "237990",
    title: "Rock removal, underwater",
  },
  {
    code: "237990",
    title: "Seawall, wave protection, construction",
  },
  {
    code: "237990",
    title: "Sediment control system construction",
  },
  {
    code: "237990",
    title: "Ski tow construction",
  },
  {
    code: "237990",
    title: "Spillway, floodwater, construction",
  },
  {
    code: "237990",
    title: "Sports field construction",
  },
  {
    code: "237990",
    title: "Streetcar line construction",
  },
  {
    code: "237990",
    title: "Subway construction",
  },
  {
    code: "237990",
    title: "Tennis courts, outdoor, construction",
  },
  {
    code: "237990",
    title: "Timber removal, underwater",
  },
  {
    code: "237990",
    title: "Trail construction",
  },
  {
    code: "237990",
    title: "Trenching, underwater",
  },
  {
    code: "237990",
    title: "Tunnel construction",
  },
  {
    code: "237990",
    title: "Wharf construction",
  },
  {
    code: "238110",
    title: "Chimney, concrete, construction",
  },
  {
    code: "238110",
    title: "Concrete finishing",
  },
  {
    code: "238110",
    title: "Concrete floor surfacing",
  },
  {
    code: "238110",
    title: "Concrete pouring",
  },
  {
    code: "238110",
    title: "Concrete pumping (i.e., placement)",
  },
  {
    code: "238110",
    title: "Concrete repair",
  },
  {
    code: "238110",
    title: "Concrete resurfacing",
  },
  {
    code: "238110",
    title: "Footing and foundation concrete contractors",
  },
  {
    code: "238110",
    title: "Foundation, building, poured concrete, contractors",
  },
  {
    code: "238110",
    title: "Grouting (i.e., reinforcing with concrete)",
  },
  {
    code: "238110",
    title: "Gunite contractors",
  },
  {
    code: "238110",
    title: "Gunning shotcrete",
  },
  {
    code: "238110",
    title: "Mud-jacking contractors",
  },
  {
    code: "238110",
    title:
      "Retaining wall (except anchored earth), poured concrete, construction",
  },
  {
    code: "238110",
    title: "Shotcrete contractors",
  },
  {
    code: "238120",
    title: "Balcony, precast concrete, installation",
  },
  {
    code: "238120",
    title:
      "Concrete product (e.g., structural precast, structural prestressed) installation",
  },
  {
    code: "238120",
    title: "Concrete reinforcement placement",
  },
  {
    code: "238120",
    title: "Curtain wall, precast concrete, installation",
  },
  {
    code: "238120",
    title: "Erecting structural steel",
  },
  {
    code: "238120",
    title: "Iron work, structural, contractors",
  },
  {
    code: "238120",
    title: "Placing and tying reinforcing rod at a construction site",
  },
  {
    code: "238120",
    title: "Precast concrete panel, slab, or form installation",
  },
  {
    code: "238120",
    title: "Prestressed concrete beam, slab or other component installation",
  },
  {
    code: "238120",
    title: "Rebar contractors",
  },
  {
    code: "238120",
    title: "Reinforcing rod, bar, mesh and cage installation",
  },
  {
    code: "238120",
    title: "Reinforcing steel contractors",
  },
  {
    code: "238120",
    title: "Stairway, precast concrete, installation",
  },
  {
    code: "238120",
    title: "Steel reinforcing contractors",
  },
  {
    code: "238120",
    title: "Structural steel erecting or iron work contractors",
  },
  {
    code: "238130",
    title: "Building framing (except structural steel)",
  },
  {
    code: "238130",
    title: "Carpentry, framing",
  },
  {
    code: "238130",
    title: "Ceiling beam, wood, installation",
  },
  {
    code: "238130",
    title: "Foundation, building, wood, contractors",
  },
  {
    code: "238130",
    title: "Framework, house, contractors",
  },
  {
    code: "238130",
    title: "Framing contractors",
  },
  {
    code: "238130",
    title: "House framing",
  },
  {
    code: "238130",
    title: "Permanent wood foundation installation",
  },
  {
    code: "238130",
    title: "Post framing contractors",
  },
  {
    code: "238130",
    title: "Prefabricated wood frame component (e.g., trusses) installation",
  },
  {
    code: "238130",
    title: "Roof truss (wood) installation",
  },
  {
    code: "238130",
    title: "Sheathing, wood, installation",
  },
  {
    code: "238130",
    title: "Steel framing contractors",
  },
  {
    code: "238130",
    title: "Stud wall (e.g., wood, steel) installation",
  },
  {
    code: "238130",
    title:
      "Wall component (i.e., exterior, interior), prefabricated, installation",
  },
  {
    code: "238130",
    title: "Wood frame component (e.g., truss) fabrication on site",
  },
  {
    code: "238140",
    title: "Brick veneer, installation",
  },
  {
    code: "238140",
    title: "Bricklaying contractors",
  },
  {
    code: "238140",
    title: "Cement block laying",
  },
  {
    code: "238140",
    title: "Chimney, brick, block or stone, contractors",
  },
  {
    code: "238140",
    title: "Cinder block installation",
  },
  {
    code: "238140",
    title: "Concrete block laying",
  },
  {
    code: "238140",
    title: "Field stone (i.e., masonry) installation",
  },
  {
    code: "238140",
    title: "Fireplace, masonry, installation",
  },
  {
    code: "238140",
    title: "Foundation (e.g., brick, block, stone), building, contractors",
  },
  {
    code: "238140",
    title: "Glass block laying",
  },
  {
    code: "238140",
    title: "Glass unit (i.e., glass block) masonry",
  },
  {
    code: "238140",
    title: "Granite, exterior, contractors",
  },
  {
    code: "238140",
    title: "Marble, granite and slate, exterior, contractors",
  },
  {
    code: "238140",
    title: "Masonry contractors",
  },
  {
    code: "238140",
    title: "Masonry pointing, cleaning or caulking",
  },
  {
    code: "238140",
    title: "Refractory brick contractors",
  },
  {
    code: "238140",
    title: "Retaining wall, masonry (i.e., block, brick, stone), construction",
  },
  {
    code: "238140",
    title: "Slate (i.e., masonry) contractors",
  },
  {
    code: "238140",
    title: "Stonework (i.e., masonry) contractors",
  },
  {
    code: "238140",
    title: "Stucco contractors",
  },
  {
    code: "238140",
    title: "Tuck pointing contractors",
  },
  {
    code: "238150",
    title: "Curtain wall, glass, installation",
  },
  {
    code: "238150",
    title: "Decorative glass and mirror installation",
  },
  {
    code: "238150",
    title: "Glass cladding (i.e., curtain wall), installation",
  },
  {
    code: "238150",
    title: "Glass coating and tinting (except automotive) contractors",
  },
  {
    code: "238150",
    title: "Glass installation (except automotive) contractors",
  },
  {
    code: "238150",
    title: "Glass partitions, installation",
  },
  {
    code: "238150",
    title: "Glazing contractors",
  },
  {
    code: "238150",
    title: "Hermetically sealed window unit, commercial-type, installation",
  },
  {
    code: "238150",
    title: "Mirror installation",
  },
  {
    code: "238150",
    title: "Stained glass installation",
  },
  {
    code: "238150",
    title: "Window pane or sheet installation",
  },
  {
    code: "238160",
    title: "Asphalt roof shingle installation",
  },
  {
    code: "238160",
    title: "Copper roofing installation",
  },
  {
    code: "238160",
    title: "Corrugated metal roofing installation",
  },
  {
    code: "238160",
    title: "Galvanized iron roofing installation",
  },
  {
    code: "238160",
    title: "Low slope roofing installation",
  },
  {
    code: "238160",
    title: "Painting, spraying, or coating, roof",
  },
  {
    code: "238160",
    title: "Roll roofing installation",
  },
  {
    code: "238160",
    title: "Roof membrane installation",
  },
  {
    code: "238160",
    title: "Roof painting, spraying, or coating",
  },
  {
    code: "238160",
    title: "Roofing contractors",
  },
  {
    code: "238160",
    title: "Roofing, built-up tar and gravel, installation",
  },
  {
    code: "238160",
    title: "Shake and shingle, roof, installation",
  },
  {
    code: "238160",
    title: "Sheet metal roofing installation",
  },
  {
    code: "238160",
    title: "Skylight installation",
  },
  {
    code: "238160",
    title: "Solar reflecting coating, roof, application",
  },
  {
    code: "238160",
    title: "Steep slope roofing installation",
  },
  {
    code: "238160",
    title: "Treating roofs (by spraying, painting or coating)",
  },
  {
    code: "238170",
    title: "Aluminum siding installation",
  },
  {
    code: "238170",
    title: "Downspout, gutter, and gutter guard installation",
  },
  {
    code: "238170",
    title: "Eavestrough installation",
  },
  {
    code: "238170",
    title: "Fascia and soffit installation",
  },
  {
    code: "238170",
    title: "Flashing contractors",
  },
  {
    code: "238170",
    title: "Gutter and downspout contractors",
  },
  {
    code: "238170",
    title: "Gutters, seamless roof, formed and installed on site",
  },
  {
    code: "238170",
    title: "Ice apron, roof, installation",
  },
  {
    code: "238170",
    title: "Metal siding installation",
  },
  {
    code: "238170",
    title: "Siding (e.g., vinyl, wood, aluminum) installation",
  },
  {
    code: "238170",
    title: "Siding contractors",
  },
  {
    code: "238170",
    title: "Vinyl siding, soffit and fascia, installation",
  },
  {
    code: "238170",
    title: "Wood siding, installation",
  },
  {
    code: "238190",
    title: "Awning installation",
  },
  {
    code: "238190",
    title: "Balcony, metal, installation",
  },
  {
    code: "238190",
    title: "Cathodic protection, installation",
  },
  {
    code: "238190",
    title: "Concrete form contractors",
  },
  {
    code: "238190",
    title: "Curtain wall, metal, installation",
  },
  {
    code: "238190",
    title: "Deck and grate (except roof), metal, installation",
  },
  {
    code: "238190",
    title: "Decorative steel and wrought iron work installation",
  },
  {
    code: "238190",
    title: "Epoxy application contractors",
  },
  {
    code: "238190",
    title: "Erection and dismantling, poured concrete form",
  },
  {
    code: "238190",
    title: "Falsework construction",
  },
  {
    code: "238190",
    title: "Fire escape installation",
  },
  {
    code: "238190",
    title: "Forming contractor",
  },
  {
    code: "238190",
    title: "Forms for poured concrete, erecting and dismantling",
  },
  {
    code: "238190",
    title: "Metal furring contractors",
  },
  {
    code: "238190",
    title: "Ornamental metal work installation",
  },
  {
    code: "238190",
    title: "Shutter installation",
  },
  {
    code: "238190",
    title: "Stairway, metal, installation",
  },
  {
    code: "238190",
    title: "Storefront, metal or metal frame, installation",
  },
  {
    code: "238190",
    title: "Urethane slabjacking contractors",
  },
  {
    code: "238190",
    title: "Urethane soil stabilization contractors",
  },
  {
    code: "238190",
    title: "Welding, on-site, contractors",
  },
  {
    code: "238210",
    title: "Airport runway lighting contractors",
  },
  {
    code: "238210",
    title: "Alarm system (e.g., fire, burglar), electric, installation only",
  },
  {
    code: "238210",
    title: "Audio equipment installation (except automotive) contractors",
  },
  {
    code: "238210",
    title: "Audio visual equipment installation",
  },
  {
    code: "238210",
    title: "Building automation system installation contractors",
  },
  {
    code: "238210",
    title: "Burglar alarm system, electric, installation only",
  },
  {
    code: "238210",
    title: "Cable splicing, electrical or fiber optic",
  },
  {
    code: "238210",
    title: "Cable television hookup contractors",
  },
  {
    code: "238210",
    title: "Communication equipment installation",
  },
  {
    code: "238210",
    title: "Computer and network cable installation",
  },
  {
    code: "238210",
    title:
      "Control system (e.g., environmental, humidity, temperature) installation",
  },
  {
    code: "238210",
    title: "Electric contracting",
  },
  {
    code: "238210",
    title: "Electric power control panel and outlet installation",
  },
  {
    code: "238210",
    title: "Electrical contractors",
  },
  {
    code: "238210",
    title: "Electrical equipment and appliance installation",
  },
  {
    code: "238210",
    title: "Electrical wiring contractors",
  },
  {
    code: "238210",
    title: "Electrical work",
  },
  {
    code: "238210",
    title: "Electrical, electrical wiring, and low voltage electrical work",
  },
  {
    code: "238210",
    title: "Electrician",
  },
  {
    code: "238210",
    title: "Electronic containment fencing for pets, installation",
  },
  {
    code: "238210",
    title: "Electronic control installation and service",
  },
  {
    code: "238210",
    title: "Electronic control system installation",
  },
  {
    code: "238210",
    title: "Environmental control system installation",
  },
  {
    code: "238210",
    title: "Fiber optic cable (except transmission lines) installation",
  },
  {
    code: "238210",
    title: "Fire alarm system, electric, installation only",
  },
  {
    code: "238210",
    title:
      "Highway, street and bridge lighting and electrical signal installation",
  },
  {
    code: "238210",
    title: "Home automation system installation",
  },
  {
    code: "238210",
    title: "Home standby power generator installation",
  },
  {
    code: "238210",
    title: "Home theater installation",
  },
  {
    code: "238210",
    title: "Humidity control system installation",
  },
  {
    code: "238210",
    title: "Installation of photovoltaic panels",
  },
  {
    code: "238210",
    title: "Intercommunication (intercom) system installation",
  },
  {
    code: "238210",
    title: "Lighting system installation",
  },
  {
    code: "238210",
    title: "Low voltage electrical work",
  },
  {
    code: "238210",
    title: "Private driveway or parking area lighting contractors",
  },
  {
    code: "238210",
    title: "Public address system installation",
  },
  {
    code: "238210",
    title: "Railroad signaling equipment installation",
  },
  {
    code: "238210",
    title: "Security and fire system, installation only",
  },
  {
    code: "238210",
    title: "Smoke detection system, installation only",
  },
  {
    code: "238210",
    title: "Snow melting cable, electric, installation",
  },
  {
    code: "238210",
    title: "Solar panel installation",
  },
  {
    code: "238210",
    title: "Sound equipment installation",
  },
  {
    code: "238210",
    title: "Surveillance system, installation only",
  },
  {
    code: "238210",
    title:
      "Telecommunications equipment and wiring (except transmission line) installation contractors",
  },
  {
    code: "238210",
    title: "Telephone equipment and building wiring installation",
  },
  {
    code: "238210",
    title: "Telephone installation contractors",
  },
  {
    code: "238210",
    title: "Temperature control system installation",
  },
  {
    code: "238210",
    title: "Traffic signal installation",
  },
  {
    code: "238210",
    title: "Tunnel lighting contractors",
  },
  {
    code: "238220",
    title: "Air system balancing and testing",
  },
  {
    code: "238220",
    title: "Air vent installation",
  },
  {
    code: "238220",
    title: "Air-conditioning system (except window) installation",
  },
  {
    code: "238220",
    title: "Bathroom plumbing fixture and sanitary ware installation",
  },
  {
    code: "238220",
    title: "Blower or fan, cooling and dry heating, installation",
  },
  {
    code: "238220",
    title: "Boiler chipping, cleaning and scaling",
  },
  {
    code: "238220",
    title: "Boiler, heating, installation",
  },
  {
    code: "238220",
    title: "Central air-conditioning equipment installation",
  },
  {
    code: "238220",
    title: "Central cooling equipment and piping installation",
  },
  {
    code: "238220",
    title: "Central heating equipment and piping installation",
  },
  {
    code: "238220",
    title: "Chilled water system installation",
  },
  {
    code: "238220",
    title: "Chimney liner installation",
  },
  {
    code: "238220",
    title: "Commercial freezer installation",
  },
  {
    code: "238220",
    title: "Commercial refrigeration system installation",
  },
  {
    code: "238220",
    title: "Cooling tower installation",
  },
  {
    code: "238220",
    title: "Drain, waste and vent system installation",
  },
  {
    code: "238220",
    title: "Drinking fountain installation",
  },
  {
    code: "238220",
    title: "Dry heating equipment installation",
  },
  {
    code: "238220",
    title:
      "Duct work (e.g., cooling, dust collection, exhaust, heating, ventilation) installation",
  },
  {
    code: "238220",
    title: "Dust collecting and bag house equipment installation",
  },
  {
    code: "238220",
    title:
      "Exhaust system (e.g., kitchens, industrial work areas) installation",
  },
  {
    code: "238220",
    title: "Fire extinguisher installation",
  },
  {
    code: "238220",
    title: "Fire extinguisher installation and repair",
  },
  {
    code: "238220",
    title: "Fire sprinkler system installation",
  },
  {
    code: "238220",
    title: "Fireplace, natural gas, installation",
  },
  {
    code: "238220",
    title: "Fuel oil burner installation",
  },
  {
    code: "238220",
    title: "Furnace conversion (i.e., from one fuel to another)",
  },
  {
    code: "238220",
    title: "Furnace humidifier installation",
  },
  {
    code: "238220",
    title: "Furnace installation",
  },
  {
    code: "238220",
    title: "Furnace, forced air, installation",
  },
  {
    code: "238220",
    title: "Gas fitting contractor",
  },
  {
    code: "238220",
    title: "Gas line installation, individual hookup, contractors",
  },
  {
    code: "238220",
    title: "Heat pump installation",
  },
  {
    code: "238220",
    title: "Heating and cooling duct work installation",
  },
  {
    code: "238220",
    title:
      "Heating and ventilation system component (e.g., air registers, diffusers, filters, grilles, sound attenuators) installation",
  },
  {
    code: "238220",
    title: "Heating boiler installation",
  },
  {
    code: "238220",
    title: "Heating contractors",
  },
  {
    code: "238220",
    title: "Heating equipment installation",
  },
  {
    code: "238220",
    title: "Heating, ventilation and air-conditioning (HVAC) contractors",
  },
  {
    code: "238220",
    title: "Hot water heating system installation",
  },
  {
    code: "238220",
    title: "Hot water tank installation",
  },
  {
    code: "238220",
    title: "Household oil storage tank installation",
  },
  {
    code: "238220",
    title: "HVAC (heating, ventilation and air-conditioning) contractors",
  },
  {
    code: "238220",
    title: "Hydronic heating system installation",
  },
  {
    code: "238220",
    title: "Industrial process piping installation",
  },
  {
    code: "238220",
    title: "Kitchen sink and hardware installation",
  },
  {
    code: "238220",
    title: "Lawn sprinkler system installation ",
  },
  {
    code: "238220",
    title: "Mechanical contractors",
  },
  {
    code: "238220",
    title: "Natural gas piping installation",
  },
  {
    code: "238220",
    title: "Oil burner installation",
  },
  {
    code: "238220",
    title: "Pipe fitting contractors",
  },
  {
    code: "238220",
    title: "Plumbers",
  },
  {
    code: "238220",
    title: "Plumbing and heating contractors",
  },
  {
    code: "238220",
    title: "Plumbing contractors",
  },
  {
    code: "238220",
    title: "Plumbing fixture installation",
  },
  {
    code: "238220",
    title: "Process piping installation",
  },
  {
    code: "238220",
    title: "Pumping system, water, installation",
  },
  {
    code: "238220",
    title: "Radiant floor heating equipment installation",
  },
  {
    code: "238220",
    title:
      "Refrigeration system (e.g., commercial, industrial, scientific) installation",
  },
  {
    code: "238220",
    title: "Sanitary ware installation",
  },
  {
    code: "238220",
    title: "Scrubber, air purification, installation",
  },
  {
    code: "238220",
    title: "Sewer hookup and connection, building",
  },
  {
    code: "238220",
    title: "Sheet metal duct work installation",
  },
  {
    code: "238220",
    title: "Snow melting system (e.g., hot water, glycol) installation",
  },
  {
    code: "238220",
    title: "Solar heating equipment installation",
  },
  {
    code: "238220",
    title: "Sprinkler system, building, installation",
  },
  {
    code: "238220",
    title: "Steam fitting contractors",
  },
  {
    code: "238220",
    title: "Sump pump installation",
  },
  {
    code: "238220",
    title: "Ventilating contractors",
  },
  {
    code: "238220",
    title: "Warehouse refrigeration system installation",
  },
  {
    code: "238220",
    title: "Warm air heating system installation",
  },
  {
    code: "238220",
    title: "Water heater installation",
  },
  {
    code: "238220",
    title: "Water meter installation",
  },
  {
    code: "238220",
    title: "Water softener installation",
  },
  {
    code: "238220",
    title: "Water system balancing and testing contractors",
  },
  {
    code: "238220",
    title: "Waterless fire suppression system installation",
  },
  {
    code: "238220",
    title: "Waterless fire suppression system installation and repair",
  },
  {
    code: "238290",
    title: "Antenna, household-type, installation",
  },
  {
    code: "238290",
    title: "ATMs (automated teller machines) installation",
  },
  {
    code: "238290",
    title: "Automated and revolving door installation",
  },
  {
    code: "238290",
    title: "Automatic gate (e.g., garage, parking lot) installation",
  },
  {
    code: "238290",
    title: "Boiler and pipe insulation installation",
  },
  {
    code: "238290",
    title: "Boiler covering installation",
  },
  {
    code: "238290",
    title: "Bowling alley equipment installation",
  },
  {
    code: "238290",
    title: "Church bell and tower clock installation",
  },
  {
    code: "238290",
    title:
      "Commercial kitchen food preparation equipment (e.g., mixers, ovens, stoves) installation",
  },
  {
    code: "238290",
    title: "Commercial-type door installation",
  },
  {
    code: "238290",
    title: "Conveyor system installation",
  },
  {
    code: "238290",
    title: "Deodorization (i.e., air filtration) system installation",
  },
  {
    code: "238290",
    title: "Dismantling large-scale machinery and equipment",
  },
  {
    code: "238290",
    title: "Door, commercial- or industrial-type, installation",
  },
  {
    code: "238290",
    title: "Duct insulation installation",
  },
  {
    code: "238290",
    title: "Dumbwaiter installation",
  },
  {
    code: "238290",
    title: "Elevator installation",
  },
  {
    code: "238290",
    title: "Escalator installation",
  },
  {
    code: "238290",
    title: "Garage door, commercial- or industrial-type, installation",
  },
  {
    code: "238290",
    title: "Gasoline pump, service station, installation",
  },
  {
    code: "238290",
    title: "Hoisting and placement of large-scale apparatus",
  },
  {
    code: "238290",
    title: "Incinerators, building equipment type, installation",
  },
  {
    code: "238290",
    title: "Insulation, boiler, duct and pipe, installation",
  },
  {
    code: "238290",
    title: "Lightning protection equipment (e.g., lightning rod) installation",
  },
  {
    code: "238290",
    title: "Lightning rod and conductor installation",
  },
  {
    code: "238290",
    title: "Machine rigging",
  },
  {
    code: "238290",
    title: "Machinery and equipment, large-scale, installation",
  },
  {
    code: "238290",
    title: "Material handling equipment installation",
  },
  {
    code: "238290",
    title: "Mechanical equipment insulation",
  },
  {
    code: "238290",
    title: "Millwrights",
  },
  {
    code: "238290",
    title:
      "Motor vehicle garage and service station mechanical equipment (e.g., gasoline pumps, hoists) installation",
  },
  {
    code: "238290",
    title: "Moving sidewalk installation",
  },
  {
    code: "238290",
    title: "Overhead door, commercial- or industrial-type, installation",
  },
  {
    code: "238290",
    title: "Pipe covering",
  },
  {
    code: "238290",
    title: "Pipe, duct and boiler insulation",
  },
  {
    code: "238290",
    title: "Pneumatic tube conveyor system installation",
  },
  {
    code: "238290",
    title: "Power boiler, installation only",
  },
  {
    code: "238290",
    title:
      "Power generating equipment (except home standby power generator) installation",
  },
  {
    code: "238290",
    title: "Revolving door installation",
  },
  {
    code: "238290",
    title: "Rigging large-scale equipment",
  },
  {
    code: "238290",
    title: "Rubber door installation",
  },
  {
    code: "238290",
    title: "Satellite dish, household-type, installation",
  },
  {
    code: "238290",
    title: "Vacuum cleaning system, built-in, installation",
  },
  {
    code: "238290",
    title: "Vault, safe and banking machine installation",
  },
  {
    code: "238290",
    title: "Vehicle lift installation",
  },
  {
    code: "238290",
    title: "Vending machine installation",
  },
  {
    code: "238290",
    title: "Water pipe insulating",
  },
  {
    code: "238310",
    title: "Acoustical ceiling tile and panel installation",
  },
  {
    code: "238310",
    title: "Acoustical foam (i.e., sound barrier) installation",
  },
  {
    code: "238310",
    title: "Attic space insulating",
  },
  {
    code: "238310",
    title: "Blown-in insulation (e.g., cellulose, vermiculite) installation",
  },
  {
    code: "238310",
    title: "Building fireproofing contractors",
  },
  {
    code: "238310",
    title: "Building insulation contractors",
  },
  {
    code: "238310",
    title: "Ceiling tile installation",
  },
  {
    code: "238310",
    title: "Cellulosic fiber insulation installation",
  },
  {
    code: "238310",
    title: "Drop ceiling installation",
  },
  {
    code: "238310",
    title: "Drywall contractors",
  },
  {
    code: "238310",
    title:
      "Drywall finishing (e.g., sanding, spackling, stippling, taping, texturing)",
  },
  {
    code: "238310",
    title: "Drywall hanging",
  },
  {
    code: "238310",
    title: "Drywall installation",
  },
  {
    code: "238310",
    title: "Exterior insulation finish system installation",
  },
  {
    code: "238310",
    title: "Fabric wall system, noise insulating, installation",
  },
  {
    code: "238310",
    title: "Finishing drywall contractors",
  },
  {
    code: "238310",
    title: "Fireproof flooring installation",
  },
  {
    code: "238310",
    title: "Fireproofing buildings",
  },
  {
    code: "238310",
    title: "Firestop contractors ",
  },
  {
    code: "238310",
    title: "Foam insulation installation",
  },
  {
    code: "238310",
    title: "Fresco (i.e., decorative plaster finishing) contractors",
  },
  {
    code: "238310",
    title: "Glass fiber insulation installation",
  },
  {
    code: "238310",
    title: "Gypsum board installation",
  },
  {
    code: "238310",
    title: "Insulation contractors",
  },
  {
    code: "238310",
    title: "Lathing contractors",
  },
  {
    code: "238310",
    title: "Mineral wool insulation installation",
  },
  {
    code: "238310",
    title: "Panel or rigid board insulation installation",
  },
  {
    code: "238310",
    title: "Plastering (i.e., ornamental, plain) contractors",
  },
  {
    code: "238310",
    title: "Polystyrene board insulation installation",
  },
  {
    code: "238310",
    title: "Roof insulation contractor",
  },
  {
    code: "238310",
    title: "Soundproofing contractors",
  },
  {
    code: "238310",
    title: "Styrofoam insulation installation",
  },
  {
    code: "238310",
    title: "Suspended ceiling installation",
  },
  {
    code: "238310",
    title: "Taping and finishing drywall",
  },
  {
    code: "238310",
    title: "Urethane foam insulation application",
  },
  {
    code: "238310",
    title: "Wall cavity and attic space insulation installation",
  },
  {
    code: "238320",
    title: "Bridge painting",
  },
  {
    code: "238320",
    title: "Electrostatic painting, on-site, contractors",
  },
  {
    code: "238320",
    title:
      "Engineering structure (e.g., oil storage tank, water tower) painting",
  },
  {
    code: "238320",
    title: "House painting",
  },
  {
    code: "238320",
    title: "Paint and wallpaper stripping",
  },
  {
    code: "238320",
    title: "Painting (except roof) contractors",
  },
  {
    code: "238320",
    title: "Painting and wallpapering",
  },
  {
    code: "238320",
    title: "Paperhanging and removal contractors",
  },
  {
    code: "238320",
    title: "Paperhanging or removal contractors",
  },
  {
    code: "238320",
    title: "Rustproofing (except automotive)",
  },
  {
    code: "238320",
    title: "Ship painting contractors",
  },
  {
    code: "238320",
    title: "Wall covering or removal contractors",
  },
  {
    code: "238320",
    title: "Wallpaper hanging and removal contractors",
  },
  {
    code: "238320",
    title: "Wallpaper stripping",
  },
  {
    code: "238320",
    title: "Whitewashing contractors",
  },
  {
    code: "238330",
    title: "Access flooring installation",
  },
  {
    code: "238330",
    title: "Asphalt flooring, installation only",
  },
  {
    code: "238330",
    title: "Carpet, installation only",
  },
  {
    code: "238330",
    title: "Computer flooring installation",
  },
  {
    code: "238330",
    title: "Floor laying, scraping, finishing and refinishing",
  },
  {
    code: "238330",
    title: "Floor tile and sheets, installation only",
  },
  {
    code: "238330",
    title: "Hardwood flooring, installation only",
  },
  {
    code: "238330",
    title: "Linoleum, installation only",
  },
  {
    code: "238330",
    title: "Parquet flooring installation",
  },
  {
    code: "238330",
    title:
      "Resilient floor tile or sheet (e.g., linoleum, rubber, vinyl), installation only",
  },
  {
    code: "238330",
    title: "Resurfacing hardwood flooring",
  },
  {
    code: "238330",
    title: "Vinyl flooring contractors",
  },
  {
    code: "238330",
    title: "Wood floor finishing (e.g., coating, sanding)",
  },
  {
    code: "238330",
    title: "Wood flooring, installation only",
  },
  {
    code: "238340",
    title: "Ceramic tile installation",
  },
  {
    code: "238340",
    title: "Countertop (ceramic tile, stone), residential-type, installation",
  },
  {
    code: "238340",
    title: "Granite, interior, installation",
  },
  {
    code: "238340",
    title: "Mantel, marble or stone, installation",
  },
  {
    code: "238340",
    title: "Marble, granite, and slate, interior installation contractors",
  },
  {
    code: "238340",
    title: "Mosaic work",
  },
  {
    code: "238340",
    title: "Slate, interior, installation",
  },
  {
    code: "238340",
    title: "Stone flooring installation",
  },
  {
    code: "238340",
    title: "Terrazzo and tile refinishing",
  },
  {
    code: "238340",
    title: "Terrazzo contractors",
  },
  {
    code: "238340",
    title: "Tile (except resilient) contractors",
  },
  {
    code: "238340",
    title: "Tile (except resilient) laying and setting",
  },
  {
    code: "238350",
    title: "Aluminum door and window, residential-type, installation",
  },
  {
    code: "238350",
    title: "Built-in wood cabinets constructed on site",
  },
  {
    code: "238350",
    title: "Cabinet work performed at the construction site",
  },
  {
    code: "238350",
    title: "Cabinetry work performed at the construction site",
  },
  {
    code: "238350",
    title: "Cabinets, wood built-in, constructed on site",
  },
  {
    code: "238350",
    title: "Carpenters (except framing)",
  },
  {
    code: "238350",
    title: "Carpentry work (except framing)",
  },
  {
    code: "238350",
    title:
      "Countertop (except ceramic tile or stone), residential-type, installation",
  },
  {
    code: "238350",
    title: "Deck construction, residential-type",
  },
  {
    code: "238350",
    title: "Door and window frame construction",
  },
  {
    code: "238350",
    title: "Door and window, prefabricated, installation",
  },
  {
    code: "238350",
    title: "Door, folding, installation",
  },
  {
    code: "238350",
    title: "Finish carpentry",
  },
  {
    code: "238350",
    title: "Garage door, residential-type, installation",
  },
  {
    code: "238350",
    title: "Hermetically sealed window unit, residential-type, installation",
  },
  {
    code: "238350",
    title: "Kitchen cabinets and counters, constructed on site",
  },
  {
    code: "238350",
    title: "Millwork installation",
  },
  {
    code: "238350",
    title: "Molding or trim, wood or plastic, installation",
  },
  {
    code: "238350",
    title: "Overhead door, residential-type, installation",
  },
  {
    code: "238350",
    title: "Paneling installation",
  },
  {
    code: "238350",
    title:
      "Prefabricated kitchen and bath cabinet, residential-type, installation",
  },
  {
    code: "238350",
    title: "Prefabricated sash and door installation",
  },
  {
    code: "238350",
    title: "Shelving, wood, constructed on site",
  },
  {
    code: "238350",
    title: "Ship joinery contractors",
  },
  {
    code: "238350",
    title: "Stairway, wood, installation",
  },
  {
    code: "238350",
    title: "Trim and finish carpentry contractors",
  },
  {
    code: "238350",
    title:
      "Window and door (residential-type) of any material, prefabricated, installation",
  },
  {
    code: "238350",
    title: "Window installation",
  },
  {
    code: "238350",
    title: "Window, metal frame residential-type, installation",
  },
  {
    code: "238350",
    title: "Window, wood, installation",
  },
  {
    code: "238390",
    title: "Bathtub refinishing, on-site",
  },
  {
    code: "238390",
    title: "Bleacher installation",
  },
  {
    code: "238390",
    title:
      "Building fixture and fitting (except mechanical equipment) installation",
  },
  {
    code: "238390",
    title: "Caulking (i.e., waterproofing) contractors",
  },
  {
    code: "238390",
    title: "Ceiling, metal, installation",
  },
  {
    code: "238390",
    title: "Closet organizer system installation",
  },
  {
    code: "238390",
    title: "Coating concrete structures with plastics",
  },
  {
    code: "238390",
    title: "Concrete coating, glazing or sealing",
  },
  {
    code: "238390",
    title:
      "Countertop and cabinet, metal (except residential-type), installation",
  },
  {
    code: "238390",
    title: "Dampproofing contractors",
  },
  {
    code: "238390",
    title: "Drapery fixture (e.g., hardware, rods, tracks) installation",
  },
  {
    code: "238390",
    title: "Fabrication, metal cabinet or countertop, on site",
  },
  {
    code: "238390",
    title:
      "Foundation dampproofing (including installing rigid foam insulation)",
  },
  {
    code: "238390",
    title: "Laboratory furniture and equipment installation",
  },
  {
    code: "238390",
    title: "Lead lining walls for X-ray room contractors",
  },
  {
    code: "238390",
    title: "Modular furniture system attachment and installation",
  },
  {
    code: "238390",
    title: "Museum exhibit installation and dismantling contractors",
  },
  {
    code: "238390",
    title: "Office furniture, modular system, installation",
  },
  {
    code: "238390",
    title: "Panel, metal, installation",
  },
  {
    code: "238390",
    title: "Partition (e.g., office, washroom), metal, installation",
  },
  {
    code: "238390",
    title: "Partition, moveable and/or demountable, installation",
  },
  {
    code: "238390",
    title: "Shelving, metal, constructed on site",
  },
  {
    code: "238390",
    title: "Spectator seating installation",
  },
  {
    code: "238390",
    title: "Trade show exhibit installation and dismantling contractors",
  },
  {
    code: "238390",
    title:
      "Ventilated wire shelving (i.e., closet organizing-type) installation",
  },
  {
    code: "238390",
    title: "Vibration isolation contractors",
  },
  {
    code: "238390",
    title: "Waterproofing contractors",
  },
  {
    code: "238390",
    title: "Weatherproofing concrete",
  },
  {
    code: "238390",
    title: "Weatherstripping installation",
  },
  {
    code: "238390",
    title: "Window shade and blind installation",
  },
  {
    code: "238910",
    title: "Aerial or picker truck, construction, rental with operator",
  },
  {
    code: "238910",
    title: "Backfilling, construction",
  },
  {
    code: "238910",
    title: "Backhoe rental with operator",
  },
  {
    code: "238910",
    title: "Blast hole drilling (except mining)",
  },
  {
    code: "238910",
    title: "Blasting, building demolition",
  },
  {
    code: "238910",
    title: "Blasting, construction site",
  },
  {
    code: "238910",
    title: "Boring, for building construction",
  },
  {
    code: "238910",
    title: "Building demolition",
  },
  {
    code: "238910",
    title: "Building interior gutting and stripping",
  },
  {
    code: "238910",
    title: "Bulldozer rental with operator",
  },
  {
    code: "238910",
    title: "Caisson (i.e., drilled building foundations) construction",
  },
  {
    code: "238910",
    title: "Cesspool construction",
  },
  {
    code: "238910",
    title: "Concrete breaking and cutting for demolition",
  },
  {
    code: "238910",
    title: "Construction equipment (except crane) rental with operator",
  },
  {
    code: "238910",
    title: "Core drilling and test boring for construction",
  },
  {
    code: "238910",
    title: "Crawler tractor rental with operator",
  },
  {
    code: "238910",
    title: "Culvert or bridge removal",
  },
  {
    code: "238910",
    title: "Cutting new rights of way",
  },
  {
    code: "238910",
    title: "Demolition contractor",
  },
  {
    code: "238910",
    title: "Demolition, building and structure",
  },
  {
    code: "238910",
    title: "Dewatering contractors",
  },
  {
    code: "238910",
    title: "Digging foundations",
  },
  {
    code: "238910",
    title: "Dirt moving for construction",
  },
  {
    code: "238910",
    title: "Dismantling engineering structures (e.g., oil storage tank)",
  },
  {
    code: "238910",
    title: "Drainage system (e.g., cesspool, septic tank) installation",
  },
  {
    code: "238910",
    title: "Drilled pier (i.e., for building foundations) contractors",
  },
  {
    code: "238910",
    title: "Drilled shaft (i.e., drilled building foundations) construction",
  },
  {
    code: "238910",
    title: "Dry well construction",
  },
  {
    code: "238910",
    title: "Equipment rental (except crane), construction, with operator",
  },
  {
    code: "238910",
    title:
      "Excavating, earthmoving or land clearing, mining (except overburden removal at open pit mine sites or quarries)",
  },
  {
    code: "238910",
    title: "Excavating, earthmoving, or land clearing contractors",
  },
  {
    code: "238910",
    title: "Excavation contractors",
  },
  {
    code: "238910",
    title: "Exterior demolition contractors",
  },
  {
    code: "238910",
    title: "Foundation digging (i.e., excavation)",
  },
  {
    code: "238910",
    title: "Foundation drilling contractors",
  },
  {
    code: "238910",
    title: "Grading construction sites",
  },
  {
    code: "238910",
    title: "Grave excavation contractors",
  },
  {
    code: "238910",
    title: "Ground thawing for construction site digging",
  },
  {
    code: "238910",
    title: "Helical pier (i.e., drilled building foundations) construction",
  },
  {
    code: "238910",
    title: "House demolishing",
  },
  {
    code: "238910",
    title: "House razing",
  },
  {
    code: "238910",
    title:
      "Hydrodemolition (i.e., demolition with pressurized water) contractors",
  },
  {
    code: "238910",
    title: "Interior demolition contractors",
  },
  {
    code: "238910",
    title: "Land clearing",
  },
  {
    code: "238910",
    title: "Land leveling contractors",
  },
  {
    code: "238910",
    title: "Line slashing or cutting (except maintenance)",
  },
  {
    code: "238910",
    title: "Machinery, construction (except cranes), rental with operator",
  },
  {
    code: "238910",
    title:
      "Mine site preparation and related construction activities, construction contractors",
  },
  {
    code: "238910",
    title: "Pile driving, building foundation",
  },
  {
    code: "238910",
    title:
      "Piling (i.e., bored, cast-in-place, drilled), building foundation, contractors",
  },
  {
    code: "238910",
    title: "Power shovel, construction, rental with operator",
  },
  {
    code: "238910",
    title:
      "Power, communication and pipe line right of way clearance (except maintenance)",
  },
  {
    code: "238910",
    title:
      "Removal of dams, dikes, and other heavy and civil engineering constructions",
  },
  {
    code: "238910",
    title: "Right of way cutting (except maintenance)",
  },
  {
    code: "238910",
    title: "Road decommissioning",
  },
  {
    code: "238910",
    title: "Septic system contractors",
  },
  {
    code: "238910",
    title: "Septic tank and weeping tile installation",
  },
  {
    code: "238910",
    title: "Soil compacting",
  },
  {
    code: "238910",
    title: "Soil test drilling",
  },
  {
    code: "238910",
    title: "Test boring for construction",
  },
  {
    code: "238910",
    title: "Trenching (except underwater)",
  },
  {
    code: "238910",
    title: "Underground tank (except hazardous material) removal",
  },
  {
    code: "238910",
    title: "Weeping tile installation",
  },
  {
    code: "238910",
    title: "Whole building deconstruction",
  },
  {
    code: "238910",
    title: "Wrecking, building or other structure",
  },
  {
    code: "238990",
    title: "Artificial turf installation",
  },
  {
    code: "238990",
    title:
      "Asphalt coating and sealing, residential and commercial parking lot and driveway",
  },
  {
    code: "238990",
    title: "Asphalting, residential and commercial driveway and parking area",
  },
  {
    code: "238990",
    title: "Billboard erection",
  },
  {
    code: "238990",
    title:
      "Blacktop work, residential and commercial driveway and parking area",
  },
  {
    code: "238990",
    title: "Boat lift installation",
  },
  {
    code: "238990",
    title: "Brick driveway contractors",
  },
  {
    code: "238990",
    title: "Brick paver (e.g., driveways, patios, sidewalks) installation",
  },
  {
    code: "238990",
    title: "Cable splicing (except electrical or fiber optic)",
  },
  {
    code: "238990",
    title: "Chain link fence installation",
  },
  {
    code: "238990",
    title: "Concrete patio construction",
  },
  {
    code: "238990",
    title:
      "Concrete paving, residential and commercial driveway and parking area",
  },
  {
    code: "238990",
    title: "Concrete sawing and drilling (except demolition)",
  },
  {
    code: "238990",
    title:
      "Construction elevator (i.e., temporary use during construction) erection and dismantling",
  },
  {
    code: "238990",
    title: "Crane rental with operator",
  },
  {
    code: "238990",
    title: "Culvert, concrete, residential and commercial paved area",
  },
  {
    code: "238990",
    title:
      "Curb and gutter construction, residential and commercial driveway and parking area, concrete",
  },
  {
    code: "238990",
    title: "Driveway paving or sealing",
  },
  {
    code: "238990",
    title:
      "Fence installation (except electronic containment fencing for pets)",
  },
  {
    code: "238990",
    title:
      "Fencing contractors (except electronic containment fencing for pets)",
  },
  {
    code: "238990",
    title: "Flagpole installation",
  },
  {
    code: "238990",
    title:
      "House moving (i.e., raising from one site, moving, and placing on a new foundation)",
  },
  {
    code: "238990",
    title: "Interlocking brick and block installation",
  },
  {
    code: "238990",
    title: "Mail box units, outdoor, multiple box-type, erection",
  },
  {
    code: "238990",
    title: "Manufactured (mobile) home set up and tie-down work",
  },
  {
    code: "238990",
    title: "Parking lot paving and sealing",
  },
  {
    code: "238990",
    title: "Patio construction",
  },
  {
    code: "238990",
    title: "Paver, brick (e.g., driveway, patio, sidewalk), installation",
  },
  {
    code: "238990",
    title: "Paving, residential and commercial driveway and parking lot",
  },
  {
    code: "238990",
    title: "Playground equipment installation",
  },
  {
    code: "238990",
    title: "Pole (e.g., telephone) removal",
  },
  {
    code: "238990",
    title: "Posthole digging",
  },
  {
    code: "238990",
    title: "Radon gas alleviation contractors",
  },
  {
    code: "238990",
    title: "Safety net system, erecting and dismantling at construction site",
  },
  {
    code: "238990",
    title: "Sandblasting, building exterior",
  },
  {
    code: "238990",
    title: "Scaffold erecting and dismantling",
  },
  {
    code: "238990",
    title: "Shoring, construction",
  },
  {
    code: "238990",
    title: "Sidewalk construction, residential and commercial",
  },
  {
    code: "238990",
    title: "Sign (except on highways, streets, bridges and tunnels) erection",
  },
  {
    code: "238990",
    title: "Sign, building, erection",
  },
  {
    code: "238990",
    title: "Statue erection",
  },
  {
    code: "238990",
    title: "Steeplejack work",
  },
  {
    code: "238990",
    title: "Street, interlocking brick (i.e., not mortared), installation",
  },
  {
    code: "238990",
    title: "Swimming pool screen enclosure construction",
  },
  {
    code: "238990",
    title: "Swimming pool, outdoor, construction",
  },
  {
    code: "238990",
    title: "Tank lining contractors",
  },
  {
    code: "238990",
    title: "Turf, artificial, installation",
  },
  {
    code: "238990",
    title: "Underpinning, construction",
  },
  {
    code: "311111",
    title: "Animal feed mills, dog and cat, manufacturing",
  },
  {
    code: "311111",
    title: "Animal feeds, prepared, dog and cat, manufacturing",
  },
  {
    code: "311111",
    title: "Cat food manufacturing",
  },
  {
    code: "311111",
    title:
      "Dog and cat food (e.g., canned, dry, frozen, semimoist), manufacturing",
  },
  {
    code: "311111",
    title: "Dog food manufacturing",
  },
  {
    code: "311111",
    title: "Feed supplements, dog and cat, manufacturing",
  },
  {
    code: "311111",
    title: "Feeds, prepared for dog and cat, manufacturing",
  },
  {
    code: "311111",
    title: "Horsemeat, processing, for dog and cat food",
  },
  {
    code: "311111",
    title: "Meat canning, dog and cat, pet food, made from purchased carcasses",
  },
  {
    code: "311111",
    title:
      "Meat products, dog and cat, pet food, canning, made from purchased carcasses",
  },
  {
    code: "311111",
    title: "Pet food, dog and cat, manufacturing",
  },
  {
    code: "311119",
    title: "Alfalfa meal, dehydrated, manufacturing",
  },
  {
    code: "311119",
    title: "Alfalfa prepared as feed for animals",
  },
  {
    code: "311119",
    title: "Alfalfa, cubed, manufacturing",
  },
  {
    code: "311119",
    title: "Animal feed mills (except dog and cat) manufacturing",
  },
  {
    code: "311119",
    title: "Animal feeds, prepared (except dog and cat), manufacturing",
  },
  {
    code: "311119",
    title: "Barley feed, chopped, crushed or ground, manufacturing",
  },
  {
    code: "311119",
    title: "Bird feed, prepared, manufacturing",
  },
  {
    code: "311119",
    title: "Blending animal feed",
  },
  {
    code: "311119",
    title: "Bone meal prepared as feed for animals and fowls",
  },
  {
    code: "311119",
    title:
      "Cattle feeds, supplements, concentrates, and premixes, manufacturing",
  },
  {
    code: "311119",
    title: "Chicken feeds, prepared, manufacturing",
  },
  {
    code: "311119",
    title: "Citrus pulp, cattle feed, manufacturing",
  },
  {
    code: "311119",
    title: "Complete feed, livestock, manufacturing",
  },
  {
    code: "311119",
    title: "Custom milling of animal feed",
  },
  {
    code: "311119",
    title:
      "Dairy cattle feeds, supplements, concentrates, and premixes, manufacturing",
  },
  {
    code: "311119",
    title: "Earthworm food and bedding manufacturing",
  },
  {
    code: "311119",
    title: "Feed concentrates, animal, manufacturing",
  },
  {
    code: "311119",
    title: "Feed premixes, animal, manufacturing",
  },
  {
    code: "311119",
    title: "Feed supplements, animal (except cat, dog), manufacturing",
  },
  {
    code: "311119",
    title: "Feeds, prepared, for animals (except cat, dog) manufacturing",
  },
  {
    code: "311119",
    title: "Feeds, specialty (e.g., guinea pig, mice, mink), manufacturing",
  },
  {
    code: "311119",
    title: "Fish food for feeding fish manufacturing",
  },
  {
    code: "311119",
    title: "Grain grinding, custom, for animal feed",
  },
  {
    code: "311119",
    title: "Grain mills, animal feed",
  },
  {
    code: "311119",
    title: "Hay, cubed, manufacturing",
  },
  {
    code: "311119",
    title: "Kelp meal and pellets, animal feed manufacturing",
  },
  {
    code: "311119",
    title: "Laboratory animal feed manufacturing",
  },
  {
    code: "311119",
    title:
      "Livestock feeds, supplements, concentrates and premixes, manufacturing",
  },
  {
    code: "311119",
    title: "Meal, alfalfa, manufacturing",
  },
  {
    code: "311119",
    title: "Meal, bone, prepared as feed for animals and fowls, manufacturing",
  },
  {
    code: "311119",
    title: "Micro and macro premixes, livestock, manufacturing",
  },
  {
    code: "311119",
    title: "Mineral feed supplements (except cat, dog) manufacturing",
  },
  {
    code: "311119",
    title: "Mineral supplements, animal (except cat, dog), manufacturing",
  },
  {
    code: "311119",
    title: "Mobile feed mill",
  },
  {
    code: "311119",
    title: "Pet food (except cat, dog) manufacturing",
  },
  {
    code: "311119",
    title: "Poultry feeds, supplements, and concentrates manufacturing",
  },
  {
    code: "311119",
    title: "Rabbit food manufacturing",
  },
  {
    code: "311119",
    title: "Shell crushing and grinding for animal feed",
  },
  {
    code: "311119",
    title: "Shell crushing for feed",
  },
  {
    code: "311119",
    title: "Swine feed, complete, manufacturing",
  },
  {
    code: "311119",
    title: "Swine feed, supplements, concentrates, and premixes, manufacturing",
  },
  {
    code: "311119",
    title: "Turkey feeds, prepared, manufacturing",
  },
  {
    code: "311211",
    title: "Barley flour manufacturing",
  },
  {
    code: "311211",
    title: "Batters, prepared, made in flour mills",
  },
  {
    code: "311211",
    title: "Blended flour made in flour mills",
  },
  {
    code: "311211",
    title: "Brewers' and distillers' flakes and grits, corn, manufacturing",
  },
  {
    code: "311211",
    title: "Buckwheat flour manufacturing",
  },
  {
    code: "311211",
    title: "Bulgur (flour) manufacturing",
  },
  {
    code: "311211",
    title: "Cereal grain flour manufacturing",
  },
  {
    code: "311211",
    title: "Cereal grain germ manufacturing",
  },
  {
    code: "311211",
    title: "Corn flour manufacturing",
  },
  {
    code: "311211",
    title: "Corn meal made in flour mills",
  },
  {
    code: "311211",
    title: "Doughs, prepared, made in flour mills",
  },
  {
    code: "311211",
    title: "Durum flour manufacturing",
  },
  {
    code: "311211",
    title: "Farina (except breakfast food) made in flour mills",
  },
  {
    code: "311211",
    title: "Flour mills, cereals grains (except breakfast cereals, rice)",
  },
  {
    code: "311211",
    title: "Flour mixes made in flour mills",
  },
  {
    code: "311211",
    title:
      "Flour, blended, prepared, or self-rising (except rice), made in flour mills",
  },
  {
    code: "311211",
    title: "Fruit flour, meal, and powders, manufacturing",
  },
  {
    code: "311211",
    title: "Graham flour manufacturing",
  },
  {
    code: "311211",
    title: "Grain mills (except animal feed, breakfast cereal, rice)",
  },
  {
    code: "311211",
    title: "Grits and flakes, corn brewer's, manufacturing",
  },
  {
    code: "311211",
    title: "Hominy grits (except breakfast food), manufacturing",
  },
  {
    code: "311211",
    title: "Meal, corn, for human consumption made in flour mills",
  },
  {
    code: "311211",
    title:
      "Mixes, flour (e.g., biscuit, cake, doughnut, pancake) made in flour mills",
  },
  {
    code: "311211",
    title: "Oat flour manufacturing",
  },
  {
    code: "311211",
    title: "Potato flour manufacturing",
  },
  {
    code: "311211",
    title: "Prepared flour mixes made in flour mills",
  },
  {
    code: "311211",
    title: "Rye flour manufacturing",
  },
  {
    code: "311211",
    title: "Semolina flour manufacturing",
  },
  {
    code: "311211",
    title: "Sorghum flour manufacturing",
  },
  {
    code: "311211",
    title: "Vegetable flour manufacturing",
  },
  {
    code: "311211",
    title: "Vegetable flour, meal, and powders, made in flour mills",
  },
  {
    code: "311211",
    title: "Wheat bran manufacturing",
  },
  {
    code: "311211",
    title: "Wheat flour manufacturing",
  },
  {
    code: "311211",
    title: "Wheat germ manufacturing",
  },
  {
    code: "311212",
    title: "Bran and other residues of milling rice",
  },
  {
    code: "311212",
    title: "Brewers' rice manufacturing",
  },
  {
    code: "311212",
    title: "Cleaning and polishing rice",
  },
  {
    code: "311212",
    title: "Flour, rice, manufacturing",
  },
  {
    code: "311212",
    title: "Grain mills, rice",
  },
  {
    code: "311212",
    title: "Head rice manufacturing",
  },
  {
    code: "311212",
    title: "Milling rice",
  },
  {
    code: "311212",
    title: "Polished rice manufacturing",
  },
  {
    code: "311212",
    title: "Rice bran, flour, and meals, manufacturing",
  },
  {
    code: "311212",
    title: "Rice cleaning and polishing",
  },
  {
    code: "311212",
    title: "Rice flour manufacturing",
  },
  {
    code: "311212",
    title: "Rice meal manufacturing",
  },
  {
    code: "311212",
    title: "Rice milling",
  },
  {
    code: "311212",
    title:
      "Rice mixes (i.e., uncooked and packaged with other ingredients) made in rice mills",
  },
  {
    code: "311212",
    title: "Rice, brewer's, manufacturing",
  },
  {
    code: "311212",
    title: "Rice, brown, manufacturing",
  },
  {
    code: "311213",
    title: "Barley, malt, manufacturing",
  },
  {
    code: "311213",
    title: "Brewers' malt manufacturing",
  },
  {
    code: "311213",
    title: "Corn, malt, manufacturing",
  },
  {
    code: "311213",
    title: "Distiller's malt manufacturing",
  },
  {
    code: "311213",
    title: "Flour, malt, manufacturing",
  },
  {
    code: "311213",
    title: "Malt flour manufacturing",
  },
  {
    code: "311213",
    title: "Malt manufacturing",
  },
  {
    code: "311213",
    title: "Malt sprouts manufacturing",
  },
  {
    code: "311213",
    title: "Malting (germinating and drying grains)",
  },
  {
    code: "311213",
    title: "Rice malt manufacturing",
  },
  {
    code: "311213",
    title: "Rye malt manufacturing",
  },
  {
    code: "311213",
    title: "Wheat malt manufacturing",
  },
  {
    code: "311221",
    title: "Corn dextrin manufacturing",
  },
  {
    code: "311221",
    title: "Corn gluten feed manufacturing",
  },
  {
    code: "311221",
    title: "Corn gluten meal manufacturing",
  },
  {
    code: "311221",
    title: "Corn oil cake and meal manufacturing",
  },
  {
    code: "311221",
    title: "Corn oil mills",
  },
  {
    code: "311221",
    title: "Corn oil, crude and refined, made by wet milling corn",
  },
  {
    code: "311221",
    title: "Corn starch manufacturing",
  },
  {
    code: "311221",
    title:
      "Corn sweeteners (e.g., dextrose, fructose, glucose) made by wet milling corn",
  },
  {
    code: "311221",
    title: "Crude corn oil manufacturing",
  },
  {
    code: "311221",
    title: "Dextrin made by wet milling corn",
  },
  {
    code: "311221",
    title: "Gluten feed, flour, and meal, made by wet milling corn",
  },
  {
    code: "311221",
    title: "Gluten manufacturing",
  },
  {
    code: "311221",
    title: "HFCS (high fructose corn syrup) manufacturing",
  },
  {
    code: "311221",
    title: "High fructose corn syrup (HFCS) manufacturing",
  },
  {
    code: "311221",
    title: "Maltodextrins manufacturing",
  },
  {
    code: "311221",
    title: "Margarine and other corn oils made by wet milling corn",
  },
  {
    code: "311221",
    title: "Oil, corn crude and refined, made by wet milling corn",
  },
  {
    code: "311221",
    title: "Potato starches manufacturing",
  },
  {
    code: "311221",
    title: "Rice starches manufacturing",
  },
  {
    code: "311221",
    title: "Root starches manufacturing",
  },
  {
    code: "311221",
    title: "Starches (except laundry) manufacturing",
  },
  {
    code: "311221",
    title: "Steepwater concentrate manufacturing",
  },
  {
    code: "311221",
    title: "Sugar made by wet milling corn",
  },
  {
    code: "311221",
    title: "Syrup, corn, made by wet milling",
  },
  {
    code: "311221",
    title: "Table oil, corn, made by wet milling",
  },
  {
    code: "311221",
    title: "Tapioca manufacturing",
  },
  {
    code: "311221",
    title: "Vegetable starches manufacturing",
  },
  {
    code: "311221",
    title: "Wet milling corn and other vegetables",
  },
  {
    code: "311224",
    title: "Canola (rapeseed) oil, cake and meal, made in crushing mills",
  },
  {
    code: "311224",
    title: "Castor oil and pomace made in crushing mills",
  },
  {
    code: "311224",
    title: "Coconut oil made in crushing mills",
  },
  {
    code: "311224",
    title: "Cottonseed oil, cake and meal, made in crushing mills",
  },
  {
    code: "311224",
    title: "Flaxseed oil made in crushing mills",
  },
  {
    code: "311224",
    title: "Lecithin, cottonseed, made in crushing mills",
  },
  {
    code: "311224",
    title: "Lecithin, soybean, made in crushing mills",
  },
  {
    code: "311224",
    title: "Linseed oil, cake and meal, made in crushing mills",
  },
  {
    code: "311224",
    title: "Olive oil made in crushing mills",
  },
  {
    code: "311224",
    title: "Palm-kernel oil, cake, and meal made in crushing mills",
  },
  {
    code: "311224",
    title: "Peanut cake, meal, and oil made in crushing mills",
  },
  {
    code: "311224",
    title: "Rapeseed (i.e., canola) oil made in crushing mills",
  },
  {
    code: "311224",
    title: "Safflower oil made in crushing mills",
  },
  {
    code: "311224",
    title: "Shortening made in crushing mills",
  },
  {
    code: "311224",
    title: "Soybean cakes and meal manufacturing",
  },
  {
    code: "311224",
    title: "Soybean flour and grits manufacturing",
  },
  {
    code: "311224",
    title: "Soybean millfeed made in oil mills",
  },
  {
    code: "311224",
    title: "Soybean oil mills",
  },
  {
    code: "311224",
    title: "Soybean oil, cake, and meal, made in crushing mills",
  },
  {
    code: "311224",
    title: "Soybean oil, crude, manufacturing",
  },
  {
    code: "311224",
    title: "Soybean oil, deodorized, made in oil mills",
  },
  {
    code: "311224",
    title: "Soybean oil, refined, made in crushing mills",
  },
  {
    code: "311224",
    title: "Soybean protein concentrates made in crushing mills",
  },
  {
    code: "311224",
    title: "Soybean protein isolates made in crushing mills",
  },
  {
    code: "311224",
    title: "Sunflower seed oil, cake and meal, made in crushing mills",
  },
  {
    code: "311224",
    title: "Tree nut oils (e.g., tung, walnut) made in crushing mill",
  },
  {
    code: "311224",
    title: "Vegetable oils made in crushing mills",
  },
  {
    code: "311225",
    title: "Butter substitutes made from purchased oils",
  },
  {
    code: "311225",
    title: "Canola (rapeseed) oil, cake and meal, made from purchased oils",
  },
  {
    code: "311225",
    title: "Coconut oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Cooking and baking oil sprays made from purchased oils",
  },
  {
    code: "311225",
    title: "Corn oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Cottonseed oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Flaxseed oil made from purchased oils",
  },
  {
    code: "311225",
    title:
      "Grease, inedible, animal and vegetable, refining and blending purchased oils",
  },
  {
    code: "311225",
    title: "Hydrogenating purchased oil",
  },
  {
    code: "311225",
    title: "Lecithin made from purchased oils",
  },
  {
    code: "311225",
    title: "Linseed oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Margarine-butter blend made from purchased fats and oils",
  },
  {
    code: "311225",
    title: "Margarines (including imitation) made from purchased fats and oils",
  },
  {
    code: "311225",
    title: "Nondairy butter made from purchased oils",
  },
  {
    code: "311225",
    title: "Oil, olive, made from purchased oils",
  },
  {
    code: "311225",
    title: "Oil, vegetable stearin, made from purchased oils",
  },
  {
    code: "311225",
    title: "Olive oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Palm-kernel oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Peanut oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Rapeseed (i.e., canola) oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Safflower oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Shortening made from purchased fats and oils",
  },
  {
    code: "311225",
    title: "Soybean cooking oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Table oil made from purchased oils",
  },
  {
    code: "311225",
    title: "Tree nut oils (e.g., tung, walnut) made from purchased oils",
  },
  {
    code: "311225",
    title: "Vegetable oils made from purchased oils",
  },
  {
    code: "311230",
    title: "Breakfast cereals manufacturing",
  },
  {
    code: "311230",
    title: "Corn breakfast foods manufacturing",
  },
  {
    code: "311230",
    title: "Farina, breakfast cereal, manufacturing",
  },
  {
    code: "311230",
    title: "Flour mills, breakfast cereal, manufacturing",
  },
  {
    code: "311230",
    title: "Grain mills, breakfast cereal",
  },
  {
    code: "311230",
    title: "Grain, breakfast cereal, manufacturing",
  },
  {
    code: "311230",
    title: "Granola, cereal (except bars and clusters), manufacturing",
  },
  {
    code: "311230",
    title: "Hominy grits, prepared as cereal breakfast food, manufacturing",
  },
  {
    code: "311230",
    title: "Infant cereals, dry, manufacturing",
  },
  {
    code: "311230",
    title: "Instant hot cereals manufacturing",
  },
  {
    code: "311230",
    title: "Mix grain breakfast manufacturing",
  },
  {
    code: "311230",
    title: "Oatmeal (i.e., cereal breakfast food) manufacturing",
  },
  {
    code: "311230",
    title: "Oats, breakfast cereal, manufacturing",
  },
  {
    code: "311230",
    title: "Oats, rolled (i.e., cereal breakfast food), manufacturing",
  },
  {
    code: "311230",
    title: "Rice breakfast foods manufacturing",
  },
  {
    code: "311230",
    title: "Wheat breakfast cereal manufacturing",
  },
  {
    code: "311313",
    title: "Beet pulp, dried, manufacturing",
  },
  {
    code: "311313",
    title: "Beet sugar refining",
  },
  {
    code: "311313",
    title: "Brown beet sugar refining",
  },
  {
    code: "311313",
    title: "Brown sugar made from beet sugar",
  },
  {
    code: "311313",
    title: "Confectioner's beet sugar manufacturing",
  },
  {
    code: "311313",
    title: "Granulated beet sugar manufacturing",
  },
  {
    code: "311313",
    title: "Liquid beet syrup manufacturing",
  },
  {
    code: "311313",
    title: "Liquid sugar made from beet sugar",
  },
  {
    code: "311313",
    title: "Molasses made from sugar beets",
  },
  {
    code: "311313",
    title: "Raw beet sugar manufacturing",
  },
  {
    code: "311313",
    title: "Sugar, confectionery, made from sugar beets",
  },
  {
    code: "311313",
    title: "Sugar, granulated, made from sugar beets",
  },
  {
    code: "311313",
    title: "Sugar, invert, made from sugar beets",
  },
  {
    code: "311313",
    title: "Sugar, liquid, made from sugar beets",
  },
  {
    code: "311313",
    title: "Syrup made from sugar beets",
  },
  {
    code: "311314",
    title: "Blackstrap molasses manufacturing",
  },
  {
    code: "311314",
    title: "Brown sugar manufacturing",
  },
  {
    code: "311314",
    title: "Cane sugar manufacturing",
  },
  {
    code: "311314",
    title: "Cane syrup manufacturing",
  },
  {
    code: "311314",
    title: "Confectioner's powdered sugar manufacturing",
  },
  {
    code: "311314",
    title: "Granulated cane sugar manufacturing",
  },
  {
    code: "311314",
    title: "Invert sugar manufacturing",
  },
  {
    code: "311314",
    title: "Liquid sugar manufacturing",
  },
  {
    code: "311314",
    title: "Molasses manufacturing",
  },
  {
    code: "311314",
    title: "Molasses, blackstrap, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, cane, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, clarified, granulated, and raw, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, confectionery, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, granulated, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, invert, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, raw, manufacturing",
  },
  {
    code: "311314",
    title: "Sugar, refined, manufacturing",
  },
  {
    code: "311314",
    title: "Sugarcane mills",
  },
  {
    code: "311314",
    title: "Sugarcane refining",
  },
  {
    code: "311314",
    title: "Syrup, cane, manufacturing",
  },
  {
    code: "311340",
    title: "Breakfast bars, nonchocolate covered, manufacturing",
  },
  {
    code: "311340",
    title: "Cake ornaments, confectionery, manufacturing",
  },
  {
    code: "311340",
    title: "Candied fruits and fruit peel manufacturing",
  },
  {
    code: "311340",
    title: "Candy bars, nonchocolate, manufacturing",
  },
  {
    code: "311340",
    title:
      "Candy stores, nonchocolate, candy made on premises, not for immediate consumption",
  },
  {
    code: "311340",
    title: "Chewing gum base manufacturing",
  },
  {
    code: "311340",
    title: "Chewing gum manufacturing",
  },
  {
    code: "311340",
    title: "Confectionery, nonchocolate, manufacturing",
  },
  {
    code: "311340",
    title: "Corn confections manufacturing",
  },
  {
    code: "311340",
    title: "Cough drops (except medicated) manufacturing",
  },
  {
    code: "311340",
    title: "Crystallized fruits and fruit peel manufacturing",
  },
  {
    code: "311340",
    title: "Dates, sugared and stuffed, manufacturing",
  },
  {
    code: "311340",
    title:
      "Fruit peel products (e.g., candied, crystallized, glace, glazed) manufacturing",
  },
  {
    code: "311340",
    title: "Fruits (e.g., candied, crystallized, glazed) manufacturing",
  },
  {
    code: "311340",
    title: "Fudge, nonchocolate, manufacturing",
  },
  {
    code: "311340",
    title: "Granola bars and clusters, nonchocolate, manufacturing",
  },
  {
    code: "311340",
    title: "Gum, chewing, manufacturing",
  },
  {
    code: "311340",
    title: "Halvah manufacturing",
  },
  {
    code: "311340",
    title: "Hard candies manufacturing",
  },
  {
    code: "311340",
    title: "Jelly candies manufacturing",
  },
  {
    code: "311340",
    title: "Licorice candy manufacturing",
  },
  {
    code: "311340",
    title: "Lozenges, nonmedicated, candy, manufacturing",
  },
  {
    code: "311340",
    title: "Marshmallow creme manufacturing",
  },
  {
    code: "311340",
    title: "Marshmallows manufacturing",
  },
  {
    code: "311340",
    title: "Marzipan (i.e., candy) manufacturing",
  },
  {
    code: "311340",
    title: "Nuts, covered (except chocolate covered), manufacturing",
  },
  {
    code: "311340",
    title: "Popcorn balls manufacturing",
  },
  {
    code: "311340",
    title: "Popcorn, candy covered popped, manufacturing",
  },
  {
    code: "311340",
    title: "Synthetic chocolate manufacturing",
  },
  {
    code: "311340",
    title: "Toffee manufacturing",
  },
  {
    code: "311351",
    title: "Baking chocolate made from cacao beans",
  },
  {
    code: "311351",
    title:
      "Candy bars, chocolate (including chocolate covered), made from cacao beans",
  },
  {
    code: "311351",
    title: "Candy, chocolate, made from cacao beans",
  },
  {
    code: "311351",
    title:
      "Chocolate (e.g.,  coatings, instant, liquor, syrups) made from cacao beans",
  },
  {
    code: "311351",
    title: "Chocolate bars made from cocoa beans",
  },
  {
    code: "311351",
    title: "Chocolate, confectionery, made from cacao beans",
  },
  {
    code: "311351",
    title: "Coatings, chocolate, made from cacao beans",
  },
  {
    code: "311351",
    title:
      "Cocoa (e.g., instant, mix, mixed with other ingredients, powder drink, powdered) made from cacao beans",
  },
  {
    code: "311351",
    title: "Cocoa butter made from cocoa beans",
  },
  {
    code: "311351",
    title: "Confectionery chocolate made from cacao beans",
  },
  {
    code: "311351",
    title: "Cooking chocolate made from cacao beans",
  },
  {
    code: "311351",
    title: "Drink powdered mixes, cocoa, made from cacao",
  },
  {
    code: "311351",
    title: "Fudge, chocolate, made from cacao beans",
  },
  {
    code: "311351",
    title: "Granola bars and clusters, chocolate, made from cacao beans",
  },
  {
    code: "311351",
    title: "Liquor, chocolate, made from cacao beans",
  },
  {
    code: "311351",
    title: "Nuts, chocolate covered, made from cacao beans",
  },
  {
    code: "311351",
    title: "Syrup, chocolate, made from cacao beans",
  },
  {
    code: "311352",
    title: "Baking chocolate made from purchased chocolate",
  },
  {
    code: "311352",
    title:
      "Candy stores, chocolate, candy made on premises not for immediate consumption",
  },
  {
    code: "311352",
    title:
      "Chocolate (coating, instant, liquor, syrups) made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Chocolate coatings and syrups made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Chocolate covered candy bars made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Chocolate covered granola bars made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Cocoa, powdered drink, prepared, made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Cocoa, powdered, made from purchased chocolate",
  },
  {
    code: "311352",
    title:
      "Cocoa, powdered, mixed with other ingredients, made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Drink powdered mixes, cocoa, made from purchased cocoa",
  },
  {
    code: "311352",
    title: "Fudge, chocolate, made from purchased chocolate",
  },
  {
    code: "311352",
    title:
      "Granola bars and clusters, chocolate, made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Liquor, chocolate, made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Nuts, chocolate covered, made from purchased chocolate",
  },
  {
    code: "311352",
    title: "Syrup, chocolate, made from purchased chocolate",
  },
  {
    code: "311411",
    title: "Blast freezing on a contract basis",
  },
  {
    code: "311411",
    title: "Citrus pulp, frozen, manufacturing",
  },
  {
    code: "311411",
    title: "Concentrates, frozen fruit juice, manufacturing",
  },
  {
    code: "311411",
    title: "French fries, frozen, pre-cooked, manufacturing",
  },
  {
    code: "311411",
    title: "Frozen ades, drinks and cocktail mixes, manufacturing",
  },
  {
    code: "311411",
    title: "Frozen citrus pulp manufacturing",
  },
  {
    code: "311411",
    title: "Frozen fruit and vegetable processing",
  },
  {
    code: "311411",
    title: "Frozen fruits, fruit juices, and vegetables, manufacturing",
  },
  {
    code: "311411",
    title: "Fruit juice concentrates, frozen, manufacturing",
  },
  {
    code: "311411",
    title: "Fruits, frozen, manufacturing",
  },
  {
    code: "311411",
    title: "Juices, fruit or vegetable concentrates, frozen, manufacturing",
  },
  {
    code: "311411",
    title: "Juices, fruit or vegetable, frozen, manufacturing",
  },
  {
    code: "311411",
    title: "Vegetable juice concentrates, frozen, manufacturing",
  },
  {
    code: "311411",
    title: "Vegetables, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Chop suey, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Chow mein, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Dinners, frozen (except seafood-based), manufacturing",
  },
  {
    code: "311412",
    title: "French toast, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Frozen dinners (except seafood-based) manufacturing",
  },
  {
    code: "311412",
    title:
      "Frozen food entrees (except seafood-based), packaged, manufacturing",
  },
  {
    code: "311412",
    title: "Frozen pizza manufacturing",
  },
  {
    code: "311412",
    title: "Frozen pot pies manufacturing",
  },
  {
    code: "311412",
    title: "Frozen rice dishes manufacturing",
  },
  {
    code: "311412",
    title: "Frozen side dishes manufacturing",
  },
  {
    code: "311412",
    title: "Frozen soups (except seafood) manufacturing",
  },
  {
    code: "311412",
    title: "Frozen waffles manufacturing",
  },
  {
    code: "311412",
    title: "Macaroni, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Meatless patties, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Mexican foods, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Nationality specialty foods, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Pancakes, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Pizzas, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Pot pies, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Soups, frozen (except seafood), manufacturing",
  },
  {
    code: "311412",
    title: "Vegetable patties, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Waffles, frozen, manufacturing",
  },
  {
    code: "311412",
    title: "Whipped topping, frozen, manufacturing",
  },
  {
    code: "311421",
    title: "Artichokes, canned, manufacturing",
  },
  {
    code: "311421",
    title: "Barbecue sauce manufacturing",
  },
  {
    code: "311421",
    title: "Berries, canned, manufacturing",
  },
  {
    code: "311421",
    title: "Beverages, fruit and vegetable juice, manufacturing",
  },
  {
    code: "311421",
    title: "Brining of fruits and vegetables",
  },
  {
    code: "311421",
    title: "Canning fruits and vegetables",
  },
  {
    code: "311421",
    title: "Canning jams and jellies",
  },
  {
    code: "311421",
    title: "Catsup manufacturing",
  },
  {
    code: "311421",
    title: "Chili sauce manufacturing",
  },
  {
    code: "311421",
    title: "Fruit brining",
  },
  {
    code: "311421",
    title: "Fruit butters manufacturing",
  },
  {
    code: "311421",
    title: "Fruit juice canning",
  },
  {
    code: "311421",
    title: "Fruit juices, fresh, manufacturing",
  },
  {
    code: "311421",
    title: "Fruit pickling",
  },
  {
    code: "311421",
    title: "Fruit pie fillings, canning",
  },
  {
    code: "311421",
    title: "Fruits pickling",
  },
  {
    code: "311421",
    title: "Fruits, canned, bottled, and jarred, manufacturing",
  },
  {
    code: "311421",
    title: "Hominy, canned, manufacturing",
  },
  {
    code: "311421",
    title: "Horseradish (except sauce) canning",
  },
  {
    code: "311421",
    title: "Jellies and jams manufacturing",
  },
  {
    code: "311421",
    title: "Juices, fruit or vegetable, canned manufacturing",
  },
  {
    code: "311421",
    title: "Juices, fruit or vegetable, fresh, manufacturing",
  },
  {
    code: "311421",
    title: "Ketchup manufacturing",
  },
  {
    code: "311421",
    title: "Marmalade manufacturing",
  },
  {
    code: "311421",
    title: "Mushrooms canning",
  },
  {
    code: "311421",
    title: "Olives brined",
  },
  {
    code: "311421",
    title: "Onions pickled",
  },
  {
    code: "311421",
    title: "Pastes, fruit and vegetable, canning",
  },
  {
    code: "311421",
    title: "Pickles manufacturing",
  },
  {
    code: "311421",
    title: "Pickling fruits and vegetables",
  },
  {
    code: "311421",
    title: "Preserves (e.g., imitation) canning",
  },
  {
    code: "311421",
    title: "Relishes canning",
  },
  {
    code: "311421",
    title: "Salsa canning",
  },
  {
    code: "311421",
    title: "Sauces, tomato-based, canning",
  },
  {
    code: "311421",
    title: "Sauerkraut manufacturing",
  },
  {
    code: "311421",
    title: "Spaghetti sauce canning",
  },
  {
    code: "311421",
    title: "Vegetable brining",
  },
  {
    code: "311421",
    title: "Vegetable canning, bottling, and jarring",
  },
  {
    code: "311421",
    title: "Vegetable juices canning",
  },
  {
    code: "311421",
    title: "Vegetable juices, fresh, manufacturing",
  },
  {
    code: "311421",
    title: "Vegetables pickling",
  },
  {
    code: "311422",
    title: "Baby foods (including meats) canning",
  },
  {
    code: "311422",
    title: "Baked beans canning",
  },
  {
    code: "311422",
    title: "Beans, baked, canning",
  },
  {
    code: "311422",
    title: "Bouillon canning",
  },
  {
    code: "311422",
    title: "Broth (except seafood) canning",
  },
  {
    code: "311422",
    title: "Canning soups (except seafood)",
  },
  {
    code: "311422",
    title: "Chili con carne canning",
  },
  {
    code: "311422",
    title: "Chinese foods canning",
  },
  {
    code: "311422",
    title: "Dry beans canning",
  },
  {
    code: "311422",
    title: "Gravy canning",
  },
  {
    code: "311422",
    title: "Infant and junior food canning",
  },
  {
    code: "311422",
    title: "Italian foods canning",
  },
  {
    code: "311422",
    title: "Meat canning, baby food, manufacturing",
  },
  {
    code: "311422",
    title: "Mexican foods canning",
  },
  {
    code: "311422",
    title: "Nationality specialty foods canning, bottling, and jarring",
  },
  {
    code: "311422",
    title: "Pasta based products canning",
  },
  {
    code: "311422",
    title: "Pork and beans canning",
  },
  {
    code: "311422",
    title: "Soups (except seafood) canning",
  },
  {
    code: "311422",
    title: "Spaghetti canning",
  },
  {
    code: "311423",
    title: "Bouillon made in dehydration plants",
  },
  {
    code: "311423",
    title: "Dates, dried, made in dehydration plants",
  },
  {
    code: "311423",
    title: "Dehydrating fruits and vegetables",
  },
  {
    code: "311423",
    title: "Dehydrating potato products (e.g., flakes, granules)",
  },
  {
    code: "311423",
    title: "Freeze-dried, food processing, fruits and vegetables",
  },
  {
    code: "311423",
    title: "Fruit and vegetables, dehydrating, manufacturing",
  },
  {
    code: "311423",
    title: "Fruits dehydrating (except sun drying)",
  },
  {
    code: "311423",
    title: "Grapes, artificially drying",
  },
  {
    code: "311423",
    title: "Noodle mixes made in dehydration plants",
  },
  {
    code: "311423",
    title: "Olives, dried, made in dehydration plants",
  },
  {
    code: "311423",
    title: "Potato products (e.g., flakes, granules) dehydrating",
  },
  {
    code: "311423",
    title: "Prunes, dried, made in dehydration plants",
  },
  {
    code: "311423",
    title: "Raisins made in dehydration plants",
  },
  {
    code: "311423",
    title:
      "Rice mixes (i.e., uncooked and packaged with other ingredients) made in dehydration plants",
  },
  {
    code: "311423",
    title: "Salad dressing mixes, dry, made in dehydration plants",
  },
  {
    code: "311423",
    title: "Sauce mixes, dry, made in dehydration plants",
  },
  {
    code: "311423",
    title: "Soup mixes made in dehydration plants",
  },
  {
    code: "311423",
    title: "Sulphured fruits and vegetables manufacturing",
  },
  {
    code: "311423",
    title: "Vegetables dehydrating",
  },
  {
    code: "311511",
    title: "Acidophilus milk manufacturing",
  },
  {
    code: "311511",
    title: "Almond milk manufacturing",
  },
  {
    code: "311511",
    title: "Beverages, milk based (except dietary), manufacturing",
  },
  {
    code: "311511",
    title: "Buttermilk manufacturing",
  },
  {
    code: "311511",
    title: "Cheese, cottage,  manufacturing",
  },
  {
    code: "311511",
    title: "Chocolate drink (milk based) manufacturing",
  },
  {
    code: "311511",
    title: "Chocolate milk manufacturing",
  },
  {
    code: "311511",
    title: "Cottage cheese manufacturing",
  },
  {
    code: "311511",
    title: "Cream manufacturing",
  },
  {
    code: "311511",
    title: "Dips, sour cream based, manufacturing",
  },
  {
    code: "311511",
    title: "Drink, chocolate milk, manufacturing",
  },
  {
    code: "311511",
    title: "Eggnog, fresh, nonalcoholic, manufacturing",
  },
  {
    code: "311511",
    title: "Eggnog, nonalcoholic (except canned), manufacturing",
  },
  {
    code: "311511",
    title: "Flavored milk drinks manufacturing",
  },
  {
    code: "311511",
    title: "Fluid milk substitutes processing",
  },
  {
    code: "311511",
    title: "Homogenizing milk",
  },
  {
    code: "311511",
    title: "Milk based drinks (except dietary) manufacturing",
  },
  {
    code: "311511",
    title: "Milk drink, chocolate, manufacturing",
  },
  {
    code: "311511",
    title: "Milk pasteurizing",
  },
  {
    code: "311511",
    title:
      "Milk processing (e.g., bottling, homogenizing, pasteurizing, vitaminizing) manufacturing",
  },
  {
    code: "311511",
    title: "Milk substitutes manufacturing",
  },
  {
    code: "311511",
    title: "Milk, acidophilus, manufacturing",
  },
  {
    code: "311511",
    title: "Milk, fluid (except canned), manufacturing",
  },
  {
    code: "311511",
    title: "Nondairy creamers, liquid, manufacturing",
  },
  {
    code: "311511",
    title: "Nondairy yogurt (except frozen) manufacturing",
  },
  {
    code: "311511",
    title: "Oat milk manufacturing",
  },
  {
    code: "311511",
    title: "Pasteurizing milk",
  },
  {
    code: "311511",
    title: "Rice milk manufacturing",
  },
  {
    code: "311511",
    title: "Sour cream manufacturing",
  },
  {
    code: "311511",
    title: "Sour cream substitutes manufacturing",
  },
  {
    code: "311511",
    title: "Soy milk manufacturing",
  },
  {
    code: "311511",
    title: "Whipped topping (except dry mix, frozen) manufacturing",
  },
  {
    code: "311511",
    title: "Whipping cream manufacturing",
  },
  {
    code: "311511",
    title: "Yogurt (except frozen) manufacturing",
  },
  {
    code: "311512",
    title: "Anhydrous butterfat manufacturing",
  },
  {
    code: "311512",
    title: "Butter manufacturing",
  },
  {
    code: "311512",
    title: "Butter, creamery and whey, manufacturing",
  },
  {
    code: "311512",
    title: "Creamery butter manufacturing",
  },
  {
    code: "311512",
    title: "Whey butter manufacturing",
  },
  {
    code: "311513",
    title: "Cheese (except cottage cheese) manufacturing",
  },
  {
    code: "311513",
    title: "Cheese analogs manufacturing",
  },
  {
    code: "311513",
    title: "Cheese products, imitation or substitute, manufacturing",
  },
  {
    code: "311513",
    title: "Cheese spreads manufacturing",
  },
  {
    code: "311513",
    title: "Cheese, imitation or substitute, manufacturing",
  },
  {
    code: "311513",
    title: "Cheese, natural (except cottage cheese), manufacturing",
  },
  {
    code: "311513",
    title: "Curds, cheese, made in a cheese plant, manufacturing",
  },
  {
    code: "311513",
    title: "Dips, cheese based, manufacturing",
  },
  {
    code: "311513",
    title: "Nondairy cheese manufacturing",
  },
  {
    code: "311513",
    title: "Nondairy cheese products manufacturing",
  },
  {
    code: "311513",
    title: "Processed cheeses manufacturing",
  },
  {
    code: "311513",
    title: "Spreads, cheese, manufacturing",
  },
  {
    code: "311513",
    title: "Whey, raw, liquid, manufacturing",
  },
  {
    code: "311514",
    title: "Baby formula, fresh, processed, and bottled, manufacturing",
  },
  {
    code: "311514",
    title: "Beverages, dietary, dairy and nondairy based",
  },
  {
    code: "311514",
    title: "Casein, dry and wet, manufacturing",
  },
  {
    code: "311514",
    title: "Condensed milk manufacturing",
  },
  {
    code: "311514",
    title: "Condensed, evaporated or powdered whey, manufacturing",
  },
  {
    code: "311514",
    title: "Cream, dried and powdered, manufacturing",
  },
  {
    code: "311514",
    title: "Dairy food canning",
  },
  {
    code: "311514",
    title: "Dehydrated milk manufacturing",
  },
  {
    code: "311514",
    title: "Dietary drinks, dairy and nondairy based, manufacturing",
  },
  {
    code: "311514",
    title: "Dry milk manufacturing",
  },
  {
    code: "311514",
    title: "Dry milk products and mixture manufacturing",
  },
  {
    code: "311514",
    title: "Dry milk products for animal feed manufacturing",
  },
  {
    code: "311514",
    title: "Eggnog, canned, nonalcoholic, manufacturing",
  },
  {
    code: "311514",
    title: "Evaporated milk manufacturing",
  },
  {
    code: "311514",
    title: "Feed grade dry milk products manufacturing",
  },
  {
    code: "311514",
    title: "Ice cream mix manufacturing",
  },
  {
    code: "311514",
    title: "Ice milk mix manufacturing",
  },
  {
    code: "311514",
    title: "Infant's formulas manufacturing",
  },
  {
    code: "311514",
    title: "Lactose manufacturing",
  },
  {
    code: "311514",
    title: "Malted milk manufacturing",
  },
  {
    code: "311514",
    title: "Milk based drinks, dietary, manufacturing",
  },
  {
    code: "311514",
    title:
      "Milk, concentrated, condensed, dried, evaporated, and powdered, manufacturing",
  },
  {
    code: "311514",
    title: "Milk, malted, manufacturing",
  },
  {
    code: "311514",
    title: "Milk, powdered, manufacturing",
  },
  {
    code: "311514",
    title: "Milk, ultra high temperature, manufacturing",
  },
  {
    code: "311514",
    title: "Milkshake mixes manufacturing",
  },
  {
    code: "311514",
    title: "Mix, ice cream, manufacturing",
  },
  {
    code: "311514",
    title: "Nondairy creamers, dry, manufacturing",
  },
  {
    code: "311514",
    title: "Nonfat dry milk manufacturing",
  },
  {
    code: "311514",
    title: "Powdered milk manufacturing",
  },
  {
    code: "311514",
    title: "UHT (ultra high temperature) milk manufacturing",
  },
  {
    code: "311514",
    title: "Whey, condensed, dried, evaporated, and powdered, manufacturing",
  },
  {
    code: "311514",
    title: "Whipped topping, dry mix, manufacturing",
  },
  {
    code: "311514",
    title: "Yogurt mix manufacturing",
  },
  {
    code: "311520",
    title: "Custard, frozen, manufacturing",
  },
  {
    code: "311520",
    title: "Desserts, frozen (except bakery), manufacturing",
  },
  {
    code: "311520",
    title: "Frozen custard manufacturing",
  },
  {
    code: "311520",
    title: "Frozen dairy product substitutes manufacturing",
  },
  {
    code: "311520",
    title: "Frozen desserts (except bakery) manufacturing",
  },
  {
    code: "311520",
    title: "Fruit pops, frozen, manufacturing",
  },
  {
    code: "311520",
    title: "Ice cream manufacturing",
  },
  {
    code: "311520",
    title: "Ice cream specialties manufacturing",
  },
  {
    code: "311520",
    title: "Ice milk manufacturing",
  },
  {
    code: "311520",
    title: "Ice milk specialties manufacturing",
  },
  {
    code: "311520",
    title: "Ices, flavored sherbets, manufacturing",
  },
  {
    code: "311520",
    title: "Juice pops, frozen, manufacturing",
  },
  {
    code: "311520",
    title: "Nondairy frozen desserts (except bakery) manufacturing",
  },
  {
    code: "311520",
    title: "Nondairy frozen yogurt manufacturing",
  },
  {
    code: "311520",
    title: "Nondairy ice cream manufacturing",
  },
  {
    code: "311520",
    title: "Pudding pops, frozen, manufacturing",
  },
  {
    code: "311520",
    title: "Sherbets manufacturing",
  },
  {
    code: "311520",
    title: "Tofu frozen desserts manufacturing",
  },
  {
    code: "311520",
    title: "Yogurt, frozen, manufacturing",
  },
  {
    code: "311611",
    title: "Abattoirs",
  },
  {
    code: "311611",
    title:
      "Animal fats (except poultry and small game) produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Bacon, slab and sliced, produced in slaughtering plants",
  },
  {
    code: "311611",
    title:
      "Beef carcasses, half carcasses, primal and sub-primal cuts, produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Beef produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Boxed beef produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Boxed meats produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Canned meats (except poultry) produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Cured hides and skins produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Custom slaughtering",
  },
  {
    code: "311611",
    title:
      "Fats, animal (except poultry, small game), produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Hams (except poultry) produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Hides and skins produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Horsemeat produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Hot dogs (except poultry) produced in slaughtering plants",
  },
  {
    code: "311611",
    title:
      "Inedible products (e.g., hides, skins, pulled wool, wool grease) produced in slaughtering plants",
  },
  {
    code: "311611",
    title:
      "Lamb carcasses, half carcasses, primal and sub-primal cuts, produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Lard produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Luncheon meat (except poultry) produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Meat canning (except poultry) produced in slaughtering plants",
  },
  {
    code: "311611",
    title:
      "Meats fresh, chilled or frozen (except poultry and small game), produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Meats, cured or smoked, produced in slaughtering plants",
  },
  {
    code: "311611",
    title:
      "Pork carcasses, half carcasses, and primal and sub-primal cuts produced in slaughtering plants",
  },
  {
    code: "311611",
    title: "Sausage casings, natural, produced in slaughtering plant",
  },
  {
    code: "311611",
    title: "Slaughtering, custom",
  },
  {
    code: "311611",
    title: "Tallow produced in a slaughtering plant",
  },
  {
    code: "311611",
    title: "Variety meats, edible organs, made in slaughtering plants",
  },
  {
    code: "311611",
    title:
      "Veal carcasses, half carcasses, primal and sub-primal cuts, produced in slaughtering plants",
  },
  {
    code: "311612",
    title: "Bacon, slab and sliced, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Beef stew made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Beef, primal and sub-primal cuts, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Bologna made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Boxed beef made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Boxed meat produced from purchased carcasses",
  },
  {
    code: "311612",
    title: "Collagen sausage casings made from purchased hides",
  },
  {
    code: "311612",
    title: "Cooked meats made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Corned meats made from purchases carcasses",
  },
  {
    code: "311612",
    title:
      "Cured meats (e.g., brined, dried, and salted) made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Dried meats made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Frozen meat pies (i.e., tourtiere) made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Hams, canned, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Hams, preserved (except poultry), made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Hot dogs (except poultry) made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Lamb, primal and sub-primal cuts, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Luncheon meat (except poultry) made from purchased carcasses",
  },
  {
    code: "311612",
    title:
      "Meat canning (except baby food, pet food, poultry), made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Meat extracts made from purchased carcasses",
  },
  {
    code: "311612",
    title:
      "Meat products canning (except baby food, pet food, poultry) made from purchased carcasses",
  },
  {
    code: "311612",
    title:
      "Meats (except poultry), cured or smoked, made from purchased carcasses",
  },
  {
    code: "311612",
    title:
      "Meats, fresh or chilled  (except poultry and small game), frozen, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Pastrami made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Pig's feet, cooked and pickled, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Pork, primal and sub-primal cuts, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Potted meats made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Processed meats manufacturing",
  },
  {
    code: "311612",
    title: "Salted meats made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Sandwich spreads, meat, made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Sausage and similar cased products made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Sausage casings, collagen, made from purchased hides",
  },
  {
    code: "311612",
    title: "Smoked meats made from purchased carcasses",
  },
  {
    code: "311612",
    title: "Variety meats, edible organs, made from purchased meats",
  },
  {
    code: "311612",
    title: "Veal, primal and sub-primal cuts, made from purchased carcasses",
  },
  {
    code: "311613",
    title: "Animal fats rendering",
  },
  {
    code: "311613",
    title: "Animal oil rendering",
  },
  {
    code: "311613",
    title: "Bones, fat, rendering",
  },
  {
    code: "311613",
    title: "Fats, animal, rendering",
  },
  {
    code: "311613",
    title: "Grease rendering",
  },
  {
    code: "311613",
    title: "Lard made from purchased fat",
  },
  {
    code: "311613",
    title: "Meat and bone meal and tankage, produced in rendering plant",
  },
  {
    code: "311613",
    title: "Neatsfoot oil rendering",
  },
  {
    code: "311613",
    title: "Oil, animal, rendering",
  },
  {
    code: "311613",
    title: "Rendering animals (carrion) for feed",
  },
  {
    code: "311613",
    title: "Rendering fats",
  },
  {
    code: "311613",
    title: "Rendering plants",
  },
  {
    code: "311613",
    title: "Stearin, animal, rendering",
  },
  {
    code: "311613",
    title: "Tallow produced in rendering plant",
  },
  {
    code: "311615",
    title: "Canning poultry (except baby and pet food)",
  },
  {
    code: "311615",
    title:
      "Chickens, processing, fresh, frozen, canned, or cooked (except baby and pet food)",
  },
  {
    code: "311615",
    title: "Chickens, slaughtering and dressing",
  },
  {
    code: "311615",
    title: "Dressing small game",
  },
  {
    code: "311615",
    title: "Ducks, processing, fresh, frozen, canned, or cooked",
  },
  {
    code: "311615",
    title: "Ducks, slaughtering and dressing",
  },
  {
    code: "311615",
    title: "Geese, processing, fresh, frozen, canned, or cooked",
  },
  {
    code: "311615",
    title: "Geese, slaughtering and dressing",
  },
  {
    code: "311615",
    title: "Hams, poultry, manufacturing",
  },
  {
    code: "311615",
    title: "Hot dogs, poultry, manufacturing",
  },
  {
    code: "311615",
    title: "Luncheon meat, poultry, manufacturing",
  },
  {
    code: "311615",
    title: "Meat canning, poultry (except baby and pet food), manufacturing",
  },
  {
    code: "311615",
    title:
      "Meat products (e.g., hot dogs, luncheon meats, sausages) made from a combination of poultry and other meats",
  },
  {
    code: "311615",
    title: "Poultry (e.g., canned, cooked, fresh, frozen) manufacturing",
  },
  {
    code: "311615",
    title: "Poultry (e.g., canned, cooked, fresh, frozen) processing",
  },
  {
    code: "311615",
    title: "Poultry canning (except baby and pet food)",
  },
  {
    code: "311615",
    title: "Poultry slaughtering, dressing, and packing",
  },
  {
    code: "311615",
    title: "Processed poultry manufacturing",
  },
  {
    code: "311615",
    title: "Rabbits processing (i.e., canned, cooked, fresh, frozen)",
  },
  {
    code: "311615",
    title: "Rabbits slaughtering and dressing",
  },
  {
    code: "311615",
    title: "Small game, processing, fresh, frozen, canned or cooked",
  },
  {
    code: "311615",
    title: "Small game, slaughtering, dressing and packing",
  },
  {
    code: "311615",
    title: "Turkeys, processing, fresh, frozen, canned, or cooked",
  },
  {
    code: "311615",
    title: "Turkeys, slaughtering and dressing",
  },
  {
    code: "311710",
    title: "Cannery, seafood",
  },
  {
    code: "311710",
    title: "Canning, fish, crustacea, and mollusks",
  },
  {
    code: "311710",
    title: "Chowders, seafood, manufacturing",
  },
  {
    code: "311710",
    title: "Cod liver oil extraction, crude, processing",
  },
  {
    code: "311710",
    title: "Curing fish and seafood",
  },
  {
    code: "311710",
    title: "Dinners, frozen seafood, manufacturing",
  },
  {
    code: "311710",
    title: "Drying fish and seafood",
  },
  {
    code: "311710",
    title: "Fish and marine animal oils processing",
  },
  {
    code: "311710",
    title: "Fish egg bait canning",
  },
  {
    code: "311710",
    title: "Fish freezing (e.g., blocks, fillets, ready-to-serve products)",
  },
  {
    code: "311710",
    title: "Fish manufacturing",
  },
  {
    code: "311710",
    title: "Fish meal processing",
  },
  {
    code: "311710",
    title: "Fish, curing, drying, pickling, salting, and smoking",
  },
  {
    code: "311710",
    title: "Floating factory ships, seafood processing",
  },
  {
    code: "311710",
    title: "Freezing fish (e.g., blocks, fillets, ready-to-serve products)",
  },
  {
    code: "311710",
    title: "Picking crab meat",
  },
  {
    code: "311710",
    title: "Seafood and seafood products canning",
  },
  {
    code: "311710",
    title: "Seafood and seafood products curing",
  },
  {
    code: "311710",
    title: "Seafood and seafood products manufacturing",
  },
  {
    code: "311710",
    title: "Seafood dinners, frozen, manufacturing",
  },
  {
    code: "311710",
    title: "Seaweed processing (e.g., dulse)",
  },
  {
    code: "311710",
    title: "Shellfish and shellfish products canning",
  },
  {
    code: "311710",
    title: "Shellfish and shellfish products manufacturing",
  },
  {
    code: "311710",
    title: "Shellfish curing",
  },
  {
    code: "311710",
    title: "Shucking and packing fresh shellfish",
  },
  {
    code: "311710",
    title: "Soups, seafood, manufacturing",
  },
  {
    code: "311710",
    title: "Surimi manufacturing",
  },
  {
    code: "311811",
    title:
      "Bakeries with baking from flour on the premises, retailing not for immediate consumption",
  },
  {
    code: "311812",
    title: "Bagels made in commercial bakeries",
  },
  {
    code: "311812",
    title:
      "Bakery products, fresh (i.e., bread, cakes, doughnuts, pastries), made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Biscuits, bread-type, made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Bread and bread-type rolls made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Cakes, baking (except frozen), made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Commercial bakeries",
  },
  {
    code: "311812",
    title: "Communion wafer manufacturing",
  },
  {
    code: "311812",
    title: "Croissants, baking, made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Croutons and bread crumbs made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Crullers (except frozen) made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Doughnuts (except frozen) made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Frozen bread and bread-type rolls, made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Knishes (except frozen) made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Matzo baking made in commercial bakeries",
  },
  {
    code: "311812",
    title:
      "Pastries (e.g., Danish, French), fresh, made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Pies, fresh, made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Pretzels, soft, manufacturing",
  },
  {
    code: "311812",
    title: "Rolls and buns (including frozen) made in commercial bakeries",
  },
  {
    code: "311812",
    title: "Soft pretzels made in a commercial bakery",
  },
  {
    code: "311812",
    title: "Sweet yeast goods (except frozen) manufacturing",
  },
  {
    code: "311812",
    title: "Unleavened bread made in commercial bakeries",
  },
  {
    code: "311813",
    title:
      "Baked goods (except bread, bread-type rolls), frozen, manufacturing",
  },
  {
    code: "311813",
    title: "Cake, frozen, manufacturing",
  },
  {
    code: "311813",
    title: "Crullers, frozen, made in a commercial bakery",
  },
  {
    code: "311813",
    title: "Desserts, frozen bakery, manufacturing",
  },
  {
    code: "311813",
    title: "Doughnuts, frozen, manufacturing",
  },
  {
    code: "311813",
    title: "Frozen cake manufacturing",
  },
  {
    code: "311813",
    title: "Knishes, frozen, manufacturing",
  },
  {
    code: "311813",
    title: "Pastries (e.g., Danish, French), frozen, manufacturing",
  },
  {
    code: "311813",
    title: "Pies, frozen, manufacturing",
  },
  {
    code: "311813",
    title: "Sweet yeast goods, frozen, manufacturing",
  },
  {
    code: "311821",
    title:
      "Bakery products, dry (e.g., biscuits, cookies, crackers), manufacturing",
  },
  {
    code: "311821",
    title: "Cones, ice cream, manufacturing",
  },
  {
    code: "311821",
    title: "Cookies manufacturing",
  },
  {
    code: "311821",
    title: "Cookies, filled, manufacturing",
  },
  {
    code: "311821",
    title: "Crackers (e.g., graham, soda) manufacturing",
  },
  {
    code: "311821",
    title: "Graham wafers manufacturing",
  },
  {
    code: "311821",
    title: "Ice cream cones manufacturing",
  },
  {
    code: "311821",
    title: "Saltines manufacturing",
  },
  {
    code: "311821",
    title: "Soda crackers manufacturing",
  },
  {
    code: "311824",
    title: "Batters, prepared, made from purchased flour",
  },
  {
    code: "311824",
    title: "Bread and bread-type roll mixes made from purchased flour",
  },
  {
    code: "311824",
    title: "Cake mixes made from purchased flour",
  },
  {
    code: "311824",
    title: "Cookie dough made from purchased flour",
  },
  {
    code: "311824",
    title: "Doughs, refrigerated or frozen, made from purchased flour",
  },
  {
    code: "311824",
    title: "Dry mixes made from purchased flour",
  },
  {
    code: "311824",
    title: "Dry pasta manufacturing",
  },
  {
    code: "311824",
    title: "Dry pasta packaged with other ingredients made in dry pasta plants",
  },
  {
    code: "311824",
    title: "Egg noodles, dry, manufacturing",
  },
  {
    code: "311824",
    title: "Flour, blended or self-rising, made from purchased flour",
  },
  {
    code: "311824",
    title: "Frozen doughs made from purchased flour",
  },
  {
    code: "311824",
    title: "Macaroni, dry, manufacturing",
  },
  {
    code: "311824",
    title:
      "Mixes, flour (e.g., biscuit, cake, doughnut, pancake), made from purchased flour",
  },
  {
    code: "311824",
    title: "Noodle mixes made in dry pasta plants",
  },
  {
    code: "311824",
    title: "Noodles, dry, manufacturing",
  },
  {
    code: "311824",
    title: "Pancake mixes made from purchased flour",
  },
  {
    code: "311824",
    title: "Pasta, dry, manufacturing",
  },
  {
    code: "311824",
    title: "Pastries, uncooked, manufacturing",
  },
  {
    code: "311824",
    title: "Pie crust shells, uncooked, made from purchased flour",
  },
  {
    code: "311824",
    title: "Pizza doughs made from purchased flour",
  },
  {
    code: "311824",
    title: "Prepared flour mixes made from purchased flour",
  },
  {
    code: "311824",
    title: "Refrigerated doughs made from purchased flour",
  },
  {
    code: "311824",
    title: "Spaghetti, dry, manufacturing",
  },
  {
    code: "311830",
    title: "Tortillas manufacturing",
  },
  {
    code: "311911",
    title: "Canned nuts manufacturing",
  },
  {
    code: "311911",
    title: "Nuts, kernels and seeds, roasting and processing",
  },
  {
    code: "311911",
    title: "Nuts, salted, roasted, cooked, canned, manufacturing",
  },
  {
    code: "311911",
    title: "Peanut butter blended with jelly manufacturing",
  },
  {
    code: "311911",
    title: "Peanut butter manufacturing",
  },
  {
    code: "311911",
    title: "Roasted nuts and seeds manufacturing",
  },
  {
    code: "311911",
    title: "Seeds, snack (e.g., canned, cooked, roasted, salted) manufacturing",
  },
  {
    code: "311919",
    title: "Cheese curls and puffs manufacturing",
  },
  {
    code: "311919",
    title: "Corn chips and related corn snacks manufacturing",
  },
  {
    code: "311919",
    title: "Popcorn (except candy covered), popped, manufacturing",
  },
  {
    code: "311919",
    title: "Pork rinds manufacturing",
  },
  {
    code: "311919",
    title: "Potato chips manufacturing",
  },
  {
    code: "311919",
    title: "Potato sticks manufacturing",
  },
  {
    code: "311919",
    title: "Pretzels (except soft) manufacturing",
  },
  {
    code: "311919",
    title: "Tortilla chips manufacturing",
  },
  {
    code: "311920",
    title: "Coffee concentrates (i.e., instant coffee) manufacturing",
  },
  {
    code: "311920",
    title: "Coffee extracts manufacturing",
  },
  {
    code: "311920",
    title: "Coffee flavoring and syrups (i.e., made from coffee) manufacturing",
  },
  {
    code: "311920",
    title: "Coffee roasting",
  },
  {
    code: "311920",
    title: "Coffee substitute manufacturing",
  },
  {
    code: "311920",
    title: "Coffee, blended, manufacturing",
  },
  {
    code: "311920",
    title: "Coffee, instant and freeze-dried, manufacturing",
  },
  {
    code: "311920",
    title: "Extracts, essences and preparations, coffee, manufacturing",
  },
  {
    code: "311920",
    title: "Extracts, essences and preparations, tea, manufacturing",
  },
  {
    code: "311920",
    title: "Instant coffee manufacturing",
  },
  {
    code: "311920",
    title: "Instant tea manufacturing",
  },
  {
    code: "311920",
    title: "Roasting coffee",
  },
  {
    code: "311920",
    title: "Syrup, flavoring, coffee based, manufacturing",
  },
  {
    code: "311920",
    title: "Tea (except herbal) manufacturing",
  },
  {
    code: "311920",
    title: "Tea blending",
  },
  {
    code: "311920",
    title: "Tea, herbal, manufacturing",
  },
  {
    code: "311920",
    title: "Tea, instant, manufacturing",
  },
  {
    code: "311930",
    title: "Beverage bases manufacturing",
  },
  {
    code: "311930",
    title: "Beverage flavorings (except coffee based) manufacturing",
  },
  {
    code: "311930",
    title: "Beverage syrups (except coffee based) manufacturing",
  },
  {
    code: "311930",
    title: "Concentrates, drink (except frozen fruit juice), manufacturing",
  },
  {
    code: "311930",
    title: "Concentrates, flavoring (except coffee based), manufacturing",
  },
  {
    code: "311930",
    title: "Flavoring concentrates (except coffee based) manufacturing",
  },
  {
    code: "311930",
    title: "Flavoring pastes, powders, and syrups for soft drink manufacturing",
  },
  {
    code: "311930",
    title: "Fruit syrups, flavoring, manufacturing",
  },
  {
    code: "311930",
    title: "Soda fountain syrups manufacturing",
  },
  {
    code: "311930",
    title: "Soft drink concentrates (i.e., syrup) manufacturing",
  },
  {
    code: "311930",
    title: "Syrup, beverage, manufacturing",
  },
  {
    code: "311930",
    title: "Syrup, flavoring (except coffee based), manufacturing",
  },
  {
    code: "311941",
    title: "Cheese based salad dressing manufacturing",
  },
  {
    code: "311941",
    title: "Cider vinegar manufacturing",
  },
  {
    code: "311941",
    title: "Cider, nonalcoholic, manufacturing",
  },
  {
    code: "311941",
    title: "Dips (except cheese and sour cream based) manufacturing",
  },
  {
    code: "311941",
    title: "Horseradish, prepared sauce, manufacturing",
  },
  {
    code: "311941",
    title: "Mayonnaise manufacturing",
  },
  {
    code: "311941",
    title: "Mayonnaise, imitation or substitute, manufacturing",
  },
  {
    code: "311941",
    title: "Mustard, prepared, manufacturing",
  },
  {
    code: "311941",
    title: "Prepared sauces (except gravy, tomato-based) manufacturing",
  },
  {
    code: "311941",
    title: "Salad dressings manufacturing",
  },
  {
    code: "311941",
    title: "Sandwich spreads, salad dressing based, manufacturing",
  },
  {
    code: "311941",
    title: "Sauces (except tomato-based) manufacturing",
  },
  {
    code: "311941",
    title: "Sauces for meat (except tomato-based) manufacturing",
  },
  {
    code: "311941",
    title: "Sauces for seafood (except tomato-based) manufacturing",
  },
  {
    code: "311941",
    title: "Sauces for vegetable (except tomato-based) manufacturing",
  },
  {
    code: "311941",
    title: "Soy sauce manufacturing",
  },
  {
    code: "311941",
    title: "Tartar sauce manufacturing",
  },
  {
    code: "311941",
    title: "Vinegar manufacturing",
  },
  {
    code: "311941",
    title: "Worcestershire sauce manufacturing",
  },
  {
    code: "311942",
    title: "Cake frosting mixes manufacturing",
  },
  {
    code: "311942",
    title: "Chili pepper or powder manufacturing",
  },
  {
    code: "311942",
    title: "Extracts, food (except coffee, meat), manufacturing",
  },
  {
    code: "311942",
    title: "Extracts, malt, manufacturing",
  },
  {
    code: "311942",
    title: "Flavor extracts (except coffee) manufacturing",
  },
  {
    code: "311942",
    title: "Food coloring, natural, manufacturing",
  },
  {
    code: "311942",
    title: "Food extracts (except coffee, meat) manufacturing",
  },
  {
    code: "311942",
    title: "Fruit extracts manufacturing",
  },
  {
    code: "311942",
    title: "Gravy mixes, dry, manufacturing",
  },
  {
    code: "311942",
    title: "Grinding spices",
  },
  {
    code: "311942",
    title: "Hop extract manufacturing",
  },
  {
    code: "311942",
    title: "Malt extract and syrups manufacturing",
  },
  {
    code: "311942",
    title: "Pectin manufacturing",
  },
  {
    code: "311942",
    title: "Pepper (i.e., spice) manufacturing",
  },
  {
    code: "311942",
    title: "Salad dressing mixes, dry, manufacturing",
  },
  {
    code: "311942",
    title: "Salt substitute manufacturing",
  },
  {
    code: "311942",
    title: "Salt, table, manufacturing",
  },
  {
    code: "311942",
    title: "Sauce mixes, dry, manufacturing",
  },
  {
    code: "311942",
    title: "Seasoning salt manufacturing",
  },
  {
    code: "311942",
    title: "Spice grinding and blending",
  },
  {
    code: "311942",
    title: "Spice mixtures manufacturing",
  },
  {
    code: "311942",
    title: "Spices and spice mix manufacturing",
  },
  {
    code: "311942",
    title: "Table salt manufacturing",
  },
  {
    code: "311991",
    title: "Box lunches (for sale off premises) manufacturing",
  },
  {
    code: "311991",
    title: "Carrots, cut, peeled or sliced fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Cole slaw, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Egg noodles, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Food, prepared, perishable, packaged for individual resale",
  },
  {
    code: "311991",
    title: "Fruit, cut or peeled, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Macaroni, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Noodles, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Pasta, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Pizzas, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Potatoes, peeled or cut, manufacturing",
  },
  {
    code: "311991",
    title: "Prepared meals, perishable, packaged for individual resale",
  },
  {
    code: "311991",
    title: "Salads, fresh or refrigerated, manufacturing",
  },
  {
    code: "311991",
    title:
      "Sandwiches, fresh (i.e., assembled and packaged for wholesale market), manufacturing",
  },
  {
    code: "311991",
    title: "Slaw, cole, fresh, manufacturing",
  },
  {
    code: "311991",
    title: "Tofu (i.e., bean curd) (except frozen desserts) manufacturing",
  },
  {
    code: "311991",
    title: "Vegetables, cut or peeled, fresh, manufacturing",
  },
  {
    code: "311999",
    title: "Almond pastes manufacturing",
  },
  {
    code: "311999",
    title: "Baking powder manufacturing",
  },
  {
    code: "311999",
    title: "Bread crumbs not made in bakeries",
  },
  {
    code: "311999",
    title: "Cake frosting manufacturing",
  },
  {
    code: "311999",
    title: "Chinese noodles, fried, manufacturing",
  },
  {
    code: "311999",
    title: "Cocktail mixes, dry, manufacturing",
  },
  {
    code: "311999",
    title: "Coconut, desiccated and shredded, manufacturing",
  },
  {
    code: "311999",
    title: "Corn syrups made from purchased sweeteners",
  },
  {
    code: "311999",
    title:
      "Drink powder mixes (except chocolate, coffee, milk based, tea) manufacturing",
  },
  {
    code: "311999",
    title: "Egg substitutes manufacturing",
  },
  {
    code: "311999",
    title: "Eggs, processed, manufacturing",
  },
  {
    code: "311999",
    title:
      "Fillings, cake or pie (except fruits, meat, vegetables), manufacturing",
  },
  {
    code: "311999",
    title: "Frosting, prepared, manufacturing",
  },
  {
    code: "311999",
    title: "Gelatin dessert preparations manufacturing",
  },
  {
    code: "311999",
    title: "Gelatin for cooking manufacturing",
  },
  {
    code: "311999",
    title: "Honey processing",
  },
  {
    code: "311999",
    title: "Maple syrup mixing into other products",
  },
  {
    code: "311999",
    title: "Noodle mixes made from purchased dry ingredients",
  },
  {
    code: "311999",
    title: "Noodles, fried, manufacturing",
  },
  {
    code: "311999",
    title: "Pancake syrups (except pure maple) manufacturing",
  },
  {
    code: "311999",
    title: "Pasta mixes made from purchased dry ingredients",
  },
  {
    code: "311999",
    title: "Popcorn (except popped) manufacturing",
  },
  {
    code: "311999",
    title: "Potato mixes made from purchased dry ingredients",
  },
  {
    code: "311999",
    title:
      "Powdered drink mixes (except chocolate, coffee, tea, milk based) manufacturing",
  },
  {
    code: "311999",
    title: "Powders, baking, manufacturing",
  },
  {
    code: "311999",
    title: "Puddings, canned dessert, manufacturing",
  },
  {
    code: "311999",
    title: "Puddings, dessert, manufacturing",
  },
  {
    code: "311999",
    title:
      "Rice mixes (i.e., uncooked and packaged with other ingredients) made from purchased rice and dry ingredients",
  },
  {
    code: "311999",
    title: "Sorghum syrup manufacturing",
  },
  {
    code: "311999",
    title: "Soup mixes, dry, made from purchased dry ingredients",
  },
  {
    code: "311999",
    title: "Sweetening syrups (except pure maple) manufacturing",
  },
  {
    code: "311999",
    title: "Syrup, corn (except wet milled), manufacturing",
  },
  {
    code: "311999",
    title: "Syrup, sweetening (except pure maple), manufacturing",
  },
  {
    code: "311999",
    title: "Syrup, table, artificially flavored, manufacturing",
  },
  {
    code: "311999",
    title: "Yeast manufacturing",
  },
  {
    code: "312111",
    title: "Artificially carbonated waters manufacturing",
  },
  {
    code: "312111",
    title:
      "Beverages, fruit and vegetable drinks, cocktails, and ades, manufacturing",
  },
  {
    code: "312111",
    title:
      "Beverages, soft drink (including artificially carbonated waters), manufacturing",
  },
  {
    code: "312111",
    title: "Carbonated soda manufacturing",
  },
  {
    code: "312111",
    title: "Carbonated soft drinks manufacturing",
  },
  {
    code: "312111",
    title: "Coffee, iced, manufacturing",
  },
  {
    code: "312111",
    title: "Drinks, fruit (except juice), manufacturing",
  },
  {
    code: "312111",
    title: "Flavored water manufacturing",
  },
  {
    code: "312111",
    title: "Fruit drinks (except juice), manufacturing",
  },
  {
    code: "312111",
    title: "Iced coffee manufacturing",
  },
  {
    code: "312111",
    title: "Iced tea manufacturing",
  },
  {
    code: "312111",
    title: "Pop, soda, manufacturing",
  },
  {
    code: "312111",
    title: "Soda carbonated, manufacturing",
  },
  {
    code: "312111",
    title: "Soda pop manufacturing",
  },
  {
    code: "312111",
    title: "Soft drinks manufacturing",
  },
  {
    code: "312111",
    title: "Tea, iced, manufacturing",
  },
  {
    code: "312111",
    title: "Water, artificially carbonated, manufacturing",
  },
  {
    code: "312111",
    title: "Water, flavored, manufacturing",
  },
  {
    code: "312112",
    title: "Beverages, naturally carbonated bottled water, manufacturing",
  },
  {
    code: "312112",
    title: "Naturally carbonated water, purifying and bottling",
  },
  {
    code: "312112",
    title: "Spring waters, purifying and bottling",
  },
  {
    code: "312112",
    title: "Water, naturally carbonated, purifying and bottling",
  },
  {
    code: "312113",
    title: "Block ice manufacturing",
  },
  {
    code: "312113",
    title: "Ice (except dry ice) manufacturing",
  },
  {
    code: "312120",
    title: "Ale brewing",
  },
  {
    code: "312120",
    title: "Beer brewing",
  },
  {
    code: "312120",
    title: "Beverages, beer, ale, and malt liquors, manufacturing",
  },
  {
    code: "312120",
    title: "Breweries",
  },
  {
    code: "312120",
    title: "Grain, brewers' spent, manufacturing",
  },
  {
    code: "312120",
    title: "Lager brewing",
  },
  {
    code: "312120",
    title: "Malt liquor brewing",
  },
  {
    code: "312120",
    title: "Microbreweries without restaurant or bar",
  },
  {
    code: "312120",
    title: "Near beer brewing",
  },
  {
    code: "312120",
    title: "Nonalcoholic beer brewing",
  },
  {
    code: "312120",
    title: "Porter brewing",
  },
  {
    code: "312120",
    title: "Stout brewing",
  },
  {
    code: "312130",
    title: "Alcoholic beverages, brandy, distilling",
  },
  {
    code: "312130",
    title: "Applejack distilling",
  },
  {
    code: "312130",
    title: "Beverages, wines and brandies, manufacturing",
  },
  {
    code: "312130",
    title: "Blending brandy",
  },
  {
    code: "312130",
    title: "Blending wines",
  },
  {
    code: "312130",
    title: "Brandy distilling",
  },
  {
    code: "312130",
    title: "Champagne method sparkling wine, manufacturing",
  },
  {
    code: "312130",
    title: "Cider, alcoholic, manufacturing",
  },
  {
    code: "312130",
    title: "Distilling brandy",
  },
  {
    code: "312130",
    title: "Fortified wines manufacturing",
  },
  {
    code: "312130",
    title: "Grape farming and making wine",
  },
  {
    code: "312130",
    title: "Ice wine",
  },
  {
    code: "312130",
    title: "Liquors, brandy, distilling and blending",
  },
  {
    code: "312130",
    title: "Nonalcoholic wines manufacturing",
  },
  {
    code: "312130",
    title: "Sake manufacturing",
  },
  {
    code: "312130",
    title: "Sparkling wines manufacturing",
  },
  {
    code: "312130",
    title: "Vermouth manufacturing",
  },
  {
    code: "312130",
    title: "Wine coolers manufacturing",
  },
  {
    code: "312130",
    title: "Wineries",
  },
  {
    code: "312130",
    title: "Wines manufacturing",
  },
  {
    code: "312130",
    title: "Wines, cooking, manufacturing",
  },
  {
    code: "312140",
    title: "Alcoholic beverages (except brandy) distilling",
  },
  {
    code: "312140",
    title: "Beverages, liquors (except brandies), manufacturing",
  },
  {
    code: "312140",
    title: "Blending distilled beverages (except brandy)",
  },
  {
    code: "312140",
    title: "Distilleries",
  },
  {
    code: "312140",
    title: "Distilling alcoholic beverages (except brandy)",
  },
  {
    code: "312140",
    title: "Distilling potable liquor (except brandy)",
  },
  {
    code: "312140",
    title: "Eggnog, alcoholic, manufacturing",
  },
  {
    code: "312140",
    title: "Ethyl alcohol, potable, manufacturing",
  },
  {
    code: "312140",
    title: "Grain alcohol, beverage, manufacturing",
  },
  {
    code: "312140",
    title: "Liquors, distilling and blending (except brandy)",
  },
  {
    code: "312140",
    title: "Mixed drinks, alcoholic, manufacturing",
  },
  {
    code: "312140",
    title: "Neutral spirit, beverages (except fruit), manufacturing",
  },
  {
    code: "312140",
    title: "Spirits, distilled (except brandy), manufacturing",
  },
  {
    code: "312230",
    title: "Chewing tobacco manufacturing",
  },
  {
    code: "312230",
    title: "Cigar manufacturing",
  },
  {
    code: "312230",
    title: "Cigarettes manufacturing",
  },
  {
    code: "312230",
    title: "Imitation tobacco cigarettes, manufacturing",
  },
  {
    code: "312230",
    title: "Pipe tobacco, prepared, manufacturing",
  },
  {
    code: "312230",
    title: "Reconstituting tobacco",
  },
  {
    code: "312230",
    title: "Smoking tobacco (e.g., cigarette, pipe) manufacturing",
  },
  {
    code: "312230",
    title: "Snuff manufacturing",
  },
  {
    code: "312230",
    title: "Tobacco leaf processing and aging",
  },
  {
    code: "312230",
    title: "Tobacco products (e.g., chewing, smoking, snuff) manufacturing",
  },
  {
    code: "312230",
    title: "Tobacco products, imitation, manufacturing",
  },
  {
    code: "312230",
    title: "Tobacco sheeting services",
  },
  {
    code: "312230",
    title: "Tobacco stemming and redrying",
  },
  {
    code: "313110",
    title: "Acetate spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title:
      "Acrylic and modacrylic filament yarn throwing, twisting, texturizing, or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Acrylic spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Animal fiber yarn twisting or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Bags, hemp, made from purchased fiber",
  },
  {
    code: "313110",
    title: "Beaming yarn",
  },
  {
    code: "313110",
    title: "Carded yarn manufacturing",
  },
  {
    code: "313110",
    title: "Carpet and rug yarn spinning",
  },
  {
    code: "313110",
    title: "Cotton cordage spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Cotton spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Cotton thread manufacturing",
  },
  {
    code: "313110",
    title:
      "Crochet spun yarns (e.g., cotton, manmade fiber, silk, wool) made from purchased fiber",
  },
  {
    code: "313110",
    title:
      "Darning thread (e.g., cotton, manmade fibers, silk, wool) manufacturing",
  },
  {
    code: "313110",
    title:
      "Embroidery spun yarns (e.g., cotton, manmade fiber, silk, wool) made from purchased fiber",
  },
  {
    code: "313110",
    title:
      "Embroidery thread (e.g., cotton, manmade fibers, silk, wool) manufacturing",
  },
  {
    code: "313110",
    title: "Flax spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Hard fiber spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Hard fiber thread manufacturing",
  },
  {
    code: "313110",
    title: "Hemp bags made from purchased fiber",
  },
  {
    code: "313110",
    title: "Hemp ropes made from purchased fiber",
  },
  {
    code: "313110",
    title: "Hemp spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Knitting and crocheting thread manufacturing",
  },
  {
    code: "313110",
    title:
      "Knitting spun yarns (e.g., cotton, manmade fiber, silk, wool) made from purchased fiber",
  },
  {
    code: "313110",
    title: "Manmade fiber thread manufacturing",
  },
  {
    code: "313110",
    title: "Manmade staple spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Modacrylic spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Mohair yarn twisting or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Natural fiber (i.e., hemp, linen, ramie) thread manufacturing",
  },
  {
    code: "313110",
    title:
      "Natural fiber spun yarns (i.e., hemp, jute, ramie, flax) made from purchased fiber",
  },
  {
    code: "313110",
    title: "Nylon spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Nylon thread manufacturing",
  },
  {
    code: "313110",
    title: "Nylon yarn twisting or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Paper yarn manufacturing",
  },
  {
    code: "313110",
    title:
      "Polyester filament yarn throwing, twisting, texturizing, or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Polyester spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Polyester thread manufacturing",
  },
  {
    code: "313110",
    title:
      "Polypropylene filament yarn throwing, twisting, texturizing, or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Polypropylene spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Ramie spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Rayon spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Rayon thread manufacturing",
  },
  {
    code: "313110",
    title:
      "Rayon yarn throwing, twisting, texturizing, or winding purchased filament",
  },
  {
    code: "313110",
    title: "Sewing threads manufacturing",
  },
  {
    code: "313110",
    title: "Silk spun yarns made from purchased fiber",
  },
  {
    code: "313110",
    title: "Silk thread manufacturing",
  },
  {
    code: "313110",
    title: "Silk throwing, spooling, twisting, or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Spinning carpet and rug yarn from purchased fiber",
  },
  {
    code: "313110",
    title: "Spinning yarn from purchased fiber",
  },
  {
    code: "313110",
    title: "Spooling of yarn",
  },
  {
    code: "313110",
    title: "Spooling of yarns for the trade",
  },
  {
    code: "313110",
    title: "Texturizing purchased yarn",
  },
  {
    code: "313110",
    title: "Thread mills",
  },
  {
    code: "313110",
    title: "Thread, all fibers, manufacturing",
  },
  {
    code: "313110",
    title: "Throwing purchased yarn",
  },
  {
    code: "313110",
    title: "Winding purchased yarn",
  },
  {
    code: "313110",
    title: "Winding, spooling, beaming and rewinding of purchased yarn",
  },
  {
    code: "313110",
    title: "Wool spun yarn made from purchased fiber",
  },
  {
    code: "313110",
    title: "Wool yarn, twisting or winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Yarn spinning mills",
  },
  {
    code: "313110",
    title: "Yarn spun from purchased fiber",
  },
  {
    code: "313110",
    title: "Yarn throwing, twisting, and winding of purchased yarn",
  },
  {
    code: "313110",
    title: "Yarn, carpet and rug, spun from purchased fiber",
  },
  {
    code: "313210",
    title: "Blankets and bedspreads made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Broadwoven fabrics (except rugs, tire fabrics) weaving",
  },
  {
    code: "313210",
    title: "Brocades weaving",
  },
  {
    code: "313210",
    title: "Canvases weaving",
  },
  {
    code: "313210",
    title: "Carpet linings (except felt) weaving",
  },
  {
    code: "313210",
    title: "Chambrays weaving",
  },
  {
    code: "313210",
    title: "Cheesecloths weaving",
  },
  {
    code: "313210",
    title: "Chintzes weaving",
  },
  {
    code: "313210",
    title: "Corduroys weaving",
  },
  {
    code: "313210",
    title: "Cotton fabrics, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Curtains and draperies made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Denims weaving",
  },
  {
    code: "313210",
    title: "Drills weaving",
  },
  {
    code: "313210",
    title: "Ducks weaving",
  },
  {
    code: "313210",
    title: "Elastic fabrics, more than 12 inches in width, weaving",
  },
  {
    code: "313210",
    title: "Fabrics (except rug, tire fabrics), broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Felts, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Fiberglass fabrics weaving",
  },
  {
    code: "313210",
    title: "Flannels, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Gauzes, surgical, made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Glass broadwoven fabrics weaving",
  },
  {
    code: "313210",
    title: "Hand weaving fabrics, more than 12 inches (30 cm) in width",
  },
  {
    code: "313210",
    title: "Hard fiber fabrics, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Jacquard woven fabrics weaving",
  },
  {
    code: "313210",
    title: "Jute bags made in broadwoven mills",
  },
  {
    code: "313210",
    title: "Manmade fabrics, broadwoven, weaving",
  },
  {
    code: "313210",
    title:
      "Natural fiber fabrics (i.e., jute, linen, hemp, ramie), broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Nets and nettings, more than 12 inches in width, weaving",
  },
  {
    code: "313210",
    title: "Paper fabrics, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Percales weaving",
  },
  {
    code: "313210",
    title: "Poplins weaving",
  },
  {
    code: "313210",
    title: "Sheets and pillowcases made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Silk fabrics, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Spandex broadwoven fabrics",
  },
  {
    code: "313210",
    title: "Tablecloths made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Terry broadwoven fabrics weaving",
  },
  {
    code: "313210",
    title: "Textile broadwoven fabrics mills",
  },
  {
    code: "313210",
    title: "Textile mills, broadwoven fabrics",
  },
  {
    code: "313210",
    title: "Textile products (except apparel) made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Towels and washcloths made in broadwoven fabric mills",
  },
  {
    code: "313210",
    title: "Twills weaving",
  },
  {
    code: "313210",
    title: "Velvets, manmade fiber and silk, weaving",
  },
  {
    code: "313210",
    title:
      "Weaving and finishing of broadwoven fabrics (except rugs, tire fabric)",
  },
  {
    code: "313210",
    title: "Weaving broadwoven fabrics (except rugs, tire fabrics)",
  },
  {
    code: "313210",
    title: "Weaving broadwoven felts",
  },
  {
    code: "313210",
    title: "Weaving fabrics more than 12 inches (30cm) in width",
  },
  {
    code: "313210",
    title: "Wool fabrics, broadwoven, weaving",
  },
  {
    code: "313210",
    title: "Worsted fabrics weaving",
  },
  {
    code: "313220",
    title: "Apparel webbings manufacturing",
  },
  {
    code: "313220",
    title: "Belting fabrics, narrow woven",
  },
  {
    code: "313220",
    title: "Bias bindings, woven, manufacturing",
  },
  {
    code: "313220",
    title: "Bindings, narrow woven, manufacturing",
  },
  {
    code: "313220",
    title: "Braiding narrow fabrics",
  },
  {
    code: "313220",
    title: "Cords and braids, narrow woven, manufacturing",
  },
  {
    code: "313220",
    title: "Cotton fabrics, narrow woven weaving",
  },
  {
    code: "313220",
    title: "Elastic fabrics, narrow woven, manufacturing",
  },
  {
    code: "313220",
    title: "Embroideries, Schiffli machine, manufacturing",
  },
  {
    code: "313220",
    title: "Fabrics, narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Fiberglasses, narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Fringes weaving",
  },
  {
    code: "313220",
    title: "Glass fabrics, narrow woven weaving",
  },
  {
    code: "313220",
    title: "Hand weaving fabric, 12 inches or less (30cm)",
  },
  {
    code: "313220",
    title: "Hard fiber, narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Hook and loop fastener fabric manufacturing",
  },
  {
    code: "313220",
    title: "Hose fabrics, tubular, weaving",
  },
  {
    code: "313220",
    title: "Labels weaving",
  },
  {
    code: "313220",
    title: "Laces (e.g., shoe), textile, manufacturing",
  },
  {
    code: "313220",
    title: "Manmade fabric, narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Narrow fabrics weaving",
  },
  {
    code: "313220",
    title:
      "Natural fiber fabrics (i.e., jute, linen, hemp, ramie), narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Paper fabric, narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Ribbons made in narrow woven fabric mills",
  },
  {
    code: "313220",
    title: "Rubber thread and yarns, fabric covered, manufacturing",
  },
  {
    code: "313220",
    title: "Schiffli machine embroideries manufacturing",
  },
  {
    code: "313220",
    title: "Tapes weaving",
  },
  {
    code: "313220",
    title: "Textile mills, narrow woven fabric",
  },
  {
    code: "313220",
    title: "Textile narrow woven fabric mills",
  },
  {
    code: "313220",
    title:
      "Textile products (except apparel) made in narrow woven fabric mills",
  },
  {
    code: "313220",
    title: "Weaving and finishing narrow fabrics",
  },
  {
    code: "313220",
    title: "Weaving fabric less than 12 inches (30cm)",
  },
  {
    code: "313220",
    title: "Weaving narrow fabrics",
  },
  {
    code: "313220",
    title: "Webbing weaving",
  },
  {
    code: "313220",
    title: "Wicks manufacturing",
  },
  {
    code: "313220",
    title: "Wool fabrics, narrow woven, weaving",
  },
  {
    code: "313220",
    title: "Zipper tape weaving",
  },
  {
    code: "313230",
    title: "Air laid nonwoven fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Blankets, nonwoven fabric, manufacturing",
  },
  {
    code: "313230",
    title: "Bonded-fiber fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Carded nonwoven fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Carpet paddings, nonwoven, manufacturing",
  },
  {
    code: "313230",
    title: "Fabrics, nonwoven, manufacturing",
  },
  {
    code: "313230",
    title: "Felts, nonwoven, manufacturing",
  },
  {
    code: "313230",
    title: "Melt blown nonwoven fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Nonwoven fabric tapes manufacturing",
  },
  {
    code: "313230",
    title: "Nonwoven fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Nonwoven felts manufacturing",
  },
  {
    code: "313230",
    title: "Pads and wadding, nonwoven, manufacturing",
  },
  {
    code: "313230",
    title: "Pressed felts manufacturing",
  },
  {
    code: "313230",
    title: "Punched felts manufacturing",
  },
  {
    code: "313230",
    title: "Ribbons made in nonwoven fabric mills",
  },
  {
    code: "313230",
    title: "Spunbonded fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Tapes, nonwoven fabric, manufacturing",
  },
  {
    code: "313230",
    title: "Wet laid nonwoven fabrics manufacturing",
  },
  {
    code: "313230",
    title: "Wipes, nonwoven fabric, manufacturing",
  },
  {
    code: "313240",
    title: "Bags and bagging fabrics made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Bedspreads and bed sets made in lace mills",
  },
  {
    code: "313240",
    title: "Bedspreads and bed sets made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Circular (i.e., weft) fabrics knitting",
  },
  {
    code: "313240",
    title: "Curtains made in lace mills",
  },
  {
    code: "313240",
    title: "Curtains made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Dishcloths made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Fabrics, knit, made in warp or weft knit fabric mills",
  },
  {
    code: "313240",
    title: "Fabrics, lace, made in lace mills",
  },
  {
    code: "313240",
    title: "Flat (i.e., warp) fabrics knitting",
  },
  {
    code: "313240",
    title: "Hand knitting lace or warp fabric products",
  },
  {
    code: "313240",
    title: "Knitting and finishing lace",
  },
  {
    code: "313240",
    title: "Knitting and finishing warp or weft fabric",
  },
  {
    code: "313240",
    title: "Knitting lace",
  },
  {
    code: "313240",
    title: "Knitting warp or weft fabric",
  },
  {
    code: "313240",
    title: "Lace manufacturing",
  },
  {
    code: "313240",
    title: "Lace products (except apparel) made in lace mills",
  },
  {
    code: "313240",
    title: "Netting made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Netting made on a lace or net machine",
  },
  {
    code: "313240",
    title: "Pile fabrics made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Tablecloths made in lace mills",
  },
  {
    code: "313240",
    title: "Tablecloths made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Textile products (except apparel) made in lace mills",
  },
  {
    code: "313240",
    title:
      "Textile products (except apparel) made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Towels and washcloths made in warp or weft knitting mills",
  },
  {
    code: "313240",
    title: "Warp or weft fabrics knitting",
  },
  {
    code: "313310",
    title: "Bleaching textile products, apparel, and fabrics ",
  },
  {
    code: "313310",
    title: "Broadwoven fabrics finishing",
  },
  {
    code: "313310",
    title: "Burling and mending fabrics ",
  },
  {
    code: "313310",
    title: "Calendering textile products, apparel, and fabrics",
  },
  {
    code: "313310",
    title: "Carbonizing textile fibers",
  },
  {
    code: "313310",
    title: "Carding textile fibers",
  },
  {
    code: "313310",
    title: "Chemical finishing (e.g., fire, mildew, water resistance) fabrics",
  },
  {
    code: "313310",
    title: "Combing and converting top",
  },
  {
    code: "313310",
    title: "Combing textile fibers",
  },
  {
    code: "313310",
    title: "Converters, piece goods",
  },
  {
    code: "313310",
    title: "Converting textiles",
  },
  {
    code: "313310",
    title: "Crease resistant finishing of fabrics ",
  },
  {
    code: "313310",
    title: "Dyeing gloves, woven or knit, for the trade",
  },
  {
    code: "313310",
    title: "Dyeing textile products and fabrics ",
  },
  {
    code: "313310",
    title: "Embossing textile products and fabrics ",
  },
  {
    code: "313310",
    title: "Fabric finishing",
  },
  {
    code: "313310",
    title: "Fabric mercerizing",
  },
  {
    code: "313310",
    title: "Gassing yarn (i.e., singeing)",
  },
  {
    code: "313310",
    title: "Mechanical finishing of fabrics",
  },
  {
    code: "313310",
    title: "Mercerizing textile products and fabrics ",
  },
  {
    code: "313310",
    title: "Napping textile products and fabrics",
  },
  {
    code: "313310",
    title: "Preshrinking textile products and fabrics ",
  },
  {
    code: "313310",
    title: "Printing fabric grey goods ",
  },
  {
    code: "313310",
    title: "Printing textile banners (except screen printing)",
  },
  {
    code: "313310",
    title: "Printing textile products (except screen and apparel printing)",
  },
  {
    code: "313310",
    title: "Scouring and combing textile fibers",
  },
  {
    code: "313310",
    title: "Screen printing fabric grey goods",
  },
  {
    code: "313310",
    title: "Shrinking textile products and fabrics ",
  },
  {
    code: "313310",
    title: "Sizing of fabrics",
  },
  {
    code: "313310",
    title: "Sponging textile products and fabrics ",
  },
  {
    code: "313310",
    title: "Stone washing textile products, apparel, and fabrics ",
  },
  {
    code: "313310",
    title: "Sueding textile products and fabrics",
  },
  {
    code: "313310",
    title: "Teaseling fabrics",
  },
  {
    code: "313310",
    title: "Textile products finishing",
  },
  {
    code: "313310",
    title: "Thread finishing",
  },
  {
    code: "313310",
    title: "Wool tops and noils manufacturing",
  },
  {
    code: "313320",
    title: "Garments, oiling (i.e., waterproofing)",
  },
  {
    code: "313320",
    title: "Laminating purchased textiles",
  },
  {
    code: "313320",
    title: "Leather, artificial, made from purchased fabric",
  },
  {
    code: "313320",
    title: "Metallizing purchased textiles",
  },
  {
    code: "313320",
    title: "Oilcloth manufacturing",
  },
  {
    code: "313320",
    title: "Oiling of purchased textiles and apparel",
  },
  {
    code: "313320",
    title: "Plastics coating of textiles and apparel",
  },
  {
    code: "313320",
    title: "Raincoats waterproofing (i.e., oiling)",
  },
  {
    code: "313320",
    title: "Rubberizing purchased capes",
  },
  {
    code: "313320",
    title: "Rubberizing purchased cloaks",
  },
  {
    code: "313320",
    title: "Rubberizing purchased clothing",
  },
  {
    code: "313320",
    title: "Rubberizing purchased coats",
  },
  {
    code: "313320",
    title: "Rubberizing purchased textiles and apparel",
  },
  {
    code: "313320",
    title:
      "Tapes, varnished and coated (except magnetic), made from purchased fabric",
  },
  {
    code: "313320",
    title: "Textile waterproofing",
  },
  {
    code: "313320",
    title: "Varnishing purchased textiles and apparel",
  },
  {
    code: "313320",
    title: "Vinyl coated fabrics manufacturing",
  },
  {
    code: "313320",
    title:
      "Waterproofing apparel, fabrics and textile products (e.g., oiling, rubberizing, waxing, varnishing)",
  },
  {
    code: "313320",
    title: "Waxing purchased textiles and apparel",
  },
  {
    code: "314110",
    title: "Automobile and aircraft carpet and rug manufacturing",
  },
  {
    code: "314110",
    title: "Bath mats and bath sets made in carpet mills",
  },
  {
    code: "314110",
    title: "Carpets and rugs made from textile materials",
  },
  {
    code: "314110",
    title:
      "Doormats, all materials (except entirely of rubber or plastics), manufacturing",
  },
  {
    code: "314110",
    title: "Finishing (e.g., dyeing) rugs and carpets",
  },
  {
    code: "314110",
    title: "Rugs and carpets made from textile materials",
  },
  {
    code: "314110",
    title: "Synthetic or artificial turf manufacturing",
  },
  {
    code: "314110",
    title: "Weaving rugs, carpets, and mats",
  },
  {
    code: "314120",
    title: "Bedspreads and bed sets made from purchased fabrics",
  },
  {
    code: "314120",
    title: "Blankets (except electric) made from purchased fabrics or felts",
  },
  {
    code: "314120",
    title: "Comforters made from purchased fabrics",
  },
  {
    code: "314120",
    title: "Curtains and draperies, window, made from purchased fabrics",
  },
  {
    code: "314120",
    title: "Cushions (except carpet, springs) made from purchased fabrics",
  },
  {
    code: "314120",
    title: "Draperies made from purchased fabrics or sheet goods",
  },
  {
    code: "314120",
    title: "Linens made from purchased materials",
  },
  {
    code: "314120",
    title: "Napkins made from purchased fabrics",
  },
  {
    code: "314120",
    title:
      "Pads and protectors (e.g., ironing board, mattress, table), textile, made from purchased fabrics or felts",
  },
  {
    code: "314120",
    title: "Pillowcases, bed, made from purchased fabrics",
  },
  {
    code: "314120",
    title: "Pillows made from purchased materials",
  },
  {
    code: "314120",
    title: "Placemats, all materials, made from purchased materials",
  },
  {
    code: "314120",
    title: "Quilts made from purchased materials",
  },
  {
    code: "314120",
    title: "Sheets and pillowcases made from purchased fabrics",
  },
  {
    code: "314120",
    title:
      "Shower and bath curtains, all materials, made from purchased fabric or sheet goods",
  },
  {
    code: "314120",
    title: "Slipcovers, all materials, made from purchased materials",
  },
  {
    code: "314120",
    title: "Tablecloths (except paper) made from purchased materials",
  },
  {
    code: "314120",
    title: "Towels or washcloths made from purchased fabrics",
  },
  {
    code: "314910",
    title: "Awnings and canopies, outdoor, made from purchased fabrics",
  },
  {
    code: "314910",
    title: "Bags, plastics, made from purchased woven plastics",
  },
  {
    code: "314910",
    title: "Bags, rubberized fabric, manufacturing",
  },
  {
    code: "314910",
    title: "Bags, textile, made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Blanket bags manufacturing",
  },
  {
    code: "314910",
    title: "Canvas bags manufacturing",
  },
  {
    code: "314910",
    title: "Canvas products made from purchased canvas or canvas substitutes",
  },
  {
    code: "314910",
    title:
      "Covers (e.g., boat, swimming pool, truck) made from purchased fabrics",
  },
  {
    code: "314910",
    title: "Feed bags made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Flour bags made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Garment storage bags manufacturing",
  },
  {
    code: "314910",
    title: "Knapsacks (e.g., backpacks, book bags) manufacturing",
  },
  {
    code: "314910",
    title: "Knapsacks, made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Laundry bags made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Sails made from purchased fabrics",
  },
  {
    code: "314910",
    title: "Seed bags made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Shipping bags made from purchased woven or knitted materials",
  },
  {
    code: "314910",
    title: "Tarpaulins made from purchased fabrics",
  },
  {
    code: "314910",
    title: "Tents made from purchased fabrics",
  },
  {
    code: "314910",
    title: "Textile bags made from purchased woven or knitted materials",
  },
  {
    code: "314994",
    title: "Cord (except wire) manufacturing",
  },
  {
    code: "314994",
    title:
      "Cord for reinforcing rubber tires, industrial belting, and fuel cells manufacturing",
  },
  {
    code: "314994",
    title: "Cordage (except wire) manufacturing",
  },
  {
    code: "314994",
    title:
      "Fabricated rope products (e.g., nets, slings) made in cordage or twine mills",
  },
  {
    code: "314994",
    title:
      "Fabrics for reinforcing rubber tires, industrial belting, and fuel cells manufacturing",
  },
  {
    code: "314994",
    title: "Industrial belting reinforcement, cord and fabric, manufacturing",
  },
  {
    code: "314994",
    title: "Ropes (except wire rope) manufacturing",
  },
  {
    code: "314994",
    title: "Strings (except musical instrument) manufacturing",
  },
  {
    code: "314994",
    title: "Tire cord and fabric, all materials, manufacturing",
  },
  {
    code: "314994",
    title: "Twines manufacturing",
  },
  {
    code: "314999",
    title: "Aircraft tie-down strap assemblies (except leather) manufacturing",
  },
  {
    code: "314999",
    title: "Apparel fillings (e.g., cotton mill waste, kapok) manufacturing",
  },
  {
    code: "314999",
    title: "Appliqueing on textile products (except apparel)",
  },
  {
    code: "314999",
    title: "Art needlework contractors on apparel",
  },
  {
    code: "314999",
    title: "Art needlework on clothing for the trade",
  },
  {
    code: "314999",
    title:
      "Automotive pad and upholstery filling (except foam rubber and plastics) manufacturing",
  },
  {
    code: "314999",
    title: "Badges, fabric, manufacturing",
  },
  {
    code: "314999",
    title: "Bags, sleeping, manufacturing",
  },
  {
    code: "314999",
    title: "Banners made from purchased fabrics (except banner printing)",
  },
  {
    code: "314999",
    title: "Batts and batting (except nonwoven fabrics) manufacturing",
  },
  {
    code: "314999",
    title: "Beading on textile products (except apparel) for the trade",
  },
  {
    code: "314999",
    title: "Belting made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Bias bindings made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Binding carpets and rugs for the trade",
  },
  {
    code: "314999",
    title: "Bindings, bias, made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Bows made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Burnt-out laces manufacturing",
  },
  {
    code: "314999",
    title: "Carpet cutting and binding",
  },
  {
    code: "314999",
    title: "Cotton battings (except nonwoven batting) manufacturing",
  },
  {
    code: "314999",
    title: "Crochet ware made from purchased materials",
  },
  {
    code: "314999",
    title: "Decorative stitching contractors on apparel",
  },
  {
    code: "314999",
    title: "Decorative stitching on textile articles and apparel",
  },
  {
    code: "314999",
    title: "Diapers (except disposable) made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Dust cloths made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Embroidering contractors on apparel",
  },
  {
    code: "314999",
    title: "Embroidering on textile products or apparel for the trade",
  },
  {
    code: "314999",
    title: "Fiber, textile recovery from textile mill waste and rags",
  },
  {
    code: "314999",
    title: "Filling (except nonwoven textile), upholstery, manufacturing",
  },
  {
    code: "314999",
    title: "Fire hose, textile, made from purchased materials",
  },
  {
    code: "314999",
    title: "Fishing nets made from purchased materials",
  },
  {
    code: "314999",
    title:
      "Flags, textile (e.g., banners, bunting, emblems, pennants), made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Furniture trimmings made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Garnetting of textile waste and rags",
  },
  {
    code: "314999",
    title: "Hammocks, fabric, manufacturing",
  },
  {
    code: "314999",
    title: "Lace, burnt-out, manufacturing",
  },
  {
    code: "314999",
    title: "Laundry nets made from purchased materials",
  },
  {
    code: "314999",
    title: "Linings, casket, manufacturing",
  },
  {
    code: "314999",
    title: "Linings, luggage, manufacturing",
  },
  {
    code: "314999",
    title: "Luggage linings manufacturing",
  },
  {
    code: "314999",
    title: "Military insignia, textile, manufacturing",
  },
  {
    code: "314999",
    title: "Mill menders, contract, woven fabrics",
  },
  {
    code: "314999",
    title: "Needlework art contractors on apparel",
  },
  {
    code: "314999",
    title: "Novelty stitching contractors on apparel",
  },
  {
    code: "314999",
    title: "Padding and wadding (except nonwoven fabric) manufacturing",
  },
  {
    code: "314999",
    title: "Parachutes manufacturing",
  },
  {
    code: "314999",
    title: "Powder puffs and mitts manufacturing",
  },
  {
    code: "314999",
    title: "Processing of textile mill waste and recovering fibers",
  },
  {
    code: "314999",
    title: "Quilting of textiles",
  },
  {
    code: "314999",
    title: "Reclaimed wool processing",
  },
  {
    code: "314999",
    title: "Recovered fibers processing",
  },
  {
    code: "314999",
    title: "Ribbons made from purchased fabrics",
  },
  {
    code: "314999",
    title: "Sleeping bags manufacturing",
  },
  {
    code: "314999",
    title: "Stitching, decorative and novelty, contractors on apparel",
  },
  {
    code: "314999",
    title: "Stitching, decorative and novelty, on textile articles and apparel",
  },
  {
    code: "314999",
    title: "Tassels manufacturing",
  },
  {
    code: "314999",
    title: "Textile fire hose made from purchased material",
  },
  {
    code: "314999",
    title: "Upholstering filling (except nonwoven fabric) manufacturing",
  },
  {
    code: "314999",
    title: "Weatherstripping made from purchased textiles",
  },
  {
    code: "314999",
    title: "Wool waste processing",
  },
  {
    code: "315120",
    title:
      "Anklets, sheer hosiery or socks, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Athletic clothing made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Athletic socks knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Bathing suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Bathrobes made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Beachwear made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Blouses made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Body stockings made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Boys' socks manufacturing",
  },
  {
    code: "315120",
    title: "Briefs, underwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Calf high sheer hosiery knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Caps made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Chemises made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Children's socks manufacturing",
  },
  {
    code: "315120",
    title: "Clerical vestments made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Collar and cuff sets made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Crew socks knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Drawers, apparel, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Dress and semidress gloves made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Dresses made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Dresses, hand-knit, manufacturing",
  },
  {
    code: "315120",
    title: "Ensemble dresses made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Footies, sheer, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title:
      "Girdles and other foundation garments made in apparel knitting mills",
  },
  {
    code: "315120",
    title:
      "Girls' hosiery, sheer, full-length and knee-length, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Girls' socks manufacturing",
  },
  {
    code: "315120",
    title: "Gloves, knit, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Hats made in apparel knitting mills",
  },
  {
    code: "315120",
    title:
      "Hosiery, sheer, women's, misses', and girls' full-length and knee-length, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Hosiery, women's, girls', and infants', manufacturing",
  },
  {
    code: "315120",
    title: "Housecoats made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Jackets made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Jerseys made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Jogging suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Knit gloves made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Leggings knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Leotards made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Lounging robes and dressing gowns made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Men's socks knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Mittens, knit, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Mufflers made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Neckties made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Neckwear made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Negligees made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Nightgowns made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Nightshirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Nightwear made in apparel knitting mills",
  },
  {
    code: "315120",
    title:
      "Nylon hosiery, sheer, women's, misses', and girls' full-length and knee-length, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title:
      "Nylons, sheer, women's, misses', and girls' full-length and knee-length, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Outerwear handknitted for the trade",
  },
  {
    code: "315120",
    title: "Pajamas made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Panties made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Pants, athletic, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Pants, outerwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Panty hose, women's and girls', knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Polo shirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Prayer shawls made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Robes, lounging, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Scarves made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Shirts, outerwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Shirts, underwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Shorts, outerwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Shorts, underwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Ski pants made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Ski suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Skirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Slacks made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Slacks, jean-cut casual, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Slipper socks made in sock mills",
  },
  {
    code: "315120",
    title: "Slips made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Snowsuits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Socks knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Socks, men's and boy's, manufacturing",
  },
  {
    code: "315120",
    title: "Socks, slipper, made in sock mills",
  },
  {
    code: "315120",
    title: "Sports clothing made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sports shirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Stockings, sheer, manufacturing",
  },
  {
    code: "315120",
    title:
      "Stockings, sheer, women's, misses', and girls', full-length and knee-length, knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweat bands made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweat pants made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweat suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweater jackets made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweater vests made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweaters made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Sweatshirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Swimsuits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Tank tops, outerwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Tank tops, underwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Tennis shirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Tennis skirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Ties made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Tights knitting or knitting and finishing",
  },
  {
    code: "315120",
    title: "Trousers made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "T-shirts, outerwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "T-shirts, underwear, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Underwear made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Underwear shirts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Underwear shorts made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Uniforms, nontailored, made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Union suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Warmup suits made in apparel knitting mills",
  },
  {
    code: "315120",
    title: "Work gloves and mittens, knit, made in apparel knitting mills",
  },
  {
    code: "315210",
    title: "Apparel cut and sew contractors",
  },
  {
    code: "315210",
    title: "Apparel trimmings and findings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Apparel, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Appliqueing on apparel",
  },
  {
    code: "315210",
    title:
      "Aprons, waterproof (including rubberized fabric, plastics), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Aprons, work (except leather), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Arm bands cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Ascots cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Athletic clothing cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Athletic uniforms, team, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bakers' service apparel, washable, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Band uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bandeaux cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Barbers' service apparel, washable, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Baseball caps (except plastics) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Baseball uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Basketball uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bathing suits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bathrobes cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Beachwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bedjackets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Belts, apparel (e.g., fabric, leather, vinyl), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Belts, money, any material, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Bibs and aprons, waterproof (e.g., plastics, rubber, similar materials), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Blouses cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Body stockings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bow ties cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bra-slips cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Brassieres cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Bridal dresses or gowns cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Briefs cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Buntings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Burial garments cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Buttonhole making apparel contractors",
  },
  {
    code: "315210",
    title: "Buttonhole making, fur goods, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Buttonholing and button covering apparel contractors",
  },
  {
    code: "315210",
    title: "Caftans cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Camisoles cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Capes cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Caps (i.e., apparel accessory) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Caps and gowns, academic, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Caps, textiles, straw, fur-felt, and wool-felt, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Chauffeurs' hats and caps cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Chemises cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Clerical vestments cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Clothing, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Clothing, leather or sheep-lined, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Clothing, water resistant, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Clothing, waterproof, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Clothing, water-repellent, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Coat linings, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Coat trimmings, fabric, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Coats (e.g., tailored, fur, artificial leather, leather, sheep-lined), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Coats, nontailored service apparel (e.g., laboratory, medical, mechanics'), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Coats, waterproof (i.e., plastics, rubberized fabric, similar materials), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Collar and cuff sets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Contractors, cut and sew apparel",
  },
  {
    code: "315210",
    title: "Corselets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Corsets and allied garments (except surgical) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Costumes (e.g., lodge, masquerade, theatrical) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Coveralls, work, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Culottes cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Cummerbunds cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Cutting fabric owned by others for apparel",
  },
  {
    code: "315210",
    title:
      "Diaper covers, water resistant and waterproof, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dickeys cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Down-filled clothing cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Drawers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dress and semidress gloves cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dress trimmings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dresses cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dressing gowns cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dungarees cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Dusters (i.e., apparel) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Ensemble dresses cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Eyelet making contractors on apparel",
  },
  {
    code: "315210",
    title: "Feather-filled clothing cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Field jackets, military, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Findings, suit and coat (e.g., coat fronts, pockets), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Firefighters' dress uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Flannel shirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Formal jackets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Foundation garments cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Fur accessories and trimmings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Fur apparel (e.g., capes, coats, hats, jackets, neckpieces) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Fur clothing cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Fur finishers, liners, and buttonhole makers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Fur plates and trimmings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Garments, leather or sheep-lined, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Garter belts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Garters cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Girdles cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Glove linings, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Gloves and mittens (except athletic), leather, fabric, fur, or combinations, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Gloves and mittens, woven or knit, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Gowns (e.g., academic, choir, clerical) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Gowns, formal, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Gowns, hospital, surgical and patient, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Gowns, wedding, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Graduation caps and gowns cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Handkerchiefs (except paper) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Hat bodies (e.g., fur-felt, straw, wool-felt) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Hat findings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Hat linings and trimmings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Hats (e.g., cloth, fur, fur-felt, leather, straw, wool-felt) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Hats, trimmed, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Headbands cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Hemstitching apparel contractors on apparel",
  },
  {
    code: "315210",
    title:
      "Hospital service apparel, washable, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Housecoats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Housedresses cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Hunting coats and vests cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Industrial garments cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Infants' cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jackets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jackets, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Jackets, leather (except welders') or sheep-lined, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Jackets, service apparel (e.g., laboratory, medical), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jackets, ski, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jean-cut casual slacks cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jeans cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jerseys cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jogging suits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Jumpsuits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Knickers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Knit gloves cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Laboratory coats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Leather apparel (e.g., capes, coats, hats, jackets) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Leather clothing cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Leather gloves or mittens (except athletic) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Leggings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Leotards cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Lingerie cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Linings, hat, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Lounging robes and dressing gowns cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Mackinaws cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Maternity bras and corsets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Medical service apparel cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Melton jackets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Middies cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Military dress uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Millinery cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Millinery trimmings cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Mittens (e.g., leather, woven or knit) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Mufflers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Neckpieces, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Neckties cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Neckwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Negligees cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Nightgowns cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Nightshirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Nightwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Opera hats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Overall jackets, work, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Overalls, work, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Overcoats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Pajamas cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Panama hats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Panties cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Pants (e.g., athletic, dress, leather, sweat, waterproof outerwear, work) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Pants outfits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Pantsuits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Panty girdles cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Paper dresses cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Plastics gowns cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Plastics rainwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Playsuits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Pleating contractors on apparel",
  },
  {
    code: "315210",
    title: "Pockets (e.g., coat, suit) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Police caps and hats (except protective head gear) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Police uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Polo shirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Ponchos and similar waterproof raincoats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Prayer shawls cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Professional service apparel, washable, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Raincoats (e.g., water resistant, waterproof, water-repellent) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Riding clothes cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Robes, lounging, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Rompers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Scarves cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Service apparel, washable, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sewing fabric owned by others for apparel",
  },
  {
    code: "315210",
    title: "Shirts, outerwear, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Shirts, underwear, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Shorts, outerwear, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Shorts, underwear, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Ski pants cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Ski suits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Skirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Slacks cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Slacks, jean-cut casual, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Slips cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Snowsuits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sport coats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sport coats, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Sport coats, leather (including artificial and tailored), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sport shirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sports clothing cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Suit trimmings cut and sew  apparel contractors",
  },
  {
    code: "315210",
    title:
      "Suits (i.e., nontailored, tailored, work) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Suspenders cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweat bands cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweat pants cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweat suits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweater jackets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweater vests cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweaters cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Sweatshirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Swimsuits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Tailored dress and sport coats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Tank tops cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Team athletic uniforms cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Teddies cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Tennis shirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Tennis skirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Theatrical costumes cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Ties cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Topcoats cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Training pants (i.e., underwear) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Trimmings, fur, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Trousers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "T-shirts, outerwear, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "T-shirts, underwear, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Tuxedos cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Underwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Underwear shirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Underwear shorts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Uniform hats and caps cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Uniform shirts cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Uniforms, band, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Uniforms, dress (e.g., military, police, firefighter), cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Uniforms, nontailored, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Uniforms, team athletic, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Union suits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Vestments, academic and clerical, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Vests cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Vests, leather, fur, or sheep-lined, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Warmup suits cut and sew apparel contractors",
  },
  {
    code: "315210",
    title:
      "Washable service apparel (e.g., barbers', hospital, professional) cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Water resistant apparel cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Water resistant outerwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Waterproof outerwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Water-repellent outerwear cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Wedding dresses cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Windbreakers cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Work coats and jackets cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Work gloves, leather, cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Work pants cut and sew apparel contractors",
  },
  {
    code: "315210",
    title: "Work shirts cut and sew apparel contractors",
  },
  {
    code: "315250",
    title: "Apparel, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Aprons, work (except leather, waterproof), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Aprons, work (except waterproof, leather), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Athletic clothing, men's, boys' and unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Athletic clothing, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Athletic uniforms, team, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bakers' service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bakers' service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Band uniforms cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bandeaux, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Barbers' service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Baseball uniforms cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Basketball uniforms cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bathing suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bathing suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bathrobes, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bathrobes, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Beachwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Beachwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bedjackets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Blouses, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Body stockings, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Bra-slips, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Brassieres cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Bridal dresses or gowns, custom made",
  },
  {
    code: "315250",
    title:
      "Bridal dresses or gowns, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Briefs, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Briefs, underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Buntings, infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Burial garments cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Caftans, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Caftans, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Camisoles, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Capes, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Capes, waterproof (e.g., plastics, rubber, similar materials), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Capes, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Caps and gowns, academic, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Caps, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title: "Caps, leather (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Chemises, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Clerical vestments cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Clothing, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Clothing, leather or sheep-lined (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Clothing, water resistant, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Clothing, water resistant, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Clothing, waterproof, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Clothing, water-repellent, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Clothing, water-repellent, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Coat linings, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Coats (including tailored), leather or sheep-lined (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Coats, artificial leather, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Coats, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title: "Coats, leather (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coats, nontailored service apparel (e.g., laboratory, mechanics', medical), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coats, nontailored service apparel (e.g., laboratory, medical, mechanics'), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coats, tailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coats, tailored, women's and girls', cut and sewn from purchased fabric",
  },
  {
    code: "315250",
    title:
      "Coats, waterproof (e.g., plastics, rubberized fabric, similar materials), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coats, waterproof (e.g., plastics, rubberized fabric, similar materials), rubberizing fabric and manufacturing coats",
  },
  {
    code: "315250",
    title:
      "Coats, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Collar and cuff sets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Corselets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Corsets and allied garments (except surgical), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Costumes (e.g., lodge, masquerade, theatrical) cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coveralls, work, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Coveralls, work, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Culottes, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Custom tailors, men's and boys' dress shirts, cut and sewn from purchased fabric",
  },
  {
    code: "315250",
    title:
      "Custom tailors, men's and boys' suits, cut and sewn from purchased fabric",
  },
  {
    code: "315250",
    title:
      "Custom tailors, women's and girls' dresses cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Diaper covers, infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Dickeys, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Down-filled clothing, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Down-filled clothing, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Drawers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Drawers, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Dresses, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Dressing gowns, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Dungarees, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Dungarees, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Dusters (i.e., apparel), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Ensemble dresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Feather-filled clothing, jackets, and vests, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Feather-filled clothing, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Field jackets, military, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Firefighters' dress uniforms, men's, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Firefighters' dress uniforms, women's, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Flannel shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Flannel shirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Formal jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Foundation garments, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Fur accessories and trimmings (except apparel contractors) manufacturing",
  },
  {
    code: "315250",
    title:
      "Fur apparel (e.g., capes, coats, hats, jackets, neckpieces) (except apparel contractors) manufacturing",
  },
  {
    code: "315250",
    title: "Fur clothing (except apparel contractors) manufacturing",
  },
  {
    code: "315250",
    title:
      "Fur plates and trimmings (except apparel contractors) manufacturing",
  },
  {
    code: "315250",
    title:
      "Garments, leather or sheep-lined (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Garter belts cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Garters, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Girdles, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Glazing furs",
  },
  {
    code: "315250",
    title: "Glove linings, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Gowns (e.g., academic, choir, clerical) cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Gowns, formal, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Gowns, hospital, surgical and patient, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Gowns, wedding, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Graduation caps and gowns cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Hats, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title: "Hats, leather (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Hospital service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Hospital service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Housecoats, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Housedresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Hunting coats and vests, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Industrial garments, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Industrial garments, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Infants' apparel cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Infants' water resistant outerwear cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Jackets, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Jackets, leather (except welders') or sheep-lined (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jackets, service apparel (e.g., laboratory, medical), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jackets, service apparel (e.g., laboratory, medical), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jackets, ski, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jackets, ski, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jackets, tailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jackets, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jean-cut casual slacks, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jean-cut casual slacks, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jeans, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jerseys, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jerseys, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jogging suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jogging suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Jumpsuits, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Knickers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Knickers, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Laboratory coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Laboratory coats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Leather apparel (e.g., capes, coats, hats, jackets) (except apparel contractors) manufacturing",
  },
  {
    code: "315250",
    title: "Leather clothing (except apparel contractors) manufacturing",
  },
  {
    code: "315250",
    title:
      "Leggings, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Leotards, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Lingerie, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Lounging robes and dressing gowns, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Lounging robes and dressing gowns, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Mackinaws, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Mackinaws, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Maternity bras and corsets, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Medical service apparel, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Medical service apparel, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Melton jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Melton jackets, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Middies, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Military dress uniforms, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Military dress uniforms, tailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Neckpieces, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Negligees, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Nightgowns, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Nightgowns, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Nightshirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Nightshirts, women's, girls', and infants', cut and sewn from purchased fabric (except contractors)",
  },
  {
    code: "315250",
    title:
      "Nightwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Nightwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Overall jackets, work, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Overalls, work, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Overcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Overcoats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pajamas, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pajamas, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Panties, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pants (e.g., athletic, dress, sweat, work), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pants outfits, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pants, athletic, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Pants, leather (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Pants, rubber and rubberized fabric, made in the same establishment as the basic material",
  },
  {
    code: "315250",
    title:
      "Pants, sweat, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Pants, vulcanized rubber, manufacturing",
  },
  {
    code: "315250",
    title:
      "Pants, waterproof outerwear, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pants, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Pantsuits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Panty girdles, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Paper dresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Plastics gowns cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Plastics rainwear cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Playsuits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Pointing furs",
  },
  {
    code: "315250",
    title:
      "Police dress uniforms, men's, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Police dress uniforms, women's, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Polo shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Polo shirts, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Ponchos and similar waterproof raincoats cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Prayer shawls cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Professional service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Professional service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Raincoats, rubber or rubberized fabric, manufacturing",
  },
  {
    code: "315250",
    title:
      "Raincoats, water resistant, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Raincoats, water resistant, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Raincoats, waterproof, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Raincoats, water-repellent, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Raincoats, water-repellent, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Riding clothes, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Riding clothes, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Robes, lounging, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Robes, lounging, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Rompers, infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Service apparel, washable, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Service apparel, washable, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shirts, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shirts, outerwear, unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shirts, outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shirts, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shirts, underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shorts, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shorts, outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Shorts, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Ski pants, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Ski pants, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Ski suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Ski suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Skirts, tennis, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Skirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Slacks, jean-cut casual, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Slacks, jean-cut casual, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Slacks, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Slacks, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Slips, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Snowsuits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Snowsuits, women's, girls, and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Sport coats, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Sport coats, leather (including artificial and tailored) (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Sport coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sport shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sports clothing, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sports clothing, team uniforms, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sports clothing, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Suits (e.g., jogging, snowsuit, warmup), women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Suits, nontailored (e.g., jogging, snow, ski, warmup), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Suits, tailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Suits, tailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sunsuits, infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweat bands cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweat pants, men's, boys', and unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweat pants, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweat suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweat suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweater jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweater jackets, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweater vests, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweater vests, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweaters, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweaters, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweatshirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweatshirts, outerwear, unisex (sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Sweatshirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Swimsuits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Swimsuits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tailored dress and sport coats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tank tops, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tank tops, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tank tops, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Team athletic uniforms cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Teddies, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tennis shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tennis shirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tennis skirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Theatrical costumes cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Topcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Training pants (i.e., underwear), infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title: "Trimmings, fur (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Trousers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "T-shirts, outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "T-shirts, outerwear, unisex (i.e., sized without regard to gender), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "T-shirts, outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "T-shirts, underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "T-shirts, underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Tuxedos cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Underwear shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Underwear shirts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Underwear shorts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Underwear shorts, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Underwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Underwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniform shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniform shirts, team athletic, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniform shirts, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniforms, band, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniforms, dress (e.g., firefighter, military, police), men's, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniforms, dress, tailored (e.g., firefighter, military, police), women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniforms, nontailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniforms, nontailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Uniforms, team athletic, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Union suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Union suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Vestments, academic and clerical, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Vests, leather, fur, or sheep-lined (except apparel contractors), manufacturing",
  },
  {
    code: "315250",
    title:
      "Vests, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Vests, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Warmup suits, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Warmup suits, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Washable service apparel (e.g., barbers', hospital, professional), men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Washable service apparel, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water resistant jackets and windbreakers, nontailored, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water resistant jackets and windbreakers, nontailored, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water resistant outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water resistant outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water resistant overcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water resistant overcoats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Waterproof outerwear cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Waterproof outerwear, rubberizing fabric and manufacturing outerwear",
  },
  {
    code: "315250",
    title:
      "Water-repellent outerwear, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water-repellent outerwear, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water-repellent overcoats, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Water-repellent overcoats, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Wedding dresses, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Windbreakers, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Windbreakers, women's, girls', and infants', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Work coats and jackets, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Work pants, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315250",
    title:
      "Work shirts, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Apparel findings and trimmings cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Aprons, waterproof (e.g., plastics, rubberized fabric), rubberizing fabric and manufacturing aprons",
  },
  {
    code: "315990",
    title:
      "Aprons, waterproof (including rubberized fabric, plastics), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Arm bands, elastic, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Ascots, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Baseball caps cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title: "Bathing caps, rubber, manufacturing",
  },
  {
    code: "315990",
    title:
      "Belts, apparel (e.g., fabric, leather, vinyl), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Belts, money, any material, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Bibs and aprons, waterproof (e.g., plastics, rubber, similar materials), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Bibs and aprons, waterproof (e.g., plastics, rubber, similar materials), rubberizing fabric and manufacturing bibs and aprons",
  },
  {
    code: "315990",
    title:
      "Bow ties, men's and boys', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Caps (except fur, leather) cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Caps (i.e., apparel accessory) cut and sewn from purchased fabric (except fur, leather, apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Caps, textiles, straw, fur-felt, and wool-felt, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Chauffeurs' hats and caps cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Coat trimmings fabric cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Cummerbunds cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Dress and semidress gloves cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Dress trimmings cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Findings, suit and coat (e.g., coat fronts, pockets), cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title: "Glove linings (except fur) manufacturing",
  },
  {
    code: "315990",
    title:
      "Gloves and mittens (except athletic), leather, fabric, fur, or combinations, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Gloves and mittens, woven or knit, cut and sewn from purchased fabric (except apparel contractors), manufacturing",
  },
  {
    code: "315990",
    title:
      "Gloves, leather (except athletic, cut and sewn apparel contractors), manufacturing",
  },
  {
    code: "315990",
    title: "Handkerchiefs (except paper) cut and sewn from purchased fabric",
  },
  {
    code: "315990",
    title: "Harvest hats, straw, manufacturing",
  },
  {
    code: "315990",
    title:
      "Hat bodies (e.g., fur-felt, straw, wool-felt) cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Hat findings cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Hat linings and trimmings cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Hats (except fur, knitting mill products, leather) cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Hats, cloth, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Hats, fur-felt, straw, and wool-felt, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Hats, trimmed, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Headbands, women's and girls', cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Knit gloves cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Leather gloves or mittens (except athletic, cut and sewn apparel contractors) manufacturing",
  },
  {
    code: "315990",
    title:
      "Linings, hat, men's, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Millinery cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Millinery trimmings cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Mittens cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title: "Mittens, leather (except apparel contractors), manufacturing",
  },
  {
    code: "315990",
    title:
      "Mittens, woven or knit, cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Mufflers cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Neckties cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Neckwear cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Opera hats cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Panama hats cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Police caps and hats (except protective head gear) cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Scarves cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title: "Straw hats manufacturing",
  },
  {
    code: "315990",
    title:
      "Suit trimmings cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Suspenders cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title:
      "Ties, men's and boys' hand sewn (except apparel contractors), manufacturing",
  },
  {
    code: "315990",
    title:
      "Uniform hats and caps cut and sewn from purchased fabric (except apparel contractors)",
  },
  {
    code: "315990",
    title: "Work gloves, leather (except apparel contractors), manufacturing",
  },
  {
    code: "316110",
    title: "Bag leather manufacturing",
  },
  {
    code: "316110",
    title: "Belting butts, curried or rough, manufacturing",
  },
  {
    code: "316110",
    title: "Belting leather, manufacturing",
  },
  {
    code: "316110",
    title: "Bookbinder's leather manufacturing",
  },
  {
    code: "316110",
    title: "Bridle leather manufacturing",
  },
  {
    code: "316110",
    title: "Buffings, russet, manufacturing",
  },
  {
    code: "316110",
    title: "Case leather manufacturing",
  },
  {
    code: "316110",
    title: "Chamois leather manufacturing",
  },
  {
    code: "316110",
    title: "Collar leather, manufacturing",
  },
  {
    code: "316110",
    title: "Coloring leather",
  },
  {
    code: "316110",
    title: "Converters, leather",
  },
  {
    code: "316110",
    title: "Currying furs",
  },
  {
    code: "316110",
    title: "Currying leather",
  },
  {
    code: "316110",
    title: "Cutting of leather",
  },
  {
    code: "316110",
    title:
      "Dressing (i.e., bleaching, blending, currying, scraping, tanning) furs",
  },
  {
    code: "316110",
    title: "Dressing hides",
  },
  {
    code: "316110",
    title: "Dyeing furs",
  },
  {
    code: "316110",
    title: "Dyeing leather",
  },
  {
    code: "316110",
    title: "Embossing leather",
  },
  {
    code: "316110",
    title: "Exotic leathers manufacturing",
  },
  {
    code: "316110",
    title: "Fancy leathers manufacturing",
  },
  {
    code: "316110",
    title: "Finishing hides and skins on a contract basis",
  },
  {
    code: "316110",
    title: "Finishing leather",
  },
  {
    code: "316110",
    title:
      "Fleshers, leather (i.e., flesh side of split leather), manufacturing",
  },
  {
    code: "316110",
    title: "Fur stripping",
  },
  {
    code: "316110",
    title:
      "Furs, dressed (e.g., bleached, curried, dyed, scraped, tanned), manufacturing",
  },
  {
    code: "316110",
    title: "Garment leather manufacturing",
  },
  {
    code: "316110",
    title: "Glove leather manufacturing",
  },
  {
    code: "316110",
    title: "Handbag leather manufacturing",
  },
  {
    code: "316110",
    title: "Harness leather manufacturing",
  },
  {
    code: "316110",
    title: "Hides and skins, finishing on a contract basis",
  },
  {
    code: "316110",
    title: "Hides, tanning, currying, dressing, and finishing",
  },
  {
    code: "316110",
    title: "Japanning of leather",
  },
  {
    code: "316110",
    title: "Lace leather manufacturing",
  },
  {
    code: "316110",
    title: "Latigo leather manufacturing",
  },
  {
    code: "316110",
    title: "Leather coloring, cutting, embossing, and japanning",
  },
  {
    code: "316110",
    title: "Leather converters",
  },
  {
    code: "316110",
    title: "Leather tanning, currying, and finishing",
  },
  {
    code: "316110",
    title: "Lining leather manufacturing",
  },
  {
    code: "316110",
    title: "Mechanical leather manufacturing",
  },
  {
    code: "316110",
    title: "Parchment leather manufacturing",
  },
  {
    code: "316110",
    title: "Patent leather manufacturing",
  },
  {
    code: "316110",
    title: "Pelts bleaching, currying, dyeing, scraping, and tanning",
  },
  {
    code: "316110",
    title: "Rawhide manufacturing",
  },
  {
    code: "316110",
    title: "Roller leather manufacturing",
  },
  {
    code: "316110",
    title: "Saddlery leather manufacturing",
  },
  {
    code: "316110",
    title: "Shearling (i.e., prepared sheepskin) manufacturing",
  },
  {
    code: "316110",
    title: "Skins, tanning, currying and finishing",
  },
  {
    code: "316110",
    title: "Skirting leather manufacturing",
  },
  {
    code: "316110",
    title: "Skivers, leather, manufacturing",
  },
  {
    code: "316110",
    title: "Slitting leather for the trade",
  },
  {
    code: "316110",
    title: "Sole leather manufacturing",
  },
  {
    code: "316110",
    title: "Specialty leathers manufacturing",
  },
  {
    code: "316110",
    title: "Splits, leather, manufacturing",
  },
  {
    code: "316110",
    title: "Strap leather manufacturing",
  },
  {
    code: "316110",
    title: "Sweatband leather manufacturing",
  },
  {
    code: "316110",
    title: "Tannery leather manufacturing",
  },
  {
    code: "316110",
    title: "Tanning and currying furs",
  },
  {
    code: "316110",
    title: "Upholstery leather manufacturing",
  },
  {
    code: "316110",
    title: "Upper leather manufacturing",
  },
  {
    code: "316110",
    title: "Vellum leather manufacturing",
  },
  {
    code: "316110",
    title: "Welting leather manufacturing",
  },
  {
    code: "316110",
    title: "Wet blues manufacturing",
  },
  {
    code: "316210",
    title: "Arctics, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Arctics, rubber or rubber soled fabric, manufacturing",
  },
  {
    code: "316210",
    title: "Athletic shoes manufacturing",
  },
  {
    code: "316210",
    title:
      "Athletic shoes, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Athletic shoes, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Ballet slippers manufacturing",
  },
  {
    code: "316210",
    title:
      "Beach sandals, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Beach sandals, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Boots, dress and casual, children's and infants', manufacturing",
  },
  {
    code: "316210",
    title: "Boots, dress and casual, men's, manufacturing",
  },
  {
    code: "316210",
    title: "Boots, dress and casual, women's, manufacturing",
  },
  {
    code: "316210",
    title: "Boots, hiking, children's and infants', manufacturing",
  },
  {
    code: "316210",
    title: "Boots, hiking, men's, manufacturing",
  },
  {
    code: "316210",
    title: "Boots, hiking, women's, manufacturing",
  },
  {
    code: "316210",
    title: "Boots, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Boots, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Canvas shoes, plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Canvas shoes, rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Casual shoes, children's and infants', manufacturing",
  },
  {
    code: "316210",
    title: "Casual shoes, men's, manufacturing",
  },
  {
    code: "316210",
    title: "Casual shoes, women's, manufacturing",
  },
  {
    code: "316210",
    title: "Children's shoes (except orthopedic extension) manufacturing",
  },
  {
    code: "316210",
    title: "Cleated athletic shoes manufacturing",
  },
  {
    code: "316210",
    title:
      "Climbing shoes, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Climbing shoes, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Dress shoes, children's and infants', manufacturing",
  },
  {
    code: "316210",
    title: "Dress shoes, men's, manufacturing",
  },
  {
    code: "316210",
    title: "Dress shoes, women's, manufacturing",
  },
  {
    code: "316210",
    title: "Footholds, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Footholds, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Footwear, athletic, manufacturing",
  },
  {
    code: "316210",
    title: "Footwear, children's (except orthopedic extension), manufacturing",
  },
  {
    code: "316210",
    title:
      "Footwear, children's, leather or vinyl upper with rubber or plastics soles, manufacturing",
  },
  {
    code: "316210",
    title: "Footwear, men's (except orthopedic extension), manufacturing",
  },
  {
    code: "316210",
    title:
      "Footwear, men's leather or vinyl upper with rubber or plastics soles, manufacturing",
  },
  {
    code: "316210",
    title: "Footwear, plastics or plastics soled fabric uppers, manufacturing",
  },
  {
    code: "316210",
    title: "Footwear, women's (except orthopedic extension), manufacturing",
  },
  {
    code: "316210",
    title:
      "Footwear, women's leather or vinyl upper with rubber or plastics soles, manufacturing",
  },
  {
    code: "316210",
    title: "Gaiters, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Gaiters, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Galoshes, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Galoshes, rubber, or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Golf shoes, men's cleated, manufacturing",
  },
  {
    code: "316210",
    title: "Golf shoes, women's cleated, manufacturing",
  },
  {
    code: "316210",
    title: "House slippers manufacturing",
  },
  {
    code: "316210",
    title:
      "House slippers, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "House slippers, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Infant's shoes manufacturing",
  },
  {
    code: "316210",
    title: "Leather footwear manufacturing",
  },
  {
    code: "316210",
    title: "Leather footwear, men's, manufacturing",
  },
  {
    code: "316210",
    title: "Leather footwear, slippers, manufacturing",
  },
  {
    code: "316210",
    title: "Leather footwear, women's, manufacturing",
  },
  {
    code: "316210",
    title: "Leather house slippers manufacturing",
  },
  {
    code: "316210",
    title: "Leather upper athletic footwear manufacturing",
  },
  {
    code: "316210",
    title: "Moccasins manufacturing",
  },
  {
    code: "316210",
    title:
      "Orthopedic shoes (except extension shoes), children's, manufacturing",
  },
  {
    code: "316210",
    title: "Orthopedic shoes (except extension shoes), men's, manufacturing",
  },
  {
    code: "316210",
    title: "Orthopedic shoes (except extension shoes), women's, manufacturing",
  },
  {
    code: "316210",
    title: "Overshoes, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Overshoes, rubber, or rubber soled fabric, manufacturing",
  },
  {
    code: "316210",
    title: "Pacs, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Pacs, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title:
      "Protective footwear, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title:
      "Protective footwear, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Pumps (i.e., dress shoes) manufacturing",
  },
  {
    code: "316210",
    title: "Sandals, children's, manufacturing",
  },
  {
    code: "316210",
    title: "Sandals, men's footwear, manufacturing",
  },
  {
    code: "316210",
    title: "Sandals, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Sandals, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Sandals, women's footwear, manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, athletic, manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, ballet, manufacturing",
  },
  {
    code: "316210",
    title:
      "Shoes, children's and infant's (except orthopedic extension), manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, cleated or spiked, all materials, manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, men's (except orthopedic extension), manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, theatrical, manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, women's (except orthopedic extension), manufacturing",
  },
  {
    code: "316210",
    title: "Shoes, wooden, manufacturing",
  },
  {
    code: "316210",
    title: "Shower sandals or slippers, rubber, manufacturing",
  },
  {
    code: "316210",
    title: "Slipper socks made from purchased socks",
  },
  {
    code: "316210",
    title: "Slippers, ballet, manufacturing",
  },
  {
    code: "316210",
    title: "Slippers, house, manufacturing",
  },
  {
    code: "316210",
    title: "Socks, slipper, made from purchased socks",
  },
  {
    code: "316210",
    title: "Vinyl upper athletic footwear manufacturing",
  },
  {
    code: "316210",
    title:
      "Water shoes, plastics or plastics soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Water shoes, rubber or rubber soled fabric upper, manufacturing",
  },
  {
    code: "316210",
    title: "Work shoes manufacturing",
  },
  {
    code: "316990",
    title: "Aprons for textile machinery, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Aprons, leather (e.g., blacksmith's, welder's), manufacturing",
  },
  {
    code: "316990",
    title: "Attache cases, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Bags (i.e., luggage), all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Bags, athletic, manufacturing",
  },
  {
    code: "316990",
    title: "Belt laces, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Belting for machinery, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Belts, leather safety, manufacturing",
  },
  {
    code: "316990",
    title: "Billfolds (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Binocular cases manufacturing",
  },
  {
    code: "316990",
    title: "Blacksmith's aprons, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Boot and shoe cut stock and findings, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Bows, shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Box toes (i.e., shoe cut stock), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Boxes, hat (except paper or paperboard), manufacturing",
  },
  {
    code: "316990",
    title: "Boxes, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Briefcases, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Camera carrying bags, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Caps, heel and toe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Card cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Cases, jewelry (except metal), manufacturing",
  },
  {
    code: "316990",
    title: "Cases, luggage, manufacturing",
  },
  {
    code: "316990",
    title: "Cases, musical instrument, manufacturing",
  },
  {
    code: "316990",
    title: "Checkbook covers (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Cigar cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Cigarette cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Clasps, shoe (leather), manufacturing",
  },
  {
    code: "316990",
    title: "Coin purses (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Collars and collar pads (i.e., harness) manufacturing",
  },
  {
    code: "316990",
    title: "Collars, dog, manufacturing",
  },
  {
    code: "316990",
    title: "Comb cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Compacts, solid leather, manufacturing",
  },
  {
    code: "316990",
    title: "Corners, luggage, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Cosmetic bags (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Counters (i.e., shoe cut stock), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Crops, riding, manufacturing",
  },
  {
    code: "316990",
    title: "Cut stock for boots and shoes manufacturing",
  },
  {
    code: "316990",
    title: "Desk sets, leather, manufacturing",
  },
  {
    code: "316990",
    title:
      "Dog furnishings (e.g., collars, harnesses, leashes, muzzles) manufacturing",
  },
  {
    code: "316990",
    title: "Eyeglass cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Feed bags for horses manufacturing",
  },
  {
    code: "316990",
    title: "Findings, boot and shoe, manufacturing",
  },
  {
    code: "316990",
    title: "Handbags, all materials (except precious metal), manufacturing",
  },
  {
    code: "316990",
    title: "Handles (e.g., luggage, whip), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Harnesses and harness parts, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Harnesses, dog, manufacturing",
  },
  {
    code: "316990",
    title: "Heel caps, leather or metal, manufacturing",
  },
  {
    code: "316990",
    title: "Heel lifts, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Heels, boot and shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Holsters, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Horse boots and muzzles manufacturing",
  },
  {
    code: "316990",
    title: "Inner soles, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Jackets, welder's, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Key cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Laces (e.g., shoe), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Lashes (i.e., whips) manufacturing",
  },
  {
    code: "316990",
    title: "Leashes, dog, manufacturing",
  },
  {
    code: "316990",
    title: "Leather belting manufacturing",
  },
  {
    code: "316990",
    title: "Leather cut stock for shoe and boot manufacturing",
  },
  {
    code: "316990",
    title:
      "Leather goods, small personal (e.g., coin purses, eyeglass cases, key cases), manufacturing",
  },
  {
    code: "316990",
    title: "Leather handbags and purses manufacturing",
  },
  {
    code: "316990",
    title: "Leather luggage manufacturing",
  },
  {
    code: "316990",
    title: "Leather welting manufacturing",
  },
  {
    code: "316990",
    title: "Leggings, welder's, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Lifts, heel, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Linings, boot and shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Luggage, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Mill strapping for textile mills, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Musical instrument cases, all materials, manufacturing",
  },
  {
    code: "316990",
    title:
      "Novelties, leather (e.g., cigarette lighter covers, key fobs), manufacturing",
  },
  {
    code: "316990",
    title: "Pegs, leather shoe, manufacturing",
  },
  {
    code: "316990",
    title:
      "Personal leather goods (e.g., coin purses, eyeglass cases, key cases), small, manufacturing",
  },
  {
    code: "316990",
    title: "Purses (except precious metal) manufacturing",
  },
  {
    code: "316990",
    title: "Quarters (i.e., shoe cut stock), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Rands (i.e., shoe cut stock), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Razor strops manufacturing",
  },
  {
    code: "316990",
    title: "Riding crops manufacturing",
  },
  {
    code: "316990",
    title: "Saddles and parts, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Safety belts, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Sample cases, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Satchels, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Seatbelts, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Sewing cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Shanks, shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Shoe kits (i.e., cases), all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Shoe soles, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Sleeves, welder's, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Soles, boot and shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Spats, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Stays, shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Straps, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Straps, watch (except metal), manufacturing",
  },
  {
    code: "316990",
    title: "Suitcases, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Taps, shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title:
      "Textile leathers (e.g., apron picker leather, mill strapping) manufacturing",
  },
  {
    code: "316990",
    title: "Tips, shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Tobacco pouches (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Toe caps, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Toilet kits and cases (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Tongues, boot and shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Top lifts, boot and shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Transmission belting, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Traveling bags, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Trimmings, shoe, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Trunks (i.e., luggage), all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Uppers (i.e., shoe cut stock), leather, manufacturing",
  },
  {
    code: "316990",
    title: "Valises, all materials, manufacturing",
  },
  {
    code: "316990",
    title: "Vamps, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Vanity cases, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Wallets (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Wardrobe bags (i.e., luggage) manufacturing",
  },
  {
    code: "316990",
    title: "Watch bands (except metal) manufacturing",
  },
  {
    code: "316990",
    title: "Welders' aprons, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Welders' jackets, leggings, and sleeves, leather, manufacturing",
  },
  {
    code: "316990",
    title: "Whips, horse, manufacturing",
  },
  {
    code: "316990",
    title: "Whipstocks manufacturing",
  },
  {
    code: "321113",
    title: "Beams, wood, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Boards, wood, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Ceiling lumber, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Chipper mills (except portable)",
  },
  {
    code: "321113",
    title: "Custom sawmills",
  },
  {
    code: "321113",
    title: "Dimension lumber, hardwood, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Dimension lumber, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Dimension lumber, softwood, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Flitches (i.e., veneer stock) made in sawmills",
  },
  {
    code: "321113",
    title: "Lumber (i.e., rough, dressed) made from logs or bolts",
  },
  {
    code: "321113",
    title: "Lumber, hardwood dimension, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Lumber, softwood dimension, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Poles, wood, made from log or bolts",
  },
  {
    code: "321113",
    title: "Pressure treated lumber made from logs or bolts and treated",
  },
  {
    code: "321113",
    title: "Sawdust and shavings (i.e., sawmill byproducts) manufacturing",
  },
  {
    code: "321113",
    title: "Sawed lumber made in sawmills",
  },
  {
    code: "321113",
    title: "Sawmills",
  },
  {
    code: "321113",
    title: "Shakes (i.e., hand split shingles) manufacturing",
  },
  {
    code: "321113",
    title: "Shingle mills, wood",
  },
  {
    code: "321113",
    title: "Shingles, wood, sawed or hand split, manufacturing",
  },
  {
    code: "321113",
    title: "Siding mills, wood",
  },
  {
    code: "321113",
    title: "Siding, dressed lumber, manufacturing",
  },
  {
    code: "321113",
    title: "Stud mills",
  },
  {
    code: "321113",
    title: "Ties, railroad, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Ties, wood, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Timbers, made from logs or bolts",
  },
  {
    code: "321113",
    title: "Wood chips made in sawmills",
  },
  {
    code: "321114",
    title: "Bridge and trestle parts, wood, treating",
  },
  {
    code: "321114",
    title: "Creosoting of wood",
  },
  {
    code: "321114",
    title: "Crossties, treating",
  },
  {
    code: "321114",
    title: "Flooring, wood block, treating",
  },
  {
    code: "321114",
    title: "Millwork, treating",
  },
  {
    code: "321114",
    title: "Mine props, treating",
  },
  {
    code: "321114",
    title: "Mine ties, wood, treated, manufacturing",
  },
  {
    code: "321114",
    title: "Pilings, foundation and marine construction, treating",
  },
  {
    code: "321114",
    title: "Pilings, round wood, cutting and treating",
  },
  {
    code: "321114",
    title: "Pilings, wood, treating",
  },
  {
    code: "321114",
    title: "Poles, round wood, cutting and treating",
  },
  {
    code: "321114",
    title: "Poles, wood, treating",
  },
  {
    code: "321114",
    title: "Posts, round wood, cutting and treating",
  },
  {
    code: "321114",
    title: "Posts, wood, treating",
  },
  {
    code: "321114",
    title: "Preserving purchased wood and wood products",
  },
  {
    code: "321114",
    title: "Pressure treated lumber made from purchased lumber",
  },
  {
    code: "321114",
    title: "Railroad ties (i.e., bridge, cross, switch) treating",
  },
  {
    code: "321114",
    title: "Structural lumber and timber, treating",
  },
  {
    code: "321114",
    title: "Ties, wood railroad bridge, cross, and switch, treating",
  },
  {
    code: "321114",
    title: "Timber, structural, treating",
  },
  {
    code: "321114",
    title: "Treating purchased wood and wood products",
  },
  {
    code: "321114",
    title: "Treating wood products with creosote or other preservatives",
  },
  {
    code: "321114",
    title: "Trestle parts, wood, treating",
  },
  {
    code: "321114",
    title: "Wood fence (i.e., pickets, poling, rails), treating",
  },
  {
    code: "321114",
    title: "Wood products, creosoting purchased wood products",
  },
  {
    code: "321211",
    title: "Hardwood plywood composites manufacturing",
  },
  {
    code: "321211",
    title: "Hardwood veneer or plywood manufacturing",
  },
  {
    code: "321211",
    title: "Panels, hardwood plywood, manufacturing",
  },
  {
    code: "321211",
    title: "Plywood, faced with nonwood materials, hardwood, manufacturing",
  },
  {
    code: "321211",
    title: "Plywood, hardwood faced, manufacturing",
  },
  {
    code: "321211",
    title: "Plywood, hardwood, manufacturing",
  },
  {
    code: "321211",
    title: "Prefinished hardwood plywood manufacturing",
  },
  {
    code: "321211",
    title: "Reconstituted hardwood veneer manufacturing",
  },
  {
    code: "321211",
    title: "Veneer mills, hardwood",
  },
  {
    code: "321212",
    title: "Panels, softwood plywood, manufacturing",
  },
  {
    code: "321212",
    title: "Plywood, faced with nonwood materials, softwood, manufacturing",
  },
  {
    code: "321212",
    title: "Plywood, softwood faced, manufacturing",
  },
  {
    code: "321212",
    title: "Plywood, softwood, manufacturing",
  },
  {
    code: "321212",
    title: "Prefinished softwood plywood manufacturing",
  },
  {
    code: "321212",
    title: "Softwood plywood composites manufacturing",
  },
  {
    code: "321212",
    title: "Softwood veneer or plywood manufacturing",
  },
  {
    code: "321212",
    title: "Veneer mills, softwood",
  },
  {
    code: "321215",
    title: "Arches, glue laminated or pre-engineered wood, manufacturing",
  },
  {
    code: "321215",
    title: "Fabricated structural wood members manufacturing",
  },
  {
    code: "321215",
    title: "Finger joint lumber manufacturing",
  },
  {
    code: "321215",
    title: "Floor trusses, wood, manufacturing",
  },
  {
    code: "321215",
    title: "I-joists, wood, fabricating",
  },
  {
    code: "321215",
    title: "Laminated structural wood members manufacturing",
  },
  {
    code: "321215",
    title: "Laminated veneer lumber (LVL) manufacturing",
  },
  {
    code: "321215",
    title: "Lumber, parallel strand, manufacturing",
  },
  {
    code: "321215",
    title: "LVL (laminated veneer lumber) manufacturing",
  },
  {
    code: "321215",
    title: "Parallel strand lumber manufacturing",
  },
  {
    code: "321215",
    title: "Roof trusses, wood, manufacturing",
  },
  {
    code: "321215",
    title:
      "Structural members, glue laminated or pre-engineered wood, manufacturing",
  },
  {
    code: "321215",
    title: "Structural wood members, fabricated, manufacturing",
  },
  {
    code: "321215",
    title:
      "Timbers, structural, glue laminated or pre-engineered wood, manufacturing",
  },
  {
    code: "321215",
    title: "Trusses, glue laminated or pre-engineered wood, manufacturing",
  },
  {
    code: "321215",
    title: "Trusses, wood roof or floor, manufacturing",
  },
  {
    code: "321215",
    title: "Trusses, wood, glue laminated or metal connected, manufacturing",
  },
  {
    code: "321215",
    title: "Wood I-joists manufacturing",
  },
  {
    code: "321219",
    title: "Board, bagasse, manufacturing",
  },
  {
    code: "321219",
    title: "Board, particle, manufacturing",
  },
  {
    code: "321219",
    title: "Chipboard (i.e., particle core, wood chip face) manufacturing",
  },
  {
    code: "321219",
    title: "Compression modified wood manufacturing",
  },
  {
    code: "321219",
    title: "Densified wood manufacturing",
  },
  {
    code: "321219",
    title: "Fiberboard manufacturing",
  },
  {
    code: "321219",
    title: "Flakeboard manufacturing",
  },
  {
    code: "321219",
    title: "Hardboard manufacturing",
  },
  {
    code: "321219",
    title:
      "Insulation board, cellular fiber or hard pressed wood, manufacturing",
  },
  {
    code: "321219",
    title: "Lath, fiber, manufacturing",
  },
  {
    code: "321219",
    title: "MDF (medium density fiberboard) manufacturing",
  },
  {
    code: "321219",
    title: "Medium density fiberboard (MDF) manufacturing",
  },
  {
    code: "321219",
    title: "Oriented strandboard (OSB) manufacturing",
  },
  {
    code: "321219",
    title: "OSB (oriented strandboard) manufacturing",
  },
  {
    code: "321219",
    title: "Particleboard manufacturing",
  },
  {
    code: "321219",
    title: "Reconstituted wood panels manufacturing",
  },
  {
    code: "321219",
    title: "Reconstituted wood sheets and boards manufacturing",
  },
  {
    code: "321219",
    title: "Strandboard, oriented, manufacturing",
  },
  {
    code: "321219",
    title: "Waferboard manufacturing",
  },
  {
    code: "321911",
    title: "Door frames and sash, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Door jambs, wood, manufacturing",
  },
  {
    code: "321911",
    title: "Door units, prehung, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Doors, combination screen-storm, wood, manufacturing",
  },
  {
    code: "321911",
    title: "Doors, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Frames, door and window, wood, manufacturing",
  },
  {
    code: "321911",
    title: "Garage doors, wood, manufacturing",
  },
  {
    code: "321911",
    title:
      "Louver windows and doors, made from purchased glass with wood frame",
  },
  {
    code: "321911",
    title: "Sash, door and window, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Screens, door and window, wood framed, manufacturing",
  },
  {
    code: "321911",
    title: "Storm doors and windows, wood framed, manufacturing",
  },
  {
    code: "321911",
    title: "Window frames and sash, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Window screens, wood framed, manufacturing",
  },
  {
    code: "321911",
    title: "Window units, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Windows, louver, wood, manufacturing",
  },
  {
    code: "321911",
    title: "Windows, wood and covered wood, manufacturing",
  },
  {
    code: "321911",
    title: "Wood door frames and sash manufacturing",
  },
  {
    code: "321911",
    title: "Wood window frames and sash manufacturing",
  },
  {
    code: "321912",
    title:
      "Blanks, wood (e.g., bowling pins, handles, textile machinery accessories), manufacturing",
  },
  {
    code: "321912",
    title: "Boards, wood, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Bobbin blocks and blanks, wood, manufacturing",
  },
  {
    code: "321912",
    title: "Bowling pin blanks manufacturing",
  },
  {
    code: "321912",
    title: "Brush blocks, wood, turned and shaped",
  },
  {
    code: "321912",
    title: "Cants, resawed (lumber), manufacturing",
  },
  {
    code: "321912",
    title: "Ceiling lumber, dressed, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Cut stock manufacturing",
  },
  {
    code: "321912",
    title: "Dimension lumber, hardwood, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Dimension lumber, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Dimension lumber, softwood, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Dimension stock, hardwood, manufacturing",
  },
  {
    code: "321912",
    title: "Dimension stock, softwood, manufacturing",
  },
  {
    code: "321912",
    title: "Dimension stock, wood, manufacturing",
  },
  {
    code: "321912",
    title: "Furniture dimension stock, hardwood, unfinished, manufacturing",
  },
  {
    code: "321912",
    title: "Furniture dimension stock, softwood, unfinished, manufacturing",
  },
  {
    code: "321912",
    title: "Furniture dimension stock, unfinished wood, manufacturing",
  },
  {
    code: "321912",
    title: "Furniture squares, unfinished hardwood, manufacturing",
  },
  {
    code: "321912",
    title: "Gun stock blanks manufacturing",
  },
  {
    code: "321912",
    title: "Handle blanks, wood, manufacturing",
  },
  {
    code: "321912",
    title: "Handle stock, sawed or planed, manufacturing",
  },
  {
    code: "321912",
    title: "Hardwood dimension lumber and stock, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Ladder rounds or rungs, hardwood, manufacturing",
  },
  {
    code: "321912",
    title: "Lath, wood, manufacturing",
  },
  {
    code: "321912",
    title: "Lathmills, wood",
  },
  {
    code: "321912",
    title: "Lumber, hardwood dimension, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Lumber, softwood dimension, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Planing mills (except millwork)",
  },
  {
    code: "321912",
    title: "Planing purchased lumber",
  },
  {
    code: "321912",
    title: "Resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Rounds or rungs, furniture, hardwood, manufacturing",
  },
  {
    code: "321912",
    title: "Sawed lumber, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Snow fence lath manufacturing",
  },
  {
    code: "321912",
    title: "Softwood dimension lumber and stock, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Stock, chair, unfinished hardwood, manufacturing",
  },
  {
    code: "321912",
    title: "Studs, resawing purchased lumber",
  },
  {
    code: "321912",
    title: "Turnings, furniture, unfinished wood, manufacturing",
  },
  {
    code: "321912",
    title: "Vehicle stock, hardwood, manufacturing",
  },
  {
    code: "321918",
    title: "Bamboo flooring manufacturing",
  },
  {
    code: "321918",
    title: "Baseboards, floor, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Brackets, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Clear and finger joint wood moldings manufacturing",
  },
  {
    code: "321918",
    title: "Columns, porch, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Cornices, wood, manufacturing",
  },
  {
    code: "321918",
    title:
      "Decorative wood moldings (e.g., base, chair rail, crown, shoe) manufacturing",
  },
  {
    code: "321918",
    title: "Door shutters, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Door trim, wood molding, manufacturing",
  },
  {
    code: "321918",
    title: "Exterior wood shutters manufacturing",
  },
  {
    code: "321918",
    title: "Floor baseboards, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Flooring, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Moldings, clear and finger joint wood, manufacturing",
  },
  {
    code: "321918",
    title: "Moldings, wood and covered wood, manufacturing",
  },
  {
    code: "321918",
    title: "Newel posts, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Ornamental woodwork (e.g., cornices, mantels) manufacturing",
  },
  {
    code: "321918",
    title: "Panel work, wood millwork, manufacturing",
  },
  {
    code: "321918",
    title: "Parquet flooring, hardwood, manufacturing",
  },
  {
    code: "321918",
    title: "Parquetry, hardwood, manufacturing",
  },
  {
    code: "321918",
    title: "Planing mills, millwork",
  },
  {
    code: "321918",
    title:
      "Porch work (e.g., columns, newels, rails, trellises), wood, manufacturing",
  },
  {
    code: "321918",
    title: "Railings, wood stair, manufacturing",
  },
  {
    code: "321918",
    title: "Shutters, door and window, wood and covered wood, manufacturing",
  },
  {
    code: "321918",
    title: "Shutters, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Stair railings, wood, manufacturing",
  },
  {
    code: "321918",
    title:
      "Stairwork (e.g., newel posts, railings, staircases, stairs), wood, manufacturing",
  },
  {
    code: "321918",
    title: "Trellises, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Trim, wood and covered wood, manufacturing",
  },
  {
    code: "321918",
    title: "Venetian blind slats, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Wainscots, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Weatherstrip, wood, manufacturing",
  },
  {
    code: "321918",
    title: "Window trim, wood and covered wood moldings, manufacturing",
  },
  {
    code: "321918",
    title:
      "Wood flooring (including laminate and wood composite) manufacturing",
  },
  {
    code: "321918",
    title:
      "Wood moldings (e.g., prefinished, unfinished), clear and finger joint, manufacturing",
  },
  {
    code: "321918",
    title: "Wood shutters manufacturing",
  },
  {
    code: "321920",
    title: "Ammunition boxes, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Barrel heading and staves manufacturing",
  },
  {
    code: "321920",
    title: "Barrels, wood, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Baskets, wood (e.g., round stave, veneer), manufacturing",
  },
  {
    code: "321920",
    title: "Berry crates, wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Berry cups, veneer and splint, manufacturing",
  },
  {
    code: "321920",
    title: "Box cleats, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Box shook manufacturing",
  },
  {
    code: "321920",
    title: "Boxes, cigar, wood or part wood, manufacturing",
  },
  {
    code: "321920",
    title: "Boxes, jewelry, wood or part wood, manufacturing",
  },
  {
    code: "321920",
    title: "Boxes, wood, manufacturing",
  },
  {
    code: "321920",
    title:
      "Boxes, wood, plain or fabric covered, nailed or lock corner, manufacturing",
  },
  {
    code: "321920",
    title: "Buckets, wood, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Cases, shipping, wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Cases, wood packing, nailed or lock corner, manufacturing",
  },
  {
    code: "321920",
    title: "Cases, wood shipping, nailed or lock corner, manufacturing",
  },
  {
    code: "321920",
    title: "Casks, wood, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Chests for tools, wood, manufacturing",
  },
  {
    code: "321920",
    title:
      "Chicken coops (i.e., crates), wood, wirebound for shipping poultry, manufacturing",
  },
  {
    code: "321920",
    title: "Cigar boxes, wood and part wood, manufacturing",
  },
  {
    code: "321920",
    title: "Containers, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Cooperage manufacturing",
  },
  {
    code: "321920",
    title: "Cooperage stock (e.g., heading, hoops, staves) manufacturing",
  },
  {
    code: "321920",
    title: "Cooperage stock mills",
  },
  {
    code: "321920",
    title: "Coopered tubs manufacturing",
  },
  {
    code: "321920",
    title:
      "Crates (e.g., berry, butter, fruit, vegetable) made of wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Drums, plywood, manufacturing",
  },
  {
    code: "321920",
    title: "Drums, shipping, wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Egg cases, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Firkins and kits, wood, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Flats, wood, greenhouse, manufacturing",
  },
  {
    code: "321920",
    title: "Fruit baskets, veneer and splint, manufacturing",
  },
  {
    code: "321920",
    title: "Fruit crates, wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Heading, barrel (i.e., cooperage stock), wood, manufacturing",
  },
  {
    code: "321920",
    title: "Hogsheads, coopered wood, manufacturing",
  },
  {
    code: "321920",
    title:
      "Hoops, sawed or split wood for tight or slack cooperage, manufacturing",
  },
  {
    code: "321920",
    title: "Hot tubs, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Kegs, wood, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Packing cases, wood, nailed or lock corner, manufacturing",
  },
  {
    code: "321920",
    title: "Packing crates, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Pails, coopered wood, manufacturing",
  },
  {
    code: "321920",
    title: "Pails, plywood, manufacturing",
  },
  {
    code: "321920",
    title: "Pails, wood, manufacturing",
  },
  {
    code: "321920",
    title:
      "Pallet containers, wood or wood and metal combination, manufacturing",
  },
  {
    code: "321920",
    title: "Pallet parts, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Pallets, wood or wood and metal combination, manufacturing",
  },
  {
    code: "321920",
    title: "Round stave baskets (e.g., fruit, vegetable) manufacturing",
  },
  {
    code: "321920",
    title: "Shipping cases and drums, wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Shipping cases, wood, nailed or lock corner, manufacturing",
  },
  {
    code: "321920",
    title: "Shipping crates, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Shook, box, manufacturing",
  },
  {
    code: "321920",
    title:
      "Skids and pallets, wood or wood and metal combination, manufacturing",
  },
  {
    code: "321920",
    title: "Splint baskets for fruits and vegetables, manufacturing",
  },
  {
    code: "321920",
    title: "Staves, barrel, sawed or split, manufacturing",
  },
  {
    code: "321920",
    title: "Tanks, wood, coopered, manufacturing",
  },
  {
    code: "321920",
    title: "Tobacco hogshead stock, manufacturing",
  },
  {
    code: "321920",
    title: "Tobacco hogsheads, manufacturing",
  },
  {
    code: "321920",
    title: "Tool chests, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Trays, carrier, wood, manufacturing",
  },
  {
    code: "321920",
    title: "Vegetable baskets, veneer and splint, manufacturing",
  },
  {
    code: "321920",
    title: "Vegetable crates, wood, wirebound, manufacturing",
  },
  {
    code: "321920",
    title: "Veneer baskets, for fruits and vegetables, manufacturing",
  },
  {
    code: "321991",
    title: "Buildings, mobile, commercial use, manufacturing",
  },
  {
    code: "321991",
    title: "Houses, prefabricated mobile homes, manufacturing",
  },
  {
    code: "321991",
    title:
      "Manufactured (mobile) buildings for commercial use (e.g., banks, offices) manufacturing",
  },
  {
    code: "321991",
    title: "Manufactured (mobile) classrooms manufacturing",
  },
  {
    code: "321991",
    title: "Manufactured (mobile) homes manufacturing",
  },
  {
    code: "321991",
    title: "Mobile homes manufacturing",
  },
  {
    code: "321992",
    title: "Buildings, prefabricated, wood, manufacturing",
  },
  {
    code: "321992",
    title: "Chicken coops, prefabricated, wood, manufacturing",
  },
  {
    code: "321992",
    title: "Corn cribs, prefabricated, wood, manufacturing",
  },
  {
    code: "321992",
    title: "Farm buildings, prefabricated wood, manufacturing",
  },
  {
    code: "321992",
    title: "Garages, prefabricated wood, manufacturing",
  },
  {
    code: "321992",
    title: "Geodesic domes, prefabricated, wood, manufacturing",
  },
  {
    code: "321992",
    title: "Houses, prefabricated, wood (except mobile homes), manufacturing",
  },
  {
    code: "321992",
    title: "Log cabins, prefabricated wood, manufacturing",
  },
  {
    code: "321992",
    title: "Panels, prefabricated wood building, manufacturing",
  },
  {
    code: "321992",
    title: "Prefabricated homes (except mobile homes), wood, manufacturing",
  },
  {
    code: "321992",
    title: "Prefabricated wood buildings manufacturing",
  },
  {
    code: "321992",
    title: "Sauna rooms, prefabricated, wood, manufacturing",
  },
  {
    code: "321992",
    title: "Sections, prefabricated wood building, manufacturing",
  },
  {
    code: "321992",
    title:
      "Sheds (e.g., garden, storage, utility), prefabricated wood, manufacturing",
  },
  {
    code: "321999",
    title: "Applicators, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Audio cabinets (i.e., housings), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Bentwood (steam bent) products (except furniture) manufacturing",
  },
  {
    code: "321999",
    title: "Blocks, tackle, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Blocks, tailors' pressing wood, manufacturing",
  },
  {
    code: "321999",
    title: "Boards, bulletin, wood and cork, manufacturing",
  },
  {
    code: "321999",
    title: "Boards, wood (e.g., clip, ironing, meat, pastry), manufacturing",
  },
  {
    code: "321999",
    title: "Boot and shoe lasts, all materials, manufacturing",
  },
  {
    code: "321999",
    title: "Bottle corks manufacturing",
  },
  {
    code: "321999",
    title: "Bottle covers, willow, rattan, and reed, manufacturing",
  },
  {
    code: "321999",
    title: "Bowls, wood, turned and shaped, manufacturing",
  },
  {
    code: "321999",
    title: "Bulletin boards, wood and cork, manufacturing",
  },
  {
    code: "321999",
    title: "Bungs, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Buoys, cork, manufacturing",
  },
  {
    code: "321999",
    title: "Burnt wood articles manufacturing",
  },
  {
    code: "321999",
    title: "Bushings, wood, manufacturing",
  },
  {
    code: "321999",
    title:
      "Cabinets (i.e., housings), wood (e.g., sewing machines, stereo, television), manufacturing",
  },
  {
    code: "321999",
    title: "Carpets, cork, manufacturing",
  },
  {
    code: "321999",
    title: "Clipboards, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Cloth winding reels, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Clothes dryers (clothes horses), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Clothes poles, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Clothespins, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Cork products (except gaskets) manufacturing",
  },
  {
    code: "321999",
    title: "Corks, bottle, manufacturing",
  },
  {
    code: "321999",
    title:
      "Covers, bottle and demijohn, willow, rattan, and reed, manufacturing",
  },
  {
    code: "321999",
    title: "Curtain stretchers, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Dishes, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Dowels, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Excelsior (e.g., pads, wrappers) manufacturing",
  },
  {
    code: "321999",
    title: "Extension ladders, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Extension planks, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Fencing, prefabricated sections, wood, manufacturing",
  },
  {
    code: "321999",
    title:
      "Fencing, wood (except rough pickets, poles, and rails), manufacturing",
  },
  {
    code: "321999",
    title: "Firewood and fuel wood containing fuel binder manufacturing",
  },
  {
    code: "321999",
    title: "Flagpoles, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Flour, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Forms, display, boot and shoe, all materials, manufacturing",
  },
  {
    code: "321999",
    title: "Furniture inlays manufacturing",
  },
  {
    code: "321999",
    title: "Garment hangers, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Gavels, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Grain measures, wood, turned and shaped, manufacturing",
  },
  {
    code: "321999",
    title: "Hammers, wood, meat, manufacturing",
  },
  {
    code: "321999",
    title: "Handles (e.g., broom, mop, handtool), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Hangers, wooden, garment, manufacturing",
  },
  {
    code: "321999",
    title: "Heels, boot and shoe, finished wood, manufacturing",
  },
  {
    code: "321999",
    title: "Household-type woodenware manufacturing",
  },
  {
    code: "321999",
    title: "Hubs, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Insulating materials, cork, manufacturing",
  },
  {
    code: "321999",
    title: "Ironing boards, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Kiln drying lumber",
  },
  {
    code: "321999",
    title: "Kitchenware, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Knobs, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Ladder jacks, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Ladders, extension, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Last sole patterns, all materials, manufacturing",
  },
  {
    code: "321999",
    title: "Lumber, kiln drying",
  },
  {
    code: "321999",
    title: "Mallets, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Marquetry, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Mashers, potato, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Masts, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Mauls, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Novelties, wood fiber, manufacturing",
  },
  {
    code: "321999",
    title: "Oars, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Paddles, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Pads, excelsior, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Pads, table, rattan, reed, and willow, manufacturing",
  },
  {
    code: "321999",
    title: "Paint sticks, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Pastry boards, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Pencil slats, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Plugs, wood, manufacturing",
  },
  {
    code: "321999",
    title:
      "Pressed logs of sawdust and other wood particles, nonpetroleum binder, manufacturing",
  },
  {
    code: "321999",
    title: "Pressing blocks, wood, tailor's, manufacturing",
  },
  {
    code: "321999",
    title: "Pulleys, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Rails (except rough), wood fence, manufacturing",
  },
  {
    code: "321999",
    title: "Rattan ware (except furniture) manufacturing",
  },
  {
    code: "321999",
    title: "Reed ware (except furniture) manufacturing",
  },
  {
    code: "321999",
    title: "Reels, plywood, manufacturing",
  },
  {
    code: "321999",
    title: "Reels, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Rollers, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Rolling pins, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Rulers and rules (except slide), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Saddle trees, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Sawdust, regrinding",
  },
  {
    code: "321999",
    title: "Scoops, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Seat covers, rattan, manufacturing",
  },
  {
    code: "321999",
    title: "Seats, toilet, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Sewing machine cabinets, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Shoe display forms, all materials, manufacturing",
  },
  {
    code: "321999",
    title: "Shoe stretchers manufacturing",
  },
  {
    code: "321999",
    title: "Shoe trees manufacturing",
  },
  {
    code: "321999",
    title: "Skewers, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Snow fence, sections or rolls, manufacturing",
  },
  {
    code: "321999",
    title: "Spars, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Speaker cabinets (i.e., housings), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Spigots, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Spokes, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Spools (except for textile machinery), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Stakes, surveyor's, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Stepladders, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Stereo cabinets (i.e., housings), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Stoppers, cork, manufacturing",
  },
  {
    code: "321999",
    title: "Straw baskets manufacturing",
  },
  {
    code: "321999",
    title: "Stretchers, curtain, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Surveyor's stakes, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Tackle blocks, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Television cabinets (i.e., housings), wood, manufacturing",
  },
  {
    code: "321999",
    title: "Tent poles, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Tile, cork, manufacturing",
  },
  {
    code: "321999",
    title: "Toilet seats, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Tool handles, wood, turned and shaped, manufacturing",
  },
  {
    code: "321999",
    title: "Toothpicks, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Trays, wood, wicker, and bagasse, manufacturing",
  },
  {
    code: "321999",
    title: "Trophy bases, wood, manufacturing",
  },
  {
    code: "321999",
    title: "Veneer work, inlaid, manufacturing",
  },
  {
    code: "321999",
    title: "Washboards, wood and part wood, manufacturing",
  },
  {
    code: "321999",
    title: "Webbing, cane, reed, and rattan, manufacturing",
  },
  {
    code: "321999",
    title: "Willow ware (except furniture) manufacturing",
  },
  {
    code: "321999",
    title: "Wood flour manufacturing",
  },
  {
    code: "321999",
    title: "Wood heel blocks manufacturing",
  },
  {
    code: "321999",
    title: "Wood heels, finished, manufacturing",
  },
  {
    code: "321999",
    title: "Wood pellets manufacturing",
  },
  {
    code: "321999",
    title: "Wood wool (excelsior) manufacturing",
  },
  {
    code: "321999",
    title: "Woodenware, kitchen and household, manufacturing",
  },
  {
    code: "321999",
    title: "Wrappers, excelsior, manufacturing",
  },
  {
    code: "321999",
    title: "Yardsticks, wood, manufacturing",
  },
  {
    code: "322110",
    title: "Deinking plants",
  },
  {
    code: "322110",
    title: "Deinking recovered paper",
  },
  {
    code: "322110",
    title: "Groundwood pulp manufacturing",
  },
  {
    code: "322110",
    title:
      "Pulp manufacturing (i.e., chemical, mechanical, or semichemical processes) without making paper",
  },
  {
    code: "322110",
    title:
      "Pulp manufacturing (made from bagasse, linters, rags, straw, wastepaper, or wood) without making paper",
  },
  {
    code: "322110",
    title: "Pulp mills not making paper or paperboard",
  },
  {
    code: "322110",
    title: "Wood pulp manufacturing",
  },
  {
    code: "322120",
    title: "Absorbent paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Asphalt paper made in paper mills",
  },
  {
    code: "322120",
    title: "Bond paper made in paper mills",
  },
  {
    code: "322120",
    title: "Book paper, coated, made in paper mills",
  },
  {
    code: "322120",
    title: "Bristols paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Building paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Cigarette paper made in paper mills",
  },
  {
    code: "322120",
    title: "Construction paper, school and art, made in paper mills",
  },
  {
    code: "322120",
    title: "Cotton fiber paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Diapers, disposable, made in paper mills",
  },
  {
    code: "322120",
    title: "Facial tissues made in paper mills",
  },
  {
    code: "322120",
    title: "Felts, asphalt, made in paper mills",
  },
  {
    code: "322120",
    title: "Glassine wrapping paper made in paper mills",
  },
  {
    code: "322120",
    title:
      "Groundwood paper products (e.g., publication and printing paper, tablet stock, wallpaper base) made in newsprint mills",
  },
  {
    code: "322120",
    title: "Groundwood paper, coated, laminated, or treated in paper mills",
  },
  {
    code: "322120",
    title: "Groundwood paper, coated, made in paper mills",
  },
  {
    code: "322120",
    title: "Groundwood paper, newsprint, made in paper mills",
  },
  {
    code: "322120",
    title: "Kraft paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Looseleaf fillers and paper made in paper mills",
  },
  {
    code: "322120",
    title: "Napkins, table, made in paper mills",
  },
  {
    code: "322120",
    title: "Newsprint mills",
  },
  {
    code: "322120",
    title: "Newsprint paper, manufacturing",
  },
  {
    code: "322120",
    title:
      "Office paper (e.g., computer printer, photocopy, plain paper) made in paper mills",
  },
  {
    code: "322120",
    title: "Paper manufacturing",
  },
  {
    code: "322120",
    title: "Paper mills",
  },
  {
    code: "322120",
    title: "Paper mills, newsprint",
  },
  {
    code: "322120",
    title: "Paper mills, uncoated groundwood",
  },
  {
    code: "322120",
    title: "Paper products made in paper mills",
  },
  {
    code: "322120",
    title:
      "Paper stock for conversion into paper products (e.g., bag and sack stock, envelope stock, tissue stock, wallpaper stock) manufacturing",
  },
  {
    code: "322120",
    title: "Paper towels made in paper mills",
  },
  {
    code: "322120",
    title: "Paper, asphalt, made in paper mills",
  },
  {
    code: "322120",
    title: "Paper, coated, laminated or treated, made in paper mills",
  },
  {
    code: "322120",
    title: "Paper, newsprint and uncoated groundwood, manufacturing",
  },
  {
    code: "322120",
    title: "Pulp and newsprint combined manufacturing",
  },
  {
    code: "322120",
    title: "Pulp and paper combined manufacturing",
  },
  {
    code: "322120",
    title:
      "Pulp mills and groundwood paper, uncoated and untreated, manufacturing",
  },
  {
    code: "322120",
    title: "Pulp mills producing newsprint paper",
  },
  {
    code: "322120",
    title: "Pulp mills producing paper",
  },
  {
    code: "322120",
    title: "Sanitary napkins and tampons made in paper mills",
  },
  {
    code: "322120",
    title: "Sanitary paper products made in paper mills",
  },
  {
    code: "322120",
    title: "Sanitary paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Sanitary products made in paper mills",
  },
  {
    code: "322120",
    title: "Saturated felts made in paper mills",
  },
  {
    code: "322120",
    title: "Sheathing paper made in paper mills",
  },
  {
    code: "322120",
    title: "Tablets (e.g., memo, note, writing) made in paper mills",
  },
  {
    code: "322120",
    title: "Tar paper, building and roofing, made in paper mills",
  },
  {
    code: "322120",
    title: "Tissue paper stock manufacturing",
  },
  {
    code: "322120",
    title: "Toilet paper made in paper mills",
  },
  {
    code: "322120",
    title: "Towels, paper, made in paper mills",
  },
  {
    code: "322120",
    title: "Uncoated groundwood paper mills",
  },
  {
    code: "322120",
    title: "Writing paper made in paper mills",
  },
  {
    code: "322130",
    title: "Binder's board manufacturing",
  },
  {
    code: "322130",
    title: "Bristols board stock manufacturing",
  },
  {
    code: "322130",
    title: "Cardboard stock manufacturing",
  },
  {
    code: "322130",
    title: "Chipboard (i.e., paperboard) stock manufacturing",
  },
  {
    code: "322130",
    title: "Coated board made in paperboard mills",
  },
  {
    code: "322130",
    title: "Container board stock manufacturing",
  },
  {
    code: "322130",
    title: "Folding boxboard stock manufacturing",
  },
  {
    code: "322130",
    title: "Kraft linerboard manufacturing",
  },
  {
    code: "322130",
    title: "Leatherboard (i.e., paperboard based) made in paperboard mills",
  },
  {
    code: "322130",
    title: "Milk carton board made in paperboard mills",
  },
  {
    code: "322130",
    title:
      "Paperboard (e.g., can/drum stock, container board, corrugating medium, folding carton stock, linerboard, tube) manufacturing",
  },
  {
    code: "322130",
    title: "Paperboard coating, laminating, or treating in paperboard mills",
  },
  {
    code: "322130",
    title: "Paperboard mills",
  },
  {
    code: "322130",
    title: "Paperboard products (e.g., containers) made in paperboard mills",
  },
  {
    code: "322130",
    title: "Pulp and paperboard combined manufacturing",
  },
  {
    code: "322130",
    title: "Pulp mills producing paperboard",
  },
  {
    code: "322130",
    title: "Setup boxboard stock manufacturing",
  },
  {
    code: "322130",
    title: "Wet machine board mills",
  },
  {
    code: "322211",
    title:
      "Boxes, corrugated and solid fiber, made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title:
      "Boxes, shipping, laminated paper and paperboard, made from purchased paperboard",
  },
  {
    code: "322211",
    title:
      "Corrugated and solid fiber boxes made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title:
      "Corrugated and solid fiberboard pads made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title: "Corrugated paper made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title:
      "Pads, corrugated and solid fiberboard, made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title:
      "Pallets, corrugated and solid fiber, made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title: "Paper, corrugated, made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title:
      "Partitions, corrugated and solid fiber, made from purchased paper or paperboard",
  },
  {
    code: "322211",
    title: "Shipping containers made from purchased paperboard",
  },
  {
    code: "322211",
    title:
      "Shipping containers, corrugated, made from purchased paper or paperboard",
  },
  {
    code: "322212",
    title: "Boxes, folding (except corrugated), made from purchased paperboard",
  },
  {
    code: "322212",
    title: "Cartons, folding (except milk), made from purchased paperboard",
  },
  {
    code: "322212",
    title: "Folding boxes (except corrugated) made from purchased paperboard",
  },
  {
    code: "322212",
    title:
      "Folding paper and paperboard containers (except corrugated) made from purchased paperboard",
  },
  {
    code: "322212",
    title: "Food containers, sanitary, folding, made from purchased paperboard",
  },
  {
    code: "322212",
    title: "Sanitary food container, folding, made from purchased paperboard",
  },
  {
    code: "322212",
    title: "Shoe boxes, folding, made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Bobbins, fiber, made from purchased paperboard",
  },
  {
    code: "322219",
    title:
      "Boxes, sanitary food (except folding), made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title:
      "Boxes, setup (i.e., not shipped flat), made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Cartons, milk, made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title:
      "Composite cans (i.e., foil-fiber and other combinations) manufacturing",
  },
  {
    code: "322219",
    title:
      "Cones (e.g., winding yarn, string, ribbon, cloth), fiber, made from purchased paperboard",
  },
  {
    code: "322219",
    title:
      "Cores (i.e., all-fiber, nonfiber ends of any material), fiber, made from purchased paperboard",
  },
  {
    code: "322219",
    title:
      "Fiber cans and drums (i.e., all-fiber, nonfiber ends of any material) made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Fiber drums made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Fiber spools, reels, blocks made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Fiber tubes made from purchased paperboard",
  },
  {
    code: "322219",
    title:
      "Food containers, sanitary (except folding), made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title:
      "Mailing cases and tubes, paper fiber (i.e., all-fiber, nonfiber ends of any material), made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Milk cartons made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title: "Paper cups made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title:
      "Paper dishes (e.g., cups, plates) made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title: "Paper plates made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title:
      "Sanitary food containers (except folding) made from purchased paper or paperboard",
  },
  {
    code: "322219",
    title:
      "Setup (i.e., not shipped flat) boxes made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Shoe boxes, setup, made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Vulcanized fiber products made from purchased paperboard",
  },
  {
    code: "322219",
    title: "Wastebaskets, fiber made from purchased paperboard",
  },
  {
    code: "322220",
    title: "Adhesive tape (except medical) made from purchased materials",
  },
  {
    code: "322220",
    title:
      "Bags (except plastics only) made by laminating or coating combinations of purchased plastics, foil and paper",
  },
  {
    code: "322220",
    title: "Bags, coated paper, made from purchased paper",
  },
  {
    code: "322220",
    title: "Bags, foil, made from purchased foil",
  },
  {
    code: "322220",
    title: "Bags, multiwall, made from purchased uncoated paper",
  },
  {
    code: "322220",
    title: "Bags, paper, uncoated, made from purchased paper",
  },
  {
    code: "322220",
    title: "Bags, uncoated paper, made from purchased paper",
  },
  {
    code: "322220",
    title: "Book paper made by coating purchased paper",
  },
  {
    code: "322220",
    title: "Book paper, coated, made from purchased paper",
  },
  {
    code: "322220",
    title:
      "Cardboard, laminated or surface coated, made from purchased paperboard",
  },
  {
    code: "322220",
    title:
      "Chipboard, laminated or surface coated, made from purchased paperboard",
  },
  {
    code: "322220",
    title: "Coated board made from purchased paperboard",
  },
  {
    code: "322220",
    title:
      "Coating purchased papers for nonpackaging applications (except photosensitive paper)",
  },
  {
    code: "322220",
    title: "Coating purchased papers for packaging applications",
  },
  {
    code: "322220",
    title: "Duct tape made from purchased materials",
  },
  {
    code: "322220",
    title:
      "Flexible packaging sheet materials made by coating or laminating purchased paper",
  },
  {
    code: "322220",
    title:
      "Flexible packaging sheet materials made by laminating purchased foil",
  },
  {
    code: "322220",
    title: "Foil bags made from purchased foil",
  },
  {
    code: "322220",
    title:
      "Foil sheet, laminating purchased foil sheets for packaging applications",
  },
  {
    code: "322220",
    title: "Gift wrap made from purchased materials",
  },
  {
    code: "322220",
    title: "Grocers' bags and sacks made from purchased uncoated paper",
  },
  {
    code: "322220",
    title: "Groundwood paper, coated, made from purchased paper",
  },
  {
    code: "322220",
    title:
      "Gummed paper products (e.g., labels, sheets, tapes) made from purchased paper",
  },
  {
    code: "322220",
    title: "Laminating foil for flexible packaging applications",
  },
  {
    code: "322220",
    title: "Laminating purchased foil sheets for nonpackaging applications",
  },
  {
    code: "322220",
    title: "Laminating purchased paperboard",
  },
  {
    code: "322220",
    title: "Laminating purchased papers for nonpackaging applications",
  },
  {
    code: "322220",
    title: "Laminating purchased papers for packaging applications",
  },
  {
    code: "322220",
    title:
      "Leatherboard (i.e., paperboard based) made from purchased paperboard",
  },
  {
    code: "322220",
    title: "Masking tape made from purchased paper",
  },
  {
    code: "322220",
    title: "Milk carton board stock made from purchased paperboard",
  },
  {
    code: "322220",
    title: "Paper bags, coated, made from purchased paper",
  },
  {
    code: "322220",
    title: "Paper bags, uncoated, made from purchased paper",
  },
  {
    code: "322220",
    title:
      "Paperboard, pasted, lined, laminated, or surface coated, made from purchased paperboard",
  },
  {
    code: "322220",
    title:
      "Pressure sensitive paper and tape (except medical) made from purchased materials",
  },
  {
    code: "322220",
    title: "Sacks, multiwall, made from purchased uncoated paper",
  },
  {
    code: "322220",
    title:
      "Slitting adhesive-type tapes other than medical types for the trade",
  },
  {
    code: "322220",
    title: "Surface coating purchased paperboard",
  },
  {
    code: "322220",
    title:
      "Tapes, pressure sensitive (e.g., cellophane, masking), gummed, made from purchased paper or other materials",
  },
  {
    code: "322220",
    title: "Wallpaper made from purchased papers or other materials",
  },
  {
    code: "322220",
    title:
      "Waxed paper for nonpackaging applications made from purchased paper",
  },
  {
    code: "322220",
    title: "Waxed paper for packaging applications made from purchased paper",
  },
  {
    code: "322230",
    title: "Bond paper made from purchased paper",
  },
  {
    code: "322230",
    title:
      "Cards, die-cut office supply (e.g., index, library, time recording), made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title: "Computer paper, die-cut, made from purchased paper",
  },
  {
    code: "322230",
    title: "Construction paper, school and art, made from purchased paper",
  },
  {
    code: "322230",
    title:
      "Die-cut paper products for office use made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title: "Envelopes (i.e., mailing, stationery) made from any material",
  },
  {
    code: "322230",
    title:
      "File folders (e.g., accordion, expanding, hanging, manila) made from purchased paper and paperboard",
  },
  {
    code: "322230",
    title: "Letters, die-cut, made from purchased cardboard",
  },
  {
    code: "322230",
    title: "Looseleaf fillers and paper made from purchased paper",
  },
  {
    code: "322230",
    title: "Manila folders, die-cut, made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title:
      "Notebooks (including mechanically bound by wire, or plastics) made from purchased paper",
  },
  {
    code: "322230",
    title:
      "Office paper (e.g., computer printer, photocopy, plain paper), cut sheet, made from purchased paper",
  },
  {
    code: "322230",
    title:
      "Office supplies, die-cut paper, made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title: "Padded envelopes manufacturing",
  },
  {
    code: "322230",
    title: "Pads, desk, made from purchased paper",
  },
  {
    code: "322230",
    title:
      "Paper products, die-cut office supply, made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title: "Pocket folders made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title: "Report covers made from purchased paper or paperboard",
  },
  {
    code: "322230",
    title: "Seed packets made from purchased paper",
  },
  {
    code: "322230",
    title: "Stationery made from purchased paper",
  },
  {
    code: "322230",
    title: "Tablets (e.g., memo, note, writing) made from purchased paper",
  },
  {
    code: "322230",
    title:
      "Tapes (e.g., adding machine, calculator, cash register) made from purchased paper",
  },
  {
    code: "322230",
    title: "Writing paper and envelopes, boxed sets, made from purchased paper",
  },
  {
    code: "322230",
    title: "Writing paper, cut sheet, made from purchased paper",
  },
  {
    code: "322291",
    title: "Diapers, disposable, made from purchased paper or textile fiber",
  },
  {
    code: "322291",
    title: "Facial tissues made from purchased paper",
  },
  {
    code: "322291",
    title: "Handkerchiefs, paper, made from purchased paper",
  },
  {
    code: "322291",
    title: "Napkins, table, made from purchased paper",
  },
  {
    code: "322291",
    title: "Pads, incontinent and bed, manufacturing",
  },
  {
    code: "322291",
    title: "Paper napkins and tablecloths made from purchased paper",
  },
  {
    code: "322291",
    title: "Paper towels made from purchased paper",
  },
  {
    code: "322291",
    title:
      "Sanitary napkins and tampons made from purchased paper or textile fiber",
  },
  {
    code: "322291",
    title: "Sanitary products made from purchased sanitary paper stock",
  },
  {
    code: "322291",
    title: "Tablecloths, paper, made from purchased paper",
  },
  {
    code: "322291",
    title: "Toilet paper made from purchased paper",
  },
  {
    code: "322291",
    title: "Towels, paper, made from purchased paper",
  },
  {
    code: "322299",
    title:
      "Cards, die-cut (except office supply) made from purchased paper or paperboard",
  },
  {
    code: "322299",
    title: "Cartons, egg, molded pulp manufacturing",
  },
  {
    code: "322299",
    title: "Cigarette paper made from purchased paper",
  },
  {
    code: "322299",
    title: "Cigarette paper, book, made from purchased paper",
  },
  {
    code: "322299",
    title: "Coffee filters made from purchased paper",
  },
  {
    code: "322299",
    title: "Confetti made from purchased paper",
  },
  {
    code: "322299",
    title: "Crepe paper made from purchased paper",
  },
  {
    code: "322299",
    title: "Cups, molded pulp, manufacturing",
  },
  {
    code: "322299",
    title:
      "Die-cut paper products (except for office use) made from purchased paper or paperboard",
  },
  {
    code: "322299",
    title: "Doilies, paper, made from purchased paper",
  },
  {
    code: "322299",
    title: "Filters, paper, made from purchased paper",
  },
  {
    code: "322299",
    title: "Food containers made from molded pulp",
  },
  {
    code: "322299",
    title: "Food trays, molded pulp, manufacturing",
  },
  {
    code: "322299",
    title: "Glassine wrapping paper made from purchased paper",
  },
  {
    code: "322299",
    title: "Hats made from purchased paper",
  },
  {
    code: "322299",
    title: "Insulating batts, fills, or blankets made from purchased paper",
  },
  {
    code: "322299",
    title:
      "Molded pulp products (e.g., egg cartons, food containers, food trays) manufacturing",
  },
  {
    code: "322299",
    title: "Paper dishes (e.g., cups, plates) made from molded pulp",
  },
  {
    code: "322299",
    title: "Paper novelties made from purchased paper",
  },
  {
    code: "322299",
    title:
      "Paper products (except office supply), die-cut, made from purchased paper or paperboard",
  },
  {
    code: "322299",
    title: "Photograph folders, mats, and mounts manufacturing",
  },
  {
    code: "322299",
    title: "Plates, molded pulp, manufacturing",
  },
  {
    code: "322299",
    title: "Pulp products, molded, manufacturing",
  },
  {
    code: "322299",
    title: "Trays, food, molded pulp, manufacturing",
  },
  {
    code: "323111",
    title:
      "Address lists commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Advertising materials (e.g., coupons, flyers) commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Agricultural magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Albums (e.g., photo, scrap) and refills manufacturing",
  },
  {
    code: "323111",
    title: "Appointment books and refills manufacturing",
  },
  {
    code: "323111",
    title: "Art prints commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Atlases commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Blankbooks and refills manufacturing",
  },
  {
    code: "323111",
    title: "Books, sales, manifold, printing",
  },
  {
    code: "323111",
    title:
      "Business directories commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Business forms commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Business forms, manifold, printing",
  },
  {
    code: "323111",
    title: "Calendars commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Cards (e.g., business, greeting, playing, postcards, trading) commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Catalogs commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Catalogs of collections commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Checkbooks and refills printing",
  },
  {
    code: "323111",
    title: "Comic books commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Commercial digital printing (except books)",
  },
  {
    code: "323111",
    title: "Commercial engraving printing (except books)",
  },
  {
    code: "323111",
    title: "Commercial flexographic printing (except books)",
  },
  {
    code: "323111",
    title: "Commercial gravure printing (except books)",
  },
  {
    code: "323111",
    title: "Commercial letterpress printing (except books)",
  },
  {
    code: "323111",
    title: "Commercial lithographic (offset) printing (except books)",
  },
  {
    code: "323111",
    title: "Commercial printing (except screen, books)",
  },
  {
    code: "323111",
    title: "Commercial quick printing (except books)",
  },
  {
    code: "323111",
    title: "Computer forms (manifold or continuous) printing",
  },
  {
    code: "323111",
    title: "Credit and identification card imprinting, embossing, and encoding",
  },
  {
    code: "323111",
    title: "Databases commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Diaries manufacturing",
  },
  {
    code: "323111",
    title:
      "Digital printing (e.g., billboards, other large format graphic materials, high resolution) (except books)",
  },
  {
    code: "323111",
    title: "Directories commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Discount coupon books commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Financial magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Flexographic printing (except books, grey goods)",
  },
  {
    code: "323111",
    title:
      "Globe covers and maps commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Gravure printing (except books, grey goods)",
  },
  {
    code: "323111",
    title:
      "Greeting cards (e.g., birthday, holiday, sympathy) commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Guides, street map, commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Heat press printing apparel and textile products (e.g., caps, napkins, placemats, T-shirts, towels) (except grey goods and T-shirt shops)",
  },
  {
    code: "323111",
    title: "Hydrographic printing",
  },
  {
    code: "323111",
    title: "Instant printing (i.e., quick printing) (except books)",
  },
  {
    code: "323111",
    title: "Intaglio printing (except books)",
  },
  {
    code: "323111",
    title: "Job printing (except screen, books)",
  },
  {
    code: "323111",
    title: "Job printing, engraving (except books)",
  },
  {
    code: "323111",
    title: "Job printing, flexographic (except books)",
  },
  {
    code: "323111",
    title: "Job printing, gravure (except books)",
  },
  {
    code: "323111",
    title: "Job printing, letterpress (except books)",
  },
  {
    code: "323111",
    title: "Job printing, lithographic (except books)",
  },
  {
    code: "323111",
    title: "Job printing, offset (except books)",
  },
  {
    code: "323111",
    title:
      "Juvenile magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Labels, commercial printing (except screen), on a job-order basis",
  },
  {
    code: "323111",
    title: "Lithographic printing (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Looseleaf binders and devices manufacturing",
  },
  {
    code: "323111",
    title:
      "Magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Manifold business forms printing",
  },
  {
    code: "323111",
    title: "Maps commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Music, sheet, commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Newsletters commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Newspapers commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Offset printing (except books, grey goods)",
  },
  {
    code: "323111",
    title:
      "Patterns and plans (e.g., clothing patterns) commercial printing (except blueprinting, screen) without publishing",
  },
  {
    code: "323111",
    title: "Periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Photo albums and refills manufacturing",
  },
  {
    code: "323111",
    title: "Postcards commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Posters commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Print shops, digital (except printing books)",
  },
  {
    code: "323111",
    title: "Print shops, engraving (except printing books)",
  },
  {
    code: "323111",
    title: "Print shops, flexographic (except printing books)",
  },
  {
    code: "323111",
    title: "Print shops, gravure (except printing books)",
  },
  {
    code: "323111",
    title: "Print shops, letterpress (except printing books)",
  },
  {
    code: "323111",
    title: "Print shops, lithographic (offset) (except printing books)",
  },
  {
    code: "323111",
    title: "Print shops, quick (except printing books)",
  },
  {
    code: "323111",
    title: "Printing apparel (except screen printing)",
  },
  {
    code: "323111",
    title: "Printing manifold business forms",
  },
  {
    code: "323111",
    title:
      "Printing, digital (e.g., billboards, other large format graphical materials, high resolution) (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Printing, engraving, on paper products",
  },
  {
    code: "323111",
    title: "Printing, flexographic (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Printing, gravure (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Printing, letterpress (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Printing, lithographic (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Printing, photo-offset (except books, grey goods)",
  },
  {
    code: "323111",
    title: "Printing, quick (except books, grey goods)",
  },
  {
    code: "323111",
    title:
      "Professional magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Quick printing (except books)",
  },
  {
    code: "323111",
    title:
      "Racetrack programs commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Racing forms commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Radio guides commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Radio schedules commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Religious magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Rotogravure printing (except books)",
  },
  {
    code: "323111",
    title: "Sales books, manifold, printing",
  },
  {
    code: "323111",
    title:
      "Scholarly journals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Scholastic magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Scrapbooks and refills manufacturing",
  },
  {
    code: "323111",
    title: "Sheet music commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Shipping registers commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Stationery, commercial printing (except screen), on a job-order basis",
  },
  {
    code: "323111",
    title:
      "Technical magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Telephone directories commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Television guides commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Time planners/organizers and refills manufacturing",
  },
  {
    code: "323111",
    title:
      "Trade journals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title:
      "Trade magazines and periodicals commercial printing (except screen) without publishing",
  },
  {
    code: "323111",
    title: "Unit set forms (e.g., manifold credit card slips) printing",
  },
  {
    code: "323111",
    title: "Yearbooks commercial printing (except screen) without publishing",
  },
  {
    code: "323113",
    title: "Address lists screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Agricultural magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Art prints screen printing without publishing",
  },
  {
    code: "323113",
    title: "Atlases screen printing without publishing",
  },
  {
    code: "323113",
    title: "Business directories screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Business forms (except manifold) screen printing without publishing",
  },
  {
    code: "323113",
    title: "Calendars screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Cards (e.g., business, greeting, playing, postcards, trading) screen printing without publishing",
  },
  {
    code: "323113",
    title: "Catalogs of collections screen printing without publishing",
  },
  {
    code: "323113",
    title: "Catalogs screen printing without publishing",
  },
  {
    code: "323113",
    title: "Comic books screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Commercial screen printing (except books, manifold business forms, grey goods)",
  },
  {
    code: "323113",
    title: "Databases screen printing without publishing",
  },
  {
    code: "323113",
    title: "Directories screen printing without publishing",
  },
  {
    code: "323113",
    title: "Discount coupon books screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Financial magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Globe covers and maps screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Greeting cards (e.g., birthday, holiday, sympathy) screen printing without publishing",
  },
  {
    code: "323113",
    title: "Guides, street map, screen printing without publishing",
  },
  {
    code: "323113",
    title: "Job printing, screen",
  },
  {
    code: "323113",
    title:
      "Juvenile magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Maps screen printing without publishing",
  },
  {
    code: "323113",
    title: "Music, sheet, screen printing without publishing",
  },
  {
    code: "323113",
    title: "Newsletters screen printing without publishing",
  },
  {
    code: "323113",
    title: "Newspapers screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Patterns and plans (e.g., clothing patterns) screen printing without publishing",
  },
  {
    code: "323113",
    title: "Periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Postcards screen printing without publishing",
  },
  {
    code: "323113",
    title: "Posters screen printing without publishing",
  },
  {
    code: "323113",
    title: "Print shops, screen",
  },
  {
    code: "323113",
    title:
      "Printing, screen (except books, manifold business forms, grey goods)",
  },
  {
    code: "323113",
    title:
      "Professional magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Racetrack programs screen printing without publishing",
  },
  {
    code: "323113",
    title: "Racing forms screen printing without publishing",
  },
  {
    code: "323113",
    title: "Radio guides screen printing without publishing",
  },
  {
    code: "323113",
    title: "Radio schedules screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Religious magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Scholarly journals screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Scholastic magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title:
      "Screen printing (except books, manifold business forms, grey goods)",
  },
  {
    code: "323113",
    title:
      "Screen printing apparel and textile products (e.g., caps, napkins, placemats, T-shirts, towels) (except grey goods and T-shirt shops)",
  },
  {
    code: "323113",
    title: "Screen printing textile banners",
  },
  {
    code: "323113",
    title: "Sheet music screen printing without publishing",
  },
  {
    code: "323113",
    title: "Shipping registers screen printing without publishing",
  },
  {
    code: "323113",
    title: "Stationery, screen printing, on a job-order basis",
  },
  {
    code: "323113",
    title:
      "Technical magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Telephone directories screen printing without publishing",
  },
  {
    code: "323113",
    title: "Television guides screen printing without publishing",
  },
  {
    code: "323113",
    title: "Trade journals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Trade magazines and periodicals screen printing without publishing",
  },
  {
    code: "323113",
    title: "Yearbooks screen printing without publishing",
  },
  {
    code: "323117",
    title: "Almanacs printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Almanacs printing without publishing",
  },
  {
    code: "323117",
    title: "Books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Books printing without publishing",
  },
  {
    code: "323117",
    title: "Dictionaries printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Dictionaries printing without publishing",
  },
  {
    code: "323117",
    title: "Encyclopedias printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Encyclopedias printing without publishing",
  },
  {
    code: "323117",
    title: "Fiction books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Fiction books printing without publishing",
  },
  {
    code: "323117",
    title: "Music books printing or printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Nonfiction books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Nonfiction books printing without publishing",
  },
  {
    code: "323117",
    title: "Pamphlets printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Pamphlets printing without publishing",
  },
  {
    code: "323117",
    title: "Printing and binding books without publishing",
  },
  {
    code: "323117",
    title: "Printing books without publishing",
  },
  {
    code: "323117",
    title: "Professional books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Professional books printing without publishing",
  },
  {
    code: "323117",
    title: "Religious books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Religious books printing without publishing",
  },
  {
    code: "323117",
    title: "School books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "School books printing without publishing",
  },
  {
    code: "323117",
    title:
      "Technical manuals and papers (books) printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Technical manuals and papers (books) printing without publishing",
  },
  {
    code: "323117",
    title: "Textbooks printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Textbooks printing without publishing",
  },
  {
    code: "323117",
    title: "Travel guide books printing and binding without publishing",
  },
  {
    code: "323117",
    title: "Travel guide books printing without publishing",
  },
  {
    code: "323120",
    title: "Almanac binding without printing",
  },
  {
    code: "323120",
    title: "Bookbinding shops",
  },
  {
    code: "323120",
    title: "Bookbinding without printing",
  },
  {
    code: "323120",
    title: "Color separation services, for the printing trade",
  },
  {
    code: "323120",
    title: "Dictionary binding without printing",
  },
  {
    code: "323120",
    title: "Electronic prepress services for the printing trade",
  },
  {
    code: "323120",
    title: "Electrotype plate preparation services",
  },
  {
    code: "323120",
    title: "Embossing plate preparation services",
  },
  {
    code: "323120",
    title: "Encyclopedia binding without printing",
  },
  {
    code: "323120",
    title: "Engraving printing plate, for the printing trade",
  },
  {
    code: "323120",
    title: "Fiction bookbinding without printing",
  },
  {
    code: "323120",
    title: "Flexographic plate preparation services",
  },
  {
    code: "323120",
    title: "Gold stamping books for the trade",
  },
  {
    code: "323120",
    title: "Gravure plate and cylinder preparation services",
  },
  {
    code: "323120",
    title: "Imagesetting services, prepress",
  },
  {
    code: "323120",
    title: "Letterpress plate preparation services",
  },
  {
    code: "323120",
    title: "Lithographic plate preparation services",
  },
  {
    code: "323120",
    title: "Nonfiction bookbinding without printing",
  },
  {
    code: "323120",
    title: "Offset plate preparation services",
  },
  {
    code: "323120",
    title: "Pamphlet binding without printing",
  },
  {
    code: "323120",
    title: "Photocomposition services, for the printing trade",
  },
  {
    code: "323120",
    title: "Photoengraving plate preparation services",
  },
  {
    code: "323120",
    title: "Phototypesetting services",
  },
  {
    code: "323120",
    title:
      "Postpress services (e.g., beveling, bronzing, folding, gluing, edging, foil stamping, gilding) on printed materials",
  },
  {
    code: "323120",
    title:
      "Prepress printing services (e.g., color separation, imagesetting, photocomposition, typesetting)",
  },
  {
    code: "323120",
    title: "Printing plate preparation services",
  },
  {
    code: "323120",
    title:
      "Printing postpress services (e.g., beveling, bronzing, folding, gluing, edging, foil stamping) to printed products (e.g., books, cards, paper)",
  },
  {
    code: "323120",
    title:
      "Printing prepress services (e.g., color separation, imagesetting, photocomposition, typesetting)",
  },
  {
    code: "323120",
    title: "Professional bookbinding without printing",
  },
  {
    code: "323120",
    title: "Rebinding books, magazines, or pamphlets",
  },
  {
    code: "323120",
    title: "Religious bookbinding without printing",
  },
  {
    code: "323120",
    title: "Repairing books",
  },
  {
    code: "323120",
    title: "Rotogravure printing plates and cylinders preparation services",
  },
  {
    code: "323120",
    title: "Samples mounting",
  },
  {
    code: "323120",
    title: "School textbooks binding without printing",
  },
  {
    code: "323120",
    title: "Screen for printing, preparation services",
  },
  {
    code: "323120",
    title: "Swatches and samples, mounting for the trade",
  },
  {
    code: "323120",
    title: "Technical manual paper (books) binding without printing",
  },
  {
    code: "323120",
    title: "Trade binding services",
  },
  {
    code: "323120",
    title: "Typesetting (i.e., computer controlled, hand, machine)",
  },
  {
    code: "324110",
    title: "Acid oils made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Aliphatic chemicals (i.e., acyclic) made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Alkylates made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Asphalt and asphaltic materials made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Asphalt paving mixtures made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Aviation fuels manufacturing",
  },
  {
    code: "324110",
    title: "Benzene made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Biodiesel fuels made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Butylene (i.e., butene) made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Coke, petroleum, made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Crude oil refining",
  },
  {
    code: "324110",
    title: "Crude petroleum refineries",
  },
  {
    code: "324110",
    title: "Cumene made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Cyclic aromatic hydrocarbons made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Diesel fuels made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Ethylene made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Fuel oils manufacturing",
  },
  {
    code: "324110",
    title: "Fuels, jet, manufacturing",
  },
  {
    code: "324110",
    title: "Gasoline made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Heating oils made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Hydraulic fluids made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Jet fuels manufacturing",
  },
  {
    code: "324110",
    title: "Kerosene manufacturing",
  },
  {
    code: "324110",
    title: "Liquefied petroleum gas (LPG) made in refineries",
  },
  {
    code: "324110",
    title: "Lubricating oils and greases made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Naphtha made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Naphthenic acids made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Oil (i.e., petroleum) refineries",
  },
  {
    code: "324110",
    title: "Oil additives made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Oils, fuel, manufacturing",
  },
  {
    code: "324110",
    title: "Paraffin waxes made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Petrochemical feedstocks made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Petrochemicals made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Petroleum coke made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Petroleum cracking and reforming",
  },
  {
    code: "324110",
    title: "Petroleum distillation",
  },
  {
    code: "324110",
    title: "Petroleum jelly made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Petroleum lubricating oils made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Petroleum refineries",
  },
  {
    code: "324110",
    title: "Propane gases made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Propylene (i.e., propene) made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Refineries, petroleum",
  },
  {
    code: "324110",
    title: "Refinery gases made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Road oils made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Solvents made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Still gases made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Styrene made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Tar made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Toluene made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Waxes, petroleum, made in petroleum refineries",
  },
  {
    code: "324110",
    title: "Xylene made in petroleum refineries",
  },
  {
    code: "324121",
    title: "Asphalt paving blocks made from purchased asphaltic materials",
  },
  {
    code: "324121",
    title: "Asphalt paving mixtures made from purchased asphaltic materials",
  },
  {
    code: "324121",
    title: "Asphalt road compounds made from purchased asphaltic materials",
  },
  {
    code: "324121",
    title: "Blocks, asphalt paving, made from purchased asphaltic materials",
  },
  {
    code: "324121",
    title: "Coal tar paving materials made from purchased coal tar",
  },
  {
    code: "324121",
    title: "Paving blocks and mixtures made from purchased asphaltic materials",
  },
  {
    code: "324121",
    title:
      "Tar and asphalt paving mixtures made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Asphalt roofing cements made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Asphalt roofing coatings made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Asphalt saturated boards made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title:
      "Asphalt saturated mats and felts made from purchased asphaltic materials and paper",
  },
  {
    code: "324122",
    title: "Asphalt shingles made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Boards, asphalt saturated, made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Cements, asphalt roofing, made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Coating compounds, tar, made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Pitch, roofing, made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Roofing cements, asphalt, made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Roofing coatings made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Roofing felts made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Saturated felts made from purchased paper",
  },
  {
    code: "324122",
    title: "Sheathing, asphalt saturated, made from refined petroleum",
  },
  {
    code: "324122",
    title: "Shingles made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Siding made from purchased asphaltic materials",
  },
  {
    code: "324122",
    title: "Tar paper made from purchased asphaltic materials and paper",
  },
  {
    code: "324122",
    title: "Tar paper, building and roofing, made from purchased paper",
  },
  {
    code: "324122",
    title:
      "Tar roofing cements and coatings made from purchased asphaltic materials",
  },
  {
    code: "324191",
    title: "Brake fluids, petroleum, made from refined petroleum",
  },
  {
    code: "324191",
    title: "Cutting oils made from refined petroleum",
  },
  {
    code: "324191",
    title: "Greases, petroleum lubricating, made from refined petroleum",
  },
  {
    code: "324191",
    title: "Grinding oils, petroleum, made from refined petroleum",
  },
  {
    code: "324191",
    title: "Hydraulic fluids, petroleum, made from refined petroleum",
  },
  {
    code: "324191",
    title:
      "Lubricating oils and greases, petroleum, made from refined petroleum",
  },
  {
    code: "324191",
    title: "Motor oils, petroleum, made from refined petroleum",
  },
  {
    code: "324191",
    title: "Oils, lubricating petroleum, made from refined petroleum",
  },
  {
    code: "324191",
    title: "Oils, petroleum lubricating, re-refining used",
  },
  {
    code: "324191",
    title: "Petroleum lubricating oils made from refined petroleum",
  },
  {
    code: "324191",
    title: "Re-refining used petroleum lubricating oils",
  },
  {
    code: "324191",
    title: "Rust arresting petroleum compounds made from refined petroleum",
  },
  {
    code: "324191",
    title: "Transmission fluids, petroleum, made from refined petroleum",
  },
  {
    code: "324199",
    title:
      "Biodiesel fuels not made in petroleum refineries and blended with purchased refined petroleum",
  },
  {
    code: "324199",
    title:
      "Biofuels not made in petroleum refineries and blended with purchased refined petroleum",
  },
  {
    code: "324199",
    title: "Boulets (i.e., fuel bricks) made from refined petroleum",
  },
  {
    code: "324199",
    title: "Briquettes, petroleum, made from refined petroleum",
  },
  {
    code: "324199",
    title: "Calcining petroleum coke from refined petroleum",
  },
  {
    code: "324199",
    title:
      "Coke oven products (e.g., coke, gases, tars) made in coke oven establishments",
  },
  {
    code: "324199",
    title: "Fuel briquettes or boulets made from refined petroleum",
  },
  {
    code: "324199",
    title: "Oil-based additives made from refined petroleum",
  },
  {
    code: "324199",
    title: "Petroleum jelly made from refined petroleum",
  },
  {
    code: "324199",
    title: "Petroleum waxes made from refined petroleum",
  },
  {
    code: "324199",
    title: "Road oils made from refined petroleum",
  },
  {
    code: "324199",
    title: "Waxes, petroleum, made from refined petroleum",
  },
  {
    code: "325110",
    title:
      "Acyclic hydrocarbons (e.g., butene, ethylene, propene) (except acetylene) made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title:
      "Aliphatic (e.g., hydrocarbons) (except acetylene) made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title:
      "Aromatic petrochemicals made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Benzene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Butadiene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Butane made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Butylene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Cumene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title:
      "Cyclic aromatic hydrocarbons made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Dodecene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Ethane made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Ethylbenzene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Ethylene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Heptanes made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Heptenes made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Isobutane made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Isobutene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Isoprene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Nonene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Olefins made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Paraffins made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Pentanes made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Pentenes made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Propylene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Styrene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Toluene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325110",
    title: "Xylene made from refined petroleum or liquid hydrocarbons",
  },
  {
    code: "325120",
    title: "Acetylene manufacturing",
  },
  {
    code: "325120",
    title: "Argon manufacturing",
  },
  {
    code: "325120",
    title:
      "Biogases, industrial (i.e., compressed, liquefied, solid), manufacturing",
  },
  {
    code: "325120",
    title: "Carbon dioxide manufacturing",
  },
  {
    code: "325120",
    title: "Chlorodifluoromethane manufacturing",
  },
  {
    code: "325120",
    title: "Chlorofluorocarbon (CFC) gases manufacturing",
  },
  {
    code: "325120",
    title: "Compressed and liquefied industrial gas manufacturing",
  },
  {
    code: "325120",
    title: "Dichlorodifluoromethane manufacturing",
  },
  {
    code: "325120",
    title: "Dry ice (i.e., solid carbon dioxide) manufacturing",
  },
  {
    code: "325120",
    title: "Fluorinated hydrocarbon gases manufacturing",
  },
  {
    code: "325120",
    title: "Fluorocarbon gases manufacturing",
  },
  {
    code: "325120",
    title:
      "Gases, industrial (i.e., compressed, liquefied, solid), manufacturing",
  },
  {
    code: "325120",
    title: "Helium manufacturing",
  },
  {
    code: "325120",
    title: "Helium recovery from natural gas",
  },
  {
    code: "325120",
    title: "Hydrochlorofluorocarbon (HCFC) gases manufacturing",
  },
  {
    code: "325120",
    title: "Hydrofluorocarbon (HFC) gases manufacturing",
  },
  {
    code: "325120",
    title: "Hydrogen manufacturing",
  },
  {
    code: "325120",
    title: "Ice, dry, manufacturing",
  },
  {
    code: "325120",
    title: "Industrial gases manufacturing",
  },
  {
    code: "325120",
    title: "Liquid air manufacturing",
  },
  {
    code: "325120",
    title: "Monochlorodifluoromethane manufacturing",
  },
  {
    code: "325120",
    title: "Neon manufacturing",
  },
  {
    code: "325120",
    title: "Nitrogen manufacturing",
  },
  {
    code: "325120",
    title: "Nitrous oxide manufacturing",
  },
  {
    code: "325120",
    title: "Oxygen manufacturing",
  },
  {
    code: "325130",
    title: "Acid dyes, synthetic organic, manufacturing",
  },
  {
    code: "325130",
    title: "Anthraquinone dyes manufacturing",
  },
  {
    code: "325130",
    title: "Antimony based pigments manufacturing",
  },
  {
    code: "325130",
    title: "Arsenic based pigments manufacturing",
  },
  {
    code: "325130",
    title: "Azine dyes manufacturing",
  },
  {
    code: "325130",
    title: "Azo dyes manufacturing",
  },
  {
    code: "325130",
    title: "Barytes based pigments manufacturing",
  },
  {
    code: "325130",
    title:
      "Black pigments (except carbon black, bone black, lamp black) manufacturing",
  },
  {
    code: "325130",
    title: "Blanc fixe (i.e., barium sulfate, precipitated) manufacturing",
  },
  {
    code: "325130",
    title: "Ceramic colors manufacturing",
  },
  {
    code: "325130",
    title:
      "Chrome pigments (e.g., chrome green, chrome orange, chrome yellow) manufacturing",
  },
  {
    code: "325130",
    title:
      "Color pigments, inorganic (except bone black, carbon black, lamp black), manufacturing",
  },
  {
    code: "325130",
    title:
      "Color pigments, organic (except animal black, bone black), manufacturing",
  },
  {
    code: "325130",
    title: "Copper base pigments manufacturing",
  },
  {
    code: "325130",
    title: "Direct dyes manufacturing",
  },
  {
    code: "325130",
    title: "Disperse dyes manufacturing",
  },
  {
    code: "325130",
    title: "Dyes, inorganic, manufacturing",
  },
  {
    code: "325130",
    title: "Dyes, synthetic organic, manufacturing",
  },
  {
    code: "325130",
    title: "Eosin dyes manufacturing",
  },
  {
    code: "325130",
    title: "Ferric oxide pigments manufacturing",
  },
  {
    code: "325130",
    title: "Fluorescent dyes manufacturing",
  },
  {
    code: "325130",
    title: "Food coloring, synthetic, manufacturing",
  },
  {
    code: "325130",
    title:
      "Inorganic pigments (except bone black, carbon black, lamp black) manufacturing",
  },
  {
    code: "325130",
    title: "Iron based pigments manufacturing",
  },
  {
    code: "325130",
    title: "Lakes (i.e., organic pigments) manufacturing",
  },
  {
    code: "325130",
    title: "Lead based pigments manufacturing",
  },
  {
    code: "325130",
    title: "Lead pigments manufacturing",
  },
  {
    code: "325130",
    title: "Litharge manufacturing",
  },
  {
    code: "325130",
    title: "Lithopone manufacturing",
  },
  {
    code: "325130",
    title: "Metallic pigments, inorganic, manufacturing",
  },
  {
    code: "325130",
    title: "Methyl violet toners manufacturing",
  },
  {
    code: "325130",
    title: "Mineral colors and pigments manufacturing",
  },
  {
    code: "325130",
    title: "Mordant dyes manufacturing",
  },
  {
    code: "325130",
    title: "Nitroso dyes manufacturing",
  },
  {
    code: "325130",
    title: "Ocher pigments manufacturing",
  },
  {
    code: "325130",
    title: "Organic pigments, dyes, lakes, and toners manufacturing",
  },
  {
    code: "325130",
    title: "Pararosaniline dyes manufacturing",
  },
  {
    code: "325130",
    title: "Peacock blue lake manufacturing",
  },
  {
    code: "325130",
    title: "Pearl essence pigment, synthetic, manufacturing",
  },
  {
    code: "325130",
    title: "Persian orange lake manufacturing",
  },
  {
    code: "325130",
    title: "Phosphomolybdic acid lakes and toners manufacturing",
  },
  {
    code: "325130",
    title: "Phosphotungstic acid lakes and toners manufacturing",
  },
  {
    code: "325130",
    title: "Phthalocyanine pigments manufacturing",
  },
  {
    code: "325130",
    title: "Pigment, scarlet lake, manufacturing",
  },
  {
    code: "325130",
    title: "Pigments (except animal black, bone black), organic, manufacturing",
  },
  {
    code: "325130",
    title:
      "Pigments (except bone black, carbon black, lamp black), inorganic, manufacturing",
  },
  {
    code: "325130",
    title: "Prussian blue pigments manufacturing",
  },
  {
    code: "325130",
    title: "Satin white pigments manufacturing",
  },
  {
    code: "325130",
    title: "Scarlet 2 R lake manufacturing",
  },
  {
    code: "325130",
    title: "Sienna pigment manufacturing",
  },
  {
    code: "325130",
    title: "Solvent dyes manufacturing",
  },
  {
    code: "325130",
    title: "Stains, biological, manufacturing",
  },
  {
    code: "325130",
    title: "Stilbene dyes manufacturing",
  },
  {
    code: "325130",
    title: "Titanium based pigments manufacturing",
  },
  {
    code: "325130",
    title: "Toners (except electrostatic, photographic) manufacturing",
  },
  {
    code: "325130",
    title: "Ultramarine pigments manufacturing",
  },
  {
    code: "325130",
    title: "Umber manufacturing",
  },
  {
    code: "325130",
    title: "Vat dyes, synthetic, manufacturing",
  },
  {
    code: "325130",
    title: "Vermilion pigments manufacturing",
  },
  {
    code: "325130",
    title:
      "White extender pigments (e.g., barytes, blanc fixe, whiting) manufacturing",
  },
  {
    code: "325130",
    title: "Whiting manufacturing",
  },
  {
    code: "325130",
    title: "Zinc based pigments manufacturing",
  },
  {
    code: "325180",
    title: "Alkalies manufacturing",
  },
  {
    code: "325180",
    title: "Aluminum chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Aluminum compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Aluminum hydroxide (i.e., alumina trihydrate) manufacturing",
  },
  {
    code: "325180",
    title: "Aluminum sulfate manufacturing",
  },
  {
    code: "325180",
    title:
      "Alums (e.g., aluminum ammonium sulfate, aluminum potassium sulfate) manufacturing",
  },
  {
    code: "325180",
    title: "Ammonium chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Ammonium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Ammonium hydroxide manufacturing",
  },
  {
    code: "325180",
    title: "Ammonium molybdate manufacturing",
  },
  {
    code: "325180",
    title: "Ammonium perchlorate manufacturing",
  },
  {
    code: "325180",
    title: "Ammonium thiosulfate manufacturing",
  },
  {
    code: "325180",
    title: "Animal black manufacturing",
  },
  {
    code: "325180",
    title: "Antimony oxide (except pigments) manufacturing",
  },
  {
    code: "325180",
    title: "Arsenates (except insecticides) manufacturing",
  },
  {
    code: "325180",
    title:
      "Arsenic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Arsenites (except insecticides) manufacturing",
  },
  {
    code: "325180",
    title:
      "Barium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Barium hydroxide manufacturing",
  },
  {
    code: "325180",
    title: "Beryllium oxide manufacturing",
  },
  {
    code: "325180",
    title: "Bleaching agents, inorganic, manufacturing",
  },
  {
    code: "325180",
    title: "Bone black manufacturing",
  },
  {
    code: "325180",
    title: "Borax (i.e., sodium borate) manufacturing",
  },
  {
    code: "325180",
    title: "Boric acid manufacturing",
  },
  {
    code: "325180",
    title: "Boron compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Borosilicate manufacturing",
  },
  {
    code: "325180",
    title: "Bromine manufacturing",
  },
  {
    code: "325180",
    title: "Calcium carbide, chloride, and hypochlorite manufacturing",
  },
  {
    code: "325180",
    title: "Calcium hypochlorite manufacturing",
  },
  {
    code: "325180",
    title:
      "Calcium inorganic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Carbides (e.g., boron, calcium, silicon, tungsten) manufacturing",
  },
  {
    code: "325180",
    title: "Carbon black manufacturing",
  },
  {
    code: "325180",
    title: "Carbon disulfide manufacturing",
  },
  {
    code: "325180",
    title: "Carbon inorganic compounds manufacturing",
  },
  {
    code: "325180",
    title: "Carbonic acid manufacturing",
  },
  {
    code: "325180",
    title: "Caustic potash manufacturing",
  },
  {
    code: "325180",
    title: "Caustic soda (i.e., sodium hydroxide) manufacturing",
  },
  {
    code: "325180",
    title: "Cerium salts manufacturing",
  },
  {
    code: "325180",
    title:
      "Cesium and cesium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Channel black manufacturing",
  },
  {
    code: "325180",
    title: "Chloride of lime manufacturing",
  },
  {
    code: "325180",
    title:
      "Chlorine compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Chlorine dioxide manufacturing",
  },
  {
    code: "325180",
    title: "Chlorine manufacturing",
  },
  {
    code: "325180",
    title: "Chlorosulfonic acid manufacturing",
  },
  {
    code: "325180",
    title: "Chromic acid manufacturing",
  },
  {
    code: "325180",
    title:
      "Chromium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Chromium oxide manufacturing",
  },
  {
    code: "325180",
    title: "Chromium salts manufacturing",
  },
  {
    code: "325180",
    title: "Cobalt 60 (i.e., radioactive cobalt) manufacturing",
  },
  {
    code: "325180",
    title: "Cobalt chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Cobalt compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Cobalt sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Copper chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Copper compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Copper iodide manufacturing",
  },
  {
    code: "325180",
    title: "Copper sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Cyanides manufacturing",
  },
  {
    code: "325180",
    title: "Deuterium oxide (i.e., heavy water) manufacturing",
  },
  {
    code: "325180",
    title: "Dichromates manufacturing",
  },
  {
    code: "325180",
    title: "Ferric chloride manufacturing",
  },
  {
    code: "325180",
    title: "Ferric oxide manufacturing",
  },
  {
    code: "325180",
    title: "Ferrocyanides manufacturing",
  },
  {
    code: "325180",
    title: "Fluoboric acid manufacturing",
  },
  {
    code: "325180",
    title: "Fluorine manufacturing",
  },
  {
    code: "325180",
    title:
      "Fuel propellants, solid inorganic, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Furnace black manufacturing",
  },
  {
    code: "325180",
    title: "Glauber's salt manufacturing",
  },
  {
    code: "325180",
    title: "Heavy water (i.e., deuterium oxide) manufacturing",
  },
  {
    code: "325180",
    title: "Hydrazine manufacturing",
  },
  {
    code: "325180",
    title: "Hydrochloric acid manufacturing",
  },
  {
    code: "325180",
    title: "Hydrocyanic acid manufacturing",
  },
  {
    code: "325180",
    title: "Hydrofluoric acid manufacturing",
  },
  {
    code: "325180",
    title: "Hydrofluosilicic acid manufacturing",
  },
  {
    code: "325180",
    title: "Hydrogen peroxide manufacturing",
  },
  {
    code: "325180",
    title: "Hydrogen sulfide manufacturing",
  },
  {
    code: "325180",
    title: "Hydrosulfites manufacturing",
  },
  {
    code: "325180",
    title: "Hypochlorites manufacturing",
  },
  {
    code: "325180",
    title: "Hypophosphites manufacturing",
  },
  {
    code: "325180",
    title: "Indium chloride manufacturing",
  },
  {
    code: "325180",
    title: "Iodides manufacturing",
  },
  {
    code: "325180",
    title: "Iodine, crude or resublimed, manufacturing",
  },
  {
    code: "325180",
    title: "Iron compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Iron sulphate manufacturing",
  },
  {
    code: "325180",
    title: "Lamp black manufacturing",
  },
  {
    code: "325180",
    title: "Lead oxides (except pigments) manufacturing",
  },
  {
    code: "325180",
    title: "Lead silicate manufacturing",
  },
  {
    code: "325180",
    title:
      "Lithium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Magnesium carbonate manufacturing",
  },
  {
    code: "325180",
    title: "Magnesium chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Magnesium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Manganese dioxide manufacturing",
  },
  {
    code: "325180",
    title: "Mercury chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Mercury compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Mercury oxide manufacturing",
  },
  {
    code: "325180",
    title: "Nickel ammonium sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Nickel carbonate manufacturing",
  },
  {
    code: "325180",
    title:
      "Nickel compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Nickel sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Nuclear fuel scrap reprocessing",
  },
  {
    code: "325180",
    title: "Nuclear fuels, inorganic, manufacturing",
  },
  {
    code: "325180",
    title: "Oleum (i.e., fuming sulfuric acid) manufacturing",
  },
  {
    code: "325180",
    title: "Perchloric acid manufacturing",
  },
  {
    code: "325180",
    title: "Peroxides, inorganic, manufacturing",
  },
  {
    code: "325180",
    title:
      "Phosphorus compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Phosphorus oxychloride manufacturing",
  },
  {
    code: "325180",
    title: "Potassium aluminum sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Potassium bichromate and chromate manufacturing",
  },
  {
    code: "325180",
    title: "Potassium bromide manufacturing",
  },
  {
    code: "325180",
    title: "Potassium carbonate manufacturing",
  },
  {
    code: "325180",
    title: "Potassium chlorate manufacturing",
  },
  {
    code: "325180",
    title: "Potassium chloride manufacturing",
  },
  {
    code: "325180",
    title: "Potassium cyanide manufacturing",
  },
  {
    code: "325180",
    title: "Potassium hydroxide (i.e., caustic potash) manufacturing",
  },
  {
    code: "325180",
    title: "Potassium hypochlorate manufacturing",
  },
  {
    code: "325180",
    title:
      "Potassium inorganic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Potassium iodide manufacturing",
  },
  {
    code: "325180",
    title: "Potassium nitrate manufacturing",
  },
  {
    code: "325180",
    title: "Potassium permanganate manufacturing",
  },
  {
    code: "325180",
    title: "Potassium salts manufacturing",
  },
  {
    code: "325180",
    title: "Potassium sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Radioactive elements manufacturing",
  },
  {
    code: "325180",
    title: "Radioactive isotopes manufacturing",
  },
  {
    code: "325180",
    title: "Radium chloride manufacturing",
  },
  {
    code: "325180",
    title: "Radium luminous compounds manufacturing",
  },
  {
    code: "325180",
    title:
      "Rare earth compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Rare earth salts manufacturing",
  },
  {
    code: "325180",
    title: "Sal soda (i.e., washing soda) manufacturing",
  },
  {
    code: "325180",
    title:
      "Selenium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Selenium dioxide manufacturing",
  },
  {
    code: "325180",
    title: "Silica gel manufacturing",
  },
  {
    code: "325180",
    title: "Silica, amorphous, manufacturing",
  },
  {
    code: "325180",
    title: "Silicofluorides manufacturing",
  },
  {
    code: "325180",
    title: "Silver bromide manufacturing",
  },
  {
    code: "325180",
    title: "Silver chloride manufacturing",
  },
  {
    code: "325180",
    title:
      "Silver compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Silver nitrate manufacturing",
  },
  {
    code: "325180",
    title: "Soda ash manufacturing",
  },
  {
    code: "325180",
    title: "Sodium aluminate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium aluminum sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium antimoniate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium arsenite (except insecticides) manufacturing",
  },
  {
    code: "325180",
    title: "Sodium bicarbonate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium bichromate and chromate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium borate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium borohydride manufacturing",
  },
  {
    code: "325180",
    title: "Sodium bromide manufacturing",
  },
  {
    code: "325180",
    title: "Sodium carbonate (i.e., soda ash) manufacturing",
  },
  {
    code: "325180",
    title: "Sodium chlorate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium cyanide manufacturing",
  },
  {
    code: "325180",
    title: "Sodium hydrosulfite manufacturing",
  },
  {
    code: "325180",
    title: "Sodium hydroxide (i.e., caustic soda) manufacturing",
  },
  {
    code: "325180",
    title: "Sodium hypochlorite manufacturing",
  },
  {
    code: "325180",
    title:
      "Sodium inorganic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Sodium molybdate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium perborate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium peroxide manufacturing",
  },
  {
    code: "325180",
    title: "Sodium phosphate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium polyphosphate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium silicate (i.e., water glass) manufacturing",
  },
  {
    code: "325180",
    title: "Sodium silicofluoride manufacturing",
  },
  {
    code: "325180",
    title: "Sodium stannate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium sulfate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium tetraborate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium thiosulfate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium tungstate manufacturing",
  },
  {
    code: "325180",
    title: "Sodium uranate manufacturing",
  },
  {
    code: "325180",
    title:
      "Solid fuel propellants, inorganic, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Stannic and stannous chloride manufacturing",
  },
  {
    code: "325180",
    title: "Strontium carbonate manufacturing",
  },
  {
    code: "325180",
    title:
      "Strontium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Strontium nitrate manufacturing",
  },
  {
    code: "325180",
    title: "Sulfides and sulfites manufacturing",
  },
  {
    code: "325180",
    title: "Sulfocyanides manufacturing",
  },
  {
    code: "325180",
    title:
      "Sulfur and sulfur compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Sulfur chloride manufacturing",
  },
  {
    code: "325180",
    title: "Sulfur dioxide manufacturing",
  },
  {
    code: "325180",
    title: "Sulfur hexafluoride gas manufacturing",
  },
  {
    code: "325180",
    title: "Sulfur recovering or refining (except from sour natural gas)",
  },
  {
    code: "325180",
    title: "Sulfuric acid manufacturing",
  },
  {
    code: "325180",
    title: "Tanning agents, inorganic, manufacturing",
  },
  {
    code: "325180",
    title: "Thiocyanate manufacturing",
  },
  {
    code: "325180",
    title: "Tin chloride manufacturing",
  },
  {
    code: "325180",
    title: "Tin compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Tin oxide manufacturing",
  },
  {
    code: "325180",
    title: "Tin salts manufacturing",
  },
  {
    code: "325180",
    title: "Titanium dioxide manufacturing",
  },
  {
    code: "325180",
    title:
      "Tungstates (e.g., ammonium tungstate, sodium tungstate) manufacturing",
  },
  {
    code: "325180",
    title:
      "Tungsten compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title:
      "Uranium compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Uranium oxide manufacturing",
  },
  {
    code: "325180",
    title: "Uranium, enriched, manufacturing",
  },
  {
    code: "325180",
    title: "Zinc ammonium chloride manufacturing",
  },
  {
    code: "325180",
    title: "Zinc chloride manufacturing",
  },
  {
    code: "325180",
    title: "Zinc compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325180",
    title: "Zinc hydrosulfite (i.e., zinc dithionite) manufacturing",
  },
  {
    code: "325180",
    title: "Zinc oxide (except pigments) manufacturing",
  },
  {
    code: "325180",
    title: "Zinc sulfide manufacturing",
  },
  {
    code: "325193",
    title: "Denatured alcohol manufacturing",
  },
  {
    code: "325193",
    title: "Ethanol, nonpotable, manufacturing",
  },
  {
    code: "325193",
    title: "Ethyl alcohol, nonpotable, manufacturing",
  },
  {
    code: "325193",
    title: "Grain alcohol, nonpotable, manufacturing",
  },
  {
    code: "325194",
    title: "Acetate of lime, natural, made by distillation of wood",
  },
  {
    code: "325194",
    title: "Acetone, natural, manufacturing",
  },
  {
    code: "325194",
    title: "Aminoanthraquinone manufacturing",
  },
  {
    code: "325194",
    title: "Aminoazobenzene manufacturing",
  },
  {
    code: "325194",
    title: "Aminoazotoluene manufacturing",
  },
  {
    code: "325194",
    title: "Aminophenol manufacturing",
  },
  {
    code: "325194",
    title: "Aniline manufacturing",
  },
  {
    code: "325194",
    title: "Annatto extract manufacturing",
  },
  {
    code: "325194",
    title: "Anthracene manufacturing",
  },
  {
    code: "325194",
    title: "Azobenzene manufacturing",
  },
  {
    code: "325194",
    title: "Benzaldehyde manufacturing",
  },
  {
    code: "325194",
    title: "Benzoic acid manufacturing",
  },
  {
    code: "325194",
    title: "Brazilwood extract manufacturing",
  },
  {
    code: "325194",
    title: "Brewers' pitch made by distillation of wood",
  },
  {
    code: "325194",
    title: "Camphor, natural, manufacturing",
  },
  {
    code: "325194",
    title: "Charcoal (except activated) manufacturing",
  },
  {
    code: "325194",
    title: "Charcoal briquettes, wood, manufacturing",
  },
  {
    code: "325194",
    title: "Chestnut extract manufacturing",
  },
  {
    code: "325194",
    title: "Chlorobenzene manufacturing",
  },
  {
    code: "325194",
    title: "Chloronaphthalene manufacturing",
  },
  {
    code: "325194",
    title: "Chlorophenol manufacturing",
  },
  {
    code: "325194",
    title: "Chlorotoluene manufacturing",
  },
  {
    code: "325194",
    title: "Coal tar distillates manufacturing",
  },
  {
    code: "325194",
    title: "Creosote made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Creosote made by distillation of wood tar",
  },
  {
    code: "325194",
    title: "Cresols made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Cresylic acids made from refined petroleum or natural gas",
  },
  {
    code: "325194",
    title: "Cyclic crudes made by distillation of coal tar",
  },
  {
    code: "325194",
    title:
      "Cyclic intermediates made from refined petroleum or natural gas (except aromatic petrochemicals)",
  },
  {
    code: "325194",
    title: "Cyclohexane manufacturing",
  },
  {
    code: "325194",
    title: "Cyclopentane made from refined petroleum or natural gas",
  },
  {
    code: "325194",
    title: "Cyclopropane made from refined petroleum or natural gas",
  },
  {
    code: "325194",
    title: "Cycloterpenes manufacturing",
  },
  {
    code: "325194",
    title: "Diethylcyclohexane manufacturing",
  },
  {
    code: "325194",
    title: "Diphenylamine manufacturing",
  },
  {
    code: "325194",
    title: "Distillates, wood, manufacturing",
  },
  {
    code: "325194",
    title: "Dragon's blood manufacturing",
  },
  {
    code: "325194",
    title: "Dyes, natural, manufacturing",
  },
  {
    code: "325194",
    title: "Ethyl acetate, natural, manufacturing",
  },
  {
    code: "325194",
    title: "Extracts, natural dyeing and tanning, manufacturing",
  },
  {
    code: "325194",
    title: "Fustic wood extract manufacturing",
  },
  {
    code: "325194",
    title: "Gambier extract manufacturing",
  },
  {
    code: "325194",
    title: "Gum and wood chemicals manufacturing",
  },
  {
    code: "325194",
    title: "Halogenated aromatic hydrocarbon derivatives manufacturing",
  },
  {
    code: "325194",
    title: "Hardwood distillates manufacturing",
  },
  {
    code: "325194",
    title: "Hemlock extract manufacturing",
  },
  {
    code: "325194",
    title: "Hydroquinone manufacturing",
  },
  {
    code: "325194",
    title: "Isocyanates manufacturing",
  },
  {
    code: "325194",
    title: "Logwood extract manufacturing",
  },
  {
    code: "325194",
    title: "Maleic anhydride manufacturing",
  },
  {
    code: "325194",
    title: "Mangrove extract manufacturing",
  },
  {
    code: "325194",
    title: "Methyl acetone manufacturing",
  },
  {
    code: "325194",
    title: "Methyl alcohol (methanol), natural, manufacturing",
  },
  {
    code: "325194",
    title: "Myrobalans extract manufacturing",
  },
  {
    code: "325194",
    title: "Naphtha made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Naphtha, solvent, made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Naphthalene made from refined petroleum or natural gas",
  },
  {
    code: "325194",
    title: "Naphthalenesulfonic acid manufacturing",
  },
  {
    code: "325194",
    title: "Naphthenic acids made from refined petroleum or natural gas",
  },
  {
    code: "325194",
    title: "Naphthol sulfonic acids manufacturing",
  },
  {
    code: "325194",
    title: "Naphthol, alpha and beta, manufacturing",
  },
  {
    code: "325194",
    title: "Naval stores, gum or wood, manufacturing",
  },
  {
    code: "325194",
    title: "Nitrated hydrocarbon derivatives manufacturing",
  },
  {
    code: "325194",
    title: "Nitroaniline manufacturing",
  },
  {
    code: "325194",
    title: "Nitrobenzene manufacturing",
  },
  {
    code: "325194",
    title: "Nitrophenol manufacturing",
  },
  {
    code: "325194",
    title: "Nitrosated hydrocarbon derivatives manufacturing",
  },
  {
    code: "325194",
    title: "Oak extract manufacturing",
  },
  {
    code: "325194",
    title: "Oils made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Oils, wood, made by distillation of wood",
  },
  {
    code: "325194",
    title: "Orthodichlorobenzene manufacturing",
  },
  {
    code: "325194",
    title: "Pentachlorophenol manufacturing",
  },
  {
    code: "325194",
    title: "Phenol manufacturing",
  },
  {
    code: "325194",
    title: "Phthalic anhydride manufacturing",
  },
  {
    code: "325194",
    title: "Pine oil manufacturing",
  },
  {
    code: "325194",
    title: "Pinene manufacturing",
  },
  {
    code: "325194",
    title: "Pitch made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Pitch, wood, manufacturing",
  },
  {
    code: "325194",
    title: "Pyroligneous acids manufacturing",
  },
  {
    code: "325194",
    title: "Quebracho extracts manufacturing",
  },
  {
    code: "325194",
    title: "Quercitron extracts manufacturing",
  },
  {
    code: "325194",
    title: "Resorcinol manufacturing",
  },
  {
    code: "325194",
    title: "Rosins made by distillation of pine gum or pine wood",
  },
  {
    code: "325194",
    title: "Softwood distillates manufacturing",
  },
  {
    code: "325194",
    title: "Sulfonated naphthalene manufacturing",
  },
  {
    code: "325194",
    title: "Sulphonated derivatives manufacturing",
  },
  {
    code: "325194",
    title: "Sumac extract manufacturing",
  },
  {
    code: "325194",
    title: "Tall oil (except skimmings) manufacturing",
  },
  {
    code: "325194",
    title: "Tannic acid (i.e., tannins) manufacturing",
  },
  {
    code: "325194",
    title: "Tanning extracts and materials, natural, manufacturing",
  },
  {
    code: "325194",
    title: "Tar and tar oils made by distillation of wood",
  },
  {
    code: "325194",
    title: "Tar made by distillation of coal tar",
  },
  {
    code: "325194",
    title: "Toluidines manufacturing",
  },
  {
    code: "325194",
    title: "Turpentine made by distillation of pine gum or pine wood",
  },
  {
    code: "325194",
    title: "Valonia extract manufacturing",
  },
  {
    code: "325194",
    title: "Wattle extract manufacturing",
  },
  {
    code: "325194",
    title: "Witch hazel extract manufacturing",
  },
  {
    code: "325194",
    title: "Wood alcohol, natural, manufacturing",
  },
  {
    code: "325194",
    title: "Wood distillates manufacturing",
  },
  {
    code: "325194",
    title: "Wood oils manufacturing",
  },
  {
    code: "325199",
    title: "Accelerators (i.e., basic synthetic chemical) manufacturing",
  },
  {
    code: "325199",
    title: "Acetaldehyde manufacturing",
  },
  {
    code: "325199",
    title: "Acetates, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Acetic acid manufacturing",
  },
  {
    code: "325199",
    title: "Acetic anhydride manufacturing",
  },
  {
    code: "325199",
    title: "Acetin manufacturing",
  },
  {
    code: "325199",
    title: "Acetone, synthetic, manufacturing",
  },
  {
    code: "325199",
    title: "Acid esters, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Acids, organic, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Acrolein manufacturing",
  },
  {
    code: "325199",
    title: "Acrylonitrile manufacturing",
  },
  {
    code: "325199",
    title: "Adipic acid esters or amines manufacturing",
  },
  {
    code: "325199",
    title: "Adipic acid manufacturing",
  },
  {
    code: "325199",
    title: "Adiponitrile manufacturing",
  },
  {
    code: "325199",
    title: "Aldehydes manufacturing",
  },
  {
    code: "325199",
    title: "Alginates (e.g., calcium, potassium, sodium) manufacturing",
  },
  {
    code: "325199",
    title: "Alginic acid manufacturing",
  },
  {
    code: "325199",
    title: "Amyl acetate manufacturing",
  },
  {
    code: "325199",
    title:
      "Biodiesel fuels not made in petroleum refineries and not blended with petroleum",
  },
  {
    code: "325199",
    title:
      "Biofuels not made in petroleum refineries and not blended with petroleum",
  },
  {
    code: "325199",
    title: "Bleaching agents, organic, manufacturing",
  },
  {
    code: "325199",
    title: "Bromochloromethane manufacturing",
  },
  {
    code: "325199",
    title: "Butadiene made from alcohol",
  },
  {
    code: "325199",
    title: "Butyl acetate manufacturing",
  },
  {
    code: "325199",
    title: "Calcium citrate manufacturing",
  },
  {
    code: "325199",
    title:
      "Calcium organic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Calcium oxalate manufacturing",
  },
  {
    code: "325199",
    title: "Camphor, synthetic, manufacturing",
  },
  {
    code: "325199",
    title: "Caprolactam manufacturing",
  },
  {
    code: "325199",
    title: "Carbinol manufacturing",
  },
  {
    code: "325199",
    title:
      "Carbon organic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Carbon tetrachloride manufacturing",
  },
  {
    code: "325199",
    title: "Cellulose acetate (except resins) manufacturing",
  },
  {
    code: "325199",
    title: "Cetyl alcohol manufacturing",
  },
  {
    code: "325199",
    title: "Chloral manufacturing",
  },
  {
    code: "325199",
    title: "Chloroacetic acid manufacturing",
  },
  {
    code: "325199",
    title: "Chloroform manufacturing",
  },
  {
    code: "325199",
    title: "Chloropicrin manufacturing",
  },
  {
    code: "325199",
    title: "Citral manufacturing",
  },
  {
    code: "325199",
    title: "Citrates, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Citric acid manufacturing",
  },
  {
    code: "325199",
    title: "Citronellal manufacturing",
  },
  {
    code: "325199",
    title: "Coumarin manufacturing",
  },
  {
    code: "325199",
    title: "Cream of tartar manufacturing",
  },
  {
    code: "325199",
    title: "Decahydronaphthalene manufacturing",
  },
  {
    code: "325199",
    title: "Diethylene glycol manufacturing",
  },
  {
    code: "325199",
    title:
      "Dimethyl divinyl acetylene (di-isopropenyl acetylene) manufacturing",
  },
  {
    code: "325199",
    title: "Dimethylhydrazine manufacturing",
  },
  {
    code: "325199",
    title:
      "Enzyme proteins (i.e., basic synthetic chemicals) (except pharmaceutical use) manufacturing",
  },
  {
    code: "325199",
    title: "Essential oils, synthetic, manufacturing",
  },
  {
    code: "325199",
    title: "Esters, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl acetate, synthetic, manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl butyrate manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl cellulose (except resins) manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl chloride manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl ether manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl formate manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl nitrite manufacturing",
  },
  {
    code: "325199",
    title: "Ethyl perhydrophenanthrene manufacturing",
  },
  {
    code: "325199",
    title: "Ethylene glycol ether manufacturing",
  },
  {
    code: "325199",
    title: "Ethylene glycol manufacturing",
  },
  {
    code: "325199",
    title: "Ethylene oxide manufacturing",
  },
  {
    code: "325199",
    title: "Fatty acid esters and amines manufacturing",
  },
  {
    code: "325199",
    title: "Fatty acids (e.g., margaric, oleic, stearic) manufacturing",
  },
  {
    code: "325199",
    title: "Fatty alcohols manufacturing",
  },
  {
    code: "325199",
    title:
      "Flavoring materials (i.e., basic synthetic chemicals such as coumarin) manufacturing",
  },
  {
    code: "325199",
    title: "Formaldehyde manufacturing",
  },
  {
    code: "325199",
    title: "Formalin manufacturing",
  },
  {
    code: "325199",
    title: "Formic acid manufacturing",
  },
  {
    code: "325199",
    title:
      "Fuel propellants, solid organic, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Geraniol manufacturing",
  },
  {
    code: "325199",
    title: "Glycerin (i.e., glycerol), synthetic, manufacturing",
  },
  {
    code: "325199",
    title:
      "Halogenated hydrocarbon derivatives (except aromatic) manufacturing",
  },
  {
    code: "325199",
    title:
      "Heterocyclic chemicals, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Hexadecanol manufacturing",
  },
  {
    code: "325199",
    title: "Hexamethylenediamine manufacturing",
  },
  {
    code: "325199",
    title: "Hexamethylenetetramine manufacturing",
  },
  {
    code: "325199",
    title: "Hexanol manufacturing",
  },
  {
    code: "325199",
    title: "Ionone manufacturing",
  },
  {
    code: "325199",
    title: "Isopropyl alcohol manufacturing",
  },
  {
    code: "325199",
    title:
      "Ketone compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Lactic acid manufacturing",
  },
  {
    code: "325199",
    title: "Lauric acid esters and amines manufacturing",
  },
  {
    code: "325199",
    title: "Linoleic acid esters and amines manufacturing",
  },
  {
    code: "325199",
    title: "Malonic dinitrile manufacturing",
  },
  {
    code: "325199",
    title: "Margaric acid manufacturing",
  },
  {
    code: "325199",
    title: "Metallic soap manufacturing",
  },
  {
    code: "325199",
    title: "Methyl alcohol (i.e., methanol), synthetic, manufacturing",
  },
  {
    code: "325199",
    title: "Methyl chloride manufacturing",
  },
  {
    code: "325199",
    title: "Methyl perhydrofluorine manufacturing",
  },
  {
    code: "325199",
    title: "Methyl salicylate manufacturing",
  },
  {
    code: "325199",
    title: "Methylamine manufacturing",
  },
  {
    code: "325199",
    title: "Methylene chloride manufacturing",
  },
  {
    code: "325199",
    title: "Monomethylparaminophenol sulfate manufacturing",
  },
  {
    code: "325199",
    title: "Monosodium glutamate manufacturing",
  },
  {
    code: "325199",
    title: "Naphthenic acid soaps manufacturing",
  },
  {
    code: "325199",
    title: "Natural nonfood coloring manufacturing",
  },
  {
    code: "325199",
    title: "Nitrous ether manufacturing",
  },
  {
    code: "325199",
    title: "Oleic acid (i.e., red oil) manufacturing",
  },
  {
    code: "325199",
    title: "Oleic acid esters manufacturing",
  },
  {
    code: "325199",
    title: "Organo-inorganic compound manufacturing",
  },
  {
    code: "325199",
    title:
      "Oxalates (e.g., ammonium oxalate, ethyl oxalate, sodium oxalate) manufacturing",
  },
  {
    code: "325199",
    title: "Oxalic acid manufacturing",
  },
  {
    code: "325199",
    title: "Palmitic acid esters and amines manufacturing",
  },
  {
    code: "325199",
    title: "Pentaerythritol manufacturing",
  },
  {
    code: "325199",
    title: "Perchloroethylene manufacturing",
  },
  {
    code: "325199",
    title:
      "Perfume materials (i.e., basic synthetic chemicals, such as terpineol) manufacturing",
  },
  {
    code: "325199",
    title: "Peroxides, organic, manufacturing",
  },
  {
    code: "325199",
    title: "Phosgene manufacturing",
  },
  {
    code: "325199",
    title: "Phosphoric acid esters manufacturing",
  },
  {
    code: "325199",
    title: "Phthalate acid manufacturing",
  },
  {
    code: "325199",
    title: "Plasticizers (i.e., basic synthetic chemicals) manufacturing",
  },
  {
    code: "325199",
    title: "Polyhydric alcohol esters and amines manufacturing",
  },
  {
    code: "325199",
    title: "Polyhydric alcohols manufacturing",
  },
  {
    code: "325199",
    title: "Potassium bitartrate manufacturing",
  },
  {
    code: "325199",
    title:
      "Potassium organic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Propylcarbinol manufacturing",
  },
  {
    code: "325199",
    title: "Propylene glycol manufacturing",
  },
  {
    code: "325199",
    title: "Raw organic waxes manufacturing",
  },
  {
    code: "325199",
    title: "Red oil (i.e., oleic acid) manufacturing",
  },
  {
    code: "325199",
    title: "Refrigerant mixtures and blends manufacturing",
  },
  {
    code: "325199",
    title: "Saccharin manufacturing",
  },
  {
    code: "325199",
    title: "Salicylic acid (except medicinal) manufacturing",
  },
  {
    code: "325199",
    title: "Sebacic acid esters manufacturing",
  },
  {
    code: "325199",
    title: "Sebacic acid manufacturing",
  },
  {
    code: "325199",
    title: "Silicone (except resins) manufacturing",
  },
  {
    code: "325199",
    title: "Sodium acetate manufacturing",
  },
  {
    code: "325199",
    title: "Sodium alginate manufacturing",
  },
  {
    code: "325199",
    title: "Sodium benzoate manufacturing",
  },
  {
    code: "325199",
    title: "Sodium glutamate manufacturing",
  },
  {
    code: "325199",
    title:
      "Sodium organic compounds, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Sodium pentachlorophenate manufacturing",
  },
  {
    code: "325199",
    title: "Sodium sulfoxalate formaldehyde manufacturing",
  },
  {
    code: "325199",
    title: "Sorbitol manufacturing",
  },
  {
    code: "325199",
    title: "Stearic acid esters manufacturing",
  },
  {
    code: "325199",
    title: "Stearic acid manufacturing",
  },
  {
    code: "325199",
    title: "Stearic acid salts manufacturing",
  },
  {
    code: "325199",
    title:
      "Sugar substitutes (i.e., synthetic sweeteners blended with other ingredients) made in synthetic sweetener establishments",
  },
  {
    code: "325199",
    title: "Synthetic sweeteners (i.e., sweetening agents) manufacturing",
  },
  {
    code: "325199",
    title: "Tanning agents, synthetic organic, manufacturing",
  },
  {
    code: "325199",
    title: "Tartaric acid manufacturing",
  },
  {
    code: "325199",
    title: "Tartrates, not specified elsewhere by process, manufacturing",
  },
  {
    code: "325199",
    title: "Tear gas manufacturing",
  },
  {
    code: "325199",
    title: "Terpineol manufacturing",
  },
  {
    code: "325199",
    title: "Tert-butylated bis (p-phenoxyphenyl) ether fluid manufacturing",
  },
  {
    code: "325199",
    title: "Tetrachloroethylene manufacturing",
  },
  {
    code: "325199",
    title: "Tetraethyl lead manufacturing",
  },
  {
    code: "325199",
    title: "Thioglycolic acid manufacturing",
  },
  {
    code: "325199",
    title:
      "Transesterification of vegetable oils to produce fuels or fuel additives",
  },
  {
    code: "325199",
    title: "Trichloroethylene manufacturing",
  },
  {
    code: "325199",
    title: "Trichlorophenoxyacetic acid manufacturing",
  },
  {
    code: "325199",
    title: "Tricresyl phosphate manufacturing",
  },
  {
    code: "325199",
    title: "Tridecyl alcohol manufacturing",
  },
  {
    code: "325199",
    title: "Triphenyl phosphate manufacturing",
  },
  {
    code: "325199",
    title: "Vanillin, synthetic, manufacturing",
  },
  {
    code: "325199",
    title: "Vinyl acetate (except resins) manufacturing",
  },
  {
    code: "325199",
    title: "Wood alcohol, synthetic, manufacturing",
  },
  {
    code: "325211",
    title: "Acetal resins manufacturing",
  },
  {
    code: "325211",
    title: "Acrylic resins manufacturing",
  },
  {
    code: "325211",
    title: "Acrylonitrile-butadiene-styrene (ABS) resins manufacturing",
  },
  {
    code: "325211",
    title: "Alkyd resins manufacturing",
  },
  {
    code: "325211",
    title: "Allyl resins manufacturing",
  },
  {
    code: "325211",
    title: "Amino resins manufacturing",
  },
  {
    code: "325211",
    title: "Amino-aldehyde resins manufacturing",
  },
  {
    code: "325211",
    title:
      "Butadiene copolymers containing less than 50 percent butadiene manufacturing",
  },
  {
    code: "325211",
    title: "Carbohydrate plastics manufacturing",
  },
  {
    code: "325211",
    title: "Casein plastics manufacturing",
  },
  {
    code: "325211",
    title: "Cellulose acetate resins manufacturing",
  },
  {
    code: "325211",
    title: "Cellulose nitrate resins manufacturing",
  },
  {
    code: "325211",
    title: "Cellulose propionate resins manufacturing",
  },
  {
    code: "325211",
    title: "Cellulose resins manufacturing",
  },
  {
    code: "325211",
    title: "Cellulose xanthate (viscose) manufacturing",
  },
  {
    code: "325211",
    title: "Coal tar resins manufacturing",
  },
  {
    code: "325211",
    title: "Coumarone-indene resins manufacturing",
  },
  {
    code: "325211",
    title: "Cresol resins manufacturing",
  },
  {
    code: "325211",
    title: "Cresol-furfural resins manufacturing",
  },
  {
    code: "325211",
    title: "Dicyandiamine resins manufacturing",
  },
  {
    code: "325211",
    title: "Diisocyanate resins manufacturing",
  },
  {
    code: "325211",
    title: "Elastomers (except synthetic rubber) manufacturing",
  },
  {
    code: "325211",
    title: "Epichlorohydrin bisphenol manufacturing",
  },
  {
    code: "325211",
    title: "Epichlorohydrin diphenol manufacturing",
  },
  {
    code: "325211",
    title: "Epoxy resins manufacturing",
  },
  {
    code: "325211",
    title: "Ester gum manufacturing",
  },
  {
    code: "325211",
    title: "Ethylcellulose plastics manufacturing",
  },
  {
    code: "325211",
    title: "Ethylene-vinyl acetate resins manufacturing",
  },
  {
    code: "325211",
    title: "Fluorohydrocarbon resins manufacturing",
  },
  {
    code: "325211",
    title: "Fluoro-polymer resins manufacturing",
  },
  {
    code: "325211",
    title: "Ion exchange resins manufacturing",
  },
  {
    code: "325211",
    title: "Ionomer resins manufacturing",
  },
  {
    code: "325211",
    title: "Isobutylene polymer resins manufacturing",
  },
  {
    code: "325211",
    title: "Lignin plastics manufacturing",
  },
  {
    code: "325211",
    title: "Melamine resins manufacturing",
  },
  {
    code: "325211",
    title: "Methyl acrylate resins manufacturing",
  },
  {
    code: "325211",
    title: "Methyl cellulose resins manufacturing",
  },
  {
    code: "325211",
    title: "Methyl methacrylate resins manufacturing",
  },
  {
    code: "325211",
    title: "Nitrocellulose (i.e., pyroxylin) resins manufacturing",
  },
  {
    code: "325211",
    title: "Nylon resins manufacturing",
  },
  {
    code: "325211",
    title: "Petroleum polymer resins manufacturing",
  },
  {
    code: "325211",
    title: "Phenol-formaldehyde resins manufacturing",
  },
  {
    code: "325211",
    title: "Phenol-furfural resins manufacturing",
  },
  {
    code: "325211",
    title: "Phenolic resins manufacturing",
  },
  {
    code: "325211",
    title: "Phenoxy resins manufacturing",
  },
  {
    code: "325211",
    title: "Phthalic alkyd resins manufacturing",
  },
  {
    code: "325211",
    title: "Phthalic anhydride resins manufacturing",
  },
  {
    code: "325211",
    title:
      "Plastics and synthetic resins regenerating, precipitating, and coagulating",
  },
  {
    code: "325211",
    title: "Polyacrylonitrile resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyamide resins manufacturing",
  },
  {
    code: "325211",
    title: "Polycarbonate resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyester resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyethylene resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyethylene terephthalate (PET) resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyhexamethylenediamine adipamide resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyisobutylene resins manufacturing",
  },
  {
    code: "325211",
    title: "Polymethacrylate resins manufacturing",
  },
  {
    code: "325211",
    title: "Polypropylene resins manufacturing",
  },
  {
    code: "325211",
    title: "Polystyrene resins manufacturing",
  },
  {
    code: "325211",
    title: "Polytetrafluoroethylene resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyurethane resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyvinyl alcohol resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyvinyl chloride (PVC) resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyvinyl halide resins manufacturing",
  },
  {
    code: "325211",
    title: "Polyvinyl resins manufacturing",
  },
  {
    code: "325211",
    title: "Propylene resins manufacturing",
  },
  {
    code: "325211",
    title: "Protein plastics manufacturing",
  },
  {
    code: "325211",
    title: "Pyroxylin (i.e., nitrocellulose) resins manufacturing",
  },
  {
    code: "325211",
    title:
      "Resins, plastics (except custom compounding purchased resins), manufacturing",
  },
  {
    code: "325211",
    title: "Rosins (i.e., modified resins) manufacturing",
  },
  {
    code: "325211",
    title: "Silicone resins manufacturing",
  },
  {
    code: "325211",
    title: "Soybean plastics manufacturing",
  },
  {
    code: "325211",
    title: "Styrene resins manufacturing",
  },
  {
    code: "325211",
    title: "Styrene-acrylonitrile resins manufacturing",
  },
  {
    code: "325211",
    title: "Tar acid resins manufacturing",
  },
  {
    code: "325211",
    title: "Thermoplastic resins and plastics materials manufacturing",
  },
  {
    code: "325211",
    title: "Thermosetting plastics resins manufacturing",
  },
  {
    code: "325211",
    title: "Urea resins manufacturing",
  },
  {
    code: "325211",
    title: "Urea-formaldehyde resins manufacturing",
  },
  {
    code: "325211",
    title: "Vinyl acetate resins manufacturing",
  },
  {
    code: "325211",
    title: "Vinyl chloride resins manufacturing",
  },
  {
    code: "325211",
    title: "Vinyl resins manufacturing",
  },
  {
    code: "325211",
    title: "Vinylidene resins manufacturing",
  },
  {
    code: "325212",
    title: "Acrylate rubber manufacturing",
  },
  {
    code: "325212",
    title: "Acrylate-butadiene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Acrylic rubber manufacturing",
  },
  {
    code: "325212",
    title:
      "Butadiene copolymers containing more than 50 percent butadiene manufacturing",
  },
  {
    code: "325212",
    title: "Butadiene rubber (i.e., polybutadiene) manufacturing",
  },
  {
    code: "325212",
    title: "Butyl rubber manufacturing",
  },
  {
    code: "325212",
    title: "Chlorinated rubber, synthetic, manufacturing",
  },
  {
    code: "325212",
    title: "Chloroprene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Chlorosulfonated polyethylenes manufacturing",
  },
  {
    code: "325212",
    title: "Cyclo rubber, synthetic, manufacturing",
  },
  {
    code: "325212",
    title: "Elastomers, synthetic rubber, manufacturing",
  },
  {
    code: "325212",
    title: "Epichlorohydrin elastomers manufacturing",
  },
  {
    code: "325212",
    title: "Ethylene-propylene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Ethylene-propylene-nonconjugated diene (EPDM) rubber manufacturing",
  },
  {
    code: "325212",
    title: "Fluoro rubbers manufacturing",
  },
  {
    code: "325212",
    title: "Fluorocarbon derivative rubbers manufacturing",
  },
  {
    code: "325212",
    title: "Isobutylene-isoprene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Isocyanate rubber manufacturing",
  },
  {
    code: "325212",
    title: "Latex rubber, synthetic, manufacturing",
  },
  {
    code: "325212",
    title: "Neoprene manufacturing",
  },
  {
    code: "325212",
    title: "Nitrile rubber manufacturing",
  },
  {
    code: "325212",
    title: "Nitrile-butadiene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Nitrile-chloroprene rubbers manufacturing",
  },
  {
    code: "325212",
    title: "N-type rubber manufacturing",
  },
  {
    code: "325212",
    title: "Polyethylene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Polyisobutylene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Polyisobutylene-isoprene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Polymethylene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Polysulfide rubber manufacturing",
  },
  {
    code: "325212",
    title: "Rubber, synthetic, manufacturing",
  },
  {
    code: "325212",
    title: "Silicone rubber manufacturing",
  },
  {
    code: "325212",
    title: "Stereo rubber manufacturing",
  },
  {
    code: "325212",
    title: "S-type rubber manufacturing",
  },
  {
    code: "325212",
    title:
      "Styrene-butadiene rubber containing less than 50 percent styrene manufacturing",
  },
  {
    code: "325212",
    title: "Styrene-chloroprene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Styrene-isoprene rubber manufacturing",
  },
  {
    code: "325212",
    title: "Synthetic rubber (i.e., vulcanizable elastomers) manufacturing",
  },
  {
    code: "325212",
    title: "Thermosetting vulcanizable elastomers manufacturing",
  },
  {
    code: "325212",
    title: "Thiol rubber manufacturing",
  },
  {
    code: "325212",
    title: "Urethane rubber manufacturing",
  },
  {
    code: "325212",
    title: "Vulcanized oils manufacturing",
  },
  {
    code: "325220",
    title: "Acetate fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Acrylic fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Acrylonitrile fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Anidex fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Casein fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Cellophane film or sheet manufacturing",
  },
  {
    code: "325220",
    title: "Cellulosic fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Cellulosic filament yarn manufacturing",
  },
  {
    code: "325220",
    title: "Cellulosic staple fibers manufacturing",
  },
  {
    code: "325220",
    title: "Cigarette tow, cellulosic fiber, manufacturing",
  },
  {
    code: "325220",
    title: "Elastomeric fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Fibers and filaments, cellulosic, manufacturing and texturizing",
  },
  {
    code: "325220",
    title: "Fibers and filaments, noncellulosic, manufacturing and texturizing",
  },
  {
    code: "325220",
    title: "Fluorocarbon fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Linear esters fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Manmade cellulosic fibers manufacturing",
  },
  {
    code: "325220",
    title: "Manmade noncellulosic fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Modacrylic fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Nitrocellulose fibers manufacturing",
  },
  {
    code: "325220",
    title: "Noncellulosic fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Noncellulosic filament yarn manufacturing",
  },
  {
    code: "325220",
    title: "Noncellulosic staple fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Nylon fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Olefin fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Organic noncellulosic fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Polyester fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title:
      "Polyethylene terephthalate (PET) fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Polyolefin fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Polyvinyl ester fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title:
      "Polyvinylidene chloride (i.e., saran) fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Protein fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Rayon fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Regenerated cellulosic fibers manufacturing",
  },
  {
    code: "325220",
    title:
      "Saran (i.e., polyvinylidene chloride) fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Soybean fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Spandex fiber, filaments, and yarn manufacturing",
  },
  {
    code: "325220",
    title: "Texturizing cellulosic yarn made in the same establishment",
  },
  {
    code: "325220",
    title: "Texturizing noncellulosic yarn made in the same establishment",
  },
  {
    code: "325220",
    title: "Throwing cellulosic yarn made in the same establishment",
  },
  {
    code: "325220",
    title: "Throwing noncellulosic yarn made in the same establishment",
  },
  {
    code: "325220",
    title: "Triacetate fibers and yarns manufacturing",
  },
  {
    code: "325220",
    title: "Vinyl fibers and filaments manufacturing",
  },
  {
    code: "325220",
    title: "Vinylidene chloride fiber and filament manufacturing",
  },
  {
    code: "325220",
    title: "Viscose fibers, bands, strips, and yarn manufacturing",
  },
  {
    code: "325220",
    title: "Yarn, cellulosic filament, manufacturing",
  },
  {
    code: "325220",
    title: "Yarn, cellulosic filament, manufacturing and texturizing",
  },
  {
    code: "325220",
    title: "Yarn, noncellulosic fiber and filament, manufacturing",
  },
  {
    code: "325220",
    title:
      "Yarn, noncellulosic fiber and filament, manufacturing and texturizing",
  },
  {
    code: "325220",
    title: "Zein fibers and filaments manufacturing",
  },
  {
    code: "325311",
    title: "Ammonia, anhydrous and aqueous, manufacturing",
  },
  {
    code: "325311",
    title: "Ammonium nitrate manufacturing",
  },
  {
    code: "325311",
    title: "Ammonium sulfate manufacturing",
  },
  {
    code: "325311",
    title: "Anhydrous ammonia manufacturing",
  },
  {
    code: "325311",
    title:
      "Fertilizers, mixed, made in plants producing nitrogenous fertilizer materials",
  },
  {
    code: "325311",
    title: "Fertilizers, natural organic (except compost), manufacturing",
  },
  {
    code: "325311",
    title: "Fertilizers, of animal waste origin, manufacturing",
  },
  {
    code: "325311",
    title: "Fertilizers, of sewage origin, manufacturing",
  },
  {
    code: "325311",
    title: "Nitric acid manufacturing",
  },
  {
    code: "325311",
    title: "Nitrogenous fertilizer materials manufacturing",
  },
  {
    code: "325311",
    title:
      "Plant foods, mixed, made in plants producing nitrogenous fertilizer materials",
  },
  {
    code: "325311",
    title: "Urea manufacturing",
  },
  {
    code: "325312",
    title: "Ammonium phosphates manufacturing",
  },
  {
    code: "325312",
    title: "Defluorinated phosphates manufacturing",
  },
  {
    code: "325312",
    title: "Diammonium phosphates manufacturing",
  },
  {
    code: "325312",
    title:
      "Fertilizers, mixed, made in plants producing phosphatic fertilizer materials",
  },
  {
    code: "325312",
    title: "Phosphatic fertilizer materials manufacturing",
  },
  {
    code: "325312",
    title: "Phosphoric acid manufacturing",
  },
  {
    code: "325312",
    title:
      "Plant foods, mixed, made in plants producing phosphatic fertilizer materials",
  },
  {
    code: "325312",
    title: "Superphosphates manufacturing",
  },
  {
    code: "325314",
    title:
      "Fertilizers, mixed, made in plants not manufacturing fertilizer materials",
  },
  {
    code: "325314",
    title: "Mixing purchased fertilizer materials",
  },
  {
    code: "325314",
    title: "Nitrogenous fertilizers made by mixing purchased materials",
  },
  {
    code: "325314",
    title: "Phosphatic fertilizers made by mixing purchased materials",
  },
  {
    code: "325314",
    title: "Potassic fertilizers made by mixing purchased materials",
  },
  {
    code: "325314",
    title: "Potting soil manufacturing",
  },
  {
    code: "325315",
    title: "Compost manufacturing",
  },
  {
    code: "325315",
    title: "Sewage and animal waste compost manufacturing",
  },
  {
    code: "325320",
    title: "Ant poisons manufacturing",
  },
  {
    code: "325320",
    title: "Arsenate insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Arsenite insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Benzene hexachloride (BHC) insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Bordeaux mixture insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Botanical insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Chlordane insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Cholinesterase inhibitors used as insecticides manufacturing",
  },
  {
    code: "325320",
    title: "DDT (dichlorodiphenyltrichloroethane) insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Defoliants manufacturing",
  },
  {
    code: "325320",
    title: "Dips (i.e., pesticides), cattle and sheep, manufacturing",
  },
  {
    code: "325320",
    title: "Endrin insecticides manufacturing",
  },
  {
    code: "325320",
    title:
      "Exterminating chemical products (e.g., fungicides, insecticides, pesticides) manufacturing",
  },
  {
    code: "325320",
    title: "Flea powders or sprays manufacturing",
  },
  {
    code: "325320",
    title: "Fly sprays manufacturing",
  },
  {
    code: "325320",
    title: "Fungicides manufacturing",
  },
  {
    code: "325320",
    title: "Herbicides manufacturing",
  },
  {
    code: "325320",
    title: "Household-type insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Lime-sulfur fungicides manufacturing",
  },
  {
    code: "325320",
    title: "Lindane pesticides manufacturing",
  },
  {
    code: "325320",
    title: "Malathion insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Methoxychlor insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Moth repellents manufacturing",
  },
  {
    code: "325320",
    title: "Nicotine insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Organo-phosphate based insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Parathion insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Paris green insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Pest (e.g., ant, rat, roach, rodent) control poison manufacturing",
  },
  {
    code: "325320",
    title: "Pesticides manufacturing",
  },
  {
    code: "325320",
    title: "Plant growth regulants manufacturing",
  },
  {
    code: "325320",
    title: "Pyrethrin insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Roach poisons manufacturing",
  },
  {
    code: "325320",
    title: "Rodent poisons manufacturing",
  },
  {
    code: "325320",
    title: "Rodenticides manufacturing",
  },
  {
    code: "325320",
    title: "Root removing chemicals manufacturing",
  },
  {
    code: "325320",
    title: "Rotenone insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Seed treatment preparations manufacturing",
  },
  {
    code: "325320",
    title: "Sodium arsenite insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Sulfur insecticides manufacturing",
  },
  {
    code: "325320",
    title: "Termite poisons manufacturing",
  },
  {
    code: "325320",
    title: "Tick powders or sprays manufacturing",
  },
  {
    code: "325320",
    title: "Xanthone insecticides manufacturing",
  },
  {
    code: "325411",
    title: "Acetylsalicylic acid manufacturing",
  },
  {
    code: "325411",
    title: "Adrenal derivatives, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Agar-agar manufacturing",
  },
  {
    code: "325411",
    title: "Amphetamines, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Anesthetics, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Antibiotics, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Anticholinergics, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Anticonvulsants, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Antidepressants, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Ascorbic acid (i.e., vitamin C), uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Atropine and derivatives manufacturing",
  },
  {
    code: "325411",
    title: "Barbiturates, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Barbituric acid manufacturing",
  },
  {
    code: "325411",
    title: "Brucine manufacturing",
  },
  {
    code: "325411",
    title: "Caffeine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Cephalosporin, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Cinchona and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Cocaine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Cod liver oil, medicinal, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Codeine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Concentrated medicinal chemicals, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Cortisone, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Dietary supplements, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Digitoxin, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Endocrine products, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title:
      "Enzyme proteins (i.e., basic synthetic chemicals), pharmaceutical use, manufacturing",
  },
  {
    code: "325411",
    title: "Ephedrine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Ergot alkaloids (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Fish liver oils, medicinal, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Glandular derivatives, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Glycosides, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title:
      "Grinding and milling botanicals (i.e., for medicinal or dietary supplement use)",
  },
  {
    code: "325411",
    title: "Herbal supplements, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Hormones and derivatives, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Hypnotic drugs, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Insulin, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Magnesia, medicinal, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Medicinal chemicals, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Medicinal gelatins manufacturing",
  },
  {
    code: "325411",
    title: "Morphine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Nicotine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "N-methylpiperazine manufacturing",
  },
  {
    code: "325411",
    title: "Oils, vegetable and animal, medicinal, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Ophthalmic agents, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Opium and opium derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Penicillin, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title:
      "Physostigmine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Pituitary gland derivatives, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Procaine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Quinine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Reserpines (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Salicylic acid, medicinal, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Steroids, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Strychnine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title: "Sulfa drugs, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Sulfonamides, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Tetracycline, uncompounded, manufacturing",
  },
  {
    code: "325411",
    title: "Theobromine and derivatives (i.e., basic chemicals) manufacturing",
  },
  {
    code: "325411",
    title:
      "Vegetable alkaloids (i.e., basic chemicals) (e.g., caffeine, codeine, morphine, nicotine), manufacturing",
  },
  {
    code: "325411",
    title: "Vitamins, uncompounded, manufacturing",
  },
  {
    code: "325412",
    title: "Adrenal medicinal preparations manufacturing",
  },
  {
    code: "325412",
    title: "Analgesic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Anesthetic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Angiourographic diagnostic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antacid preparations manufacturing",
  },
  {
    code: "325412",
    title: "Anthelmintic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antibacterial preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antibiotic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antidepressant preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antihistamine preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antineoplastic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antipyretic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antiseptic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Antispasmodic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Astringent preparations manufacturing",
  },
  {
    code: "325412",
    title: "Barbiturate preparations manufacturing",
  },
  {
    code: "325412",
    title: "Barium in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Belladonna preparations manufacturing",
  },
  {
    code: "325412",
    title: "Birth control pills manufacturing",
  },
  {
    code: "325412",
    title:
      "Botanical extract preparations (except in-vitro diagnostics) manufacturing",
  },
  {
    code: "325412",
    title: "Cardiac preparations manufacturing",
  },
  {
    code: "325412",
    title: "Cathartic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Central nervous system stimulant preparations manufacturing",
  },
  {
    code: "325412",
    title: "Coagulation in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Cold remedies manufacturing",
  },
  {
    code: "325412",
    title: "Contraceptive preparations manufacturing",
  },
  {
    code: "325412",
    title:
      "Contrast media in-vivo diagnostic substances (e.g., iodine, barium) manufacturing",
  },
  {
    code: "325412",
    title: "Cough drops, medicated, manufacturing",
  },
  {
    code: "325412",
    title: "Cough medicines manufacturing",
  },
  {
    code: "325412",
    title: "Cyclopropane medicinal preparations manufacturing",
  },
  {
    code: "325412",
    title: "Dermatological preparations manufacturing",
  },
  {
    code: "325412",
    title: "Diagnostic biological preparations (except in-vitro) manufacturing",
  },
  {
    code: "325412",
    title: "Dietary supplements, compounded, manufacturing",
  },
  {
    code: "325412",
    title: "Digestive system preparations manufacturing",
  },
  {
    code: "325412",
    title: "Digitalis medicinal preparations manufacturing",
  },
  {
    code: "325412",
    title: "Diuretic preparations manufacturing",
  },
  {
    code: "325412",
    title: "Effervescent salts manufacturing",
  },
  {
    code: "325412",
    title: "Electrolyte in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Eye and ear preparations manufacturing",
  },
  {
    code: "325412",
    title: "Fever remedy preparations manufacturing",
  },
  {
    code: "325412",
    title: "Glandular medicinal preparations manufacturing",
  },
  {
    code: "325412",
    title: "Hematology in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Herbal supplements, compounded, manufacturing",
  },
  {
    code: "325412",
    title: "Hormone preparations (except in-vitro diagnostics) manufacturing",
  },
  {
    code: "325412",
    title: "Insulin preparations manufacturing",
  },
  {
    code: "325412",
    title: "Intravenous (IV) solution preparations manufacturing",
  },
  {
    code: "325412",
    title: "In-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Iodinated in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Laxative preparations manufacturing",
  },
  {
    code: "325412",
    title: "Lip balms manufacturing",
  },
  {
    code: "325412",
    title: "Metabolite in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Mouthwashes, medicated, manufacturing",
  },
  {
    code: "325412",
    title: "Muscle relaxant preparations manufacturing",
  },
  {
    code: "325412",
    title: "Nonprescription drug preparations manufacturing",
  },
  {
    code: "325412",
    title:
      "Nuclear medicine (e.g., radioactive isotopes) preparations manufacturing",
  },
  {
    code: "325412",
    title: "Oral contraceptive preparations manufacturing",
  },
  {
    code: "325412",
    title: "Patent medicine preparations manufacturing",
  },
  {
    code: "325412",
    title: "Penicillin preparations manufacturing",
  },
  {
    code: "325412",
    title:
      "Pharmaceutical preparations (e.g., capsules, liniments, ointments, tablets) manufacturing",
  },
  {
    code: "325412",
    title: "Pituitary gland preparations manufacturing",
  },
  {
    code: "325412",
    title: "Radioactive in-vivo diagnostic substances manufacturing",
  },
  {
    code: "325412",
    title: "Sedative preparations manufacturing",
  },
  {
    code: "325412",
    title: "Sodium chloride pharmaceutical preparations manufacturing",
  },
  {
    code: "325412",
    title: "Sodium salicylate preparations manufacturing",
  },
  {
    code: "325412",
    title: "Suppositories manufacturing",
  },
  {
    code: "325412",
    title: "Technetium medicinal preparations manufacturing",
  },
  {
    code: "325412",
    title: "Thyroid preparations manufacturing",
  },
  {
    code: "325412",
    title: "Tincture of iodine preparations manufacturing",
  },
  {
    code: "325412",
    title: "Tranquilizer preparations manufacturing",
  },
  {
    code: "325412",
    title: "Vermifuge preparations manufacturing",
  },
  {
    code: "325412",
    title: "Veterinary medicinal preparations manufacturing",
  },
  {
    code: "325412",
    title: "Vitamin preparations manufacturing",
  },
  {
    code: "325412",
    title:
      "Water (i.e., drinking) decontamination or purification tablets manufacturing",
  },
  {
    code: "325412",
    title: "Zinc oxide medicinal preparations manufacturing",
  },
  {
    code: "325413",
    title: "Blood derivative in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title: "Blood glucose test kits manufacturing",
  },
  {
    code: "325413",
    title: "Coagulation in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title:
      "Cytology and histology in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title: "Diagnostic substances, in-vitro, manufacturing",
  },
  {
    code: "325413",
    title: "Enzyme and isoenzyme in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title: "Hematology in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title: "HIV test kits manufacturing",
  },
  {
    code: "325413",
    title: "Hormone in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title: "In-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title:
      "Microbiology, virology, and serology in-vitro diagnostic substances manufacturing",
  },
  {
    code: "325413",
    title: "Pregnancy test kits manufacturing",
  },
  {
    code: "325413",
    title: "Viral in-vitro diagnostic test substances manufacturing",
  },
  {
    code: "325414",
    title: "Agar culture media manufacturing",
  },
  {
    code: "325414",
    title: "Aggressins (except in-vitro) manufacturing",
  },
  {
    code: "325414",
    title: "Allergenic extracts (except diagnostic substances) manufacturing",
  },
  {
    code: "325414",
    title: "Allergens manufacturing",
  },
  {
    code: "325414",
    title: "Antigens manufacturing",
  },
  {
    code: "325414",
    title: "Antiserums manufacturing",
  },
  {
    code: "325414",
    title: "Antitoxins manufacturing",
  },
  {
    code: "325414",
    title: "Antivenoms manufacturing",
  },
  {
    code: "325414",
    title: "Bacterial vaccines manufacturing",
  },
  {
    code: "325414",
    title: "Bacterins (i.e., bacterial vaccines) manufacturing",
  },
  {
    code: "325414",
    title: "Blood derivatives manufacturing",
  },
  {
    code: "325414",
    title: "Blood fractions manufacturing",
  },
  {
    code: "325414",
    title: "Cholera serums manufacturing",
  },
  {
    code: "325414",
    title: "Culture media manufacturing",
  },
  {
    code: "325414",
    title: "Gene therapy preparations manufacturing",
  },
  {
    code: "325414",
    title: "Hematology products (except diagnostic substances) manufacturing",
  },
  {
    code: "325414",
    title: "Plasmas manufacturing",
  },
  {
    code: "325414",
    title: "Serums (except diagnostic substances) manufacturing",
  },
  {
    code: "325414",
    title: "Toxoids (e.g., diphtheria, tetanus) manufacturing",
  },
  {
    code: "325414",
    title: "Tuberculin (i.e., tuberculo-protein derived) manufacturing",
  },
  {
    code: "325414",
    title: "Vaccines (i.e., bacterial, virus) manufacturing",
  },
  {
    code: "325414",
    title: "Virus vaccines manufacturing",
  },
  {
    code: "325510",
    title: "Architectural coatings (i.e., paint) manufacturing",
  },
  {
    code: "325510",
    title: "Calcimines manufacturing",
  },
  {
    code: "325510",
    title: "Dispersions, pigment, manufacturing",
  },
  {
    code: "325510",
    title: "Dopes, paint, and lacquer manufacturing",
  },
  {
    code: "325510",
    title: "Driers, paint and varnish, manufacturing",
  },
  {
    code: "325510",
    title: "Enamel paints manufacturing",
  },
  {
    code: "325510",
    title: "Epoxy coatings made from purchased resins",
  },
  {
    code: "325510",
    title: "Fillers, wood (e.g., dry, liquid, paste), manufacturing",
  },
  {
    code: "325510",
    title: "Frit manufacturing",
  },
  {
    code: "325510",
    title: "Glaziers' putty manufacturing",
  },
  {
    code: "325510",
    title:
      "Industrial product finishes and coatings (i.e., paint) manufacturing",
  },
  {
    code: "325510",
    title: "Lacquers manufacturing",
  },
  {
    code: "325510",
    title: "Latex paint (i.e., water based) manufacturing",
  },
  {
    code: "325510",
    title: "Marine paints manufacturing",
  },
  {
    code: "325510",
    title: "Motor vehicle paints manufacturing",
  },
  {
    code: "325510",
    title: "Paint and varnish removers manufacturing",
  },
  {
    code: "325510",
    title: "Paint thinner and reducer preparations manufacturing",
  },
  {
    code: "325510",
    title: "Paintbrush cleaners manufacturing",
  },
  {
    code: "325510",
    title: "Paints (except artist's) manufacturing",
  },
  {
    code: "325510",
    title: "Paints, emulsion (i.e., latex paint), manufacturing",
  },
  {
    code: "325510",
    title: "Paints, oil and alkyd vehicle, manufacturing",
  },
  {
    code: "325510",
    title: "Plastic wood fillers manufacturing",
  },
  {
    code: "325510",
    title: "Plastisol coating compounds manufacturing",
  },
  {
    code: "325510",
    title: "Polyurethane coatings manufacturing",
  },
  {
    code: "325510",
    title: "Powder coatings manufacturing",
  },
  {
    code: "325510",
    title: "Primers, paint, manufacturing",
  },
  {
    code: "325510",
    title: "Shellac manufacturing",
  },
  {
    code: "325510",
    title: "Stains (except biological) manufacturing",
  },
  {
    code: "325510",
    title: "Varnishes manufacturing",
  },
  {
    code: "325510",
    title:
      "Water-repellent coatings for wood, concrete and masonry manufacturing",
  },
  {
    code: "325510",
    title: "Wood fillers manufacturing",
  },
  {
    code: "325520",
    title: "Adhesives (except asphalt, dental, gypsum base) manufacturing",
  },
  {
    code: "325520",
    title: "Caulking compounds (except gypsum base) manufacturing",
  },
  {
    code: "325520",
    title: "Cement, rubber, manufacturing",
  },
  {
    code: "325520",
    title: "Construction adhesives (except asphalt, gypsum base) manufacturing",
  },
  {
    code: "325520",
    title: "Dextrin glues manufacturing",
  },
  {
    code: "325520",
    title: "Epoxy adhesives manufacturing",
  },
  {
    code: "325520",
    title: "Glues (except dental) manufacturing",
  },
  {
    code: "325520",
    title: "Joint compounds (except gypsum base) manufacturing",
  },
  {
    code: "325520",
    title: "Mucilage adhesives manufacturing",
  },
  {
    code: "325520",
    title: "Pastes, adhesive, manufacturing",
  },
  {
    code: "325520",
    title: "Pipe sealing compounds manufacturing",
  },
  {
    code: "325520",
    title: "Plumbers' putty manufacturing",
  },
  {
    code: "325520",
    title: "Rubber cements manufacturing",
  },
  {
    code: "325520",
    title: "Sealing compounds for pipe threads and joints manufacturing",
  },
  {
    code: "325520",
    title: "Starch glues manufacturing",
  },
  {
    code: "325520",
    title: "Tile adhesives manufacturing",
  },
  {
    code: "325611",
    title: "Bar soaps manufacturing",
  },
  {
    code: "325611",
    title: "Dentifrices manufacturing",
  },
  {
    code: "325611",
    title: "Detergents (e.g., dishwashing, industrial, laundry) manufacturing",
  },
  {
    code: "325611",
    title: "Dishwasher detergents manufacturing",
  },
  {
    code: "325611",
    title: "Glycerin (i.e., glycerol), natural, manufacturing",
  },
  {
    code: "325611",
    title: "Hand sanitizers manufacturing",
  },
  {
    code: "325611",
    title: "Hand soaps (e.g., hard, liquid, soft) manufacturing",
  },
  {
    code: "325611",
    title: "Laundry soap, chips, and powder manufacturing",
  },
  {
    code: "325611",
    title: "Mechanic's hand soaps and pastes manufacturing",
  },
  {
    code: "325611",
    title: "Presoaks manufacturing",
  },
  {
    code: "325611",
    title: "Scouring cleansers (e.g., pastes, powders) manufacturing",
  },
  {
    code: "325611",
    title: "Soaps (e.g., bar, chip, powder) manufacturing",
  },
  {
    code: "325611",
    title: "Teeth whiteners (e.g., pastes, gels) manufacturing",
  },
  {
    code: "325611",
    title: "Toilet soaps manufacturing",
  },
  {
    code: "325611",
    title: "Toothpastes, gels, and tooth powders manufacturing",
  },
  {
    code: "325611",
    title: "Waterless hand soaps manufacturing",
  },
  {
    code: "325612",
    title: "Air fresheners manufacturing",
  },
  {
    code: "325612",
    title: "Ammonia, household-type, manufacturing",
  },
  {
    code: "325612",
    title: "Automobile polishes and cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Beeswax polishes and waxes manufacturing",
  },
  {
    code: "325612",
    title: "Bleaches, formulated for household use, manufacturing",
  },
  {
    code: "325612",
    title: "Brass polishes manufacturing",
  },
  {
    code: "325612",
    title: "Buffing compounds manufacturing",
  },
  {
    code: "325612",
    title: "Cloths, dusting and polishing, chemically treated, manufacturing",
  },
  {
    code: "325612",
    title: "Copper cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Degreasing preparations, household-type, manufacturing",
  },
  {
    code: "325612",
    title: "Deodorants (except personal) manufacturing",
  },
  {
    code: "325612",
    title: "Disinfectants, household-type and industrial, manufacturing",
  },
  {
    code: "325612",
    title: "Drain pipe cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Drycleaning preparations manufacturing",
  },
  {
    code: "325612",
    title: "Fabric softeners manufacturing",
  },
  {
    code: "325612",
    title: "Floor polishes and waxes manufacturing",
  },
  {
    code: "325612",
    title: "Furniture polishes and waxes manufacturing",
  },
  {
    code: "325612",
    title: "Glass and tile cleaning preparations manufacturing",
  },
  {
    code: "325612",
    title: "Gun cleaning preparations",
  },
  {
    code: "325612",
    title: "Ink eradicators manufacturing",
  },
  {
    code: "325612",
    title: "Kitchen degreasing and cleaning preparations manufacturing",
  },
  {
    code: "325612",
    title: "Laundry bluing manufacturing",
  },
  {
    code: "325612",
    title: "Lye, household-type, manufacturing",
  },
  {
    code: "325612",
    title: "Metal polishes (i.e., tarnish removers) manufacturing",
  },
  {
    code: "325612",
    title: "Oven cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Polishes (e.g., automobile, furniture, metal, shoe) manufacturing",
  },
  {
    code: "325612",
    title: "Polishing preparations manufacturing",
  },
  {
    code: "325612",
    title: "Recycling drycleaning fluids",
  },
  {
    code: "325612",
    title: "Rug cleaning preparations manufacturing",
  },
  {
    code: "325612",
    title: "Rust removers manufacturing",
  },
  {
    code: "325612",
    title: "Saddle soaps manufacturing",
  },
  {
    code: "325612",
    title: "Shoe polishes and cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Silver polishes manufacturing",
  },
  {
    code: "325612",
    title: "Soot removing chemicals manufacturing",
  },
  {
    code: "325612",
    title: "Spot removers (except laundry presoaks) manufacturing",
  },
  {
    code: "325612",
    title: "Starches, laundry, manufacturing",
  },
  {
    code: "325612",
    title: "Sweeping compounds, absorbent, manufacturing",
  },
  {
    code: "325612",
    title: "Toilet bowl cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Tub and tile cleaning preparations manufacturing",
  },
  {
    code: "325612",
    title: "Wallpaper cleaners manufacturing",
  },
  {
    code: "325612",
    title: "Wax removers manufacturing",
  },
  {
    code: "325612",
    title: "Waxes, polishing (e.g., floor, furniture), manufacturing",
  },
  {
    code: "325612",
    title: "Window cleaning preparations manufacturing",
  },
  {
    code: "325612",
    title: "Windshield washer fluid manufacturing",
  },
  {
    code: "325613",
    title: "Assistants, textile and leather finishing, manufacturing",
  },
  {
    code: "325613",
    title: "Emulsifiers (i.e., surface active agents) manufacturing",
  },
  {
    code: "325613",
    title: "Finishing agents, textile and leather, manufacturing",
  },
  {
    code: "325613",
    title: "Mordants manufacturing",
  },
  {
    code: "325613",
    title: "Oils, soluble (i.e., textile finishing assistants), manufacturing",
  },
  {
    code: "325613",
    title: "Penetrants manufacturing",
  },
  {
    code: "325613",
    title: "Softeners, leather or textile, manufacturing",
  },
  {
    code: "325613",
    title: "Surface active agents manufacturing",
  },
  {
    code: "325613",
    title: "Textile finishing assistants manufacturing",
  },
  {
    code: "325613",
    title: "Textile scouring agents manufacturing",
  },
  {
    code: "325613",
    title: "Turkey-red oil manufacturing",
  },
  {
    code: "325613",
    title: "Wetting agents manufacturing",
  },
  {
    code: "325620",
    title: "After-shave preparations manufacturing",
  },
  {
    code: "325620",
    title: "Antiperspirants, personal, manufacturing",
  },
  {
    code: "325620",
    title: "Baby powder and baby oil manufacturing",
  },
  {
    code: "325620",
    title: "Bath salts manufacturing",
  },
  {
    code: "325620",
    title: "Blending and compounding perfume bases",
  },
  {
    code: "325620",
    title: "Blushes, face, manufacturing",
  },
  {
    code: "325620",
    title: "Bubble bath preparations manufacturing",
  },
  {
    code: "325620",
    title: "Colognes manufacturing",
  },
  {
    code: "325620",
    title: "Cosmetic creams, lotions, and oils manufacturing",
  },
  {
    code: "325620",
    title: "Dental floss manufacturing",
  },
  {
    code: "325620",
    title: "Denture adhesives manufacturing",
  },
  {
    code: "325620",
    title: "Denture cleaners, effervescent, manufacturing",
  },
  {
    code: "325620",
    title: "Deodorants, personal, manufacturing",
  },
  {
    code: "325620",
    title: "Depilatory preparations manufacturing",
  },
  {
    code: "325620",
    title:
      "Eye makeup (e.g., eye shadow, eyebrow pencil, mascara) manufacturing",
  },
  {
    code: "325620",
    title: "Face creams (e.g., cleansing, moisturizing) manufacturing",
  },
  {
    code: "325620",
    title: "Foundations (i.e., makeup) manufacturing",
  },
  {
    code: "325620",
    title: "Hair coloring preparations manufacturing",
  },
  {
    code: "325620",
    title:
      "Hair preparations (e.g., conditioners, dyes, rinses, shampoos) manufacturing",
  },
  {
    code: "325620",
    title: "Hair sprays manufacturing",
  },
  {
    code: "325620",
    title: "Hand lotions manufacturing",
  },
  {
    code: "325620",
    title: "Lipsticks manufacturing",
  },
  {
    code: "325620",
    title: "Lotions (e.g., body, face, hand) manufacturing",
  },
  {
    code: "325620",
    title: "Makeup (i.e., cosmetics) manufacturing",
  },
  {
    code: "325620",
    title: "Manicure preparations manufacturing",
  },
  {
    code: "325620",
    title: "Mouthwashes (except medicinal) manufacturing",
  },
  {
    code: "325620",
    title: "Nail polish remover manufacturing",
  },
  {
    code: "325620",
    title: "Nail polishes manufacturing",
  },
  {
    code: "325620",
    title: "Perfumes manufacturing",
  },
  {
    code: "325620",
    title: "Permanent wave preparations manufacturing",
  },
  {
    code: "325620",
    title: "Powders (e.g., baby, body, face, talcum, toilet) manufacturing",
  },
  {
    code: "325620",
    title: "Rouge, cosmetic, manufacturing",
  },
  {
    code: "325620",
    title: "Sachet, scented, manufacturing",
  },
  {
    code: "325620",
    title: "Shampoos and conditioners, hair, manufacturing",
  },
  {
    code: "325620",
    title:
      "Shaving preparations (e.g., creams, gels, lotions, powders) manufacturing",
  },
  {
    code: "325620",
    title: "Sunscreen lotions and oils manufacturing",
  },
  {
    code: "325620",
    title: "Suntan lotions and oils manufacturing",
  },
  {
    code: "325620",
    title: "Talcum powders manufacturing",
  },
  {
    code: "325620",
    title: "Tints, dyes, and rinses, hair, manufacturing",
  },
  {
    code: "325620",
    title:
      "Toilet preparations (e.g., cosmetics, deodorants, perfumes) manufacturing",
  },
  {
    code: "325620",
    title: "Toilet water manufacturing",
  },
  {
    code: "325620",
    title: "Towelettes, premoistened, manufacturing",
  },
  {
    code: "325910",
    title: "Bronze printing inks manufacturing",
  },
  {
    code: "325910",
    title: "Duplicating inks manufacturing",
  },
  {
    code: "325910",
    title: "Flexographic inks manufacturing",
  },
  {
    code: "325910",
    title: "Gold printing inks manufacturing",
  },
  {
    code: "325910",
    title: "Gravure inks manufacturing",
  },
  {
    code: "325910",
    title: "Inkjet cartridges manufacturing",
  },
  {
    code: "325910",
    title: "Inkjet inks manufacturing",
  },
  {
    code: "325910",
    title: "Inks, printing, manufacturing",
  },
  {
    code: "325910",
    title: "Letterpress inks manufacturing",
  },
  {
    code: "325910",
    title: "Lithographic inks manufacturing",
  },
  {
    code: "325910",
    title: "Offset inks manufacturing",
  },
  {
    code: "325910",
    title: "Printing inks manufacturing",
  },
  {
    code: "325910",
    title: "Screen process inks manufacturing",
  },
  {
    code: "325910",
    title: "Stencil inks manufacturing",
  },
  {
    code: "325910",
    title: "Textile printing inks manufacturing",
  },
  {
    code: "325920",
    title: "Amatols manufacturing",
  },
  {
    code: "325920",
    title: "Azides explosive materials manufacturing",
  },
  {
    code: "325920",
    title:
      "Blasting accessories (e.g., caps, fuses, ignitors, squibbs) manufacturing",
  },
  {
    code: "325920",
    title: "Blasting powders manufacturing",
  },
  {
    code: "325920",
    title: "Caps, blasting and detonating, manufacturing",
  },
  {
    code: "325920",
    title: "Cordite explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Detonating caps, cord, fuses, and primers manufacturing",
  },
  {
    code: "325920",
    title: "Detonators (except ammunition) manufacturing",
  },
  {
    code: "325920",
    title: "Dynamite manufacturing",
  },
  {
    code: "325920",
    title: "Explosives manufacturing",
  },
  {
    code: "325920",
    title: "Gunpowder manufacturing",
  },
  {
    code: "325920",
    title: "Mannitol hexanitrate explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Mercury fulminate explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Nitrocellulose explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Nitroglycerin explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Nitrostarch explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Pentolite explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Picric acid explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Safety fuses, blasting, manufacturing",
  },
  {
    code: "325920",
    title: "Styphnic acid explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "Tetryl explosive materials manufacturing",
  },
  {
    code: "325920",
    title: "TNT (trinitrotoluene) manufacturing",
  },
  {
    code: "325920",
    title: "Trinitrotoluene (TNT) manufacturing",
  },
  {
    code: "325991",
    title:
      "Custom compounding (i.e., blending and mixing) of purchased plastics resins",
  },
  {
    code: "325991",
    title: "Plastics resins compounding from recycled materials",
  },
  {
    code: "325991",
    title: "Plastics resins, custom compounding of purchased",
  },
  {
    code: "325991",
    title: "Reformulating plastics resins from recycled plastics products",
  },
  {
    code: "325992",
    title: "Computer printer toner cartridges manufacturing",
  },
  {
    code: "325992",
    title: "Developers, prepared photographic, manufacturing",
  },
  {
    code: "325992",
    title:
      "Diazo (i.e., whiteprint) paper and cloth, sensitized, manufacturing",
  },
  {
    code: "325992",
    title: "Driers, photographic chemical, manufacturing",
  },
  {
    code: "325992",
    title: "Facsimile toner cartridges manufacturing",
  },
  {
    code: "325992",
    title:
      "Film, sensitized (e.g., camera, motion picture, X-ray), manufacturing",
  },
  {
    code: "325992",
    title: "Fixers, prepared photographic, manufacturing",
  },
  {
    code: "325992",
    title: "Graphic arts plates, sensitized, manufacturing",
  },
  {
    code: "325992",
    title: "Heat sensitized (i.e., thermal) paper made from purchased paper",
  },
  {
    code: "325992",
    title: "Motion picture film manufacturing",
  },
  {
    code: "325992",
    title: "Paper, photographic sensitized, manufacturing",
  },
  {
    code: "325992",
    title: "Photocopying toner cartridges manufacturing",
  },
  {
    code: "325992",
    title: "Photographic chemicals manufacturing",
  },
  {
    code: "325992",
    title:
      "Photographic film, cloth, paper, and plate, sensitized, manufacturing",
  },
  {
    code: "325992",
    title: "Photomasks manufacturing",
  },
  {
    code: "325992",
    title: "Photosensitized paper manufacturing",
  },
  {
    code: "325992",
    title:
      "Sensitized cloth or paper (e.g., blueprint, photographic) manufacturing",
  },
  {
    code: "325992",
    title: "Toner cartridges manufacturing",
  },
  {
    code: "325992",
    title: "Toner cartridges rebuilding",
  },
  {
    code: "325992",
    title: "Toners, electrostatic and photographic, manufacturing",
  },
  {
    code: "325992",
    title: "X-ray film and plates, sensitized, manufacturing",
  },
  {
    code: "325998",
    title: "Activated carbon or charcoal manufacturing",
  },
  {
    code: "325998",
    title:
      "Additive preparations for gasoline (e.g., antiknock preparations, detergents, gum inhibitors) manufacturing",
  },
  {
    code: "325998",
    title: "Aerosol can filling on a job-order or contract basis",
  },
  {
    code: "325998",
    title: "Aerosol packaging services",
  },
  {
    code: "325998",
    title: "Anise oil manufacturing",
  },
  {
    code: "325998",
    title: "Antifreeze preparations manufacturing",
  },
  {
    code: "325998",
    title: "Antiscaling compounds manufacturing",
  },
  {
    code: "325998",
    title: "Bay oil manufacturing",
  },
  {
    code: "325998",
    title: "Brake fluid, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Cannabidiol (CBD oil) manufacturing",
  },
  {
    code: "325998",
    title: "Caps for toy pistols manufacturing",
  },
  {
    code: "325998",
    title: "Capsules, gelatin, empty, manufacturing",
  },
  {
    code: "325998",
    title: "Carbon, activated, manufacturing",
  },
  {
    code: "325998",
    title: "Carburetor cleaners manufacturing",
  },
  {
    code: "325998",
    title: "Cat litter manufacturing",
  },
  {
    code: "325998",
    title: "Cedar oil manufacturing",
  },
  {
    code: "325998",
    title: "Charcoal, activated, manufacturing",
  },
  {
    code: "325998",
    title: "Citronella oil manufacturing",
  },
  {
    code: "325998",
    title: "Clove oil manufacturing",
  },
  {
    code: "325998",
    title:
      "Concrete additive preparations (e.g., curing, hardening) manufacturing",
  },
  {
    code: "325998",
    title: "Correction fluids (i.e., typewriter) manufacturing",
  },
  {
    code: "325998",
    title: "Crankcase additive preparations manufacturing",
  },
  {
    code: "325998",
    title: "Cutting oils, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Defoamers and antifoaming agents manufacturing",
  },
  {
    code: "325998",
    title: "Degreasing preparations for machinery parts manufacturing",
  },
  {
    code: "325998",
    title: "Deicing preparations manufacturing",
  },
  {
    code: "325998",
    title: "Desalination kits manufacturing",
  },
  {
    code: "325998",
    title: "Distilled water manufacturing",
  },
  {
    code: "325998",
    title: "Drawing inks manufacturing",
  },
  {
    code: "325998",
    title:
      "Drilling mud compounds, conditioners, and additives (except bentonites) manufacturing",
  },
  {
    code: "325998",
    title: "Dye preparations, clothing, household-type, manufacturing",
  },
  {
    code: "325998",
    title:
      "Electronic cigarette vapor liquids, including closed refills, manufacturing",
  },
  {
    code: "325998",
    title: "Embalming fluids manufacturing",
  },
  {
    code: "325998",
    title: "Engine degreasers manufacturing",
  },
  {
    code: "325998",
    title: "Engine starting fluids manufacturing",
  },
  {
    code: "325998",
    title: "Essential oils manufacturing",
  },
  {
    code: "325998",
    title: "Eucalyptus oil manufacturing",
  },
  {
    code: "325998",
    title: "Fire extinguisher chemical preparations manufacturing",
  },
  {
    code: "325998",
    title: "Fire retardant chemical preparations manufacturing",
  },
  {
    code: "325998",
    title: "Fireworks manufacturing",
  },
  {
    code: "325998",
    title: "Flares manufacturing",
  },
  {
    code: "325998",
    title:
      "Fluxes (e.g., brazing, galvanizing, soldering, welding) manufacturing",
  },
  {
    code: "325998",
    title: "Foundry core oil, wash, and wax manufacturing",
  },
  {
    code: "325998",
    title: "Gelatin (except dessert preparations) manufacturing",
  },
  {
    code: "325998",
    title: "Gelatin capsules, empty, manufacturing",
  },
  {
    code: "325998",
    title: "Grapefruit oil manufacturing",
  },
  {
    code: "325998",
    title: "Greases, synthetic lubricating, manufacturing",
  },
  {
    code: "325998",
    title: "Hydraulic fluids, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Incense manufacturing",
  },
  {
    code: "325998",
    title: "Indelible inks manufacturing",
  },
  {
    code: "325998",
    title: "India inks manufacturing",
  },
  {
    code: "325998",
    title: "Industrial salt manufacturing",
  },
  {
    code: "325998",
    title:
      "Inhibitors (e.g., corrosion, oxidation, polymerization) manufacturing",
  },
  {
    code: "325998",
    title: "Inks, writing, manufacturing",
  },
  {
    code: "325998",
    title: "Insulating oils manufacturing",
  },
  {
    code: "325998",
    title: "Lemon oil manufacturing",
  },
  {
    code: "325998",
    title: "Lighter fluids (e.g., charcoal, cigarette) manufacturing",
  },
  {
    code: "325998",
    title: "Lime oil manufacturing",
  },
  {
    code: "325998",
    title: "Lubricating oils and greases, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Matches and match books manufacturing",
  },
  {
    code: "325998",
    title: "Motor oils, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Napalm manufacturing",
  },
  {
    code: "325998",
    title: "Oil additive preparations manufacturing",
  },
  {
    code: "325998",
    title: "Oils (e.g., cutting, lubricating), synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Oils, lubricating, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Orange oil manufacturing",
  },
  {
    code: "325998",
    title: "Orris oil manufacturing",
  },
  {
    code: "325998",
    title: "Ossein manufacturing",
  },
  {
    code: "325998",
    title: "Packer's fluids manufacturing",
  },
  {
    code: "325998",
    title: "Penetrating fluids, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Peppermint oil manufacturing",
  },
  {
    code: "325998",
    title:
      "Pyrotechnics (e.g., flares, flashlight bombs, signals) manufacturing",
  },
  {
    code: "325998",
    title: "Radiator additive preparations manufacturing",
  },
  {
    code: "325998",
    title:
      "Recycling services for degreasing solvents (e.g., engine, machinery) manufacturing",
  },
  {
    code: "325998",
    title:
      "Retarders (e.g., flameproofing agents, mildewproofing agents) manufacturing",
  },
  {
    code: "325998",
    title:
      "Rubber processing preparations (e.g., accelerators, stabilizers) manufacturing",
  },
  {
    code: "325998",
    title: "Rust preventive preparations manufacturing",
  },
  {
    code: "325998",
    title: "Salt (except table) manufacturing",
  },
  {
    code: "325998",
    title: "Soil testing kits manufacturing",
  },
  {
    code: "325998",
    title: "Spearmint oil manufacturing",
  },
  {
    code: "325998",
    title: "Stamp pad ink manufacturing",
  },
  {
    code: "325998",
    title:
      "Sugar substitutes (i.e., synthetic sweeteners blended with other ingredients) made from purchased synthetic sweeteners",
  },
  {
    code: "325998",
    title: "Swimming pool chemical preparations manufacturing",
  },
  {
    code: "325998",
    title:
      "Tint and dye preparations, household-type (except hair), manufacturing",
  },
  {
    code: "325998",
    title: "Tire inflators, aerosol, manufacturing",
  },
  {
    code: "325998",
    title: "Transmission fluids, synthetic, manufacturing",
  },
  {
    code: "325998",
    title: "Water, distilled, manufacturing",
  },
  {
    code: "325998",
    title: "Wintergreen oil manufacturing",
  },
  {
    code: "325998",
    title: "Writing inks manufacturing",
  },
  {
    code: "326111",
    title: "Bags, plastics film, single wall or multiwall, manufacturing",
  },
  {
    code: "326111",
    title:
      "Food storage bags, plastics film, single wall or multiwall, manufacturing",
  },
  {
    code: "326111",
    title:
      "Frozen food bags, plastics film, single wall or multiwall, manufacturing",
  },
  {
    code: "326111",
    title:
      "Grocery bags, plastics film, single wall or multiwall, manufacturing",
  },
  {
    code: "326111",
    title:
      "Merchandise bags, plastics film, single wall or multiwall, manufacturing",
  },
  {
    code: "326111",
    title: "Trash bags, plastics film, single wall or multiwall, manufacturing",
  },
  {
    code: "326112",
    title: "Film, plastics, packaging, manufacturing",
  },
  {
    code: "326112",
    title: "Flexible packaging, plastics film, manufacturing",
  },
  {
    code: "326112",
    title: "Packaging film, plastics, single-web or multiweb, manufacturing",
  },
  {
    code: "326113",
    title:
      "Acrylic film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title:
      "Cellulosic plastics film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title: "Film, plastics (except packaging), manufacturing",
  },
  {
    code: "326113",
    title:
      "Photographic, micrographic, and X-ray plastics, sheet, and film (except sensitized), manufacturing",
  },
  {
    code: "326113",
    title:
      "Plastics film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title:
      "Polyester film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title:
      "Polyethylene film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title:
      "Polypropylene film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title:
      "Polyvinyl film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326113",
    title: "Sheet, plastics, unlaminated (except packaging), manufacturing",
  },
  {
    code: "326113",
    title:
      "Vinyl and vinyl copolymer film and unlaminated sheet (except packaging) manufacturing",
  },
  {
    code: "326121",
    title: "Casings, sausage, nonrigid plastics, manufacturing",
  },
  {
    code: "326121",
    title: "Profile shapes (e.g., rod, tube), nonrigid plastics, manufacturing",
  },
  {
    code: "326121",
    title: "Rod, nonrigid plastics, manufacturing",
  },
  {
    code: "326121",
    title: "Sausage casings, plastics, manufacturing",
  },
  {
    code: "326121",
    title: "Tube, nonrigid plastics, manufacturing",
  },
  {
    code: "326122",
    title: "Fittings and unions, rigid plastics pipe, manufacturing",
  },
  {
    code: "326122",
    title: "Fittings, rigid plastics pipe, manufacturing",
  },
  {
    code: "326122",
    title: "Pipe fittings, rigid plastics, manufacturing",
  },
  {
    code: "326122",
    title: "Pipe, rigid plastics, manufacturing",
  },
  {
    code: "326122",
    title: "PVC pipe manufacturing",
  },
  {
    code: "326130",
    title: "Laminated plastics plate, rod, and sheet, manufacturing",
  },
  {
    code: "326130",
    title: "Plate, laminated plastics, manufacturing",
  },
  {
    code: "326130",
    title:
      "Profile shapes (e.g., plate, rod, sheet), laminated plastics, manufacturing",
  },
  {
    code: "326130",
    title: "Rod, laminated plastics, manufacturing",
  },
  {
    code: "326130",
    title:
      "Sheet, laminated plastics (except flexible packaging), manufacturing",
  },
  {
    code: "326140",
    title: "Coolers or ice chests, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Cups, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Dinnerware, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Foam polystyrene products manufacturing",
  },
  {
    code: "326140",
    title: "Food containers, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Ice buckets, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Ice chests or coolers, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title:
      "Insulation and cushioning, polystyrene foam plastics, manufacturing",
  },
  {
    code: "326140",
    title: "Jugs, vacuum, polystyrene foam plastics, manufacturing",
  },
  {
    code: "326140",
    title: "Plates, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Polystyrene foam packaging manufacturing",
  },
  {
    code: "326140",
    title: "Sheet (i.e., board), polystyrene foam insulation, manufacturing",
  },
  {
    code: "326140",
    title:
      "Shipping pads and shaped cushioning, polystyrene foam, manufacturing",
  },
  {
    code: "326140",
    title: "Thermal insulation, polystyrene foam, manufacturing",
  },
  {
    code: "326150",
    title:
      "Cushions, carpet and rug, urethane and other foam plastics (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title: "Foam plastics products (except polystyrene) manufacturing",
  },
  {
    code: "326150",
    title:
      "Ice buckets, urethane or other plastics foam (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title:
      "Ice chests or coolers, urethane or other plastics foam (except polystyrene) manufacturing",
  },
  {
    code: "326150",
    title:
      "Insulation and cushioning, foam plastics (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title: "Jugs, vacuum, foam plastics (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title: "Packaging, foam plastics (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title: "Polyurethane foam products manufacturing",
  },
  {
    code: "326150",
    title: "Seat cushions, foam plastics (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title:
      "Shipping pads and shaped cushioning, foam plastics (except polystyrene), manufacturing",
  },
  {
    code: "326150",
    title: "Urethane foam products manufacturing",
  },
  {
    code: "326160",
    title: "Bottles, plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Bathtubs, plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Chemical toilets, plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Cultured marble plumbing fixtures manufacturing",
  },
  {
    code: "326191",
    title:
      "Drinking fountains (except mechanically refrigerated), plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Hot tubs, plastics or fiberglass, manufacturing",
  },
  {
    code: "326191",
    title: "Laundry tubs, plastics, manufacturing",
  },
  {
    code: "326191",
    title:
      "Plumbing fixtures (e.g., shower stalls, toilets, urinals), plastics or fiberglass, manufacturing",
  },
  {
    code: "326191",
    title: "Portable toilets, plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Shower stalls, plastics or fiberglass, manufacturing",
  },
  {
    code: "326191",
    title: "Sinks, plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Toilet fixtures, plastics, manufacturing",
  },
  {
    code: "326191",
    title: "Urinals, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Awnings, rigid plastics or fiberglass, manufacturing",
  },
  {
    code: "326199",
    title: "Badges, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Balloons, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Bathroom and toilet accessories, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Bolts, nuts, and rivets, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Bottle caps and lids, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Bowls and bowl covers, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Bubble packaging materials, plastics, manufacturing",
  },
  {
    code: "326199",
    title:
      "Building materials (e.g., fascia, panels, siding, soffit), plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Building panels, corrugated and flat, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Bushings, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Cigar and cigarette holders, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Clothes hangers, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Clothespins, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Combs, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Coolers or ice chests, plastics (except foam), manufacturing",
  },
  {
    code: "326199",
    title: "Countertops, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Credit and identification card stock, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Cultured marble products (except plumbing fixtures) manufacturing",
  },
  {
    code: "326199",
    title: "Cultured stone products (except plumbing fixtures) manufacturing",
  },
  {
    code: "326199",
    title: "Cups, plastics (except foam), manufacturing",
  },
  {
    code: "326199",
    title: "Dinnerware, plastics (except polystyrene foam), manufacturing",
  },
  {
    code: "326199",
    title: "Doormats, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Doors and door frames, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Drums, plastics (i.e., containers), manufacturing",
  },
  {
    code: "326199",
    title: "Floor coverings, linoleum, manufacturing",
  },
  {
    code: "326199",
    title: "Floor coverings, resilient, manufacturing",
  },
  {
    code: "326199",
    title: "Floor coverings, rubber, manufacturing",
  },
  {
    code: "326199",
    title: "Floor coverings, vinyl, manufacturing",
  },
  {
    code: "326199",
    title: "Footwear parts (e.g., heels, soles), plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Fruits and vegetables, artificial, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Gloves, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Gutters and down spouts, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Hampers, laundry, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Handles (e.g., brush, tool, umbrella), plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Hardware, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Ice buckets, plastics (except foam), manufacturing",
  },
  {
    code: "326199",
    title:
      "Ice chests or coolers, plastics (except plastics foam), manufacturing",
  },
  {
    code: "326199",
    title: "Jars, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Kitchen utensils, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Ladders, fiberglass, manufacturing",
  },
  {
    code: "326199",
    title: "Lamp shades, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Lens blanks, plastics ophthalmic or optical, manufacturing",
  },
  {
    code: "326199",
    title: "Linoleum floor coverings manufacturing",
  },
  {
    code: "326199",
    title: "Mattresses, air, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Microwaveware, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Motor vehicle moldings and extrusions, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Netting, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Nozzles, aerosol spray, plastics, manufacturing",
  },
  {
    code: "326199",
    title:
      "Organizers for closets, drawers, and shelves, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Packaging, plastics (e.g., blister, bubble), manufacturing",
  },
  {
    code: "326199",
    title: "Pails, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Paint sticks, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Picnic jugs, plastics (except foam), manufacturing",
  },
  {
    code: "326199",
    title: "Prefabricated buildings, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Radio housings, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Reels, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Reflectors, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Resilient floor coverings (e.g., sheet, tile) manufacturing",
  },
  {
    code: "326199",
    title: "Rubber floor coverings manufacturing",
  },
  {
    code: "326199",
    title: "Rulers, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Screening, window, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Septic tanks, plastics or fiberglass, manufacturing",
  },
  {
    code: "326199",
    title: "Shoe parts (e.g., heels, soles), plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Shutters, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Siding, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Sponges, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Swimming pool covers and liners, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Swimming pools, fiberglass, manufacturing",
  },
  {
    code: "326199",
    title: "Tanks, storage, plastics or fiberglass, manufacturing",
  },
  {
    code: "326199",
    title: "Television housings, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Tiles, floor (i.e., linoleum, rubber, vinyl), manufacturing",
  },
  {
    code: "326199",
    title: "Tires, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Trash containers, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Tumblers, plastics, manufacturing",
  },
  {
    code: "326199",
    title:
      "Utility containers (e.g., baskets, bins, boxes, buckets, dishpans, pails), plastics (except foam), manufacturing",
  },
  {
    code: "326199",
    title: "Vinyl floor coverings manufacturing",
  },
  {
    code: "326199",
    title: "Watch crystals, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Watering cans, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Window sashes, vinyl, manufacturing",
  },
  {
    code: "326199",
    title: "Windows and window frames, plastics, manufacturing",
  },
  {
    code: "326199",
    title: "Windows and window frames, vinyl, manufacturing",
  },
  {
    code: "326199",
    title: "Windshields, plastics, manufacturing",
  },
  {
    code: "326211",
    title: "Aircraft tire manufacturing",
  },
  {
    code: "326211",
    title: "Camelback (i.e., retreading material) manufacturing",
  },
  {
    code: "326211",
    title: "Inner tubes manufacturing",
  },
  {
    code: "326211",
    title: "Motor vehicle tires manufacturing",
  },
  {
    code: "326211",
    title: "Retreading materials, tire, manufacturing",
  },
  {
    code: "326211",
    title: "Tire repair materials manufacturing",
  },
  {
    code: "326211",
    title:
      "Tires (e.g., pneumatic, semi-pneumatic, solid rubber) manufacturing",
  },
  {
    code: "326211",
    title: "Tread rubber (i.e., camelback) manufacturing",
  },
  {
    code: "326212",
    title: "Rebuilding tires",
  },
  {
    code: "326212",
    title: "Recapping tires",
  },
  {
    code: "326212",
    title: "Retreading tires",
  },
  {
    code: "326212",
    title: "Tire retreading, recapping or rebuilding",
  },
  {
    code: "326220",
    title:
      "Belting, rubber (e.g., conveyor, elevator, transmission), manufacturing",
  },
  {
    code: "326220",
    title: "Conveyor belts, rubber, manufacturing",
  },
  {
    code: "326220",
    title: "Fan belts, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Garden hose, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Hoses, reinforced, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Hoses, rubberized fabric, manufacturing",
  },
  {
    code: "326220",
    title:
      "Hydraulic hoses (without fitting), rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Motor vehicle belts, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Motor vehicle hoses, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title:
      "Plastics and rubber belts and hoses (without fittings) manufacturing",
  },
  {
    code: "326220",
    title:
      "Pneumatic hose (without fittings), rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Radiator and heater hoses, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title:
      "Rubber and plastics belts and hoses (without fittings) manufacturing",
  },
  {
    code: "326220",
    title: "Timing belt, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Transmission belts, rubber, manufacturing",
  },
  {
    code: "326220",
    title: "Vacuum cleaner belts, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "V-belts, rubber or plastics, manufacturing",
  },
  {
    code: "326220",
    title: "Water hoses, rubber or plastics, manufacturing",
  },
  {
    code: "326291",
    title: "Extruded, molded or lathe-cut rubber goods manufacturing",
  },
  {
    code: "326291",
    title:
      "Mechanical rubber goods (i.e., extruded, lathe-cut, molded) manufacturing",
  },
  {
    code: "326291",
    title:
      "Rubber goods, mechanical (i.e.,  extruded, lathe-cut, molded), manufacturing",
  },
  {
    code: "326299",
    title: "Balloons, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Bath mats, rubber, manufacturing",
  },
  {
    code: "326299",
    title:
      "Birth control devices (i.e., diaphragms, prophylactics) manufacturing",
  },
  {
    code: "326299",
    title: "Brushes, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Combs, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Condom manufacturing",
  },
  {
    code: "326299",
    title: "Curlers, hair, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Diaphragms (i.e., birth control device), rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Doormats, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Erasers, rubber or rubber and abrasive combined, manufacturing",
  },
  {
    code: "326299",
    title: "Floor mats (e.g., bath, door), rubber, manufacturing",
  },
  {
    code: "326299",
    title:
      "Footwear parts (e.g., heels, soles, soling strips), rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Fuel bladders, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Grips and handles, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Grommets, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Hair care products (e.g., combs, curlers), rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Hairpins, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Hot water bottles, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Latex foam rubber manufacturing",
  },
  {
    code: "326299",
    title: "Latex foam rubber products manufacturing",
  },
  {
    code: "326299",
    title: "Mattress protectors, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Mattresses, air, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Nipples and teething rings, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Pacifiers, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Pipe bits and stems, tobacco, hard rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Prophylactics manufacturing",
  },
  {
    code: "326299",
    title: "Rafts, swimming pool-type, rubber inflatable, manufacturing",
  },
  {
    code: "326299",
    title: "Reclaiming rubber from waste or scrap",
  },
  {
    code: "326299",
    title: "Rods, hard rubber, manufacturing",
  },
  {
    code: "326299",
    title:
      "Rolls and roll coverings, rubber (e.g., industrial, papermill, painters', steelmill) manufacturing",
  },
  {
    code: "326299",
    title: "Roofing (i.e., single ply rubber membrane) manufacturing",
  },
  {
    code: "326299",
    title: "Rubber bands manufacturing",
  },
  {
    code: "326299",
    title: "Rubber tubing manufacturing",
  },
  {
    code: "326299",
    title: "Sheeting, rubber, manufacturing",
  },
  {
    code: "326299",
    title:
      "Shoe and boot parts (e.g., heels, soles, soling strips), rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Spatulas, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Sponges, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Stair treads, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Stoppers, rubber, manufacturing",
  },
  {
    code: "326299",
    title: "Thread, rubber (except fabric covered), manufacturing",
  },
  {
    code: "327110",
    title: "Advanced and technical ceramic products manufacturing",
  },
  {
    code: "327110",
    title: "Alumina porcelain insulators manufacturing",
  },
  {
    code: "327110",
    title: "Architectural sculptures, clay, manufacturing",
  },
  {
    code: "327110",
    title: "Ashtrays, pottery, manufacturing",
  },
  {
    code: "327110",
    title:
      "Bathroom accessories, vitreous china and earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Beryllia porcelain insulators manufacturing",
  },
  {
    code: "327110",
    title: "Bidets, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Bone china manufacturing",
  },
  {
    code: "327110",
    title: "Chemical stoneware (i.e., pottery products) manufacturing",
  },
  {
    code: "327110",
    title: "China cooking ware manufacturing",
  },
  {
    code: "327110",
    title: "China tableware, vitreous, manufacturing",
  },
  {
    code: "327110",
    title: "Clay and ceramic statuary manufacturing",
  },
  {
    code: "327110",
    title: "Cones, pyrometric, earthenware, manufacturing",
  },
  {
    code: "327110",
    title:
      "Cooking ware (e.g., stoneware, coarse earthenware, pottery), manufacturing",
  },
  {
    code: "327110",
    title: "Cooking ware, china, manufacturing",
  },
  {
    code: "327110",
    title: "Cooking ware, fine earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Crockery manufacturing",
  },
  {
    code: "327110",
    title: "Decalcomania on china and glass for the trade",
  },
  {
    code: "327110",
    title:
      "Decorating china (e.g., encrusting gold, silver, other metal on china) for the trade",
  },
  {
    code: "327110",
    title: "Dishes, pottery, manufacturing",
  },
  {
    code: "327110",
    title:
      "Drinking fountains, vitreous china, non-refrigerated, manufacturing",
  },
  {
    code: "327110",
    title: "Earthenware table and kitchen articles, coarse, manufacturing",
  },
  {
    code: "327110",
    title: "Earthenware, commercial and household, semivitreous, manufacturing",
  },
  {
    code: "327110",
    title: "Ecclesiastical statuary, clay, manufacturing",
  },
  {
    code: "327110",
    title: "Electrical insulators, ceramic, manufacturing",
  },
  {
    code: "327110",
    title: "Electrical supplies, ceramic, manufacturing",
  },
  {
    code: "327110",
    title: "Faucet handles, vitreous china and earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Filtering media, pottery, manufacturing",
  },
  {
    code: "327110",
    title: "Firing china for the trade",
  },
  {
    code: "327110",
    title: "Florists' articles, red earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Flower pots, red earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Forms for dipped rubber products, pottery, manufacturing",
  },
  {
    code: "327110",
    title: "Garden pottery manufacturing",
  },
  {
    code: "327110",
    title: "Handles, faucet, vitreous china and earthenware, manufacturing",
  },
  {
    code: "327110",
    title:
      "Hotel tableware and kitchen articles, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Household-type earthenware, semivitreous, manufacturing",
  },
  {
    code: "327110",
    title:
      "Household-type tableware and kitchen articles, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Insulators, electrical porcelain, manufacturing",
  },
  {
    code: "327110",
    title: "Kitchen articles, coarse earthenware, manufacturing",
  },
  {
    code: "327110",
    title:
      "Kitchenware, commercial and household-type, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Kitchenware, semivitreous earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Lamp bases, pottery, manufacturing",
  },
  {
    code: "327110",
    title: "Lavatories, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Magnets, permanent, ceramic or ferrite, manufacturing",
  },
  {
    code: "327110",
    title: "Plumbing fixtures, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title:
      "Porcelain parts, electrical and electronic device, molded, manufacturing",
  },
  {
    code: "327110",
    title: "Porcelain, chemical, manufacturing",
  },
  {
    code: "327110",
    title: "Pottery made and sold on site ",
  },
  {
    code: "327110",
    title: "Pottery products manufacturing",
  },
  {
    code: "327110",
    title: "Pyrometer tubes manufacturing",
  },
  {
    code: "327110",
    title: "Pyrometric cones, earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Sculptures, architectural, clay, manufacturing",
  },
  {
    code: "327110",
    title: "Sinks, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Soap dishes, vitreous china and earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Spark plug insulators, porcelain, manufacturing",
  },
  {
    code: "327110",
    title: "Stationery articles, pottery, manufacturing",
  },
  {
    code: "327110",
    title: "Statuary, clay and ceramic, manufacturing",
  },
  {
    code: "327110",
    title: "Steatite porcelain insulators manufacturing",
  },
  {
    code: "327110",
    title: "Stoneware (i.e., pottery products) manufacturing",
  },
  {
    code: "327110",
    title: "Table articles, coarse earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Table articles, earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Table articles, fine earthenware (i.e., whiteware), manufacturing",
  },
  {
    code: "327110",
    title: "Table articles, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Tableware, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Tanks, flush, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Textile guides, porcelain, manufacturing",
  },
  {
    code: "327110",
    title: "Titania porcelain insulators manufacturing",
  },
  {
    code: "327110",
    title: "Toilet fixtures, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title: "Towel bar holders, vitreous china and earthenware, manufacturing",
  },
  {
    code: "327110",
    title: "Urinals, vitreous china, manufacturing",
  },
  {
    code: "327110",
    title:
      "Vases, pottery (e.g., china, earthenware, stoneware), manufacturing",
  },
  {
    code: "327110",
    title: "Water closet bowls, vitreous china, manufacturing",
  },
  {
    code: "327120",
    title: "Adobe bricks manufacturing",
  },
  {
    code: "327120",
    title: "Alumina fused refractories manufacturing",
  },
  {
    code: "327120",
    title: "Aluminous refractory cement manufacturing",
  },
  {
    code: "327120",
    title: "Architectural terra cotta manufacturing",
  },
  {
    code: "327120",
    title: "Bauxite brick manufacturing",
  },
  {
    code: "327120",
    title: "Blocks, fire clay, manufacturing",
  },
  {
    code: "327120",
    title:
      "Bricks (i.e., common, face, glazed, hollow, vitrified), clay, manufacturing",
  },
  {
    code: "327120",
    title: "Bricks, adobe, manufacturing",
  },
  {
    code: "327120",
    title: "Bricks, clay refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Bricks, nonclay refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Building tile, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Carbon brick manufacturing",
  },
  {
    code: "327120",
    title: "Castable refractories, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Castable refractories, nonclay, manufacturing",
  },
  {
    code: "327120",
    title: "Cement, clay refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Ceramic tiles, floor and wall, manufacturing",
  },
  {
    code: "327120",
    title: "Clay refractories (e.g., mortar, brick, tile, block) manufacturing",
  },
  {
    code: "327120",
    title: "Conduit, vitrified clay, manufacturing",
  },
  {
    code: "327120",
    title: "Coping, wall, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Crucibles, fire clay, manufacturing",
  },
  {
    code: "327120",
    title:
      "Crucibles, graphite, magnesite, chrome, silica, or other nonclay materials, manufacturing",
  },
  {
    code: "327120",
    title: "Drain tile, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Firebrick, clay refractories, manufacturing",
  },
  {
    code: "327120",
    title: "Floaters, glasshouse, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Floor tile, ceramic, manufacturing",
  },
  {
    code: "327120",
    title: "Flue lining, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Glasshouse refractories manufacturing",
  },
  {
    code: "327120",
    title: "Insulating firebrick and shapes, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Kiln furniture, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Liner brick and plates, vitrified clay, manufacturing",
  },
  {
    code: "327120",
    title: "Magnesia refractory cement manufacturing",
  },
  {
    code: "327120",
    title: "Mortar, nonclay refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Mortars, clay refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Mosaic tile, ceramic, manufacturing",
  },
  {
    code: "327120",
    title:
      "Nonclay refractories (e.g., block, brick, mortar, tile) manufacturing",
  },
  {
    code: "327120",
    title: "Paving brick, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Pots, glasshouse, clay refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Quarry tiles, clay, manufacturing",
  },
  {
    code: "327120",
    title:
      "Refractories (e.g., block, brick, mortar, tile), clay, manufacturing",
  },
  {
    code: "327120",
    title:
      "Refractories (e.g., block, brick, mortar, tile), nonclay, manufacturing",
  },
  {
    code: "327120",
    title: "Refractory cement, nonclay, manufacturing",
  },
  {
    code: "327120",
    title: "Roofing tile, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Sewer pipe and fittings, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Stove lining, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Structural clay tile manufacturing",
  },
  {
    code: "327120",
    title: "Tile, ceramic wall and floor, manufacturing",
  },
  {
    code: "327120",
    title: "Tile, clay, refractory, manufacturing",
  },
  {
    code: "327120",
    title: "Tile, clay, structural, manufacturing",
  },
  {
    code: "327120",
    title: "Tile, roofing and drain, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Tile, sewer, clay, manufacturing",
  },
  {
    code: "327120",
    title: "Wall tile, ceramic, manufacturing",
  },
  {
    code: "327211",
    title: "Flat glass (e.g., float, plate) manufacturing",
  },
  {
    code: "327211",
    title: "Glass, plate, made in glass making plants",
  },
  {
    code: "327211",
    title: "Insulating glass, sealed units, made in glass making plants",
  },
  {
    code: "327211",
    title: "Laminated glass made in glass making plants",
  },
  {
    code: "327211",
    title:
      "Stained glass and stained glass products made in glass making plants",
  },
  {
    code: "327212",
    title: "Ashtrays, glass, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Blanks for electric light bulbs, glass, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Blanks, ophthalmic lens and optical glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Blocks, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Bricks, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Christmas tree ornaments, glass, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Cooking utensils, glass and glass ceramic, made in glass making plants",
  },
  {
    code: "327212",
    title: "Cooking ware made in glass making plants",
  },
  {
    code: "327212",
    title: "Decorative glassware made in glass making plants",
  },
  {
    code: "327212",
    title: "Electron tube parts, glass blanks, made in glass making plants",
  },
  {
    code: "327212",
    title: "Fibers, glass, textile, made in glass making plants",
  },
  {
    code: "327212",
    title: "Fruits, artificial, made in glass making plants",
  },
  {
    code: "327212",
    title: "Glass blanks for electric light bulbs made in glass making plants",
  },
  {
    code: "327212",
    title: "Glass fiber, optical, made in glass making plants",
  },
  {
    code: "327212",
    title: "Glass fiber, textile type, made in glass making plants",
  },
  {
    code: "327212",
    title: "Glass fiber, unsheathed, made in glass making plants",
  },
  {
    code: "327212",
    title: "Glass making and blowing by hand",
  },
  {
    code: "327212",
    title:
      "Glass products (except packaging containers) made in a glass making plants",
  },
  {
    code: "327212",
    title: "Glass, automotive, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Glassware for industrial, scientific, and technical use made in glass making plants",
  },
  {
    code: "327212",
    title: "Glassware for lighting fixtures made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Glassware, art, decorative, and novelty made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Industrial glassware and glass products, pressed or blown, made in glass making plants",
  },
  {
    code: "327212",
    title: "Insulators, electrical, glass, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Laboratory glassware (e.g., beakers, test tubes, vials) made in glass making plants",
  },
  {
    code: "327212",
    title: "Lamp shades made in glass making plants",
  },
  {
    code: "327212",
    title: "Lens blanks, optical and ophthalmic, made in glass making plants",
  },
  {
    code: "327212",
    title: "Medical glassware made in glass making plants",
  },
  {
    code: "327212",
    title: "Ornaments, Christmas tree, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Ovenware, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Photomask blanks, glass, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Scientific glassware, pressed or blown, made in glass making plants",
  },
  {
    code: "327212",
    title: "Stemware, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Tableware made in glass making plants",
  },
  {
    code: "327212",
    title: "Teakettles, glass and glass ceramic, made in glass making plants",
  },
  {
    code: "327212",
    title:
      "Technical glassware and glass products, pressed or blown, made in glass making plants",
  },
  {
    code: "327212",
    title: "Textile glass fibers made in glass making plants",
  },
  {
    code: "327212",
    title: "Vacuum tube blanks, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Vases, glass, made in glass making plants",
  },
  {
    code: "327212",
    title: "Yarn, fiberglass, made in glass making plants",
  },
  {
    code: "327213",
    title: "Beer bottles, glass, manufacturing",
  },
  {
    code: "327213",
    title: "Beverage containers, glass, manufacturing",
  },
  {
    code: "327213",
    title: "Bottles (i.e., bottling, canning, packaging), glass, manufacturing",
  },
  {
    code: "327213",
    title:
      "Containers for packaging, bottling, and canning, glass, manufacturing",
  },
  {
    code: "327213",
    title: "Food packaging, glass, manufacturing",
  },
  {
    code: "327213",
    title: "Glass packaging containers manufacturing",
  },
  {
    code: "327213",
    title: "Jars for packaging, bottling, and canning, glass, manufacturing",
  },
  {
    code: "327213",
    title: "Soda bottles, glass, manufacturing",
  },
  {
    code: "327215",
    title: "Aquariums made from purchased glass",
  },
  {
    code: "327215",
    title: "Ashtrays made from purchased glass",
  },
  {
    code: "327215",
    title:
      "Blanks, ophthalmic lens and optical glass, made from purchased glass",
  },
  {
    code: "327215",
    title: "Bricks, glass, made from purchased glass",
  },
  {
    code: "327215",
    title: "Christmas tree ornaments made from purchased glass",
  },
  {
    code: "327215",
    title: "Cooking ware made from purchased glass",
  },
  {
    code: "327215",
    title: "Cut and engraved glassware made from purchased glass",
  },
  {
    code: "327215",
    title: "Cutting, engraving, etching, painting or polishing purchased glass",
  },
  {
    code: "327215",
    title: "Decorated glassware made from purchased glass",
  },
  {
    code: "327215",
    title: "Doors, unframed glass, made from purchased glass",
  },
  {
    code: "327215",
    title: "Electron tube parts, glass blanks, made from purchased glass",
  },
  {
    code: "327215",
    title: "Fruits, artificial, made from purchased glass",
  },
  {
    code: "327215",
    title:
      "Furniture tops, glass (e.g., beveled, cut, polished), made from purchased glass",
  },
  {
    code: "327215",
    title: "Glass blanks for electric light bulbs made from purchased glass",
  },
  {
    code: "327215",
    title:
      "Glass products (except packaging containers) made from purchased glass",
  },
  {
    code: "327215",
    title: "Glass, automotive, made from purchased glass",
  },
  {
    code: "327215",
    title:
      "Glassware for industrial, scientific, and technical use made from purchased glass",
  },
  {
    code: "327215",
    title: "Glassware for lighting fixtures made from purchased glass",
  },
  {
    code: "327215",
    title: "Glassware, art decorative and novelty, made from purchased glass",
  },
  {
    code: "327215",
    title: "Glassware, cutting and engraving, made from purchased glass",
  },
  {
    code: "327215",
    title: "Hand blowing purchased glass",
  },
  {
    code: "327215",
    title: "Industrial glassware made from purchased glass",
  },
  {
    code: "327215",
    title: "Insulating glass, sealed units, made from purchased glass",
  },
  {
    code: "327215",
    title: "Insulators, electrical, glass, made from purchased glass",
  },
  {
    code: "327215",
    title:
      "Laboratory glassware (e.g., beakers, test tubes, vials) made from purchased glass",
  },
  {
    code: "327215",
    title: "Laminated glass made from purchased glass",
  },
  {
    code: "327215",
    title: "Lamp shades made from purchased glass",
  },
  {
    code: "327215",
    title: "Lens blanks, optical and ophthalmic, made from purchased glass",
  },
  {
    code: "327215",
    title: "Medical glassware made from purchased glass",
  },
  {
    code: "327215",
    title:
      "Mirrors, framed (except automotive) or unframed, made from purchased glass",
  },
  {
    code: "327215",
    title: "Ornaments, Christmas tree, made from purchased glass",
  },
  {
    code: "327215",
    title: "Ovenware made from purchased glass",
  },
  {
    code: "327215",
    title: "Safety glass (including motor vehicle) made from purchased glass",
  },
  {
    code: "327215",
    title: "Scientific apparatus glassware made from purchased glass",
  },
  {
    code: "327215",
    title: "Scientific glassware made from purchased glass",
  },
  {
    code: "327215",
    title: "Stained glass products made from purchased glass",
  },
  {
    code: "327215",
    title: "Stemware made from purchased glass",
  },
  {
    code: "327215",
    title: "Tableware made from purchased glass",
  },
  {
    code: "327215",
    title: "Technical glassware made from purchased glass",
  },
  {
    code: "327215",
    title: "Tempered glass made from purchased glass",
  },
  {
    code: "327215",
    title: "Vacuum tube blanks, glass, made from purchased glass",
  },
  {
    code: "327215",
    title: "Vases, glass, made from purchased glass",
  },
  {
    code: "327215",
    title: "Watch crystals made from purchased glass",
  },
  {
    code: "327310",
    title:
      "Cement (e.g., hydraulic, masonry, Portland, pozzolana) manufacturing",
  },
  {
    code: "327310",
    title: "Cement clinker manufacturing",
  },
  {
    code: "327310",
    title: "Natural (i.e., calcined earth) cement manufacturing",
  },
  {
    code: "327320",
    title: "Central-mixed concrete manufacturing",
  },
  {
    code: "327320",
    title: "Concrete batch plants (including temporary)",
  },
  {
    code: "327320",
    title: "Ready-mix concrete manufacturing and distributing",
  },
  {
    code: "327320",
    title: "Transit-mixed concrete manufacturing",
  },
  {
    code: "327320",
    title: "Truck-mixed concrete manufacturing",
  },
  {
    code: "327331",
    title:
      "Architectural block, concrete (e.g., fluted, ground face, screen, slump, split), manufacturing",
  },
  {
    code: "327331",
    title: "Blocks, concrete and cinder, manufacturing",
  },
  {
    code: "327331",
    title: "Bricks, concrete, manufacturing",
  },
  {
    code: "327331",
    title: "Cinder (clinker) block, concrete, manufacturing",
  },
  {
    code: "327331",
    title: "Patio block, concrete, manufacturing",
  },
  {
    code: "327331",
    title: "Paving blocks, concrete, manufacturing",
  },
  {
    code: "327331",
    title: "Plinth blocks, precast terrazzo, manufacturing",
  },
  {
    code: "327331",
    title: "Precast concrete block and brick manufacturing",
  },
  {
    code: "327331",
    title: "Prestressed concrete blocks or bricks manufacturing",
  },
  {
    code: "327331",
    title: "Slumped brick manufacturing",
  },
  {
    code: "327332",
    title: "Conduits, concrete, manufacturing",
  },
  {
    code: "327332",
    title: "Culvert pipe, concrete, manufacturing",
  },
  {
    code: "327332",
    title: "Cylinder pipe, prestressed concrete, manufacturing",
  },
  {
    code: "327332",
    title: "Irrigation pipe, concrete, manufacturing",
  },
  {
    code: "327332",
    title: "Pipe, concrete, manufacturing",
  },
  {
    code: "327332",
    title: "Precast concrete pipe manufacturing",
  },
  {
    code: "327332",
    title: "Pressure pipe, reinforced concrete, manufacturing",
  },
  {
    code: "327332",
    title: "Prestressed concrete pipes manufacturing",
  },
  {
    code: "327332",
    title: "Sewer pipe, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Architectural wall panels, precast concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Burial vaults, concrete and precast terrazzo, manufacturing",
  },
  {
    code: "327390",
    title: "Cast stone, concrete (except structural), manufacturing",
  },
  {
    code: "327390",
    title: "Chimney caps, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Concrete furniture (e.g., benches, tables) manufacturing",
  },
  {
    code: "327390",
    title:
      "Concrete products, precast (except block, brick and pipe), manufacturing",
  },
  {
    code: "327390",
    title: "Concrete tanks manufacturing",
  },
  {
    code: "327390",
    title: "Copings, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Garbage incinerators, precast concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Garden furniture, precast concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Girders and beams, prestressed concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Girders, prestressed concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Incinerators, precast concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Lintels, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Ornamental and statuary precast concrete products manufacturing",
  },
  {
    code: "327390",
    title: "Poles, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Posts, concrete, manufacturing",
  },
  {
    code: "327390",
    title:
      "Precast concrete products (except brick, block, pipe) manufacturing",
  },
  {
    code: "327390",
    title:
      "Prestressed concrete products (except blocks, bricks, pipes) manufacturing",
  },
  {
    code: "327390",
    title: "Roofing tile, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Sills, concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Silos, prefabricated concrete, manufacturing",
  },
  {
    code: "327390",
    title: "Tanks, concrete, manufacturing",
  },
  {
    code: "327390",
    title:
      "Terrazzo products, precast (except brick, block and pipe), manufacturing",
  },
  {
    code: "327390",
    title: "Ties, concrete, railroad, manufacturing",
  },
  {
    code: "327410",
    title: "Agricultural lime manufacturing",
  },
  {
    code: "327410",
    title: "Calcium hydroxide (i.e., hydrated lime) manufacturing",
  },
  {
    code: "327410",
    title: "Calcium oxide (i.e., quicklime) manufacturing",
  },
  {
    code: "327410",
    title: "Dolomite, dead-burned, manufacturing",
  },
  {
    code: "327410",
    title: "Dolomitic lime manufacturing",
  },
  {
    code: "327410",
    title: "Hydrated lime (i.e., calcium hydroxide) manufacturing",
  },
  {
    code: "327410",
    title: "Lime production",
  },
  {
    code: "327410",
    title: "Quicklime (i.e., calcium oxide) manufacturing",
  },
  {
    code: "327420",
    title: "Art goods (e.g., gypsum, plaster of paris) manufacturing",
  },
  {
    code: "327420",
    title: "Board, gypsum, manufacturing",
  },
  {
    code: "327420",
    title: "Cement, Keene's (i.e., tiling plaster), manufacturing",
  },
  {
    code: "327420",
    title: "Columns, architectural or ornamental plaster work, manufacturing",
  },
  {
    code: "327420",
    title: "Ecclesiastical statuary, gypsum, manufacturing",
  },
  {
    code: "327420",
    title: "Flower boxes, plaster of paris, manufacturing",
  },
  {
    code: "327420",
    title: "Fountains, plaster of paris, manufacturing",
  },
  {
    code: "327420",
    title: "Gypsum building products manufacturing",
  },
  {
    code: "327420",
    title:
      "Gypsum products (e.g., block, board, plaster, lath, rock, tile) manufacturing",
  },
  {
    code: "327420",
    title: "Gypsum statuary manufacturing",
  },
  {
    code: "327420",
    title: "Images, small gypsum, manufacturing",
  },
  {
    code: "327420",
    title: "Joint compounds, gypsum based, manufacturing",
  },
  {
    code: "327420",
    title: "Keene's cement manufacturing",
  },
  {
    code: "327420",
    title: "Lath, gypsum, manufacturing",
  },
  {
    code: "327420",
    title:
      "Ornamental and architectural plaster work (e.g., columns, mantels, molding) manufacturing",
  },
  {
    code: "327420",
    title: "Orthopedic plaster, gypsum, manufacturing",
  },
  {
    code: "327420",
    title: "Plaster and plasterboard, gypsum, manufacturing",
  },
  {
    code: "327420",
    title: "Plaster of paris manufacturing",
  },
  {
    code: "327420",
    title:
      "Plaster of paris products (e.g., columns, statuary, urns) manufacturing",
  },
  {
    code: "327420",
    title: "Plaster, gypsum, manufacturing",
  },
  {
    code: "327420",
    title: "Sculptures (e.g., gypsum, plaster of paris) manufacturing",
  },
  {
    code: "327420",
    title: "Statuary (e.g., gypsum, plaster of paris) manufacturing",
  },
  {
    code: "327420",
    title: "Urns (e.g., gypsum, plaster of paris) manufacturing",
  },
  {
    code: "327420",
    title: "Vases (e.g., gypsum, plaster of paris) manufacturing",
  },
  {
    code: "327420",
    title: "Wallboard, gypsum, manufacturing",
  },
  {
    code: "327910",
    title: "Abrasive products manufacturing",
  },
  {
    code: "327910",
    title: "Aluminum oxide (fused) abrasives manufacturing",
  },
  {
    code: "327910",
    title:
      "Buffing and polishing wheels, abrasive and nonabrasive, manufacturing",
  },
  {
    code: "327910",
    title:
      "Cloth (e.g., aluminum oxide, garnet, emery, silicon carbide), abrasive-coated, made from purchased cloth",
  },
  {
    code: "327910",
    title: "Diamond dressing wheels manufacturing",
  },
  {
    code: "327910",
    title: "Grains, abrasive, natural and artificial, manufacturing",
  },
  {
    code: "327910",
    title: "Grinding balls, ceramic, manufacturing",
  },
  {
    code: "327910",
    title: "Grinding wheels manufacturing",
  },
  {
    code: "327910",
    title:
      "Paper (e.g., aluminum oxide, emery, garnet, silicon carbide), abrasive-coated, made from purchased paper",
  },
  {
    code: "327910",
    title: "Polishing wheels manufacturing",
  },
  {
    code: "327910",
    title: "Pumice and pumicite abrasives manufacturing",
  },
  {
    code: "327910",
    title: "Sandpaper manufacturing",
  },
  {
    code: "327910",
    title: "Silicon carbide abrasives manufacturing",
  },
  {
    code: "327910",
    title: "Steel shot abrasives manufacturing",
  },
  {
    code: "327910",
    title: "Wheels, abrasive, manufacturing",
  },
  {
    code: "327910",
    title: "Wheels, polishing and grinding, manufacturing",
  },
  {
    code: "327910",
    title: "Whetstones manufacturing",
  },
  {
    code: "327991",
    title: "Architectural sculptures, stone, manufacturing",
  },
  {
    code: "327991",
    title: "Baptismal fonts, cut stone, manufacturing",
  },
  {
    code: "327991",
    title: "Blackboards, unframed, slate, manufacturing",
  },
  {
    code: "327991",
    title: "Burial vaults, stone, manufacturing",
  },
  {
    code: "327991",
    title: "Countertops, stone, manufacturing",
  },
  {
    code: "327991",
    title: "Curbing, granite and stone, manufacturing",
  },
  {
    code: "327991",
    title:
      "Cut stone bases (e.g., desk sets pedestals, lamps, plaques and similar small particles) manufacturing",
  },
  {
    code: "327991",
    title: "Cut stone products (e.g., blocks, statuary) manufacturing",
  },
  {
    code: "327991",
    title: "Dimension stone dressing and manufacturing",
  },
  {
    code: "327991",
    title: "Dimension stone for buildings manufacturing",
  },
  {
    code: "327991",
    title: "Ecclesiastical statuary, stone, manufacturing",
  },
  {
    code: "327991",
    title: "Flagstones cutting",
  },
  {
    code: "327991",
    title:
      "Furniture, cut stone (i.e., benches, tables, church), manufacturing",
  },
  {
    code: "327991",
    title: "Garden furniture, stone, manufacturing",
  },
  {
    code: "327991",
    title: "Monuments and tombstones, cut stone, manufacturing",
  },
  {
    code: "327991",
    title: "Slate products manufacturing",
  },
  {
    code: "327991",
    title: "Statuary, marble, manufacturing",
  },
  {
    code: "327991",
    title: "Table tops, marble, manufacturing",
  },
  {
    code: "327992",
    title: "Barite processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Barium processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Blast furnace slag processing",
  },
  {
    code: "327992",
    title: "Desiccants, activated clay, manufacturing",
  },
  {
    code: "327992",
    title: "Diatomaceous earth processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Feldspar processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Flint processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Fuller's earth processing beyond beneficiating",
  },
  {
    code: "327992",
    title:
      "Graphite, natural (e.g., ground, pulverized, refined, blended), manufacturing",
  },
  {
    code: "327992",
    title: "Kaolin, processing beyond beneficiation",
  },
  {
    code: "327992",
    title:
      "Lead, black (i.e., natural graphite), ground, refined, or blended, manufacturing",
  },
  {
    code: "327992",
    title:
      "Magnesite, crude (e.g., calcined, dead-burned, ground), manufacturing",
  },
  {
    code: "327992",
    title: "Mica processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Perlite aggregates manufacturing",
  },
  {
    code: "327992",
    title: "Perlite, expanded, manufacturing",
  },
  {
    code: "327992",
    title: "Pumice (except abrasives) processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Pyrophyllite processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Shale, expanded, manufacturing",
  },
  {
    code: "327992",
    title: "Silicon, ultra high purity, manufacturing",
  },
  {
    code: "327992",
    title: "Soapstone processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Talc processing beyond beneficiation",
  },
  {
    code: "327992",
    title: "Vermiculite, exfoliated, manufacturing",
  },
  {
    code: "327993",
    title: "Fiberglass insulation products manufacturing",
  },
  {
    code: "327993",
    title: "Insulating batts, fills, or blankets, fiberglass, manufacturing",
  },
  {
    code: "327993",
    title: "Mineral wool insulation materials manufacturing",
  },
  {
    code: "327993",
    title:
      "Mineral wool products (e.g., board, insulation, tile) manufacturing",
  },
  {
    code: "327999",
    title: "Asbestos products (except brake shoes and clutches) manufacturing",
  },
  {
    code: "327999",
    title:
      "Asphalt concrete crushing and grinding (except at construction site)",
  },
  {
    code: "327999",
    title: "Built-up mica manufacturing",
  },
  {
    code: "327999",
    title: "Ceramic fiber manufacturing",
  },
  {
    code: "327999",
    title: "Concrete crushing and grinding (except at construction site)",
  },
  {
    code: "327999",
    title: "Concrete, dry mixture, manufacturing",
  },
  {
    code: "327999",
    title: "Dry mix concrete manufacturing",
  },
  {
    code: "327999",
    title: "Ecclesiastical statuary, papier-mache, manufacturing",
  },
  {
    code: "327999",
    title: "Images, small papier-mache, manufacturing",
  },
  {
    code: "327999",
    title:
      "Manmade and engineered proppants (e.g., resin-coated sand, ceramic materials) manufacturing",
  },
  {
    code: "327999",
    title: "Mica products manufacturing",
  },
  {
    code: "327999",
    title:
      "Papier-mache statuary and related art goods (e.g., urns, vases) manufacturing",
  },
  {
    code: "327999",
    title: "Peat pots, molded pulp, manufacturing",
  },
  {
    code: "327999",
    title: "Statuary, vases, and urns, papier-mache, manufacturing",
  },
  {
    code: "327999",
    title:
      "Stones, synthetic, for gem stones and industrial use, manufacturing",
  },
  {
    code: "327999",
    title: "Stucco and stucco products manufacturing",
  },
  {
    code: "327999",
    title: "Synthetic stones, for gem stones and industrial use, manufacturing",
  },
  {
    code: "331110",
    title: "Armor plate made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Axles, rolled or forged, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Balls, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Bars, concrete reinforcing (rebar) made in steel mills",
  },
  {
    code: "331110",
    title: "Bars, iron, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Bars, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Billets, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Blackplate made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Blast furnaces",
  },
  {
    code: "331110",
    title: "Blooms, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Car wheels, rolled steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Coke oven products made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Concrete reinforcing bar (rebar) made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Direct reduction of iron ore",
  },
  {
    code: "331110",
    title: "Electrometallurgical ferroalloy manufacturing",
  },
  {
    code: "331110",
    title: "Electrometallurgical steel manufacturing",
  },
  {
    code: "331110",
    title: "Fence posts, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Ferroalloys manufacturing",
  },
  {
    code: "331110",
    title: "Ferrochromium manufacturing",
  },
  {
    code: "331110",
    title: "Ferromanganese manufacturing",
  },
  {
    code: "331110",
    title: "Ferromolybdenum manufacturing",
  },
  {
    code: "331110",
    title: "Ferrophosphorus manufacturing",
  },
  {
    code: "331110",
    title: "Ferrosilicon manufacturing",
  },
  {
    code: "331110",
    title: "Ferrotitanium manufacturing",
  },
  {
    code: "331110",
    title: "Ferrotungsten manufacturing",
  },
  {
    code: "331110",
    title: "Ferrovanadium manufacturing",
  },
  {
    code: "331110",
    title: "Flakes, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Flats, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Forgings, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Frogs, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title:
      "Galvanizing metals and metal formed products made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Gun forgings made in iron and steel mills",
  },
  {
    code: "331110",
    title:
      "High percentage nonferrous alloying elements (i.e., ferroalloys) manufacturing",
  },
  {
    code: "331110",
    title: "Hoops made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Hoops, galvanized, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Hot-rolling iron or steel products in iron and steel mills",
  },
  {
    code: "331110",
    title: "Ingot made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Iron ore recovery from open hearth slag",
  },
  {
    code: "331110",
    title: "Iron sinter made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Iron, pig, manufacturing",
  },
  {
    code: "331110",
    title: "Manganese metal ferroalloys manufacturing",
  },
  {
    code: "331110",
    title: "Mesh, wire, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Mini-mills, steel",
  },
  {
    code: "331110",
    title: "Molybdenum silicon ferroalloys manufacturing",
  },
  {
    code: "331110",
    title: "Nut rods, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Paste, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Pig iron manufacturing",
  },
  {
    code: "331110",
    title: "Pilings, iron or steel plain sheet, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Pipe, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Plate, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Powder, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Rail joints and fastenings made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Railroad crossings, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Rails rerolled or renewed in iron and steel mills",
  },
  {
    code: "331110",
    title: "Rails, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Rods, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Rounds, tube, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Sheet pilings, plain, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Sheets, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Shell slugs, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Silicomanganese ferroalloys manufacturing",
  },
  {
    code: "331110",
    title: "Skelp, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Slab, steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Spiegeleisen ferroalloys manufacturing",
  },
  {
    code: "331110",
    title: "Spike rods made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Sponge iron",
  },
  {
    code: "331110",
    title: "Stainless steel made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Steel balls made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Steel manufacturing",
  },
  {
    code: "331110",
    title:
      "Steel mill products (e.g., bar, plate, rod, sheet, structural shapes) manufacturing",
  },
  {
    code: "331110",
    title: "Steel mills",
  },
  {
    code: "331110",
    title: "Steel, from pig iron, manufacturing",
  },
  {
    code: "331110",
    title: "Strip, galvanized iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Strip, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Structural shapes, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Superalloys, iron or steel, manufacturing",
  },
  {
    code: "331110",
    title: "Template, made in iron and steel mills, manufacturing",
  },
  {
    code: "331110",
    title: "Terneplate made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Ternes, iron or steel, long or short, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tie plates, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tin-free steel made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tinplate made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tool steel made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tube rounds, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tube, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tubing, seamless steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Tubing, wrought iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Well casings, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title:
      "Wheels, car and locomotive, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Wire products, iron or steel, made in iron and steel mills",
  },
  {
    code: "331110",
    title: "Wrought iron or steel pipe and tubing made in iron and steel mills",
  },
  {
    code: "331210",
    title: "Boiler tubes, wrought, made from purchased iron",
  },
  {
    code: "331210",
    title: "Conduit, welded and lock joint, made from purchased iron or steel",
  },
  {
    code: "331210",
    title:
      "Pipe (e.g., heavy riveted, lock joint, seamless, welded) made from purchased iron or steel",
  },
  {
    code: "331210",
    title:
      "Tube (e.g., heavy riveted, lock joint, seamless, welded) made from purchased iron or steel",
  },
  {
    code: "331210",
    title:
      "Tubing, mechanical and hypodermic sizes, cold-drawn stainless steel, made from purchased steel",
  },
  {
    code: "331210",
    title:
      "Well casings (e.g., heavy riveted, lock joint, welded, wrought) made from purchased iron or steel",
  },
  {
    code: "331221",
    title:
      "Bars, concrete reinforcing (rebar), made from purchased steel in steel rolling mills",
  },
  {
    code: "331221",
    title: "Bars, steel, made from purchased steel in cold rolling mills",
  },
  {
    code: "331221",
    title:
      "Cold rolling steel shapes (e.g., bar, plate, rod, sheet, strip) made from purchased steel",
  },
  {
    code: "331221",
    title:
      "Concrete reinforcing bar (rebar), made from purchased steel in cold rolling mills ",
  },
  {
    code: "331221",
    title:
      "Concrete reinforcing bar (rebar), made from purchased steel in steel rolling mills",
  },
  {
    code: "331221",
    title:
      "Corrugating iron or steel in cold rolling mills made from purchased iron or steel",
  },
  {
    code: "331221",
    title:
      "Ferrous metal powder, paste, and flake made from purchased iron or steel",
  },
  {
    code: "331221",
    title: "Flakes made from purchased iron or steel",
  },
  {
    code: "331221",
    title:
      "Flat bright steel strip made in cold rolling mills made from purchased steel",
  },
  {
    code: "331221",
    title: "Hot-rolling purchased steel",
  },
  {
    code: "331221",
    title: "Metal powder and flake made from purchased iron or steel",
  },
  {
    code: "331221",
    title: "Nut rods, iron or steel, made in cold rolling mills",
  },
  {
    code: "331221",
    title: "Paste made from purchased iron or steel",
  },
  {
    code: "331221",
    title: "Powder made from purchased iron or steel",
  },
  {
    code: "331221",
    title: "Razor blade strip steel made in cold rolling mills",
  },
  {
    code: "331221",
    title: "Wire, flat, rolled strip, made in cold rolling mills",
  },
  {
    code: "331222",
    title: "Barbed and twisted wire made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Baskets, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Brads, iron or steel, wire or cut, made in wire drawing plants",
  },
  {
    code: "331222",
    title:
      "Cable, iron or steel, insulated or armored, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Chain link fencing, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Drawing iron or steel wire from purchased iron or steel",
  },
  {
    code: "331222",
    title:
      "Drawing iron or steel wire from purchased iron or steel and fabricating wire products",
  },
  {
    code: "331222",
    title:
      "Fence gates, posts, and fittings, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Form ties made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Horseshoe nails, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Mesh, wire, made in wire drawing mills",
  },
  {
    code: "331222",
    title: "Nails, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Paper clips, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Spikes, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Staples, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Tacks, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Tie wires made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Welded iron or steel wire fabric made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Wire cages, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title:
      "Wire carts (e.g., grocery, household, industrial), iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Wire cloth, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Wire garment hangers, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title: "Wire products, iron or steel, made in wire drawing plants",
  },
  {
    code: "331222",
    title:
      "Wire, iron or steel (e.g., armored, bare, insulated), made in wire drawing plants",
  },
  {
    code: "331313",
    title: "Alumina refining",
  },
  {
    code: "331313",
    title:
      "Aluminum alloys made from bauxite or alumina producing primary aluminum and manufacturing",
  },
  {
    code: "331313",
    title:
      "Aluminum ingot and other primary aluminum production shapes made from bauxite or alumina",
  },
  {
    code: "331313",
    title: "Aluminum oxide refining",
  },
  {
    code: "331313",
    title: "Aluminum producing from alumina",
  },
  {
    code: "331313",
    title:
      "Aluminum shapes (e.g., bar, ingot, rod, sheet) made by producing primary aluminum and manufacturing",
  },
  {
    code: "331313",
    title: "Extrusion ingot, primary aluminum, manufacturing",
  },
  {
    code: "331313",
    title: "Ingot, primary aluminum, manufacturing",
  },
  {
    code: "331313",
    title: "Primary aluminum production and manufacturing aluminum alloys",
  },
  {
    code: "331313",
    title:
      "Primary aluminum production and manufacturing aluminum shapes (e.g., bar, ingot, rod, sheet)",
  },
  {
    code: "331313",
    title: "Primary refining of aluminum",
  },
  {
    code: "331313",
    title: "Primary smelting of aluminum",
  },
  {
    code: "331313",
    title: "Refining aluminum, primary",
  },
  {
    code: "331313",
    title: "Slab, primary aluminum, manufacturing",
  },
  {
    code: "331314",
    title: "Alloying purchased aluminum metals",
  },
  {
    code: "331314",
    title: "Aluminum alloys made from scrap or dross",
  },
  {
    code: "331314",
    title: "Aluminum billet made from purchased aluminum",
  },
  {
    code: "331314",
    title:
      "Aluminum billet made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331314",
    title: "Aluminum extrusion ingot (i.e., billet), secondary",
  },
  {
    code: "331314",
    title: "Aluminum flakes made from purchased aluminum",
  },
  {
    code: "331314",
    title: "Aluminum ingot made from purchased aluminum",
  },
  {
    code: "331314",
    title: "Aluminum ingot, secondary smelting of aluminum and manufacturing",
  },
  {
    code: "331314",
    title: "Aluminum ingot, secondary, manufacturing",
  },
  {
    code: "331314",
    title:
      "Aluminum recovering from scrap and making ingot and billet (except by rolling)",
  },
  {
    code: "331314",
    title:
      "Aluminum smelting, secondary, and making ingot and billet (except by rolling)",
  },
  {
    code: "331314",
    title: "Flakes, aluminum, made from purchased aluminum",
  },
  {
    code: "331314",
    title: "Metal powder and flake made from purchased aluminum",
  },
  {
    code: "331314",
    title: "Paste made from purchased aluminum",
  },
  {
    code: "331314",
    title: "Powder made from purchased aluminum",
  },
  {
    code: "331314",
    title: "Refining aluminum, secondary",
  },
  {
    code: "331315",
    title: "Aluminum foil made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Aluminum foil made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Aluminum plate made by continuous casting purchased aluminum",
  },
  {
    code: "331315",
    title: "Aluminum plate made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Aluminum plate made in integrated secondary smelting and continuous casting mills",
  },
  {
    code: "331315",
    title:
      "Aluminum plate made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Aluminum sheet made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Aluminum sheet made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Aluminum welded tube made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Aluminum welded tube made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Foil, aluminum, made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Foil, aluminum, made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Plate, aluminum, made by continuous casting purchased aluminum",
  },
  {
    code: "331315",
    title: "Plate, aluminum, made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Plate, aluminum, made in integrated secondary smelting and continuous casting mills",
  },
  {
    code: "331315",
    title:
      "Plate, aluminum, made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Sheet, aluminum, made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Sheet, aluminum, made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331315",
    title: "Tube, welded, aluminum, made by flat rolling purchased aluminum",
  },
  {
    code: "331315",
    title:
      "Tube, welded, aluminum, made in integrated secondary smelting and flat rolling mills",
  },
  {
    code: "331318",
    title: "Aluminum bar made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Aluminum bar made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Aluminum pipe made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Aluminum pipe made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Aluminum rod made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Aluminum rod made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Aluminum tube blooms made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Aluminum tube blooms made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Aluminum tube made by drawing or extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Aluminum tube made in integrated secondary smelting and drawing plants",
  },
  {
    code: "331318",
    title:
      "Aluminum tube made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Apparatus wire or cord made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title:
      "Automotive or aircraft wire and cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Bar made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title: "Bar made by rolling purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Bar, aluminum, made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title:
      "Bar, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Coaxial cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Communications wire or cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Cord sets, flexible, made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Energy wire or cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Extrusion billet made by rolling purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Extrusion billet, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Extrusion ingot made by rolling purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Extrusion ingot, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Ingot made by rolling purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Ingot, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Insulated wire or cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Magnet wire, insulated, made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Mesh, wire, made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Nails, aluminum, made in wire drawing plants",
  },
  {
    code: "331318",
    title: "Pipe made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Pipe, aluminum, made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Rails made by rolling or drawing purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Rails, aluminum, made in integrated secondary smelting and drawing plants",
  },
  {
    code: "331318",
    title:
      "Rails, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Rod made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title: "Rod made by rolling purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Rod, aluminum, made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title:
      "Rod, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Shipboard cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Signal and control cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Structural shapes made by rolling purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Structural shapes, aluminum, made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331318",
    title: "Tube blooms made by extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Tube blooms, aluminum, made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Tube made by drawing or extruding purchased aluminum",
  },
  {
    code: "331318",
    title:
      "Tube, aluminum, made in integrated secondary smelting and drawing plants",
  },
  {
    code: "331318",
    title:
      "Tube, aluminum, made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331318",
    title: "Weatherproof wire or cable made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Wire cloth made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title:
      "Wire screening, aluminum, made in integrated secondary smelting and drawing plants",
  },
  {
    code: "331318",
    title: "Wire, armored, made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Wire, bare, made in aluminum wire drawing plants",
  },
  {
    code: "331318",
    title: "Wire, insulated, made in aluminum wire drawing plants",
  },
  {
    code: "331410",
    title: "Antimony refining, primary",
  },
  {
    code: "331410",
    title: "Bars made in primary copper smelting and refining mills",
  },
  {
    code: "331410",
    title: "Beryllium refining, primary",
  },
  {
    code: "331410",
    title: "Bismuth refining, primary",
  },
  {
    code: "331410",
    title: "Blister copper manufacturing",
  },
  {
    code: "331410",
    title: "Cadmium refining, primary",
  },
  {
    code: "331410",
    title: "Chromium refining, primary",
  },
  {
    code: "331410",
    title: "Cobalt refining, primary",
  },
  {
    code: "331410",
    title: "Copper alloys made in primary copper smelting and refining mills",
  },
  {
    code: "331410",
    title: "Copper concentrate refining",
  },
  {
    code: "331410",
    title:
      "Copper shapes (e.g., bar, billet, ingot, plate, sheet) made in primary copper smelting and refining mills",
  },
  {
    code: "331410",
    title: "Copper smelting and refining, primary",
  },
  {
    code: "331410",
    title: "Germanium refining, primary",
  },
  {
    code: "331410",
    title: "Gold bullion or dore bar produced at primary metal refineries",
  },
  {
    code: "331410",
    title: "Gold refining, primary",
  },
  {
    code: "331410",
    title: "Ingot, primary, nonferrous metals (except aluminum), manufacturing",
  },
  {
    code: "331410",
    title: "Iridium refining, primary",
  },
  {
    code: "331410",
    title: "Lead smelting and refining, primary",
  },
  {
    code: "331410",
    title: "Magnesium refining, primary",
  },
  {
    code: "331410",
    title: "Nickel refining, primary",
  },
  {
    code: "331410",
    title: "Niobium refining, primary",
  },
  {
    code: "331410",
    title:
      "Nonferrous metal (except aluminum) shapes made in primary nonferrous metal smelting and refining mills",
  },
  {
    code: "331410",
    title:
      "Nonferrous metals (except aluminum) made in primary nonferrous metal smelting and refining mills",
  },
  {
    code: "331410",
    title: "Nonferrous metals (except aluminum) smelting and refining, primary",
  },
  {
    code: "331410",
    title: "Platinum refining, primary",
  },
  {
    code: "331410",
    title: "Precious metals refining, primary",
  },
  {
    code: "331410",
    title: "Primary refining of copper",
  },
  {
    code: "331410",
    title: "Primary refining of nonferrous metals (except aluminum)",
  },
  {
    code: "331410",
    title: "Primary smelting of copper",
  },
  {
    code: "331410",
    title: "Primary smelting of nonferrous metals (except aluminum)",
  },
  {
    code: "331410",
    title: "Refining copper, primary",
  },
  {
    code: "331410",
    title: "Refining nonferrous metals and alloys (except aluminum), primary",
  },
  {
    code: "331410",
    title: "Rhenium refining, primary",
  },
  {
    code: "331410",
    title: "Selenium refining, primary",
  },
  {
    code: "331410",
    title: "Silver bullion or dore bar produced at primary metal refineries",
  },
  {
    code: "331410",
    title: "Silver refining, primary",
  },
  {
    code: "331410",
    title: "Slab, nonferrous metals (except aluminum) primary",
  },
  {
    code: "331410",
    title: "Smelting of nonferrous metals (except aluminum), primary",
  },
  {
    code: "331410",
    title: "Tantalum refining, primary",
  },
  {
    code: "331410",
    title: "Tellurium refining, primary",
  },
  {
    code: "331410",
    title: "Tin base alloys made in primary tin smelting and refining mills",
  },
  {
    code: "331410",
    title: "Tin refining, primary",
  },
  {
    code: "331410",
    title: "Titanium refining, primary",
  },
  {
    code: "331410",
    title: "Uranium refining, primary",
  },
  {
    code: "331410",
    title: "Zinc refining, primary",
  },
  {
    code: "331410",
    title: "Zirconium refining, primary",
  },
  {
    code: "331420",
    title:
      "Aircraft and automotive wire or cable made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title: "Alloying purchased copper",
  },
  {
    code: "331420",
    title: "Alloying purchased copper metals",
  },
  {
    code: "331420",
    title:
      "Apparatus wire or cord made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title: "Armored cable made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Armored cable, copper, made in integrated secondary smelting and drawing plants",
  },
  {
    code: "331420",
    title:
      "Bar, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Brass products, rolling, drawing, or extruding, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Bronze products, rolling, drawing, or extruding, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Cable, copper (e.g., armored, bare, insulated), made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Cable, copper (e.g., armored, bare, insulated), made in integrated secondary smelting and wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Cartridge cups, discs, and sheets, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Coaxial cable, copper, made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Communications wire or cable, copper, made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Copper alloys (e.g., brass, bronze) made from purchased metal or scrap",
  },
  {
    code: "331420",
    title:
      "Copper and copper-based shapes (e.g., cake, ingot, slag, wire bar) made from purchased metal or scrap",
  },
  {
    code: "331420",
    title: "Copper foil made from purchased metal or scrap",
  },
  {
    code: "331420",
    title: "Copper powder, flakes, and paste made from purchased copper",
  },
  {
    code: "331420",
    title: "Copper products made by drawing purchased copper",
  },
  {
    code: "331420",
    title:
      "Copper products made by rolling, drawing, or extruding purchased copper",
  },
  {
    code: "331420",
    title:
      "Copper products made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331420",
    title:
      "Copper products made in integrated secondary smelting mills and drawing plants",
  },
  {
    code: "331420",
    title: "Copper secondary smelting and alloying",
  },
  {
    code: "331420",
    title:
      "Copper secondary smelting and refining from purchased metal or scrap",
  },
  {
    code: "331420",
    title:
      "Cord sets, flexible, made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Energy wire or cable, copper, made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title: "Foil, copper, made from purchased metal or scrap",
  },
  {
    code: "331420",
    title:
      "Insulated wire or cable made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Insulated wire or cable, copper, made in integrated secondary smelting and wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Magnet wire, insulated, made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title: "Mesh, wire, made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title: "Metal powder and flake made from purchased copper",
  },
  {
    code: "331420",
    title: "Paste made from purchased copper",
  },
  {
    code: "331420",
    title:
      "Pipe, extruded and drawn, brass, bronze, and copper, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Plate, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title: "Powder made from purchased copper",
  },
  {
    code: "331420",
    title: "Refining copper, secondary",
  },
  {
    code: "331420",
    title:
      "Rod, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Sheet, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title: "Shipboard cable made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Signal and control cable made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Strip, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Tubing, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331420",
    title:
      "Weatherproof wire or cable made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title: "Wire cloth made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Wire cloth, copper, made in integrated secondary smelting and wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Wire, copper  (e.g., armored, bare, insulated), made from purchased copper in wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Wire, copper (e.g., armored, bare, insulated), made in integrated secondary smelting and wire drawing plants",
  },
  {
    code: "331420",
    title:
      "Wire, mechanical, copper and copper alloy, made from purchased copper or in integrated secondary smelting and rolling, drawing or extruding plants",
  },
  {
    code: "331491",
    title:
      "Aircraft and automotive wire and cable (except aluminum, copper) made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Apparatus wire and cord (except aluminum, copper) made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Bar, nonferrous metals (except aluminum, copper), made from purchased metals in wire drawing plants or in integrated secondary smelting and rolling, drawing, or extruding plants",
  },
  {
    code: "331491",
    title:
      "Coaxial cable, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Communications wire or cable, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Cord sets, flexible, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Energy wire or cable, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title: "Foil, gold, made by rolling purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Foil, nickel, made by rolling purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Foil, silver, made by rolling purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Gold and gold alloy bar, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Gold foil made by rolling purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Gold rolling and drawing purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Iridium bar, rod, sheet, strip and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Lead and lead alloy bar, pipe, plate, rod, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Lead rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Magnesium and magnesium alloy bar, rod, shape, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Magnesium foil made by rolling purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Magnesium rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Magnet wire, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Mesh, wire, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Molybdenum and molybdenum alloy bar, plate, pipe, rod, sheet, tubing, and wire made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Molybdenum rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Nails, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Nickel and nickel alloy pipe, plate, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Nickel rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Nonferrous metal shapes (except aluminum, copper) made by rolling, drawing, or extruding purchased nonferrous metal",
  },
  {
    code: "331491",
    title:
      "Nonferrous metal shapes (except aluminum, copper) made in integrated secondary smelting and extruding mills",
  },
  {
    code: "331491",
    title:
      "Nonferrous metal shapes (except aluminum, copper) made in integrated secondary smelting and rolling mills",
  },
  {
    code: "331491",
    title:
      "Nonferrous metal shapes (except aluminum, copper) made in integrated secondary smelting mills and wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Nonferrous wire (except aluminum, copper) made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Nonferrous wire (except aluminum, copper) made in integrated secondary smelting mills and wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Pipe, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Plate, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Platinum and platinum alloy rolling, drawing, or extruding from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Platinum and platinum alloy sheet and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Precious metal bar, rod, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Rod, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Selenium bar, rod, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Silver and silver alloy bar, rod, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Silver foil made by rolling purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Silver rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Solder wire, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Strip, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Tin and tin alloy bar, pipe, rod, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Tin rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Titanium and titanium alloy bar, billet, rod, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Titanium rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Tubing, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Tungsten bar, rod, sheet, strip, and tubing made by rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Welding rod, uncoated, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Wire cloth, nonferrous metals (except aluminum, copper), made from purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Wire screening, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Wire, nonferrous metals (except aluminum, copper), made from purchased nonferrous metals (except aluminum, copper) in wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Wire, nonferrous metals (except aluminum, copper), made in integrated secondary smelting mills and wire drawing plants",
  },
  {
    code: "331491",
    title:
      "Zinc and zinc alloy bar, plate, pipe, rod, sheet, tubing, and wire made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Zinc rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331491",
    title:
      "Zirconium and zirconium alloy bar, rod, billet, sheet, strip, and tubing made from purchased metals or scrap",
  },
  {
    code: "331491",
    title: "Zirconium rolling, drawing, or extruding purchased metals or scrap",
  },
  {
    code: "331492",
    title: "Alloying purchased nonferrous metals (except aluminum, copper)",
  },
  {
    code: "331492",
    title: "Detinning scrap (e.g., cans)",
  },
  {
    code: "331492",
    title: "Germanium recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title: "Gold recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title:
      "Ingot, nonferrous metals (except aluminum, copper), secondary smelting and refining",
  },
  {
    code: "331492",
    title: "Iridium recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title: "Lead recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title: "Magnesium recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title:
      "Metal powder and flake nonferrous (except aluminum, copper) made from purchased metal",
  },
  {
    code: "331492",
    title: "Nickel recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title:
      "Nonferrous alloys (except aluminum, copper) made from purchased nonferrous metals",
  },
  {
    code: "331492",
    title:
      "Nonferrous alloys (except aluminum, copper) made in integrated secondary smelting and alloying plants",
  },
  {
    code: "331492",
    title:
      "Nonferrous metals (except aluminum, copper) secondary smelting and refining",
  },
  {
    code: "331492",
    title:
      "Paste, nonferrous metals (except aluminum, copper), made from purchased metal",
  },
  {
    code: "331492",
    title: "Platinum recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title:
      "Powder, nonferrous metals (except aluminum, copper), made from purchased metal",
  },
  {
    code: "331492",
    title:
      "Precious metals recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title:
      "Recovering and refining of nonferrous metals (except aluminum, copper) from scrap",
  },
  {
    code: "331492",
    title: "Recovering silver from used photographic film or X-ray plates",
  },
  {
    code: "331492",
    title:
      "Refining nonferrous metals and alloys (except aluminum, copper), secondary",
  },
  {
    code: "331492",
    title: "Secondary refining of nonferrous metals (except aluminum, copper)",
  },
  {
    code: "331492",
    title: "Secondary smelting of nonferrous metals (except aluminum, copper)",
  },
  {
    code: "331492",
    title: "Selenium recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title: "Silver recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title: "Silver recovering from used photographic film or X-ray plates",
  },
  {
    code: "331492",
    title:
      "Smelting and refining of nonferrous metals (except aluminum, copper), secondary",
  },
  {
    code: "331492",
    title: "Smelting nonferrous metals (except aluminum, copper), secondary",
  },
  {
    code: "331492",
    title: "Superalloys, nonferrous based, made from purchased metals or scrap",
  },
  {
    code: "331492",
    title: "Tin recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331492",
    title: "Tungsten carbide powder made by metallurgical process",
  },
  {
    code: "331492",
    title: "Zinc dust reclaiming",
  },
  {
    code: "331492",
    title: "Zinc recovering from scrap and/or alloying purchased metals",
  },
  {
    code: "331511",
    title: "Cast iron brake shoes, railroad, manufacturing",
  },
  {
    code: "331511",
    title: "Cast iron pipe and pipe fittings manufacturing",
  },
  {
    code: "331511",
    title: "Cast iron railroad car wheels manufacturing",
  },
  {
    code: "331511",
    title: "Castings, compacted graphite iron, unfinished, manufacturing",
  },
  {
    code: "331511",
    title: "Castings, malleable iron, unfinished, manufacturing",
  },
  {
    code: "331511",
    title:
      "Castings, unfinished iron (e.g., ductile, gray, malleable, semisteel), manufacturing",
  },
  {
    code: "331511",
    title: "Cooking utensils, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Ductile iron castings, unfinished, manufacturing",
  },
  {
    code: "331511",
    title: "Ductile iron foundries",
  },
  {
    code: "331511",
    title: "Fittings, soil and pressure pipe, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Foundries, iron (i.e., ductile, gray, malleable, semisteel)",
  },
  {
    code: "331511",
    title: "Gray iron foundries",
  },
  {
    code: "331511",
    title: "Industrial molds, steel ingot, manufacturing",
  },
  {
    code: "331511",
    title: "Iron castings, unfinished, manufacturing",
  },
  {
    code: "331511",
    title: "Iron foundries",
  },
  {
    code: "331511",
    title: "Malleable iron foundries",
  },
  {
    code: "331511",
    title: "Manhole covers, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Molds for casting steel ingots manufacturing",
  },
  {
    code: "331511",
    title: "Molds, steel ingot, industrial, manufacturing",
  },
  {
    code: "331511",
    title: "Pearlitic castings, malleable iron, unfinished, manufacturing",
  },
  {
    code: "331511",
    title: "Pipe and pipe fittings, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Pipe couplings, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Rolling mill rolls, iron, manufacturing",
  },
  {
    code: "331511",
    title: "Semisteel foundries",
  },
  {
    code: "331511",
    title: "Sewer pipe, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Soil pipe, cast iron, manufacturing",
  },
  {
    code: "331511",
    title: "Water pipe, cast iron, manufacturing",
  },
  {
    code: "331512",
    title: "Foundries, steel investment",
  },
  {
    code: "331512",
    title: "Investment castings, steel, unfinished, manufacturing",
  },
  {
    code: "331512",
    title: "Steel investment castings, unfinished, manufacturing",
  },
  {
    code: "331512",
    title: "Steel investment foundries",
  },
  {
    code: "331513",
    title:
      "Alloy steel castings (except investment), unfinished, manufacturing",
  },
  {
    code: "331513",
    title: "Cast steel railroad car wheels, unfinished, manufacturing",
  },
  {
    code: "331513",
    title: "Castings, steel (except investment), unfinished, manufacturing",
  },
  {
    code: "331513",
    title: "Foundries, steel (except investment)",
  },
  {
    code: "331513",
    title: "Rolling mill rolls, steel, manufacturing",
  },
  {
    code: "331513",
    title:
      "Stainless steel castings (except investment), unfinished, manufacturing",
  },
  {
    code: "331513",
    title: "Steel castings (except investment), unfinished, manufacturing",
  },
  {
    code: "331513",
    title: "Steel foundries (except investment)",
  },
  {
    code: "331523",
    title: "Aluminum die-casting foundries",
  },
  {
    code: "331523",
    title: "Aluminum die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Beryllium die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Brass die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Bronze die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Copper die-casting foundries",
  },
  {
    code: "331523",
    title: "Copper die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Die-castings, aluminum, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Die-castings, nonferrous metals, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Foundries, die-casting, aluminum",
  },
  {
    code: "331523",
    title: "Foundries, die-casting, nonferrous metals ",
  },
  {
    code: "331523",
    title: "Lead die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Magnesium die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Nickel alloy die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Nickel die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Nonferrous die-casting foundries",
  },
  {
    code: "331523",
    title: "Titanium die-castings, unfinished, manufacturing",
  },
  {
    code: "331523",
    title: "Zinc die-castings, unfinished, manufacturing",
  },
  {
    code: "331524",
    title: "Aluminum castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331524",
    title: "Aluminum foundries (except die-casting)",
  },
  {
    code: "331524",
    title:
      "Castings (except die-castings), unfinished, aluminum, manufacturing",
  },
  {
    code: "331524",
    title: "Foundries, aluminum (except die-casting)",
  },
  {
    code: "331524",
    title: "Investment castings, aluminum, unfinished, manufacturing",
  },
  {
    code: "331524",
    title: "Permanent mold castings, aluminum, unfinished, manufacturing",
  },
  {
    code: "331524",
    title: "Sand castings, aluminum, unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Beryllium castings (except die-castings), unfinished manufacturing",
  },
  {
    code: "331529",
    title: "Brass foundries (except die-casting)",
  },
  {
    code: "331529",
    title: "Bronze foundries (except die-casting)",
  },
  {
    code: "331529",
    title:
      "Castings (except die-castings), nonferrous metals (except aluminum), unfinished, manufacturing",
  },
  {
    code: "331529",
    title:
      "Copper alloy castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Copper foundries (except die-casting)",
  },
  {
    code: "331529",
    title:
      "Foundries (except die-casting), nonferrous metals (except aluminum)",
  },
  {
    code: "331529",
    title:
      "Investment castings, nonferrous metal (except aluminum), unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Lead castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331529",
    title:
      "Magnesium castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Nickel castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Nonferrous metals (except aluminum) foundries (except die-casting)",
  },
  {
    code: "331529",
    title:
      "Nonferrous metals (except aluminum) unfinished castings (except die-castings) manufacturing",
  },
  {
    code: "331529",
    title:
      "Permanent mold castings, nonferrous metal (except aluminum), unfinished, manufacturing",
  },
  {
    code: "331529",
    title:
      "Sand castings, nonferrous metals (except aluminum), unfinished, manufacturing",
  },
  {
    code: "331529",
    title:
      "Ship and boat propellers, cast brass, bronze and copper (except die-casting), unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Titanium castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331529",
    title:
      "White metal castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "331529",
    title: "Zinc castings (except die-castings), unfinished, manufacturing",
  },
  {
    code: "332111",
    title: "Cold forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Drop forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Ferrous forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Gun forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Hammer forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Horseshoes, ferrous forged, made from purchased iron or steel",
  },
  {
    code: "332111",
    title: "Hot forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Iron forgings made from purchased iron, unfinished",
  },
  {
    code: "332111",
    title: "Press forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332111",
    title: "Steel forgings made from purchased steel, unfinished",
  },
  {
    code: "332111",
    title: "Upset forgings made from purchased iron or steel, unfinished",
  },
  {
    code: "332112",
    title: "Aluminum forgings made from purchased metals, unfinished",
  },
  {
    code: "332112",
    title: "Cold forgings made from purchased nonferrous metals, unfinished",
  },
  {
    code: "332112",
    title: "Copper forgings made from purchased metals, unfinished",
  },
  {
    code: "332112",
    title: "Hammer forgings made from purchased nonferrous metals, unfinished",
  },
  {
    code: "332112",
    title: "Hot forgings made from purchased nonferrous metals, unfinished",
  },
  {
    code: "332112",
    title: "Press forgings made from purchased nonferrous metals, unfinished",
  },
  {
    code: "332112",
    title: "Titanium forgings made from purchased metals, unfinished",
  },
  {
    code: "332112",
    title: "Upset forgings made from purchased nonferrous metals, unfinished",
  },
  {
    code: "332114",
    title: "Custom roll forming metal products",
  },
  {
    code: "332114",
    title:
      "Gutters and down spouts sheet metal, custom roll formed, manufacturing",
  },
  {
    code: "332117",
    title: "Powder metallurgy products manufactured on a job or order basis",
  },
  {
    code: "332119",
    title: "Bottle caps and tops, metal, stamping",
  },
  {
    code: "332119",
    title: "Caps and tops, bottle, metal, stamping",
  },
  {
    code: "332119",
    title: "Closures, metal, stamping",
  },
  {
    code: "332119",
    title: "Crowns, metal (e.g., bottle, can), stamping",
  },
  {
    code: "332119",
    title: "Home canning lids and rings, metal stamping",
  },
  {
    code: "332119",
    title: "Lids, jar, metal, stamping",
  },
  {
    code: "332119",
    title:
      "Metal stampings (except automotive, cans, coins), unfinished, manufacturing",
  },
  {
    code: "332119",
    title: "Spinning unfinished metal products",
  },
  {
    code: "332119",
    title:
      "Stampings (except automotive, cans, coins), metal, unfinished, manufacturing",
  },
  {
    code: "332215",
    title: "Barber's scissors, manufacturing",
  },
  {
    code: "332215",
    title: "Blades, knife and razor, manufacturing",
  },
  {
    code: "332215",
    title: "Butcher's knives manufacturing",
  },
  {
    code: "332215",
    title: "Carving sets manufacturing",
  },
  {
    code: "332215",
    title: "Cleavers manufacturing",
  },
  {
    code: "332215",
    title: "Clippers, fingernail and toenail, manufacturing",
  },
  {
    code: "332215",
    title: "Cooking utensils, fabricated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Cookware, fabricated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Cutlery, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Enameled metal cutting utensils",
  },
  {
    code: "332215",
    title: "Fishing knives manufacturing",
  },
  {
    code: "332215",
    title: "Flatware, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Forks, table, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Hair clippers for human use, nonelectric, manufacturing",
  },
  {
    code: "332215",
    title: "Hunting knives manufacturing",
  },
  {
    code: "332215",
    title:
      "Kitchen cutlery, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title:
      "Kitchen utensils, fabricated metal (e.g., colanders, garlic presses, ice cream scoops, spatulas), manufacturing",
  },
  {
    code: "332215",
    title: "Knife blades manufacturing",
  },
  {
    code: "332215",
    title: "Knife blanks manufacturing",
  },
  {
    code: "332215",
    title:
      "Knives (e.g., hunting, pocket, table nonprecious, table precious plated) manufacturing",
  },
  {
    code: "332215",
    title: "Nonstick metal cooking utensils",
  },
  {
    code: "332215",
    title: "Plated metal cutlery manufacturing",
  },
  {
    code: "332215",
    title: "Plated metal flatware manufacturing",
  },
  {
    code: "332215",
    title: "Pocket knives manufacturing",
  },
  {
    code: "332215",
    title: "Potato mashers manufacturing",
  },
  {
    code: "332215",
    title: "Pots and pans, fabricated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Pressure cookers, household-type, manufacturing",
  },
  {
    code: "332215",
    title: "Razor blades manufacturing",
  },
  {
    code: "332215",
    title: "Razors (except electric) manufacturing",
  },
  {
    code: "332215",
    title: "Safety razor blades manufacturing",
  },
  {
    code: "332215",
    title: "Safety razors manufacturing",
  },
  {
    code: "332215",
    title: "Scissors, nonelectric, manufacturing",
  },
  {
    code: "332215",
    title:
      "Shears, nonelectric, household-type (e.g., kitchen, barber, tailor) manufacturing",
  },
  {
    code: "332215",
    title:
      "Spoons, table, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Straight razors manufacturing",
  },
  {
    code: "332215",
    title: "Swords, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title:
      "Table cutlery, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332215",
    title: "Tailors' scissors, nonelectric, manufacturing",
  },
  {
    code: "332215",
    title:
      "Teakettles and coffee pots, fabricated metal (except electric, glass), manufacturing",
  },
  {
    code: "332216",
    title:
      "Agricultural handtools (e.g., hay forks, hoes, rakes, spades), nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Augers, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Awls manufacturing",
  },
  {
    code: "332216",
    title: "Axes manufacturing",
  },
  {
    code: "332216",
    title: "Bearing pullers, handtools, manufacturing",
  },
  {
    code: "332216",
    title: "Bits, edge tool, woodworking, manufacturing",
  },
  {
    code: "332216",
    title: "Blades, saw, all types, manufacturing",
  },
  {
    code: "332216",
    title: "Blow torches manufacturing",
  },
  {
    code: "332216",
    title: "Calipers and dividers, machinists' precision tools, manufacturing",
  },
  {
    code: "332216",
    title: "Can openers (except electric) manufacturing",
  },
  {
    code: "332216",
    title: "Carpenter's handtools, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title: "Caulking guns, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "C-clamps manufacturing",
  },
  {
    code: "332216",
    title: "Chain saw blades manufacturing",
  },
  {
    code: "332216",
    title: "Chisels manufacturing",
  },
  {
    code: "332216",
    title: "Clippers for animal use, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title:
      "Coordinate and contour measuring machines, machinists' precision tools, manufacturing",
  },
  {
    code: "332216",
    title: "Counterbores and countersinking bits, woodworking, manufacturing",
  },
  {
    code: "332216",
    title: "Cutters, glass, manufacturing",
  },
  {
    code: "332216",
    title: "Cutting dies (e.g., paper, leather, textile) manufacturing",
  },
  {
    code: "332216",
    title: "Cutting dies (except metal cutting) manufacturing",
  },
  {
    code: "332216",
    title: "Dial indicators, machinists' precision tools, manufacturing",
  },
  {
    code: "332216",
    title: "Dies, cutting (except metal cutting), manufacturing",
  },
  {
    code: "332216",
    title: "Dies, steel rule (except metal cutting), manufacturing",
  },
  {
    code: "332216",
    title: "Dividers, machinists' precision tools, manufacturing",
  },
  {
    code: "332216",
    title: "Drawknives manufacturing",
  },
  {
    code: "332216",
    title: "Drill bits, woodworking, manufacturing",
  },
  {
    code: "332216",
    title: "Drills, handheld, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title:
      "Edge tools, woodworking (e.g., augers, bits, countersinks), manufacturing",
  },
  {
    code: "332216",
    title: "Engraver's handtools, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Files, handheld, manufacturing",
  },
  {
    code: "332216",
    title: "Fish wire (i.e., electrical wiring tool) manufacturing",
  },
  {
    code: "332216",
    title: "Forks, handtools (e.g., garden, hay, manure), manufacturing",
  },
  {
    code: "332216",
    title: "Gauge blocks, machinists' precision tools, manufacturing",
  },
  {
    code: "332216",
    title:
      "Gauges, machinists' precision tools (except optical), manufacturing",
  },
  {
    code: "332216",
    title: "Gear pullers, handtools, manufacturing",
  },
  {
    code: "332216",
    title: "Gouges, woodworking, manufacturing",
  },
  {
    code: "332216",
    title: "Grass mowing equipment, nonpowered lawn and garden, manufacturing",
  },
  {
    code: "332216",
    title: "Guns, caulking, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Hair clippers for animal use, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title: "Hammers, handtools, manufacturing",
  },
  {
    code: "332216",
    title:
      "Handheld edge tools (except scissors-type), nonelectric, manufacturing",
  },
  {
    code: "332216",
    title:
      "Handtool metal blades (e.g., putty knives, scrapers, screwdrivers) manufacturing",
  },
  {
    code: "332216",
    title: "Handtools, machinists' precision, manufacturing",
  },
  {
    code: "332216",
    title: "Handtools, motor vehicle mechanics', manufacturing",
  },
  {
    code: "332216",
    title: "Hatchets manufacturing",
  },
  {
    code: "332216",
    title: "Hedge shears and trimmers, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title: "Hoes, garden and mason's handtools, manufacturing",
  },
  {
    code: "332216",
    title:
      "Hooks, handtools (e.g., baling, bush, grass, husking), manufacturing",
  },
  {
    code: "332216",
    title: "Jacks (except hydraulic, pneumatic) manufacturing",
  },
  {
    code: "332216",
    title: "Jeweler's handtools, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title:
      "Knives and bits for woodworking lathes, planers, and shapers manufacturing",
  },
  {
    code: "332216",
    title: "Lawn edgers, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Lawnmowers, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Leaf skimmers and rakes, nonpowered swimming pool, manufacturing",
  },
  {
    code: "332216",
    title: "Levels, carpenter's, manufacturing",
  },
  {
    code: "332216",
    title: "Machetes manufacturing",
  },
  {
    code: "332216",
    title: "Machine knives (except metal cutting) manufacturing",
  },
  {
    code: "332216",
    title:
      "Machinists' precision measuring tools (except optical) manufacturing",
  },
  {
    code: "332216",
    title: "Mallets (e.g., rubber, wood) manufacturing",
  },
  {
    code: "332216",
    title: "Mason's handtools manufacturing",
  },
  {
    code: "332216",
    title: "Mattocks (i.e., handtools) manufacturing",
  },
  {
    code: "332216",
    title: "Mauls, metal, manufacturing",
  },
  {
    code: "332216",
    title: "Measuring tools, machinist's (except optical), manufacturing",
  },
  {
    code: "332216",
    title: "Mechanic's handtools, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Metal cutting saw blades manufacturing",
  },
  {
    code: "332216",
    title: "Micrometers, machinist's precision tools, manufacturing",
  },
  {
    code: "332216",
    title: "Miter boxes manufacturing",
  },
  {
    code: "332216",
    title: "Picks (i.e., handtools) manufacturing",
  },
  {
    code: "332216",
    title: "Planes, handheld, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Pliers, handtools, manufacturing",
  },
  {
    code: "332216",
    title: "Plumbers' handtools, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Post hole diggers, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Precision tools, machinist's (except optical), manufacturing",
  },
  {
    code: "332216",
    title: "Pruners manufacturing",
  },
  {
    code: "332216",
    title: "Pry (i.e., crow) bars manufacturing",
  },
  {
    code: "332216",
    title: "Punches (except paper), nonpowered handtool, manufacturing",
  },
  {
    code: "332216",
    title: "Putty knives manufacturing",
  },
  {
    code: "332216",
    title: "Rakes, nonpowered handtool, manufacturing",
  },
  {
    code: "332216",
    title: "Rasps, handheld, manufacturing",
  },
  {
    code: "332216",
    title: "Ratchets, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Rulers, metal, manufacturing",
  },
  {
    code: "332216",
    title: "Saw blades, all types, manufacturing",
  },
  {
    code: "332216",
    title: "Saws, hand, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Scoops, metal (except kitchen-type), manufacturing",
  },
  {
    code: "332216",
    title: "Screwdrivers, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title: "Screwjacks manufacturing",
  },
  {
    code: "332216",
    title: "Scythes manufacturing",
  },
  {
    code: "332216",
    title:
      "Shears, nonelectric, tool-type (e.g., garden, pruners, tinsnip), manufacturing",
  },
  {
    code: "332216",
    title: "Shovels, handheld, manufacturing",
  },
  {
    code: "332216",
    title: "Sickles manufacturing",
  },
  {
    code: "332216",
    title: "Sledgehammers manufacturing",
  },
  {
    code: "332216",
    title: "Sockets and socket sets manufacturing",
  },
  {
    code: "332216",
    title:
      "Soldering guns and irons, handheld (including electric), manufacturing",
  },
  {
    code: "332216",
    title: "Soldering iron tips and tiplets manufacturing",
  },
  {
    code: "332216",
    title: "Spades and shovels, handheld, manufacturing",
  },
  {
    code: "332216",
    title: "Squares, carpenters', metal, manufacturing",
  },
  {
    code: "332216",
    title: "Stone cutting saw blades manufacturing",
  },
  {
    code: "332216",
    title: "Stonecutters' handtools, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Tape measures, metal, manufacturing",
  },
  {
    code: "332216",
    title: "Tinners' snips manufacturing",
  },
  {
    code: "332216",
    title:
      "Tools, hand, metal blade (e.g., putty knives, scrapers, screwdrivers)",
  },
  {
    code: "332216",
    title: "Tools, handheld, nonpowered (except kitchen-type), manufacturing",
  },
  {
    code: "332216",
    title:
      "Tools, woodworking edge (e.g., augers, bits, countersinks), manufacturing",
  },
  {
    code: "332216",
    title: "Trimmers, hedge, nonelectric, manufacturing",
  },
  {
    code: "332216",
    title: "Trowels manufacturing",
  },
  {
    code: "332216",
    title: "Vises (except machine tool attachments) manufacturing",
  },
  {
    code: "332216",
    title: "Wheel pullers, handtools, manufacturing",
  },
  {
    code: "332216",
    title: "Wood cutting saw blades manufacturing",
  },
  {
    code: "332216",
    title: "Wrenches, handtools, nonpowered, manufacturing",
  },
  {
    code: "332216",
    title: "Yardsticks, metal, manufacturing",
  },
  {
    code: "332311",
    title: "Buildings, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Carports, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Dwellings, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Farm buildings, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Garages, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Greenhouses, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Houses, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Panels, prefabricated metal building, manufacturing",
  },
  {
    code: "332311",
    title: "Portable buildings, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Prefabricated buildings, metal, manufacturing",
  },
  {
    code: "332311",
    title: "Prefabricated homes, metal, manufacturing",
  },
  {
    code: "332311",
    title: "Sections for prefabricated metal buildings manufacturing",
  },
  {
    code: "332311",
    title:
      "Sheds (e.g., garden, storage, utility), prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Silos, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Utility buildings, prefabricated metal, manufacturing",
  },
  {
    code: "332311",
    title: "Warehouses, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Barge sections, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Bars, concrete reinforcing, manufacturing",
  },
  {
    code: "332312",
    title: "Boat sections, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Bridge sections, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Concrete reinforcing bar (rebar) assemblies, fabrication",
  },
  {
    code: "332312",
    title: "Dam gates, metal plate, manufacturing",
  },
  {
    code: "332312",
    title: "Expansion joints, metal, manufacturing",
  },
  {
    code: "332312",
    title: "Fabricated bar joists manufacturing",
  },
  {
    code: "332312",
    title: "Fabricated structural metal manufacturing",
  },
  {
    code: "332312",
    title: "Flood gates, metal plate, manufacturing",
  },
  {
    code: "332312",
    title: "Floor jacks, metal, manufacturing",
  },
  {
    code: "332312",
    title: "Floor posts, adjustable metal, manufacturing",
  },
  {
    code: "332312",
    title: "Highway bridge sections, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Joists, fabricated bar, manufacturing",
  },
  {
    code: "332312",
    title: "Landing mats, aircraft, metal, manufacturing",
  },
  {
    code: "332312",
    title:
      "Radio and television tower sections, fabricated structural metal, manufacturing",
  },
  {
    code: "332312",
    title: "Railway bridge sections, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Ship sections, prefabricated metal, manufacturing",
  },
  {
    code: "332312",
    title: "Steel joists manufacturing",
  },
  {
    code: "332312",
    title: "Steel railroad car racks manufacturing",
  },
  {
    code: "332312",
    title: "Structural steel, fabricated, manufacturing",
  },
  {
    code: "332312",
    title:
      "Television tower sections, fabricated structural metal, manufacturing",
  },
  {
    code: "332312",
    title:
      "Transmission tower sections, fabricated structural metal, manufacturing",
  },
  {
    code: "332313",
    title: "Airlocks, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Baffles, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Bins, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Breechings, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Buoys, fabricated plate work metal, manufacturing",
  },
  {
    code: "332313",
    title: "Casings, scroll, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Chutes, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Covers, annealing, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Covers, floating, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Culverts, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Cupolas, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Cyclones, industrial, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Ducting, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Fabricated plate work manufacturing",
  },
  {
    code: "332313",
    title: "Floating covers, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Flumes, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Fumigating chambers, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Hoods, industrial, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Hoppers, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Jackets, industrial, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Ladle bails, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Ladles, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Liners, industrial, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Nuclear shielding, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Penstocks, fabricated metal plate, manufacturing",
  },
  {
    code: "332313",
    title: "Pile shells, fabricated metal plate, manufacturing",
  },
  {
    code: "332313",
    title: "Pipe, fabricated metal plate, manufacturing",
  },
  {
    code: "332313",
    title:
      "Plate work (e.g., bending, cutting, punching, shaping, welding), fabricated metal, manufacturing",
  },
  {
    code: "332313",
    title: "Racks (e.g., trash), fabricated metal plate, manufacturing",
  },
  {
    code: "332313",
    title: "Reactor containment vessels, fabricated metal plate, manufacturing",
  },
  {
    code: "332313",
    title: "Rocket casings, fabricated metal work, manufacturing",
  },
  {
    code: "332313",
    title: "Smokestacks, fabricated metal boiler plate, manufacturing",
  },
  {
    code: "332313",
    title:
      "Space simulation chambers, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Sterilizing chambers, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Trash racks, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Troughs, industrial, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Truss plates, metal, manufacturing",
  },
  {
    code: "332313",
    title: "Tunnel lining, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Tunnels, wind, fabricated metal plate work, manufacturing",
  },
  {
    code: "332313",
    title: "Weldments manufacturing",
  },
  {
    code: "332321",
    title: "Baseboards, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Casements, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Door and jamb assemblies, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Door frames and sash, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Doors, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Fire doors, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Frames, door and window, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Garage doors, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Hangar doors, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Jalousies, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Louver windows, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Molding and trim (except motor vehicle), metal, manufacturing",
  },
  {
    code: "332321",
    title:
      "Rolling doors for industrial buildings and warehouses, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Sash, door and window, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Screen doors, metal frame, manufacturing",
  },
  {
    code: "332321",
    title: "Screens, door and window, metal frame, manufacturing",
  },
  {
    code: "332321",
    title: "Shutters, door and window, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Skylights, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Storm doors and windows, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Trim and molding (except motor vehicle), metal, manufacturing",
  },
  {
    code: "332321",
    title: "Trim, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Weatherstrip, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Window frames and sash, metal, manufacturing",
  },
  {
    code: "332321",
    title: "Window screens, metal frame, manufacturing",
  },
  {
    code: "332321",
    title: "Windows, metal, manufacturing",
  },
  {
    code: "332322",
    title: "Air cowls, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Awnings, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Canopies, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Casings, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Coal chutes, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Concrete forms, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Cornices, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Cowls, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Culverts, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Dampers, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Door hoods, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Downspouts, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Ducts, sheet metal, manufacturing",
  },
  {
    code: "332322",
    title: "Eaves, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title:
      "Elbows for conductor pipe, hot air ducts, and stovepipe, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Flooring, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title:
      "Flues, stove and furnace, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Flumes, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Forms, concrete, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Furnace casings, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Furnace flues, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Guardrails, highway, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Gutters, sheet metal (except custom roll formed), manufacturing",
  },
  {
    code: "332322",
    title: "Hampers, laundry, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Highway guardrails, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title:
      "Hoods, range (except household-type), sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Irrigation pipe, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Joists, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Louvers, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Machine guards, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Mail chutes, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Pile shells, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Pipe, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title:
      "Radiator shields and enclosures, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Roof deck, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Roof ventilators, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Roofing, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Sheet metal work (except stampings) manufacturing",
  },
  {
    code: "332322",
    title: "Siding, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Spouts, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Stove boards, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title:
      "Stove pipes and flues, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Studs, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Troughs, elevator, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332322",
    title: "Wells, light, sheet metal (except stampings), manufacturing",
  },
  {
    code: "332323",
    title: "Acoustical suspension systems, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Architectural metalwork manufacturing",
  },
  {
    code: "332323",
    title: "Balcony railings, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Bank fixtures, ornamental metal, manufacturing",
  },
  {
    code: "332323",
    title: "Bannisters, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Barn stanchions and standards manufacturing",
  },
  {
    code: "332323",
    title: "Brasswork, ornamental, manufacturing",
  },
  {
    code: "332323",
    title: "Chain ladders, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Channels, furring metal, manufacturing",
  },
  {
    code: "332323",
    title: "Corrals, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Curtain wall, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Elevator guide rails, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Fences and gates (except wire), metal, manufacturing",
  },
  {
    code: "332323",
    title: "Fire escapes, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Flagpoles, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Flooring, open steel (i.e., grating), manufacturing",
  },
  {
    code: "332323",
    title: "Furring channels, sheet metal, manufacturing",
  },
  {
    code: "332323",
    title: "Gates, holding, sheet metal, manufacturing",
  },
  {
    code: "332323",
    title: "Gates, metal (except wire), manufacturing",
  },
  {
    code: "332323",
    title: "Gratings (i.e., open steel flooring) manufacturing",
  },
  {
    code: "332323",
    title: "Grills and grillwork, sheet metal, manufacturing",
  },
  {
    code: "332323",
    title: "Grillwork, ornamental metal, manufacturing",
  },
  {
    code: "332323",
    title: "Guards, bannisters, and railings, sheet metal, manufacturing",
  },
  {
    code: "332323",
    title: "Ladders, metal chain, manufacturing",
  },
  {
    code: "332323",
    title: "Ladders, permanently installed, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Lath, expanded metal, manufacturing",
  },
  {
    code: "332323",
    title: "Ornamental metalwork manufacturing",
  },
  {
    code: "332323",
    title: "Partitions, ornamental metal, manufacturing",
  },
  {
    code: "332323",
    title: "Pipe bannisters, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Pipe guards, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Pipe railings, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Purlins, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Railings, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Registers, metal air, manufacturing",
  },
  {
    code: "332323",
    title: "Scaffolds, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Stair railings, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Stair treads, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Staircases, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Stairs, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Stalls, metal, manufacturing",
  },
  {
    code: "332323",
    title: "Treads, metal stair, manufacturing",
  },
  {
    code: "332323",
    title: "Wrought iron fences manufacturing",
  },
  {
    code: "332410",
    title: "Aftercoolers (i.e., heat exchangers) manufacturing",
  },
  {
    code: "332410",
    title: "Barometric condensers manufacturing",
  },
  {
    code: "332410",
    title: "Boiler casings manufacturing",
  },
  {
    code: "332410",
    title: "Boilers, power, manufacturing",
  },
  {
    code: "332410",
    title: "Condenser boxes, metal, manufacturing",
  },
  {
    code: "332410",
    title: "Condensers, steam, manufacturing",
  },
  {
    code: "332410",
    title: "Economizers (i.e., power boiler accessory) manufacturing",
  },
  {
    code: "332410",
    title: "Exchangers, heat, manufacturing",
  },
  {
    code: "332410",
    title: "Heat exchangers manufacturing",
  },
  {
    code: "332410",
    title: "Intercooler shells manufacturing",
  },
  {
    code: "332410",
    title: "Marine power boilers manufacturing",
  },
  {
    code: "332410",
    title: "Nuclear control drive mechanisms manufacturing",
  },
  {
    code: "332410",
    title: "Nuclear reactor steam supply systems manufacturing",
  },
  {
    code: "332410",
    title: "Nuclear reactors control rod drive mechanisms manufacturing",
  },
  {
    code: "332410",
    title: "Nuclear reactors manufacturing",
  },
  {
    code: "332410",
    title: "Power boilers manufacturing",
  },
  {
    code: "332410",
    title: "Reactors, nuclear, manufacturing",
  },
  {
    code: "332410",
    title: "Stationary power boilers manufacturing",
  },
  {
    code: "332410",
    title: "Steam condensers manufacturing",
  },
  {
    code: "332420",
    title: "Absorbers, gas, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title:
      "Accumulators, industrial pressure vessels, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Acetylene cylinders, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Air receiver tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Annealing vats, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Autoclaves, industrial-type, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Bulk storage tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Caissons, underwater work, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Columns, fractionating, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Cryogenic tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Cylinders, pressure, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Digesters, industrial-type, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Farm storage tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Fermentation tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Gas storage tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Kettles, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Liquefied petroleum gas (LPG) cylinders manufacturing",
  },
  {
    code: "332420",
    title: "Liquid oxygen tanks manufacturing",
  },
  {
    code: "332420",
    title: "Nuclear waste casks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Oil storage tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Petroleum storage tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title:
      "Pots (e.g., annealing, melting, smelting), heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Retorts, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Septic tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Smelting pots and retorts manufacturing",
  },
  {
    code: "332420",
    title: "Stills, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Storage tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Vacuum tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Vats, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Vessels, heavy gauge metal, manufacturing",
  },
  {
    code: "332420",
    title: "Water tanks, heavy gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Aerosol cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Aluminum cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Beer cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Can lids and ends, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Cans, aluminum, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Cans, steel, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Lids and ends, can, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Metal cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Soft drink cans manufacturing",
  },
  {
    code: "332431",
    title: "Soup cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Steel cans, light gauge metal, manufacturing",
  },
  {
    code: "332431",
    title: "Tin plate cans, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Air cargo containers, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Ammunition boxes, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Barrels, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Beer kegs, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Bins, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Bottles, vacuum, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Boxes, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Cash boxes, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title:
      "Collapsible tubes (e.g., toothpaste, glue), light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Containers, air cargo, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Containers, light gauge metal (except cans), manufacturing",
  },
  {
    code: "332439",
    title: "Drums, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Fluid milk shipping containers, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Garbage cans, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Hoppers, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Ice chests or coolers, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Jugs, vacuum, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Laundry hampers, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Lunch boxes, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Mailboxes, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title:
      "Shipping barrels, drums, kegs, and pails, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Tool boxes, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Vacuum bottles and jugs, light gauge metal, manufacturing",
  },
  {
    code: "332439",
    title: "Vats, light gauge metal, manufacturing",
  },
  {
    code: "332510",
    title: "Aircraft hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Appliance hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Automobile hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Brackets (i.e., builder's hardware-type), metal, manufacturing",
  },
  {
    code: "332510",
    title: "Builder's hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Cabinet hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Casket hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Casters, furniture, metal manufacturing",
  },
  {
    code: "332510",
    title: "Casters, industrial, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Dead bolts, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Door locks, metal, manufacturing",
  },
  {
    code: "332510",
    title:
      "Door opening and closing devices (except electrical), metal, manufacturing",
  },
  {
    code: "332510",
    title: "Furniture hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Gun trigger locks, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Hinges, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Key blanks, metal, manufacturing",
  },
  {
    code: "332510",
    title:
      "Locks (except coin- or card-operated, time locks), metal, manufacturing",
  },
  {
    code: "332510",
    title: "Luggage hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Marine hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Motor vehicle hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Padlocks, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Piano hardware, metal, manufacturing",
  },
  {
    code: "332510",
    title: "Suitcase hardware, metal, manufacturing",
  },
  {
    code: "332613",
    title: "Automobile suspension springs, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Coiled springs (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
  },
  {
    code: "332613",
    title: "Coiled springs, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title: "Disk and ring springs, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Flat springs (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
  },
  {
    code: "332613",
    title: "Flat springs, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Furniture springs, light gauge, unassembled, made from purchased wire or strip",
  },
  {
    code: "332613",
    title:
      "Gun springs, light gauge, made from purchased wire or strip, manufacturing",
  },
  {
    code: "332613",
    title:
      "Hairsprings (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
  },
  {
    code: "332613",
    title: "Helical springs, hot wound heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Helical springs, light gauge, made from purchased wire or strip, manufacturing",
  },
  {
    code: "332613",
    title:
      "Instrument springs, precision (except clock, watch), light gauge, made from purchased wire or strip, manufacturing",
  },
  {
    code: "332613",
    title: "Leaf springs, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Mattress springs and spring units, light gauge, made from purchased wire or strip",
  },
  {
    code: "332613",
    title:
      "Sash balance springs, light gauge, made from purchased wire or strip",
  },
  {
    code: "332613",
    title:
      "Springs and spring units for seats, light gauge, made from purchased wire or strip",
  },
  {
    code: "332613",
    title: "Springs, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Springs, light gauge (except clock, watch), made from purchased wire or strip",
  },
  {
    code: "332613",
    title:
      "Springs, precision (except clock, watch), light gauge, made from purchased wire or strip",
  },
  {
    code: "332613",
    title: "Torsion bar, heavy gauge metal, manufacturing",
  },
  {
    code: "332613",
    title:
      "Upholstery springs and spring units, light gauge, made from purchased wire or strip",
  },
  {
    code: "332618",
    title: "Automobile skid chains made from purchased wire",
  },
  {
    code: "332618",
    title: "Bale ties made from purchased wire",
  },
  {
    code: "332618",
    title: "Barbed wire made from purchased wire",
  },
  {
    code: "332618",
    title: "Baskets, metal, made from purchased wire",
  },
  {
    code: "332618",
    title: "Belts, conveyor, made from purchased wire",
  },
  {
    code: "332618",
    title: "Belts, drying, made from purchased wire",
  },
  {
    code: "332618",
    title: "Brackets made from purchased wire",
  },
  {
    code: "332618",
    title: "Brads, metal, made from purchased wire",
  },
  {
    code: "332618",
    title: "Cable, noninsulated wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Cages made from purchased wire",
  },
  {
    code: "332618",
    title: "Can keys made from purchased wire",
  },
  {
    code: "332618",
    title: "Chain link fencing and fence gates made from purchased wire",
  },
  {
    code: "332618",
    title: "Chain made from purchased wire",
  },
  {
    code: "332618",
    title: "Chain, welded, made from purchased wire",
  },
  {
    code: "332618",
    title: "Chicken netting made from purchased wire",
  },
  {
    code: "332618",
    title: "Cloth, woven wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Coat hangers made from purchased wire",
  },
  {
    code: "332618",
    title: "Concrete reinforcing mesh made from purchased wire",
  },
  {
    code: "332618",
    title: "Crab traps made from purchased wire",
  },
  {
    code: "332618",
    title: "Cylinder wire cloth made from purchased wire",
  },
  {
    code: "332618",
    title: "Delivery cases made from purchased wire",
  },
  {
    code: "332618",
    title: "Diamond cloths made from purchased wire",
  },
  {
    code: "332618",
    title: "Fabrics, woven wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Fencing and fence gates made from purchased wire",
  },
  {
    code: "332618",
    title: "Fourdrinier wire cloth made from purchased wire",
  },
  {
    code: "332618",
    title: "Grilles and grillwork made from purchased wire",
  },
  {
    code: "332618",
    title: "Guards, wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Hardware cloth, woven wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Insect screening made from purchased wire",
  },
  {
    code: "332618",
    title: "Key rings made from purchased wire",
  },
  {
    code: "332618",
    title: "Lamp frames, wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Mats and matting made from purchased wire",
  },
  {
    code: "332618",
    title: "Mesh made from purchased wire",
  },
  {
    code: "332618",
    title: "Nails, brads, and staples made from purchased wire",
  },
  {
    code: "332618",
    title: "Netting, woven, made from purchased wire",
  },
  {
    code: "332618",
    title: "Paper clips made from purchased wire",
  },
  {
    code: "332618",
    title: "Paper machine wire cloth made from purchased wire",
  },
  {
    code: "332618",
    title: "Poultry netting made from purchased wire",
  },
  {
    code: "332618",
    title: "Racks, household-type, made from purchased wire",
  },
  {
    code: "332618",
    title: "Reinforcing mesh, concrete, made from purchased wire",
  },
  {
    code: "332618",
    title: "Rope, wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Shelving, wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Sieves, made from purchased wire, manufacturing",
  },
  {
    code: "332618",
    title: "Slings, lifting, made from purchased wire",
  },
  {
    code: "332618",
    title: "Spikes made from purchased wire",
  },
  {
    code: "332618",
    title: "Spiral cloth made from purchased wire",
  },
  {
    code: "332618",
    title: "Staples made from purchased wire",
  },
  {
    code: "332618",
    title: "Stranded wire, uninsulated, made from purchased wire",
  },
  {
    code: "332618",
    title: "Tacks, metal, made from purchased wire",
  },
  {
    code: "332618",
    title: "Tire chains made from purchased wire",
  },
  {
    code: "332618",
    title: "Traps, animal and fish, made from purchased wire",
  },
  {
    code: "332618",
    title: "Trays, wire, made from purchased wire",
  },
  {
    code: "332618",
    title: "Window screening, woven, made from purchased wire",
  },
  {
    code: "332710",
    title: "Automotive machine shops",
  },
  {
    code: "332710",
    title: "Chemical milling job shops",
  },
  {
    code: "332710",
    title: "Machine shops",
  },
  {
    code: "332721",
    title: "Precision turned product manufacturing",
  },
  {
    code: "332722",
    title: "Bolts, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Cotter pins, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Dowel pins, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Hook and eye latches, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Hooks (i.e., general purpose fasteners), metal, manufacturing",
  },
  {
    code: "332722",
    title: "Hooks, metal screw, manufacturing",
  },
  {
    code: "332722",
    title: "Hose clamps, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Lock washers, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Machine keys, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Nuts, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Rivets, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Screw eyes, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Screws, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Spring pins, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Spring washers, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Toggle bolts, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Turnbuckles, metal, manufacturing",
  },
  {
    code: "332722",
    title: "Washers, metal, manufacturing",
  },
  {
    code: "332811",
    title: "Annealing metals and metal products for the trade",
  },
  {
    code: "332811",
    title: "Brazing (i.e., hardening) metals and metal products for the trade",
  },
  {
    code: "332811",
    title: "Burning metals and metal products for the trade",
  },
  {
    code: "332811",
    title: "Cold treating metals for the trade",
  },
  {
    code: "332811",
    title: "Cryogenic treating metals for the trade",
  },
  {
    code: "332811",
    title:
      "Hardening (i.e., heat treating) metals and metal products for the trade",
  },
  {
    code: "332811",
    title: "Heat treating metals and metal products for the trade",
  },
  {
    code: "332811",
    title: "Shot peening metal and metal products for the trade",
  },
  {
    code: "332811",
    title: "Tempering metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Aluminum coating of metal products for the trade",
  },
  {
    code: "332812",
    title: "Bonderizing metal and metal products for the trade",
  },
  {
    code: "332812",
    title:
      "Chasing metals and metal products (except printing plates) for the trade",
  },
  {
    code: "332812",
    title: "Coating metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Coating of metal and metal products with plastics for the trade",
  },
  {
    code: "332812",
    title: "Enameling metals and metal products for the trade",
  },
  {
    code: "332812",
    title:
      "Engraving metals and metal products (except printing plates) for the trade",
  },
  {
    code: "332812",
    title:
      "Etching metals and metal products (except printing plates) for the trade",
  },
  {
    code: "332812",
    title: "Flocking metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Galvanizing metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Glazing metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Hot dip galvanizing metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Japanning metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Lacquering metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Painting metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Parkerizing metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Powder coating metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Rustproofing metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Sherardizing of metals and metal products for the trade",
  },
  {
    code: "332812",
    title: "Varnishing metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Anodizing metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Buffing metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Chrome plating metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Cleaning and descaling metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Coloring metals and metal products (except coating) for the trade",
  },
  {
    code: "332813",
    title: "Depolishing metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Electroplating metals and formed products for the trade",
  },
  {
    code: "332813",
    title: "Gold and silver plating metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Laminating metals and metal formed products without fabricating",
  },
  {
    code: "332813",
    title: "Pickling metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Plastic, glass, or other media blasting services",
  },
  {
    code: "332813",
    title: "Plating metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Polishing metals and metal products for the trade",
  },
  {
    code: "332813",
    title: "Sandblasting metals and metal products for the trade",
  },
  {
    code: "332813",
    title:
      "Tumbling (i.e., cleaning and polishing) metal and metal products for the trade",
  },
  {
    code: "332911",
    title: "Angle valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title:
      "Automatic (i.e., controlling-type, regulating) valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Ball valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Boiler gauge cocks, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Butterfly valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Check valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Compressed gas cylinder valves manufacturing",
  },
  {
    code: "332911",
    title: "Control valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Cross valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Fire hydrant valves manufacturing",
  },
  {
    code: "332911",
    title: "Fire hydrants, complete, manufacturing",
  },
  {
    code: "332911",
    title: "Flushing hydrant manufacturing",
  },
  {
    code: "332911",
    title: "Gas valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Gate valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Globe valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Nuclear application valves manufacturing",
  },
  {
    code: "332911",
    title: "Plug valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title:
      "Pressure control valves (except fluid power), industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Safety (i.e., pop-off) valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title:
      "Solenoid valves (except fluid power), industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Steam traps, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Stop valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Straightway (i.e., Y-type) valves, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Thermostatic traps, industrial-type, manufacturing",
  },
  {
    code: "332911",
    title: "Valves for nuclear applications manufacturing",
  },
  {
    code: "332911",
    title: "Valves for water works and municipal water systems manufacturing",
  },
  {
    code: "332911",
    title:
      "Valves, industrial-type (e.g., check, gate, globe, relief, safety), manufacturing",
  },
  {
    code: "332911",
    title: "Water sampling station manufacturing",
  },
  {
    code: "332911",
    title: "Waterworks and municipal water system valves manufacturing",
  },
  {
    code: "332912",
    title: "Control valves, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Electrohydraulic servo valves, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Fluid power aircraft subassemblies manufacturing",
  },
  {
    code: "332912",
    title: "Fluid power hose assemblies manufacturing",
  },
  {
    code: "332912",
    title: "Fluid power valves and hose fittings manufacturing",
  },
  {
    code: "332912",
    title: "Hose assemblies for fluid power systems manufacturing",
  },
  {
    code: "332912",
    title: "Hose couplings and fittings, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Hydraulic aircraft subassemblies manufacturing",
  },
  {
    code: "332912",
    title: "Hydraulic hose fittings, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Hydraulic valves, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Pneumatic aircraft subassemblies manufacturing",
  },
  {
    code: "332912",
    title: "Pneumatic hose fittings, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Pneumatic valves, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Pressure control valves, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Solenoid valves, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Tube and hose fittings, fluid power, manufacturing",
  },
  {
    code: "332912",
    title: "Valves, hydraulic and pneumatic, fluid power, manufacturing",
  },
  {
    code: "332913",
    title: "Antiscald bath and shower valves, plumbing, manufacturing",
  },
  {
    code: "332913",
    title: "Backflow preventers, plumbing, manufacturing",
  },
  {
    code: "332913",
    title: "Cocks, drain, plumbing, manufacturing",
  },
  {
    code: "332913",
    title: "Drain cocks, plumbing, manufacturing",
  },
  {
    code: "332913",
    title: "Faucets, plumbing, manufacturing",
  },
  {
    code: "332913",
    title: "Flush valves, plumbing, manufacturing",
  },
  {
    code: "332913",
    title:
      "Plumbing fittings and couplings (e.g., compression fittings, metal elbows, metal unions) manufacturing",
  },
  {
    code: "332913",
    title: "Plumbing fixture fittings and trim, all materials, manufacturing",
  },
  {
    code: "332913",
    title: "Shower heads, plumbing, manufacturing",
  },
  {
    code: "332913",
    title: "Spigots, plumbing fixture fitting, manufacturing",
  },
  {
    code: "332913",
    title: "Stopcock drains, plumbing, manufacturing",
  },
  {
    code: "332913",
    title:
      "Supply line assemblies, plumbing (i.e., flexible hose with fittings), manufacturing",
  },
  {
    code: "332919",
    title: "Aerosol valves manufacturing",
  },
  {
    code: "332919",
    title:
      "Boiler couplings and drains, plumbing and heating-type, manufacturing",
  },
  {
    code: "332919",
    title: "Breakers, vacuum, plumbing, manufacturing",
  },
  {
    code: "332919",
    title: "Couplings, hose, metal (except fluid power), manufacturing",
  },
  {
    code: "332919",
    title:
      "Elbows, pipe, metal (except made from purchased pipe), manufacturing",
  },
  {
    code: "332919",
    title: "Flanges and flange unions, pipe, metal, manufacturing",
  },
  {
    code: "332919",
    title: "Hose couplings, metal (except fluid power), manufacturing",
  },
  {
    code: "332919",
    title: "Lawn hose nozzles and lawn sprinklers manufacturing",
  },
  {
    code: "332919",
    title: "Nozzles, firefighting, manufacturing",
  },
  {
    code: "332919",
    title: "Nozzles, lawn hose, manufacturing",
  },
  {
    code: "332919",
    title:
      "Plumbing and heating inline valves (e.g., check, cutoffs, stop) manufacturing",
  },
  {
    code: "332919",
    title: "Sprinklers, lawn, manufacturing",
  },
  {
    code: "332919",
    title: "Steam fittings, metal, manufacturing",
  },
  {
    code: "332919",
    title: "Traps, water, manufacturing",
  },
  {
    code: "332919",
    title:
      "Unions, pipe, metal (except made from purchased pipe), manufacturing",
  },
  {
    code: "332919",
    title:
      "Valves, inline plumbing and heating (e.g., cutoffs, stop), manufacturing",
  },
  {
    code: "332919",
    title: "Water traps manufacturing",
  },
  {
    code: "332991",
    title: "Annular ball bearings manufacturing",
  },
  {
    code: "332991",
    title: "Ball bearings manufacturing",
  },
  {
    code: "332991",
    title: "Bearings, ball and roller, manufacturing",
  },
  {
    code: "332991",
    title: "Cylindrical roller bearings manufacturing",
  },
  {
    code: "332991",
    title: "Flange units, ball or roller bearing, manufacturing",
  },
  {
    code: "332991",
    title: "Linear ball bearings manufacturing",
  },
  {
    code: "332991",
    title: "Linear roller bearings manufacturing",
  },
  {
    code: "332991",
    title: "Needle roller bearings manufacturing",
  },
  {
    code: "332991",
    title: "Pillow blocks with ball or roller bearings manufacturing",
  },
  {
    code: "332991",
    title: "Races, ball or roller bearings, manufacturing",
  },
  {
    code: "332991",
    title: "Roller bearings manufacturing",
  },
  {
    code: "332991",
    title: "Tapered roller bearings manufacturing",
  },
  {
    code: "332991",
    title: "Thrust roller bearings manufacturing",
  },
  {
    code: "332992",
    title:
      "Ammunition, small arms (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
  },
  {
    code: "332992",
    title: "BB shot manufacturing",
  },
  {
    code: "332992",
    title:
      "Blank cartridges (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
  },
  {
    code: "332992",
    title:
      "Bullet jackets and cores (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
  },
  {
    code: "332992",
    title:
      "Cartridge cases for ammunition (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
  },
  {
    code: "332992",
    title: "Cartridges (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
  },
  {
    code: "332992",
    title:
      "Cores, bullet (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
  },
  {
    code: "332992",
    title:
      "Jackets, bullet (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
  },
  {
    code: "332992",
    title:
      "Paper shells (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
  },
  {
    code: "332992",
    title: "Pellets, air rifle and pistol, manufacturing",
  },
  {
    code: "332992",
    title:
      "Percussion caps (i.e., 30 mm. or less, 1.18 inch or less), ammunition, manufacturing",
  },
  {
    code: "332992",
    title:
      "Shells, small arms (i.e., 30 mm. or less, 1.18 inch or less), manufacturing",
  },
  {
    code: "332992",
    title: "Shot, BB, manufacturing",
  },
  {
    code: "332992",
    title: "Shot, lead, manufacturing",
  },
  {
    code: "332992",
    title: "Shot, pellet, manufacturing",
  },
  {
    code: "332992",
    title: "Shot, steel, manufacturing",
  },
  {
    code: "332992",
    title: "Shotgun shells manufacturing",
  },
  {
    code: "332992",
    title:
      "Small arms ammunition (i.e., 30 mm. or less, 1.18 inch or less) manufacturing",
  },
  {
    code: "332992",
    title: "Wads, ammunition, manufacturing",
  },
  {
    code: "332993",
    title: "Adapters, bombcluster, manufacturing",
  },
  {
    code: "332993",
    title:
      "Ammunition (i.e., more than 30 mm., more than 1.18 inch) manufacturing",
  },
  {
    code: "332993",
    title: "Ammunition loading and assembling plants",
  },
  {
    code: "332993",
    title: "Arming and fusing devices, missile, manufacturing",
  },
  {
    code: "332993",
    title:
      "Artillery ammunition (i.e., more than 30 mm., more than 1.18 inch) manufacturing",
  },
  {
    code: "332993",
    title: "Bag loading plants, ammunition, manufacturing",
  },
  {
    code: "332993",
    title: "Bomb loading and assembling plants",
  },
  {
    code: "332993",
    title: "Bombcluster adapters manufacturing",
  },
  {
    code: "332993",
    title: "Bombs manufacturing",
  },
  {
    code: "332993",
    title: "Boosters and bursters, artillery, manufacturing",
  },
  {
    code: "332993",
    title: "Canisters, ammunition, manufacturing",
  },
  {
    code: "332993",
    title: "Caps, bomb, manufacturing",
  },
  {
    code: "332993",
    title: "Depth charges manufacturing",
  },
  {
    code: "332993",
    title:
      "Detonators, ammunition (i.e., more than 30 mm., more than 1.18 inch), manufacturing",
  },
  {
    code: "332993",
    title: "Fin assemblies, mortar, manufacturing",
  },
  {
    code: "332993",
    title: "Fin assemblies, torpedo and bomb, manufacturing",
  },
  {
    code: "332993",
    title:
      "Fuses ammunition (i.e., more than 30 mm., more than 1.18 inch) manufacturing",
  },
  {
    code: "332993",
    title: "Grenades, hand or projectile, manufacturing",
  },
  {
    code: "332993",
    title:
      "Igniters, ammunition tracer (i.e., more than 30 mm., more than 1.18 inch), manufacturing",
  },
  {
    code: "332993",
    title: "Jet propulsion projectiles (except guided missiles) manufacturing",
  },
  {
    code: "332993",
    title: "Loading and assembling bombs",
  },
  {
    code: "332993",
    title: "Mines, ammunition, manufacturing",
  },
  {
    code: "332993",
    title: "Missile warheads manufacturing",
  },
  {
    code: "332993",
    title: "Mortar shells manufacturing",
  },
  {
    code: "332993",
    title:
      "Primers (i.e., more than 30 mm., more than 1.18 inch), ammunition, manufacturing",
  },
  {
    code: "332993",
    title: "Projectiles (except guided missile), jet propulsion, manufacturing",
  },
  {
    code: "332993",
    title:
      "Rockets, ammunition (except guided missiles, pyrotechnic), manufacturing",
  },
  {
    code: "332993",
    title: "Shell loading and assembly plants",
  },
  {
    code: "332993",
    title: "Shells, artillery, manufacturing",
  },
  {
    code: "332993",
    title: "Torpedoes manufacturing",
  },
  {
    code: "332993",
    title:
      "Tracer igniters, ammunition (i.e., more than 30 mm., more than 1.18 inch), manufacturing",
  },
  {
    code: "332994",
    title: "Aircraft artillery manufacturing",
  },
  {
    code: "332994",
    title: "Ammunition carts manufacturing",
  },
  {
    code: "332994",
    title: "Antiaircraft artillery manufacturing",
  },
  {
    code: "332994",
    title: "Antisubmarine projectors manufacturing",
  },
  {
    code: "332994",
    title: "Antitank rocket launchers manufacturing",
  },
  {
    code: "332994",
    title: "Barrels, gun, manufacturing",
  },
  {
    code: "332994",
    title: "BB guns manufacturing",
  },
  {
    code: "332994",
    title: "Belts, machine gun, manufacturing",
  },
  {
    code: "332994",
    title: "Bofors guns manufacturing",
  },
  {
    code: "332994",
    title: "Cannons manufacturing",
  },
  {
    code: "332994",
    title: "Carbines manufacturing",
  },
  {
    code: "332994",
    title: "Catapult guns manufacturing",
  },
  {
    code: "332994",
    title: "Clips, gun, manufacturing",
  },
  {
    code: "332994",
    title: "Cylinders and clips, gun, manufacturing",
  },
  {
    code: "332994",
    title: "Dart guns manufacturing",
  },
  {
    code: "332994",
    title: "Depth charge projectors manufacturing",
  },
  {
    code: "332994",
    title: "Field artillery manufacturing",
  },
  {
    code: "332994",
    title: "Firearms, small, manufacturing",
  },
  {
    code: "332994",
    title: "Flame throwers manufacturing",
  },
  {
    code: "332994",
    title: "Generators, smoke, manufacturing",
  },
  {
    code: "332994",
    title: "Grenade launchers manufacturing",
  },
  {
    code: "332994",
    title: "Gun barrels manufacturing",
  },
  {
    code: "332994",
    title: "Gun cleaning kits manufacturing",
  },
  {
    code: "332994",
    title: "Gun magazines manufacturing",
  },
  {
    code: "332994",
    title: "Gun turrets manufacturing",
  },
  {
    code: "332994",
    title: "Guns manufacturing",
  },
  {
    code: "332994",
    title: "Guns, BB and pellet, manufacturing",
  },
  {
    code: "332994",
    title: "Howitzers manufacturing",
  },
  {
    code: "332994",
    title: "Links, ammunition, manufacturing",
  },
  {
    code: "332994",
    title: "Livens projectors (i.e., ordnance) manufacturing",
  },
  {
    code: "332994",
    title: "Machine gun belts manufacturing",
  },
  {
    code: "332994",
    title: "Machine guns manufacturing",
  },
  {
    code: "332994",
    title: "Mortars manufacturing",
  },
  {
    code: "332994",
    title: "Naval artillery manufacturing",
  },
  {
    code: "332994",
    title: "Oerlikon guns manufacturing",
  },
  {
    code: "332994",
    title: "Pellet guns manufacturing",
  },
  {
    code: "332994",
    title: "Pistols manufacturing",
  },
  {
    code: "332994",
    title:
      "Projectors (e.g., antisub, depth charge release, grenade, livens, rocket), ordnance, manufacturing",
  },
  {
    code: "332994",
    title: "Pyrotechnic pistols and projectors manufacturing",
  },
  {
    code: "332994",
    title: "Recoil mechanisms, gun, manufacturing",
  },
  {
    code: "332994",
    title: "Recoilless rifles manufacturing",
  },
  {
    code: "332994",
    title: "Revolvers manufacturing",
  },
  {
    code: "332994",
    title: "Rifles (except toy) manufacturing",
  },
  {
    code: "332994",
    title: "Rifles, BB and pellet, manufacturing",
  },
  {
    code: "332994",
    title: "Rifles, pneumatic, manufacturing",
  },
  {
    code: "332994",
    title: "Rifles, recoilless, manufacturing",
  },
  {
    code: "332994",
    title: "Rocket launchers manufacturing",
  },
  {
    code: "332994",
    title: "Shotguns manufacturing",
  },
  {
    code: "332994",
    title: "Small arms manufacturing",
  },
  {
    code: "332994",
    title: "Smoke generators manufacturing",
  },
  {
    code: "332994",
    title: "Submachine guns manufacturing",
  },
  {
    code: "332994",
    title: "Tampion guns manufacturing",
  },
  {
    code: "332994",
    title: "Tank artillery manufacturing",
  },
  {
    code: "332994",
    title: "Torpedo tubes manufacturing",
  },
  {
    code: "332994",
    title: "Tranquilizer guns, manufacturing",
  },
  {
    code: "332994",
    title: "Turrets, gun, manufacturing",
  },
  {
    code: "332996",
    title: "Bends, pipe, made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Coils, pipe, made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Couplings, pipe, made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Fabricated pipe and pipe fittings made from purchased pipe",
  },
  {
    code: "332996",
    title: "Manifolds, pipe, made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Nipples, metal, made from purchased pipe",
  },
  {
    code: "332996",
    title: "Pipe and pipe fittings made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Pipe couplings made from purchased metal pipe",
  },
  {
    code: "332996",
    title:
      "Pipe fabricating (i.e., bending, cutting, threading) made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Pipe headers made from purchased metal pipe",
  },
  {
    code: "332996",
    title: "Tubes made from purchased metal pipe",
  },
  {
    code: "332996",
    title:
      "Wrought iron or steel pipe and tubing made from purchased metal pipe",
  },
  {
    code: "332999",
    title: "Aluminum freezer foil not made in rolling mills",
  },
  {
    code: "332999",
    title: "Aluminum ladders manufacturing",
  },
  {
    code: "332999",
    title: "Andirons manufacturing",
  },
  {
    code: "332999",
    title: "Angle irons, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Animal traps, metal (except wire), manufacturing",
  },
  {
    code: "332999",
    title: "Aquarium accessories, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Badges, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Bank chests, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Barricades, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Bathroom fixtures, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Bathtubs, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Bellows, hand, manufacturing",
  },
  {
    code: "332999",
    title: "Book ends, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Car seals, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Chain fittings manufacturing",
  },
  {
    code: "332999",
    title: "Chests, fire or burglary resistive, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Chests, money, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Chests, safe deposit, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Combs, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Containers, foil (except bags), manufacturing",
  },
  {
    code: "332999",
    title: "Copper foil not made in rolling mills",
  },
  {
    code: "332999",
    title: "Cores, sand foundry, manufacturing",
  },
  {
    code: "332999",
    title: "Cuffs, leg, iron, manufacturing",
  },
  {
    code: "332999",
    title: "Doors, safe and vault, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Drain plugs, magnetic, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Drill stands, metal, manufacturing",
  },
  {
    code: "332999",
    title:
      "Drinking fountains (except mechanically refrigerated), metal, manufacturing",
  },
  {
    code: "332999",
    title: "Ecclesiastical ware, precious plated metal, manufacturing",
  },
  {
    code: "332999",
    title: "Fireplace fixtures and equipment manufacturing",
  },
  {
    code: "332999",
    title: "Flexible metal hose and tubing manufacturing",
  },
  {
    code: "332999",
    title: "Flush tanks, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Foil containers (except bags) manufacturing",
  },
  {
    code: "332999",
    title: "Foil not made in rolling mills",
  },
  {
    code: "332999",
    title: "Foundry cores manufacturing",
  },
  {
    code: "332999",
    title: "Foundry pattern making",
  },
  {
    code: "332999",
    title: "Fountains (except drinking), metal, manufacturing",
  },
  {
    code: "332999",
    title:
      "Fountains, drinking (except mechanically refrigerated), metal, manufacturing",
  },
  {
    code: "332999",
    title: "Frames and handles, handbag and luggage, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Frames, metal, lamp shade, manufacturing",
  },
  {
    code: "332999",
    title: "Frames, metal, umbrella and parasol, manufacturing",
  },
  {
    code: "332999",
    title: "Gold beating (i.e., foil, leaf)",
  },
  {
    code: "332999",
    title: "Gold foil and leaf not made in rolling mills",
  },
  {
    code: "332999",
    title: "Hair curlers, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Handcuffs manufacturing",
  },
  {
    code: "332999",
    title: "Handles (e.g., parasol, umbrella), metal, manufacturing",
  },
  {
    code: "332999",
    title: "Harness parts, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Hollowware, precious plated metal, manufacturing",
  },
  {
    code: "332999",
    title: "Hoops, metal (except wire), fabricated from purchased metal",
  },
  {
    code: "332999",
    title: "Horse bits manufacturing",
  },
  {
    code: "332999",
    title: "Hose, flexible metal, manufacturing",
  },
  {
    code: "332999",
    title: "Identification plates, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Industrial pattern manufacturing",
  },
  {
    code: "332999",
    title: "Ironing boards, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Ladder jacks, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Ladders, portable metal, manufacturing",
  },
  {
    code: "332999",
    title: "Lamp shade frames, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Laundry tubs, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Lavatories, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Lead foil not made in rolling mills",
  },
  {
    code: "332999",
    title: "Leaf, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Linings, metal safe and vault, manufacturing",
  },
  {
    code: "332999",
    title: "Machine bases, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Magnesium foil not made in rolling mills",
  },
  {
    code: "332999",
    title: "Magnets, permanent, metallic, manufacturing",
  },
  {
    code: "332999",
    title: "Marine horns, compressed air or steam, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Metal foil containers (except bags) manufacturing",
  },
  {
    code: "332999",
    title: "Military insignia, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Money chests, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Name plate blanks, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Nickel foil not made in rolling mills",
  },
  {
    code: "332999",
    title:
      "Novelties and specialties, nonprecious metal and precious plated, manufacturing",
  },
  {
    code: "332999",
    title: "Pads, soap impregnated scouring, manufacturing",
  },
  {
    code: "332999",
    title: "Paint sticks, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Pallet parts, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Pallets, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Patterns (except shoe), industrial, manufacturing",
  },
  {
    code: "332999",
    title: "Pipe hangers and supports, metal, manufacturing",
  },
  {
    code: "332999",
    title:
      "Plated ware (e.g., ecclesiastical ware, hollowware, toilet ware) manufacturing",
  },
  {
    code: "332999",
    title: "Platinum foil and leaf not made in rolling mills",
  },
  {
    code: "332999",
    title: "Plugs, magnetic metal drain, manufacturing",
  },
  {
    code: "332999",
    title: "Plumbing fixtures, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Portable chemical toilets, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Propellers, ship and boat, made from purchased metal",
  },
  {
    code: "332999",
    title: "Reels, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Rope fittings manufacturing",
  },
  {
    code: "332999",
    title: "Saddlery parts, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Safe deposit boxes and chests, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Safe doors and linings, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Safes, metal, manufacturing",
  },
  {
    code: "332999",
    title:
      "Sanitary ware (e.g., bathtubs, lavatories, sinks), metal, manufacturing",
  },
  {
    code: "332999",
    title: "Scouring pads, soap impregnated, manufacturing",
  },
  {
    code: "332999",
    title: "Shims, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Shower receptors, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Shower rods, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Shower stalls, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Silver beating (i.e., foil, leaf)",
  },
  {
    code: "332999",
    title: "Silver foil and leaf not made in rolling mills",
  },
  {
    code: "332999",
    title: "Sinks, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Skids, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Soap dispensers, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Sponges, metal scouring, manufacturing",
  },
  {
    code: "332999",
    title: "Stabilizing bars, cargo, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Steel wool manufacturing",
  },
  {
    code: "332999",
    title: "Stepladders, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Strappings, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Tablets, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Thimbles for wire rope manufacturing",
  },
  {
    code: "332999",
    title: "Tinfoil not made in rolling mills",
  },
  {
    code: "332999",
    title: "Toilet fixtures, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Toilet ware, precious plated metal, manufacturing",
  },
  {
    code: "332999",
    title: "Trophies, nonprecious and precious plated metal, manufacturing",
  },
  {
    code: "332999",
    title: "Tubing, flexible metal, manufacturing",
  },
  {
    code: "332999",
    title: "Tubs, laundry and bath, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Urinals, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Vault doors and linings, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Vaults (except burial), metal, manufacturing",
  },
  {
    code: "332999",
    title: "Water closets, metal, manufacturing",
  },
  {
    code: "332999",
    title: "Zinc foil and leaf not made in rolling mills",
  },
  {
    code: "333111",
    title: "Bale throwers manufacturing",
  },
  {
    code: "333111",
    title: "Balers, farm-type (e.g., cotton, hay, straw), manufacturing",
  },
  {
    code: "333111",
    title: "Berry harvesting machines manufacturing",
  },
  {
    code: "333111",
    title: "Blowers, forage, manufacturing",
  },
  {
    code: "333111",
    title: "Cabs for agricultural machinery manufacturing",
  },
  {
    code: "333111",
    title: "Cattle feeding and watering equipment manufacturing",
  },
  {
    code: "333111",
    title: "Chicken brooders manufacturing",
  },
  {
    code: "333111",
    title: "Chicken feeders manufacturing",
  },
  {
    code: "333111",
    title: "Combines (i.e., harvester-threshers) manufacturing",
  },
  {
    code: "333111",
    title: "Corn heads for combines manufacturing",
  },
  {
    code: "333111",
    title: "Corn pickers and shellers manufacturing",
  },
  {
    code: "333111",
    title: "Cotton balers and presses manufacturing",
  },
  {
    code: "333111",
    title: "Cotton ginning machinery manufacturing",
  },
  {
    code: "333111",
    title: "Cotton picker and stripper harvesting machinery manufacturing",
  },
  {
    code: "333111",
    title: "Cream separators, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Crop driers manufacturing",
  },
  {
    code: "333111",
    title: "Cultivators, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Curers, tobacco, manufacturing",
  },
  {
    code: "333111",
    title: "Drags, farm-type equipment, manufacturing",
  },
  {
    code: "333111",
    title: "Dusters, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Farm tractors and attachments manufacturing",
  },
  {
    code: "333111",
    title: "Farm wagons manufacturing",
  },
  {
    code: "333111",
    title: "Feed processing equipment, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Fertilizing machinery, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Fruit harvesting machines manufacturing",
  },
  {
    code: "333111",
    title: "Grading, cleaning, and sorting machinery, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Grain drills manufacturing",
  },
  {
    code: "333111",
    title: "Grain stackers manufacturing",
  },
  {
    code: "333111",
    title: "Grass mowing equipment (except lawn and garden) manufacturing",
  },
  {
    code: "333111",
    title: "Hair clippers for animal use, electric, manufacturing",
  },
  {
    code: "333111",
    title: "Harrows (e.g., disc, spring, tine) manufacturing",
  },
  {
    code: "333111",
    title: "Harvesting machinery and equipment, agriculture, manufacturing",
  },
  {
    code: "333111",
    title: "Hay balers and presses manufacturing",
  },
  {
    code: "333111",
    title: "Haying machines manufacturing",
  },
  {
    code: "333111",
    title: "Hog feeding and watering equipment manufacturing",
  },
  {
    code: "333111",
    title: "Hulling machinery, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Incubators, poultry, manufacturing",
  },
  {
    code: "333111",
    title: "Irrigation equipment, agriculture, manufacturing",
  },
  {
    code: "333111",
    title: "Lawnmowers, agricultural-type, powered, manufacturing",
  },
  {
    code: "333111",
    title: "Milking machines manufacturing",
  },
  {
    code: "333111",
    title: "Nut shellers, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Peanut combines (i.e., diggers, packers, threshers) manufacturing",
  },
  {
    code: "333111",
    title: "Planting machines, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Plows, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Potato diggers, harvesters, and planters manufacturing",
  },
  {
    code: "333111",
    title: "Poultry brooders, feeders, and waterers manufacturing",
  },
  {
    code: "333111",
    title: "Presses, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Rakes, hay, manufacturing",
  },
  {
    code: "333111",
    title: "Rotary hoes manufacturing",
  },
  {
    code: "333111",
    title: "Rotary tillers, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Seeders, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Shears, powered, for use on animals, manufacturing",
  },
  {
    code: "333111",
    title: "Sheep shears, powered, manufacturing",
  },
  {
    code: "333111",
    title: "Shredders, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Sod harvesting machines manufacturing",
  },
  {
    code: "333111",
    title: "Sprayers and dusters, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Spreaders, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Stalk choppers (i.e., shredders) manufacturing",
  },
  {
    code: "333111",
    title: "Tobacco harvester machines manufacturing",
  },
  {
    code: "333111",
    title: "Tomato harvesting machines manufacturing",
  },
  {
    code: "333111",
    title: "Tractors and attachments, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Transplanters, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Tree shakers (e.g., citrus, nut, soft fruit) manufacturing",
  },
  {
    code: "333111",
    title: "Wagons, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Weeding machines, farm-type, manufacturing",
  },
  {
    code: "333111",
    title: "Windmills, farm-type, manufacturing",
  },
  {
    code: "333112",
    title: "Attachments, powered lawn and garden equipment, manufacturing",
  },
  {
    code: "333112",
    title: "Blowers, leaf, manufacturing",
  },
  {
    code: "333112",
    title: "Carts, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Chippers (i.e., shredders), lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Cultivators, powered, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Garden machinery and equipment, powered, manufacturing",
  },
  {
    code: "333112",
    title: "Grass mowing equipment, powered lawn and garden, manufacturing",
  },
  {
    code: "333112",
    title: "Hedge trimmers, powered, manufacturing",
  },
  {
    code: "333112",
    title: "Lawn and garden equipment manufacturing",
  },
  {
    code: "333112",
    title: "Lawn edgers, powered, manufacturing",
  },
  {
    code: "333112",
    title: "Lawnmowers (except agricultural-type), powered, manufacturing",
  },
  {
    code: "333112",
    title: "Leaf blowers manufacturing",
  },
  {
    code: "333112",
    title: "Mulchers, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Seeders, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Snow plow attachments, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Snowblowers and throwers, residential-type, manufacturing",
  },
  {
    code: "333112",
    title: "Spreaders, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Tillers, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Tractors and attachments, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Trimmers, hedge, electric, manufacturing",
  },
  {
    code: "333112",
    title: "Trimmers, string, lawn and garden-type, manufacturing",
  },
  {
    code: "333112",
    title: "Vacuums, yard, manufacturing",
  },
  {
    code: "333112",
    title: "Wagons, lawn and garden-type, manufacturing",
  },
  {
    code: "333120",
    title: "Aggregate spreaders manufacturing",
  },
  {
    code: "333120",
    title: "Asphalt roofing construction machinery manufacturing",
  },
  {
    code: "333120",
    title: "Augers (except mining-type) manufacturing",
  },
  {
    code: "333120",
    title: "Backhoes manufacturing",
  },
  {
    code: "333120",
    title:
      "Bits, rock drill, construction and surface mining-type, manufacturing",
  },
  {
    code: "333120",
    title:
      "Blades for graders, scrapers, bulldozers, and snowplows manufacturing",
  },
  {
    code: "333120",
    title: "Bucket and scarifier teeth manufacturing",
  },
  {
    code: "333120",
    title:
      "Buckets, excavating (e.g., clamshell, concrete, drag scraper, dragline, shovel), manufacturing",
  },
  {
    code: "333120",
    title: "Bulldozers manufacturing",
  },
  {
    code: "333120",
    title: "Cabs for construction machinery manufacturing",
  },
  {
    code: "333120",
    title:
      "Chippers, portable, commercial (e.g., brush, limb, log), manufacturing",
  },
  {
    code: "333120",
    title: "Concrete finishing machinery manufacturing",
  },
  {
    code: "333120",
    title: "Concrete gunning equipment manufacturing",
  },
  {
    code: "333120",
    title: "Concrete mixing machinery, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Construction machinery manufacturing",
  },
  {
    code: "333120",
    title: "Construction-type tractors and attachments manufacturing",
  },
  {
    code: "333120",
    title: "Cranes, construction-type, manufacturing",
  },
  {
    code: "333120",
    title: "Crushing machinery, portable, manufacturing",
  },
  {
    code: "333120",
    title:
      "Crushing, pulverizing, and screening machinery, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Ditchers and trenchers, self-propelled, manufacturing",
  },
  {
    code: "333120",
    title: "Draglines, crawler, manufacturing",
  },
  {
    code: "333120",
    title:
      "Drags, road construction and road maintenance equipment, manufacturing",
  },
  {
    code: "333120",
    title: "Dredging machinery manufacturing",
  },
  {
    code: "333120",
    title: "Excavators (e.g., power shovels) manufacturing",
  },
  {
    code: "333120",
    title: "Extractors, piling, manufacturing",
  },
  {
    code: "333120",
    title: "Grader attachments manufacturing",
  },
  {
    code: "333120",
    title: "Graders, road, manufacturing",
  },
  {
    code: "333120",
    title:
      "Hammer mill machinery (i.e., rock and ore crushing machines), portable, manufacturing",
  },
  {
    code: "333120",
    title: "Highway line marking machinery manufacturing",
  },
  {
    code: "333120",
    title: "Jack hammers manufacturing",
  },
  {
    code: "333120",
    title: "Land preparation machinery, construction, manufacturing",
  },
  {
    code: "333120",
    title: "Loaders, shovel, manufacturing",
  },
  {
    code: "333120",
    title: "Log debarking machinery, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Log splitters, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Mixers, concrete, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Mortar mixers, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Off-highway trucks manufacturing",
  },
  {
    code: "333120",
    title: "Paving machinery manufacturing",
  },
  {
    code: "333120",
    title: "Pile-driving equipment manufacturing",
  },
  {
    code: "333120",
    title: "Planers, bituminous, manufacturing",
  },
  {
    code: "333120",
    title: "Plows, construction (e.g., excavating, grading), manufacturing",
  },
  {
    code: "333120",
    title: "Post hole diggers, powered, manufacturing",
  },
  {
    code: "333120",
    title: "Rock crushing machinery, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Rock drills, construction and surface mining-type, manufacturing",
  },
  {
    code: "333120",
    title:
      "Rollers, road construction and maintenance machinery, manufacturing",
  },
  {
    code: "333120",
    title: "Sand mixers manufacturing",
  },
  {
    code: "333120",
    title: "Scarifiers, road, manufacturing",
  },
  {
    code: "333120",
    title: "Scrapers, construction-type, manufacturing",
  },
  {
    code: "333120",
    title: "Screening machinery, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Shovel loaders manufacturing",
  },
  {
    code: "333120",
    title: "Shovels, power, manufacturing",
  },
  {
    code: "333120",
    title: "Slag mixers, portable, manufacturing",
  },
  {
    code: "333120",
    title: "Snow plow attachments (except lawn, garden-type) manufacturing",
  },
  {
    code: "333120",
    title: "Surface mining machinery (except drilling) manufacturing",
  },
  {
    code: "333120",
    title: "Tampers, powered, manufacturing",
  },
  {
    code: "333120",
    title: "Tractors and attachments, construction-type, manufacturing",
  },
  {
    code: "333120",
    title: "Tractors, crawler, manufacturing",
  },
  {
    code: "333120",
    title: "Trenching machines manufacturing",
  },
  {
    code: "333120",
    title: "Trucks, off-highway, manufacturing",
  },
  {
    code: "333120",
    title: "Vibrators, concrete, manufacturing",
  },
  {
    code: "333131",
    title:
      "Amalgamators (i.e., metallurgical and mining machinery) manufacturing",
  },
  {
    code: "333131",
    title: "Augers, mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Bits, rock drill, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Breakers, coal, manufacturing",
  },
  {
    code: "333131",
    title: "Cars, mining, manufacturing",
  },
  {
    code: "333131",
    title: "Cleaning machinery, mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Coal breakers, cutters, and pulverizers manufacturing",
  },
  {
    code: "333131",
    title: "Concentration machinery, mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Core drills, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Crushing machinery, stationary, manufacturing",
  },
  {
    code: "333131",
    title: "Cutters, coal, manufacturing",
  },
  {
    code: "333131",
    title: "Drilling equipment, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Drills, core, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Drills, rock, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Dumpers, mining car, manufacturing",
  },
  {
    code: "333131",
    title: "Feeders, mineral beneficiating-type, manufacturing",
  },
  {
    code: "333131",
    title: "Flotation machinery, mining-type, manufacturing",
  },
  {
    code: "333131",
    title:
      "Hammer mill machinery (i.e., rock and ore crushing machines), stationary, manufacturing",
  },
  {
    code: "333131",
    title: "Loading machines, underground mining, manufacturing",
  },
  {
    code: "333131",
    title: "Mineral processing and beneficiating machinery manufacturing",
  },
  {
    code: "333131",
    title: "Mining cars manufacturing",
  },
  {
    code: "333131",
    title:
      "Ore crushing, washing, screening, and loading machinery manufacturing",
  },
  {
    code: "333131",
    title: "Pellet mills machinery, mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Quarrying machinery and equipment manufacturing",
  },
  {
    code: "333131",
    title: "Rock crushing machinery, stationary, manufacturing",
  },
  {
    code: "333131",
    title: "Rock drills, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Scraper loaders, underground mining-type, manufacturing",
  },
  {
    code: "333131",
    title: "Screening machinery, stationary, manufacturing",
  },
  {
    code: "333131",
    title: "Sedimentary mineral machinery manufacturing",
  },
  {
    code: "333131",
    title:
      "Sieves and screening equipment, mineral beneficiating, manufacturing",
  },
  {
    code: "333131",
    title: "Stone beneficiating machinery manufacturing",
  },
  {
    code: "333131",
    title: "Underground mining machinery manufacturing",
  },
  {
    code: "333131",
    title: "Washers, aggregate and sand, stationary, manufacturing",
  },
  {
    code: "333132",
    title: "Bits, rock drill, oil and gas field-type, manufacturing",
  },
  {
    code: "333132",
    title: "Christmas tree assemblies, oil and gas field-type, manufacturing",
  },
  {
    code: "333132",
    title: "Derricks, oil and gas field-type, manufacturing",
  },
  {
    code: "333132",
    title: "Drilling equipment, oil and gas field-type, manufacturing",
  },
  {
    code: "333132",
    title: "Drilling rigs, oil and gas field-type, manufacturing",
  },
  {
    code: "333132",
    title: "Gas well machinery and equipment manufacturing",
  },
  {
    code: "333132",
    title:
      "Oil and gas field-type drilling machinery and equipment (except offshore floating platforms) manufacturing",
  },
  {
    code: "333132",
    title: "Rock drill bits, oil and gas field-type, manufacturing",
  },
  {
    code: "333132",
    title: "Water well drilling machinery manufacturing",
  },
  {
    code: "333132",
    title: "Well logging equipment manufacturing",
  },
  {
    code: "333241",
    title: "Bakery machinery and equipment manufacturing",
  },
  {
    code: "333241",
    title: "Bakery ovens manufacturing",
  },
  {
    code: "333241",
    title: "Bread slicing machinery manufacturing",
  },
  {
    code: "333241",
    title: "Brewery machinery manufacturing",
  },
  {
    code: "333241",
    title: "Butter processing machinery manufacturing",
  },
  {
    code: "333241",
    title: "Cheese processing machinery manufacturing",
  },
  {
    code: "333241",
    title: "Chewing gum machinery manufacturing",
  },
  {
    code: "333241",
    title: "Chocolate processing machinery manufacturing",
  },
  {
    code: "333241",
    title: "Cider presses manufacturing",
  },
  {
    code: "333241",
    title:
      "Coffee roasting and grinding machinery (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Condensed and evaporated milk machinery manufacturing",
  },
  {
    code: "333241",
    title: "Confectionery machinery manufacturing",
  },
  {
    code: "333241",
    title:
      "Corn popping machinery (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Cracker making machinery manufacturing",
  },
  {
    code: "333241",
    title: "Cream separators, industrial, manufacturing",
  },
  {
    code: "333241",
    title: "Dairy product plant machinery and equipment",
  },
  {
    code: "333241",
    title: "Distilling equipment, beverage, manufacturing",
  },
  {
    code: "333241",
    title:
      "Dough mixing machinery (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Dry milk processing machinery manufacturing",
  },
  {
    code: "333241",
    title: "Flour milling machinery manufacturing",
  },
  {
    code: "333241",
    title:
      "Food choppers, grinders, mixers, and slicers (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Food dehydrating equipment (except household-type) manufacturing",
  },
  {
    code: "333241",
    title: "Food product machinery manufacturing",
  },
  {
    code: "333241",
    title:
      "Grading, cleaning, and sorting machinery (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Grain milling machinery manufacturing",
  },
  {
    code: "333241",
    title: "Homogenizing machinery, food, manufacturing",
  },
  {
    code: "333241",
    title: "Ice cream making machinery manufacturing",
  },
  {
    code: "333241",
    title: "Juice extractors (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Malt milling machinery manufacturing",
  },
  {
    code: "333241",
    title: "Meat and poultry processing and preparation machinery",
  },
  {
    code: "333241",
    title: "Meat grinders, food-type, manufacturing",
  },
  {
    code: "333241",
    title: "Milk processing (except farm-type) machinery manufacturing",
  },
  {
    code: "333241",
    title: "Oilseed crushing and extracting machinery manufacturing",
  },
  {
    code: "333241",
    title: "Ovens, bakery, manufacturing",
  },
  {
    code: "333241",
    title:
      "Pasta making machinery (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Pasteurizing equipment, food, manufacturing",
  },
  {
    code: "333241",
    title:
      "Peanut roasting machines (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Presses (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Roasting machinery manufacturing",
  },
  {
    code: "333241",
    title:
      "Sieves and screening equipment (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Sifting machine (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Slicing machinery (i.e., food manufacturing-type) manufacturing",
  },
  {
    code: "333241",
    title: "Stuffer, sausage machinery, manufacturing",
  },
  {
    code: "333241",
    title: "Sugar refining machinery manufacturing",
  },
  {
    code: "333241",
    title: "Vegetable oil processing machinery manufacturing",
  },
  {
    code: "333242",
    title: "Etching equipment, semiconductor, manufacturing",
  },
  {
    code: "333242",
    title: "Micro-lithography equipment, semiconductor, manufacturing",
  },
  {
    code: "333242",
    title: "Nanoindentation equipment, semiconductor, manufacturing",
  },
  {
    code: "333242",
    title: "Semiconductor assembly and packaging machinery manufacturing",
  },
  {
    code: "333242",
    title: "Semiconductor making machinery manufacturing",
  },
  {
    code: "333242",
    title:
      "Surface mount machinery for making printed circuit boards manufacturing",
  },
  {
    code: "333242",
    title: "Thin layer deposition equipment, semiconductor, manufacturing",
  },
  {
    code: "333242",
    title: "Vapor deposition equipment, semiconductor, manufacturing",
  },
  {
    code: "333242",
    title: "Wafer processing equipment, semiconductor, manufacturing",
  },
  {
    code: "333243",
    title: "Bandsaws, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Chippers, stationary (e.g., log), manufacturing",
  },
  {
    code: "333243",
    title: "Circular saws, woodworking-type, stationary, manufacturing",
  },
  {
    code: "333243",
    title: "Dovetailing machines, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Drill presses, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Envelope making machinery manufacturing",
  },
  {
    code: "333243",
    title: "Fourdrinier machinery manufacturing",
  },
  {
    code: "333243",
    title: "Jigsaws, woodworking-type, stationary, manufacturing",
  },
  {
    code: "333243",
    title: "Jointers, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Lathes, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Log debarking machinery, stationary, manufacturing",
  },
  {
    code: "333243",
    title: "Log splitters, stationary, manufacturing",
  },
  {
    code: "333243",
    title: "Mortisers, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Paper and paperboard coating and finishing machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paper and paperboard converting machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paper and paperboard corrugating machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paper and paperboard cutting and folding machinery manufacturing",
  },
  {
    code: "333243",
    title:
      "Paper and paperboard die-cutting and stamping machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paper bag making machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paper making machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paperboard box making machinery manufacturing",
  },
  {
    code: "333243",
    title: "Paperboard making machinery manufacturing",
  },
  {
    code: "333243",
    title: "Planers woodworking-type, stationary, manufacturing",
  },
  {
    code: "333243",
    title:
      "Presses for making composite woods (e.g., hardboard, medium density fiberboard (MDF), particleboard, plywood) manufacturing",
  },
  {
    code: "333243",
    title: "Pulp making machinery manufacturing",
  },
  {
    code: "333243",
    title: "Pulp, paper, and paperboard molding machinery manufacturing",
  },
  {
    code: "333243",
    title: "Sanding machines, woodworking-type, stationary, manufacturing",
  },
  {
    code: "333243",
    title: "Sandpaper making machines manufacturing",
  },
  {
    code: "333243",
    title: "Sawmill equipment manufacturing",
  },
  {
    code: "333243",
    title:
      "Saws, bench and table, power-driven, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Scarfing machines, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Shapers, woodworking-type, manufacturing",
  },
  {
    code: "333243",
    title: "Veneer and plywood forming machinery manufacturing",
  },
  {
    code: "333243",
    title: "Wood veneer laminating and gluing machines manufacturing",
  },
  {
    code: "333243",
    title: "Woodworking machines (except handheld) manufacturing",
  },
  {
    code: "333248",
    title: "Additive manufacturing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Anodizing equipment manufacturing",
  },
  {
    code: "333248",
    title: "Beaming machinery for yarn manufacturing",
  },
  {
    code: "333248",
    title: "Bindery machinery manufacturing",
  },
  {
    code: "333248",
    title: "Bleaching machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Blow molding machinery for plastics manufacturing",
  },
  {
    code: "333248",
    title: "Bobbins, textile machinery, manufacturing",
  },
  {
    code: "333248",
    title: "Bookbinding machines manufacturing",
  },
  {
    code: "333248",
    title: "Boot making and repairing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Braiding machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Buttonhole and eyelet machinery manufacturing",
  },
  {
    code: "333248",
    title: "Calendering machinery for plastics manufacturing",
  },
  {
    code: "333248",
    title: "Calendering machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Camelback (i.e., retreading materials) machinery manufacturing",
  },
  {
    code: "333248",
    title: "Carbonizing equipment for processing wool manufacturing",
  },
  {
    code: "333248",
    title: "Carding machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Cement kilns manufacturing",
  },
  {
    code: "333248",
    title: "Chemical kilns manufacturing",
  },
  {
    code: "333248",
    title: "Chemical processing machinery and equipment manufacturing",
  },
  {
    code: "333248",
    title: "Chip placement machinery manufacturing",
  },
  {
    code: "333248",
    title: "Cigarette making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Circuit board making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Circular knitting machinery manufacturing",
  },
  {
    code: "333248",
    title: "Clayworking and tempering machinery manufacturing",
  },
  {
    code: "333248",
    title: "Cloth spreading machinery manufacturing",
  },
  {
    code: "333248",
    title: "Collating machinery for printing and bookbinding manufacturing",
  },
  {
    code: "333248",
    title: "Combing machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Compression molding machinery for plastics manufacturing",
  },
  {
    code: "333248",
    title: "Concrete products forming machinery manufacturing",
  },
  {
    code: "333248",
    title: "Cordage and rope (except wire) making machines manufacturing",
  },
  {
    code: "333248",
    title: "Digital printing presses manufacturing",
  },
  {
    code: "333248",
    title:
      "Distilling equipment (except beverage), including laboratory-type, manufacturing",
  },
  {
    code: "333248",
    title: "Drawing machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Drying kilns, lumber, manufacturing",
  },
  {
    code: "333248",
    title: "Drying machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Dyeing machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Electron tube machinery manufacturing",
  },
  {
    code: "333248",
    title: "Electroplating machinery and equipment manufacturing",
  },
  {
    code: "333248",
    title: "Electrotyping machinery manufacturing",
  },
  {
    code: "333248",
    title: "Embroidery machinery manufacturing",
  },
  {
    code: "333248",
    title: "Extruding machinery for plastics and rubber manufacturing",
  },
  {
    code: "333248",
    title: "Extruding machinery for yarn manufacturing",
  },
  {
    code: "333248",
    title: "Fermentation equipment, chemical, manufacturing",
  },
  {
    code: "333248",
    title: "Finishing machinery for textile manufacturing",
  },
  {
    code: "333248",
    title: "Flexographic printing presses manufacturing",
  },
  {
    code: "333248",
    title: "Footwear making or repairing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Fractionating equipment, chemical, manufacturing",
  },
  {
    code: "333248",
    title: "Frames for textile making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Garnetting machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Gas liquefying machinery manufacturing",
  },
  {
    code: "333248",
    title: "Gem stone processing machinery manufacturing",
  },
  {
    code: "333248",
    title:
      "Glass making machinery (e.g., blowing, forming, molding) manufacturing",
  },
  {
    code: "333248",
    title: "Granulator and pelletizer machinery for plastics manufacturing",
  },
  {
    code: "333248",
    title: "Gravure printing presses manufacturing",
  },
  {
    code: "333248",
    title: "Hosiery machines manufacturing",
  },
  {
    code: "333248",
    title: "Injection molding machinery for plastics manufacturing",
  },
  {
    code: "333248",
    title: "Jacquard card cutting machinery manufacturing",
  },
  {
    code: "333248",
    title: "Kilns (i.e., cement, chemical, wood) manufacturing",
  },
  {
    code: "333248",
    title: "Knitting machinery manufacturing",
  },
  {
    code: "333248",
    title: "Knot tying machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Lace and net making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Leather working machinery manufacturing",
  },
  {
    code: "333248",
    title: "Letterpress printing presses manufacturing",
  },
  {
    code: "333248",
    title: "Light bulb and tube (i.e., electric lamp) machinery manufacturing",
  },
  {
    code: "333248",
    title: "Linotype machines manufacturing",
  },
  {
    code: "333248",
    title: "Lithographic printing presses manufacturing",
  },
  {
    code: "333248",
    title: "Loom bobbins manufacturing",
  },
  {
    code: "333248",
    title: "Loom reeds manufacturing",
  },
  {
    code: "333248",
    title: "Looms for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Loopers for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Mercerizing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Metal casting machinery and equipment manufacturing",
  },
  {
    code: "333248",
    title: "Napping machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Needles for knitting machinery manufacturing",
  },
  {
    code: "333248",
    title: "Net and lace making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Newspaper inserting equipment manufacturing",
  },
  {
    code: "333248",
    title: "Offset printing presses manufacturing",
  },
  {
    code: "333248",
    title: "Optical lens making and grinding machinery manufacturing",
  },
  {
    code: "333248",
    title: "Petroleum refining machinery manufacturing",
  },
  {
    code: "333248",
    title: "Photoengraving machinery manufacturing",
  },
  {
    code: "333248",
    title: "Picker machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Picker sticks for looms manufacturing",
  },
  {
    code: "333248",
    title: "Plastics working machinery manufacturing",
  },
  {
    code: "333248",
    title: "Presses, printing, manufacturing",
  },
  {
    code: "333248",
    title: "Printer machinery, 3D, manufacturing",
  },
  {
    code: "333248",
    title: "Printing machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Printing plate engraving machinery manufacturing",
  },
  {
    code: "333248",
    title: "Printing plates, blank (except photosensitive), manufacturing",
  },
  {
    code: "333248",
    title: "Printing press rollers manufacturing",
  },
  {
    code: "333248",
    title: "Printing presses manufacturing",
  },
  {
    code: "333248",
    title: "Rectifying equipment, chemical, manufacturing",
  },
  {
    code: "333248",
    title: "Recycling sorting machinery manufacturing",
  },
  {
    code: "333248",
    title: "Roving machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Rubber working machinery manufacturing",
  },
  {
    code: "333248",
    title: "Schiffli machinery manufacturing",
  },
  {
    code: "333248",
    title: "Sewing machines (including household-type) manufacturing",
  },
  {
    code: "333248",
    title: "Shoe making and repairing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Shuttles for textile weaving machinery manufacturing",
  },
  {
    code: "333248",
    title:
      "Sieves and screening equipment, chemical preparation-type, manufacturing",
  },
  {
    code: "333248",
    title: "Silk screens for textile fabrics manufacturing",
  },
  {
    code: "333248",
    title: "Spindles for textile machinery manufacturing",
  },
  {
    code: "333248",
    title: "Spinning machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Spools for textile machinery manufacturing",
  },
  {
    code: "333248",
    title: "Stitchers and trimmers bookbinding equipment manufacturing",
  },
  {
    code: "333248",
    title: "Stone working machinery manufacturing",
  },
  {
    code: "333248",
    title: "Tannery machinery manufacturing",
  },
  {
    code: "333248",
    title:
      "Textile finishing machinery (e.g., bleaching, dyeing, mercerizing, printing) manufacturing",
  },
  {
    code: "333248",
    title: "Textile making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Textile printing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Texturizing machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Thermoforming machinery for plastics manufacturing",
  },
  {
    code: "333248",
    title: "Thread making machinery manufacturing",
  },
  {
    code: "333248",
    title:
      "Through-hole machinery, printed circuit board loading, manufacturing",
  },
  {
    code: "333248",
    title: "Tile making machinery (except kilns) manufacturing",
  },
  {
    code: "333248",
    title: "Tire making machinery manufacturing",
  },
  {
    code: "333248",
    title: "Tire recapping machinery manufacturing",
  },
  {
    code: "333248",
    title: "Tire shredding machinery manufacturing",
  },
  {
    code: "333248",
    title: "Tobacco processing machinery (except farm-type) manufacturing",
  },
  {
    code: "333248",
    title: "Tufting machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Typesetting machinery manufacturing",
  },
  {
    code: "333248",
    title: "Vulcanizing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Warping machinery manufacturing",
  },
  {
    code: "333248",
    title: "Weaving machinery manufacturing",
  },
  {
    code: "333248",
    title: "Winding machinery for textiles manufacturing",
  },
  {
    code: "333248",
    title: "Wire and cable insulating machinery manufacturing",
  },
  {
    code: "333248",
    title: "Wood drying kilns manufacturing",
  },
  {
    code: "333248",
    title: "Wool and worsted finishing machinery manufacturing",
  },
  {
    code: "333248",
    title: "Yarn texturizing machines manufacturing",
  },
  {
    code: "333248",
    title: "Zipper making machinery manufacturing",
  },
  {
    code: "333310",
    title: "Adding machines manufacturing",
  },
  {
    code: "333310",
    title: "Aerial cameras manufacturing",
  },
  {
    code: "333310",
    title: "Alignment equipment, motor vehicle, manufacturing",
  },
  {
    code: "333310",
    title: "Balancing equipment, motor vehicle, manufacturing",
  },
  {
    code: "333310",
    title: "Beauty and barber shop equipment (except chairs) manufacturing",
  },
  {
    code: "333310",
    title:
      "Binding equipment (i.e., plastics or tape binding), office-type, manufacturing",
  },
  {
    code: "333310",
    title: "Binoculars manufacturing",
  },
  {
    code: "333310",
    title: "Blueprint equipment manufacturing",
  },
  {
    code: "333310",
    title:
      "Brake service equipment (except mechanic's handtools), motor vehicle, manufacturing",
  },
  {
    code: "333310",
    title:
      "Bundling machinery (e.g., box strapping, mail, newspaper) manufacturing",
  },
  {
    code: "333310",
    title: "Calculators manufacturing",
  },
  {
    code: "333310",
    title: "Camera lenses manufacturing",
  },
  {
    code: "333310",
    title: "Cameras (except television, video) manufacturing",
  },
  {
    code: "333310",
    title: "Canceling machinery, postal office-type, manufacturing",
  },
  {
    code: "333310",
    title: "Car washing machinery manufacturing",
  },
  {
    code: "333310",
    title: "Carnival and amusement park rides manufacturing",
  },
  {
    code: "333310",
    title:
      "Carnival and amusement park shooting gallery machinery manufacturing",
  },
  {
    code: "333310",
    title: "Carousels (i.e., merry-go-rounds) manufacturing",
  },
  {
    code: "333310",
    title:
      "Carpet and floor cleaning equipment, electric commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Carpet sweepers, mechanical, manufacturing",
  },
  {
    code: "333310",
    title: "Cash registers (except point of sales terminals) manufacturing",
  },
  {
    code: "333310",
    title: "Central vacuuming systems, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Change making machines manufacturing",
  },
  {
    code: "333310",
    title: "Check writing machines manufacturing",
  },
  {
    code: "333310",
    title: "Cigarette vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Coffee makers and urns, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Coin counting machinery manufacturing",
  },
  {
    code: "333310",
    title: "Coin- or card-operated vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Coin wrapping machines manufacturing",
  },
  {
    code: "333310",
    title: "Collating machinery, office-type, manufacturing",
  },
  {
    code: "333310",
    title: "Comparators, optical, manufacturing",
  },
  {
    code: "333310",
    title:
      "Cooking equipment (i.e., fryers, microwave ovens, ovens, ranges), commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Corn popping machines, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Currency counting machinery manufacturing",
  },
  {
    code: "333310",
    title: "Deep-fat fryers, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Densitometers (except laboratory analytical) manufacturing",
  },
  {
    code: "333310",
    title: "Developing equipment, film, manufacturing",
  },
  {
    code: "333310",
    title: "Dictating machines manufacturing",
  },
  {
    code: "333310",
    title: "Digital cameras manufacturing",
  },
  {
    code: "333310",
    title: "Dishwashing machines, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Driers, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Drycleaning equipment and machinery manufacturing",
  },
  {
    code: "333310",
    title: "Dryers, laundry (except household-type), manufacturing",
  },
  {
    code: "333310",
    title:
      "Editing equipment, motion picture (e.g., rewinders, splicers, titlers, viewers), manufacturing",
  },
  {
    code: "333310",
    title: "Enlargers, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Envelope stuffing, sealing, and addressing machinery manufacturing",
  },
  {
    code: "333310",
    title: "Exposure meters, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Ferris wheels manufacturing",
  },
  {
    code: "333310",
    title: "Film developing equipment manufacturing",
  },
  {
    code: "333310",
    title: "Flash apparatus, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Flight simulation machinery manufacturing",
  },
  {
    code: "333310",
    title:
      "Floor sanding, washing, and polishing machines, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Food warming equipment, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Frame and body alignment equipment, motor vehicle, manufacturing",
  },
  {
    code: "333310",
    title: "Garbage disposal units, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Gas ranges, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Gauges, machinist's precision tool, optical, manufacturing",
  },
  {
    code: "333310",
    title: "Glasses, field or opera, manufacturing",
  },
  {
    code: "333310",
    title: "Gratings, diffraction, manufacturing",
  },
  {
    code: "333310",
    title:
      "Gun sighting and fire control equipment and instruments, optical, manufacturing",
  },
  {
    code: "333310",
    title: "Gun sights, optical, manufacturing",
  },
  {
    code: "333310",
    title: "Hair dryers, beauty parlor-type, manufacturing",
  },
  {
    code: "333310",
    title: "Holepunchers (except hand operated), office-type, manufacturing",
  },
  {
    code: "333310",
    title: "Hot beverage vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Hotplates, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Ice cream vending machines manufacturing",
  },
  {
    code: "333310",
    title:
      "Incoming mail handling equipment (e.g., opening, scanning, sorting) manufacturing",
  },
  {
    code: "333310",
    title: "Instrument lenses manufacturing",
  },
  {
    code: "333310",
    title: "Interferometers manufacturing",
  },
  {
    code: "333310",
    title:
      "Laboratory analytical optical instruments (e.g., microscopes) manufacturing",
  },
  {
    code: "333310",
    title: "Laundry extractors manufacturing",
  },
  {
    code: "333310",
    title:
      "Laundry machinery and equipment (except household-type) manufacturing",
  },
  {
    code: "333310",
    title: "Laundry pressing machines (except household-type) manufacturing",
  },
  {
    code: "333310",
    title: "Lens coating (except ophthalmic)",
  },
  {
    code: "333310",
    title: "Lens grinding (except ophthalmic)",
  },
  {
    code: "333310",
    title: "Lens hoods, camera, manufacturing",
  },
  {
    code: "333310",
    title: "Lens mounting (except ophthalmic)",
  },
  {
    code: "333310",
    title: "Lens polishing (except ophthalmic)",
  },
  {
    code: "333310",
    title: "Lenses (except ophthalmic) manufacturing",
  },
  {
    code: "333310",
    title: "Letter folding, stuffing, and sealing machinery manufacturing",
  },
  {
    code: "333310",
    title: "Light meters, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Locks, coin- or card-operated, manufacturing",
  },
  {
    code: "333310",
    title: "Loupes (e.g., jewelers) manufacturing",
  },
  {
    code: "333310",
    title: "Magnifying glasses (except corrective vision-type) manufacturing",
  },
  {
    code: "333310",
    title: "Magnifying instruments, optical, manufacturing",
  },
  {
    code: "333310",
    title: "Mail handling machinery, post office-type, manufacturing",
  },
  {
    code: "333310",
    title: "Mechanisms for coin- or card-operated machines manufacturing",
  },
  {
    code: "333310",
    title:
      "Microfiche equipment (e.g., cameras, projectors, readers) manufacturing",
  },
  {
    code: "333310",
    title:
      "Microfilm equipment (e.g., cameras, projectors, readers) manufacturing",
  },
  {
    code: "333310",
    title: "Microscopes (except electron, proton) manufacturing",
  },
  {
    code: "333310",
    title: "Microwave ovens, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Mirrors, optical, manufacturing",
  },
  {
    code: "333310",
    title: "Mop wringers manufacturing",
  },
  {
    code: "333310",
    title: "Motion picture cameras manufacturing",
  },
  {
    code: "333310",
    title: "Motion picture theater projectors manufacturing",
  },
  {
    code: "333310",
    title: "Night vision optical devices manufacturing",
  },
  {
    code: "333310",
    title: "Oil water separators manufacturing",
  },
  {
    code: "333310",
    title: "Optical alignment and display instruments manufacturing",
  },
  {
    code: "333310",
    title:
      "Optical gun sighting and fire control equipment and instruments manufacturing",
  },
  {
    code: "333310",
    title: "Optical test and inspection equipment manufacturing",
  },
  {
    code: "333310",
    title: "Ovens, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Overhead projectors (except computer peripheral) manufacturing",
  },
  {
    code: "333310",
    title: "Ozone machines for water purification manufacturing",
  },
  {
    code: "333310",
    title: "Periscopes manufacturing",
  },
  {
    code: "333310",
    title: "Photocopying machines manufacturing",
  },
  {
    code: "333310",
    title: "Photoflash equipment manufacturing",
  },
  {
    code: "333310",
    title: "Photographic equipment manufacturing",
  },
  {
    code: "333310",
    title: "Photographic lenses manufacturing",
  },
  {
    code: "333310",
    title: "Postage meters manufacturing",
  },
  {
    code: "333310",
    title: "Postage stamp vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Power washer cleaning equipment manufacturing",
  },
  {
    code: "333310",
    title: "Prisms, optical, manufacturing",
  },
  {
    code: "333310",
    title:
      "Projection equipment (e.g., motion picture, slide), photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Projection lenses manufacturing",
  },
  {
    code: "333310",
    title:
      "Projection screens (i.e., motion picture, overhead, slide) manufacturing",
  },
  {
    code: "333310",
    title: "Range finders, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Ranges, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Readers, microfilm or microfiche, manufacturing",
  },
  {
    code: "333310",
    title: "Reflectors, optical, manufacturing",
  },
  {
    code: "333310",
    title: "Sanding machines, floor, manufacturing",
  },
  {
    code: "333310",
    title:
      "Screens, projection (i.e., motion picture, overhead, slide), manufacturing",
  },
  {
    code: "333310",
    title: "Sensitometers, photographic, manufacturing",
  },
  {
    code: "333310",
    title: "Sewage treatment equipment manufacturing",
  },
  {
    code: "333310",
    title: "Sights, telescopic, manufacturing",
  },
  {
    code: "333310",
    title: "Snack and confection vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Soft drink vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Steam cookers, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Steam tables manufacturing",
  },
  {
    code: "333310",
    title: "Stenography machinery manufacturing",
  },
  {
    code: "333310",
    title: "Stoves, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Swimming pool filter systems manufacturing",
  },
  {
    code: "333310",
    title: "Tanks, photographic developing, fixing, and washing, manufacturing",
  },
  {
    code: "333310",
    title: "Teaching machines (e.g., flight simulators) manufacturing",
  },
  {
    code: "333310",
    title: "Telescopes manufacturing",
  },
  {
    code: "333310",
    title: "Theodolites manufacturing",
  },
  {
    code: "333310",
    title: "Tire mounting machines, motor vehicle, manufacturing",
  },
  {
    code: "333310",
    title: "Trash and garbage compactors, commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Trays, photographic printing and processing, manufacturing",
  },
  {
    code: "333310",
    title: "Tripods, camera and projector, manufacturing",
  },
  {
    code: "333310",
    title: "Typewriters manufacturing",
  },
  {
    code: "333310",
    title: "Vacuum cleaners, industrial and commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Vending machines manufacturing",
  },
  {
    code: "333310",
    title: "Voting machines manufacturing",
  },
  {
    code: "333310",
    title: "Wash water recycling machinery manufacturing",
  },
  {
    code: "333310",
    title: "Washing machines, laundry (except household-type), manufacturing",
  },
  {
    code: "333310",
    title: "Water heaters (except boilers), commercial-type, manufacturing",
  },
  {
    code: "333310",
    title: "Water purification equipment manufacturing",
  },
  {
    code: "333310",
    title: "Water softening equipment manufacturing",
  },
  {
    code: "333310",
    title: "Water treatment equipment manufacturing",
  },
  {
    code: "333310",
    title: "Word processing equipment, dedicated, manufacturing",
  },
  {
    code: "333413",
    title: "Air purification equipment, stationary, manufacturing",
  },
  {
    code: "333413",
    title: "Air scrubbing systems manufacturing",
  },
  {
    code: "333413",
    title: "Air washers (i.e., air scrubbers) manufacturing",
  },
  {
    code: "333413",
    title: "Aircurtains manufacturing",
  },
  {
    code: "333413",
    title: "Attic fans manufacturing",
  },
  {
    code: "333413",
    title: "Blower filter units manufacturing",
  },
  {
    code: "333413",
    title: "Dust and fume collecting equipment manufacturing",
  },
  {
    code: "333413",
    title: "Electrostatic precipitation equipment manufacturing",
  },
  {
    code: "333413",
    title: "Exhaust fans, industrial and commercial-type, manufacturing",
  },
  {
    code: "333413",
    title: "Fans, industrial and commercial-type, manufacturing",
  },
  {
    code: "333413",
    title: "Filters, air-conditioner, manufacturing",
  },
  {
    code: "333413",
    title: "Filters, furnace, manufacturing",
  },
  {
    code: "333413",
    title: "Furnace filters manufacturing",
  },
  {
    code: "333413",
    title: "Ventilating fans, industrial and commercial-type, manufacturing",
  },
  {
    code: "333414",
    title: "Baseboard heating equipment manufacturing",
  },
  {
    code: "333414",
    title: "Boilers, heating, manufacturing",
  },
  {
    code: "333414",
    title: "Burners, heating, manufacturing",
  },
  {
    code: "333414",
    title: "Fireplace inserts (i.e., heat directing) manufacturing",
  },
  {
    code: "333414",
    title: "Furnaces (except forced air), heating, manufacturing",
  },
  {
    code: "333414",
    title: "Furnaces, floor and wall, manufacturing",
  },
  {
    code: "333414",
    title: "Gas burners, heating, manufacturing",
  },
  {
    code: "333414",
    title: "Gas fireplaces manufacturing",
  },
  {
    code: "333414",
    title: "Gas space heaters manufacturing",
  },
  {
    code: "333414",
    title: "Gas-oil burners, combination, manufacturing",
  },
  {
    code: "333414",
    title: "Heaters, space (except portable electric), manufacturing",
  },
  {
    code: "333414",
    title: "Heaters, swimming pool, manufacturing",
  },
  {
    code: "333414",
    title:
      "Heating equipment, hot water (except hot water heaters), manufacturing",
  },
  {
    code: "333414",
    title: "Heating units, baseboard, manufacturing",
  },
  {
    code: "333414",
    title: "Hydronic heating equipment manufacturing",
  },
  {
    code: "333414",
    title: "Kerosene space heaters manufacturing",
  },
  {
    code: "333414",
    title: "Logs, gas fireplace, manufacturing",
  },
  {
    code: "333414",
    title: "Oil burners, heating, manufacturing",
  },
  {
    code: "333414",
    title: "Radiators (except motor vehicle, portable electric) manufacturing",
  },
  {
    code: "333414",
    title: "Room heaters (except portable electric) manufacturing",
  },
  {
    code: "333414",
    title: "Solar energy heating equipment manufacturing",
  },
  {
    code: "333414",
    title: "Solar heating systems manufacturing",
  },
  {
    code: "333414",
    title: "Space heaters (except portable electric) manufacturing",
  },
  {
    code: "333414",
    title: "Steam heating equipment manufacturing",
  },
  {
    code: "333414",
    title: "Swimming pool heaters manufacturing",
  },
  {
    code: "333414",
    title: "Unit heaters (except portable electric) manufacturing",
  },
  {
    code: "333414",
    title: "Wood stoves manufacturing",
  },
  {
    code: "333415",
    title:
      "Air-conditioners, unit (e.g., motor home, travel trailer, window), manufacturing",
  },
  {
    code: "333415",
    title:
      "Air-conditioning and warm air heating combination units manufacturing",
  },
  {
    code: "333415",
    title: "Air-conditioning compressors (except motor vehicle) manufacturing",
  },
  {
    code: "333415",
    title: "Air-conditioning condensers and condensing units manufacturing",
  },
  {
    code: "333415",
    title: "Air-conditioning equipment (except motor vehicle) manufacturing",
  },
  {
    code: "333415",
    title: "Beer cooling and dispensing equipment manufacturing",
  },
  {
    code: "333415",
    title: "Coolers, refrigeration, manufacturing",
  },
  {
    code: "333415",
    title: "Coolers, water, manufacturing",
  },
  {
    code: "333415",
    title: "Cooling towers manufacturing",
  },
  {
    code: "333415",
    title: "Counters and display cases, refrigerated, manufacturing",
  },
  {
    code: "333415",
    title: "Dehumidifiers (except portable electric) manufacturing",
  },
  {
    code: "333415",
    title: "Display cases, refrigerated, manufacturing",
  },
  {
    code: "333415",
    title: "Drinking fountains, refrigerated, manufacturing",
  },
  {
    code: "333415",
    title: "Electric warm air (i.e., forced air) furnaces manufacturing",
  },
  {
    code: "333415",
    title:
      "Evaporative condensers (i.e., heat transfer equipment) manufacturing",
  },
  {
    code: "333415",
    title: "Fountains, refrigerated drinking, manufacturing",
  },
  {
    code: "333415",
    title: "Freezing equipment, industrial and commercial-type, manufacturing",
  },
  {
    code: "333415",
    title: "Furnaces, warm air (i.e., forced air), manufacturing",
  },
  {
    code: "333415",
    title: "Heat pumps manufacturing",
  },
  {
    code: "333415",
    title: "Heating and air-conditioning combination units manufacturing",
  },
  {
    code: "333415",
    title: "Heating equipment, warm air (i.e., forced air), manufacturing",
  },
  {
    code: "333415",
    title: "Humidifying equipment (except portable) manufacturing",
  },
  {
    code: "333415",
    title: "Ice making machinery manufacturing",
  },
  {
    code: "333415",
    title: "Laboratory-type freezers manufacturing",
  },
  {
    code: "333415",
    title: "Lockers, refrigerated, manufacturing",
  },
  {
    code: "333415",
    title: "Refrigerated lockers manufacturing",
  },
  {
    code: "333415",
    title: "Refrigeration compressors manufacturing",
  },
  {
    code: "333415",
    title:
      "Refrigeration equipment, industrial and commercial-type, manufacturing",
  },
  {
    code: "333415",
    title: "Refrigeration units, truck-type, manufacturing",
  },
  {
    code: "333415",
    title: "Room air-conditioners manufacturing",
  },
  {
    code: "333415",
    title: "Showcases, refrigerated, manufacturing",
  },
  {
    code: "333415",
    title: "Snow making machinery manufacturing",
  },
  {
    code: "333415",
    title: "Soda fountain cooling and dispensing equipment manufacturing",
  },
  {
    code: "333415",
    title: "Water (i.e., drinking) coolers, mechanical, manufacturing",
  },
  {
    code: "333511",
    title: "Die-casting dies manufacturing",
  },
  {
    code: "333511",
    title: "Foundry casting molds manufacturing",
  },
  {
    code: "333511",
    title: "Industrial molds (except steel ingot) manufacturing",
  },
  {
    code: "333511",
    title: "Molds (except steel ingot), industrial, manufacturing",
  },
  {
    code: "333511",
    title:
      "Molds for forming materials (e.g., glass, plastics, rubber) manufacturing",
  },
  {
    code: "333511",
    title: "Molds for metal casting (except steel ingot) manufacturing",
  },
  {
    code: "333511",
    title: "Molds for plastics and rubber working machinery manufacturing",
  },
  {
    code: "333514",
    title: "Cutting dies, metalworking, manufacturing",
  },
  {
    code: "333514",
    title: "Diamond dies, metalworking, manufacturing",
  },
  {
    code: "333514",
    title: "Die sets for metal stamping presses manufacturing",
  },
  {
    code: "333514",
    title:
      "Dies and die holders for metal cutting and forming (except threading) manufacturing",
  },
  {
    code: "333514",
    title: "Dies, metalworking (except threading), manufacturing",
  },
  {
    code: "333514",
    title: "Dies, plastics forming, manufacturing",
  },
  {
    code: "333514",
    title: "Dies, steel rule, metal cutting, manufacturing",
  },
  {
    code: "333514",
    title: "Extrusion dies for use with all materials manufacturing",
  },
  {
    code: "333514",
    title: "Jigs (e.g., checking, gauging, inspection) manufacturing",
  },
  {
    code: "333514",
    title: "Jigs and fixtures for use with machine tools manufacturing",
  },
  {
    code: "333514",
    title: "Punches for use with machine tools manufacturing",
  },
  {
    code: "333514",
    title: "Subpresses, machine tool, manufacturing",
  },
  {
    code: "333514",
    title: "Welding positioners (i.e., jigs) manufacturing",
  },
  {
    code: "333514",
    title: "Wire drawing and straightening dies manufacturing",
  },
  {
    code: "333515",
    title: "Angle rings (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Arbors (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title:
      "Bits and knives for metalworking lathes, planers, and shapers manufacturing",
  },
  {
    code: "333515",
    title: "Bits, drill, metalworking, manufacturing",
  },
  {
    code: "333515",
    title: "Blanks, cutting tool, manufacturing",
  },
  {
    code: "333515",
    title: "Broaches (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Cams (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Chasers (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Chucks (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Clamps (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Collars (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Collets (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title:
      "Counterbores (i.e., a machine tool accessory), metalworking, manufacturing",
  },
  {
    code: "333515",
    title: "Countersinks (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Cutters, metal milling, manufacturing",
  },
  {
    code: "333515",
    title: "Dies and taps (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Drill bits, metalworking, manufacturing",
  },
  {
    code: "333515",
    title: "Files (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Hobs (i.e., metal gear cutting tool) manufacturing",
  },
  {
    code: "333515",
    title: "Honing heads (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Hopper feed devices (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title:
      "Indexing, rotary tables (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Inserts, cutting tool, manufacturing",
  },
  {
    code: "333515",
    title:
      "Knives and bits for metalworking lathes, planers, and shapers manufacturing",
  },
  {
    code: "333515",
    title: "Letter pins (e.g., gauging, measuring) manufacturing",
  },
  {
    code: "333515",
    title: "Machine knives, metal cutting, manufacturing",
  },
  {
    code: "333515",
    title: "Machine tool attachments and accessories manufacturing",
  },
  {
    code: "333515",
    title: "Mandrels (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title:
      "Measuring attachments (e.g., sine bars) for machine tool manufacturing",
  },
  {
    code: "333515",
    title: "Pushers (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Reamers (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Sine bars (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Taps and dies (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Thread cutting dies (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Toolholders (i.e., a machine tool accessory) manufacturing",
  },
  {
    code: "333515",
    title: "Tools and accessories for machine tools manufacturing",
  },
  {
    code: "333515",
    title: "Tracer and tapering machine tool attachments manufacturing",
  },
  {
    code: "333517",
    title: "Arbor presses, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Automatic screw machines, metal cutting type, manufacturing",
  },
  {
    code: "333517",
    title: "Beader machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Bending and forming machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Boring machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title:
      "Boring, drilling, and milling machine combinations, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Brakes, press, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Broaching machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Brushing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Buffing and polishing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Burnishing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Can forming machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Centering machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Chamfering machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Chemical milling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Chucking machines, automatic, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Crankshaft grinding machines metal cutting type, manufacturing",
  },
  {
    code: "333517",
    title: "Custom roll forming machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Cut-off machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Cutting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Cylinder boring machines metal cutting type, manufacturing",
  },
  {
    code: "333517",
    title: "Deburring machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Die sinking machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Die-casting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Drill presses, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Drilling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Drop hammers, metal forging and shaping, manufacturing",
  },
  {
    code: "333517",
    title:
      "Duplicating machines (e.g., key cutting), metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Electrochemical milling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Electrode discharge metal cutting machines manufacturing",
  },
  {
    code: "333517",
    title: "Electrolytic metal cutting machines manufacturing",
  },
  {
    code: "333517",
    title: "Electron-discharge metal cutting machines manufacturing",
  },
  {
    code: "333517",
    title: "Extruding machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Facing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Filing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Flange facing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Forging machinery and hammers manufacturing",
  },
  {
    code: "333517",
    title: "Forming machines (except drawing), metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Gear cutting and finishing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Gear rolling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Grinding machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title:
      "Home workshop metal cutting machine tools (except handtools, welding equipment) manufacturing",
  },
  {
    code: "333517",
    title: "Honing and lapping machines, metal cutting type, manufacturing",
  },
  {
    code: "333517",
    title: "Key cutting machines, metal cutting type, manufacturing",
  },
  {
    code: "333517",
    title: "Knurling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title:
      "Laser boring, drilling, and cutting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Lathes, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Machine tools, metal cutting, manufacturing",
  },
  {
    code: "333517",
    title: "Machine tools, metal forming, manufacturing",
  },
  {
    code: "333517",
    title: "Magnetic forming machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Metal cutting machine tools manufacturing",
  },
  {
    code: "333517",
    title: "Metal deposit forming machines manufacturing",
  },
  {
    code: "333517",
    title: "Metal forming machine tools manufacturing",
  },
  {
    code: "333517",
    title: "Metalworking lathes manufacturing",
  },
  {
    code: "333517",
    title: "Milling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Nail heading machines manufacturing",
  },
  {
    code: "333517",
    title: "Numerically controlled metal cutting machine tools manufacturing",
  },
  {
    code: "333517",
    title: "Pipe cutting and threading machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Planers, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Plasma jet spray metal forming machines manufacturing",
  },
  {
    code: "333517",
    title:
      "Plasma process metal cutting machines (except welding equipment) manufacturing",
  },
  {
    code: "333517",
    title: "Polishing and buffing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Powder metal forming presses manufacturing",
  },
  {
    code: "333517",
    title: "Press brakes, metalworking, manufacturing",
  },
  {
    code: "333517",
    title:
      "Presses (e.g., bending, punching, shearing, stamping), metal forming, manufacturing",
  },
  {
    code: "333517",
    title: "Punching machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Reaming machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Rifling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Riveting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Sawing machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Screw and nut slotting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Shaving machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Shearing machines, metal forming, manufacturing",
  },
  {
    code: "333517",
    title: "Sheet metal forming machines manufacturing",
  },
  {
    code: "333517",
    title: "Slotting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Spinning machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Spline rolling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Spring winding and forming machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Stamping machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Stretching machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Swaging machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Tapping machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Thread rolling machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Threading machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Turning machines (i.e., lathes), metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Turret lathes, metalworking, manufacturing",
  },
  {
    code: "333517",
    title:
      "Ultrasonic boring, drilling, and cutting machines, metalworking, manufacturing",
  },
  {
    code: "333517",
    title: "Ultrasonic metal forming machines manufacturing",
  },
  {
    code: "333517",
    title: "Upsetters (i.e., forging machines) manufacturing",
  },
  {
    code: "333517",
    title: "Valve grinding machines, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Assembly machines (i.e., wire making equipment) manufacturing",
  },
  {
    code: "333519",
    title: "Bar mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Billet mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Blooming and slabbing mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Coil winding and cutting machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Cold rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title:
      "Cradle assembly machinery (i.e., wire making equipment) manufacturing",
  },
  {
    code: "333519",
    title: "Draw bench machines manufacturing",
  },
  {
    code: "333519",
    title: "Galvanizing machinery manufacturing",
  },
  {
    code: "333519",
    title: "Hot strip mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Hot-rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Marking machines, metal, manufacturing",
  },
  {
    code: "333519",
    title: "Picklers and pickling machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Pipe and tube rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Plate rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Propeller straightening presses manufacturing",
  },
  {
    code: "333519",
    title: "Rod rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Rolling mill machinery and equipment, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Rolling mill roll machines, metalworking, manufacturing",
  },
  {
    code: "333519",
    title:
      "Scarfing units, rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Screwdowns and boxes machinery, metal, manufacturing",
  },
  {
    code: "333519",
    title: "Screwdriving machines manufacturing",
  },
  {
    code: "333519",
    title: "Structural rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title: "Tube rolling mill machinery, metalworking, manufacturing",
  },
  {
    code: "333519",
    title:
      "Wire drawing and fabricating machinery and equipment (except dies) manufacturing",
  },
  {
    code: "333611",
    title: "Gas turbine generator set units manufacturing",
  },
  {
    code: "333611",
    title: "Gas turbines (except aircraft) manufacturing",
  },
  {
    code: "333611",
    title:
      "Generator sets, turbine (e.g., gas, hydraulic, steam), manufacturing",
  },
  {
    code: "333611",
    title: "Governors, steam, manufacturing",
  },
  {
    code: "333611",
    title: "Hydraulic turbine generator set units manufacturing",
  },
  {
    code: "333611",
    title: "Hydraulic turbines manufacturing",
  },
  {
    code: "333611",
    title: "Motor generator sets, turbo generators, manufacturing",
  },
  {
    code: "333611",
    title: "Steam turbine generator set units manufacturing",
  },
  {
    code: "333611",
    title: "Steam turbines manufacturing",
  },
  {
    code: "333611",
    title: "Turbine generator set units manufacturing",
  },
  {
    code: "333611",
    title: "Turbines (except aircraft) manufacturing",
  },
  {
    code: "333611",
    title: "Water turbines manufacturing",
  },
  {
    code: "333611",
    title: "Wind powered turbine generator sets manufacturing",
  },
  {
    code: "333611",
    title: "Wind turbines (i.e., windmill) manufacturing",
  },
  {
    code: "333611",
    title: "Windmills, electric power, generation-type, manufacturing",
  },
  {
    code: "333612",
    title: "Drives, high-speed industrial (except hydrostatic), manufacturing",
  },
  {
    code: "333612",
    title: "Gearmotors (i.e., power transmission equipment) manufacturing",
  },
  {
    code: "333612",
    title:
      "Gears, power transmission (except aircraft, motor vehicle), manufacturing",
  },
  {
    code: "333612",
    title: "Motors, gear, manufacturing",
  },
  {
    code: "333612",
    title: "Reducers, speed, manufacturing",
  },
  {
    code: "333612",
    title:
      "Reduction gears and gear units (except aircraft power transmission equipment, automotive) manufacturing",
  },
  {
    code: "333612",
    title: "Speed changers (i.e., power transmission equipment) manufacturing",
  },
  {
    code: "333612",
    title: "Speed reducers (i.e., power transmission equipment) manufacturing",
  },
  {
    code: "333613",
    title: "Ball joints (except aircraft, motor vehicle) manufacturing",
  },
  {
    code: "333613",
    title: "Bearings, plain (except internal combustion engine), manufacturing",
  },
  {
    code: "333613",
    title: "Bushings, plain (except internal combustion engine), manufacturing",
  },
  {
    code: "333613",
    title: "Chains, power transmission, manufacturing",
  },
  {
    code: "333613",
    title: "Collars, shaft for power transmission equipment, manufacturing",
  },
  {
    code: "333613",
    title: "Couplings, mechanical power transmission, manufacturing",
  },
  {
    code: "333613",
    title: "Drive chains, bicycle and motorcycle, manufacturing",
  },
  {
    code: "333613",
    title: "Joints, swivel (except aircraft, motor vehicle), manufacturing",
  },
  {
    code: "333613",
    title: "Joints, universal (except aircraft, motor vehicle), manufacturing",
  },
  {
    code: "333613",
    title: "Pulleys, power transmission, manufacturing",
  },
  {
    code: "333613",
    title: "Railroad car journal bearings, plain, manufacturing",
  },
  {
    code: "333613",
    title: "Sheaves, mechanical power transmission, manufacturing",
  },
  {
    code: "333613",
    title: "Sprockets, power transmission equipment, manufacturing",
  },
  {
    code: "333613",
    title: "Universal joints (except aircraft, motor vehicle) manufacturing",
  },
  {
    code: "333618",
    title: "Diesel and semidiesel engines manufacturing",
  },
  {
    code: "333618",
    title: "Electric outboard motors manufacturing",
  },
  {
    code: "333618",
    title: "Engines, diesel and semidiesel, manufacturing",
  },
  {
    code: "333618",
    title: "Engines, diesel locomotive, manufacturing",
  },
  {
    code: "333618",
    title:
      "Engines, internal combustion (except aircraft, nondiesel automotive), manufacturing",
  },
  {
    code: "333618",
    title: "Engines, natural gas, manufacturing",
  },
  {
    code: "333618",
    title:
      "Gasoline engines (except aircraft, automotive, truck) manufacturing",
  },
  {
    code: "333618",
    title: "Governors, diesel engine, manufacturing",
  },
  {
    code: "333618",
    title: "Governors, gasoline engine (except automotive), manufacturing",
  },
  {
    code: "333618",
    title:
      "Internal combustion engines (except aircraft, nondiesel automotive, nondiesel truck) manufacturing",
  },
  {
    code: "333618",
    title:
      "Internal combustion engines for hybrid drive systems (except automotive) manufacturing",
  },
  {
    code: "333618",
    title: "Locomotive diesel engines manufacturing",
  },
  {
    code: "333618",
    title: "Marine engines manufacturing",
  },
  {
    code: "333618",
    title: "Motors, outboard, manufacturing",
  },
  {
    code: "333618",
    title: "Natural gas engines manufacturing",
  },
  {
    code: "333618",
    title: "Outboard motors manufacturing",
  },
  {
    code: "333618",
    title: "Semidiesel engines manufacturing",
  },
  {
    code: "333912",
    title:
      "Air compressors (except air-conditioning, refrigeration) manufacturing",
  },
  {
    code: "333912",
    title: "Bicycle pumps manufacturing",
  },
  {
    code: "333912",
    title: "Compressors, air and gas, general purpose-type, manufacturing",
  },
  {
    code: "333912",
    title: "Paint sprayers (i.e., compressor and spray gun unit) manufacturing",
  },
  {
    code: "333912",
    title: "Power (i.e., pressure) washer units manufacturing",
  },
  {
    code: "333912",
    title: "Sprayers, manual pump, general purpose-type, manufacturing",
  },
  {
    code: "333912",
    title: "Vacuum pumps (except laboratory) manufacturing",
  },
  {
    code: "333914",
    title: "Centrifugal pumps manufacturing",
  },
  {
    code: "333914",
    title:
      "Dispensing and measuring pumps (e.g., gasoline, lubricants) manufacturing",
  },
  {
    code: "333914",
    title: "Gasoline measuring and dispensing pumps manufacturing",
  },
  {
    code: "333914",
    title: "Oil measuring and dispensing pumps manufacturing",
  },
  {
    code: "333914",
    title: "Oil well and oil field pumps manufacturing",
  },
  {
    code: "333914",
    title: "Pumps (except fluid power), general purpose, manufacturing",
  },
  {
    code: "333914",
    title: "Pumps for railroad equipment lubrication systems manufacturing",
  },
  {
    code: "333914",
    title:
      "Pumps, industrial and commercial-type, general purpose, manufacturing",
  },
  {
    code: "333914",
    title: "Pumps, measuring and dispensing (e.g., gasoline), manufacturing",
  },
  {
    code: "333914",
    title: "Pumps, oil field or well, manufacturing",
  },
  {
    code: "333914",
    title: "Pumps, sump or water, residential-type, manufacturing",
  },
  {
    code: "333914",
    title: "Sump pumps, residential-type, manufacturing",
  },
  {
    code: "333921",
    title:
      "Automobile lifts (i.e., garage-type, service station) manufacturing",
  },
  {
    code: "333921",
    title: "Dumbwaiters manufacturing",
  },
  {
    code: "333921",
    title: "Elevators, passenger and freight, manufacturing",
  },
  {
    code: "333921",
    title: "Escalators manufacturing",
  },
  {
    code: "333921",
    title: "Stairways, moving, manufacturing",
  },
  {
    code: "333921",
    title: "Walkways, moving, manufacturing",
  },
  {
    code: "333922",
    title: "Belt conveyor systems manufacturing",
  },
  {
    code: "333922",
    title: "Buckets, elevator or conveyor, manufacturing",
  },
  {
    code: "333922",
    title: "Carousel conveyors (e.g., luggage) manufacturing",
  },
  {
    code: "333922",
    title: "Coal and ore conveyors manufacturing",
  },
  {
    code: "333922",
    title: "Conveyors and conveying equipment manufacturing",
  },
  {
    code: "333922",
    title: "Elevators, farm, manufacturing",
  },
  {
    code: "333922",
    title: "Farm-type conveyors manufacturing",
  },
  {
    code: "333922",
    title: "Mine conveyors manufacturing",
  },
  {
    code: "333922",
    title: "Overhead conveyors manufacturing",
  },
  {
    code: "333922",
    title:
      "Passenger baggage belt loaders (except industrial truck) manufacturing",
  },
  {
    code: "333922",
    title: "Pneumatic tube conveyors manufacturing",
  },
  {
    code: "333922",
    title: "Screw conveyors manufacturing",
  },
  {
    code: "333923",
    title: "Aerial work platforms manufacturing",
  },
  {
    code: "333923",
    title: "Automobile wrecker (i.e., tow truck) hoists manufacturing",
  },
  {
    code: "333923",
    title: "Block and tackle manufacturing",
  },
  {
    code: "333923",
    title: "Boat lifts manufacturing",
  },
  {
    code: "333923",
    title: "Chain hoists manufacturing",
  },
  {
    code: "333923",
    title: "Cranes, overhead traveling, manufacturing",
  },
  {
    code: "333923",
    title: "Davits manufacturing",
  },
  {
    code: "333923",
    title: "Hoists (except aircraft loading) manufacturing",
  },
  {
    code: "333923",
    title: "Locomotive cranes manufacturing",
  },
  {
    code: "333923",
    title: "Monorail systems (except passenger-type) manufacturing",
  },
  {
    code: "333923",
    title: "Overhead traveling cranes manufacturing",
  },
  {
    code: "333923",
    title: "Pulleys (except power transmission), metal, manufacturing",
  },
  {
    code: "333923",
    title: "Ship cranes and derricks manufacturing",
  },
  {
    code: "333923",
    title: "Winches manufacturing",
  },
  {
    code: "333923",
    title: "Wire rope hoists manufacturing",
  },
  {
    code: "333924",
    title: "Aircraft engine cradles manufacturing",
  },
  {
    code: "333924",
    title: "Aircraft loading hoists manufacturing",
  },
  {
    code: "333924",
    title: "Bomb lifts manufacturing",
  },
  {
    code: "333924",
    title: "Cabs for industrial trucks manufacturing",
  },
  {
    code: "333924",
    title: "Carts, grocery, made from purchased wire",
  },
  {
    code: "333924",
    title: "Cranes, industrial truck, manufacturing",
  },
  {
    code: "333924",
    title: "Dollies manufacturing",
  },
  {
    code: "333924",
    title: "Drum cradles manufacturing",
  },
  {
    code: "333924",
    title: "Forklifts manufacturing",
  },
  {
    code: "333924",
    title: "Grocery carts made from purchased wire",
  },
  {
    code: "333924",
    title: "Hand trucks manufacturing",
  },
  {
    code: "333924",
    title: "Hoists, aircraft loading, manufacturing",
  },
  {
    code: "333924",
    title: "Industrial trucks and tractors manufacturing",
  },
  {
    code: "333924",
    title: "Mechanic's creepers manufacturing",
  },
  {
    code: "333924",
    title: "Mobile straddle carriers manufacturing",
  },
  {
    code: "333924",
    title: "Pallet movers manufacturing",
  },
  {
    code: "333924",
    title: "Pallet or skid jacks manufacturing",
  },
  {
    code: "333924",
    title: "Stackers, industrial, truck-type, manufacturing",
  },
  {
    code: "333924",
    title: "Stackers, portable (except farm), manufacturing",
  },
  {
    code: "333924",
    title: "Straddle carriers, mobile, manufacturing",
  },
  {
    code: "333924",
    title: "Tractors, industrial, manufacturing",
  },
  {
    code: "333924",
    title: "Trucks, industrial, manufacturing",
  },
  {
    code: "333924",
    title: "Unmanned and robotic forklifts manufacturing",
  },
  {
    code: "333924",
    title: "Unmanned and robotic pallet loaders and unloaders manufacturing",
  },
  {
    code: "333924",
    title: "Wheelbarrows manufacturing",
  },
  {
    code: "333991",
    title: "Buffing machines, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Cartridge (i.e., powder) handheld power-driven tools manufacturing",
  },
  {
    code: "333991",
    title: "Chain saws, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Chisels, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Circular saws, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title:
      "Drills, handheld power-driven (except heavy construction and mining-type), manufacturing",
  },
  {
    code: "333991",
    title: "Grinders, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Handtools, power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Impact wrenches, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Jigsaws, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Nail guns, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Nailers and staplers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Paint spray guns, handheld pneumatic, manufacturing",
  },
  {
    code: "333991",
    title: "Planers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Polishers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Powder actuated handheld power tools manufacturing",
  },
  {
    code: "333991",
    title: "Power-driven handtools manufacturing",
  },
  {
    code: "333991",
    title: "Riveting guns, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Routers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Sanders, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Saws, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Screwdrivers and nut drivers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Shears and nibblers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Staplers and nailers, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Tools, handheld power-driven, manufacturing",
  },
  {
    code: "333991",
    title: "Wrenches, impact, handheld power-driven, manufacturing",
  },
  {
    code: "333992",
    title: "Arc-welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Electrode holders, welding, manufacturing",
  },
  {
    code: "333992",
    title: "Electrodes, welding, manufacturing",
  },
  {
    code: "333992",
    title: "Electron beam welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Gas welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Gas welding rods, coated or cored, manufacturing",
  },
  {
    code: "333992",
    title: "Generating apparatus and parts, welding, electrical, manufacturing",
  },
  {
    code: "333992",
    title: "Laser welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Plasma welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Resistance welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Seam welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Soldering equipment (except handheld) manufacturing",
  },
  {
    code: "333992",
    title: "Spot welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Ultrasonic welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Welding equipment manufacturing",
  },
  {
    code: "333992",
    title: "Welding wire or rods (i.e., coated, cored) manufacturing",
  },
  {
    code: "333993",
    title: "Bag opening, filling, and closing machines manufacturing",
  },
  {
    code: "333993",
    title: "Bottle washers, packaging machinery, manufacturing",
  },
  {
    code: "333993",
    title:
      "Bottling machinery (e.g., capping, filling, labeling, sterilizing, washing) manufacturing",
  },
  {
    code: "333993",
    title: "Bread wrapping machines manufacturing",
  },
  {
    code: "333993",
    title: "Canning machinery manufacturing",
  },
  {
    code: "333993",
    title: "Capping, sealing, and lidding packaging machinery manufacturing",
  },
  {
    code: "333993",
    title: "Carton filling machinery manufacturing",
  },
  {
    code: "333993",
    title: "Coding, dating, and imprinting packaging machinery manufacturing",
  },
  {
    code: "333993",
    title: "Food packaging machinery manufacturing",
  },
  {
    code: "333993",
    title: "Labeling (i.e., packaging) machinery manufacturing",
  },
  {
    code: "333993",
    title: "Packaging machinery manufacturing",
  },
  {
    code: "333993",
    title: "Testing, weighing, inspecting, packaging machinery manufacturing",
  },
  {
    code: "333993",
    title: "Thermoform, blister, and skin packaging machinery manufacturing",
  },
  {
    code: "333993",
    title: "Wrapping (i.e., packaging) machinery manufacturing",
  },
  {
    code: "333994",
    title: "Ceramic kilns and furnaces manufacturing",
  },
  {
    code: "333994",
    title: "Core baking and mold drying ovens manufacturing",
  },
  {
    code: "333994",
    title: "Dielectric industrial heating equipment manufacturing",
  },
  {
    code: "333994",
    title: "Distillation ovens, charcoal and coke, manufacturing",
  },
  {
    code: "333994",
    title: "Enameling ovens manufacturing",
  },
  {
    code: "333994",
    title:
      "Furnaces and ovens for drying and redrying, industrial process-type, manufacturing",
  },
  {
    code: "333994",
    title: "Furnaces and ovens, semiconductor wafer, manufacturing",
  },
  {
    code: "333994",
    title:
      "Furnaces, industrial and laboratory-type (except dental), manufacturing",
  },
  {
    code: "333994",
    title: "Garbage incinerators (except precast concrete) manufacturing",
  },
  {
    code: "333994",
    title: "Heat treating ovens, industrial process-type, manufacturing",
  },
  {
    code: "333994",
    title: "Incinerators (except precast concrete) manufacturing",
  },
  {
    code: "333994",
    title:
      "Induction heating equipment, industrial process-type, manufacturing",
  },
  {
    code: "333994",
    title: "Infrared ovens, industrial, manufacturing",
  },
  {
    code: "333994",
    title: "Japanning ovens manufacturing",
  },
  {
    code: "333994",
    title: "Kilns (except cement, chemical, wood) manufacturing",
  },
  {
    code: "333994",
    title: "Lacquering ovens manufacturing",
  },
  {
    code: "333994",
    title: "Metal melting furnaces, industrial, manufacturing",
  },
  {
    code: "333994",
    title: "Ovens, industrial process and laboratory-type, manufacturing",
  },
  {
    code: "333994",
    title: "Paint baking and drying ovens manufacturing",
  },
  {
    code: "333994",
    title: "Smelting ovens manufacturing",
  },
  {
    code: "333994",
    title: "Tile making kilns manufacturing",
  },
  {
    code: "333995",
    title: "Actuators, fluid power, manufacturing",
  },
  {
    code: "333995",
    title: "Cylinders, fluid power, manufacturing",
  },
  {
    code: "333995",
    title: "Electric linear actuators manufacturing",
  },
  {
    code: "333995",
    title: "Fluid power actuators manufacturing",
  },
  {
    code: "333995",
    title: "Fluid power cylinders manufacturing",
  },
  {
    code: "333995",
    title: "Gas spring cylinders manufacturing",
  },
  {
    code: "333995",
    title: "Hydraulic cylinders, fluid power, manufacturing",
  },
  {
    code: "333995",
    title: "Pneumatic cylinders, fluid power, manufacturing",
  },
  {
    code: "333996",
    title: "Fluid power motors manufacturing",
  },
  {
    code: "333996",
    title: "Fluid power pumps manufacturing",
  },
  {
    code: "333996",
    title: "Hydraulic pumps, fluid power, manufacturing",
  },
  {
    code: "333996",
    title: "Hydrostatic drives manufacturing",
  },
  {
    code: "333996",
    title: "Hydrostatic transmissions manufacturing",
  },
  {
    code: "333996",
    title: "Motors, fluid power, manufacturing",
  },
  {
    code: "333996",
    title: "Pneumatic pumps, fluid power, manufacturing",
  },
  {
    code: "333996",
    title: "Pumps, fluid power, manufacturing",
  },
  {
    code: "333998",
    title: "Aircraft carrier catapults manufacturing",
  },
  {
    code: "333998",
    title: "Baby scales manufacturing",
  },
  {
    code: "333998",
    title: "Balances, including laboratory-type, manufacturing",
  },
  {
    code: "333998",
    title: "Baling machinery (e.g., paper, scrap metal) manufacturing",
  },
  {
    code: "333998",
    title: "Bathroom scales manufacturing",
  },
  {
    code: "333998",
    title: "Bellows, industrial-type, manufacturing",
  },
  {
    code: "333998",
    title: "Bridge and gate lifting machinery manufacturing",
  },
  {
    code: "333998",
    title: "Centrifuges, industrial and laboratory-type, manufacturing",
  },
  {
    code: "333998",
    title: "Cremating ovens manufacturing",
  },
  {
    code: "333998",
    title: "Delicatessen scales manufacturing",
  },
  {
    code: "333998",
    title:
      "Filters, industrial and general purpose-type (except internal combustion engine, warm air furnace), manufacturing",
  },
  {
    code: "333998",
    title: "Gas generating machinery, general purpose-type, manufacturing",
  },
  {
    code: "333998",
    title: "Gas separating machinery manufacturing",
  },
  {
    code: "333998",
    title: "Gate and bridge lifting machinery manufacturing",
  },
  {
    code: "333998",
    title: "Ice crushers, industrial and commercial-type, manufacturing",
  },
  {
    code: "333998",
    title: "Industrial robot cells manufacturing",
  },
  {
    code: "333998",
    title: "Industrial robots manufacturing",
  },
  {
    code: "333998",
    title: "Industrial scales manufacturing",
  },
  {
    code: "333998",
    title: "Jacks, hydraulic and pneumatic, manufacturing",
  },
  {
    code: "333998",
    title: "Motor truck scales manufacturing",
  },
  {
    code: "333998",
    title: "Parcel post scales manufacturing",
  },
  {
    code: "333998",
    title: "Post office-type scales manufacturing",
  },
  {
    code: "333998",
    title: "Presses, metal baling, manufacturing",
  },
  {
    code: "333998",
    title: "Railroad track scales manufacturing",
  },
  {
    code: "333998",
    title: "Retail scales (e.g., butcher, delicatessen, produce) manufacturing",
  },
  {
    code: "333998",
    title: "Scales, including laboratory-type, manufacturing",
  },
  {
    code: "333998",
    title:
      "Screening and sifting machinery for general industrial use manufacturing",
  },
  {
    code: "333998",
    title:
      "Sieves and screening equipment, general purpose-type, manufacturing",
  },
  {
    code: "333998",
    title: "Sludge tables manufacturing",
  },
  {
    code: "333998",
    title: "Sprinkler systems, automatic fire, manufacturing",
  },
  {
    code: "333998",
    title: "Steam separating machinery manufacturing",
  },
  {
    code: "333998",
    title: "Strainers, pipeline, manufacturing",
  },
  {
    code: "333998",
    title: "Vapor separating machinery manufacturing",
  },
  {
    code: "333998",
    title: "Vehicle scales manufacturing",
  },
  {
    code: "333998",
    title: "Weather vanes manufacturing",
  },
  {
    code: "334111",
    title: "Analog computers manufacturing",
  },
  {
    code: "334111",
    title: "Computer servers manufacturing",
  },
  {
    code: "334111",
    title: "Computers manufacturing",
  },
  {
    code: "334111",
    title: "Digital computers manufacturing",
  },
  {
    code: "334111",
    title: "Hybrid computers manufacturing",
  },
  {
    code: "334111",
    title: "Laptop computers manufacturing",
  },
  {
    code: "334111",
    title: "Mainframe computers manufacturing",
  },
  {
    code: "334111",
    title: "Microcomputers manufacturing",
  },
  {
    code: "334111",
    title: "Minicomputers manufacturing",
  },
  {
    code: "334111",
    title: "Notebook computers manufacturing",
  },
  {
    code: "334111",
    title: "Personal computers manufacturing",
  },
  {
    code: "334111",
    title: "Portable computers manufacturing",
  },
  {
    code: "334111",
    title: "Tablet computers manufacturing",
  },
  {
    code: "334111",
    title: "Workstations, computer, manufacturing",
  },
  {
    code: "334112",
    title: "CD-ROM drives manufacturing",
  },
  {
    code: "334112",
    title: "Direct access storage devices manufacturing",
  },
  {
    code: "334112",
    title: "Disk drives, computer, manufacturing",
  },
  {
    code: "334112",
    title:
      "DVD (digital video disc) drives, computer peripheral equipment, manufacturing",
  },
  {
    code: "334112",
    title: "Flexible (i.e., floppy) magnetic disk drives manufacturing",
  },
  {
    code: "334112",
    title: "Floppy disk drives manufacturing",
  },
  {
    code: "334112",
    title: "Hard disk drives, computer peripheral equipment, manufacturing",
  },
  {
    code: "334112",
    title:
      "Magnetic/optical combination storage units for computers manufacturing",
  },
  {
    code: "334112",
    title: "Optical disk drives manufacturing",
  },
  {
    code: "334112",
    title: "Storage devices, computer, manufacturing",
  },
  {
    code: "334112",
    title:
      "Tape storage units (e.g., drive backups), computer peripheral equipment, manufacturing",
  },
  {
    code: "334112",
    title: "USB flash drives (e.g., thumbdrives, jumpdrives) manufacturing",
  },
  {
    code: "334118",
    title: "ATMs (automated teller machines) manufacturing",
  },
  {
    code: "334118",
    title: "Automated teller machines (ATM) manufacturing",
  },
  {
    code: "334118",
    title: "Bar code scanners manufacturing",
  },
  {
    code: "334118",
    title:
      "Biometrics system input devices (e.g., retinal scan, iris pattern recognition, hand geometry) manufacturing",
  },
  {
    code: "334118",
    title: "Computer input/output equipment manufacturing",
  },
  {
    code: "334118",
    title: "Computer terminals manufacturing",
  },
  {
    code: "334118",
    title:
      "Flat panel displays (i.e., complete units), computer peripheral equipment, manufacturing",
  },
  {
    code: "334118",
    title: "Funds transfer devices manufacturing",
  },
  {
    code: "334118",
    title: "Input/output equipment, computer, manufacturing",
  },
  {
    code: "334118",
    title: "Joystick devices manufacturing",
  },
  {
    code: "334118",
    title: "Keyboards, computer peripheral equipment, manufacturing",
  },
  {
    code: "334118",
    title: "Lottery ticket sales terminals manufacturing",
  },
  {
    code: "334118",
    title:
      "Magnetic ink recognition devices, computer peripheral equipment, manufacturing",
  },
  {
    code: "334118",
    title: "Monitors, computer peripheral equipment, manufacturing",
  },
  {
    code: "334118",
    title: "Mouse devices, computer peripheral equipment, manufacturing",
  },
  {
    code: "334118",
    title: "Optical readers and scanners manufacturing",
  },
  {
    code: "334118",
    title: "Overhead projectors, computer peripheral-type, manufacturing",
  },
  {
    code: "334118",
    title: "Plotters, computer, manufacturing",
  },
  {
    code: "334118",
    title: "Point of sale terminals manufacturing",
  },
  {
    code: "334118",
    title: "Pointing devices, computer peripheral equipment, manufacturing",
  },
  {
    code: "334118",
    title: "Printers, computer, manufacturing",
  },
  {
    code: "334118",
    title: "Smart card readers manufacturing",
  },
  {
    code: "334118",
    title: "Teleprinters (i.e., computer terminals) manufacturing",
  },
  {
    code: "334118",
    title: "Terminals, computer, manufacturing",
  },
  {
    code: "334210",
    title:
      "Carrier equipment (i.e., analog, digital), telephone, manufacturing",
  },
  {
    code: "334210",
    title: "Central office and switching equipment, telephone, manufacturing",
  },
  {
    code: "334210",
    title: "Communications headgear, telephone, manufacturing",
  },
  {
    code: "334210",
    title: "Cordless telephones (except cellular) manufacturing",
  },
  {
    code: "334210",
    title:
      "Data communications equipment (e.g., bridges, gateways, routers) manufacturing",
  },
  {
    code: "334210",
    title: "Facsimile equipment, stand-alone, manufacturing",
  },
  {
    code: "334210",
    title: "Keysets, telephone, manufacturing",
  },
  {
    code: "334210",
    title:
      "Local area network (LAN) communications equipment (e.g., bridges, gateways, routers) manufacturing",
  },
  {
    code: "334210",
    title: "Modems, carrier equipment, manufacturing",
  },
  {
    code: "334210",
    title: "Multiplex equipment, telephone, manufacturing",
  },
  {
    code: "334210",
    title: "PBX (private branch exchange) equipment manufacturing",
  },
  {
    code: "334210",
    title: "Private branch exchange (PBX) equipment manufacturing",
  },
  {
    code: "334210",
    title: "Repeater and transceiver equipment, carrier line, manufacturing",
  },
  {
    code: "334210",
    title: "Subscriber loop equipment, telephone, manufacturing",
  },
  {
    code: "334210",
    title: "Switching equipment, telephone, manufacturing",
  },
  {
    code: "334210",
    title: "Telephone answering machines manufacturing",
  },
  {
    code: "334210",
    title: "Telephone carrier line equipment manufacturing",
  },
  {
    code: "334210",
    title: "Telephone carrier switching equipment manufacturing",
  },
  {
    code: "334210",
    title: "Telephones (except cellular telephone) manufacturing",
  },
  {
    code: "334210",
    title: "Telephones, coin- or card-operated, manufacturing",
  },
  {
    code: "334210",
    title: "Toll switching equipment, telephone, manufacturing",
  },
  {
    code: "334210",
    title:
      "Wide area network communications equipment (e.g., bridges, gateways, routers) manufacturing",
  },
  {
    code: "334220",
    title: "Airborne radio communications equipment manufacturing",
  },
  {
    code: "334220",
    title:
      "Amplifiers (e.g., RF power and IF), broadcast and studio equipment, manufacturing",
  },
  {
    code: "334220",
    title: "Antennas, satellite, manufacturing",
  },
  {
    code: "334220",
    title: "Antennas, transmitting and receiving, manufacturing",
  },
  {
    code: "334220",
    title: "Automobile antennas manufacturing",
  },
  {
    code: "334220",
    title:
      "Broadcast equipment (including studio), for radio and television, manufacturing",
  },
  {
    code: "334220",
    title: "Cable decoders manufacturing",
  },
  {
    code: "334220",
    title:
      "Cable television transmission and receiving equipment manufacturing",
  },
  {
    code: "334220",
    title: "Cameras, television, manufacturing",
  },
  {
    code: "334220",
    title: "CB (citizens' band) radios manufacturing",
  },
  {
    code: "334220",
    title: "Cellular telephones (new and rebuilt) manufacturing",
  },
  {
    code: "334220",
    title: "Citizens' band (CB) radios manufacturing",
  },
  {
    code: "334220",
    title: "Closed-circuit television equipment manufacturing",
  },
  {
    code: "334220",
    title: "Communications equipment, mobile and microwave, manufacturing",
  },
  {
    code: "334220",
    title: "Earth station communications equipment manufacturing",
  },
  {
    code: "334220",
    title: "Global positioning system (GPS) equipment manufacturing",
  },
  {
    code: "334220",
    title: "GPS (global positioning system) equipment manufacturing",
  },
  {
    code: "334220",
    title: "Marine radio communications equipment manufacturing",
  },
  {
    code: "334220",
    title: "Microphones, broadcast and studio equipment, manufacturing",
  },
  {
    code: "334220",
    title: "Microwave communications equipment manufacturing",
  },
  {
    code: "334220",
    title: "Mobile communications equipment manufacturing",
  },
  {
    code: "334220",
    title: "Pagers manufacturing",
  },
  {
    code: "334220",
    title: "Radio transmitting antennas and ground equipment manufacturing",
  },
  {
    code: "334220",
    title: "Receiver-transmitter units (i.e., transceivers) manufacturing",
  },
  {
    code: "334220",
    title: "Satellite antennas manufacturing",
  },
  {
    code: "334220",
    title: "Satellite communications equipment manufacturing",
  },
  {
    code: "334220",
    title: "Smartphones (new and rebuilt) manufacturing",
  },
  {
    code: "334220",
    title: "Smartwatches manufacturing",
  },
  {
    code: "334220",
    title: "Space satellites, communications, manufacturing",
  },
  {
    code: "334220",
    title: "Studio equipment, radio and television broadcasting, manufacturing",
  },
  {
    code: "334220",
    title: "Telephones, cellular (new and rebuilt), manufacturing",
  },
  {
    code: "334220",
    title:
      "Television transmitting antennas and ground equipment manufacturing",
  },
  {
    code: "334220",
    title: "Television, closed-circuit equipment, manufacturing",
  },
  {
    code: "334220",
    title: "Transceivers (i.e., transmitter-receiver units) manufacturing",
  },
  {
    code: "334220",
    title: "Video cameras (except household-type) manufacturing",
  },
  {
    code: "334220",
    title:
      "Video projectors (except household-type, motion picture theater) manufacturing",
  },
  {
    code: "334290",
    title: "Alarm system central monitoring equipment manufacturing",
  },
  {
    code: "334290",
    title: "Alarm systems and equipment manufacturing",
  },
  {
    code: "334290",
    title: "Automotive theft alarm systems manufacturing",
  },
  {
    code: "334290",
    title: "Burglar alarm systems and equipment manufacturing",
  },
  {
    code: "334290",
    title: "Car alarm manufacturing",
  },
  {
    code: "334290",
    title: "Carbon monoxide detectors manufacturing",
  },
  {
    code: "334290",
    title: "Controlling equipment, street light, manufacturing",
  },
  {
    code: "334290",
    title: "Fire detection and alarm systems manufacturing",
  },
  {
    code: "334290",
    title: "Glass breakage detection and signaling devices",
  },
  {
    code: "334290",
    title: "Intercom systems and equipment manufacturing",
  },
  {
    code: "334290",
    title: "Motion alarms (e.g., swimming pool, perimeter) manufacturing",
  },
  {
    code: "334290",
    title: "Motion detectors, security system, manufacturing",
  },
  {
    code: "334290",
    title: "Portable intrusion detection and signaling devices manufacturing",
  },
  {
    code: "334290",
    title: "Railroad signaling equipment manufacturing",
  },
  {
    code: "334290",
    title: "Remote control units (e.g., garage door, television) manufacturing",
  },
  {
    code: "334290",
    title:
      "Signals (e.g., highway, pedestrian, railway, traffic) manufacturing",
  },
  {
    code: "334290",
    title: "Sirens (e.g., air raid, industrial, marine, vehicle) manufacturing",
  },
  {
    code: "334290",
    title: "Smoke detectors manufacturing",
  },
  {
    code: "334290",
    title:
      "Theft prevention signaling devices (e.g., door entrance annunciation, holdup signaling devices, personal duress signaling devices), manufacturing",
  },
  {
    code: "334290",
    title: "Traffic advisory and signalling systems manufacturing",
  },
  {
    code: "334290",
    title: "Traffic signals manufacturing",
  },
  {
    code: "334290",
    title: "Video-based stadium displays manufacturing",
  },
  {
    code: "334310",
    title:
      "Amplifiers (e.g., auto, home, musical instrument, public address) manufacturing",
  },
  {
    code: "334310",
    title: "Automobile radio receivers manufacturing",
  },
  {
    code: "334310",
    title: "Camcorders manufacturing",
  },
  {
    code: "334310",
    title: "Car stereos manufacturing",
  },
  {
    code: "334310",
    title: "Clock radios manufacturing",
  },
  {
    code: "334310",
    title: "Coin- or card-operated jukebox manufacturing",
  },
  {
    code: "334310",
    title:
      "Compact disc players (e.g., automotive, household-type) manufacturing",
  },
  {
    code: "334310",
    title: "Digital video disc players manufacturing",
  },
  {
    code: "334310",
    title: "DVD (digital video disc) players manufacturing",
  },
  {
    code: "334310",
    title: "E-book readers (i.e., dedicated) manufacturing",
  },
  {
    code: "334310",
    title: "Home stereo systems manufacturing",
  },
  {
    code: "334310",
    title:
      "Home tape recorders and players (e.g., cartridge, cassette, reel) manufacturing",
  },
  {
    code: "334310",
    title: "Home theater audio and video equipment manufacturing",
  },
  {
    code: "334310",
    title: "Jukeboxes manufacturing",
  },
  {
    code: "334310",
    title: "Loudspeakers manufacturing",
  },
  {
    code: "334310",
    title: "Microphones (except broadcast and studio equipment) manufacturing",
  },
  {
    code: "334310",
    title:
      "Personal audio and video headsets, including virtual reality headsets, manufacturing",
  },
  {
    code: "334310",
    title: "Portable stereo systems manufacturing",
  },
  {
    code: "334310",
    title: "Projection television manufacturing",
  },
  {
    code: "334310",
    title: "Public address systems and equipment manufacturing",
  },
  {
    code: "334310",
    title: "Radio headphones manufacturing",
  },
  {
    code: "334310",
    title: "Radio receiving sets manufacturing",
  },
  {
    code: "334310",
    title: "Speaker systems manufacturing",
  },
  {
    code: "334310",
    title: "Tape players and recorders, household-type, manufacturing",
  },
  {
    code: "334310",
    title: "Television (TV) sets manufacturing",
  },
  {
    code: "334310",
    title: "TV (television) sets manufacturing",
  },
  {
    code: "334310",
    title: "VCR (video cassette recorder) manufacturing",
  },
  {
    code: "334310",
    title: "Video cameras, household-type, manufacturing",
  },
  {
    code: "334310",
    title: "Video cassette recorders (VCR) manufacturing",
  },
  {
    code: "334310",
    title: "Video projectors, household-type, manufacturing",
  },
  {
    code: "334412",
    title: "Circuit boards, printed, bare, manufacturing",
  },
  {
    code: "334412",
    title: "Flexible wiring boards, bare, manufacturing",
  },
  {
    code: "334412",
    title: "Printed circuit boards, bare, manufacturing",
  },
  {
    code: "334413",
    title: "Diodes, solid-state (e.g., germanium, silicon), manufacturing",
  },
  {
    code: "334413",
    title: "Fuel cells, solid-state, manufacturing",
  },
  {
    code: "334413",
    title: "Gunn effect devices manufacturing",
  },
  {
    code: "334413",
    title: "Hall effect devices manufacturing",
  },
  {
    code: "334413",
    title: "Hybrid integrated circuits manufacturing",
  },
  {
    code: "334413",
    title: "Infrared sensors, solid-state, manufacturing",
  },
  {
    code: "334413",
    title: "Integrated microcircuits manufacturing",
  },
  {
    code: "334413",
    title: "Laser diodes manufacturing",
  },
  {
    code: "334413",
    title: "LED (light emitting diode) manufacturing",
  },
  {
    code: "334413",
    title: "Light emitting diodes (LED) manufacturing",
  },
  {
    code: "334413",
    title: "Memory chip, semiconductor, manufacturing",
  },
  {
    code: "334413",
    title: "Metal oxide silicon (MOS) devices manufacturing",
  },
  {
    code: "334413",
    title: "Microcontroller chip manufacturing",
  },
  {
    code: "334413",
    title: "Microprocessor chip manufacturing",
  },
  {
    code: "334413",
    title: "Monolithic integrated circuits (solid-state) manufacturing",
  },
  {
    code: "334413",
    title: "MOS (metal oxide silicon) devices manufacturing",
  },
  {
    code: "334413",
    title: "Optoelectronic devices manufacturing",
  },
  {
    code: "334413",
    title:
      "Photoelectric cells, solid-state (e.g., electronic eye), manufacturing",
  },
  {
    code: "334413",
    title: "Photonic integrated circuits manufacturing",
  },
  {
    code: "334413",
    title: "Photovoltaic cells manufacturing",
  },
  {
    code: "334413",
    title: "Photovoltaic devices, solid-state, manufacturing",
  },
  {
    code: "334413",
    title: "Rectifiers, semiconductor, manufacturing",
  },
  {
    code: "334413",
    title:
      "Semiconductor circuit networks (i.e., solid-state integrated circuits) manufacturing",
  },
  {
    code: "334413",
    title: "Semiconductor devices manufacturing",
  },
  {
    code: "334413",
    title: "Semiconductor dice and wafers manufacturing",
  },
  {
    code: "334413",
    title: "Semiconductor memory chips manufacturing",
  },
  {
    code: "334413",
    title: "Silicon wafers, chemically doped, manufacturing",
  },
  {
    code: "334413",
    title: "Silicon wave guides manufacturing",
  },
  {
    code: "334413",
    title: "Solar cells manufacturing",
  },
  {
    code: "334413",
    title: "Static converters, integrated circuits, manufacturing",
  },
  {
    code: "334413",
    title: "Thin film integrated circuits manufacturing",
  },
  {
    code: "334413",
    title: "Thyristors manufacturing",
  },
  {
    code: "334413",
    title: "Transistors manufacturing",
  },
  {
    code: "334413",
    title: "Voltage regulators, integrated circuits, manufacturing",
  },
  {
    code: "334413",
    title: "Wafers (semiconductor devices) manufacturing",
  },
  {
    code: "334416",
    title: "Capacitors, electronic, fixed and variable, manufacturing",
  },
  {
    code: "334416",
    title: "Chokes for electronic circuitry manufacturing",
  },
  {
    code: "334416",
    title: "Condensers, electronic, manufacturing",
  },
  {
    code: "334416",
    title:
      "Inductors, electronic component-type (e.g., chokes, coils, transformers), manufacturing",
  },
  {
    code: "334416",
    title: "Resistors, electronic, manufacturing",
  },
  {
    code: "334416",
    title:
      "Telephone and telegraph transformers, electronic component-type, manufacturing",
  },
  {
    code: "334416",
    title: "Thermistors manufacturing",
  },
  {
    code: "334416",
    title: "Transformers, electronic component-types, manufacturing",
  },
  {
    code: "334416",
    title: "Varistors manufacturing",
  },
  {
    code: "334417",
    title: "Coaxial connectors manufacturing",
  },
  {
    code: "334417",
    title:
      "Connectors, electronic (e.g., coaxial, cylindrical, printed circuit, rack and panel), manufacturing",
  },
  {
    code: "334417",
    title: "Cylindrical connectors, electronic, manufacturing",
  },
  {
    code: "334417",
    title: "Fiber optic connectors manufacturing",
  },
  {
    code: "334417",
    title: "Planar cable connectors manufacturing",
  },
  {
    code: "334417",
    title: "Rack and panel connectors manufacturing",
  },
  {
    code: "334418",
    title: "Loaded computer boards manufacturing",
  },
  {
    code: "334418",
    title: "Loading printed circuit boards",
  },
  {
    code: "334418",
    title: "Memory boards manufacturing",
  },
  {
    code: "334418",
    title: "Peripheral controller boards manufacturing",
  },
  {
    code: "334418",
    title: "Personal computer modems manufacturing",
  },
  {
    code: "334418",
    title: "Plotter controller boards manufacturing",
  },
  {
    code: "334418",
    title: "Printed circuit assemblies manufacturing",
  },
  {
    code: "334418",
    title: "Printed circuit boards loading",
  },
  {
    code: "334419",
    title: "Cathode ray tubes (CRT) manufacturing",
  },
  {
    code: "334419",
    title: "Computer cable sets (e.g., monitor, printer) manufacturing",
  },
  {
    code: "334419",
    title: "CRT (cathode ray tube) manufacturing",
  },
  {
    code: "334419",
    title: "Crystals and crystal assemblies, electronic, manufacturing",
  },
  {
    code: "334419",
    title:
      "Electron tube parts (e.g., bases, getters, guns) (except glass blanks) manufacturing",
  },
  {
    code: "334419",
    title: "Electron tubes manufacturing",
  },
  {
    code: "334419",
    title: "Filters, electronic component-type, manufacturing",
  },
  {
    code: "334419",
    title: "Harness assemblies for electronic use manufacturing",
  },
  {
    code: "334419",
    title: "Heads (e.g., recording, read/write) manufacturing",
  },
  {
    code: "334419",
    title: "Klystron tubes manufacturing",
  },
  {
    code: "334419",
    title: "LCD (liquid crystal display) unit screens manufacturing",
  },
  {
    code: "334419",
    title: "Magnetron tubes manufacturing",
  },
  {
    code: "334419",
    title: "Microwave components manufacturing",
  },
  {
    code: "334419",
    title: "Needles, phonograph and styli, manufacturing",
  },
  {
    code: "334419",
    title: "Piezoelectric crystals manufacturing",
  },
  {
    code: "334419",
    title: "Piezoelectric devices manufacturing",
  },
  {
    code: "334419",
    title: "Printed circuit laminates manufacturing",
  },
  {
    code: "334419",
    title: "Quartz crystals, electronic application, manufacturing",
  },
  {
    code: "334419",
    title: "Radio frequency identification (RFID) devices manufacturing",
  },
  {
    code: "334419",
    title:
      "Rectifiers, electronic component-type (except semiconductor), manufacturing",
  },
  {
    code: "334419",
    title: "Resonant reed devices, electronic, manufacturing",
  },
  {
    code: "334419",
    title: "Rheostats, electronic, manufacturing",
  },
  {
    code: "334419",
    title: "Screens for liquid crystal display (LCD) manufacturing",
  },
  {
    code: "334419",
    title: "Solenoids for electronic applications manufacturing",
  },
  {
    code: "334419",
    title: "Switches for electronic applications manufacturing",
  },
  {
    code: "334419",
    title: "Television picture tubes manufacturing",
  },
  {
    code: "334419",
    title: "Transducers (except pressure) manufacturing",
  },
  {
    code: "334419",
    title: "Traveling wave tubes manufacturing",
  },
  {
    code: "334419",
    title: "Tubes, cathode ray, manufacturing",
  },
  {
    code: "334419",
    title: "Tubes, electron, manufacturing",
  },
  {
    code: "334419",
    title: "Tubes, electronic, manufacturing",
  },
  {
    code: "334419",
    title: "Tubes, klystron, manufacturing",
  },
  {
    code: "334419",
    title: "Vacuum tubes manufacturing",
  },
  {
    code: "334510",
    title:
      "Arc lamp units, electrotherapeutic (except infrared, ultraviolet), manufacturing",
  },
  {
    code: "334510",
    title: "Audiological equipment, electromedical, manufacturing",
  },
  {
    code: "334510",
    title:
      "Automated blood and body fluid analyzers (except laboratory) manufacturing",
  },
  {
    code: "334510",
    title: "Bronchoscopes, electromedical, manufacturing",
  },
  {
    code: "334510",
    title:
      "Carbon arc lamp units, electrotherapeutic (except infrared and ultraviolet), manufacturing",
  },
  {
    code: "334510",
    title: "Cardiodynameter manufacturing",
  },
  {
    code: "334510",
    title: "Cardiographs manufacturing",
  },
  {
    code: "334510",
    title: "Cardiophone, electric, manufacturing",
  },
  {
    code: "334510",
    title: "Cardioscope manufacturing",
  },
  {
    code: "334510",
    title: "Cardiotachometer manufacturing",
  },
  {
    code: "334510",
    title: "Colonscopes, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Cystoscopes, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Defibrillators manufacturing",
  },
  {
    code: "334510",
    title: "Diagnostic equipment, electromedical, manufacturing",
  },
  {
    code: "334510",
    title:
      "Diagnostic equipment, MRI (magnetic resonance imaging), manufacturing",
  },
  {
    code: "334510",
    title: "Dialysis equipment, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Diathermy apparatus, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Diathermy units manufacturing",
  },
  {
    code: "334510",
    title: "Electrocardiographs manufacturing",
  },
  {
    code: "334510",
    title: "Electroencephalographs manufacturing",
  },
  {
    code: "334510",
    title: "Electrogastrograph manufacturing",
  },
  {
    code: "334510",
    title: "Electromedical diagnostic equipment manufacturing",
  },
  {
    code: "334510",
    title: "Electromedical equipment manufacturing",
  },
  {
    code: "334510",
    title: "Electromedical therapy equipment manufacturing",
  },
  {
    code: "334510",
    title: "Electromyographs manufacturing",
  },
  {
    code: "334510",
    title: "Electrosurgical units manufacturing",
  },
  {
    code: "334510",
    title: "Electrotherapeutic apparatus manufacturing",
  },
  {
    code: "334510",
    title: "Electrotherapy units manufacturing",
  },
  {
    code: "334510",
    title:
      "Endoscopic equipment, electromedical (e.g., bronchoscopes, colonoscopes, cystoscopes), manufacturing",
  },
  {
    code: "334510",
    title: "Gastroscopes, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Hearing aids, electronic, manufacturing",
  },
  {
    code: "334510",
    title: "Heart-lung machine manufacturing",
  },
  {
    code: "334510",
    title: "Laser equipment, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Laser systems and equipment, medical, manufacturing",
  },
  {
    code: "334510",
    title: "Lithotripters manufacturing",
  },
  {
    code: "334510",
    title:
      "Magnetic resonance imaging (MRI) medical diagnostic equipment manufacturing",
  },
  {
    code: "334510",
    title: "Medical cleaning equipment, ultrasonic, manufacturing",
  },
  {
    code: "334510",
    title: "Medical ultrasound equipment manufacturing",
  },
  {
    code: "334510",
    title:
      "MRI (magnetic resonance imaging) medical diagnostic equipment manufacturing",
  },
  {
    code: "334510",
    title: "Otoscopes, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Pacemakers manufacturing",
  },
  {
    code: "334510",
    title:
      "Patient monitoring equipment (e.g., intensive care, coronary care unit) manufacturing",
  },
  {
    code: "334510",
    title: "PET (positron emission tomography) scanners manufacturing",
  },
  {
    code: "334510",
    title: "Phonocardiographs manufacturing",
  },
  {
    code: "334510",
    title: "Positron emission tomography (PET) scanners manufacturing",
  },
  {
    code: "334510",
    title: "Probes, electric medical, manufacturing",
  },
  {
    code: "334510",
    title: "Respiratory analysis equipment, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Retinoscopes, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "Sentinel, cardiac, manufacturing",
  },
  {
    code: "334510",
    title: "Surgical support systems, electromedical, manufacturing",
  },
  {
    code: "334510",
    title: "TENS (transcutaneous electrical nerve stimulator) manufacturing",
  },
  {
    code: "334510",
    title: "Transcutaneous electrical nerve stimulators (TENS) manufacturing",
  },
  {
    code: "334510",
    title: "Ultrasonic medical equipment manufacturing",
  },
  {
    code: "334510",
    title: "Ultrasonic scanning devices, medical, manufacturing",
  },
  {
    code: "334510",
    title: "Ventilators, electromedical, manufacturing",
  },
  {
    code: "334511",
    title:
      "Acceleration indicators and systems components, aerospace type, manufacturing",
  },
  {
    code: "334511",
    title: "Aeronautical systems and instruments manufacturing",
  },
  {
    code: "334511",
    title:
      "Aeronautical systems and instruments overhauling, conversion, or rebuilding",
  },
  {
    code: "334511",
    title: "Air traffic control radar systems and equipment manufacturing",
  },
  {
    code: "334511",
    title: "Airborne navigational systems manufacturing",
  },
  {
    code: "334511",
    title:
      "Aircraft flight instruments (except engine instruments) manufacturing",
  },
  {
    code: "334511",
    title: "Airframe equipment instruments manufacturing",
  },
  {
    code: "334511",
    title: "Airspeed instruments (aeronautical) manufacturing",
  },
  {
    code: "334511",
    title: "Altimeters, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title: "Angle-of-attack instrumentation manufacturing",
  },
  {
    code: "334511",
    title: "Angle-of-yaw instrumentation manufacturing",
  },
  {
    code: "334511",
    title: "Artificial horizon instrumentation manufacturing",
  },
  {
    code: "334511",
    title:
      "Bank and turn indicators and components (aeronautical instruments) manufacturing",
  },
  {
    code: "334511",
    title:
      "Cabin environment indicators, transmitters, and sensors manufacturing",
  },
  {
    code: "334511",
    title:
      "Compasses, gyroscopic and magnetic (except portable), manufacturing",
  },
  {
    code: "334511",
    title:
      "Countermeasure sets (e.g., active countermeasures, jamming equipment) manufacturing",
  },
  {
    code: "334511",
    title: "Distance measuring equipment (DME), aeronautical, manufacturing",
  },
  {
    code: "334511",
    title: "Driftmeters, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title: "Electronic guidance systems and equipment manufacturing",
  },
  {
    code: "334511",
    title: "Fathometers manufacturing",
  },
  {
    code: "334511",
    title: "Fish finders (i.e., sonar) manufacturing",
  },
  {
    code: "334511",
    title:
      "Flight and navigation sensors, transmitters, and displays manufacturing",
  },
  {
    code: "334511",
    title: "Flight recorders (i.e., black boxes) manufacturing",
  },
  {
    code: "334511",
    title: "Glide slope instrumentation manufacturing",
  },
  {
    code: "334511",
    title: "Gyrocompasses manufacturing",
  },
  {
    code: "334511",
    title: "Gyrogimbals manufacturing",
  },
  {
    code: "334511",
    title: "Gyroscopes manufacturing",
  },
  {
    code: "334511",
    title: "Heads-up display (HUD) systems, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title: "Horizon situation instrumentation manufacturing",
  },
  {
    code: "334511",
    title: "HUD (heads-up display) systems, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title: "Hydrophones manufacturing",
  },
  {
    code: "334511",
    title: "Inertial navigation systems, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title: "Infrared homing systems, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title:
      "Instrument landing system instrumentation, airborne or airport, manufacturing",
  },
  {
    code: "334511",
    title: "Instruments, aeronautical, manufacturing",
  },
  {
    code: "334511",
    title:
      "Light reconnaissance and surveillance systems and equipment manufacturing",
  },
  {
    code: "334511",
    title: "Machmeters manufacturing",
  },
  {
    code: "334511",
    title: "Nautical systems and  instruments manufacturing",
  },
  {
    code: "334511",
    title: "Navigational instruments manufacturing",
  },
  {
    code: "334511",
    title: "Omnibearing instrumentation manufacturing",
  },
  {
    code: "334511",
    title: "Pictorial situation instrumentation manufacturing",
  },
  {
    code: "334511",
    title:
      "Position indicators (e.g., for landing gear, stabilizers), airframe equipment, manufacturing",
  },
  {
    code: "334511",
    title:
      "Proximity warning (i.e., collision avoidance) equipment manufacturing",
  },
  {
    code: "334511",
    title: "Radar detectors manufacturing",
  },
  {
    code: "334511",
    title: "Radar systems and equipment manufacturing",
  },
  {
    code: "334511",
    title: "Radio magnetic instrumentation (RMI) manufacturing",
  },
  {
    code: "334511",
    title: "Rate-of-climb instrumentation manufacturing",
  },
  {
    code: "334511",
    title: "Search and detection systems and instruments manufacturing",
  },
  {
    code: "334511",
    title: "Sextants (except surveying) manufacturing",
  },
  {
    code: "334511",
    title: "Sonabuoys manufacturing",
  },
  {
    code: "334511",
    title: "Sonar fish finders manufacturing",
  },
  {
    code: "334511",
    title: "Sonar systems and equipment manufacturing",
  },
  {
    code: "334511",
    title: "Space vehicle guidance systems and equipment manufacturing",
  },
  {
    code: "334511",
    title:
      "Speed, pitch, and roll navigational instruments and systems manufacturing",
  },
  {
    code: "334511",
    title: "Taffrail logs manufacturing",
  },
  {
    code: "334511",
    title: "Underwater navigational systems manufacturing",
  },
  {
    code: "334511",
    title: "Warfare countermeasures equipment manufacturing",
  },
  {
    code: "334511",
    title:
      "Wheel position indicators and transmitters, aircraft, manufacturing",
  },
  {
    code: "334512",
    title:
      "Air flow controllers (except valves), air-conditioning and refrigeration, manufacturing",
  },
  {
    code: "334512",
    title: "Appliance controls manufacturing",
  },
  {
    code: "334512",
    title: "Appliance regulators (except switches) manufacturing",
  },
  {
    code: "334512",
    title: "Building services monitoring controls, automatic, manufacturing",
  },
  {
    code: "334512",
    title: "Clothes dryer controls, including dryness controls, manufacturing",
  },
  {
    code: "334512",
    title: "Combination limit and fan controls manufacturing",
  },
  {
    code: "334512",
    title: "Combination oil and hydronic controls manufacturing",
  },
  {
    code: "334512",
    title:
      "Computerized environmental control systems for buildings manufacturing",
  },
  {
    code: "334512",
    title:
      "Damper operators (e.g., electric, pneumatic, thermostatic) manufacturing",
  },
  {
    code: "334512",
    title: "Electric air cleaner controls, automatic, manufacturing",
  },
  {
    code: "334512",
    title:
      "Electric heat proportioning controls, modulating controls, manufacturing",
  },
  {
    code: "334512",
    title: "Electric space heater controls, automatic, manufacturing",
  },
  {
    code: "334512",
    title:
      "Energy cutoff controls, residential and commercial types, manufacturing",
  },
  {
    code: "334512",
    title: "Fan controls, temperature responsive, manufacturing",
  },
  {
    code: "334512",
    title: "Flame safety controls for furnaces and boilers manufacturing",
  },
  {
    code: "334512",
    title: "Float controls, residential and commercial types, manufacturing",
  },
  {
    code: "334512",
    title: "Gas burner automatic controls (except valves) manufacturing",
  },
  {
    code: "334512",
    title: "Gradual switches, pneumatic, manufacturing",
  },
  {
    code: "334512",
    title:
      "Heating and cooling system controls, residential and commercial, manufacturing",
  },
  {
    code: "334512",
    title: "Heating regulators manufacturing",
  },
  {
    code: "334512",
    title: "Humidistats (e.g., duct, skeleton, wall) manufacturing",
  },
  {
    code: "334512",
    title: "Humidity controls, air-conditioning-type, manufacturing",
  },
  {
    code: "334512",
    title: "Hydronic circulator control, automatic, manufacturing",
  },
  {
    code: "334512",
    title: "Hydronic limit control manufacturing",
  },
  {
    code: "334512",
    title: "Hydronic limit, pressure, and temperature controls, manufacturing",
  },
  {
    code: "334512",
    title: "Ice bank controls manufacturing",
  },
  {
    code: "334512",
    title: "Ice maker controls manufacturing",
  },
  {
    code: "334512",
    title:
      "Ignition controls for gas appliances and furnaces, automatic, manufacturing",
  },
  {
    code: "334512",
    title:
      "In-built thermostats, filled system and bimetal types, manufacturing",
  },
  {
    code: "334512",
    title:
      "Incinerator control systems, residential and commercial-type, manufacturing",
  },
  {
    code: "334512",
    title: "Light responsive appliance controls manufacturing",
  },
  {
    code: "334512",
    title:
      "Limit controls (e.g., air-conditioning, appliance, heating) manufacturing",
  },
  {
    code: "334512",
    title: "Line or limit control for electric heat manufacturing",
  },
  {
    code: "334512",
    title:
      "Liquid level controls, residential and commercial heating-type, manufacturing",
  },
  {
    code: "334512",
    title: "Oven temperature controls, nonindustrial, manufacturing",
  },
  {
    code: "334512",
    title: "Pneumatic relays, air-conditioning-type, manufacturing",
  },
  {
    code: "334512",
    title: "Pressure controllers, air-conditioning system-type, manufacturing",
  },
  {
    code: "334512",
    title: "Pressurestats manufacturing",
  },
  {
    code: "334512",
    title:
      "Primary oil burner controls (e.g., cadmium cells, stack controls) manufacturing",
  },
  {
    code: "334512",
    title:
      "Refrigeration controls, residential and commercial-type, manufacturing",
  },
  {
    code: "334512",
    title: "Refrigeration thermostats manufacturing",
  },
  {
    code: "334512",
    title: "Refrigeration/air-conditioning defrost controls manufacturing",
  },
  {
    code: "334512",
    title: "Room thermostats manufacturing",
  },
  {
    code: "334512",
    title: "Sequencing controls for electric heating equipment manufacturing",
  },
  {
    code: "334512",
    title: "Static pressure regulators manufacturing",
  },
  {
    code: "334512",
    title:
      "Steam pressure controls, residential and commercial heating-type, manufacturing",
  },
  {
    code: "334512",
    title: "Surface burner controls, temperature, manufacturing",
  },
  {
    code: "334512",
    title: "Switches, pneumatic positioning remote, manufacturing",
  },
  {
    code: "334512",
    title: "Switches, thermostatic, manufacturing",
  },
  {
    code: "334512",
    title:
      "Temperature controls, automatic, residential and commercial-types, manufacturing",
  },
  {
    code: "334512",
    title: "Temperature sensors for motor windings manufacturing",
  },
  {
    code: "334512",
    title: "Thermocouples, glass vacuum, manufacturing",
  },
  {
    code: "334512",
    title:
      "Thermostats (e.g., air-conditioning, appliance, comfort heating, refrigeration) manufacturing",
  },
  {
    code: "334512",
    title: "Time program controls, air-conditioning systems, manufacturing",
  },
  {
    code: "334512",
    title: "Vapor heating controls manufacturing",
  },
  {
    code: "334512",
    title: "Water heater controls manufacturing",
  },
  {
    code: "334513",
    title:
      "Absorption analyzers, industrial process type (e.g., infrared), manufacturing",
  },
  {
    code: "334513",
    title:
      "Acidity (i.e., pH) instruments, industrial process type, manufacturing",
  },
  {
    code: "334513",
    title: "Analyzers, industrial process control type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Annunciators, relay and solid-state types, industrial display, manufacturing",
  },
  {
    code: "334513",
    title: "Boiler controls, industrial, power, and marine-type, manufacturing",
  },
  {
    code: "334513",
    title: "Buoyancy instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Chromatographs, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Combustion control instruments (except commercial, household furnace-type) manufacturing",
  },
  {
    code: "334513",
    title:
      "Controllers for process variables (e.g., electric, electronic, mechanical, pneumatic operation) manufacturing",
  },
  {
    code: "334513",
    title: "Coulometric analyzers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Data loggers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Density and specific gravity instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Differential pressure instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Digital displays of process variables manufacturing",
  },
  {
    code: "334513",
    title:
      "Display instruments, industrial process control-type, manufacturing",
  },
  {
    code: "334513",
    title: "Draft gauges, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Electric and electronic controllers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Electrodes used in industrial process measurement manufacturing",
  },
  {
    code: "334513",
    title:
      "Electrolytic conductivity instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Electromagnetic flowmeters manufacturing",
  },
  {
    code: "334513",
    title: "Flow instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Fluidic devices, circuits, and systems for process control, manufacturing",
  },
  {
    code: "334513",
    title: "Gas analyzers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Gas and liquid analysis instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Gas chromatographic instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Gas flow instrumentation, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Gauges (i.e., analog, digital), industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Humidity instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Hydrometers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Hygrometers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Indicators, industrial process control-type, manufacturing",
  },
  {
    code: "334513",
    title: "Industrial process control instruments manufacturing",
  },
  {
    code: "334513",
    title: "Infrared instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Instruments for industrial process control manufacturing",
  },
  {
    code: "334513",
    title:
      "Level and bulk measuring instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Liquid analysis instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Liquid concentration instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Liquid level instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Magnetic flow meters, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Manometers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Measuring instruments, industrial process control-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Mechanical measuring instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Meters, industrial process control-type, manufacturing",
  },
  {
    code: "334513",
    title: "Moisture meters, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Nanofluidic measurement and control devices manufacturing",
  },
  {
    code: "334513",
    title:
      "Panelboard indicators, recorders, and controllers, receiver industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Pneumatic controllers, industrial process type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Potentiometric instruments (except X-Y recorders), industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Pressure gauges (e.g., dial, digital), industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Pressure instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Primary elements for process flow measurement (i.e., orifice plates) manufacturing",
  },
  {
    code: "334513",
    title: "Primary process temperature sensors manufacturing",
  },
  {
    code: "334513",
    title: "Process control instruments, industrial, manufacturing",
  },
  {
    code: "334513",
    title: "Programmers, process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Pyrometers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Recorders, industrial process control-type, manufacturing",
  },
  {
    code: "334513",
    title: "Refractometers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Resistance thermometers and bulbs, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Telemetering instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Temperature instruments, industrial process-type (except glass and bimetal thermometers), manufacturing",
  },
  {
    code: "334513",
    title:
      "Thermal conductivity instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Thermistors, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Thermocouples, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Thermometers, filled system industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Time cycle and program controllers, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Transmitters, industrial process control-type, manufacturing",
  },
  {
    code: "334513",
    title: "Turbidity instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Turbine flow meters, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title:
      "Variable control instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Viscosimeters, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Viscosity instruments, industrial process-type, manufacturing",
  },
  {
    code: "334513",
    title: "Water quality monitoring and control systems manufacturing",
  },
  {
    code: "334514",
    title: "Consumption meters (e.g., gas, water) manufacturing",
  },
  {
    code: "334514",
    title: "Controls, revolution and timing instruments, manufacturing",
  },
  {
    code: "334514",
    title: "Counter type registers manufacturing",
  },
  {
    code: "334514",
    title:
      "Counters (e.g., electrical, electronic, mechanical), totalizing, manufacturing",
  },
  {
    code: "334514",
    title: "Counters, revolution, manufacturing",
  },
  {
    code: "334514",
    title: "Counting devices manufacturing",
  },
  {
    code: "334514",
    title: "Electromechanical counters manufacturing",
  },
  {
    code: "334514",
    title: "Electronic totalizing counters manufacturing",
  },
  {
    code: "334514",
    title: "Fare collection equipment manufacturing",
  },
  {
    code: "334514",
    title: "Gasmeters, consumption registering, manufacturing",
  },
  {
    code: "334514",
    title: "Gasmeters, large capacity, domestic and industrial, manufacturing",
  },
  {
    code: "334514",
    title: "Gasoline dispensing meters (except pumps) manufacturing",
  },
  {
    code: "334514",
    title:
      "Gauges (e.g., oil pressure, water temperature, speedometer, tachometer), motor vehicle, manufacturing",
  },
  {
    code: "334514",
    title:
      "Gauges for computing pressure-temperature corrections manufacturing",
  },
  {
    code: "334514",
    title: "Impeller and counter driven flow meters manufacturing",
  },
  {
    code: "334514",
    title:
      "Instrument panels, assembling gauges made in the same establishment",
  },
  {
    code: "334514",
    title: "Integrating meters, nonelectric, manufacturing",
  },
  {
    code: "334514",
    title: "Linear counters manufacturing",
  },
  {
    code: "334514",
    title: "Liquid flow meters manufacturing",
  },
  {
    code: "334514",
    title: "Magnetic counters manufacturing",
  },
  {
    code: "334514",
    title: "Measuring wheels manufacturing",
  },
  {
    code: "334514",
    title:
      "Metering devices (except electrical and industrial process control) manufacturing",
  },
  {
    code: "334514",
    title:
      "Meters (except electrical and industrial process control) manufacturing",
  },
  {
    code: "334514",
    title: "Meters, parking, manufacturing",
  },
  {
    code: "334514",
    title:
      "Motor vehicle instruments (e.g., fuel level gauges, oil pressure, speedometers, tachometers, water temperature) manufacturing",
  },
  {
    code: "334514",
    title: "Parking meters manufacturing",
  },
  {
    code: "334514",
    title: "Pedometers manufacturing",
  },
  {
    code: "334514",
    title: "Positive displacement meters manufacturing",
  },
  {
    code: "334514",
    title: "Predetermined counters manufacturing",
  },
  {
    code: "334514",
    title: "Production counters manufacturing",
  },
  {
    code: "334514",
    title: "Propeller type meters with registers manufacturing",
  },
  {
    code: "334514",
    title: "Registers, linear tallying, manufacturing",
  },
  {
    code: "334514",
    title: "Rotary type meters, consumption registering, manufacturing",
  },
  {
    code: "334514",
    title: "Tally counters manufacturing",
  },
  {
    code: "334514",
    title:
      "Tallying meters (except clocks, electricity meters, watches) manufacturing",
  },
  {
    code: "334514",
    title: "Tank truck meters manufacturing",
  },
  {
    code: "334514",
    title: "Taximeters manufacturing",
  },
  {
    code: "334514",
    title: "Totalizing fluid meters manufacturing",
  },
  {
    code: "334514",
    title:
      "Totalizing meters (except aircraft), consumption registering, manufacturing",
  },
  {
    code: "334514",
    title: "Turbine meters, consumption registering, manufacturing",
  },
  {
    code: "334514",
    title: "Watermeters, consumption registering, manufacturing",
  },
  {
    code: "334515",
    title: "Alternator and generator testers manufacturing",
  },
  {
    code: "334515",
    title: "Ampere-hour meters manufacturing",
  },
  {
    code: "334515",
    title: "Analyzers for testing electrical characteristics manufacturing",
  },
  {
    code: "334515",
    title: "Audiofrequency oscillators manufacturing",
  },
  {
    code: "334515",
    title: "Audiometers (except medical) manufacturing",
  },
  {
    code: "334515",
    title: "Automotive ammeters and voltmeters manufacturing",
  },
  {
    code: "334515",
    title: "Automotive electrical engine diagnostic equipment manufacturing",
  },
  {
    code: "334515",
    title: "Battery testers, electrical, manufacturing",
  },
  {
    code: "334515",
    title:
      "Bridges, electrical (e.g., Kelvin, megohm, vacuum tube, Wheatstone), manufacturing",
  },
  {
    code: "334515",
    title: "Circuit testers manufacturing",
  },
  {
    code: "334515",
    title:
      "Communications signal testing and evaluation equipment manufacturing",
  },
  {
    code: "334515",
    title: "Current measuring equipment manufacturing",
  },
  {
    code: "334515",
    title:
      "Decade boxes (i.e., capacitance, inductance, resistance) manufacturing",
  },
  {
    code: "334515",
    title: "Demand meters, electric, manufacturing",
  },
  {
    code: "334515",
    title: "Digital panel meters, electricity measuring, manufacturing",
  },
  {
    code: "334515",
    title:
      "Digital test equipment (e.g., electronic and electrical circuits and equipment testing) manufacturing",
  },
  {
    code: "334515",
    title: "Diode and transistor testers manufacturing",
  },
  {
    code: "334515",
    title: "Distortion meters and analyzers manufacturing",
  },
  {
    code: "334515",
    title: "Elapsed time meters, electronic, manufacturing",
  },
  {
    code: "334515",
    title: "Electrical network analyzers manufacturing",
  },
  {
    code: "334515",
    title: "Electrical power measuring equipment manufacturing",
  },
  {
    code: "334515",
    title:
      "Electricity and electrical signal measuring instruments manufacturing",
  },
  {
    code: "334515",
    title: "Electricity and electrical signal testing equipment manufacturing",
  },
  {
    code: "334515",
    title: "Electron tube test equipment manufacturing",
  },
  {
    code: "334515",
    title:
      "Electronic test equipment for testing electrical characteristics manufacturing",
  },
  {
    code: "334515",
    title: "Energy measuring equipment, electrical, manufacturing",
  },
  {
    code: "334515",
    title:
      "Field strength and intensity measuring equipment, electrical, manufacturing",
  },
  {
    code: "334515",
    title:
      "Frequency meters (e.g., electrical, electronic, mechanical) manufacturing",
  },
  {
    code: "334515",
    title: "Frequency synthesizers manufacturing",
  },
  {
    code: "334515",
    title: "Function generators manufacturing",
  },
  {
    code: "334515",
    title: "Galvanometers (except geophysical) manufacturing",
  },
  {
    code: "334515",
    title: "Graphic recording meters, electric, manufacturing",
  },
  {
    code: "334515",
    title: "Ignition testing instruments manufacturing",
  },
  {
    code: "334515",
    title: "Impedance measuring equipment manufacturing",
  },
  {
    code: "334515",
    title: "Indicating instruments, electric, manufacturing",
  },
  {
    code: "334515",
    title: "Instrument shunts manufacturing",
  },
  {
    code: "334515",
    title: "Instruments for measuring electrical quantities manufacturing",
  },
  {
    code: "334515",
    title:
      "Instruments, electric (i.e., testing electrical characteristics), manufacturing",
  },
  {
    code: "334515",
    title: "Integrated-circuit testers manufacturing",
  },
  {
    code: "334515",
    title: "Integrating electricity meters manufacturing",
  },
  {
    code: "334515",
    title:
      "Internal combustion engine analyzers (i.e., testing electrical characteristics) manufacturing",
  },
  {
    code: "334515",
    title:
      "Kelvin bridges (i.e., electrical measuring instruments) manufacturing",
  },
  {
    code: "334515",
    title:
      "Laboratory standards testing instruments (e.g., capacitance, electrical resistance, inductance) manufacturing",
  },
  {
    code: "334515",
    title: "Logic circuit testers manufacturing",
  },
  {
    code: "334515",
    title:
      "Measuring equipment for electronic and electrical circuits and equipment manufacturing",
  },
  {
    code: "334515",
    title: "Measuring instruments and meters, electric, manufacturing",
  },
  {
    code: "334515",
    title:
      "Meters, electrical (i.e., graphic recording, panelboard, pocket, portable), manufacturing",
  },
  {
    code: "334515",
    title: "Meters, power factor and phase angle, manufacturing",
  },
  {
    code: "334515",
    title: "Microwave test equipment manufacturing",
  },
  {
    code: "334515",
    title: "Multimeters manufacturing",
  },
  {
    code: "334515",
    title: "Ohmmeters manufacturing",
  },
  {
    code: "334515",
    title:
      "Oscillators (e.g., instrument type audiofrequency and radiofrequency) manufacturing",
  },
  {
    code: "334515",
    title: "Oscilloscopes manufacturing",
  },
  {
    code: "334515",
    title: "Phase angle meters manufacturing",
  },
  {
    code: "334515",
    title: "Portable test meters manufacturing",
  },
  {
    code: "334515",
    title:
      "Potentiometric instruments (except industrial process-type) manufacturing",
  },
  {
    code: "334515",
    title: "Power factor meters manufacturing",
  },
  {
    code: "334515",
    title: "Power measuring equipment, electrical, manufacturing",
  },
  {
    code: "334515",
    title: "Pulse (i.e., signal) generators manufacturing",
  },
  {
    code: "334515",
    title: "Radar testing instruments, electric, manufacturing",
  },
  {
    code: "334515",
    title: "Radiofrequency measuring equipment manufacturing",
  },
  {
    code: "334515",
    title: "Radiofrequency oscillators manufacturing",
  },
  {
    code: "334515",
    title: "Recorders, oscillographic, manufacturing",
  },
  {
    code: "334515",
    title: "Relays (except electrical, electronic), instrument, manufacturing",
  },
  {
    code: "334515",
    title: "Resistance measuring equipment manufacturing",
  },
  {
    code: "334515",
    title: "Semiconductor test equipment manufacturing",
  },
  {
    code: "334515",
    title: "Shunts, instrument, manufacturing",
  },
  {
    code: "334515",
    title: "Signal generators and averagers manufacturing",
  },
  {
    code: "334515",
    title: "Spark plug testing instruments, electric, manufacturing",
  },
  {
    code: "334515",
    title: "Spectrum analyzers manufacturing",
  },
  {
    code: "334515",
    title:
      "Standards and calibration equipment for electrical measuring manufacturing",
  },
  {
    code: "334515",
    title: "Standing wave ratio measuring equipment manufacturing",
  },
  {
    code: "334515",
    title: "Stroboscopes manufacturing",
  },
  {
    code: "334515",
    title: "Sweep generators manufacturing",
  },
  {
    code: "334515",
    title: "Sweep oscillators manufacturing",
  },
  {
    code: "334515",
    title: "Synchroscopes manufacturing",
  },
  {
    code: "334515",
    title: "Tachometer generators manufacturing",
  },
  {
    code: "334515",
    title:
      "Test equipment for electronic and electrical circuits and equipment manufacturing",
  },
  {
    code: "334515",
    title: "Test sets, ignition harness, manufacturing",
  },
  {
    code: "334515",
    title: "Voltmeters manufacturing",
  },
  {
    code: "334515",
    title: "Watt-hour and demand meters, combined, manufacturing",
  },
  {
    code: "334515",
    title: "Watt-hour and time switch meters, combined, manufacturing",
  },
  {
    code: "334515",
    title: "Watt-hour meters, electric, manufacturing",
  },
  {
    code: "334515",
    title: "Wattmeters manufacturing",
  },
  {
    code: "334515",
    title: "Waveform measuring and/or analyzing equipment manufacturing",
  },
  {
    code: "334515",
    title:
      "Wheatstone bridges (i.e., electrical measuring instruments) manufacturing",
  },
  {
    code: "334515",
    title:
      "X-Y recorders (i.e., plotters (except computer peripheral equipment)) manufacturing",
  },
  {
    code: "334516",
    title:
      "Acidity (i.e., pH) measuring equipment, laboratory analysis-type, manufacturing",
  },
  {
    code: "334516",
    title: "Amino acid analyzers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Atomic force microscopes manufacturing",
  },
  {
    code: "334516",
    title: "Automatic chemical analyzers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Blood bank process equipment manufacturing",
  },
  {
    code: "334516",
    title: "Chromatographic instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Chronoscopes manufacturing",
  },
  {
    code: "334516",
    title: "Colorimeters, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Coulometric analyzers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Densitometers, laboratory analytical, manufacturing",
  },
  {
    code: "334516",
    title:
      "Differential thermal analysis instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title:
      "Electrolytic conductivity instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Electron microprobes, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Electron microscopes manufacturing",
  },
  {
    code: "334516",
    title: "Electron paramagnetic spin-type apparatus manufacturing",
  },
  {
    code: "334516",
    title: "Electrophoresis instruments manufacturing",
  },
  {
    code: "334516",
    title: "Elemental analyzers manufacturing",
  },
  {
    code: "334516",
    title: "Flame photometers manufacturing",
  },
  {
    code: "334516",
    title: "Gas analyzers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Gas chromatographic instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Hematology instruments manufacturing",
  },
  {
    code: "334516",
    title: "Immunology instruments, laboratory, manufacturing",
  },
  {
    code: "334516",
    title: "Infrared analytical instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Laboratory analytical instruments (except optical) manufacturing",
  },
  {
    code: "334516",
    title: "Liquid chromatographic instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title:
      "Magnetic resonance imaging (MRI) type apparatus (except medical diagnostic) manufacturing",
  },
  {
    code: "334516",
    title: "Mass spectrometers manufacturing",
  },
  {
    code: "334516",
    title: "Mass spectroscopy instrumentation manufacturing",
  },
  {
    code: "334516",
    title: "Microbiology instruments manufacturing",
  },
  {
    code: "334516",
    title: "Microprobes (e.g., electron, ion, laser, X-ray) manufacturing",
  },
  {
    code: "334516",
    title: "Microscopes, electron and proton, manufacturing",
  },
  {
    code: "334516",
    title: "Moisture analyzers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Monochrometers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Nanomanipulator equipment manufacturing",
  },
  {
    code: "334516",
    title: "Nanosensor instruments manufacturing",
  },
  {
    code: "334516",
    title: "Nephelometers (except meteorological) manufacturing",
  },
  {
    code: "334516",
    title: "Neutron activation analysis instruments manufacturing",
  },
  {
    code: "334516",
    title: "Osmometers manufacturing",
  },
  {
    code: "334516",
    title:
      "Particle beam excitation instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Particle size analyzers manufacturing",
  },
  {
    code: "334516",
    title: "Photometers (except photographic exposure meters) manufacturing",
  },
  {
    code: "334516",
    title: "Photonexcitation analyzers manufacturing",
  },
  {
    code: "334516",
    title: "Polariscopes manufacturing",
  },
  {
    code: "334516",
    title: "Polarizers manufacturing",
  },
  {
    code: "334516",
    title: "Polarographic equipment manufacturing",
  },
  {
    code: "334516",
    title: "Protein analyzers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title:
      "Redox (i.e., oxidation-reduction potential) instruments manufacturing",
  },
  {
    code: "334516",
    title: "Refractometers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Resonance instruments (i.e., laboratory-type) manufacturing",
  },
  {
    code: "334516",
    title: "Sample analysis instruments (except medical) manufacturing",
  },
  {
    code: "334516",
    title: "Scanning tunneling microscopes manufacturing",
  },
  {
    code: "334516",
    title: "Specific ion measuring instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Spectrofluorometers manufacturing",
  },
  {
    code: "334516",
    title: "Spectrographs manufacturing",
  },
  {
    code: "334516",
    title:
      "Spectrometers (e.g., electron diffraction, mass, NMR, Raman) manufacturing",
  },
  {
    code: "334516",
    title:
      "Spectrophotometers (e.g., atomic absorption, atomic emission, flame, fluorescence, infrared, Raman, visible) manufacturing",
  },
  {
    code: "334516",
    title: "Surface area analyzers manufacturing",
  },
  {
    code: "334516",
    title: "Thermal analysis instruments, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Thermal conductivity instruments and sensors manufacturing",
  },
  {
    code: "334516",
    title: "Thermogravimetric analyzers manufacturing",
  },
  {
    code: "334516",
    title: "Titrimeters manufacturing",
  },
  {
    code: "334516",
    title: "Turbidometers, laboratory-type, manufacturing",
  },
  {
    code: "334516",
    title: "Ultraviolet-type analytical instruments manufacturing",
  },
  {
    code: "334517",
    title: "Beta-ray irradiation equipment manufacturing",
  },
  {
    code: "334517",
    title: "Computerized axial tomography (CT/CAT) scanners manufacturing",
  },
  {
    code: "334517",
    title: "CT/CAT (computerized axial tomography) scanners manufacturing",
  },
  {
    code: "334517",
    title: "Fluoroscopes manufacturing",
  },
  {
    code: "334517",
    title: "Fluoroscopic X-ray apparatus and tubes manufacturing",
  },
  {
    code: "334517",
    title: "Gamma-ray irradiation equipment manufacturing",
  },
  {
    code: "334517",
    title: "Generators, X-ray, manufacturing",
  },
  {
    code: "334517",
    title:
      "Irradiation apparatus and tubes (e.g., industrial, medical diagnostic, medical therapeutic, research, scientific), manufacturing",
  },
  {
    code: "334517",
    title: "Irradiation equipment manufacturing",
  },
  {
    code: "334517",
    title: "Lamps, X-ray, manufacturing",
  },
  {
    code: "334517",
    title: "Medical radiation therapy equipment manufacturing",
  },
  {
    code: "334517",
    title: "Nuclear irradiation equipment manufacturing",
  },
  {
    code: "334517",
    title: "Radium equipment manufacturing",
  },
  {
    code: "334517",
    title:
      "Therapeutic X-ray apparatus and tubes (e.g., medical, industrial, research) manufacturing",
  },
  {
    code: "334517",
    title: "Tubes, X-ray, manufacturing",
  },
  {
    code: "334517",
    title:
      "X-ray apparatus and tubes (e.g., control, industrial, medical, research) manufacturing",
  },
  {
    code: "334517",
    title: "X-ray generators manufacturing",
  },
  {
    code: "334517",
    title: "X-ray irradiation equipment manufacturing",
  },
  {
    code: "334517",
    title: "X-ray tubes manufacturing",
  },
  {
    code: "334519",
    title: "Abrasion testing machines manufacturing",
  },
  {
    code: "334519",
    title: "Accelerometers (except aerospace type) manufacturing",
  },
  {
    code: "334519",
    title: "Actinometers, meteorological, manufacturing",
  },
  {
    code: "334519",
    title: "Aircraft engine instruments manufacturing",
  },
  {
    code: "334519",
    title: "Alarm clocks manufacturing",
  },
  {
    code: "334519",
    title: "Alidades, surveying, manufacturing",
  },
  {
    code: "334519",
    title: "Appliance timers manufacturing",
  },
  {
    code: "334519",
    title: "Automotive emissions testing equipment manufacturing",
  },
  {
    code: "334519",
    title: "Barographs manufacturing",
  },
  {
    code: "334519",
    title: "Barometers manufacturing",
  },
  {
    code: "334519",
    title: "Breath alcohol testing devices manufacturing",
  },
  {
    code: "334519",
    title: "Breathalyzers manufacturing",
  },
  {
    code: "334519",
    title: "Ceilometers manufacturing",
  },
  {
    code: "334519",
    title: "Chains, surveyor's, manufacturing",
  },
  {
    code: "334519",
    title: "Chronographs manufacturing",
  },
  {
    code: "334519",
    title: "Chronometers manufacturing",
  },
  {
    code: "334519",
    title: "Clock materials and parts (except crystals) manufacturing",
  },
  {
    code: "334519",
    title: "Clock or watch springs, precision, made from purchased wire",
  },
  {
    code: "334519",
    title: "Clocks assembling",
  },
  {
    code: "334519",
    title: "Clocks assembling from purchased components",
  },
  {
    code: "334519",
    title: "Commercial timing mechanisms manufacturing",
  },
  {
    code: "334519",
    title: "Compasses, portable magnetic-type, manufacturing",
  },
  {
    code: "334519",
    title: "Count rate meters, nuclear radiation, manufacturing",
  },
  {
    code: "334519",
    title: "Dating devices and machines (except rubber stamps) manufacturing",
  },
  {
    code: "334519",
    title: "Detectors, scintillation, manufacturing",
  },
  {
    code: "334519",
    title: "Dosimetry devices manufacturing",
  },
  {
    code: "334519",
    title: "Drafting instruments manufacturing",
  },
  {
    code: "334519",
    title: "Dynamometers manufacturing",
  },
  {
    code: "334519",
    title: "Evaporation meters manufacturing",
  },
  {
    code: "334519",
    title: "Fatigue testing machines, industrial, mechanical, manufacturing",
  },
  {
    code: "334519",
    title: "Fire detector systems, nonelectric, manufacturing",
  },
  {
    code: "334519",
    title: "Fuel densitometers, aircraft engine, manufacturing",
  },
  {
    code: "334519",
    title: "Fuel mixture indicators, aircraft engine, manufacturing",
  },
  {
    code: "334519",
    title: "Fuel system instruments, aircraft, manufacturing",
  },
  {
    code: "334519",
    title: "Fuel totalizers, aircraft engine, manufacturing",
  },
  {
    code: "334519",
    title: "Galvanometers, geophysical, manufacturing",
  },
  {
    code: "334519",
    title: "Gas leak detectors manufacturing",
  },
  {
    code: "334519",
    title: "Geiger counters manufacturing",
  },
  {
    code: "334519",
    title: "Geophysical instruments manufacturing",
  },
  {
    code: "334519",
    title:
      "Hand stamps (e.g., date, time), timing mechanism operated, manufacturing",
  },
  {
    code: "334519",
    title: "Hardness testing equipment manufacturing",
  },
  {
    code: "334519",
    title: "Household-type timing mechanisms manufacturing",
  },
  {
    code: "334519",
    title:
      "Humidity instruments (except industrial process and air-conditioning type) manufacturing",
  },
  {
    code: "334519",
    title: "Hydrometers (except industrial process-type) manufacturing",
  },
  {
    code: "334519",
    title: "Hygrometers (except industrial process-type) manufacturing",
  },
  {
    code: "334519",
    title: "Hygrothermographs manufacturing",
  },
  {
    code: "334519",
    title: "Indicator testers, turntable, manufacturing",
  },
  {
    code: "334519",
    title: "Instrumentation for reactor controls, auxiliary, manufacturing",
  },
  {
    code: "334519",
    title: "Ion chambers manufacturing",
  },
  {
    code: "334519",
    title: "Kinematic test and measuring equipment manufacturing",
  },
  {
    code: "334519",
    title: "Leak detectors, water, manufacturing",
  },
  {
    code: "334519",
    title: "Level gauges, radiation-type, manufacturing",
  },
  {
    code: "334519",
    title: "Levels and tapes, surveying, manufacturing",
  },
  {
    code: "334519",
    title: "Lie detectors manufacturing",
  },
  {
    code: "334519",
    title: "Magnetometers manufacturing",
  },
  {
    code: "334519",
    title: "Mechanisms, clockwork operated device, manufacturing",
  },
  {
    code: "334519",
    title: "Metal detectors manufacturing",
  },
  {
    code: "334519",
    title: "Meteorologic tracking systems manufacturing",
  },
  {
    code: "334519",
    title: "Meteorological instruments manufacturing",
  },
  {
    code: "334519",
    title: "Modules for clocks and watches manufacturing",
  },
  {
    code: "334519",
    title: "Movements, watch or clock, manufacturing",
  },
  {
    code: "334519",
    title: "Nephoscopes manufacturing",
  },
  {
    code: "334519",
    title: "Nuclear instrument modules manufacturing",
  },
  {
    code: "334519",
    title: "Physical properties testing and inspection equipment manufacturing",
  },
  {
    code: "334519",
    title: "Pitometers manufacturing",
  },
  {
    code: "334519",
    title: "Polygraph machines manufacturing",
  },
  {
    code: "334519",
    title: "Pressure and vacuum indicators, aircraft engine, manufacturing",
  },
  {
    code: "334519",
    title: "Pressure transducers manufacturing",
  },
  {
    code: "334519",
    title: "Pulse analyzers, nuclear monitoring, manufacturing",
  },
  {
    code: "334519",
    title: "Pyrheliometers manufacturing",
  },
  {
    code: "334519",
    title:
      "RADIAC (radioactivity detection, identification, and computation) equipment manufacturing",
  },
  {
    code: "334519",
    title: "Radiation detection and monitoring instruments manufacturing",
  },
  {
    code: "334519",
    title:
      "Radioactivity detection, identification, and computation (RADIAC) equipment manufacturing",
  },
  {
    code: "334519",
    title: "Rain gauges manufacturing",
  },
  {
    code: "334519",
    title: "Rods, surveyor's, manufacturing",
  },
  {
    code: "334519",
    title: "Rules, slide, manufacturing",
  },
  {
    code: "334519",
    title: "Sample changers, nuclear radiation, manufacturing",
  },
  {
    code: "334519",
    title: "Scalers, nuclear radiation, manufacturing",
  },
  {
    code: "334519",
    title: "Scintillation detectors manufacturing",
  },
  {
    code: "334519",
    title: "Seismographs manufacturing",
  },
  {
    code: "334519",
    title: "Seismometers manufacturing",
  },
  {
    code: "334519",
    title: "Seismoscopes manufacturing",
  },
  {
    code: "334519",
    title: "Sextants, surveying, manufacturing",
  },
  {
    code: "334519",
    title: "Solarimeters manufacturing",
  },
  {
    code: "334519",
    title: "Spectrometers (e.g., liquid scintillation, nuclear) manufacturing",
  },
  {
    code: "334519",
    title: "Springs, clock and watch, made from purchased wire",
  },
  {
    code: "334519",
    title: "Surveying instruments manufacturing",
  },
  {
    code: "334519",
    title: "Tapes, surveyor's, manufacturing",
  },
  {
    code: "334519",
    title: "Templates, drafting, manufacturing",
  },
  {
    code: "334519",
    title: "Tensile strength testing equipment manufacturing",
  },
  {
    code: "334519",
    title: "Testers for checking hydraulic controls on aircraft manufacturing",
  },
  {
    code: "334519",
    title:
      "Testing equipment (e.g., abrasion, shearing strength, tensile strength, torsion) manufacturing",
  },
  {
    code: "334519",
    title: "Theodolites, surveying, manufacturing",
  },
  {
    code: "334519",
    title:
      "Thermocouples (except industrial process, aircraft type, glass vacuum) manufacturing",
  },
  {
    code: "334519",
    title:
      "Thermometer, liquid-in-glass and bimetal types (except medical), manufacturing",
  },
  {
    code: "334519",
    title: "Thickness gauging instruments, ultrasonic, manufacturing",
  },
  {
    code: "334519",
    title: "Thrust power indicators, aircraft engine, manufacturing",
  },
  {
    code: "334519",
    title: "Time clocks and time recording devices manufacturing",
  },
  {
    code: "334519",
    title: "Time locks manufacturing",
  },
  {
    code: "334519",
    title: "Time stamps containing clock mechanisms manufacturing",
  },
  {
    code: "334519",
    title: "Timers for industrial use, clockwork mechanism, manufacturing",
  },
  {
    code: "334519",
    title: "Timing mechanisms, clockwork, manufacturing",
  },
  {
    code: "334519",
    title: "Torsion testing equipment manufacturing",
  },
  {
    code: "334519",
    title: "Transducers, pressure, manufacturing",
  },
  {
    code: "334519",
    title: "Transits, surveying, manufacturing",
  },
  {
    code: "334519",
    title: "T-squares (drafting) manufacturing",
  },
  {
    code: "334519",
    title: "Ultrasonic testing equipment (except medical) manufacturing",
  },
  {
    code: "334519",
    title: "Vibration meters, analyzers, and calibrators, manufacturing",
  },
  {
    code: "334519",
    title: "Viscosimeters (except industrial process type) manufacturing",
  },
  {
    code: "334519",
    title: "Wall clocks manufacturing",
  },
  {
    code: "334519",
    title: "Watch jewels manufacturing",
  },
  {
    code: "334519",
    title: "Watchcase manufacturing",
  },
  {
    code: "334519",
    title:
      "Watches (except smartwatches) and parts (except crystals) manufacturing",
  },
  {
    code: "334519",
    title: "Water leak detectors manufacturing",
  },
  {
    code: "334519",
    title: "Weather tracking equipment manufacturing",
  },
  {
    code: "334519",
    title: "Whole body counters, nuclear, manufacturing",
  },
  {
    code: "334519",
    title: "Wind direction indicators manufacturing",
  },
  {
    code: "334610",
    title: "Audiotape, blank, manufacturing",
  },
  {
    code: "334610",
    title: "Blank tapes, audio and video, manufacturing",
  },
  {
    code: "334610",
    title: "Cassette tapes, prerecorded audio, mass reproducing",
  },
  {
    code: "334610",
    title: "CD-ROM, software, mass reproducing",
  },
  {
    code: "334610",
    title: "Compact discs (i.e., CD-ROM), software, mass reproducing",
  },
  {
    code: "334610",
    title: "Compact discs, prerecorded audio, mass reproducing",
  },
  {
    code: "334610",
    title: "Compact discs, recordable or rewritable, blank, manufacturing",
  },
  {
    code: "334610",
    title:
      "Computer software tapes and disks, blank, rigid and floppy, manufacturing",
  },
  {
    code: "334610",
    title: "Diskettes, blank, manufacturing",
  },
  {
    code: "334610",
    title: "Game cartridge software, mass reproducing",
  },
  {
    code: "334610",
    title: "Games, computer software, mass reproducing",
  },
  {
    code: "334610",
    title: "Hard drive media (disk drive platters) manufacturing",
  },
  {
    code: "334610",
    title: "Head cleaners for magnetic tape equipment, manufacturing",
  },
  {
    code: "334610",
    title: "Laser disks, prerecorded video, mass reproducing",
  },
  {
    code: "334610",
    title: "Magnetic and optical media, blank, manufacturing",
  },
  {
    code: "334610",
    title:
      "Magnetic recording media for tapes, cassettes, and disks, manufacturing",
  },
  {
    code: "334610",
    title: "Magnetic tapes, cassettes and disks, blank, manufacturing",
  },
  {
    code: "334610",
    title: "Phonograph records manufacturing",
  },
  {
    code: "334610",
    title: "Prepackaged software, mass reproducing",
  },
  {
    code: "334610",
    title: "Prerecorded magnetic audio tapes and cassettes mass reproducing",
  },
  {
    code: "334610",
    title: "Software, packaged, mass reproducing",
  },
  {
    code: "334610",
    title:
      "Tapes, magnetic recording (i.e., audio, data, video), blank, manufacturing",
  },
  {
    code: "334610",
    title: "Video cassettes, blank, manufacturing",
  },
  {
    code: "334610",
    title: "Video cassettes, prerecorded, mass reproducing",
  },
  {
    code: "334610",
    title: "Video tape or disk mass reproducing",
  },
  {
    code: "334610",
    title: "Video tapes, blank, manufacturing",
  },
  {
    code: "335131",
    title: "Boudoir lamp fixtures manufacturing",
  },
  {
    code: "335131",
    title: "Ceiling lighting fixtures, residential, manufacturing",
  },
  {
    code: "335131",
    title: "Chandeliers, residential, manufacturing",
  },
  {
    code: "335131",
    title: "Decorative area lighting fixtures, residential, manufacturing",
  },
  {
    code: "335131",
    title: "Desk lamps, residential, electric, manufacturing",
  },
  {
    code: "335131",
    title: "Floor lamps (i.e., lighting fixtures), residential, manufacturing",
  },
  {
    code: "335131",
    title: "Fluorescent lighting fixtures, residential, manufacturing",
  },
  {
    code: "335131",
    title: "Grow light fixtures, residential, electric, manufacturing",
  },
  {
    code: "335131",
    title: "Lamp shades (except glass, plastics), residential, manufacturing",
  },
  {
    code: "335131",
    title:
      "Lamps (i.e., lighting fixtures), residential, electric, manufacturing",
  },
  {
    code: "335131",
    title: "Lighting fixtures, residential electric, manufacturing",
  },
  {
    code: "335131",
    title:
      "Low voltage lighting equipment, residential, electric, manufacturing",
  },
  {
    code: "335131",
    title: "Pendant lamps fixtures, residential electric, manufacturing",
  },
  {
    code: "335131",
    title:
      "Recessed lighting housings and trim, residential electric, manufacturing",
  },
  {
    code: "335131",
    title:
      "Shades, lamp (except glass, plastics), residential-type, manufacturing",
  },
  {
    code: "335131",
    title: "Solar lighting fixtures, residential, electric, manufacturing",
  },
  {
    code: "335131",
    title: "Table lamps (i.e., lighting fixtures) manufacturing",
  },
  {
    code: "335131",
    title:
      "Track lighting fixtures and equipment, residential, electric, manufacturing",
  },
  {
    code: "335131",
    title:
      "Wall lamps (i.e., lighting fixtures), residential electric, manufacturing",
  },
  {
    code: "335131",
    title: "Yard lights, residential electric, manufacturing",
  },
  {
    code: "335132",
    title:
      "Ceiling lighting fixtures, commercial, industrial, and institutional, manufacturing",
  },
  {
    code: "335132",
    title:
      "Chandeliers, commercial, industrial, and institutional electric, manufacturing",
  },
  {
    code: "335132",
    title: "Commercial lighting fixtures, electric, manufacturing",
  },
  {
    code: "335132",
    title: "Desk lamps, commercial, electric, manufacturing",
  },
  {
    code: "335132",
    title: "Emergency lighting (i.e., battery backup) manufacturing",
  },
  {
    code: "335132",
    title:
      "Fluorescent lighting fixtures, commercial, institutional, and industrial electric, manufacturing",
  },
  {
    code: "335132",
    title: "Grow light fixtures (except residential) manufacturing",
  },
  {
    code: "335132",
    title:
      "Illuminated indoor lighting fixtures (e.g., directional, exit) manufacturing",
  },
  {
    code: "335132",
    title: "Industrial lighting fixtures, electric, manufacturing",
  },
  {
    code: "335132",
    title: "Industrial mercury lighting fixtures, electric, manufacturing",
  },
  {
    code: "335132",
    title: "Institutional lighting fixtures, electric, manufacturing",
  },
  {
    code: "335132",
    title:
      "Lamps (i.e., lighting fixtures), commercial, industrial, and institutional, manufacturing",
  },
  {
    code: "335132",
    title: "Lighting fixtures, commercial electric, manufacturing",
  },
  {
    code: "335132",
    title: "Lighting fixtures, industrial electric, manufacturing",
  },
  {
    code: "335132",
    title: "Lighting fixtures, institutional electric, manufacturing",
  },
  {
    code: "335132",
    title: "Luminous panel ceilings, electric, manufacturing",
  },
  {
    code: "335132",
    title: "Pendant lamps (except residential), electric, manufacturing",
  },
  {
    code: "335132",
    title:
      "Recessed lighting housings and trim (except residential), electric, manufacturing",
  },
  {
    code: "335132",
    title:
      "Solar lighting fixtures (except residential), electric, manufacturing",
  },
  {
    code: "335132",
    title:
      "Wall lamps (i.e., lighting fixtures), commercial, institutional, and industrial electric, manufacturing",
  },
  {
    code: "335139",
    title:
      "Arc lighting fixtures (except electrotherapeutic), electric, manufacturing",
  },
  {
    code: "335139",
    title:
      "Area and sports luminaries (e.g., stadium lighting fixtures), electric, manufacturing",
  },
  {
    code: "335139",
    title: "Automotive light bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Bulbs, electric light, complete, manufacturing",
  },
  {
    code: "335139",
    title: "Christmas tree light bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Christmas tree lighting sets, electric, manufacturing",
  },
  {
    code: "335139",
    title: "Coating purchased light bulbs",
  },
  {
    code: "335139",
    title: "Cold cathode fluorescent lamp tubes manufacturing",
  },
  {
    code: "335139",
    title: "Compact fluorescent light bulbs manufacturing",
  },
  {
    code: "335139",
    title:
      "Decorative area lighting fixtures (except residential) manufacturing",
  },
  {
    code: "335139",
    title: "Decorative lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title:
      "Electric lamp bulb parts (except glass blanks and light emitting diodes (LEDs)) manufacturing",
  },
  {
    code: "335139",
    title: "Electric lamps (i.e., light bulbs) manufacturing",
  },
  {
    code: "335139",
    title: "Electric light bulbs, complete, manufacturing",
  },
  {
    code: "335139",
    title: "Electrodes, cold cathode fluorescent lamp, manufacturing",
  },
  {
    code: "335139",
    title:
      "Electrotherapeutic lamp bulbs for ultraviolet and infrared radiation manufacturing",
  },
  {
    code: "335139",
    title: "Filaments for electric lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Fireplace logs, electric, manufacturing",
  },
  {
    code: "335139",
    title: "Flash bulbs, photographic, manufacturing",
  },
  {
    code: "335139",
    title: "Flashlight bulb manufacturing",
  },
  {
    code: "335139",
    title: "Flashlights manufacturing",
  },
  {
    code: "335139",
    title: "Floodlights (i.e., lighting fixtures) manufacturing",
  },
  {
    code: "335139",
    title: "Fluorescent lamp electrodes, cold cathode, manufacturing",
  },
  {
    code: "335139",
    title: "Fluorescent lamp tubes, electric, manufacturing",
  },
  {
    code: "335139",
    title: "Flytraps, electrical, manufacturing",
  },
  {
    code: "335139",
    title: "Fountain lighting fixtures manufacturing",
  },
  {
    code: "335139",
    title: "Gas lighting fixtures manufacturing",
  },
  {
    code: "335139",
    title: "Glow lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Halogen light bulbs manufacturing",
  },
  {
    code: "335139",
    title:
      "Health lamp bulbs, infrared and ultraviolet radiation, manufacturing",
  },
  {
    code: "335139",
    title: "High intensity lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Incandescent filament lamp bulbs, complete, manufacturing",
  },
  {
    code: "335139",
    title: "Infrared lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Infrared lamp fixtures manufacturing",
  },
  {
    code: "335139",
    title: "Insect lamps, electric, manufacturing",
  },
  {
    code: "335139",
    title:
      "Lamp bulb parts (except glass blanks and light emitting diodes (LEDs)), electric, manufacturing",
  },
  {
    code: "335139",
    title:
      "Lamp bulbs and tubes, electric (i.e., fluorescent, incandescent filament, vapor), manufacturing",
  },
  {
    code: "335139",
    title:
      "Lamp bulbs and tubes, health, infrared and ultraviolet radiation, manufacturing",
  },
  {
    code: "335139",
    title: "Lamps, insect, electric fixture, manufacturing",
  },
  {
    code: "335139",
    title:
      "Lanterns (e.g., carbide, electric, gas, gasoline, kerosene) manufacturing",
  },
  {
    code: "335139",
    title: "Lead-in wires, electric lamp, made from purchased wire",
  },
  {
    code: "335139",
    title: "LED (light emitting diode) light bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Light bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Light bulbs, sealed beam automotive, manufacturing",
  },
  {
    code: "335139",
    title:
      "Lighting fixtures, airport (e.g., approach, ramp, runway, taxi), manufacturing",
  },
  {
    code: "335139",
    title:
      "Lighting fixtures, nonelectric (e.g., propane, kerosene, carbide), manufacturing",
  },
  {
    code: "335139",
    title: "Mercury halide lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Miner's lamps manufacturing",
  },
  {
    code: "335139",
    title: "Ornaments, Christmas tree, electric, manufacturing",
  },
  {
    code: "335139",
    title: "Photoflash and photoflood lamp bulbs and tubes manufacturing",
  },
  {
    code: "335139",
    title:
      "Prewired poles, brackets, and accessories for electric lighting, manufacturing",
  },
  {
    code: "335139",
    title: "Reflectors for lighting equipment, metal, manufacturing",
  },
  {
    code: "335139",
    title: "Sealed beam automotive light bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Searchlights, electric and nonelectric, manufacturing",
  },
  {
    code: "335139",
    title: "Sodium vapor lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Spotlights (except vehicular) manufacturing",
  },
  {
    code: "335139",
    title: "Stage lighting equipment manufacturing",
  },
  {
    code: "335139",
    title: "Street lighting fixtures (except traffic signals) manufacturing",
  },
  {
    code: "335139",
    title: "Strobotrons manufacturing",
  },
  {
    code: "335139",
    title: "Swimming pool lighting fixtures manufacturing",
  },
  {
    code: "335139",
    title: "Trouble lights manufacturing",
  },
  {
    code: "335139",
    title: "Ultraviolet lamp bulbs manufacturing",
  },
  {
    code: "335139",
    title: "Ultraviolet lamp fixtures manufacturing",
  },
  {
    code: "335139",
    title: "Underwater lighting fixtures manufacturing",
  },
  {
    code: "335139",
    title: "Vapor lamps, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Air purification equipment, portable, manufacturing",
  },
  {
    code: "335210",
    title:
      "Bath fans with integral lighting fixture, residential, manufacturing",
  },
  {
    code: "335210",
    title: "Bath fans, residential, manufacturing",
  },
  {
    code: "335210",
    title: "Bedcoverings, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Blankets, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Blenders, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Blow dryers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Bottle warmers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Bread machines, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Can openers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Carpet and floor cleaning equipment, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Casseroles, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Ceiling fans with integral lighting fixture, residential, manufacturing",
  },
  {
    code: "335210",
    title: "Ceiling fans, residential, manufacturing",
  },
  {
    code: "335210",
    title: "Central vacuuming systems, household-type, manufacturing",
  },
  {
    code: "335210",
    title: "Chafing dishes, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Cleaners, household-type electric vacuum, manufacturing",
  },
  {
    code: "335210",
    title: "Coffee makers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Cooking appliances (except convection, microwave ovens), household-type electric portable, manufacturing",
  },
  {
    code: "335210",
    title: "Corn poppers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Crock pots, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Curling irons, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Deep-fat fryers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Dehumidifiers, portable electric, manufacturing",
  },
  {
    code: "335210",
    title: "Desk fans, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Dry shavers (i.e., electric razors) manufacturing",
  },
  {
    code: "335210",
    title: "Egg cookers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Electric blankets manufacturing",
  },
  {
    code: "335210",
    title: "Electric comfort heating equipment, portable, manufacturing",
  },
  {
    code: "335210",
    title: "Electric space heaters, portable, manufacturing",
  },
  {
    code: "335210",
    title: "Electrically heated bed coverings manufacturing",
  },
  {
    code: "335210",
    title: "Fans (except attic), household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Fans, household-type kitchen, manufacturing",
  },
  {
    code: "335210",
    title:
      "Floor scrubbing and shampooing machines, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Floor standing fans, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Floor waxers and polishers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Food mixers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Fryers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Griddles and grills, household-type portable electric, manufacturing",
  },
  {
    code: "335210",
    title: "Hair clippers for human use, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Hair curlers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Hair dryers, electric (except equipment designed for beauty parlor use), manufacturing",
  },
  {
    code: "335210",
    title: "Hassock fans, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Heaters, portable electric space, manufacturing",
  },
  {
    code: "335210",
    title: "Heaters, tape, manufacturing",
  },
  {
    code: "335210",
    title: "Heating pads, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Heating units for electric appliances manufacturing",
  },
  {
    code: "335210",
    title: "Hoods, range, household-type, manufacturing",
  },
  {
    code: "335210",
    title: "Hotplates, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Humidifiers, portable electric, manufacturing",
  },
  {
    code: "335210",
    title: "Ice crushers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Immersion heaters, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Irons, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Juice extractors, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Knives, household-type electric carving, manufacturing",
  },
  {
    code: "335210",
    title:
      "Massage machines, electric (except designed for beauty and barber shop use), manufacturing",
  },
  {
    code: "335210",
    title:
      "Ovens, portable household-type (except microwave and convection ovens), manufacturing",
  },
  {
    code: "335210",
    title: "Percolators, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Popcorn poppers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Portable cooking appliances (except convection, microwave ovens), household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Portable electric space heaters manufacturing",
  },
  {
    code: "335210",
    title: "Portable hair dryers, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Portable humidifiers and dehumidifiers manufacturing",
  },
  {
    code: "335210",
    title: "Radiators, portable electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Range hoods with integral lighting fixtures, household-type, manufacturing",
  },
  {
    code: "335210",
    title: "Range hoods, household-type, manufacturing",
  },
  {
    code: "335210",
    title: "Razors, electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Roasters (i.e., cooking appliances), household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Room heaters, portable electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Sandwich toasters and grills, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Sauna heaters, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Scissors, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Shoe polishers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Steam cookers, household-type, manufacturing",
  },
  {
    code: "335210",
    title: "Sweepers, household-type electric vacuum, manufacturing",
  },
  {
    code: "335210",
    title: "Teakettles, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Toaster ovens, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Toasters, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Toothbrushes, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Trouser pressers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Unit heaters, portable electric, manufacturing",
  },
  {
    code: "335210",
    title: "Urns, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Vacuum cleaners (e.g., canister, handheld, upright) household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Vacuum cleaners and sweepers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Vaporizers, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Ventilating kitchen fans, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title:
      "Ventilation and exhaust fans (except attic fans), household-type, manufacturing",
  },
  {
    code: "335210",
    title: "Waffle irons, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Warming trays, electric, manufacturing",
  },
  {
    code: "335210",
    title: "Water pulsating devices, household-type electric, manufacturing",
  },
  {
    code: "335210",
    title: "Whippers, household-type electric, manufacturing",
  },
  {
    code: "335220",
    title: "Barbecues, grills, and braziers manufacturing",
  },
  {
    code: "335220",
    title: "Braziers, barbecue, manufacturing",
  },
  {
    code: "335220",
    title:
      "Convection ovens (including portable), household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Dishwashers, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Dishwashing machines, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Drycleaning and laundry machines, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Dryers, clothes, household-type, gas and electric, manufacturing",
  },
  {
    code: "335220",
    title: "Dryers, household-type laundry, manufacturing",
  },
  {
    code: "335220",
    title: "Food waste disposal units, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Freezers, chest and upright household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Garbage disposal units, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Gas ranges, household-type, manufacturing",
  },
  {
    code: "335220",
    title:
      "Hot water heaters (including nonelectric), household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Ice boxes, household-type, manufacturing",
  },
  {
    code: "335220",
    title:
      "Ironers and mangles, household-type (except portable irons), manufacturing",
  },
  {
    code: "335220",
    title:
      "Laundry equipment (e.g., dryers, washers), household-type, manufacturing",
  },
  {
    code: "335220",
    title:
      "Microwave ovens (including portable), household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Ovens, freestanding household-type, manufacturing",
  },
  {
    code: "335220",
    title:
      "Ovens, portable household-type convection and microwave, manufacturing",
  },
  {
    code: "335220",
    title: "Ranges, household-type cooking, manufacturing",
  },
  {
    code: "335220",
    title: "Refrigerator/freezer combinations, household-type, manufacturing",
  },
  {
    code: "335220",
    title:
      "Refrigerators (e.g., absorption, mechanical), household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Stoves, ceramic disk element, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Stoves, household-type cooking, manufacturing",
  },
  {
    code: "335220",
    title: "Trash and garbage compactors, household-type, manufacturing",
  },
  {
    code: "335220",
    title: "Washing machines, household-type, manufacturing",
  },
  {
    code: "335220",
    title:
      "Water heaters (including nonelectric), household-type, manufacturing",
  },
  {
    code: "335311",
    title: "Airport lighting transformers manufacturing",
  },
  {
    code: "335311",
    title: "Arc-welding transformers, separate solid-state, manufacturing",
  },
  {
    code: "335311",
    title:
      "Autotransformers for switchboards (except telephone switchboards) manufacturing",
  },
  {
    code: "335311",
    title: "Autotransformers manufacturing",
  },
  {
    code: "335311",
    title: "Ballasts (i.e., transformers) manufacturing",
  },
  {
    code: "335311",
    title:
      "Boosters, feeder voltage (i.e., electrical transformers), manufacturing",
  },
  {
    code: "335311",
    title: "Burner ignition transformers manufacturing",
  },
  {
    code: "335311",
    title: "Control transformers manufacturing",
  },
  {
    code: "335311",
    title: "Current limiting reactors, electrical, manufacturing",
  },
  {
    code: "335311",
    title: "Distribution transformers, electric, manufacturing",
  },
  {
    code: "335311",
    title: "Electric furnace transformers manufacturing",
  },
  {
    code: "335311",
    title:
      "Feeder voltage regulators and boosters (i.e., electrical transformers) manufacturing",
  },
  {
    code: "335311",
    title: "Fluorescent ballasts (i.e., transformers) manufacturing",
  },
  {
    code: "335311",
    title: "Fluorescent lighting transformers manufacturing",
  },
  {
    code: "335311",
    title:
      "Generator voltage regulators, electric induction and step-type (except engine electrical equipment), manufacturing",
  },
  {
    code: "335311",
    title:
      "Instrument transformers (except complete instruments) for metering or protective relaying use manufacturing",
  },
  {
    code: "335311",
    title: "Isolation transformers manufacturing",
  },
  {
    code: "335311",
    title: "Lamp ballasts manufacturing",
  },
  {
    code: "335311",
    title: "Lighting transformers manufacturing",
  },
  {
    code: "335311",
    title: "Lighting transformers, street and airport, manufacturing",
  },
  {
    code: "335311",
    title:
      "Line voltage regulators (i.e., electric transformers) manufacturing",
  },
  {
    code: "335311",
    title: "Luminous tube transformers manufacturing",
  },
  {
    code: "335311",
    title: "Machine tool transformers manufacturing",
  },
  {
    code: "335311",
    title: "Power transformers, electric, manufacturing",
  },
  {
    code: "335311",
    title: "Regulating transformers, power system-type, manufacturing",
  },
  {
    code: "335311",
    title:
      "Regulators (i.e., electric transformers), feeder voltage, manufacturing",
  },
  {
    code: "335311",
    title: "Saturable transformers manufacturing",
  },
  {
    code: "335311",
    title: "Signaling transformers, electric, manufacturing",
  },
  {
    code: "335311",
    title: "Specialty transformers, electric, manufacturing",
  },
  {
    code: "335311",
    title:
      "Substation transformers, electric power distribution, manufacturing",
  },
  {
    code: "335311",
    title: "Transformers, electric power, manufacturing",
  },
  {
    code: "335311",
    title:
      "Transformers, ignition, for use on domestic fuel burners, manufacturing",
  },
  {
    code: "335311",
    title: "Transformers, reactor, manufacturing",
  },
  {
    code: "335311",
    title: "Transformers, separate solid-state arc-welding, manufacturing",
  },
  {
    code: "335311",
    title: "Transmission and distribution voltage regulators manufacturing",
  },
  {
    code: "335311",
    title: "Voltage regulating transformers, electric power, manufacturing",
  },
  {
    code: "335311",
    title: "Voltage regulators, transmission and distribution, manufacturing",
  },
  {
    code: "335312",
    title: "Armature rewinding on a factory basis",
  },
  {
    code: "335312",
    title: "Armatures, industrial, manufacturing",
  },
  {
    code: "335312",
    title: "Coils for motors and generators manufacturing",
  },
  {
    code: "335312",
    title: "Collector rings for motors and generators manufacturing",
  },
  {
    code: "335312",
    title: "Commutators, electric motor, manufacturing",
  },
  {
    code: "335312",
    title: "Condensers, synchronous, electric, manufacturing",
  },
  {
    code: "335312",
    title: "Converters, phase and rotary, electrical equipment, manufacturing",
  },
  {
    code: "335312",
    title: "Dynamos, electric (except automotive), manufacturing",
  },
  {
    code: "335312",
    title: "Dynamotors manufacturing",
  },
  {
    code: "335312",
    title: "Exciter assemblies, motor and generator, manufacturing",
  },
  {
    code: "335312",
    title: "Fractional horsepower electric motors manufacturing",
  },
  {
    code: "335312",
    title: "Frequency converters (i.e., electric generators) manufacturing",
  },
  {
    code: "335312",
    title:
      "Generating apparatus and parts, electrical (except internal combustion engine and welding), manufacturing",
  },
  {
    code: "335312",
    title:
      "Generator sets, prime mover (except turbine generator sets), manufacturing",
  },
  {
    code: "335312",
    title:
      "Generators and sets, electric (except internal combustion engine, welding, turbine generator sets), manufacturing",
  },
  {
    code: "335312",
    title:
      "Generators for gas-electric and oil-electric vehicles, manufacturing",
  },
  {
    code: "335312",
    title:
      "Generators for storage battery chargers (except internal combustion engine and aircraft) manufacturing",
  },
  {
    code: "335312",
    title: "Ground Power Units (GPU) manufacturing",
  },
  {
    code: "335312",
    title: "Integral horsepower electric motors manufacturing",
  },
  {
    code: "335312",
    title: "Inverters, rotating electrical, manufacturing",
  },
  {
    code: "335312",
    title: "Land transportation motors and generators manufacturing",
  },
  {
    code: "335312",
    title:
      "Motor generator sets (except automotive, turbine generator sets) manufacturing",
  },
  {
    code: "335312",
    title:
      "Motors, electric (except engine starting motors, gearmotors, outboard), manufacturing",
  },
  {
    code: "335312",
    title: "Phase converters (i.e., electrical equipment) manufacturing",
  },
  {
    code: "335312",
    title: "Power generators manufacturing",
  },
  {
    code: "335312",
    title:
      "Prime mover generator sets (except turbine generator sets) manufacturing",
  },
  {
    code: "335312",
    title: "Railway motors and control equipment, electric, manufacturing",
  },
  {
    code: "335312",
    title: "Resolvers manufacturing",
  },
  {
    code: "335312",
    title: "Rotor retainers and housings manufacturing",
  },
  {
    code: "335312",
    title: "Rotors (i.e., for motors) manufacturing",
  },
  {
    code: "335312",
    title: "Servomotors manufacturing",
  },
  {
    code: "335312",
    title: "Slip rings for motors and generators manufacturing",
  },
  {
    code: "335312",
    title: "Stators for motors manufacturing",
  },
  {
    code: "335312",
    title:
      "Storage battery chargers (except internal combustion engine-type) manufacturing",
  },
  {
    code: "335312",
    title: "Synchronous condensers and timing motors, electric, manufacturing",
  },
  {
    code: "335312",
    title: "Synchronous motors manufacturing",
  },
  {
    code: "335312",
    title: "Timing motors, synchronous, electric, manufacturing",
  },
  {
    code: "335312",
    title: "Torque motors, electric, manufacturing",
  },
  {
    code: "335313",
    title: "Air circuit breakers manufacturing",
  },
  {
    code: "335313",
    title: "Bus bar structures, switchgear-type, manufacturing",
  },
  {
    code: "335313",
    title: "Circuit breakers, air, manufacturing",
  },
  {
    code: "335313",
    title: "Circuit breakers, power, manufacturing",
  },
  {
    code: "335313",
    title: "Connectors, power, manufacturing",
  },
  {
    code: "335313",
    title: "Control panels, electric power distribution, manufacturing",
  },
  {
    code: "335313",
    title: "Cubicles (i.e., electric switchboard equipment) manufacturing",
  },
  {
    code: "335313",
    title: "Distribution boards, electric, manufacturing",
  },
  {
    code: "335313",
    title: "Distribution cutouts manufacturing",
  },
  {
    code: "335313",
    title: "Ducts for electrical switchboard apparatus manufacturing",
  },
  {
    code: "335313",
    title: "Fuse clips and blocks, electric, manufacturing",
  },
  {
    code: "335313",
    title: "Fuse mountings, electric power, manufacturing",
  },
  {
    code: "335313",
    title: "Fuses, electrical, manufacturing",
  },
  {
    code: "335313",
    title:
      "Generator control and metering panels, switchgear-type, manufacturing",
  },
  {
    code: "335313",
    title: "Knife switches, electric power switchgear-type, manufacturing",
  },
  {
    code: "335313",
    title: "Metering panels, electric, manufacturing",
  },
  {
    code: "335313",
    title: "Panelboards, electric power distribution, manufacturing",
  },
  {
    code: "335313",
    title: "Panels, generator control and metering, manufacturing",
  },
  {
    code: "335313",
    title: "Power circuit breakers manufacturing",
  },
  {
    code: "335313",
    title: "Power connectors manufacturing",
  },
  {
    code: "335313",
    title: "Power fuses (i.e., 600 volts and over) manufacturing",
  },
  {
    code: "335313",
    title: "Power switchboards manufacturing",
  },
  {
    code: "335313",
    title: "Power switching equipment manufacturing",
  },
  {
    code: "335313",
    title: "Regulators, power, manufacturing",
  },
  {
    code: "335313",
    title: "Switchboards and parts, power, manufacturing",
  },
  {
    code: "335313",
    title:
      "Switches, electric power (except pushbutton, snap, solenoid, tumbler), manufacturing",
  },
  {
    code: "335313",
    title: "Switchgear and switchgear accessories manufacturing",
  },
  {
    code: "335313",
    title: "Switching equipment, power, manufacturing",
  },
  {
    code: "335313",
    title: "Time switches, electrical switchgear apparatus, manufacturing",
  },
  {
    code: "335314",
    title: "Armature relays manufacturing",
  },
  {
    code: "335314",
    title: "Brakes and clutches, electromagnetic, manufacturing",
  },
  {
    code: "335314",
    title: "Brakes, electromagnetic, manufacturing",
  },
  {
    code: "335314",
    title: "Control circuit devices, magnet and solid-state, manufacturing",
  },
  {
    code: "335314",
    title: "Control circuit relays, industrial, manufacturing",
  },
  {
    code: "335314",
    title: "Control equipment, electric, manufacturing",
  },
  {
    code: "335314",
    title: "Controls and control accessories, industrial, manufacturing",
  },
  {
    code: "335314",
    title: "Controls for adjustable speed drives manufacturing",
  },
  {
    code: "335314",
    title: "Crane and hoist controls, including metal mill, manufacturing",
  },
  {
    code: "335314",
    title: "Flow actuated electrical switches manufacturing",
  },
  {
    code: "335314",
    title:
      "Industrial controls (e.g., pushbutton, selector, and pilot switches) manufacturing",
  },
  {
    code: "335314",
    title: "Marine and navy auxiliary controls, manufacturing",
  },
  {
    code: "335314",
    title:
      "Motor control accessories (including overload relays) manufacturing",
  },
  {
    code: "335314",
    title: "Motor control centers, manufacturing",
  },
  {
    code: "335314",
    title: "Motor controls, electric, manufacturing",
  },
  {
    code: "335314",
    title:
      "Motor starters, contactors, and controllers, industrial, manufacturing",
  },
  {
    code: "335314",
    title: "Numerical controls, manufacturing",
  },
  {
    code: "335314",
    title: "Relays, electrical and electronic, manufacturing",
  },
  {
    code: "335314",
    title: "Rheostats, industrial control, manufacturing",
  },
  {
    code: "335314",
    title: "Solenoid switches, industrial, manufacturing",
  },
  {
    code: "335314",
    title:
      "Timing devices, mechanical and solid-state (except clockwork), manufacturing",
  },
  {
    code: "335314",
    title: "Vacuum relays manufacturing",
  },
  {
    code: "335910",
    title: "Alkaline cell primary batteries manufacturing",
  },
  {
    code: "335910",
    title:
      "Alkaline cell storage batteries (i.e., nickel-cadmium, nickel-iron, silver oxide-zinc) manufacturing",
  },
  {
    code: "335910",
    title: "Alkaline manganese primary batteries manufacturing",
  },
  {
    code: "335910",
    title: "Automobile storage batteries manufacturing",
  },
  {
    code: "335910",
    title: "Batteries, primary, dry or wet, manufacturing",
  },
  {
    code: "335910",
    title: "Batteries, rechargeable, manufacturing",
  },
  {
    code: "335910",
    title: "Batteries, storage, manufacturing",
  },
  {
    code: "335910",
    title: "Button cells, primary batteries, manufacturing",
  },
  {
    code: "335910",
    title: "Disposable flashlight batteries manufacturing",
  },
  {
    code: "335910",
    title:
      "Dry cell primary batteries, single and multiple cell, manufacturing",
  },
  {
    code: "335910",
    title: "Dry cells, primary (e.g., AAA, AA, C, D, 9V), manufacturing",
  },
  {
    code: "335910",
    title: "Flashlight batteries, disposable, manufacturing",
  },
  {
    code: "335910",
    title: "Lead acid storage batteries manufacturing",
  },
  {
    code: "335910",
    title: "Lithium batteries manufacturing",
  },
  {
    code: "335910",
    title: "Marine storage batteries manufacturing",
  },
  {
    code: "335910",
    title: "Mercuric oxide batteries manufacturing",
  },
  {
    code: "335910",
    title: "Nickel-cadmium storage batteries manufacturing",
  },
  {
    code: "335910",
    title: "Primary batteries manufacturing",
  },
  {
    code: "335910",
    title:
      "Rechargeable battery packs made from purchased battery cells and housings",
  },
  {
    code: "335910",
    title: "Rechargeable nickel-cadmium (NICAD) batteries manufacturing",
  },
  {
    code: "335910",
    title: "Storage batteries manufacturing",
  },
  {
    code: "335910",
    title: "Transistor radio batteries manufacturing",
  },
  {
    code: "335910",
    title: "Watch batteries manufacturing",
  },
  {
    code: "335910",
    title: "Zinc carbon batteries manufacturing",
  },
  {
    code: "335921",
    title: "Fiber optic cable made from purchased fiber optic strand",
  },
  {
    code: "335929",
    title:
      "Cable, nonferrous, insulated, or armored, made from purchased nonferrous wire",
  },
  {
    code: "335929",
    title: "Coaxial cable, nonferrous, made from purchased nonferrous wire",
  },
  {
    code: "335929",
    title:
      "Communications wire and cable, nonferrous, made from purchased nonferrous wire",
  },
  {
    code: "335929",
    title: "Insulating purchased nonferrous wire",
  },
  {
    code: "335931",
    title: "Arrestors and coils, lighting, manufacturing",
  },
  {
    code: "335931",
    title: "Automotive electrical switches manufacturing",
  },
  {
    code: "335931",
    title:
      "Bus bars, electrical conductors (except switchgear-type), manufacturing",
  },
  {
    code: "335931",
    title: "Caps and plugs, attachment, electric, manufacturing",
  },
  {
    code: "335931",
    title:
      "Conductor connectors, solderless connectors, sleeves, or soldering lugs, manufacturing",
  },
  {
    code: "335931",
    title: "Connectors and terminals for electrical devices manufacturing",
  },
  {
    code: "335931",
    title: "Connectors, electric cord, manufacturing",
  },
  {
    code: "335931",
    title: "Connectors, solderless (wiring devices), manufacturing",
  },
  {
    code: "335931",
    title: "Connectors, twist on wire (i.e., nuts), manufacturing",
  },
  {
    code: "335931",
    title: "Contacts, electrical (except carbon and graphite), manufacturing",
  },
  {
    code: "335931",
    title: "Convenience outlets, electric, manufacturing",
  },
  {
    code: "335931",
    title: "Cord connectors, electric, manufacturing",
  },
  {
    code: "335931",
    title: "Current taps, attachment plug and screw shell types, manufacturing",
  },
  {
    code: "335931",
    title: "Cutouts, switch and fuse, manufacturing",
  },
  {
    code: "335931",
    title: "Dimmer switches, outlet box mounting-type, manufacturing",
  },
  {
    code: "335931",
    title: "Duplex receptacles, electrical, manufacturing",
  },
  {
    code: "335931",
    title: "Fuse cutouts manufacturing",
  },
  {
    code: "335931",
    title: "GFCI (ground fault circuit interrupters) manufacturing",
  },
  {
    code: "335931",
    title: "Ground clamps (i.e., electric wiring devices) manufacturing",
  },
  {
    code: "335931",
    title: "Ground fault circuit interrupters (GFCI) manufacturing",
  },
  {
    code: "335931",
    title: "Lamp holders manufacturing",
  },
  {
    code: "335931",
    title:
      "Lamp sockets and receptacles (i.e., electric wiring devices) manufacturing",
  },
  {
    code: "335931",
    title: "Lightning arrestors and coils manufacturing",
  },
  {
    code: "335931",
    title: "Lightning protection equipment manufacturing",
  },
  {
    code: "335931",
    title: "Lugs and connectors, electrical, manufacturing",
  },
  {
    code: "335931",
    title: "Outlets (i.e., receptacles), electrical, manufacturing",
  },
  {
    code: "335931",
    title: "Outlets, convenience, electrical, manufacturing",
  },
  {
    code: "335931",
    title: "Plugs, electric cord, manufacturing",
  },
  {
    code: "335931",
    title: "Rail bonds, propulsion and signal circuit electric, manufacturing",
  },
  {
    code: "335931",
    title: "Receptacles (i.e., outlets), electrical, manufacturing",
  },
  {
    code: "335931",
    title:
      "Rheostats (i.e., dimmer switches), current-carrying wiring device, manufacturing",
  },
  {
    code: "335931",
    title: "Snap switches (i.e., electric wiring devices) manufacturing",
  },
  {
    code: "335931",
    title: "Sockets, electric, manufacturing",
  },
  {
    code: "335931",
    title: "Solderless connectors (electric wiring devices) manufacturing",
  },
  {
    code: "335931",
    title: "Switch cutouts manufacturing",
  },
  {
    code: "335931",
    title:
      "Switches for electrical wiring (e.g., pressure, pushbutton, snap, tumbler) manufacturing",
  },
  {
    code: "335931",
    title: "Switches, outlet box mounting-type, manufacturing",
  },
  {
    code: "335931",
    title:
      "Taps, current, attachment plug and screw shell types, manufacturing",
  },
  {
    code: "335931",
    title: "Terminals and connectors for electrical devices manufacturing",
  },
  {
    code: "335932",
    title:
      "Boxes, electrical wiring (e.g., junction, outlet, switch), manufacturing",
  },
  {
    code: "335932",
    title: "Conduits and fittings, electrical, manufacturing",
  },
  {
    code: "335932",
    title: "Electrical metallic tube (EMTs) manufacturing",
  },
  {
    code: "335932",
    title: "EMTs (electrical metallic tube) manufacturing",
  },
  {
    code: "335932",
    title: "Face plates (i.e., outlet or switch covers) manufacturing",
  },
  {
    code: "335932",
    title: "Hardware, transmission pole and line, manufacturing",
  },
  {
    code: "335932",
    title: "Insulators, electrical (except glass, porcelain), manufacturing",
  },
  {
    code: "335932",
    title: "Junction boxes, electrical wiring, manufacturing",
  },
  {
    code: "335932",
    title: "Outlet boxes, electrical wiring, manufacturing",
  },
  {
    code: "335932",
    title: "Plates (i.e., outlet or switch covers), face, manufacturing",
  },
  {
    code: "335932",
    title: "Raceways manufacturing",
  },
  {
    code: "335932",
    title: "Switch boxes, electrical wiring, manufacturing",
  },
  {
    code: "335932",
    title: "Transmission pole and line hardware manufacturing",
  },
  {
    code: "335991",
    title: "Brush blocks, carbon or molded graphite, manufacturing",
  },
  {
    code: "335991",
    title:
      "Brushes and brush stock contacts, electric, carbon and graphite, manufacturing",
  },
  {
    code: "335991",
    title: "Brushplates, carbon or graphite, manufacturing",
  },
  {
    code: "335991",
    title: "Carbon electrodes and contacts, electric, manufacturing",
  },
  {
    code: "335991",
    title:
      "Carbon specialties for aerospace use (except gaskets) manufacturing",
  },
  {
    code: "335991",
    title: "Carbon specialties for electrical use manufacturing",
  },
  {
    code: "335991",
    title:
      "Carbon specialties for mechanical use (except gaskets) manufacturing",
  },
  {
    code: "335991",
    title: "Carbons, electric, manufacturing",
  },
  {
    code: "335991",
    title: "Carbons, lighting, manufacturing",
  },
  {
    code: "335991",
    title: "Contacts, electrical, carbon and graphite, manufacturing",
  },
  {
    code: "335991",
    title:
      "Electrodes for thermal and electrolytic uses, carbon and graphite, manufacturing",
  },
  {
    code: "335991",
    title: "Fibers, carbon and graphite, manufacturing",
  },
  {
    code: "335991",
    title: "Graphite electrodes and contacts, electric, manufacturing",
  },
  {
    code: "335991",
    title:
      "Graphite specialties for aerospace use (except gaskets) manufacturing",
  },
  {
    code: "335991",
    title: "Graphite specialties for electrical use manufacturing",
  },
  {
    code: "335991",
    title:
      "Graphite specialties for mechanical use (except gaskets) manufacturing",
  },
  {
    code: "335991",
    title: "Heat shields, carbon or graphite, manufacturing",
  },
  {
    code: "335991",
    title: "Lighting carbons manufacturing",
  },
  {
    code: "335991",
    title: "Metal-graphite products manufacturing",
  },
  {
    code: "335999",
    title: "Amplifiers, magnetic, pulse, and maser, manufacturing",
  },
  {
    code: "335999",
    title: "Appliance cords made from purchased insulated wire",
  },
  {
    code: "335999",
    title: "Atom smashers (i.e., particle accelerators) manufacturing",
  },
  {
    code: "335999",
    title: "Battery chargers, solid-state, manufacturing",
  },
  {
    code: "335999",
    title: "Bells, electric, manufacturing",
  },
  {
    code: "335999",
    title: "Betatrons manufacturing",
  },
  {
    code: "335999",
    title: "Capacitors (except electronic), fixed and variable, manufacturing",
  },
  {
    code: "335999",
    title: "Cathodic protection equipment manufacturing",
  },
  {
    code: "335999",
    title: "Chimes, electric, manufacturing",
  },
  {
    code: "335999",
    title:
      "Cleaning equipment, ultrasonic (except dental, medical), manufacturing",
  },
  {
    code: "335999",
    title: "Condensers (except electronic), fixed and variable, manufacturing",
  },
  {
    code: "335999",
    title: "Cyclotrons manufacturing",
  },
  {
    code: "335999",
    title: "Door opening and closing devices, electrical, manufacturing",
  },
  {
    code: "335999",
    title: "Electric bells manufacturing",
  },
  {
    code: "335999",
    title: "Electric fence chargers manufacturing",
  },
  {
    code: "335999",
    title: "Electrochemical generators (i.e., fuel cells) manufacturing",
  },
  {
    code: "335999",
    title: "Electron linear accelerators manufacturing",
  },
  {
    code: "335999",
    title: "Electrostatic particle accelerators manufacturing",
  },
  {
    code: "335999",
    title: "Extension cords made from purchased insulated wire",
  },
  {
    code: "335999",
    title: "Fuel cells, electrochemical generators, manufacturing",
  },
  {
    code: "335999",
    title: "Garage door openers manufacturing",
  },
  {
    code: "335999",
    title: "Gongs, electric, manufacturing",
  },
  {
    code: "335999",
    title: "Inverters, solid-state, manufacturing",
  },
  {
    code: "335999",
    title: "Linear accelerators manufacturing",
  },
  {
    code: "335999",
    title:
      "Maser (i.e., microwave amplification by stimulated emission of radiation) amplifiers manufacturing",
  },
  {
    code: "335999",
    title: "Mercury arc rectifiers (i.e., electrical apparatus) manufacturing",
  },
  {
    code: "335999",
    title: "Particle accelerators, high-voltage, manufacturing",
  },
  {
    code: "335999",
    title: "Photovoltaic panels made from purchased cells",
  },
  {
    code: "335999",
    title: "Power converter units (i.e., AC to DC), static, manufacturing",
  },
  {
    code: "335999",
    title: "Power supplies, regulated and unregulated, manufacturing",
  },
  {
    code: "335999",
    title:
      "Rectifiers (except electronic component-type, semiconductor) manufacturing",
  },
  {
    code: "335999",
    title: "Semiconductor battery chargers manufacturing",
  },
  {
    code: "335999",
    title: "Semiconductor high-voltage power supplies manufacturing",
  },
  {
    code: "335999",
    title: "Series capacitors (except electronic) manufacturing",
  },
  {
    code: "335999",
    title: "Surge suppressors manufacturing",
  },
  {
    code: "335999",
    title: "Thermoelectric generators manufacturing",
  },
  {
    code: "335999",
    title:
      "Ultrasonic cleaning equipment (except dental, medical) manufacturing",
  },
  {
    code: "335999",
    title:
      "Ultrasonic generators sold separately for inclusion in tools and equipment manufacturing",
  },
  {
    code: "335999",
    title: "Uninterruptible power supplies (UPS) manufacturing",
  },
  {
    code: "335999",
    title: "UPS (uninterruptible power supplies) manufacturing",
  },
  {
    code: "336110",
    title: "Assembly plants, light trucks on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Assembly plants, minivans on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Assembly plants, passenger car on chassis of own manufacture",
  },
  {
    code: "336110",
    title:
      "Assembly plants, sport utility vehicles on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Automobiles assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Cab and chassis, light trucks and vans, manufacturing",
  },
  {
    code: "336110",
    title:
      "Cars, electric, for highway use, assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Chassis, automobile, manufacturing",
  },
  {
    code: "336110",
    title: "Chassis, light truck and utility, manufacturing",
  },
  {
    code: "336110",
    title: "Electric automobiles for highway use manufacturing",
  },
  {
    code: "336110",
    title: "Hearses assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Light utility trucks assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Minivans assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title:
      "Motor homes, self-contained, mounted on light duty truck chassis of own manufacture",
  },
  {
    code: "336110",
    title:
      "Pick-up trucks, light duty, assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Sport utility vehicles assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Trucks, light duty, assembling on chassis of own manufacture",
  },
  {
    code: "336110",
    title: "Unmanned and robotic automobiles manufacturing",
  },
  {
    code: "336110",
    title:
      "Vans, commercial and passenger light duty, assembling on chassis of own manufacture",
  },
  {
    code: "336120",
    title:
      "Assembly plants, heavy trucks, and buses on chassis of own manufacture",
  },
  {
    code: "336120",
    title:
      "Buses (except trackless trolley) assembling on chassis of own manufacture",
  },
  {
    code: "336120",
    title: "Chassis, heavy truck, with or without cabs, manufacturing",
  },
  {
    code: "336120",
    title: "Garbage trucks assembling on chassis of own manufacture",
  },
  {
    code: "336120",
    title: "Heavy trucks assembling on chassis of own manufacture",
  },
  {
    code: "336120",
    title: "Highway tractors assembled on chassis of own manufacture",
  },
  {
    code: "336120",
    title:
      "Motor homes, self-contained, mounted on heavy truck chassis of own manufacture",
  },
  {
    code: "336120",
    title:
      "Special purpose highway vehicles (e.g., firefighting vehicles) assembling on heavy chassis of own manufacture",
  },
  {
    code: "336120",
    title:
      "Tractors, truck for highway use, assembled on chassis of own manufacture",
  },
  {
    code: "336120",
    title:
      "Truck tractors for highway use, assembling on chassis of own manufacture",
  },
  {
    code: "336120",
    title: "Trucks, heavy, assembling on chassis of own manufacture",
  },
  {
    code: "336211",
    title: "Ambulance bodies manufacturing",
  },
  {
    code: "336211",
    title: "Ambulances assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Automobile bodies, passenger car, manufacturing",
  },
  {
    code: "336211",
    title: "Automobile wrecker truck bodies manufacturing",
  },
  {
    code: "336211",
    title: "Automobile wreckers assembling on purchased chassis",
  },
  {
    code: "336211",
    title:
      "Boxes, truck (e.g., cargo, dump, utility, van), assembled on purchased chassis",
  },
  {
    code: "336211",
    title: "Bus bodies assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Bus bodies manufacturing",
  },
  {
    code: "336211",
    title: "Car bodies, kit, manufacturing",
  },
  {
    code: "336211",
    title: "Dump-truck lifting mechanisms manufacturing",
  },
  {
    code: "336211",
    title: "Fifth-wheel assemblies manufacturing",
  },
  {
    code: "336211",
    title: "Garbage truck bodies manufacturing",
  },
  {
    code: "336211",
    title: "Garbage trucks assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Hearse bodies manufacturing",
  },
  {
    code: "336211",
    title: "Hearses assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Heavy trucks assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Highway tractors assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Kit car bodies manufacturing",
  },
  {
    code: "336211",
    title: "Ready-mix concrete trucks assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "School buses assembling on purchased chassis",
  },
  {
    code: "336211",
    title:
      "Special purpose highway vehicle (e.g., firefighting vehicles) assembling on purchased chassis",
  },
  {
    code: "336211",
    title:
      "Special purpose highway vehicle (e.g., firefighting vehicles) bodies manufacturing",
  },
  {
    code: "336211",
    title: "Stretch limousines assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Tank bodies for trucks manufacturing",
  },
  {
    code: "336211",
    title:
      "Tank trucks (e.g., fuel oil, milk, water) assembling on purchased chassis",
  },
  {
    code: "336211",
    title:
      "Tow trucks (including tilt and load) assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Truck bodies and cabs manufacturing",
  },
  {
    code: "336211",
    title: "Truck bodies assembling on purchased chassis",
  },
  {
    code: "336211",
    title: "Truck tractors for highway use, assembling on purchased chassis",
  },
  {
    code: "336212",
    title: "Automobile transporter trailers, multi-car, manufacturing",
  },
  {
    code: "336212",
    title: "Boat transporter trailers, multi-unit, manufacturing",
  },
  {
    code: "336212",
    title: "Demountable cargo containers manufacturing",
  },
  {
    code: "336212",
    title: "Dump trailers manufacturing",
  },
  {
    code: "336212",
    title: "Flatbed trailers, commercial, manufacturing",
  },
  {
    code: "336212",
    title: "Horse trailers, fifth-wheel-type, manufacturing",
  },
  {
    code: "336212",
    title: "Logging trailers manufacturing",
  },
  {
    code: "336212",
    title: "Semi-trailers manufacturing",
  },
  {
    code: "336212",
    title: "Tank trailers, liquid and dry bulk, manufacturing",
  },
  {
    code: "336212",
    title: "Trailers, fifth-wheel-type, for transporting horses, manufacturing",
  },
  {
    code: "336212",
    title: "Truck trailers manufacturing",
  },
  {
    code: "336213",
    title: "Assembly line conversions of purchased vans and minivans",
  },
  {
    code: "336213",
    title: "Motor homes, self-contained, assembling on purchased chassis",
  },
  {
    code: "336213",
    title: "Van and minivan conversions on purchased chassis",
  },
  {
    code: "336214",
    title: "Automobile transporter trailers, single car, manufacturing",
  },
  {
    code: "336214",
    title: "Boat transporter trailers, single-unit, manufacturing",
  },
  {
    code: "336214",
    title: "Camper units, slide-in, for pick-up trucks, manufacturing",
  },
  {
    code: "336214",
    title: "Camping trailers and chassis manufacturing",
  },
  {
    code: "336214",
    title: "Caps for pick-up trucks manufacturing",
  },
  {
    code: "336214",
    title: "Horse trailers (except fifth-wheel-type) manufacturing",
  },
  {
    code: "336214",
    title: "Pick-up canopies, caps, or covers manufacturing",
  },
  {
    code: "336214",
    title: "Tent trailers (hard top and soft top) manufacturing",
  },
  {
    code: "336214",
    title:
      "Trailers for transporting horses (except fifth-wheel-type) manufacturing",
  },
  {
    code: "336214",
    title: "Trailers, camping, manufacturing",
  },
  {
    code: "336214",
    title: "Travel trailers, recreational, manufacturing",
  },
  {
    code: "336214",
    title: "Truck campers (i.e., slide-in campers) manufacturing",
  },
  {
    code: "336214",
    title: "Utility trailers manufacturing",
  },
  {
    code: "336310",
    title: "Assembly line rebuilding of automotive and truck gasoline engines",
  },
  {
    code: "336310",
    title:
      "Bearings (e.g., camshaft, crankshaft, connecting rod), automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title: "Carburetors, all types, manufacturing",
  },
  {
    code: "336310",
    title:
      "Connecting rods, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Crankshaft assemblies, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Cylinder heads, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Engine block assemblies, automotive and truck gasoline, manufacturing",
  },
  {
    code: "336310",
    title: "Engine intake and exhaust valves manufacturing",
  },
  {
    code: "336310",
    title:
      "Engines and parts (except diesel), automotive and truck, manufacturing",
  },
  {
    code: "336310",
    title:
      "Flywheels and ring gears, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Fuel injection systems and parts, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Fuel pumps, mechanical, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Gasoline engine parts, mechanical, automotive and truck, manufacturing",
  },
  {
    code: "336310",
    title: "Gasoline engines for hybrid automotive vehicles manufacturing",
  },
  {
    code: "336310",
    title: "Gasoline engines, automotive and truck, manufacturing",
  },
  {
    code: "336310",
    title: "Governors for automotive gasoline engines manufacturing",
  },
  {
    code: "336310",
    title:
      "Internal combustion engines, automotive and truck gasoline, manufacturing",
  },
  {
    code: "336310",
    title:
      "Manifolds (i.e., intake and exhaust), automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title: "Pistons and piston rings manufacturing",
  },
  {
    code: "336310",
    title: "Positive crankcase ventilation (PCV) valves, engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Pumps (e.g., fuel, oil, water), mechanical, automotive and truck gasoline engine (except power steering), manufacturing",
  },
  {
    code: "336310",
    title: "Rebuilding automotive and truck gasoline engines",
  },
  {
    code: "336310",
    title: "Rings, piston, manufacturing",
  },
  {
    code: "336310",
    title:
      "Rocker arms and parts, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title:
      "Timing gears and chains, automotive and truck gasoline engine, manufacturing",
  },
  {
    code: "336310",
    title: "Valves, engine, intake and exhaust, manufacturing",
  },
  {
    code: "336320",
    title: "Aircraft lighting fixtures manufacturing",
  },
  {
    code: "336320",
    title:
      "Alternators and generators for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Automotive harness and ignition sets manufacturing",
  },
  {
    code: "336320",
    title: "Automotive lighting fixtures manufacturing",
  },
  {
    code: "336320",
    title: "Boat and ship lighting fixtures manufacturing",
  },
  {
    code: "336320",
    title: "Coils, ignition, internal combustion engines, manufacturing",
  },
  {
    code: "336320",
    title:
      "Cruise control mechanisms, electronic, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title:
      "Distributor cap and rotor for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Distributors for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Electrical control chips (modules), motor vehicle, manufacturing",
  },
  {
    code: "336320",
    title:
      "Electrical ignition cable sets for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Fans, electric cooling, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title: "Fuel pumps, electric, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title:
      "Generating apparatus and parts for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Generators for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title:
      "Ignition points and condensers for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title:
      "Ignition wiring harness for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title:
      "Instrument control panels (i.e., assembling purchased gauges), automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title: "Keyless entry systems, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title: "Locomotive and railroad car light fixtures manufacturing",
  },
  {
    code: "336320",
    title: "Motors, starter, for internal combustion engines, manufacturing",
  },
  {
    code: "336320",
    title:
      "Power window and door lock systems, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title:
      "Regulators, motor vehicle voltage for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Spark plugs for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Spotlights, vehicular, manufacturing",
  },
  {
    code: "336320",
    title:
      "Starter and starter parts for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Vehicular lighting fixtures manufacturing",
  },
  {
    code: "336320",
    title: "Voltage regulators for internal combustion engines manufacturing",
  },
  {
    code: "336320",
    title: "Windshield washer pumps, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title:
      "Windshield wiper systems, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336320",
    title:
      "Wiring harness and ignition sets for internal combustion engines manufacturing",
  },
  {
    code: "336330",
    title:
      "Automotive, truck and bus steering assemblies and parts manufacturing",
  },
  {
    code: "336330",
    title:
      "Automotive, truck and bus suspension assemblies and parts (except springs) manufacturing",
  },
  {
    code: "336330",
    title: "Power steering hose assemblies manufacturing",
  },
  {
    code: "336330",
    title: "Power steering pumps manufacturing",
  },
  {
    code: "336330",
    title: "Rack and pinion steering assemblies manufacturing",
  },
  {
    code: "336330",
    title: "Shock absorbers, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336330",
    title: "Steering boxes, manual and power assist, manufacturing",
  },
  {
    code: "336330",
    title: "Steering columns, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336330",
    title: "Steering wheels, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336330",
    title: "Struts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336330",
    title: "Wheels, steering, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title:
      "Air brake systems and parts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Brake and brake parts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title:
      "Brake caliper assemblies, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title:
      "Brake cylinders, master and wheel, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Brake discs (rotor), automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Brake drums, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Brake hose assemblies manufacturing",
  },
  {
    code: "336340",
    title: "Brake linings, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Brake pads and shoes, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Brake shoes and pads, asbestos, manufacturing",
  },
  {
    code: "336340",
    title: "Calipers, brake, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336340",
    title: "Cylinders, master brake (new and rebuilt), manufacturing",
  },
  {
    code: "336340",
    title:
      "Hydraulic slave cylinders, automotive, truck, and bus clutch, manufacturing",
  },
  {
    code: "336340",
    title: "Vacuum brake booster, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title:
      "Assembly line rebuilding of automotive, truck, and bus transmissions",
  },
  {
    code: "336350",
    title: "Automatic transmissions, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Axle bearings, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Clutches and clutch discs, asbestos, manufacturing",
  },
  {
    code: "336350",
    title:
      "Constant velocity joints, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title:
      "Differential and rear axle assemblies, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title:
      "Drive shafts and half shafts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title:
      "Gears (e.g., crown, pinion, spider), automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Joints, universal, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title:
      "Pressure and clutch plate assemblies, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Scattershield, engine, manufacturing",
  },
  {
    code: "336350",
    title: "Torque converters, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Transaxles, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Transmissions and parts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336350",
    title: "Universal joints, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336360",
    title: "Aircraft seats manufacturing",
  },
  {
    code: "336360",
    title: "Automobile seat covers manufacturing",
  },
  {
    code: "336360",
    title: "Automobile seat frames, metal, manufacturing",
  },
  {
    code: "336360",
    title: "Automobile trimmings, textile, manufacturing",
  },
  {
    code: "336360",
    title:
      "Motor vehicle interior systems (e.g., headliners, panels, seats, trims) manufacturing",
  },
  {
    code: "336360",
    title: "Motor vehicle seats manufacturing",
  },
  {
    code: "336360",
    title: "Motor vehicle seats, metal framed, manufacturing",
  },
  {
    code: "336360",
    title: "Motor vehicle trimmings manufacturing",
  },
  {
    code: "336360",
    title: "Railroad seating manufacturing",
  },
  {
    code: "336360",
    title: "Seat belts, motor vehicle and aircraft, manufacturing",
  },
  {
    code: "336360",
    title: "Seats for public conveyances, manufacturing",
  },
  {
    code: "336360",
    title: "Seats, railroad, manufacturing",
  },
  {
    code: "336360",
    title: "Tire covers made from purchased fabric",
  },
  {
    code: "336360",
    title: "Transportation equipment seating manufacturing",
  },
  {
    code: "336370",
    title: "Job stampings, automotive, metal, manufacturing",
  },
  {
    code: "336370",
    title: "Metal motor vehicle body parts stamping",
  },
  {
    code: "336370",
    title: "Moldings and trim, motor vehicle, stamping",
  },
  {
    code: "336370",
    title: "Motor vehicle metal bumper stampings",
  },
  {
    code: "336370",
    title: "Motor vehicle metal parts stamping",
  },
  {
    code: "336370",
    title:
      "Motor vehicle metal stampings (e.g., body parts, fenders, hub caps, tops, trim) manufacturing",
  },
  {
    code: "336370",
    title: "Stamping metal motor vehicle body parts",
  },
  {
    code: "336370",
    title: "Stamping metal motor vehicle moldings and trims",
  },
  {
    code: "336390",
    title: "Air bag assemblies manufacturing",
  },
  {
    code: "336390",
    title: "Air bag initiators manufacturing",
  },
  {
    code: "336390",
    title: "Air filters, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Air-conditioners, motor vehicle, manufacturing",
  },
  {
    code: "336390",
    title: "Automotive mirrors, framed, manufacturing",
  },
  {
    code: "336390",
    title:
      "Bumpers and bumperettes assembled, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title:
      "Catalytic converters, engine exhaust, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Compressors, motor vehicle air-conditioning, manufacturing",
  },
  {
    code: "336390",
    title: "Convertible tops for automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Exhaust and tail pipes, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title:
      "Exhaust systems and parts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title:
      "Filters (e.g., air, engine oil, fuel) automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Gas tanks assembled, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Hitches, trailer, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Luggage racks, car top, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title:
      "Mufflers and resonators, automotive, truck, and buses manufacturing",
  },
  {
    code: "336390",
    title: "Oil filters, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title:
      "Racks (e.g., bicycle, luggage, ski, tire), automotive, truck, and buses manufacturing",
  },
  {
    code: "336390",
    title: "Radiators and cores manufacturing",
  },
  {
    code: "336390",
    title: "Rims, automotive, truck, and bus wheel, manufacturing",
  },
  {
    code: "336390",
    title: "Sunroofs and parts, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Thermostats, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Tops, convertible automotive, manufacturing",
  },
  {
    code: "336390",
    title: "Towing bars and systems manufacturing",
  },
  {
    code: "336390",
    title: "Trailer hitches, motor vehicle, manufacturing",
  },
  {
    code: "336390",
    title: "Transmission coolers manufacturing",
  },
  {
    code: "336390",
    title: "Truck and trailer liftgates manufacturing",
  },
  {
    code: "336390",
    title: "Wheels (i.e., rims), automotive, truck, and bus, manufacturing",
  },
  {
    code: "336390",
    title: "Windshield wiper blades and refills manufacturing",
  },
  {
    code: "336390",
    title: "Wipers, windshield, automotive, truck, and bus, manufacturing",
  },
  {
    code: "336411",
    title: "Aircraft conversions (i.e., major modifications to system)",
  },
  {
    code: "336411",
    title: "Aircraft manufacturing",
  },
  {
    code: "336411",
    title: "Aircraft overhauling",
  },
  {
    code: "336411",
    title:
      "Aircraft rebuilding (i.e., restoration to original design specifications)",
  },
  {
    code: "336411",
    title: "Autogiros manufacturing",
  },
  {
    code: "336411",
    title: "Blimps (i.e., aircraft) manufacturing",
  },
  {
    code: "336411",
    title: "Developing and producing prototypes for aircraft",
  },
  {
    code: "336411",
    title: "Gliders (i.e., aircraft) manufacturing",
  },
  {
    code: "336411",
    title: "Hang gliders manufacturing",
  },
  {
    code: "336411",
    title: "Helicopters manufacturing",
  },
  {
    code: "336411",
    title: "Target drones, aircraft, manufacturing",
  },
  {
    code: "336411",
    title: "Ultra light aircraft manufacturing",
  },
  {
    code: "336411",
    title: "Unmanned and robotic aircraft manufacturing",
  },
  {
    code: "336412",
    title:
      "Aircraft engine and engine parts (except carburetors, pistons, piston rings, valves) manufacturing",
  },
  {
    code: "336412",
    title: "Aircraft engine overhauling",
  },
  {
    code: "336412",
    title: "Aircraft engine rebuilding",
  },
  {
    code: "336412",
    title: "Aircraft turbines manufacturing",
  },
  {
    code: "336412",
    title:
      "Developing and producing prototypes for aircraft engines and engine parts",
  },
  {
    code: "336412",
    title:
      "Engines and engine parts, aircraft (except carburetors, pistons, piston rings, valves), manufacturing",
  },
  {
    code: "336412",
    title: "Gas turbines, aircraft, manufacturing",
  },
  {
    code: "336412",
    title:
      "Gasoline engine parts (except carburetors, pistons, piston rings, valves), aircraft, manufacturing",
  },
  {
    code: "336412",
    title: "Gasoline engines, aircraft, manufacturing",
  },
  {
    code: "336412",
    title: "Internal combustion engines, aircraft, manufacturing",
  },
  {
    code: "336412",
    title:
      "Jet propulsion and internal combustion engines and parts, aircraft, manufacturing",
  },
  {
    code: "336412",
    title: "Rocket engines, aircraft, manufacturing",
  },
  {
    code: "336413",
    title:
      "Aircraft assemblies, subassemblies, and parts (except engines) manufacturing",
  },
  {
    code: "336413",
    title:
      "Aircraft auxiliary parts (e.g., crop dusting, external fuel tanks, inflight refueling equipment) manufacturing",
  },
  {
    code: "336413",
    title: "Aircraft brakes manufacturing",
  },
  {
    code: "336413",
    title: "Aircraft control surface assemblies manufacturing",
  },
  {
    code: "336413",
    title: "Aircraft fuselage wing tail and similar assemblies manufacturing",
  },
  {
    code: "336413",
    title: "Aircraft propellers and parts manufacturing",
  },
  {
    code: "336413",
    title: "Aircraft wheels manufacturing",
  },
  {
    code: "336413",
    title: "Airframe assemblies (except for guided missiles) manufacturing",
  },
  {
    code: "336413",
    title:
      "Developing and producing prototypes for aircraft parts (except engines) and auxiliary equipment",
  },
  {
    code: "336413",
    title: "Joints, universal, aircraft, manufacturing",
  },
  {
    code: "336413",
    title: "Targets, trailer type, aircraft, manufacturing",
  },
  {
    code: "336413",
    title: "Tow targets, aircraft, manufacturing",
  },
  {
    code: "336413",
    title: "Universal joints, aircraft, manufacturing",
  },
  {
    code: "336414",
    title:
      "Developing and producing prototypes for complete guided missiles and space vehicles",
  },
  {
    code: "336414",
    title: "Guided missile and space vehicle manufacturing",
  },
  {
    code: "336414",
    title: "Guided missiles, complete, assembling",
  },
  {
    code: "336414",
    title:
      "Rockets (guided missiles), space and military, complete, manufacturing",
  },
  {
    code: "336414",
    title: "Space vehicles, complete, manufacturing",
  },
  {
    code: "336415",
    title:
      "Developing and producing prototypes for guided missile and space vehicle engines",
  },
  {
    code: "336415",
    title: "Guided missile and space vehicle engine manufacturing",
  },
  {
    code: "336415",
    title:
      "Propulsion units and parts, guided missile and space vehicle, manufacturing",
  },
  {
    code: "336415",
    title: "Rocket engines, guided missile, manufacturing",
  },
  {
    code: "336419",
    title: "Airframe assemblies for guided missiles manufacturing",
  },
  {
    code: "336419",
    title:
      "Developing and producing prototypes for guided missile and space vehicle components",
  },
  {
    code: "336419",
    title:
      "Guided missile and space vehicle parts (except engines) manufacturing",
  },
  {
    code: "336419",
    title: "Space capsules manufacturing",
  },
  {
    code: "336510",
    title: "Brakes and parts for railroad rolling stock manufacturing",
  },
  {
    code: "336510",
    title: "Buses, trackless trolley, manufacturing",
  },
  {
    code: "336510",
    title: "Industrial locomotives and parts manufacturing",
  },
  {
    code: "336510",
    title: "Light rail cars and equipment manufacturing",
  },
  {
    code: "336510",
    title: "Locomotives manufacturing",
  },
  {
    code: "336510",
    title: "Locomotives rebuilding",
  },
  {
    code: "336510",
    title: "Lubrication systems, locomotive (except pumps), manufacturing",
  },
  {
    code: "336510",
    title: "Mining locomotives and parts manufacturing",
  },
  {
    code: "336510",
    title: "Rail laying and tamping equipment manufacturing",
  },
  {
    code: "336510",
    title: "Railroad cars and car equipment manufacturing",
  },
  {
    code: "336510",
    title: "Railroad cars, self-propelled, manufacturing",
  },
  {
    code: "336510",
    title:
      "Railroad locomotives and parts (except diesel engines) manufacturing",
  },
  {
    code: "336510",
    title: "Railroad rolling stock manufacturing",
  },
  {
    code: "336510",
    title: "Rapid transit cars and equipment manufacturing",
  },
  {
    code: "336510",
    title: "Rolling stock, railroad, rebuilding",
  },
  {
    code: "336510",
    title: "Streetcars and car equipment, urban transit, manufacturing",
  },
  {
    code: "336510",
    title: "Subway cars manufacturing",
  },
  {
    code: "336611",
    title: "Barge building",
  },
  {
    code: "336611",
    title: "Cargo ship building",
  },
  {
    code: "336611",
    title: "Container ship building",
  },
  {
    code: "336611",
    title: "Dredge building",
  },
  {
    code: "336611",
    title: "Drilling and production platforms, floating, oil and gas, building",
  },
  {
    code: "336611",
    title: "Drydock, floating, building",
  },
  {
    code: "336611",
    title: "Ferryboat building",
  },
  {
    code: "336611",
    title: "Fireboat building",
  },
  {
    code: "336611",
    title: "Fishing boat, commercial, building",
  },
  {
    code: "336611",
    title: "Hydrofoil vessel building and repairing in shipyard",
  },
  {
    code: "336611",
    title: "Naval ship building",
  },
  {
    code: "336611",
    title: "Oil and gas offshore floating platforms manufacturing",
  },
  {
    code: "336611",
    title: "Passenger ship building",
  },
  {
    code: "336611",
    title: "Patrol boat building",
  },
  {
    code: "336611",
    title: "Sailing ships, commercial, manufacturing",
  },
  {
    code: "336611",
    title: "Ship dismantling at shipyards",
  },
  {
    code: "336611",
    title: "Ship repair done in a shipyard",
  },
  {
    code: "336611",
    title: "Ship scaling services done at a shipyard",
  },
  {
    code: "336611",
    title:
      "Ships (i.e., not suitable or intended for personal use) manufacturing",
  },
  {
    code: "336611",
    title: "Shipyard (i.e., facility capable of building ships)",
  },
  {
    code: "336611",
    title: "Submarine building",
  },
  {
    code: "336611",
    title: "Towboat building and repairing",
  },
  {
    code: "336611",
    title: "Tugboat building",
  },
  {
    code: "336611",
    title:
      "Underwater remotely operated vehicles (ROVs) manufacturing in shipyards",
  },
  {
    code: "336611",
    title: "Unmanned and robotic watercraft manufacturing in shipyards",
  },
  {
    code: "336611",
    title: "Yachts built in shipyards",
  },
  {
    code: "336612",
    title: "Air boat building",
  },
  {
    code: "336612",
    title: "Boat yards (i.e., boat manufacturing facilities)",
  },
  {
    code: "336612",
    title: "Boats (e.g., motorboats, rowboats, canoes, kayaks) manufacturing ",
  },
  {
    code: "336612",
    title: "Boats (i.e., suitable or intended for personal use) manufacturing",
  },
  {
    code: "336612",
    title: "Boats, inflatable plastics (except toy-type), manufacturing",
  },
  {
    code: "336612",
    title: "Cabin cruiser building",
  },
  {
    code: "336612",
    title: "Dinghies manufacturing",
  },
  {
    code: "336612",
    title: "Dories building",
  },
  {
    code: "336612",
    title: "Hovercraft building",
  },
  {
    code: "336612",
    title: "Inflatable plastic boats, heavy-duty, manufacturing",
  },
  {
    code: "336612",
    title: "Inflatable rubber boats, heavy-duty, manufacturing",
  },
  {
    code: "336612",
    title: "Life rafts, inflatable, manufacturing",
  },
  {
    code: "336612",
    title: "Motorboat, inboard or outboard, building",
  },
  {
    code: "336612",
    title: "Pleasure boats manufacturing",
  },
  {
    code: "336612",
    title: "Rigid inflatable boats (RIBs) manufacturing",
  },
  {
    code: "336612",
    title: "Sailboat building, not done in shipyards",
  },
  {
    code: "336612",
    title:
      "Underwater remotely operated vehicles (ROVs) manufacturing in boat yards",
  },
  {
    code: "336612",
    title: "Unmanned and robotic watercraft manufacturing in boat yards",
  },
  {
    code: "336612",
    title: "Yacht building, not done in shipyards",
  },
  {
    code: "336991",
    title: "Bicycles and parts manufacturing",
  },
  {
    code: "336991",
    title: "Electric bicycles manufacturing",
  },
  {
    code: "336991",
    title: "Mopeds and parts manufacturing",
  },
  {
    code: "336991",
    title: "Motor scooters manufacturing",
  },
  {
    code: "336991",
    title: "Motorcycles and parts manufacturing",
  },
  {
    code: "336991",
    title: "Tricycles, metal, adult and children's, manufacturing",
  },
  {
    code: "336991",
    title: "Vehicle, children's, metal manufacturing",
  },
  {
    code: "336992",
    title: "Armored military vehicles (except tanks) and parts manufacturing",
  },
  {
    code: "336992",
    title: "Tanks, military (including factory rebuilding), manufacturing",
  },
  {
    code: "336992",
    title: "Weapons, self-propelled, manufacturing",
  },
  {
    code: "336999",
    title: "All-terrain vehicles (ATVs), wheeled or tracked, manufacturing",
  },
  {
    code: "336999",
    title: "Animal-drawn vehicles and parts manufacturing",
  },
  {
    code: "336999",
    title: "Food (vendor) carts on wheels manufacturing",
  },
  {
    code: "336999",
    title: "Gocarts (except children's) manufacturing",
  },
  {
    code: "336999",
    title: "Golf carts and similar motorized passenger carriers manufacturing",
  },
  {
    code: "336999",
    title: "Golf carts, powered, manufacturing",
  },
  {
    code: "336999",
    title:
      "Off-highway tracked vehicles (except construction, armored military) manufacturing",
  },
  {
    code: "336999",
    title:
      "Off-road all-terrain vehicles (ATVs), wheeled or tracked, manufacturing",
  },
  {
    code: "336999",
    title: "Personal watercraft manufacturing",
  },
  {
    code: "336999",
    title: "Race cars manufacturing",
  },
  {
    code: "336999",
    title: "Snowmobiles and parts manufacturing",
  },
  {
    code: "337110",
    title:
      "Bathroom vanities (except freestanding), stock or custom wood, manufacturing",
  },
  {
    code: "337110",
    title:
      "Cabinets, kitchen (except freestanding), stock or custom wood, manufacturing",
  },
  {
    code: "337110",
    title:
      "Countertops (i.e., kitchen, bathroom), wood or plastics laminated on wood, manufacturing",
  },
  {
    code: "337110",
    title: "Countertops, wood, manufacturing",
  },
  {
    code: "337110",
    title: "Drainboards, wood or plastics laminated on wood, manufacturing",
  },
  {
    code: "337110",
    title:
      "Kitchen cabinets (except freestanding), stock or custom wood, manufacturing",
  },
  {
    code: "337110",
    title:
      "Medicine cabinets (except freestanding), wood household-type, manufacturing",
  },
  {
    code: "337110",
    title:
      "Plastics laminated over particleboard (e.g., fixture tops) manufacturing",
  },
  {
    code: "337110",
    title:
      "Vanities (except freestanding), stock or custom wood, manufacturing",
  },
  {
    code: "337110",
    title: "Vanity tops, wood or plastics laminated on wood, manufacturing",
  },
  {
    code: "337121",
    title: "Chair and couch springs, assembled, manufacturing",
  },
  {
    code: "337121",
    title:
      "Chairs, upholstered household-type (except dining room, kitchen), manufacturing",
  },
  {
    code: "337121",
    title: "Convertible sofas (except futons) manufacturing",
  },
  {
    code: "337121",
    title: "Cot springs, assembled, manufacturing",
  },
  {
    code: "337121",
    title: "Couch springs, assembled, manufacturing",
  },
  {
    code: "337121",
    title: "Couches, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Cushion springs, assembled, manufacturing",
  },
  {
    code: "337121",
    title:
      "Furniture, household-type, upholstered on frames of any material, manufacturing",
  },
  {
    code: "337121",
    title: "Futons with frames manufacturing",
  },
  {
    code: "337121",
    title: "Household-type furniture, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Juvenile furniture, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Living room furniture, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Metal framed furniture, household-type, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Ottomans, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Recliners, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Rockers, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Sofa beds and chair beds, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Sofas, convertible (except futons), manufacturing",
  },
  {
    code: "337121",
    title: "Sofas, upholstered, manufacturing",
  },
  {
    code: "337121",
    title: "Upholstered furniture, household-type, custom, manufacturing",
  },
  {
    code: "337121",
    title:
      "Upholstered furniture, household-type, on frames of any material, manufacturing",
  },
  {
    code: "337121",
    title: "Wood framed furniture, upholstered, household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Bed frames, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title:
      "Bedroom furniture (except upholstered), wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Beds (except hospital), wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Beds, wood dormitory-type, manufacturing",
  },
  {
    code: "337122",
    title: "Beds, wood hotel-type, manufacturing",
  },
  {
    code: "337122",
    title: "Bookcases, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Buffets (furniture), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Cabinets, wood household-type, freestanding, manufacturing",
  },
  {
    code: "337122",
    title: "Camp furniture, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Card table sets (furniture), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Cedar chests manufacturing",
  },
  {
    code: "337122",
    title: "Chairs (except upholstered), wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "China closets, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Coffee tables, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Computer furniture, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Cots, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Cradles, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Cribs (i.e., baby beds), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Desks, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Dining room chairs (including upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Dining room furniture, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Dressers, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Dressing tables, wood, manufacturing",
  },
  {
    code: "337122",
    title: "End tables, wood, manufacturing",
  },
  {
    code: "337122",
    title:
      "Furniture, outdoor wood household-type (e.g., beach, garden, lawn, porch), manufacturing",
  },
  {
    code: "337122",
    title:
      "Furniture, unassembled or knock-down wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Furniture, unfinished wood household-type, manufacturing",
  },
  {
    code: "337122",
    title:
      "Furniture, wood household-type, not upholstered (except TV and radio housings, and sewing machine cabinets), manufacturing",
  },
  {
    code: "337122",
    title: "Futon frames manufacturing",
  },
  {
    code: "337122",
    title: "Garden furniture, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Hammocks, wood framed, manufacturing",
  },
  {
    code: "337122",
    title: "Headboards, wood, manufacturing",
  },
  {
    code: "337122",
    title: "High chairs, wood, children's, manufacturing",
  },
  {
    code: "337122",
    title: "Home entertainment centers, wood, manufacturing",
  },
  {
    code: "337122",
    title:
      "Household-type furniture, wood, not upholstered (except TV and radio housings and sewing machine cabinets), manufacturing",
  },
  {
    code: "337122",
    title: "Juvenile furniture (except upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Kitchen chairs (e.g., upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Kitchen furniture, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Knickknack shelves, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Lawn furniture, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Living room furniture (except upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Magazine racks, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Night stands, wood, manufacturing",
  },
  {
    code: "337122",
    title:
      "Nonupholstered, household-type, custom wood furniture, manufacturing",
  },
  {
    code: "337122",
    title: "Nursery furniture (except upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Playpens, children's wood, manufacturing",
  },
  {
    code: "337122",
    title: "Porch furniture (except upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Rockers (except upholstered), wood, manufacturing",
  },
  {
    code: "337122",
    title: "Room dividers, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Serving carts, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Stools, wood household-type (except upholstered), manufacturing",
  },
  {
    code: "337122",
    title: "Tables, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title:
      "TV stands and similar stands for consumer electronics, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Vanities, freestanding, wood, manufacturing",
  },
  {
    code: "337122",
    title: "Wardrobes, wood household-type, manufacturing",
  },
  {
    code: "337122",
    title: "Water bed frames, wood, manufacturing",
  },
  {
    code: "337126",
    title:
      "Bamboo furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Bassinets, reed and rattan, manufacturing",
  },
  {
    code: "337126",
    title:
      "Beds (including cabinet and folding), metal household-type (except hospital), manufacturing",
  },
  {
    code: "337126",
    title: "Bookcases (except wood), household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Cabinets, metal (i.e., bathroom, kitchen), manufacturing",
  },
  {
    code: "337126",
    title: "Cabinets, metal household-type, freestanding, manufacturing",
  },
  {
    code: "337126",
    title: "Cabinets, metal, radio and television, manufacturing",
  },
  {
    code: "337126",
    title: "Camp furniture, metal, manufacturing",
  },
  {
    code: "337126",
    title: "Camp furniture, reed and rattan, manufacturing",
  },
  {
    code: "337126",
    title: "Car seats, infant, manufacturing",
  },
  {
    code: "337126",
    title: "Card table sets, metal, manufacturing",
  },
  {
    code: "337126",
    title: "Chairs, cane, household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Chairs, metal household-type (except upholstered), manufacturing",
  },
  {
    code: "337126",
    title: "Computer furniture, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Cots, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Cribs (i.e., baby beds), metal, manufacturing",
  },
  {
    code: "337126",
    title: "Dinette sets, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Dining room chairs (including upholstered), metal, manufacturing",
  },
  {
    code: "337126",
    title:
      "Dining room chairs (including upholstered), plastics, manufacturing",
  },
  {
    code: "337126",
    title: "Dining room furniture, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Dressers, metal, manufacturing",
  },
  {
    code: "337126",
    title: "Dressing tables, metal, manufacturing",
  },
  {
    code: "337126",
    title: "End tables, metal, manufacturing",
  },
  {
    code: "337126",
    title:
      "Fiber furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title:
      "Furniture (except wood, upholstered), indoor and outdoor (e.g., beach, garden, lawn, porch) household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Hammocks, metal framed, manufacturing",
  },
  {
    code: "337126",
    title: "Hampers, laundry, reed, wicker, rattan, manufacturing",
  },
  {
    code: "337126",
    title: "Home entertainment centers, metal, manufacturing",
  },
  {
    code: "337126",
    title: "Juvenile furniture (except wood, upholstered) manufacturing",
  },
  {
    code: "337126",
    title: "Juvenile furniture, rattan and reed, manufacturing",
  },
  {
    code: "337126",
    title: "Kitchen chairs (including upholstered), metal, manufacturing",
  },
  {
    code: "337126",
    title: "Kitchen chairs (including upholstered), plastics, manufacturing",
  },
  {
    code: "337126",
    title: "Kitchen furniture, household-type, metal, manufacturing",
  },
  {
    code: "337126",
    title: "Kitchen furniture, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Laundry hampers, rattan, reed, wicker or willow, manufacturing",
  },
  {
    code: "337126",
    title: "Lawn furniture (except concrete, stone, wood) manufacturing",
  },
  {
    code: "337126",
    title: "Living room furniture (except upholstered), metal, manufacturing",
  },
  {
    code: "337126",
    title:
      "Malacca furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Medicine cabinets, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Nursery furniture, metal, manufacturing",
  },
  {
    code: "337126",
    title:
      "Plastics (including fiberglass) furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Playpens, children's metal, manufacturing",
  },
  {
    code: "337126",
    title: "Porch swings, metal, manufacturing",
  },
  {
    code: "337126",
    title: "Rattan furniture, household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Reed furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Serving carts, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Stools, metal household-type (except upholstered), manufacturing",
  },
  {
    code: "337126",
    title: "Tables, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title:
      "TV stands and similar stands for consumer electronics, metal, manufacturing",
  },
  {
    code: "337126",
    title:
      "TV stands and similar stands for consumer electronics, plastics, manufacturing",
  },
  {
    code: "337126",
    title: "Vanities, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Wardrobes, metal household-type, manufacturing",
  },
  {
    code: "337126",
    title: "Water bed frames, metal, manufacturing",
  },
  {
    code: "337126",
    title:
      "Wicker furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title:
      "Willow furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337126",
    title:
      "Wrought iron furniture (except upholstered), household-type, manufacturing",
  },
  {
    code: "337127",
    title: "Benches, park-type (except concrete, stone), manufacturing",
  },
  {
    code: "337127",
    title: "Benches, public building-type, manufacturing",
  },
  {
    code: "337127",
    title: "Benches, work, manufacturing",
  },
  {
    code: "337127",
    title: "Bleacher seating manufacturing",
  },
  {
    code: "337127",
    title: "Bowling center furniture manufacturing",
  },
  {
    code: "337127",
    title: "Cafeteria furniture manufacturing",
  },
  {
    code: "337127",
    title: "Cafeteria tables and benches manufacturing",
  },
  {
    code: "337127",
    title: "Chairs, barber, beauty shop (i.e., hydraulic), manufacturing",
  },
  {
    code: "337127",
    title: "Chairs, portable folding, auditorium-type, manufacturing",
  },
  {
    code: "337127",
    title: "Chairs, stacking, auditorium-type, manufacturing",
  },
  {
    code: "337127",
    title: "Church furniture (except concrete, stone) manufacturing",
  },
  {
    code: "337127",
    title: "Drafting tables and boards manufacturing",
  },
  {
    code: "337127",
    title: "Drawing tables and boards, artist's, manufacturing",
  },
  {
    code: "337127",
    title:
      "Furniture, factory-type (e.g., cabinets, stools, tool stands, work benches), manufacturing",
  },
  {
    code: "337127",
    title: "Furniture, institutional, manufacturing",
  },
  {
    code: "337127",
    title:
      "Furniture, laboratory-type (e.g., benches, cabinets, stools, tables), manufacturing",
  },
  {
    code: "337127",
    title:
      "Furniture, public building (e.g., church, library, school, theater), manufacturing",
  },
  {
    code: "337127",
    title: "Furniture, restaurant-type, manufacturing",
  },
  {
    code: "337127",
    title: "Institutional furniture manufacturing",
  },
  {
    code: "337127",
    title:
      "Laboratory-type furniture (e.g., benches, cabinets, stools, tables) (except dental) manufacturing",
  },
  {
    code: "337127",
    title: "Lunchroom tables and chairs manufacturing",
  },
  {
    code: "337127",
    title: "Pews, church, manufacturing",
  },
  {
    code: "337127",
    title: "Prison bed manufacturing",
  },
  {
    code: "337127",
    title: "Religious furniture manufacturing",
  },
  {
    code: "337127",
    title:
      "Restaurant furniture (e.g., carts, chairs, foodwagons, tables) manufacturing",
  },
  {
    code: "337127",
    title: "School furniture manufacturing",
  },
  {
    code: "337127",
    title: "Ship furniture manufacturing",
  },
  {
    code: "337127",
    title: "Stadium seating manufacturing",
  },
  {
    code: "337127",
    title: "Theater seating manufacturing",
  },
  {
    code: "337127",
    title: "Tool stands, factory, manufacturing",
  },
  {
    code: "337127",
    title: "Tray trucks, restaurant, manufacturing",
  },
  {
    code: "337127",
    title: "Work benches manufacturing",
  },
  {
    code: "337211",
    title: "Bookcases, wood office-type, manufacturing",
  },
  {
    code: "337211",
    title: "Cabinets, wood office-type, freestanding, manufacturing",
  },
  {
    code: "337211",
    title: "Chairs, wood office-type, manufacturing",
  },
  {
    code: "337211",
    title: "Desks, wood office-type, manufacturing",
  },
  {
    code: "337211",
    title: "Filing cabinets, wood, office-type, manufacturing",
  },
  {
    code: "337211",
    title:
      "Furniture, office-type, padded, upholstered, or plain wood, manufacturing",
  },
  {
    code: "337211",
    title: "Modular furniture systems, wood frame office-type, manufacturing",
  },
  {
    code: "337211",
    title:
      "Office furniture, padded, upholstered, or plain wood, manufacturing",
  },
  {
    code: "337211",
    title: "Tables, wood, office-type, manufacturing",
  },
  {
    code: "337212",
    title:
      "Architectural woodwork and fixtures (i.e., custom designed interiors) manufacturing",
  },
  {
    code: "337212",
    title:
      "Custom architectural millwork and fixtures, manufacturing on a job shop basis",
  },
  {
    code: "337212",
    title:
      "Custom design interiors (i.e., coordinated furniture, architectural woodwork, fixtures), manufacturing",
  },
  {
    code: "337212",
    title: "Millwork, custom architectural, manufacturing",
  },
  {
    code: "337214",
    title: "Bookcases (except wood), office-type, manufacturing",
  },
  {
    code: "337214",
    title: "Cabinets (except wood), office-type, freestanding, manufacturing",
  },
  {
    code: "337214",
    title: "Chairs (except wood), office-type, manufacturing",
  },
  {
    code: "337214",
    title: "Desks (except wood), office-type, manufacturing",
  },
  {
    code: "337214",
    title: "Filing cabinets (except wood), office-type, manufacturing",
  },
  {
    code: "337214",
    title:
      "Furniture (except wood), office-type, padded, upholstered, or plain, manufacturing",
  },
  {
    code: "337214",
    title:
      "Modular furniture systems (except wood frame), office-type, manufacturing",
  },
  {
    code: "337214",
    title:
      "Office furniture (except wood), padded, upholstered, or plain (except wood), manufacturing",
  },
  {
    code: "337214",
    title: "Tables (except wood), office-type, manufacturing",
  },
  {
    code: "337215",
    title: "Box spring frames manufacturing",
  },
  {
    code: "337215",
    title: "Cafeteria fixtures manufacturing",
  },
  {
    code: "337215",
    title: "Chair glides manufacturing",
  },
  {
    code: "337215",
    title: "Chair seats for furniture manufacturing",
  },
  {
    code: "337215",
    title: "Counter units (except refrigerated) manufacturing",
  },
  {
    code: "337215",
    title:
      "Countertops (except kitchen and bathroom), wood or plastics laminated on wood, manufacturing",
  },
  {
    code: "337215",
    title: "Display cases and fixtures (except refrigerated) manufacturing",
  },
  {
    code: "337215",
    title: "Fixtures, store display, manufacturing",
  },
  {
    code: "337215",
    title: "Furniture frames and parts, metal, manufacturing",
  },
  {
    code: "337215",
    title: "Furniture frames, wood, manufacturing",
  },
  {
    code: "337215",
    title: "Furniture parts, finished metal, manufacturing",
  },
  {
    code: "337215",
    title: "Furniture parts, finished plastics, manufacturing",
  },
  {
    code: "337215",
    title: "Furniture parts, finished wood, manufacturing",
  },
  {
    code: "337215",
    title: "Lockers (except refrigerated) manufacturing",
  },
  {
    code: "337215",
    title: "Mail carrier cases and tables, wood, manufacturing",
  },
  {
    code: "337215",
    title: "Partitions for floor attachment, prefabricated, manufacturing",
  },
  {
    code: "337215",
    title: "Partitions, freestanding, prefabricated, manufacturing",
  },
  {
    code: "337215",
    title: "Postal service lock boxes manufacturing",
  },
  {
    code: "337215",
    title: "Shelving (except wire) manufacturing",
  },
  {
    code: "337215",
    title: "Showcases (except refrigerated) manufacturing",
  },
  {
    code: "337215",
    title: "Sleeper mechanisms, convertible bed, manufacturing",
  },
  {
    code: "337215",
    title: "Stands (except wire), merchandise display, manufacturing",
  },
  {
    code: "337215",
    title: "Store display fixtures manufacturing",
  },
  {
    code: "337215",
    title: "Table tops, wood, manufacturing",
  },
  {
    code: "337215",
    title: "Telephone booths manufacturing",
  },
  {
    code: "337910",
    title:
      "Beds, sleep-system ensembles (i.e., flotation, adjustable), manufacturing",
  },
  {
    code: "337910",
    title: "Box springs, assembled, made from purchased spring",
  },
  {
    code: "337910",
    title: "Innerspring cushions manufacturing",
  },
  {
    code: "337910",
    title:
      "Mattresses (i.e., box spring, innerspring, noninnerspring) manufacturing",
  },
  {
    code: "337910",
    title:
      "Mattresses made from felt, foam rubber, urethane and similar materials",
  },
  {
    code: "337910",
    title: "Springs, assembled bed and box, made from purchased springs",
  },
  {
    code: "337910",
    title: "Water bed mattresses manufacturing",
  },
  {
    code: "337920",
    title: "Bamboo window blinds and shades manufacturing",
  },
  {
    code: "337920",
    title:
      "Blinds (e.g., mini, venetian, vertical), all materials, manufacturing",
  },
  {
    code: "337920",
    title:
      "Curtain or drapery fixtures (e.g., poles, rods, rollers) manufacturing",
  },
  {
    code: "337920",
    title: "Curtain rods and fittings manufacturing",
  },
  {
    code: "337920",
    title:
      "Fixtures (e.g., poles, rods, rollers), curtain and drapery, manufacturing",
  },
  {
    code: "337920",
    title: "Miniblinds manufacturing",
  },
  {
    code: "337920",
    title: "Porch shades, wood slat, manufacturing",
  },
  {
    code: "337920",
    title: "Shade pulls, window, manufacturing",
  },
  {
    code: "337920",
    title: "Shades, window (except outdoor canvas awnings), manufacturing",
  },
  {
    code: "337920",
    title: "Venetian blinds manufacturing",
  },
  {
    code: "337920",
    title: "Vertical blinds manufacturing",
  },
  {
    code: "337920",
    title: "Window shade rollers and fittings manufacturing",
  },
  {
    code: "337920",
    title: "Window shades (except awnings) manufacturing",
  },
  {
    code: "339112",
    title: "Anesthesia apparatus manufacturing",
  },
  {
    code: "339112",
    title: "Blood pressure apparatus manufacturing",
  },
  {
    code: "339112",
    title: "Blood transfusion equipment manufacturing",
  },
  {
    code: "339112",
    title: "Bone drills manufacturing",
  },
  {
    code: "339112",
    title: "Bone plates and screws manufacturing",
  },
  {
    code: "339112",
    title: "Bone rongeurs manufacturing",
  },
  {
    code: "339112",
    title: "Bronchoscopes (except electromedical) manufacturing",
  },
  {
    code: "339112",
    title: "Cannulae manufacturing",
  },
  {
    code: "339112",
    title: "Catheters manufacturing",
  },
  {
    code: "339112",
    title: "Clamps, surgical, manufacturing",
  },
  {
    code: "339112",
    title: "Corneal microscopes manufacturing",
  },
  {
    code: "339112",
    title: "Cystoscopes (except electromedical) manufacturing",
  },
  {
    code: "339112",
    title: "Eye examining instruments and apparatus manufacturing",
  },
  {
    code: "339112",
    title: "Forceps, surgical, manufacturing",
  },
  {
    code: "339112",
    title: "Gastroscopes (except electromedical) manufacturing",
  },
  {
    code: "339112",
    title: "Hypodermic needles and syringes manufacturing",
  },
  {
    code: "339112",
    title: "Inhalation therapy equipment manufacturing",
  },
  {
    code: "339112",
    title: "Inhalators, surgical and medical, manufacturing",
  },
  {
    code: "339112",
    title: "Instruments, mechanical microsurgical, manufacturing",
  },
  {
    code: "339112",
    title: "IV apparatus manufacturing",
  },
  {
    code: "339112",
    title: "Knives, surgical, manufacturing",
  },
  {
    code: "339112",
    title: "Medical thermometers manufacturing",
  },
  {
    code: "339112",
    title: "Needles, hypodermic and suture, manufacturing",
  },
  {
    code: "339112",
    title:
      "Ophthalmic instruments and apparatus (except laser surgical) manufacturing",
  },
  {
    code: "339112",
    title: "Ophthalmometers and ophthalmoscopes manufacturing",
  },
  {
    code: "339112",
    title: "Optometers manufacturing",
  },
  {
    code: "339112",
    title: "Oxygen tents manufacturing",
  },
  {
    code: "339112",
    title: "Pelvimeters manufacturing",
  },
  {
    code: "339112",
    title: "Physiotherapy equipment (except electrotherapeutic) manufacturing",
  },
  {
    code: "339112",
    title: "Probes, surgical, manufacturing",
  },
  {
    code: "339112",
    title: "Retinoscopes (except electromedical) manufacturing",
  },
  {
    code: "339112",
    title: "Retractors, medical, manufacturing",
  },
  {
    code: "339112",
    title: "Saws, surgical, manufacturing",
  },
  {
    code: "339112",
    title: "Skin grafting equipment manufacturing",
  },
  {
    code: "339112",
    title: "Speculums manufacturing",
  },
  {
    code: "339112",
    title: "Sphygmomanometers manufacturing",
  },
  {
    code: "339112",
    title: "Stethoscopes manufacturing",
  },
  {
    code: "339112",
    title: "Suction therapy apparatus manufacturing",
  },
  {
    code: "339112",
    title: "Surgical clamps manufacturing",
  },
  {
    code: "339112",
    title: "Surgical knife blades and handles manufacturing",
  },
  {
    code: "339112",
    title: "Surgical stapling devices manufacturing",
  },
  {
    code: "339112",
    title: "Syringes, hypodermic, manufacturing",
  },
  {
    code: "339112",
    title: "Thermometers, medical, manufacturing",
  },
  {
    code: "339112",
    title: "Tonometers, medical, manufacturing",
  },
  {
    code: "339112",
    title: "Trocars manufacturing",
  },
  {
    code: "339112",
    title: "Veterinarians' instruments and apparatus manufacturing",
  },
  {
    code: "339113",
    title: "Adhesive tape, medical, manufacturing",
  },
  {
    code: "339113",
    title: "Arch supports, orthopedic, manufacturing",
  },
  {
    code: "339113",
    title: "Artificial limbs manufacturing",
  },
  {
    code: "339113",
    title: "Autoclaves, laboratory-type (except dental), manufacturing",
  },
  {
    code: "339113",
    title: "Bandages and dressings, surgical and orthopedic, manufacturing",
  },
  {
    code: "339113",
    title: "Beds, hospital, manufacturing",
  },
  {
    code: "339113",
    title: "Biohazard protective clothing and accessories manufacturing",
  },
  {
    code: "339113",
    title: "Blood testing apparatus, laboratory-type, manufacturing",
  },
  {
    code: "339113",
    title: "Bulletproof vests manufacturing",
  },
  {
    code: "339113",
    title: "Bunsen burners manufacturing",
  },
  {
    code: "339113",
    title: "Cervical collars manufacturing",
  },
  {
    code: "339113",
    title: "Clean room suits and accessories manufacturing",
  },
  {
    code: "339113",
    title: "Colostomy appliances manufacturing",
  },
  {
    code: "339113",
    title: "Corn remover and bunion pad manufacturing",
  },
  {
    code: "339113",
    title: "Corsets, surgical, manufacturing",
  },
  {
    code: "339113",
    title: "Cotton and cotton balls, absorbent, manufacturing",
  },
  {
    code: "339113",
    title: "Cotton tipped applicators manufacturing",
  },
  {
    code: "339113",
    title: "Crutches and walkers manufacturing",
  },
  {
    code: "339113",
    title: "Depressors, tongue, manufacturing",
  },
  {
    code: "339113",
    title: "Drapes, surgical, disposable, manufacturing",
  },
  {
    code: "339113",
    title: "Dressings, surgical, manufacturing",
  },
  {
    code: "339113",
    title: "Dryers, laboratory-type, manufacturing",
  },
  {
    code: "339113",
    title: "Elastic hosiery, orthopedic, manufacturing",
  },
  {
    code: "339113",
    title: "Firefighting suits and accessories manufacturing",
  },
  {
    code: "339113",
    title: "First-aid, snake bite, or burn kits manufacturing",
  },
  {
    code: "339113",
    title: "Foot appliances, orthopedic, manufacturing",
  },
  {
    code: "339113",
    title:
      "Furniture, hospital, specialized (e.g., hospital beds, operating room furniture), manufacturing",
  },
  {
    code: "339113",
    title: "Gas masks manufacturing",
  },
  {
    code: "339113",
    title: "Gauze, surgical, made from purchased fabric",
  },
  {
    code: "339113",
    title:
      "Gloves, rubber (e.g., electrician's, examination, household-type, surgeon's), manufacturing",
  },
  {
    code: "339113",
    title: "Gynecological supplies and appliances manufacturing",
  },
  {
    code: "339113",
    title: "Hard hats manufacturing",
  },
  {
    code: "339113",
    title:
      "Helmets (except athletic), safety (e.g., motorized vehicle crash helmets, space helmets), manufacturing",
  },
  {
    code: "339113",
    title: "Hosiery, orthopedic support, manufacturing",
  },
  {
    code: "339113",
    title: "Hospital beds manufacturing",
  },
  {
    code: "339113",
    title:
      "Hospital furniture, specialized (e.g., hospital beds, operating room furniture)",
  },
  {
    code: "339113",
    title: "Hydrotherapy equipment manufacturing",
  },
  {
    code: "339113",
    title: "Implants, surgical, manufacturing",
  },
  {
    code: "339113",
    title: "Incubators, infant, manufacturing",
  },
  {
    code: "339113",
    title: "Incubators, laboratory-type, manufacturing",
  },
  {
    code: "339113",
    title: "Infant incubators manufacturing",
  },
  {
    code: "339113",
    title: "Intraocular lenses manufacturing",
  },
  {
    code: "339113",
    title: "Intrauterine devices manufacturing",
  },
  {
    code: "339113",
    title: "Laboratory-type evaporation apparatus manufacturing",
  },
  {
    code: "339113",
    title: "Laboratory-type sample preparation apparatus manufacturing",
  },
  {
    code: "339113",
    title: "Life preservers manufacturing",
  },
  {
    code: "339113",
    title: "Limbs, artificial, manufacturing",
  },
  {
    code: "339113",
    title: "Metal fabric and mesh safety gloves manufacturing",
  },
  {
    code: "339113",
    title: "Noise protectors, personal, manufacturing",
  },
  {
    code: "339113",
    title: "Nose and ear plugs manufacturing",
  },
  {
    code: "339113",
    title: "Operating room tables manufacturing",
  },
  {
    code: "339113",
    title: "Orthopedic canes manufacturing",
  },
  {
    code: "339113",
    title: "Orthopedic device manufacturing and sale in retail environment",
  },
  {
    code: "339113",
    title: "Orthopedic devices manufacturing",
  },
  {
    code: "339113",
    title: "Orthopedic extension shoes manufacturing",
  },
  {
    code: "339113",
    title: "Orthopedic hosiery, elastic, manufacturing",
  },
  {
    code: "339113",
    title: "Personal safety devices, not specified elsewhere, manufacturing",
  },
  {
    code: "339113",
    title: "Prosthetic appliances and supplies manufacturing",
  },
  {
    code: "339113",
    title: "Radiation shielding aprons, gloves, and sheeting manufacturing",
  },
  {
    code: "339113",
    title: "Respiratory protection mask manufacturing",
  },
  {
    code: "339113",
    title: "Restraints, patient, manufacturing",
  },
  {
    code: "339113",
    title: "Shoes, orthopedic extension, manufacturing",
  },
  {
    code: "339113",
    title: "Slitting medical adhesive tapes for the trade",
  },
  {
    code: "339113",
    title: "Space suits manufacturing",
  },
  {
    code: "339113",
    title: "Splints manufacturing",
  },
  {
    code: "339113",
    title: "Sterilizers, hospital and surgical, manufacturing",
  },
  {
    code: "339113",
    title: "Sterilizers, laboratory-type (except dental), manufacturing",
  },
  {
    code: "339113",
    title: "Stretchers, medical, manufacturing",
  },
  {
    code: "339113",
    title: "Suits, firefighting, manufacturing",
  },
  {
    code: "339113",
    title: "Suits, space, manufacturing",
  },
  {
    code: "339113",
    title:
      "Supports, orthopedic (e.g., abdominal, ankle, arch, kneecap), manufacturing",
  },
  {
    code: "339113",
    title: "Surgical and medical masks manufacturing",
  },
  {
    code: "339113",
    title: "Surgical dressings manufacturing",
  },
  {
    code: "339113",
    title: "Surgical implants manufacturing",
  },
  {
    code: "339113",
    title: "Surgical supplies (except medical instruments) manufacturing",
  },
  {
    code: "339113",
    title: "Sutures, surgical, manufacturing",
  },
  {
    code: "339113",
    title: "Tapes, medical adhesive, manufacturing",
  },
  {
    code: "339113",
    title: "Tongue depressors manufacturing",
  },
  {
    code: "339113",
    title: "Traction apparatus manufacturing",
  },
  {
    code: "339113",
    title: "Ultrasonic medical cleaning equipment manufacturing",
  },
  {
    code: "339113",
    title: "Vacuum pumps, laboratory-type, manufacturing",
  },
  {
    code: "339113",
    title: "Welder's hoods manufacturing",
  },
  {
    code: "339113",
    title: "Wheelchairs manufacturing",
  },
  {
    code: "339113",
    title: "Whirlpool baths (i.e., hydrotherapy equipment) manufacturing",
  },
  {
    code: "339114",
    title: "Abrasive points, wheels, and disks, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Amalgams, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Autoclaves, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Cements, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Chairs, dentist's, manufacturing",
  },
  {
    code: "339114",
    title: "Cutting instruments, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Dental alloys for amalgams manufacturing",
  },
  {
    code: "339114",
    title: "Dental chairs manufacturing",
  },
  {
    code: "339114",
    title: "Dental equipment and instruments manufacturing",
  },
  {
    code: "339114",
    title: "Dental glues and cements manufacturing",
  },
  {
    code: "339114",
    title: "Dental hand instruments (e.g., forceps) manufacturing",
  },
  {
    code: "339114",
    title: "Dental impression materials manufacturing",
  },
  {
    code: "339114",
    title: "Dental instrument delivery systems manufacturing",
  },
  {
    code: "339114",
    title: "Dental laboratory equipment manufacturing",
  },
  {
    code: "339114",
    title: "Dental wax manufacturing",
  },
  {
    code: "339114",
    title: "Denture materials manufacturing",
  },
  {
    code: "339114",
    title: "Drills, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Enamels, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Furnaces, dental laboratory, manufacturing",
  },
  {
    code: "339114",
    title: "Glue, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Impression material, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Orthodontic appliances manufacturing",
  },
  {
    code: "339114",
    title: "Points, abrasive dental, manufacturing",
  },
  {
    code: "339114",
    title: "Sterilizers, dental, manufacturing",
  },
  {
    code: "339114",
    title: "Teeth (except customized) manufacturing",
  },
  {
    code: "339114",
    title: "Tools, dentists', manufacturing",
  },
  {
    code: "339114",
    title: "Ultrasonic dental equipment manufacturing",
  },
  {
    code: "339115",
    title: "Contact lenses manufacturing",
  },
  {
    code: "339115",
    title:
      "Eyeglass frames (i.e., fronts and temples), ophthalmic, manufacturing",
  },
  {
    code: "339115",
    title: "Eyes, glass and plastics, manufacturing",
  },
  {
    code: "339115",
    title: "Goggles (e.g., industrial, safety, sun, underwater) manufacturing",
  },
  {
    code: "339115",
    title: "Lens coating, ophthalmic",
  },
  {
    code: "339115",
    title: "Lens grinding, ophthalmic (except in retail stores)",
  },
  {
    code: "339115",
    title: "Lens mounts, ophthalmic, manufacturing",
  },
  {
    code: "339115",
    title: "Lens polishing, ophthalmic",
  },
  {
    code: "339115",
    title: "Lenses, ophthalmic, manufacturing",
  },
  {
    code: "339115",
    title: "Magnifiers, corrective vision-type, manufacturing",
  },
  {
    code: "339115",
    title: "Sunglasses and goggles manufacturing",
  },
  {
    code: "339115",
    title:
      "Temples and fronts (i.e., eyeglass frames), ophthalmic, manufacturing",
  },
  {
    code: "339116",
    title: "Bridges, custom made in dental laboratories",
  },
  {
    code: "339116",
    title: "Dental laboratories",
  },
  {
    code: "339116",
    title: "Dentures, custom made in dental laboratories",
  },
  {
    code: "339116",
    title: "Mouth guards and protectors, custom made in dental laboratories",
  },
  {
    code: "339116",
    title: "Orthodontic appliance, custom made in dental laboratories",
  },
  {
    code: "339116",
    title: "Teeth, custom made in dental laboratories",
  },
  {
    code: "339910",
    title: "Bracelets, precious metal, manufacturing",
  },
  {
    code: "339910",
    title:
      "Buttons, precious metal, precious stones, semiprecious stones, manufacturing",
  },
  {
    code: "339910",
    title: "Card cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Cases, jewelry, metal, manufacturing",
  },
  {
    code: "339910",
    title: "Chains or necklace, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Checkbook covers, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Cigar cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Cigarette cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Coin purses, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Comb cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Compacts, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Cosmetic bags, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Costume jewelry manufacturing",
  },
  {
    code: "339910",
    title: "Cuff links, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Cutlery, precious metal (except precious plated), manufacturing",
  },
  {
    code: "339910",
    title: "Diamond cutting and polishing",
  },
  {
    code: "339910",
    title: "Drilling pearls",
  },
  {
    code: "339910",
    title: "Engraving and etching precious metal flatware",
  },
  {
    code: "339910",
    title: "Engraving and etching precious metal jewelry",
  },
  {
    code: "339910",
    title: "Engraving and/or etching costume jewelry",
  },
  {
    code: "339910",
    title: "Findings, jeweler's, manufacturing",
  },
  {
    code: "339910",
    title: "Handbags, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Hollowware, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Jewel settings and mountings, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Jeweler's findings and materials manufacturing",
  },
  {
    code: "339910",
    title: "Jewelry, costume, manufacturing",
  },
  {
    code: "339910",
    title: "Jewelry, natural or cultured pearls, manufacturing",
  },
  {
    code: "339910",
    title: "Jewelry, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Key cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Lapidary work manufacturing",
  },
  {
    code: "339910",
    title:
      "Lighters, cigar and cigarette, clad with precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Novelties, precious metal (except precious plated), manufacturing",
  },
  {
    code: "339910",
    title: "Pearl drilling, peeling, or sawing",
  },
  {
    code: "339910",
    title: "Pearls, costume, manufacturing",
  },
  {
    code: "339910",
    title: "Personal goods, metal, manufacturing",
  },
  {
    code: "339910",
    title: "Pewter ware manufacturing",
  },
  {
    code: "339910",
    title: "Pins and brooches, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Pocketbooks, precious metal, men's or women's, manufacturing",
  },
  {
    code: "339910",
    title: "Purses, precious metal or clad with precious metal, manufacturing",
  },
  {
    code: "339910",
    title:
      "Rosaries and other small religious articles, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Sewing cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Stamping coins",
  },
  {
    code: "339910",
    title: "Straps, watch, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Table cutlery, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Tobacco pouches, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Toilet kits and cases, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Trophies, precious metal (except precious plated), manufacturing",
  },
  {
    code: "339910",
    title: "Wallets, precious metal, manufacturing",
  },
  {
    code: "339910",
    title: "Watch bands, metal, manufacturing",
  },
  {
    code: "339920",
    title: "Archery equipment manufacturing",
  },
  {
    code: "339920",
    title:
      "Athletic goods (except ammunition, clothing, footwear, small arms) manufacturing",
  },
  {
    code: "339920",
    title: "Badminton equipment manufacturing",
  },
  {
    code: "339920",
    title: "Bags, golf, manufacturing",
  },
  {
    code: "339920",
    title: "Bags, punching, manufacturing",
  },
  {
    code: "339920",
    title: "Bait, artificial, fishing, manufacturing",
  },
  {
    code: "339920",
    title:
      "Balls, baseball, basketball, football, golf, tennis, pool, and bowling, manufacturing",
  },
  {
    code: "339920",
    title:
      "Baseball equipment and supplies (except footwear, uniforms) manufacturing",
  },
  {
    code: "339920",
    title:
      "Basketball equipment and supplies (except footwear, uniforms) manufacturing",
  },
  {
    code: "339920",
    title: "Billiard equipment and supplies manufacturing",
  },
  {
    code: "339920",
    title: "Bobsleds manufacturing",
  },
  {
    code: "339920",
    title: "Boomerangs manufacturing",
  },
  {
    code: "339920",
    title: "Bowling pin machines, automatic, manufacturing",
  },
  {
    code: "339920",
    title: "Bows, archery, manufacturing",
  },
  {
    code: "339920",
    title: "Boxing equipment manufacturing",
  },
  {
    code: "339920",
    title: "Caddy carts manufacturing",
  },
  {
    code: "339920",
    title: "Carts, caddy, manufacturing",
  },
  {
    code: "339920",
    title: "Clubs, sporting goods (e.g., golf, Indian), manufacturing",
  },
  {
    code: "339920",
    title: "Croquet sets manufacturing",
  },
  {
    code: "339920",
    title: "Dumbbells manufacturing",
  },
  {
    code: "339920",
    title: "Exercise machines manufacturing",
  },
  {
    code: "339920",
    title: "Fencing equipment (sporting goods) manufacturing",
  },
  {
    code: "339920",
    title:
      "Fishing tackle and equipment (except lines, nets, seines) manufacturing",
  },
  {
    code: "339920",
    title: "Fitness equipment manufacturing",
  },
  {
    code: "339920",
    title: "Flies, artificial fishing, manufacturing",
  },
  {
    code: "339920",
    title:
      "Football equipment and supplies (except footwear, uniforms) manufacturing",
  },
  {
    code: "339920",
    title:
      "Gloves, sport and athletic (e.g., baseball, boxing, racquetball, handball), manufacturing",
  },
  {
    code: "339920",
    title:
      "Golfing equipment (e.g., bags, balls, caddy carts, clubs, tees) manufacturing",
  },
  {
    code: "339920",
    title: "Gymnasium and playground equipment, manufacturing",
  },
  {
    code: "339920",
    title:
      "Helmets, athletic (except motorized vehicle crash helmets), manufacturing",
  },
  {
    code: "339920",
    title: "Hockey equipment (except apparel) manufacturing",
  },
  {
    code: "339920",
    title: "Hockey skates manufacturing",
  },
  {
    code: "339920",
    title: "Hooks, fishing, manufacturing",
  },
  {
    code: "339920",
    title: "Ice skates manufacturing",
  },
  {
    code: "339920",
    title: "Jogging machines, manufacturing",
  },
  {
    code: "339920",
    title: "Leather gloves, athletic, manufacturing",
  },
  {
    code: "339920",
    title:
      "Protectors, sports (e.g., baseball, basketball, hockey), manufacturing",
  },
  {
    code: "339920",
    title: "Reels, fishing, manufacturing",
  },
  {
    code: "339920",
    title: "Rods and rod parts, fishing, manufacturing",
  },
  {
    code: "339920",
    title: "Roller skates manufacturing",
  },
  {
    code: "339920",
    title: "Sailboards manufacturing",
  },
  {
    code: "339920",
    title: "Scuba diving equipment manufacturing",
  },
  {
    code: "339920",
    title: "Skateboards manufacturing",
  },
  {
    code: "339920",
    title: "Skates and parts, ice and roller, manufacturing",
  },
  {
    code: "339920",
    title: "Skis and skiing equipment (except apparel) manufacturing",
  },
  {
    code: "339920",
    title: "Snowshoes manufacturing",
  },
  {
    code: "339920",
    title:
      "Sporting goods (except ammunition, clothing, footwear, small arms) manufacturing",
  },
  {
    code: "339920",
    title: "Squash equipment (except apparel) manufacturing",
  },
  {
    code: "339920",
    title: "Sticks, sports (e.g., hockey, lacrosse), manufacturing",
  },
  {
    code: "339920",
    title: "Surfboards manufacturing",
  },
  {
    code: "339920",
    title: "Swimming pools, above ground, manufacturing",
  },
  {
    code: "339920",
    title: "Tackle, fishing (except line, nets, seines), manufacturing",
  },
  {
    code: "339920",
    title: "Tennis goods (e.g., balls, frames, rackets) manufacturing",
  },
  {
    code: "339920",
    title: "Toboggans manufacturing",
  },
  {
    code: "339920",
    title:
      "Track and field athletic equipment (except apparel, footwear) manufacturing",
  },
  {
    code: "339920",
    title: "Wet suits manufacturing",
  },
  {
    code: "339930",
    title: "Action figures manufacturing",
  },
  {
    code: "339930",
    title: "Automobiles, children's, manufacturing",
  },
  {
    code: "339930",
    title: "Balls, rubber (except athletic equipment), manufacturing",
  },
  {
    code: "339930",
    title: "Carriages, baby, manufacturing",
  },
  {
    code: "339930",
    title: "Carriages, doll, manufacturing",
  },
  {
    code: "339930",
    title: "Checkers and checkerboards manufacturing",
  },
  {
    code: "339930",
    title: "Chessmen and chessboards manufacturing",
  },
  {
    code: "339930",
    title: "Clothing, doll, manufacturing",
  },
  {
    code: "339930",
    title: "Craft and hobby kits and sets manufacturing",
  },
  {
    code: "339930",
    title: "Darts and dart games manufacturing",
  },
  {
    code: "339930",
    title: "Dishes, toy, manufacturing",
  },
  {
    code: "339930",
    title: "Doll carriages and carts manufacturing",
  },
  {
    code: "339930",
    title: "Doll clothing manufacturing",
  },
  {
    code: "339930",
    title: "Dolls, doll parts, and doll clothing (except wigs) manufacturing",
  },
  {
    code: "339930",
    title: "Electronic toys and games manufacturing",
  },
  {
    code: "339930",
    title: "Electronic video games, handheld, manufacturing",
  },
  {
    code: "339930",
    title: "Embroidery kits manufacturing",
  },
  {
    code: "339930",
    title:
      "Games (except coin- or card-operated), children's and adult, manufacturing",
  },
  {
    code: "339930",
    title: "Gaming consoles manufacturing",
  },
  {
    code: "339930",
    title: "Gocarts, children's, manufacturing",
  },
  {
    code: "339930",
    title: "Hobbyhorses manufacturing",
  },
  {
    code: "339930",
    title: "Kites manufacturing",
  },
  {
    code: "339930",
    title: "Marbles manufacturing",
  },
  {
    code: "339930",
    title: "Model kits manufacturing",
  },
  {
    code: "339930",
    title: "Model railroad manufacturing",
  },
  {
    code: "339930",
    title: "Models, toy and hobby (e.g., airplane, boat, ship), manufacturing",
  },
  {
    code: "339930",
    title: "Musical instruments, toy, manufacturing",
  },
  {
    code: "339930",
    title: "Railroad models, hobby and toy, manufacturing",
  },
  {
    code: "339930",
    title: "Rifles, toy, manufacturing",
  },
  {
    code: "339930",
    title: "Rocking horses manufacturing",
  },
  {
    code: "339930",
    title:
      "Science kits (e.g., chemistry sets, microscopes, natural science sets) manufacturing",
  },
  {
    code: "339930",
    title: "Scooters, children's, manufacturing",
  },
  {
    code: "339930",
    title: "Sleds, children's, manufacturing",
  },
  {
    code: "339930",
    title: "Strollers, baby, manufacturing",
  },
  {
    code: "339930",
    title: "Structural toy sets manufacturing",
  },
  {
    code: "339930",
    title: "Stuffed toys (including animals) manufacturing",
  },
  {
    code: "339930",
    title: "Toy furniture and household-type equipment manufacturing",
  },
  {
    code: "339930",
    title: "Toys manufacturing",
  },
  {
    code: "339930",
    title: "Trains and equipment, toy, electric or mechanical, manufacturing",
  },
  {
    code: "339930",
    title: "Tricycles (except metal) manufacturing",
  },
  {
    code: "339930",
    title:
      "Vehicles, children's (except bicycles and metal tricycles), manufacturing",
  },
  {
    code: "339930",
    title: "Video game devices manufacturing",
  },
  {
    code: "339930",
    title: "Video game machines (except coin- or card-operated) manufacturing",
  },
  {
    code: "339930",
    title:
      "Wagons, children's (e.g., coaster, express, and play), manufacturing",
  },
  {
    code: "339930",
    title: "Walkers, baby (vehicles), manufacturing",
  },
  {
    code: "339940",
    title: "Artist's paint manufacturing",
  },
  {
    code: "339940",
    title: "Artist's supplies (except paper) manufacturing",
  },
  {
    code: "339940",
    title: "Ball point pens manufacturing",
  },
  {
    code: "339940",
    title: "Blackboards, framed, manufacturing",
  },
  {
    code: "339940",
    title: "Branding irons (i.e., marking irons) manufacturing",
  },
  {
    code: "339940",
    title: "Brushes, artists', manufacturing",
  },
  {
    code: "339940",
    title: "Canvas board, artist's, manufacturing",
  },
  {
    code: "339940",
    title: "Canvas, artist's, prepared on frames, manufacturing",
  },
  {
    code: "339940",
    title: "Carbon paper manufacturing",
  },
  {
    code: "339940",
    title:
      "Chalk (e.g., artist's, blackboard, carpenter's, marking, tailor's), manufacturing",
  },
  {
    code: "339940",
    title: "Chalkboards, framed, manufacturing",
  },
  {
    code: "339940",
    title: "Clay, modeling, manufacturing",
  },
  {
    code: "339940",
    title: "Crayons manufacturing",
  },
  {
    code: "339940",
    title: "Date stamps, hand operated, manufacturing",
  },
  {
    code: "339940",
    title: "Drafting materials (except instruments and tables) manufacturing",
  },
  {
    code: "339940",
    title: "Easels, artists', manufacturing",
  },
  {
    code: "339940",
    title: "Embossing stamps manufacturing",
  },
  {
    code: "339940",
    title: "Felt tip markers manufacturing",
  },
  {
    code: "339940",
    title: "Fountain pens manufacturing",
  },
  {
    code: "339940",
    title: "Frames for artist's canvases (i.e., stretchers) manufacturing",
  },
  {
    code: "339940",
    title:
      "Hand operated stamps (e.g., canceling, postmark, shoe, textile marking) manufacturing",
  },
  {
    code: "339940",
    title: "Holepunchers, hand operated, manufacturing",
  },
  {
    code: "339940",
    title: "Inked ribbons manufacturing",
  },
  {
    code: "339940",
    title: "Label making equipment, handheld, manufacturing",
  },
  {
    code: "339940",
    title: "List finders and roledex address files manufacturing",
  },
  {
    code: "339940",
    title: "Marker boards (i.e., whiteboards) manufacturing",
  },
  {
    code: "339940",
    title: "Marking devices manufacturing",
  },
  {
    code: "339940",
    title: "Mechanical pencil refills manufacturing",
  },
  {
    code: "339940",
    title: "Mechanical pencils manufacturing",
  },
  {
    code: "339940",
    title: "Metal hand stamps manufacturing",
  },
  {
    code: "339940",
    title: "Modeling clay manufacturing",
  },
  {
    code: "339940",
    title: "Nibs (i.e., pen points) manufacturing",
  },
  {
    code: "339940",
    title: "Paints, artist's, manufacturing",
  },
  {
    code: "339940",
    title: "Palettes, artist's, manufacturing",
  },
  {
    code: "339940",
    title: "Paper cutters, office-type, manufacturing",
  },
  {
    code: "339940",
    title: "Paper, carbon, manufacturing",
  },
  {
    code: "339940",
    title: "Paper, stencil, manufacturing",
  },
  {
    code: "339940",
    title: "Pen refills and cartridges manufacturing",
  },
  {
    code: "339940",
    title: "Pencil leads manufacturing",
  },
  {
    code: "339940",
    title: "Pencil sharpeners manufacturing",
  },
  {
    code: "339940",
    title: "Pencils manufacturing",
  },
  {
    code: "339940",
    title: "Pens manufacturing",
  },
  {
    code: "339940",
    title:
      "Ribbons (e.g., cash register, printer, typewriter), inked, manufacturing",
  },
  {
    code: "339940",
    title: "Ribbons, inked, manufacturing",
  },
  {
    code: "339940",
    title: "Rubber stamps manufacturing",
  },
  {
    code: "339940",
    title: "Seal presses (e.g., notary), hand operated, manufacturing",
  },
  {
    code: "339940",
    title: "Stamp pads manufacturing",
  },
  {
    code: "339940",
    title: "Stamping devices, hand operated, manufacturing",
  },
  {
    code: "339940",
    title: "Staple removers manufacturing",
  },
  {
    code: "339940",
    title: "Staplers manufacturing",
  },
  {
    code: "339940",
    title: "Stencil paper manufacturing",
  },
  {
    code: "339940",
    title:
      "Stencils for painting and marking (e.g., cardboard, metal) manufacturing",
  },
  {
    code: "339940",
    title: "Tape dispensers manufacturing",
  },
  {
    code: "339940",
    title: "Typewriter ribbons manufacturing",
  },
  {
    code: "339940",
    title: "Water colors, artist's, manufacturing",
  },
  {
    code: "339950",
    title: "Billboards manufacturing",
  },
  {
    code: "339950",
    title: "Displays (e.g., counter, floor, point-of-purchase) manufacturing",
  },
  {
    code: "339950",
    title: "Electrical signs manufacturing",
  },
  {
    code: "339950",
    title: "Letters for signs manufacturing",
  },
  {
    code: "339950",
    title: "Neon signs manufacturing",
  },
  {
    code: "339950",
    title: "Scoreboards manufacturing",
  },
  {
    code: "339950",
    title: "Signs and signboards (except paper, paperboard) manufacturing",
  },
  {
    code: "339950",
    title: "Traffic (e.g., highway, road, street, bridge) signs manufacturing",
  },
  {
    code: "339991",
    title: "Coaxial mechanical face seals manufacturing",
  },
  {
    code: "339991",
    title: "Compression packings manufacturing",
  },
  {
    code: "339991",
    title: "Gasket, packing, and sealing devices manufacturing",
  },
  {
    code: "339991",
    title: "Gaskets manufacturing",
  },
  {
    code: "339991",
    title: "Grease seals manufacturing",
  },
  {
    code: "339991",
    title: "Molded packings and seals manufacturing",
  },
  {
    code: "339991",
    title: "Oil seals manufacturing",
  },
  {
    code: "339991",
    title: "Seals, grease or oil, manufacturing",
  },
  {
    code: "339992",
    title: "Accordions and parts manufacturing",
  },
  {
    code: "339992",
    title: "Autophones (organs with perforated music rolls) manufacturing",
  },
  {
    code: "339992",
    title: "Banjos and parts manufacturing",
  },
  {
    code: "339992",
    title: "Bassoons manufacturing",
  },
  {
    code: "339992",
    title: "Bells (musical instruments) manufacturing",
  },
  {
    code: "339992",
    title: "Calliopes (steam organs) manufacturing",
  },
  {
    code: "339992",
    title: "Cellos and parts manufacturing",
  },
  {
    code: "339992",
    title: "Chimes and parts (musical instruments) manufacturing",
  },
  {
    code: "339992",
    title: "Clarinets and parts manufacturing",
  },
  {
    code: "339992",
    title: "Cornets and parts manufacturing",
  },
  {
    code: "339992",
    title: "Cymbals and parts manufacturing",
  },
  {
    code: "339992",
    title: "Drums (musical instruments), parts, and accessories manufacturing",
  },
  {
    code: "339992",
    title: "Electric musical instruments manufacturing",
  },
  {
    code: "339992",
    title: "Flutes and parts manufacturing",
  },
  {
    code: "339992",
    title: "Fretted instruments and parts manufacturing",
  },
  {
    code: "339992",
    title: "Guitars and parts, electric and nonelectric, manufacturing",
  },
  {
    code: "339992",
    title: "Hammers, piano, manufacturing",
  },
  {
    code: "339992",
    title: "Harmonicas manufacturing",
  },
  {
    code: "339992",
    title: "Harps and parts manufacturing",
  },
  {
    code: "339992",
    title: "Harpsichords manufacturing",
  },
  {
    code: "339992",
    title: "Instruments, musical, manufacturing",
  },
  {
    code: "339992",
    title: "Keyboards, piano or organ, manufacturing",
  },
  {
    code: "339992",
    title: "Knobs, organ, manufacturing",
  },
  {
    code: "339992",
    title: "Mandolins manufacturing",
  },
  {
    code: "339992",
    title: "Mouthpieces for musical instruments manufacturing",
  },
  {
    code: "339992",
    title: "Music rolls, perforated, manufacturing",
  },
  {
    code: "339992",
    title:
      "Musical instrument accessories (e.g., mouthpieces, reeds, stands, traps) manufacturing",
  },
  {
    code: "339992",
    title: "Musical instruments (except toy) manufacturing",
  },
  {
    code: "339992",
    title: "Oboes manufacturing",
  },
  {
    code: "339992",
    title: "Ocarinas manufacturing",
  },
  {
    code: "339992",
    title: "Octophones manufacturing",
  },
  {
    code: "339992",
    title: "Percussion musical instruments manufacturing",
  },
  {
    code: "339992",
    title: "Piano parts and materials (except piano hardware) manufacturing",
  },
  {
    code: "339992",
    title: "Piccolos and parts manufacturing",
  },
  {
    code: "339992",
    title: "Pipes, organ, manufacturing",
  },
  {
    code: "339992",
    title: "Reeds, musical instrument, manufacturing",
  },
  {
    code: "339992",
    title: "Saxophones and parts manufacturing",
  },
  {
    code: "339992",
    title: "Strings, musical instrument, manufacturing",
  },
  {
    code: "339992",
    title: "Synthesizers, music, manufacturing",
  },
  {
    code: "339992",
    title: "Trombones and parts manufacturing",
  },
  {
    code: "339992",
    title: "Trumpets and parts manufacturing",
  },
  {
    code: "339992",
    title: "Tuning forks manufacturing",
  },
  {
    code: "339992",
    title: "Ukuleles and parts manufacturing",
  },
  {
    code: "339992",
    title: "Vibraphones manufacturing",
  },
  {
    code: "339992",
    title: "Violas and parts manufacturing",
  },
  {
    code: "339992",
    title: "Violins and parts manufacturing",
  },
  {
    code: "339992",
    title: "Xylophones and parts manufacturing",
  },
  {
    code: "339992",
    title: "Zithers and parts manufacturing",
  },
  {
    code: "339993",
    title: "Buckles and buckle parts (including shoe) manufacturing",
  },
  {
    code: "339993",
    title:
      "Buttons (except precious metal, precious stones, semiprecious stones) manufacturing",
  },
  {
    code: "339993",
    title: "Cuff links (except precious) manufacturing",
  },
  {
    code: "339993",
    title: "Eyelets, metal, manufacturing",
  },
  {
    code: "339993",
    title: "Fasteners (e.g., glove, hook and eye, slide, snap) manufacturing",
  },
  {
    code: "339993",
    title: "Hairpins (except rubber) manufacturing",
  },
  {
    code: "339993",
    title: "Hook and eye fasteners (i.e., sewing accessories) manufacturing",
  },
  {
    code: "339993",
    title: "Needles (except hypodermic, phonograph, styli) manufacturing",
  },
  {
    code: "339993",
    title: "Pins (except precious) manufacturing",
  },
  {
    code: "339993",
    title: "Safety pins manufacturing",
  },
  {
    code: "339993",
    title: "Slide fasteners (i.e., zippers) manufacturing",
  },
  {
    code: "339993",
    title: "Zippers (i.e., slide fasteners) manufacturing",
  },
  {
    code: "339994",
    title: "Brooms, hand and machine, manufacturing",
  },
  {
    code: "339994",
    title: "Brushes, household-type and industrial, manufacturing",
  },
  {
    code: "339994",
    title: "Brushes, paint (except artists'), manufacturing",
  },
  {
    code: "339994",
    title: "Hairbrushes manufacturing",
  },
  {
    code: "339994",
    title: "Mops, floor and dust, manufacturing",
  },
  {
    code: "339994",
    title: "Paint rollers manufacturing",
  },
  {
    code: "339994",
    title: "Paintbrushes manufacturing",
  },
  {
    code: "339994",
    title: "Shaving brushes manufacturing",
  },
  {
    code: "339994",
    title: "Toothbrushes (except electric) manufacturing",
  },
  {
    code: "339995",
    title: "Burial caskets and cases manufacturing",
  },
  {
    code: "339995",
    title: "Burial vaults (except concrete, stone) manufacturing",
  },
  {
    code: "339995",
    title: "Caskets, burial, manufacturing",
  },
  {
    code: "339995",
    title: "Vaults (except concrete) manufacturing",
  },
  {
    code: "339999",
    title: "Amusement machines, coin- or card-operated, manufacturing",
  },
  {
    code: "339999",
    title: "Artificial flower arrangements assembled from purchased components",
  },
  {
    code: "339999",
    title: "Atomizers (e.g., perfumes) manufacturing",
  },
  {
    code: "339999",
    title: "Beach umbrellas manufacturing",
  },
  {
    code: "339999",
    title: "Bone novelties manufacturing",
  },
  {
    code: "339999",
    title: "Candles manufacturing",
  },
  {
    code: "339999",
    title: "Canes (except orthopedic) manufacturing",
  },
  {
    code: "339999",
    title: "Christmas tree ornaments (except electric, glass) manufacturing",
  },
  {
    code: "339999",
    title: "Christmas trees, artificial, manufacturing",
  },
  {
    code: "339999",
    title: "Cigarette holders manufacturing",
  },
  {
    code: "339999",
    title: "Cigarette lighter flints manufacturing",
  },
  {
    code: "339999",
    title: "Cigarette lighters (except precious metal) manufacturing",
  },
  {
    code: "339999",
    title:
      "Coin- or card-operated amusement machines (except jukebox) manufacturing",
  },
  {
    code: "339999",
    title: "Coin-or card-operated gambling devices manufacturing",
  },
  {
    code: "339999",
    title: "Decalcomania work (except on china, glass)",
  },
  {
    code: "339999",
    title: "Electronic cigarettes manufacturing",
  },
  {
    code: "339999",
    title: "Feather dusters manufacturing",
  },
  {
    code: "339999",
    title:
      "Feathers, preparing (i.e., for use in apparel and textile products)",
  },
  {
    code: "339999",
    title: "Fire extinguishers, portable, manufacturing",
  },
  {
    code: "339999",
    title: "Flints, lighter, manufacturing",
  },
  {
    code: "339999",
    title: "Flowers, artificial (except glass, plastics), manufacturing",
  },
  {
    code: "339999",
    title: "Fly swatters manufacturing",
  },
  {
    code: "339999",
    title: "Frames, mirror and picture, all materials, manufacturing",
  },
  {
    code: "339999",
    title: "Fruits, artificial (except glass, plastics), manufacturing",
  },
  {
    code: "339999",
    title: "Games, coin- or card-operated, manufacturing",
  },
  {
    code: "339999",
    title: "Garden umbrellas manufacturing",
  },
  {
    code: "339999",
    title: "Globes, geographical, manufacturing",
  },
  {
    code: "339999",
    title: "Hair nets made from purchased netting",
  },
  {
    code: "339999",
    title: "Hairpieces (e.g., toupees, wigs, wiglets) manufacturing",
  },
  {
    code: "339999",
    title: "Hat blocks manufacturing",
  },
  {
    code: "339999",
    title:
      "Lighters, cigar and cigarette (except motor vehicle, precious metal), manufacturing",
  },
  {
    code: "339999",
    title: "Mannequins manufacturing",
  },
  {
    code: "339999",
    title: "Marionettes (i.e., puppets) manufacturing",
  },
  {
    code: "339999",
    title: "Models, anatomical, manufacturing",
  },
  {
    code: "339999",
    title: "Music boxes manufacturing",
  },
  {
    code: "339999",
    title: "Novelties, not specified elsewhere, manufacturing",
  },
  {
    code: "339999",
    title: "Ornaments, Christmas tree (except electric, glass), manufacturing",
  },
  {
    code: "339999",
    title: "Parasols manufacturing",
  },
  {
    code: "339999",
    title: "Patterns, shoe, manufacturing",
  },
  {
    code: "339999",
    title: "Pinball machines, coin- or card-operated, manufacturing",
  },
  {
    code: "339999",
    title: "Pipe cleaners manufacturing",
  },
  {
    code: "339999",
    title: "Pipes, smoker's, manufacturing",
  },
  {
    code: "339999",
    title: "Potpourri manufacturing",
  },
  {
    code: "339999",
    title: "Puppets manufacturing",
  },
  {
    code: "339999",
    title: "Sewing and mending kits assembling",
  },
  {
    code: "339999",
    title: "Shell novelties",
  },
  {
    code: "339999",
    title: "Slot machines manufacturing",
  },
  {
    code: "339999",
    title: "Theatrical scenery manufacturing",
  },
  {
    code: "339999",
    title: "Tinsel manufacturing",
  },
  {
    code: "339999",
    title: "Tobacco pipes manufacturing",
  },
  {
    code: "339999",
    title: "Toupees manufacturing",
  },
  {
    code: "339999",
    title: "Trees and plants, artificial, manufacturing",
  },
  {
    code: "339999",
    title: "Umbrellas manufacturing",
  },
  {
    code: "339999",
    title: "Wax figures (i.e., mannequins) manufacturing",
  },
  {
    code: "339999",
    title: "Wigs, wiglets, toupees, hairpieces, manufacturing",
  },
  {
    code: "339999",
    title: "Wreaths, artificial, manufacturing",
  },
  {
    code: "423110",
    title: "All-terrain vehicles (ATVs) merchant wholesalers",
  },
  {
    code: "423110",
    title: "Ambulance merchant wholesalers",
  },
  {
    code: "423110",
    title: "Automobile auction merchant wholesalers",
  },
  {
    code: "423110",
    title: "Automobile merchant wholesalers",
  },
  {
    code: "423110",
    title: "Bicycle, motorized, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Bodies, motor vehicle, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Bus merchant wholesalers",
  },
  {
    code: "423110",
    title: "Camping trailer merchant wholesalers",
  },
  {
    code: "423110",
    title: "Cargo van merchant wholesalers",
  },
  {
    code: "423110",
    title: "Chassis, motor vehicle, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Minivan merchant wholesalers",
  },
  {
    code: "423110",
    title: "Moped merchant wholesalers",
  },
  {
    code: "423110",
    title: "Motor home merchant wholesalers",
  },
  {
    code: "423110",
    title: "Motor vehicle merchant wholesalers",
  },
  {
    code: "423110",
    title: "Motorcycle merchant wholesalers",
  },
  {
    code: "423110",
    title: "Recreational vehicle merchant wholesalers",
  },
  {
    code: "423110",
    title: "School bus merchant wholesalers",
  },
  {
    code: "423110",
    title: "Snowmobile merchant wholesalers",
  },
  {
    code: "423110",
    title: "Special purpose highway vehicle merchant wholesalers",
  },
  {
    code: "423110",
    title: "Sport utility vehicle merchant wholesalers",
  },
  {
    code: "423110",
    title: "Taxicab merchant wholesalers",
  },
  {
    code: "423110",
    title: "Tractors, highway, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Trailers, motor vehicle, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Transportation equipment, motor vehicle, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Travel trailer (e.g., tent trailers) merchant wholesalers",
  },
  {
    code: "423110",
    title: "Truck tractors, road, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Truck trailer merchant wholesalers",
  },
  {
    code: "423110",
    title: "Trucks, road, merchant wholesalers",
  },
  {
    code: "423110",
    title: "Used car merchant wholesalers",
  },
  {
    code: "423110",
    title: "Utility trailer merchant wholesalers",
  },
  {
    code: "423110",
    title: "Vehicles, recreational, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Aftermarket parts, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Auto body shop supplies merchant wholesalers",
  },
  {
    code: "423120",
    title: "Automobile accessories (except tires, tubes) merchant wholesalers",
  },
  {
    code: "423120",
    title: "Automobile glass merchant wholesalers",
  },
  {
    code: "423120",
    title: "Automobile service station equipment merchant wholesalers",
  },
  {
    code: "423120",
    title: "Automotive brakes merchant wholesalers",
  },
  {
    code: "423120",
    title: "Automotive parts, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Automotive stampings merchant wholesalers",
  },
  {
    code: "423120",
    title: "Balancing equipment, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Batteries, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Engine testing equipment, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Engines and parts, automotive, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Gasoline marketing equipment merchant wholesalers",
  },
  {
    code: "423120",
    title: "Gasoline measuring and dispensing pumps merchant wholesalers",
  },
  {
    code: "423120",
    title: "Gasoline service station equipment merchant wholesalers",
  },
  {
    code: "423120",
    title: "Generators, motor vehicle electrical, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Glass, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Handtools, motor vehicle mechanics', merchant wholesalers",
  },
  {
    code: "423120",
    title: "Hardware, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Hoists, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Mechanic's tools merchant wholesalers",
  },
  {
    code: "423120",
    title: "Mirrors, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Motor vehicle instruments, electric, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Motor vehicle parts and accessories, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Motorcycle parts, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Mufflers, exhaust, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Oil filters, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Parts, new, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Pistons and valves, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title:
      "Pumps (e.g., fuel, oil, power steering, water), automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Radiators, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Seat belts, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Seat covers, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Shop equipment, service station, merchant wholesalers",
  },
  {
    code: "423120",
    title:
      "Testing and measuring equipment, electrical, automotive, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Tools and equipment, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Trailer parts, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Truck parts, new, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Voltage regulators, motor vehicle, merchant wholesalers",
  },
  {
    code: "423120",
    title: "Wheels, motor vehicle, new, merchant wholesalers",
  },
  {
    code: "423130",
    title: "Heavy truck tires and tubes merchant wholesalers",
  },
  {
    code: "423130",
    title: "Motor vehicle tire and tube merchant wholesalers",
  },
  {
    code: "423130",
    title: "Recapped tires merchant wholesalers",
  },
  {
    code: "423130",
    title: "Tire and tube repair materials merchant wholesalers",
  },
  {
    code: "423130",
    title: "Tire tubes, motor vehicle, merchant wholesalers",
  },
  {
    code: "423130",
    title: "Tires, new, motor vehicle, merchant wholesalers",
  },
  {
    code: "423130",
    title: "Tires, used (except scrap), merchant wholesalers",
  },
  {
    code: "423130",
    title: "Used tires, motor vehicle, merchant wholesalers",
  },
  {
    code: "423140",
    title: "Automotive parts, used, merchant wholesalers",
  },
  {
    code: "423140",
    title: "Generators, motor vehicle electrical, used, merchant wholesalers",
  },
  {
    code: "423140",
    title: "Junk yards, auto, merchant wholesalers",
  },
  {
    code: "423140",
    title: "Motor vehicle parts, used, merchant wholesalers",
  },
  {
    code: "423140",
    title: "Parts, used, motor vehicle, merchant wholesalers",
  },
  {
    code: "423140",
    title: "Used parts, motor vehicle, merchant wholesalers",
  },
  {
    code: "423210",
    title: "Antique furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Baby furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Beds (except hospital) merchant wholesalers",
  },
  {
    code: "423210",
    title: "Box springs merchant wholesalers",
  },
  {
    code: "423210",
    title: "Cabinets, kitchen, freestanding, merchant wholesalers",
  },
  {
    code: "423210",
    title:
      "Furniture (except drafting tables, hospital beds, medical furniture) merchant wholesalers",
  },
  {
    code: "423210",
    title: "Furniture parts merchant wholesalers",
  },
  {
    code: "423210",
    title: "Hotel furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Household-type furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Mattresses merchant wholesalers",
  },
  {
    code: "423210",
    title: "Office furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Outdoor furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Public building furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Religious furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Restaurant furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "School furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Store furniture merchant wholesalers",
  },
  {
    code: "423210",
    title: "Theater seats merchant wholesalers",
  },
  {
    code: "423220",
    title: "Antique home furnishings merchant wholesalers",
  },
  {
    code: "423220",
    title: "Antique houseware merchant wholesalers",
  },
  {
    code: "423220",
    title: "Bathroom accessories merchant wholesalers",
  },
  {
    code: "423220",
    title: "Blankets (except electric) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Blinds and shades, window, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Brooms and brushes, household-type, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Carpet merchant wholesalers",
  },
  {
    code: "423220",
    title:
      "Ceramic wall (except structural) and floor tile merchant wholesalers",
  },
  {
    code: "423220",
    title: "Chinaware, household-type, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Closet accessories merchant wholesalers",
  },
  {
    code: "423220",
    title:
      "Containers, household (except paper and disposable plastics), merchant wholesalers",
  },
  {
    code: "423220",
    title: "Cooking utensils, household-type, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Cups, plastics (except disposable), merchant wholesalers",
  },
  {
    code: "423220",
    title: "Curtains merchant wholesalers",
  },
  {
    code: "423220",
    title:
      "Dishes, household-type (except disposable plastics, paper), merchant wholesalers",
  },
  {
    code: "423220",
    title: "Draperies merchant wholesalers",
  },
  {
    code: "423220",
    title: "Fireplaces, prefabricated (except gas), merchant wholesalers",
  },
  {
    code: "423220",
    title: "Flatware (except plated, precious) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Floor coverings merchant wholesalers",
  },
  {
    code: "423220",
    title: "Frames and pictures merchant wholesalers",
  },
  {
    code: "423220",
    title: "Furniture coverings and protectors merchant wholesalers",
  },
  {
    code: "423220",
    title: "Glassware, household-type, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Hollowware (except precious metal) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Home furnishings merchant wholesalers",
  },
  {
    code: "423220",
    title: "Housewares (except electric) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Ironing boards merchant wholesalers",
  },
  {
    code: "423220",
    title: "Kitchen utensils, household-type, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Lamps (i.e., lighting fixtures) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Linens (e.g., bath, bed, table) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Mirrors (except automotive) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Mops, household, merchant wholesalers",
  },
  {
    code: "423220",
    title: "Napkins (except paper) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Rugs merchant wholesalers",
  },
  {
    code: "423220",
    title: "Slipcovers merchant wholesalers",
  },
  {
    code: "423220",
    title:
      "Tableware (except disposable, plated, precious) merchant wholesalers",
  },
  {
    code: "423220",
    title: "Towels and washcloths merchant wholesalers",
  },
  {
    code: "423220",
    title: "Window shades and blinds merchant wholesalers",
  },
  {
    code: "423310",
    title: "Building board (e.g., fiber, flake, particle) merchant wholesalers",
  },
  {
    code: "423310",
    title: "Buildings, prefabricated wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Cabinets, kitchen, built-in, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Countertops, wood and wood fiber, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Doors and door frames merchant wholesalers",
  },
  {
    code: "423310",
    title: "Drywall board merchant wholesalers",
  },
  {
    code: "423310",
    title: "Fencing, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Fiberboard merchant wholesalers",
  },
  {
    code: "423310",
    title: "Flooring, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Kitchen cabinets, built-in, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Laminates, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Lumber (e.g., dressed, finished, rough) merchant wholesalers",
  },
  {
    code: "423310",
    title: "Millwork merchant wholesalers",
  },
  {
    code: "423310",
    title: "Molding (e.g., sheet metal, wood) merchant wholesalers",
  },
  {
    code: "423310",
    title: "Paneling merchant wholesalers",
  },
  {
    code: "423310",
    title: "Particleboard merchant wholesalers",
  },
  {
    code: "423310",
    title: "Plywood merchant wholesalers",
  },
  {
    code: "423310",
    title: "Prefabricated buildings, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Railings, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Roofing materials, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Screens, window and door, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Shingles, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Siding, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Stairs, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Structural assemblies, prefabricated wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Veneer, wood, merchant wholesalers",
  },
  {
    code: "423310",
    title: "Wallboard merchant wholesalers",
  },
  {
    code: "423310",
    title: "Windows and window frames merchant wholesalers",
  },
  {
    code: "423310",
    title: "Wood fencing merchant wholesalers",
  },
  {
    code: "423310",
    title: "Wood flooring merchant wholesalers",
  },
  {
    code: "423310",
    title: "Wood shingles merchant wholesalers",
  },
  {
    code: "423310",
    title: "Wood siding merchant wholesalers",
  },
  {
    code: "423320",
    title: "Asphalt and concrete mixtures merchant wholesalers",
  },
  {
    code: "423320",
    title: "Bricks (except refractory) merchant wholesalers",
  },
  {
    code: "423320",
    title: "Building blocks (e.g., cinder, concrete) merchant wholesalers",
  },
  {
    code: "423320",
    title: "Building stone merchant wholesalers",
  },
  {
    code: "423320",
    title: "Cement merchant wholesalers",
  },
  {
    code: "423320",
    title:
      "Ceramic construction materials (except refractory and ceramic roofing tile) merchant wholesalers",
  },
  {
    code: "423320",
    title:
      "Clay construction materials (except refractory and clay roofing tile) merchant wholesalers",
  },
  {
    code: "423320",
    title: "Coal tar paving materials merchant wholesalers",
  },
  {
    code: "423320",
    title: "Concrete building products merchant wholesalers",
  },
  {
    code: "423320",
    title: "Concrete mixtures merchant wholesalers",
  },
  {
    code: "423320",
    title: "Conduit and pipe, concrete, merchant wholesalers",
  },
  {
    code: "423320",
    title: "Countertops, stone and concrete, merchant wholesalers",
  },
  {
    code: "423320",
    title: "Crushed stone merchant wholesalers",
  },
  {
    code: "423320",
    title: "Culvert pipe, concrete, merchant wholesalers",
  },
  {
    code: "423320",
    title: "Drywall joint compounds merchant wholesalers",
  },
  {
    code: "423320",
    title: "Fireplace linings merchant wholesalers",
  },
  {
    code: "423320",
    title: "Flue pipe and linings merchant wholesalers",
  },
  {
    code: "423320",
    title: "Gravel, construction, merchant wholesalers",
  },
  {
    code: "423320",
    title: "Lime (except agricultural) merchant wholesalers",
  },
  {
    code: "423320",
    title: "Mason's materials merchant wholesalers",
  },
  {
    code: "423320",
    title: "Paving mixtures merchant wholesalers",
  },
  {
    code: "423320",
    title: "Plaster merchant wholesalers",
  },
  {
    code: "423320",
    title: "Sand (except industrial) merchant wholesalers",
  },
  {
    code: "423320",
    title: "Septic tanks, concrete, merchant wholesalers",
  },
  {
    code: "423320",
    title: "Sewer pipe, clay (except refractory), merchant wholesalers",
  },
  {
    code: "423320",
    title: "Slate and slate products merchant wholesalers",
  },
  {
    code: "423320",
    title: "Stone, building or crushed, merchant wholesalers",
  },
  {
    code: "423320",
    title:
      "Structural clay tile (except refractory and clay roofing tile) merchant wholesalers",
  },
  {
    code: "423320",
    title: "Stucco merchant wholesalers",
  },
  {
    code: "423320",
    title: "Terra cotta merchant wholesalers",
  },
  {
    code: "423320",
    title:
      "Tile, structural clay (except refractory and clay roofing tile) merchant wholesalers",
  },
  {
    code: "423330",
    title: "Asphalt felts and coatings merchant wholesalers",
  },
  {
    code: "423330",
    title: "Asphalt roofing shingles merchant wholesalers",
  },
  {
    code: "423330",
    title: "Ceramic and clay roofing materials merchant wholesalers",
  },
  {
    code: "423330",
    title: "Eavestroughing merchant wholesalers",
  },
  {
    code: "423330",
    title: "Fascia, building (except wood), merchant wholesalers",
  },
  {
    code: "423330",
    title: "Gutters and down spouts (except wood) merchant wholesalers",
  },
  {
    code: "423330",
    title: "House wrapping insulation materials merchant wholesalers",
  },
  {
    code: "423330",
    title: "Insulation materials (except wood) merchant wholesalers",
  },
  {
    code: "423330",
    title: "Roofing materials (except wood) merchant wholesalers",
  },
  {
    code: "423330",
    title: "Sheet metal roofing materials merchant wholesalers",
  },
  {
    code: "423330",
    title: "Shingles (except wood) merchant wholesalers",
  },
  {
    code: "423330",
    title: "Siding (except wood) merchant wholesalers",
  },
  {
    code: "423330",
    title: "Soffit, building (except wood), merchant wholesalers",
  },
  {
    code: "423330",
    title: "Solar reflective film merchant wholesalers",
  },
  {
    code: "423330",
    title: "Sound insulation merchant wholesalers",
  },
  {
    code: "423330",
    title: "Tarred felts merchant wholesalers",
  },
  {
    code: "423330",
    title: "Thermal wrap, house, merchant wholesalers",
  },
  {
    code: "423330",
    title: "Vinyl siding merchant wholesalers",
  },
  {
    code: "423330",
    title: "Weatherstripping merchant wholesalers",
  },
  {
    code: "423390",
    title: "Architectural metalwork merchant wholesalers",
  },
  {
    code: "423390",
    title: "Awnings (except canvas) merchant wholesalers",
  },
  {
    code: "423390",
    title: "Bailey bridges merchant wholesalers",
  },
  {
    code: "423390",
    title: "Bins, storage, merchant wholesalers",
  },
  {
    code: "423390",
    title:
      "Building materials, fiberglass (except insulation, roofing, siding), merchant wholesalers",
  },
  {
    code: "423390",
    title: "Building paper merchant wholesalers",
  },
  {
    code: "423390",
    title: "Buildings, prefabricated nonwood, merchant wholesalers",
  },
  {
    code: "423390",
    title: "Ceiling tile merchant wholesalers",
  },
  {
    code: "423390",
    title:
      "Countertops (except wood, wood fiber, stone, concrete) merchant wholesalers",
  },
  {
    code: "423390",
    title: "Culvert pipe, metal and plastics, merchant wholesalers",
  },
  {
    code: "423390",
    title: "Fencing and fencing accessories (except wood) merchant wholesalers",
  },
  {
    code: "423390",
    title:
      "Fiberglass building materials (except insulation, roofing, siding) merchant wholesalers",
  },
  {
    code: "423390",
    title: "Flat glass merchant wholesalers",
  },
  {
    code: "423390",
    title: "Gate and fence hardware merchant wholesalers",
  },
  {
    code: "423390",
    title: "Glass, block and brick, merchant wholesalers",
  },
  {
    code: "423390",
    title: "Glass, plate, merchant wholesalers",
  },
  {
    code: "423390",
    title: "Gypsum building products merchant wholesalers",
  },
  {
    code: "423390",
    title: "Iron and steel architectural shapes merchant wholesalers",
  },
  {
    code: "423390",
    title: "Manufactured (i.e., mobile) homes merchant wholesalers",
  },
  {
    code: "423390",
    title: "Mastics, construction, merchant wholesalers",
  },
  {
    code: "423390",
    title: "Metal buildings merchant wholesalers",
  },
  {
    code: "423390",
    title: "Ornamental ironwork merchant wholesalers",
  },
  {
    code: "423390",
    title: "Paper, building, merchant wholesalers",
  },
  {
    code: "423390",
    title: "Plate glass merchant wholesalers",
  },
  {
    code: "423390",
    title: "Prefabricated buildings (except wood) merchant wholesalers",
  },
  {
    code: "423390",
    title: "Septic tanks (except concrete) merchant wholesalers",
  },
  {
    code: "423390",
    title:
      "Silt fence and other fabrics (e.g., for erosion control) merchant wholesalers",
  },
  {
    code: "423390",
    title: "Storage bins merchant wholesalers",
  },
  {
    code: "423390",
    title:
      "Structural assemblies, prefabricated (except wood), merchant wholesalers",
  },
  {
    code: "423410",
    title: "Camcorders (except household-type) merchant wholesalers",
  },
  {
    code: "423410",
    title: "Camera equipment and supplies, photographic, merchant wholesalers",
  },
  {
    code: "423410",
    title: "Cameras, television, merchant wholesalers",
  },
  {
    code: "423410",
    title: "Cameras, video (except household-type), merchant wholesalers",
  },
  {
    code: "423410",
    title: "Charged coupled devices (CCD) merchant wholesalers",
  },
  {
    code: "423410",
    title: "Developing apparatus, photographic, merchant wholesalers",
  },
  {
    code: "423410",
    title: "Film developing equipment merchant wholesalers",
  },
  {
    code: "423410",
    title: "Film finishing equipment merchant wholesalers",
  },
  {
    code: "423410",
    title: "Film, camera, merchant wholesalers",
  },
  {
    code: "423410",
    title: "Film, photographic, merchant wholesalers",
  },
  {
    code: "423410",
    title: "Identity recorders merchant wholesalers",
  },
  {
    code: "423410",
    title:
      "Motion picture cameras, equipment, and supplies merchant wholesalers",
  },
  {
    code: "423410",
    title: "Photofinishing equipment merchant wholesalers",
  },
  {
    code: "423410",
    title: "Photographic equipment and supplies merchant wholesalers",
  },
  {
    code: "423410",
    title: "Photographic film and plates merchant wholesalers",
  },
  {
    code: "423410",
    title: "Printmaking apparatus, photographic, merchant wholesalers",
  },
  {
    code: "423410",
    title:
      "Processing and finishing equipment, photographic, merchant wholesalers",
  },
  {
    code: "423410",
    title:
      "Projection equipment (e.g., motion picture, slide), photographic, merchant wholesalers",
  },
  {
    code: "423410",
    title: "Television cameras merchant wholesalers",
  },
  {
    code: "423410",
    title: "Theater equipment (except seats) merchant wholesalers",
  },
  {
    code: "423410",
    title: "Video cameras (except household-type) merchant wholesalers",
  },
  {
    code: "423410",
    title:
      "Wearable video cameras (except household-type) merchant wholesalers",
  },
  {
    code: "423420",
    title: "Accounting machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Addressing machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Automated teller machines (ATM) merchant wholesalers",
  },
  {
    code: "423420",
    title: "Bank equipment merchant wholesalers",
  },
  {
    code: "423420",
    title: "Blueprinting equipment merchant wholesalers",
  },
  {
    code: "423420",
    title: "Bookkeeping machines merchant wholesalers",
  },
  {
    code: "423420",
    title:
      "Business machines and equipment (except computers) merchant wholesalers",
  },
  {
    code: "423420",
    title: "Calculators and calculating machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Cash registers merchant wholesalers",
  },
  {
    code: "423420",
    title: "Check handling machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Coin sorting machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Copying machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Currency handling machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Dictating machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Forms handling machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Labeling machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Letter and envelope handling machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Machines, office, merchant wholesalers",
  },
  {
    code: "423420",
    title: "Mailing machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Microfilm equipment and supplies merchant wholesalers",
  },
  {
    code: "423420",
    title: "Office equipment merchant wholesalers",
  },
  {
    code: "423420",
    title: "Office machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Paper shredders merchant wholesalers",
  },
  {
    code: "423420",
    title: "Perforating machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Point of sale terminals merchant wholesalers",
  },
  {
    code: "423420",
    title: "Postage meters merchant wholesalers",
  },
  {
    code: "423420",
    title: "Safes, security, merchant wholesalers",
  },
  {
    code: "423420",
    title: "Security safes merchant wholesalers",
  },
  {
    code: "423420",
    title: "Stapling machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Tape dispensing machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Time recording machines merchant wholesalers",
  },
  {
    code: "423420",
    title: "Typewriters merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computer boards, loaded, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computer data storage devices merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computer peripheral equipment merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computer printers merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computer software, packaged, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computer terminals merchant wholesalers",
  },
  {
    code: "423430",
    title: "Computers merchant wholesalers",
  },
  {
    code: "423430",
    title: "Data keying equipment merchant wholesalers",
  },
  {
    code: "423430",
    title: "Data processing machines, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Digitizer and light pen tables merchant wholesalers",
  },
  {
    code: "423430",
    title: "Disk drives, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Diskettes, blank computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Font cartridges merchant wholesalers",
  },
  {
    code: "423430",
    title: "Game software merchant wholesalers",
  },
  {
    code: "423430",
    title: "Keyboards, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Loaded computer boards merchant wholesalers",
  },
  {
    code: "423430",
    title: "Memory boards merchant wholesalers",
  },
  {
    code: "423430",
    title: "Microprocessors merchant wholesalers",
  },
  {
    code: "423430",
    title: "Monitor screen projection devices merchant wholesalers",
  },
  {
    code: "423430",
    title: "Monitors, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Motherboards, loaded, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Peripheral equipment, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Plotters merchant wholesalers",
  },
  {
    code: "423430",
    title: "Printers, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Scanners, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Software, computer, packaged, merchant wholesalers",
  },
  {
    code: "423430",
    title: "Sound boards, computer, merchant wholesalers",
  },
  {
    code: "423430",
    title:
      "USB flash drives (e.g., thumbdrives, jumpdrives) merchant wholesalers",
  },
  {
    code: "423430",
    title: "Video boards merchant wholesalers",
  },
  {
    code: "423430",
    title: "Voice recognition equipment merchant wholesalers",
  },
  {
    code: "423440",
    title: "Balances and scales (except laboratory) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Bar equipment merchant wholesalers",
  },
  {
    code: "423440",
    title: "Chinaware, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Coffee makers, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Coin- or card-operated merchandising machine merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Coin- or card-operated phonographs and vending machines merchant wholesalers",
  },
  {
    code: "423440",
    title: "Cooking equipment, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Cups, commercial (except paper and disposable plastics), merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Dishes, commercial (except paper and disposable plastics), merchant wholesalers",
  },
  {
    code: "423440",
    title: "Dishwashing equipment, commercial-type, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Display cases (except refrigerated) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Electrical signs merchant wholesalers",
  },
  {
    code: "423440",
    title: "Fixtures, store (except refrigerated), merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Food service equipment (except refrigerated), commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Garbage disposal units, commercial-type, merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Hotel equipment and supplies (except furniture) merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Kitchen appliances, commercial (except refrigerated), merchant wholesalers",
  },
  {
    code: "423440",
    title: "Kitchen utensils, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Lockers (except refrigerated) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Mannequins merchant wholesalers",
  },
  {
    code: "423440",
    title:
      "Merchandising machines, coin- or card-operated, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Microwave ovens, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Ovens, commercial-type, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Pans, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Partitions merchant wholesalers",
  },
  {
    code: "423440",
    title: "Phonographs, coin- or card-operated, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Restaurant equipment (except furniture) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Shelving, commercial, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Showcases (except refrigerated) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Signs, electrical, merchant wholesalers",
  },
  {
    code: "423440",
    title: "Soda fountain fixtures (except refrigerated) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Store equipment (except furniture) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Store fixtures (except refrigerated) merchant wholesalers",
  },
  {
    code: "423440",
    title: "Vending machines merchant wholesalers",
  },
  {
    code: "423440",
    title: "Window display equipment merchant wholesalers",
  },
  {
    code: "423440",
    title: "Woodenware, commercial, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Appliances, surgical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Artificial limbs merchant wholesalers",
  },
  {
    code: "423450",
    title: "Beds, hospital, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Crutches merchant wholesalers",
  },
  {
    code: "423450",
    title: "Dental chairs merchant wholesalers",
  },
  {
    code: "423450",
    title: "Dental equipment and supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Dentists' professional supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Diagnostic equipment, medical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Dressings, medical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Electromedical equipment merchant wholesalers",
  },
  {
    code: "423450",
    title: "First-aid kits (except household) merchant wholesalers",
  },
  {
    code: "423450",
    title: "Glassware, medical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Hearing aids merchant wholesalers",
  },
  {
    code: "423450",
    title: "Home health care supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Hospital beds merchant wholesalers",
  },
  {
    code: "423450",
    title: "Hospital equipment and supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Hospital furniture merchant wholesalers",
  },
  {
    code: "423450",
    title: "Hospital gowns merchant wholesalers",
  },
  {
    code: "423450",
    title: "Instruments, dental and medical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Laboratory equipment, dental and medical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Medical equipment merchant wholesalers",
  },
  {
    code: "423450",
    title: "Medical furniture merchant wholesalers",
  },
  {
    code: "423450",
    title: "Medical glassware merchant wholesalers",
  },
  {
    code: "423450",
    title: "Medical instruments merchant wholesalers",
  },
  {
    code: "423450",
    title:
      "Medical supplies (except household first-aid kits and nonsurgical bandages) merchant wholesalers",
  },
  {
    code: "423450",
    title: "Orthopedic equipment and supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Patient monitoring equipment merchant wholesalers",
  },
  {
    code: "423450",
    title: "Physicians' equipment and supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Prosthetic appliances and supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Surgical and medical masks merchant wholesalers",
  },
  {
    code: "423450",
    title: "Surgical appliances merchant wholesalers",
  },
  {
    code: "423450",
    title: "Surgical dressings merchant wholesalers",
  },
  {
    code: "423450",
    title: "Surgical instruments and apparatus merchant wholesalers",
  },
  {
    code: "423450",
    title: "Surgical supplies merchant wholesalers",
  },
  {
    code: "423450",
    title: "Surgical towels merchant wholesalers",
  },
  {
    code: "423450",
    title: "Tapes, medical and surgical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Teeth, dental, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Therapy equipment merchant wholesalers",
  },
  {
    code: "423450",
    title: "Thermometers merchant wholesalers",
  },
  {
    code: "423450",
    title: "Towels, surgical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Ultrasound equipment, medical, merchant wholesalers",
  },
  {
    code: "423450",
    title: "Wheelchairs merchant wholesalers",
  },
  {
    code: "423450",
    title: "Whirlpool baths, hospital, merchant wholesalers",
  },
  {
    code: "423450",
    title: "X-ray machines and parts, medical and dental, merchant wholesalers",
  },
  {
    code: "423460",
    title: "Binoculars merchant wholesalers",
  },
  {
    code: "423460",
    title: "Contact lenses merchant wholesalers",
  },
  {
    code: "423460",
    title: "Eyeglasses merchant wholesalers",
  },
  {
    code: "423460",
    title: "Frames, ophthalmic, merchant wholesalers",
  },
  {
    code: "423460",
    title: "Glasses, optical, merchant wholesalers",
  },
  {
    code: "423460",
    title: "Lens blanks, ophthalmic, merchant wholesalers",
  },
  {
    code: "423460",
    title: "Lenses, optical, merchant wholesalers",
  },
  {
    code: "423460",
    title: "Magnifying glasses merchant wholesalers",
  },
  {
    code: "423460",
    title: "Ophthalmic goods (except cameras) merchant wholesalers",
  },
  {
    code: "423460",
    title: "Optical goods (except cameras) merchant wholesalers",
  },
  {
    code: "423460",
    title: "Optometric equipment and supplies merchant wholesalers",
  },
  {
    code: "423460",
    title: "Professional equipment and supplies, optical, merchant wholesalers",
  },
  {
    code: "423460",
    title: "Sunglasses merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Analytical instruments (e.g., chromatographic, photometers, spectrographs) merchant wholesalers",
  },
  {
    code: "423490",
    title: "Architects' equipment and supplies merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Balances and scales, laboratory (except dental, medical), merchant wholesalers",
  },
  {
    code: "423490",
    title: "Barometers merchant wholesalers",
  },
  {
    code: "423490",
    title: "Blackboards merchant wholesalers",
  },
  {
    code: "423490",
    title: "Chemical and technical pottery products merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Church supplies (except plated ware, silverware) merchant wholesalers",
  },
  {
    code: "423490",
    title: "Drafting instruments merchant wholesalers",
  },
  {
    code: "423490",
    title: "Drafting tables merchant wholesalers",
  },
  {
    code: "423490",
    title: "Engineers' equipment and supplies merchant wholesalers",
  },
  {
    code: "423490",
    title: "Instruments, professional and scientific, merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Laboratory equipment (except dental, medical, ophthalmic) merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Professional equipment and supplies (except dental, medical, ophthalmic) merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Professional furniture (except dental, metal, ophthalmic, and school) merchant wholesalers",
  },
  {
    code: "423490",
    title: "Professional instruments merchant wholesalers",
  },
  {
    code: "423490",
    title: "Religious supplies merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Scales, laboratory (except dental and medical), merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "School equipment and supplies (except books, furniture) merchant wholesalers",
  },
  {
    code: "423490",
    title: "Scientific instruments merchant wholesalers",
  },
  {
    code: "423490",
    title: "Scientific laboratory equipment merchant wholesalers",
  },
  {
    code: "423490",
    title: "Smartboards merchant wholesalers",
  },
  {
    code: "423490",
    title: "Statuary, religious, merchant wholesalers",
  },
  {
    code: "423490",
    title: "Surveying equipment and supplies merchant wholesalers",
  },
  {
    code: "423490",
    title:
      "Teaching machines (except computers), electronic, merchant wholesalers",
  },
  {
    code: "423490",
    title: "Vestments, religious, merchant wholesalers",
  },
  {
    code: "423490",
    title: "Veterinarians' equipment and supplies merchant wholesalers",
  },
  {
    code: "423490",
    title: "Wall maps merchant wholesalers",
  },
  {
    code: "423510",
    title: "Aluminum and aluminum alloy primary forms merchant wholesalers",
  },
  {
    code: "423510",
    title:
      "Aluminum foil, plate, sheet, coil, and roll products merchant wholesalers",
  },
  {
    code: "423510",
    title: "Bars, metal (except precious), merchant wholesalers",
  },
  {
    code: "423510",
    title: "Bearing piles, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Billets, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Black plate merchant wholesalers",
  },
  {
    code: "423510",
    title: "Blooms, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Cable, wire (except insulated), merchant wholesalers",
  },
  {
    code: "423510",
    title: "Carbon and alloy steel primary forms merchant wholesalers",
  },
  {
    code: "423510",
    title: "Cast iron pipe merchant wholesalers",
  },
  {
    code: "423510",
    title: "Castings, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Concrete reinforcing bars merchant wholesalers",
  },
  {
    code: "423510",
    title: "Copper and copper alloy primary forms merchant wholesalers",
  },
  {
    code: "423510",
    title: "Ferroalloys merchant wholesalers",
  },
  {
    code: "423510",
    title: "Ferrous metals merchant wholesalers",
  },
  {
    code: "423510",
    title: "Forgings, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Foundry products merchant wholesalers",
  },
  {
    code: "423510",
    title: "Galvanized iron and steel products merchant wholesalers",
  },
  {
    code: "423510",
    title: "Grinding balls merchant wholesalers",
  },
  {
    code: "423510",
    title: "Ingots (except precious) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Lead primary forms merchant wholesalers",
  },
  {
    code: "423510",
    title: "Metal pipe merchant wholesalers",
  },
  {
    code: "423510",
    title:
      "Metal products (e.g., bars, ingots, plates, rods, shapes, sheets) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Metals sales offices",
  },
  {
    code: "423510",
    title: "Metals service centers",
  },
  {
    code: "423510",
    title: "Metals, ferrous and nonferrous, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Nails merchant wholesalers",
  },
  {
    code: "423510",
    title: "Nickel and nickel alloy primary forms merchant wholesalers",
  },
  {
    code: "423510",
    title: "Nonferrous metals (except precious) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Noninsulated wire merchant wholesalers",
  },
  {
    code: "423510",
    title: "Pig iron merchant wholesalers",
  },
  {
    code: "423510",
    title: "Pilings, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Pipe, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Poles, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Posts, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Rails and accessories, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Reinforcement mesh and wire merchant wholesalers",
  },
  {
    code: "423510",
    title: "Rods, metal (except precious), merchant wholesalers",
  },
  {
    code: "423510",
    title: "Ropes, wire (except insulated), merchant wholesalers",
  },
  {
    code: "423510",
    title: "Semi-finished metal products merchant wholesalers",
  },
  {
    code: "423510",
    title: "Sewer pipe, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Spikes, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Springs, steel, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Stainless steel merchant wholesalers",
  },
  {
    code: "423510",
    title: "Steel merchant wholesalers",
  },
  {
    code: "423510",
    title: "Steel wire cloth (screening) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Steel wool merchant wholesalers",
  },
  {
    code: "423510",
    title: "Storage tanks, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Strips, metal (except precious), merchant wholesalers",
  },
  {
    code: "423510",
    title: "Structural assemblies, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Tanks, storage metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Terneplate merchant wholesalers",
  },
  {
    code: "423510",
    title: "Tin and tin alloy primary forms merchant wholesalers",
  },
  {
    code: "423510",
    title: "Tin plate merchant wholesalers",
  },
  {
    code: "423510",
    title: "Tubing, metal, merchant wholesalers",
  },
  {
    code: "423510",
    title: "Wire (except insulated) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Wire and cable (except electrical) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Wire rope (except insulated) merchant wholesalers",
  },
  {
    code: "423510",
    title: "Wire screening merchant wholesalers",
  },
  {
    code: "423510",
    title: "Zinc and zinc alloy primary forms merchant wholesalers",
  },
  {
    code: "423520",
    title: "Bauxite merchant wholesalers",
  },
  {
    code: "423520",
    title: "Coal dust merchant wholesalers",
  },
  {
    code: "423520",
    title: "Coal merchant wholesalers",
  },
  {
    code: "423520",
    title: "Coke merchant wholesalers",
  },
  {
    code: "423520",
    title: "Concentrates, metallic, merchant wholesalers",
  },
  {
    code: "423520",
    title: "Fuel, coal and coke, merchant wholesalers",
  },
  {
    code: "423520",
    title: "Fuller's earth merchant wholesalers",
  },
  {
    code: "423520",
    title: "Magnesium ores merchant wholesalers",
  },
  {
    code: "423520",
    title: "Metal ores merchant wholesalers",
  },
  {
    code: "423520",
    title: "Metallic concentrates merchant wholesalers",
  },
  {
    code: "423520",
    title:
      "Minerals (except construction materials, petroleum) merchant wholesalers",
  },
  {
    code: "423520",
    title:
      "Nonmetallic minerals (except precious and semiprecious stones and minerals used in construction, such as sand and gravel)",
  },
  {
    code: "423520",
    title: "Nonmetallic ores merchant wholesalers",
  },
  {
    code: "423520",
    title: "Ore concentrates merchant wholesalers",
  },
  {
    code: "423520",
    title: "Ores (e.g., gold, iron, lead, silver, zinc) merchant wholesalers",
  },
  {
    code: "423520",
    title: "Precious metal ores merchant wholesalers",
  },
  {
    code: "423610",
    title: "Alarm apparatus, electric, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Batteries (except automotive) merchant wholesalers",
  },
  {
    code: "423610",
    title: "Boxes and fittings, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Bus bars and trolley ducts merchant wholesalers",
  },
  {
    code: "423610",
    title: "Capacitors (except electronic) merchant wholesalers",
  },
  {
    code: "423610",
    title: "Circuit breakers merchant wholesalers",
  },
  {
    code: "423610",
    title: "Coaxial cable merchant wholesalers",
  },
  {
    code: "423610",
    title: "Conduit, electric wire and cable, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Conduits and raceways, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Connectors, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Construction materials, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Current-carrying wiring devices merchant wholesalers",
  },
  {
    code: "423610",
    title: "Distribution equipment, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Electric light fixtures merchant wholesalers",
  },
  {
    code: "423610",
    title:
      "Electric motors, wiring supplies, and lighting fixtures merchant wholesalers",
  },
  {
    code: "423610",
    title: "Electric prime movers merchant wholesalers",
  },
  {
    code: "423610",
    title: "Electrical apparatus merchant wholesalers",
  },
  {
    code: "423610",
    title: "Fastening devices, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Fittings, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Fixtures, electric lighting, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Flashlights merchant wholesalers",
  },
  {
    code: "423610",
    title: "Fuses, electric, merchant wholesalers",
  },
  {
    code: "423610",
    title:
      "Generators, electrical (except motor vehicle), merchant wholesalers",
  },
  {
    code: "423610",
    title: "Hanging devices, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Hardware, transmission pole and line, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Industrial controls, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Instruments, electric measuring, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Insulated wire or cable merchant wholesalers",
  },
  {
    code: "423610",
    title: "Insulators, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Light bulbs merchant wholesalers",
  },
  {
    code: "423610",
    title: "Lighting fixtures, electric, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Lightning arrestors merchant wholesalers",
  },
  {
    code: "423610",
    title: "Lugs and connectors, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Meters, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Motor controls, electric, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Motors, electric, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Panelboards, electric power distribution, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Pole line hardware merchant wholesalers",
  },
  {
    code: "423610",
    title: "Power transmission equipment, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Receptacles, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Regulators, voltage (except motor vehicle), merchant wholesalers",
  },
  {
    code: "423610",
    title: "Relays merchant wholesalers",
  },
  {
    code: "423610",
    title: "Security systems merchant wholesalers",
  },
  {
    code: "423610",
    title: "Signal systems and devices merchant wholesalers",
  },
  {
    code: "423610",
    title: "Storage batteries (except automotive) merchant wholesalers",
  },
  {
    code: "423610",
    title: "Switchboards, electrical distribution, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Switches, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Transformers (except electronic) merchant wholesalers",
  },
  {
    code: "423610",
    title: "Transmission equipment, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Unit substations, electrical, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Voltage regulators (except motor vehicle) merchant wholesalers",
  },
  {
    code: "423610",
    title: "Wire, insulated, merchant wholesalers",
  },
  {
    code: "423610",
    title: "Wiring supplies merchant wholesalers",
  },
  {
    code: "423620",
    title: "Air-conditioners, room, merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Appliances, household-type (except water heaters, heating stoves (i.e., noncooking)), gas and electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Audio equipment, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Automotive radios merchant wholesalers",
  },
  {
    code: "423620",
    title: "Blankets, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Clothes dryers merchant wholesalers ",
  },
  {
    code: "423620",
    title: "Coffee makers, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Compact disc players merchant wholesalers",
  },
  {
    code: "423620",
    title: "Consumer electronics merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Cooking equipment, gas and electric, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Curling irons, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Digital video disc (DVD) players merchant wholesalers",
  },
  {
    code: "423620",
    title: "Dishwashers, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Dryers, clothes, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Dryers, hair, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Electric blankets merchant wholesalers",
  },
  {
    code: "423620",
    title: "Fans, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Freezers, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Garbage disposal units, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Hair dryers, personal, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Heaters, portable electric, merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Household-type appliances (except water heaters, heating stoves (i.e., noncooking)), gas and electric, merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Household-type laundry equipment (e.g., dryers, washers) merchant wholesalers",
  },
  {
    code: "423620",
    title: "Housewares, gas and electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Humidifiers and dehumidifiers, portable, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Insect control devices, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Irons, household-type, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Kitchen appliances, household-type, gas and electric, merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Laundry machinery and equipment, household-type (e.g., dryers, washers), merchant wholesalers",
  },
  {
    code: "423620",
    title: "Microwave ovens, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Movie apparatus, home, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Outdoor grills merchant wholesalers",
  },
  {
    code: "423620",
    title: "Ovens, gas and electric, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Personal care appliances, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Radios, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Ranges, gas and electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Razors, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title:
      "Recorders (e.g., tape, video), household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Refrigerators, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Room air-conditioners merchant wholesalers",
  },
  {
    code: "423620",
    title: "Sewing machines, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Smoke detectors, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Sound equipment, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Speaker systems merchant wholesalers",
  },
  {
    code: "423620",
    title: "Stereo equipment merchant wholesalers",
  },
  {
    code: "423620",
    title: "Stoves, cooking, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Tape players and recorders, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Telephone answering machines merchant wholesalers",
  },
  {
    code: "423620",
    title: "Television sets merchant wholesalers",
  },
  {
    code: "423620",
    title: "Toasters, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Toothbrushes, electric, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Trail video cameras, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Trash compactors, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Vacuum cleaners, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Video cameras, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Washing machines, household-type, merchant wholesalers",
  },
  {
    code: "423620",
    title: "Wearable video cameras, household-type, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Amplifiers, audio (except household-type), merchant wholesalers",
  },
  {
    code: "423690",
    title: "Antennas merchant wholesalers",
  },
  {
    code: "423690",
    title: "Audiotapes, blank, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Automatic call distributors merchant wholesalers",
  },
  {
    code: "423690",
    title: "Bipolar transistors merchant wholesalers",
  },
  {
    code: "423690",
    title: "Blank CDs and DVDs merchant wholesalers",
  },
  {
    code: "423690",
    title: "Blank diskettes merchant wholesalers",
  },
  {
    code: "423690",
    title: "Blank tapes, audio and video, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Broadcasting equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Capacitors, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Carbon monoxide detectors, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Cellular telephones merchant wholesalers",
  },
  {
    code: "423690",
    title: "Circuit boards merchant wholesalers",
  },
  {
    code: "423690",
    title: "Circuits, integrated, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Citizens' band (CB) radios merchant wholesalers",
  },
  {
    code: "423690",
    title: "Coils, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Communications equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Computer boards, unloaded, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Computer chips merchant wholesalers",
  },
  {
    code: "423690",
    title: "Condensers, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Connectors, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Diodes merchant wholesalers",
  },
  {
    code: "423690",
    title: "Diskettes, blank, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Electronic aircraft instruments merchant wholesalers",
  },
  {
    code: "423690",
    title: "Electronic communications equipment merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Electronic parts (e.g., condensers, connectors, switches) merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Electronic sound equipment (except household-type and automotive) merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Electronic tubes (e.g., industrial, receiving, transmitting) merchant wholesalers",
  },
  {
    code: "423690",
    title: "Facsimile machines merchant wholesalers",
  },
  {
    code: "423690",
    title: "Integrated circuits merchant wholesalers",
  },
  {
    code: "423690",
    title: "Klystron tubes merchant wholesalers",
  },
  {
    code: "423690",
    title: "Liquid crystal displays merchant wholesalers",
  },
  {
    code: "423690",
    title: "Magnetic bubble memories merchant wholesalers",
  },
  {
    code: "423690",
    title: "Magnetic tapes, cassettes, and disks, blank, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Modems merchant wholesalers",
  },
  {
    code: "423690",
    title: "Natural gas detectors, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Navigational instruments, electronic (e.g., radar, sonar), merchant wholesalers",
  },
  {
    code: "423690",
    title: "Printed circuit boards merchant wholesalers",
  },
  {
    code: "423690",
    title: "Public address systems and equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Radar equipment merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Radio frequency identification (RFID) equipment merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Radio parts and accessories (e.g., transistors, tubes) merchant wholesalers",
  },
  {
    code: "423690",
    title: "Radios (except household-type) merchant wholesalers",
  },
  {
    code: "423690",
    title: "Random access memory (RAM) chips merchant wholesalers",
  },
  {
    code: "423690",
    title: "Rectifiers, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Resistors, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Routers merchant wholesalers",
  },
  {
    code: "423690",
    title: "Semiconductor devices merchant wholesalers",
  },
  {
    code: "423690",
    title: "Smartphones merchant wholesalers",
  },
  {
    code: "423690",
    title: "Smartwatches merchant wholesalers",
  },
  {
    code: "423690",
    title: "Solar cells merchant wholesalers",
  },
  {
    code: "423690",
    title: "Sonar equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Switches, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Tapes, blank, audio and video, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Telecommunications equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Teleconferencing equipment, audio or video, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Telegraph equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Telephone equipment merchant wholesalers",
  },
  {
    code: "423690",
    title: "Telephones merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Touch-screen displays (except computer monitors) merchant wholesalers",
  },
  {
    code: "423690",
    title: "Transformers, electronic, merchant wholesalers",
  },
  {
    code: "423690",
    title: "Transistors merchant wholesalers",
  },
  {
    code: "423690",
    title: "Transmitters merchant wholesalers",
  },
  {
    code: "423690",
    title:
      "Tubes, electronic (e.g., industrial, receiving, transmitting), merchant wholesalers",
  },
  {
    code: "423690",
    title: "Unloaded computer boards merchant wholesalers ",
  },
  {
    code: "423690",
    title: "Video tapes, blank, merchant wholesalers",
  },
  {
    code: "423710",
    title: "Appliance hardware merchant wholesalers",
  },
  {
    code: "423710",
    title: "Blades (e.g., knife, saw) merchant wholesalers",
  },
  {
    code: "423710",
    title:
      "Bolts, nuts, rivets, screws, and other fasteners merchant wholesalers",
  },
  {
    code: "423710",
    title: "Brads merchant wholesalers",
  },
  {
    code: "423710",
    title: "Cabinet hardware and fittings merchant wholesalers",
  },
  {
    code: "423710",
    title: "Carpenters' tools merchant wholesalers",
  },
  {
    code: "423710",
    title: "Cutlery merchant wholesalers",
  },
  {
    code: "423710",
    title: "Drapery hardware merchant wholesalers",
  },
  {
    code: "423710",
    title: "Fasteners (e.g., bolts, nuts, rivets, screws) merchant wholesalers",
  },
  {
    code: "423710",
    title:
      "Handtools (except motor vehicle mechanics', machinists' precision) merchant wholesalers",
  },
  {
    code: "423710",
    title: "Hardware (except motor vehicle) merchant wholesalers",
  },
  {
    code: "423710",
    title: "Hinges merchant wholesalers",
  },
  {
    code: "423710",
    title: "Keys and locks merchant wholesalers",
  },
  {
    code: "423710",
    title: "Knives (except disposable plastics) merchant wholesalers",
  },
  {
    code: "423710",
    title: "Locks, security, merchant wholesalers",
  },
  {
    code: "423710",
    title: "Plumbers' tools and equipment merchant wholesalers",
  },
  {
    code: "423710",
    title: "Power handtools (e.g., drills, sanders, saws) merchant wholesalers",
  },
  {
    code: "423710",
    title: "Specialty-line hardware merchant wholesalers",
  },
  {
    code: "423710",
    title: "Staples merchant wholesalers",
  },
  {
    code: "423710",
    title: "Tacks merchant wholesalers",
  },
  {
    code: "423710",
    title:
      "Tools, hand (except motor vehicle, machinists' precision tools), merchant wholesalers",
  },
  {
    code: "423720",
    title: "Bathtubs merchant wholesalers",
  },
  {
    code: "423720",
    title:
      "Boilers (e.g., heating, hot water, power, steam) merchant wholesalers",
  },
  {
    code: "423720",
    title: "Brass goods, plumbers', merchant wholesalers",
  },
  {
    code: "423720",
    title: "Burners, fuel oil and distillate oil, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Convectors merchant wholesalers",
  },
  {
    code: "423720",
    title: "Drinking fountains (except refrigerated) merchant wholesalers",
  },
  {
    code: "423720",
    title: "Fireplaces, gas, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Fireplaces, prefabricated gas, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Fittings and valves, plumbers', merchant wholesalers",
  },
  {
    code: "423720",
    title: "Fountains, drinking (except refrigerated), merchant wholesalers",
  },
  {
    code: "423720",
    title: "Furnaces (except forced air), heating, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Gas fireplaces merchant wholesalers",
  },
  {
    code: "423720",
    title: "Gas hot water heaters merchant wholesalers",
  },
  {
    code: "423720",
    title: "Heating boilers, steam and hot water, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Heating equipment, hot water, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Hydronic heating equipment and supplies merchant wholesalers",
  },
  {
    code: "423720",
    title: "Lavatory fixtures merchant wholesalers",
  },
  {
    code: "423720",
    title: "Oil burners, heating, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Pipe and boiler coverings merchant wholesalers",
  },
  {
    code: "423720",
    title: "Pipe fittings and valves, plumbers', merchant wholesalers",
  },
  {
    code: "423720",
    title: "Plumbers' brass goods merchant wholesalers",
  },
  {
    code: "423720",
    title: "Plumbing and heating valves merchant wholesalers",
  },
  {
    code: "423720",
    title: "Plumbing equipment merchant wholesalers",
  },
  {
    code: "423720",
    title: "Plumbing fixtures merchant wholesalers",
  },
  {
    code: "423720",
    title: "Plumbing supplies merchant wholesalers",
  },
  {
    code: "423720",
    title: "Radiators, heating, nonelectric, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Sanitary ware, china or enameled iron, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Sinks merchant wholesalers",
  },
  {
    code: "423720",
    title: "Solar heating panels and equipment merchant wholesalers",
  },
  {
    code: "423720",
    title: "Spa equipment merchant wholesalers",
  },
  {
    code: "423720",
    title: "Stoves (i.e., noncooking), heating, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Toilet bowls and tanks merchant wholesalers",
  },
  {
    code: "423720",
    title: "Urinals merchant wholesalers",
  },
  {
    code: "423720",
    title: "Valves, plumbing and heating, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Water heaters, gas and electric, merchant wholesaler",
  },
  {
    code: "423720",
    title: "Water purification equipment, household-type, merchant wholesalers",
  },
  {
    code: "423720",
    title: "Water softening and conditioning equipment merchant wholesalers",
  },
  {
    code: "423730",
    title: "Air pollution control equipment and supplies merchant wholesalers",
  },
  {
    code: "423730",
    title:
      "Air-conditioning equipment (except room units) merchant wholesalers",
  },
  {
    code: "423730",
    title: "Automotive air-conditioners merchant wholesalers",
  },
  {
    code: "423730",
    title: "Baseboard heaters, electric, nonportable, merchant wholesalers",
  },
  {
    code: "423730",
    title: "Central heating equipment, warm air, merchant wholesalers",
  },
  {
    code: "423730",
    title: "Compressors, air-conditioning, merchant wholesalers",
  },
  {
    code: "423730",
    title: "Condensing units, air-conditioning, merchant wholesalers",
  },
  {
    code: "423730",
    title: "Cooling equipment and supplies merchant wholesalers",
  },
  {
    code: "423730",
    title:
      "Ductless heating and air-conditioning system equipment merchant wholesalers",
  },
  {
    code: "423730",
    title: "Dust collection equipment merchant wholesalers",
  },
  {
    code: "423730",
    title: "Furnaces, warm air (i.e., forced air), merchant wholesalers",
  },
  {
    code: "423730",
    title: "Heat pumps merchant wholesalers",
  },
  {
    code: "423730",
    title:
      "Heating equipment, warm air (i.e. forced air), merchant wholesalers",
  },
  {
    code: "423730",
    title:
      "Humidifiers and dehumidifiers (except portable) merchant wholesalers",
  },
  {
    code: "423730",
    title: "HVAC equipment merchant wholesalers",
  },
  {
    code: "423730",
    title: "Pollution control equipment, air, merchant wholesalers",
  },
  {
    code: "423730",
    title:
      "Sheet metal duct work (heating and air-conditioning) merchant wholesalers",
  },
  {
    code: "423730",
    title:
      "Ventilating equipment and supplies (except household-type fans) merchant wholesalers",
  },
  {
    code: "423730",
    title: "Warm air heating equipment merchant wholesalers",
  },
  {
    code: "423740",
    title: "Beverage coolers, mechanical, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Cold storage machinery merchant wholesalers",
  },
  {
    code: "423740",
    title: "Compressors, refrigeration, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Condensing units, refrigeration, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Coolers, mechanical, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Display cases, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Drinking fountains, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Fixtures, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Fountains, drinking, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Freezers, commercial-type, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Ice making machines merchant wholesalers",
  },
  {
    code: "423740",
    title: "Lockers, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Refrigerated display cases merchant wholesalers",
  },
  {
    code: "423740",
    title:
      "Refrigeration equipment and supplies, commercial-type, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Refrigeration units, motor vehicle, merchant wholesalers",
  },
  {
    code: "423740",
    title:
      "Refrigerators (e.g., reach-in, walk-in), commercial-type, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Showcases, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Soda fountain fixtures, refrigerated, merchant wholesalers",
  },
  {
    code: "423740",
    title: "Water coolers, mechanical, merchant wholesalers",
  },
  {
    code: "423810",
    title: "Concrete processing equipment merchant wholesalers",
  },
  {
    code: "423810",
    title: "Construction machinery and equipment merchant wholesalers",
  },
  {
    code: "423810",
    title: "Cranes (except industrial) merchant wholesalers",
  },
  {
    code: "423810",
    title: "Cranes, mining, merchant wholesalers",
  },
  {
    code: "423810",
    title:
      "Crushing, pulverizing, and screening machinery, construction and mining, merchant wholesalers",
  },
  {
    code: "423810",
    title: "Dredges (except ships') merchant wholesalers",
  },
  {
    code: "423810",
    title: "Excavating machinery and equipment merchant wholesalers",
  },
  {
    code: "423810",
    title: "Forestry machinery and equipment merchant wholesalers",
  },
  {
    code: "423810",
    title: "Land preparation machinery, construction, merchant wholesalers",
  },
  {
    code: "423810",
    title: "Loaders merchant wholesalers",
  },
  {
    code: "423810",
    title: "Logging equipment merchant wholesalers",
  },
  {
    code: "423810",
    title: "Mining cranes merchant wholesalers",
  },
  {
    code: "423810",
    title:
      "Mining machinery and equipment (except petroleum) merchant wholesalers",
  },
  {
    code: "423810",
    title: "Mixers, construction and mining, merchant wholesalers",
  },
  {
    code: "423810",
    title: "Pavers merchant wholesalers",
  },
  {
    code: "423810",
    title: "Quarrying machinery and equipment merchant wholesalers",
  },
  {
    code: "423810",
    title: "Road construction and maintenance machinery merchant wholesalers",
  },
  {
    code: "423810",
    title: "Scaffolding merchant wholesalers",
  },
  {
    code: "423810",
    title: "Shovels, power, merchant wholesalers",
  },
  {
    code: "423810",
    title: "Snow plows merchant wholesalers",
  },
  {
    code: "423810",
    title: "Snowblowers (except household-type) merchant wholesalers",
  },
  {
    code: "423810",
    title: "Street sweeping and cleaning equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Agricultural implements merchant wholesalers",
  },
  {
    code: "423820",
    title: "Agricultural machinery and equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Blowers, snow and leaf, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Combines merchant wholesalers",
  },
  {
    code: "423820",
    title: "Conveying equipment, farm, merchant wholesalers",
  },
  {
    code: "423820",
    title:
      "Crop preparation machinery (e.g., cleaning, conditioning, drying) merchant wholesalers",
  },
  {
    code: "423820",
    title: "Cultivating machinery and equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Farm machinery and equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Feeders, animal, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Frost protection machinery merchant wholesalers",
  },
  {
    code: "423820",
    title: "Garden machinery and equipment merchant wholesalers",
  },
  {
    code: "423820",
    title:
      "Harvesting machinery and equipment, agriculture, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Haying machines merchant wholesalers",
  },
  {
    code: "423820",
    title: "Irrigation equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Land preparation machinery, agricultural, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Lawn maintenance machinery and equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Lawnmowers merchant wholesalers",
  },
  {
    code: "423820",
    title: "Milking machinery and equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Planting machinery and equipment, farm-type, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Plows, farm, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Poultry equipment merchant wholesalers",
  },
  {
    code: "423820",
    title: "Snowblowers, household-type, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Sprayers, farm-type, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Spreaders, fertilizer, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Sprinklers, agricultural, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Sprinklers, garden, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Tillers, farm and garden, merchant wholesalers",
  },
  {
    code: "423820",
    title: "Tractors, farm and garden, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Actuators, fluid power, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Air compressors (except air-conditioning, refrigeration) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Bakery machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Balancing machines (except automotive) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Beverage bottling machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Beverage processing machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Blanks, tips, and inserts merchant wholesalers",
  },
  {
    code: "423830",
    title: "Blowers, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Bottling machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Broaches (i.e., a machine tool accessory) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Burners, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Cement making machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Chainsaws merchant wholesalers",
  },
  {
    code: "423830",
    title: "Chemical industries machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Coil winding machines, spring, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Commercial fishing equipment and supplies (except boats, ships) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Compactors, trash, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Compressors (except air-conditioning, refrigeration) merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Condensing units (except air-conditioning, refrigeration) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Conveying equipment (except farm) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Cranes, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Crushing, pulverizing, and screening machinery, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Cryogenic cooling devices merchant wholesalers",
  },
  {
    code: "423830",
    title: "Dies, metalworking, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Diesel engines and parts, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Distillery machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Dyeing machinery, textile, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Elevators merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Engines, internal combustion (except aircraft, automotive), merchant wholesalers",
  },
  {
    code: "423830",
    title: "Engraving machinery merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Environmental controlling instruments and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Escalators merchant wholesalers",
  },
  {
    code: "423830",
    title: "Fans, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Fluid meters, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Fluid power transmission equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Food processing machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Forklift trucks (except log) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Foundry machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Furnaces, industrial process, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Gas detecting equipment and supplies (except household-type) merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "General purpose industrial machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Handtools, machinists' precision, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Heat exchange equipment, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Hoists (except automotive) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Hydraulic power transmission equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Hydraulic pumps and parts merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Industrial machinery and equipment (except electrical) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Industrial robotics equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Industrial robots merchant wholesalers",
  },
  {
    code: "423830",
    title: "Industrial trucks, tractors, or trailers merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Instruments (except electrical) (e.g., controlling, indicating, recording) merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Internal combustion engines (except aircraft, nondiesel automotive, nondiesel truck) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Jigs merchant wholesalers",
  },
  {
    code: "423830",
    title: "Kilns, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Ladders merchant wholesalers",
  },
  {
    code: "423830",
    title: "Lift trucks, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Machine tools and accessories merchant wholesalers",
  },
  {
    code: "423830",
    title: "Machinists' precision measuring tools merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Manufacturing machinery and equipment, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Material handling machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Measuring and testing equipment (except electric measuring and automotive) merchant wholesalers ",
  },
  {
    code: "423830",
    title: "Metalworking machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Metalworking tools (drills, taps, dies, grinding wheels) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Meters (except electrical, parking) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Mining machinery and equipment, petroleum, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Oil field equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Oil well machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Oil well supply houses merchant wholesalers",
  },
  {
    code: "423830",
    title: "Ovens, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Packing machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Pallets and skids merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Paper and pulp industries manufacturing machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Patterns (except shoe), industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Petroleum production machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Pipeline machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Pistons, hydraulic and pneumatic, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Plastics industries machinery, equipment, and supplies merchant wholesalers",
  },
  {
    code: "423830",
    title: "Pneumatic pumps and parts merchant wholesalers",
  },
  {
    code: "423830",
    title: "Pollution control equipment (except air) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Poultry processing machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Power plant machinery (except electrical) merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Printing trade machinery, equipment, and supplies merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Pulverizing machinery and equipment, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Pumps and pumping equipment, industrial-type, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Recapping machinery, tire, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Refinery machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Rolling mill machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Sawmill machinery, equipment, and supplies merchant wholesalers",
  },
  {
    code: "423830",
    title: "Saws, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Screening machinery and equipment, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Sewing machines, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Shelving, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Shoe manufacturing and repairing machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Skids merchant wholesalers",
  },
  {
    code: "423830",
    title: "Smelting machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Special purpose industrial machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Spray painting equipment, industrial-type, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Stackers, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Tanks, pressure, merchant wholesalers",
  },
  {
    code: "423830",
    title:
      "Testing and measuring equipment, electrical (except automotive), merchant wholesalers",
  },
  {
    code: "423830",
    title: "Textile machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Threading tools merchant wholesalers",
  },
  {
    code: "423830",
    title: "Tire recapping machinery merchant wholesalers",
  },
  {
    code: "423830",
    title: "Tools, machinists' precision, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Tractors, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Trailers, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Trucks, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Turbines (except transportation) merchant wholesalers",
  },
  {
    code: "423830",
    title: "Twist drills merchant wholesalers",
  },
  {
    code: "423830",
    title: "Vacuum pumps merchant wholesalers",
  },
  {
    code: "423830",
    title: "Valves, hydraulic and pneumatic, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Water treatment equipment, industrial, merchant wholesalers",
  },
  {
    code: "423830",
    title: "Welding machinery and equipment merchant wholesalers",
  },
  {
    code: "423830",
    title: "Winches merchant wholesalers",
  },
  {
    code: "423830",
    title: "Woodworking machinery merchant wholesalers",
  },
  {
    code: "423840",
    title: "Abrasives merchant wholesalers",
  },
  {
    code: "423840",
    title: "Barrels, new and reconditioned, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Bearings merchant wholesalers",
  },
  {
    code: "423840",
    title: "Belting, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Bottles (except waste) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Box shooks merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Boxes and crates, industrial (except disposable plastics, paperboard, waste), merchant wholesalers",
  },
  {
    code: "423840",
    title: "Brushes, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Canning supplies merchant wholesalers",
  },
  {
    code: "423840",
    title: "Cartons (except paper and paperboard) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Closures, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Containers, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Cooperage stock merchant wholesalers",
  },
  {
    code: "423840",
    title: "Cordage merchant wholesalers",
  },
  {
    code: "423840",
    title: "Cork merchant wholesalers",
  },
  {
    code: "423840",
    title: "Crowns and closures, metal, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Diamonds, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Drives and gears merchant wholesalers",
  },
  {
    code: "423840",
    title: "Drums, new and reconditioned, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Excelsior (e.g., pads, wrappers) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Fire hydrants merchant wholesalers",
  },
  {
    code: "423840",
    title: "Fittings, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Gaskets merchant wholesalers",
  },
  {
    code: "423840",
    title: "Gears merchant wholesalers",
  },
  {
    code: "423840",
    title: "General-line industrial supplies merchant wholesalers",
  },
  {
    code: "423840",
    title: "Grommets merchant wholesalers",
  },
  {
    code: "423840",
    title: "Hose, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Industrial containers merchant wholesalers",
  },
  {
    code: "423840",
    title: "Industrial diamonds merchant wholesalers",
  },
  {
    code: "423840",
    title: "Industrial leather products merchant wholesalers",
  },
  {
    code: "423840",
    title: "Industrial pottery products merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Industrial supplies (except disposable plastics, paper) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Inks, printing, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Lapidary equipment, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Mechanical power transmission supplies (e.g., gears, pulleys, sprockets) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Mechanical rubber goods merchant wholesalers",
  },
  {
    code: "423840",
    title: "Mill supplies merchant wholesalers",
  },
  {
    code: "423840",
    title: "Packaging materials merchant wholesalers",
  },
  {
    code: "423840",
    title: "Packing materials merchant wholesalers",
  },
  {
    code: "423840",
    title: "Pipe fittings and valves (except plumbing) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Pistons and valves, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Plastics foam packing and packaging materials merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Power transmission supplies (e.g., gears, pulleys, sprockets), mechanical, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Printing inks merchant wholesalers",
  },
  {
    code: "423840",
    title: "Reconditioned barrels and drums merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Refractory materials (e.g., block, brick, mortar, tile) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Ropes (except wire rope) merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Rubber goods, mechanical (i.e., extruded, lathe-cut, molded), merchant wholesalers",
  },
  {
    code: "423840",
    title: "Sand, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Seals merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Shipping containers (except disposable plastics, paper) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Shipping pails, metal, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Speed changers merchant wholesalers",
  },
  {
    code: "423840",
    title: "Sprockets merchant wholesalers",
  },
  {
    code: "423840",
    title: "Thread, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Towels, industrial, merchant wholesalers",
  },
  {
    code: "423840",
    title: "Twine merchant wholesalers",
  },
  {
    code: "423840",
    title:
      "Valves (except hydraulic, plumbing, pneumatic) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Welding supplies (except welding gases) merchant wholesalers",
  },
  {
    code: "423840",
    title: "Wiping cloths merchant wholesalers",
  },
  {
    code: "423850",
    title: "Amusement park equipment merchant wholesalers",
  },
  {
    code: "423850",
    title: "Barber shop equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Beauty parlor equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Boot and shoe cut stock and findings merchant wholesalers",
  },
  {
    code: "423850",
    title: "Brooms (except household-type) merchant wholesalers",
  },
  {
    code: "423850",
    title: "Burial caskets merchant wholesalers",
  },
  {
    code: "423850",
    title: "Car wash equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Carnival equipment merchant wholesalers",
  },
  {
    code: "423850",
    title: "Carpet cleaning equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Caskets, burial, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Chairs, hydraulic, beauty and barber shop, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Clothes dryers (except household-type) merchant wholesalers",
  },
  {
    code: "423850",
    title: "Coffins merchant wholesalers",
  },
  {
    code: "423850",
    title: "Drycleaning equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Fare boxes, public transit vehicle, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Firefighting equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Floor maintenance equipment merchant wholesalers",
  },
  {
    code: "423850",
    title: "Funeral home supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Furriers equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Hair preparations, professional, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Janitorial equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title:
      "Laundry machinery, equipment, and supplies, commercial, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Law enforcement equipment (except safety) merchant wholesalers",
  },
  {
    code: "423850",
    title: "Locksmith equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Manicurists supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Massage equipment merchant wholesalers",
  },
  {
    code: "423850",
    title: "Meters, parking, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Mops, industrial, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Padding, upholstery filling, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Patterns, shoe, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Pressure washers merchant wholesalers",
  },
  {
    code: "423850",
    title: "Service establishment equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Shoe repair materials merchant wholesalers",
  },
  {
    code: "423850",
    title: "Sprinkler systems, fire, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Tailors' supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Taxidermy supplies merchant wholesalers",
  },
  {
    code: "423850",
    title: "Undertakers' equipment and supplies merchant wholesalers",
  },
  {
    code: "423850",
    title:
      "Upholsterers' equipment and supplies (except fabrics) merchant wholesalers",
  },
  {
    code: "423850",
    title: "Vacuum cleaning systems, commercial, merchant wholesalers",
  },
  {
    code: "423850",
    title: "Voting machines merchant wholesalers",
  },
  {
    code: "423850",
    title: "Water treatment equipment, municipal, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Aeronautical equipment and supplies merchant wholesalers",
  },
  {
    code: "423860",
    title: "Aerospace equipment and supplies merchant wholesalers",
  },
  {
    code: "423860",
    title: "Aircraft engines and parts merchant wholesalers",
  },
  {
    code: "423860",
    title: "Aircraft equipment and supplies merchant wholesalers",
  },
  {
    code: "423860",
    title: "Aircraft merchant wholesalers",
  },
  {
    code: "423860",
    title: "Boats (except pleasure) merchant wholesalers",
  },
  {
    code: "423860",
    title: "Carts, golf, motorized passenger merchant wholesalers",
  },
  {
    code: "423860",
    title: "Draglines, ship, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Dredges, ship, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Dunnage, marine supplies, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Engines and parts, aircraft, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Engines and turbines, marine, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Golf carts, motorized passenger, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Guided missiles and space vehicles merchant wholesalers",
  },
  {
    code: "423860",
    title: "Locomotives merchant wholesalers",
  },
  {
    code: "423860",
    title: "Marine supplies (except pleasure) merchant wholesalers",
  },
  {
    code: "423860",
    title: "Military vehicles (except trucks) merchant wholesalers",
  },
  {
    code: "423860",
    title: "Motorized passenger golf carts merchant wholesalers",
  },
  {
    code: "423860",
    title: "Navigational instruments (except electronic) merchant wholesalers",
  },
  {
    code: "423860",
    title: "Propulsion systems, marine, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Railroad cars merchant wholesalers",
  },
  {
    code: "423860",
    title: "Railroad equipment and supplies merchant wholesalers",
  },
  {
    code: "423860",
    title: "Ships merchant wholesalers",
  },
  {
    code: "423860",
    title: "Space propulsion units and parts merchant wholesalers",
  },
  {
    code: "423860",
    title: "Subway cars merchant wholesalers",
  },
  {
    code: "423860",
    title: "Tanks and tank components merchant wholesalers",
  },
  {
    code: "423860",
    title:
      "Transportation equipment and supplies (except marine pleasure craft, motor vehicles) merchant wholesalers",
  },
  {
    code: "423860",
    title:
      "Transportation machinery, equipment, and supplies (except marine pleasure craft, motor vehicles) merchant wholesalers",
  },
  {
    code: "423860",
    title: "Turbines, transportation, merchant wholesalers",
  },
  {
    code: "423860",
    title: "Yachts (except pleasure) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Ammunition, sporting, merchant wholesalers",
  },
  {
    code: "423910",
    title: "Archery equipment merchant wholesalers",
  },
  {
    code: "423910",
    title:
      "Athletic goods (except apparel, footwear, nonspecialty) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Athletic uniforms merchant wholesalers",
  },
  {
    code: "423910",
    title: "Bait, artificial, merchant wholesalers",
  },
  {
    code: "423910",
    title: "Baseball equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Bicycle tires and tubes merchant wholesalers",
  },
  {
    code: "423910",
    title: "Bicycles (except motorized) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Billiard equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Boat supplies, pleasure, merchant wholesalers",
  },
  {
    code: "423910",
    title:
      "Boats, pleasure (e.g., canoes, motorboats, sailboats), merchant wholesalers",
  },
  {
    code: "423910",
    title: "Bowling equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Camping equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Casino supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Firearms, sporting, merchant wholesalers",
  },
  {
    code: "423910",
    title:
      "Fishing equipment and supplies (except commercial) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Fitness equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Football equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Gocarts merchant wholesalers",
  },
  {
    code: "423910",
    title: "Golf carts (except motorized passenger) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Golf equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Guns, sporting equipment, merchant wholesalers",
  },
  {
    code: "423910",
    title: "Gymnasium equipment merchant wholesalers",
  },
  {
    code: "423910",
    title: "Hockey equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Hot tubs merchant wholesalers",
  },
  {
    code: "423910",
    title: "Hunting equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Jet skis merchant wholesalers",
  },
  {
    code: "423910",
    title: "Marine supplies, pleasure, merchant wholesalers",
  },
  {
    code: "423910",
    title: "Motors, outboard, merchant wholesalers",
  },
  {
    code: "423910",
    title: "Outboard motors merchant wholesalers",
  },
  {
    code: "423910",
    title: "Playground equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Pleasure boats merchant wholesalers",
  },
  {
    code: "423910",
    title: "Pool (billiards) tables and supplies merchant wholesalers ",
  },
  {
    code: "423910",
    title: "Pool (swimming) and equipment merchant wholesalers",
  },
  {
    code: "423910",
    title:
      "Recreational equipment and supplies (except vehicles) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Skiing equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title:
      "Specialty athletic footwear (e.g., bowling, golf, cleated) merchant wholesalers",
  },
  {
    code: "423910",
    title: "Sporting firearms and ammunition merchant wholesalers",
  },
  {
    code: "423910",
    title: "Sporting goods and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Sports equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Swimming pools and equipment merchant wholesalers",
  },
  {
    code: "423910",
    title: "Tennis equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Trapshooting equipment and supplies merchant wholesalers",
  },
  {
    code: "423910",
    title: "Yachts, pleasure, merchant wholesalers",
  },
  {
    code: "423920",
    title: "Board games merchant wholesalers",
  },
  {
    code: "423920",
    title: "Card games merchant wholesalers",
  },
  {
    code: "423920",
    title: "Children's vehicles (except bicycles) merchant wholesalers",
  },
  {
    code: "423920",
    title: "Coloring books merchant wholesalers",
  },
  {
    code: "423920",
    title: "Craft kits merchant wholesalers",
  },
  {
    code: "423920",
    title: "Dolls merchant wholesalers",
  },
  {
    code: "423920",
    title: "Electronic games merchant wholesalers",
  },
  {
    code: "423920",
    title: "Fireworks merchant wholesalers",
  },
  {
    code: "423920",
    title: "Games (except coin- or card-operated) merchant wholesalers",
  },
  {
    code: "423920",
    title: "Gaming consoles merchant wholesalers",
  },
  {
    code: "423920",
    title: "Hobby craft kits merchant wholesalers",
  },
  {
    code: "423920",
    title: "Hobbyists' supplies merchant wholesalers",
  },
  {
    code: "423920",
    title: "Model kits merchant wholesalers",
  },
  {
    code: "423920",
    title: "Playing cards merchant wholesalers",
  },
  {
    code: "423920",
    title: "Puzzles merchant wholesalers",
  },
  {
    code: "423920",
    title: "Science kits and sets merchant wholesalers",
  },
  {
    code: "423920",
    title: "Stamps, philatelist, merchant wholesalers",
  },
  {
    code: "423920",
    title: "Toy furniture merchant wholesalers",
  },
  {
    code: "423920",
    title: "Toys (including electronic) merchant wholesalers",
  },
  {
    code: "423920",
    title: "Trading cards merchant wholesalers",
  },
  {
    code: "423920",
    title: "Vehicles, children's (except bicycles), merchant wholesalers",
  },
  {
    code: "423920",
    title: "Video games merchant wholesalers",
  },
  {
    code: "423930",
    title: "Bags, reclaimed, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Bottles, waste, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Boxes, waste, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Electronics parts, recyclable, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Fly ash merchant wholesalers",
  },
  {
    code: "423930",
    title: "Fur cuttings and scraps merchant wholesalers",
  },
  {
    code: "423930",
    title: "General-line scrap merchant wholesalers",
  },
  {
    code: "423930",
    title: "Glass scrap merchant wholesalers",
  },
  {
    code: "423930",
    title: "Industrial wastes to be reclaimed merchant wholesalers",
  },
  {
    code: "423930",
    title: "Metal scrap and waste merchant wholesalers",
  },
  {
    code: "423930",
    title: "Oil, waste, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Paper, scrap, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Plastics scrap merchant wholesalers",
  },
  {
    code: "423930",
    title: "Rags merchant wholesalers",
  },
  {
    code: "423930",
    title: "Recyclable inkjet cartridges merchant wholesalers",
  },
  {
    code: "423930",
    title:
      "Recyclable materials (e.g., glass, metal, paper) merchant wholesalers",
  },
  {
    code: "423930",
    title: "Rubber scrap and scrap tires merchant wholesalers",
  },
  {
    code: "423930",
    title: "Salvage, scrap, merchant wholesalers",
  },
  {
    code: "423930",
    title:
      "Scrap materials (e.g., automotive, industrial) merchant wholesalers",
  },
  {
    code: "423930",
    title:
      "Ship dismantling (except at floating drydocks and shipyards) merchant wholesalers",
  },
  {
    code: "423930",
    title: "Textile waste merchant wholesalers",
  },
  {
    code: "423930",
    title: "Tires, scrap, merchant wholesalers",
  },
  {
    code: "423930",
    title: "Waste materials merchant wholesalers",
  },
  {
    code: "423940",
    title: "Antique jewelry merchant wholesalers",
  },
  {
    code: "423940",
    title: "Clocks merchant wholesalers",
  },
  {
    code: "423940",
    title: "Coins merchant wholesalers",
  },
  {
    code: "423940",
    title: "Costume jewelry merchant wholesalers",
  },
  {
    code: "423940",
    title: "Diamonds (except industrial) merchant wholesalers",
  },
  {
    code: "423940",
    title: "Flatware, precious and plated, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Gem stones merchant wholesalers",
  },
  {
    code: "423940",
    title: "Hollowware, precious metal, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Ingots, precious, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Jewelers' findings merchant wholesalers",
  },
  {
    code: "423940",
    title: "Jewelry merchant wholesalers",
  },
  {
    code: "423940",
    title: "Medallions merchant wholesalers",
  },
  {
    code: "423940",
    title: "Metals, precious, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Numismatic goods merchant wholesalers",
  },
  {
    code: "423940",
    title: "Pearls merchant wholesalers",
  },
  {
    code: "423940",
    title: "Plated metal cutlery or flatware merchant wholesalers",
  },
  {
    code: "423940",
    title: "Precious and semiprecious stones merchant wholesalers",
  },
  {
    code: "423940",
    title: "Precious metals merchant wholesalers",
  },
  {
    code: "423940",
    title: "Silverware, precious and plated, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Stones, precious and semiprecious, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Tableware, precious and plated, merchant wholesalers",
  },
  {
    code: "423940",
    title: "Trophies merchant wholesalers",
  },
  {
    code: "423940",
    title: "Watchcases merchant wholesalers",
  },
  {
    code: "423940",
    title: "Watches and parts merchant wholesalers",
  },
  {
    code: "423990",
    title: "Ammunition (except sporting) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Audio and video tapes and disks, prerecorded, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Billboards merchant wholesalers",
  },
  {
    code: "423990",
    title: "Briefcases merchant wholesalers",
  },
  {
    code: "423990",
    title: "Bulletproof vests merchant wholesalers",
  },
  {
    code: "423990",
    title: "Cassettes, prerecorded audio and video, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Coin- or card-operated game machines merchant wholesalers",
  },
  {
    code: "423990",
    title: "Compact discs (CDs), prerecorded, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Digital video discs (DVDs), prerecorded, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Extinguishers, fire, merchant wholesalers",
  },
  {
    code: "423990",
    title:
      "Fire extinguisher sales combined with rental and/or service, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Fire extinguishers merchant wholesalers",
  },
  {
    code: "423990",
    title: "Firearms (except sporting) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Firewood merchant wholesalers",
  },
  {
    code: "423990",
    title: "Forest products (except lumber) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Games, coin- or card-operated, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Gas lighting fixtures merchant wholesalers",
  },
  {
    code: "423990",
    title: "General merchandise, durable goods, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Guns (except sporting) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Instruments, musical, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Lighting equipment, gas, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Logs merchant wholesalers",
  },
  {
    code: "423990",
    title: "Luggage merchant wholesalers",
  },
  {
    code: "423990",
    title: "Mailboxes merchant wholesalers",
  },
  {
    code: "423990",
    title: "Monuments and grave markers merchant wholesalers",
  },
  {
    code: "423990",
    title: "Musical instrument accessories and supplies merchant wholesalers",
  },
  {
    code: "423990",
    title: "Musical instruments merchant wholesalers",
  },
  {
    code: "423990",
    title:
      "Musical recordings (e.g., compact discs, records, tapes) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Ordnance and accessories merchant wholesalers",
  },
  {
    code: "423990",
    title:
      "Personal safety devices and supplies (e.g., eye shields, face shields, nonelectric respirators) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Phonograph records merchant wholesalers",
  },
  {
    code: "423990",
    title: "Prerecorded audio and video tapes and discs merchant wholesalers",
  },
  {
    code: "423990",
    title: "Pulpwood merchant wholesalers",
  },
  {
    code: "423990",
    title: "Railroad ties, wood, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Roundwood merchant wholesalers",
  },
  {
    code: "423990",
    title: "Safety deposit boxes merchant wholesalers",
  },
  {
    code: "423990",
    title: "Signs (except electrical) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Suitcases merchant wholesalers",
  },
  {
    code: "423990",
    title: "Synthetic or artificial turf merchant wholesalers",
  },
  {
    code: "423990",
    title: "Tapes, prerecorded, audio or video, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Ties, wood, merchant wholesalers",
  },
  {
    code: "423990",
    title: "Timber and timber products (except lumber) merchant wholesalers",
  },
  {
    code: "423990",
    title: "Tombstones merchant wholesalers",
  },
  {
    code: "423990",
    title: "Video tapes, prerecorded, merchant wholesalers",
  },
  {
    code: "423990",
    title:
      "Wood products (e.g., chips, posts, shavings, ties) merchant wholesalers",
  },
  {
    code: "424110",
    title: "Envelope paper, bulk, merchant wholesalers",
  },
  {
    code: "424110",
    title: "Fine paper, bulk, merchant wholesalers",
  },
  {
    code: "424110",
    title: "Groundwood paper, bulk, merchant wholesalers",
  },
  {
    code: "424110",
    title: "Newsprint merchant wholesalers",
  },
  {
    code: "424110",
    title: "Paper (e.g., fine, printing, writing), bulk, merchant wholesalers",
  },
  {
    code: "424110",
    title: "Printing paper, bulk, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Albums, photo, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Binders, looseleaf, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Blankbooks merchant wholesalers",
  },
  {
    code: "424120",
    title: "Books, sales or receipt, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Cards, greeting, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Cartridge toner merchant wholesalers",
  },
  {
    code: "424120",
    title: "Cellophane tape merchant wholesalers",
  },
  {
    code: "424120",
    title: "Commercial stationery supplies merchant wholesalers",
  },
  {
    code: "424120",
    title: "Computer paper supplies merchant wholesalers",
  },
  {
    code: "424120",
    title: "Desk accessories, office, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Envelopes merchant wholesalers",
  },
  {
    code: "424120",
    title: "File cards and folders merchant wholesalers",
  },
  {
    code: "424120",
    title: "Filler paper, looseleaf, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Folders, file, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Forms, paper (e.g., business, office, sales), merchant wholesalers",
  },
  {
    code: "424120",
    title: "Gift wrapping paper merchant wholesalers",
  },
  {
    code: "424120",
    title: "Greeting cards merchant wholesalers",
  },
  {
    code: "424120",
    title: "Gummed tapes, cellophane, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Ink, writing, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Inked ribbons merchant wholesalers",
  },
  {
    code: "424120",
    title: "Inks, pastes, and solvents, office, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Looseleaf binders merchant wholesalers",
  },
  {
    code: "424120",
    title: "Manifold business forms merchant wholesalers",
  },
  {
    code: "424120",
    title: "Marking devices merchant wholesalers",
  },
  {
    code: "424120",
    title: "Notebooks merchant wholesalers",
  },
  {
    code: "424120",
    title: "Office supplies (except furniture, machines) merchant wholesalers",
  },
  {
    code: "424120",
    title: "Paper, office (e.g., printer, copier), merchant wholesalers",
  },
  {
    code: "424120",
    title: "Pencils merchant wholesalers",
  },
  {
    code: "424120",
    title: "Pens, writing, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Photo albums merchant wholesalers",
  },
  {
    code: "424120",
    title: "Photocopy supplies merchant wholesalers",
  },
  {
    code: "424120",
    title: "Postcards merchant wholesalers",
  },
  {
    code: "424120",
    title: "Printing paper (except bulk) merchant wholesalers",
  },
  {
    code: "424120",
    title: "Receipt books merchant wholesalers",
  },
  {
    code: "424120",
    title: "Ribbons, inked, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Rubber stamps merchant wholesalers",
  },
  {
    code: "424120",
    title: "Sales books merchant wholesalers",
  },
  {
    code: "424120",
    title: "Scrapbooks merchant wholesalers",
  },
  {
    code: "424120",
    title: "Social stationery merchant wholesalers",
  },
  {
    code: "424120",
    title: "Stationery supplies merchant wholesalers",
  },
  {
    code: "424120",
    title: "Tapes, cellophane, merchant wholesalers",
  },
  {
    code: "424120",
    title: "Toner cartridges merchant wholesalers",
  },
  {
    code: "424120",
    title: "Typewriter paper merchant wholesalers",
  },
  {
    code: "424120",
    title: "Writing paper (except bulk) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Bags, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Boxes, paperboard and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Cardboard products merchant wholesalers",
  },
  {
    code: "424130",
    title: "Cartons, paper and paperboard, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Closures, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Containers, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Converted paper (except stationery and office supplies) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Corrugated paper merchant wholesalers",
  },
  {
    code: "424130",
    title: "Crates, paperboard and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Cups, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Diapers, disposable, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Dishes, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Disposable plastics products (e.g., boxes, cups, cutlery, dishes, sanitary food containers) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Eating utensils, disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Egg cartons, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Facial tissue merchant wholesalers",
  },
  {
    code: "424130",
    title: "Fiber cans and drums merchant wholesalers",
  },
  {
    code: "424130",
    title: "Filter papers merchant wholesalers",
  },
  {
    code: "424130",
    title: "Foam plastic trays merchant wholesalers",
  },
  {
    code: "424130",
    title: "Gummed tapes (except cellophane) merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Industrial supplies, disposable plastics, paper, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Knives, disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Napkins, paper, merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Paper (except office supplies, printing paper, stationery, writing paper) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Paper bags merchant wholesalers",
  },
  {
    code: "424130",
    title: "Paper towels merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Paperboard and paperboard products (except office supplies) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Personal sanitary paper products merchant wholesalers",
  },
  {
    code: "424130",
    title: "Plastics bags merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Plastics foam products, disposable (except packaging, packing), merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Pressed and molded pulp goods (e.g., egg cartons, shipping supplies) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Sacks, paper, merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Sanitary food containers (e.g., disposable plastics, paper, paperboard) merchant wholesalers",
  },
  {
    code: "424130",
    title: "Sanitary paper products merchant wholesalers",
  },
  {
    code: "424130",
    title:
      "Shipping supplies, paper and disposable plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Shopping bags, paper and plastics, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Tableware, disposable, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Tissue paper, toilet and facial, merchant wholesalers",
  },
  {
    code: "424130",
    title: "Toilet tissue merchant wholesalers",
  },
  {
    code: "424130",
    title: "Waxed paper merchant wholesalers",
  },
  {
    code: "424130",
    title: "Wrapping paper (except gift wrap) merchant wholesalers",
  },
  {
    code: "424210",
    title: "Antibiotics merchant wholesalers",
  },
  {
    code: "424210",
    title: "Antiseptics merchant wholesalers",
  },
  {
    code: "424210",
    title: "Bacteriological medicines merchant wholesalers",
  },
  {
    code: "424210",
    title: "Bandages (except surgical) merchant wholesalers",
  },
  {
    code: "424210",
    title: "Beauty preparations merchant wholesalers",
  },
  {
    code: "424210",
    title: "Beauty supplies merchant wholesalers",
  },
  {
    code: "424210",
    title: "Biologicals and allied products merchant wholesalers",
  },
  {
    code: "424210",
    title: "Blades, razor, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Blood derivatives merchant wholesalers",
  },
  {
    code: "424210",
    title: "Blood plasma merchant wholesalers",
  },
  {
    code: "424210",
    title: "Botanical drugs and herbs merchant wholesalers",
  },
  {
    code: "424210",
    title: "Botanicals merchant wholesalers",
  },
  {
    code: "424210",
    title: "Colognes merchant wholesalers",
  },
  {
    code: "424210",
    title: "Cosmetics merchant wholesalers",
  },
  {
    code: "424210",
    title: "Dental care preparations merchant wholesalers",
  },
  {
    code: "424210",
    title: "Dentifrices merchant wholesalers",
  },
  {
    code: "424210",
    title: "Deodorants, personal, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Dermatological medicines merchant wholesalers",
  },
  {
    code: "424210",
    title: "Diagnostic reagents merchant wholesalers",
  },
  {
    code: "424210",
    title: "Diagnostics, in-vitro and in-vivo, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Dietary supplements merchant wholesalers",
  },
  {
    code: "424210",
    title: "Drug proprietaries merchant wholesalers",
  },
  {
    code: "424210",
    title: "Druggists' sundries merchant wholesalers",
  },
  {
    code: "424210",
    title: "Drugs merchant wholesalers",
  },
  {
    code: "424210",
    title: "Endocrine substances merchant wholesalers",
  },
  {
    code: "424210",
    title: "First-aid kits, household, merchant wholesalers",
  },
  {
    code: "424210",
    title: "First-aid supplies, household, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Gauze merchant wholesalers",
  },
  {
    code: "424210",
    title: "General-line drugs merchant wholesalers",
  },
  {
    code: "424210",
    title: "Hair care products merchant wholesalers",
  },
  {
    code: "424210",
    title: "Hair preparations (except professional) merchant wholesalers",
  },
  {
    code: "424210",
    title: "Hand sanitizers merchant wholesalers",
  },
  {
    code: "424210",
    title: "Herbal supplements merchant wholesalers",
  },
  {
    code: "424210",
    title: "Hygiene products, oral, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Medical sundries, rubber, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Nonprescription drugs merchant wholesalers",
  },
  {
    code: "424210",
    title: "Perfumes merchant wholesalers",
  },
  {
    code: "424210",
    title: "Pharmaceuticals merchant wholesalers",
  },
  {
    code: "424210",
    title: "Plasmas, blood, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Prescription drugs merchant wholesalers",
  },
  {
    code: "424210",
    title: "Radioactive pharmaceutical isotopes merchant wholesalers",
  },
  {
    code: "424210",
    title: "Radiopharmaceuticals merchant wholesalers",
  },
  {
    code: "424210",
    title: "Razor blades merchant wholesalers",
  },
  {
    code: "424210",
    title: "Razors (except electric) merchant wholesalers",
  },
  {
    code: "424210",
    title: "Rubber goods, medical, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Salts, bath, merchant wholesalers",
  },
  {
    code: "424210",
    title: "Shaving preparations merchant wholesalers",
  },
  {
    code: "424210",
    title: "Skin care preparations merchant wholesalers",
  },
  {
    code: "424210",
    title: "Specialty-line pharmaceuticals merchant wholesalers",
  },
  {
    code: "424210",
    title: "Toilet preparations merchant wholesalers",
  },
  {
    code: "424210",
    title: "Toilet soaps merchant wholesalers",
  },
  {
    code: "424210",
    title: "Toiletries merchant wholesalers",
  },
  {
    code: "424210",
    title: "Toothbrushes (except electric) merchant wholesalers",
  },
  {
    code: "424210",
    title: "Toothpastes merchant wholesalers",
  },
  {
    code: "424210",
    title: "Vaccines merchant wholesalers",
  },
  {
    code: "424210",
    title: "Veterinarians' medicines merchant wholesalers",
  },
  {
    code: "424210",
    title: "Vitamins merchant wholesalers",
  },
  {
    code: "424310",
    title: "Apparel trimmings merchant wholesalers",
  },
  {
    code: "424310",
    title: "Automotive fabrics merchant wholesalers",
  },
  {
    code: "424310",
    title: "Belt and buckle assembly kits merchant wholesalers",
  },
  {
    code: "424310",
    title: "Binding, textile, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Buttons merchant wholesalers",
  },
  {
    code: "424310",
    title: "Drapery material merchant wholesalers",
  },
  {
    code: "424310",
    title: "Embroidery products merchant wholesalers",
  },
  {
    code: "424310",
    title: "Fabrics, textile (except burlap, felt), merchant wholesalers",
  },
  {
    code: "424310",
    title: "Fasteners, clothing, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Fiberglass fabrics merchant wholesalers",
  },
  {
    code: "424310",
    title: "Hair accessories merchant wholesalers",
  },
  {
    code: "424310",
    title: "Hat and cap materials merchant wholesalers",
  },
  {
    code: "424310",
    title: "Jute piece goods (except burlap) merchant wholesalers",
  },
  {
    code: "424310",
    title: "Labels, textile, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Millinery supplies merchant wholesalers",
  },
  {
    code: "424310",
    title: "Needles, sewing, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Net goods merchant wholesalers",
  },
  {
    code: "424310",
    title: "Notions merchant wholesalers",
  },
  {
    code: "424310",
    title: "Paddings, apparel, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Piece goods (except burlap, felt) merchant wholesalers",
  },
  {
    code: "424310",
    title: "Remnants, piece goods, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Ribbons, textile, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Sewing accessories merchant wholesalers",
  },
  {
    code: "424310",
    title: "Tapes, textile, merchant wholesalers",
  },
  {
    code: "424310",
    title: "Textiles (except burlap, felt) merchant wholesalers",
  },
  {
    code: "424310",
    title: "Thread (except industrial) merchant wholesalers",
  },
  {
    code: "424310",
    title: "Upholstery fabrics merchant wholesalers",
  },
  {
    code: "424310",
    title: "Yard goods, textile (except burlap, felt), merchant wholesalers",
  },
  {
    code: "424310",
    title: "Yarns (except industrial) merchant wholesalers",
  },
  {
    code: "424310",
    title: "Zippers merchant wholesalers",
  },
  {
    code: "424340",
    title:
      "Athletic footwear (except specialty athletic footwear) merchant wholesalers",
  },
  {
    code: "424340",
    title: "Boots (e.g., hiking, western, work) merchant wholesalers",
  },
  {
    code: "424340",
    title: "Footwear merchant wholesalers",
  },
  {
    code: "424340",
    title: "Leather cut stock for shoe and boot merchant wholesalers",
  },
  {
    code: "424340",
    title: "Shoe accessories merchant wholesalers",
  },
  {
    code: "424340",
    title: "Shoes merchant wholesalers",
  },
  {
    code: "424340",
    title: "Slippers merchant wholesalers",
  },
  {
    code: "424350",
    title: "Accessories, clothing, men's and boy's, merchant wholesalers",
  },
  {
    code: "424350",
    title: "Baby and infant car seats merchant wholesalers",
  },
  {
    code: "424350",
    title: "Baby and infant high chairs merchant wholesalers",
  },
  {
    code: "424350",
    title: "Baby bottles merchant wholesalers",
  },
  {
    code: "424350",
    title: "Baby clothing merchant wholesalers",
  },
  {
    code: "424350",
    title: "Booster seats merchant wholesalers",
  },
  {
    code: "424350",
    title: "Children's clothing merchant wholesalers",
  },
  {
    code: "424350",
    title:
      "Clothing accessories, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Clothing, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Clothing, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Coats, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Coats, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Costumes, clothing, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Costumes, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Diapers (except disposable) merchant wholesalers",
  },
  {
    code: "424350",
    title: "Dresses merchant wholesalers",
  },
  {
    code: "424350",
    title: "Fur clothing merchant wholesalers",
  },
  {
    code: "424350",
    title: "Furnishings (except shoes), men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title:
      "Furnishings (except shoes), women's, girls', and infants', merchant wholesalers ",
  },
  {
    code: "424350",
    title: "Gloves, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Gloves, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Handbags merchant wholesalers",
  },
  {
    code: "424350",
    title: "Hats and caps, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Hats and caps, women's, girls', and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Hosiery, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Hosiery, women's and girls', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Hosiery, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Infants' clothing merchant wholesalers",
  },
  {
    code: "424350",
    title: "Lingerie merchant wholesalers",
  },
  {
    code: "424350",
    title: "Men's and boys' clothing merchant wholesalers",
  },
  {
    code: "424350",
    title: "Men's and boys' furnishings (except shoes) merchant wholesalers",
  },
  {
    code: "424350",
    title: "Millinery merchant wholesalers",
  },
  {
    code: "424350",
    title: "Neckties, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Nightwear, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Nightwear, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Outerwear, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Outerwear, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Purses merchant wholesalers",
  },
  {
    code: "424350",
    title: "Sleepwear, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Sleepwear, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Socks, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Socks, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Sportswear, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Strollers merchant wholesalers",
  },
  {
    code: "424350",
    title: "Suits, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Swimwear, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Swimwear, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Umbrellas, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Umbrellas, women's and girls', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Underwear, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Underwear, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Uniforms (except athletic), men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title:
      "Uniforms (except athletic), women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Unisex clothing merchant wholesalers",
  },
  {
    code: "424350",
    title: "Waterproof garments, men's and boys', merchant wholesalers",
  },
  {
    code: "424350",
    title:
      "Waterproof garments, women's, children's, and infants', merchant wholesalers",
  },
  {
    code: "424350",
    title: "Women's and children's clothing accessories merchant wholesalers",
  },
  {
    code: "424350",
    title: "Women's clothing merchant wholesalers",
  },
  {
    code: "424350",
    title: "Work clothing, men's and boys', merchant wholesalers",
  },
  {
    code: "424410",
    title: "Food, general-line, merchant wholesalers",
  },
  {
    code: "424410",
    title: "General-line groceries merchant wholesalers",
  },
  {
    code: "424410",
    title: "Groceries, general-line, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Bakery products, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Dinners, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Doughs, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Fish, packaged frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Foods, prepared, packaged frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title:
      "Frozen foods, packaged (except dairy products), merchant wholesalers",
  },
  {
    code: "424420",
    title: "Fruits, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Juices, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Meat product substitutes, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Meat substitutes, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Meatless patties, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Meats, packaged frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Pies (e.g., fruit, meat, poultry), frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Pizzas, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Poultry, packaged frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title:
      "Prepared foods, frozen (except dairy products), merchant wholesalers",
  },
  {
    code: "424420",
    title: "Pretzels, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Seafoods, packaged frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Soups, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Vegetable patties, frozen, merchant wholesalers",
  },
  {
    code: "424420",
    title: "Vegetables, frozen, merchant wholesalers",
  },
  {
    code: "424430",
    title: "Butter merchant wholesalers",
  },
  {
    code: "424430",
    title: "Buttermilk merchant wholesalers",
  },
  {
    code: "424430",
    title: "Cheese merchant wholesalers",
  },
  {
    code: "424430",
    title: "Cream merchant wholesalers",
  },
  {
    code: "424430",
    title: "Cream stations merchant wholesalers",
  },
  {
    code: "424430",
    title: "Creamery products (except canned) merchant wholesalers",
  },
  {
    code: "424430",
    title: "Dairy depots merchant wholesalers",
  },
  {
    code: "424430",
    title: "Dairy products (except canned, dried) merchant wholesalers",
  },
  {
    code: "424430",
    title: "Dairy products, frozen, merchant wholesalers",
  },
  {
    code: "424430",
    title: "Desserts, dairy, merchant wholesalers",
  },
  {
    code: "424430",
    title: "Frozen yogurt merchant wholesalers",
  },
  {
    code: "424430",
    title: "Ice cream and ices merchant wholesalers",
  },
  {
    code: "424430",
    title: "Ice cream merchant wholesalers",
  },
  {
    code: "424430",
    title: "Ice milk merchant wholesalers",
  },
  {
    code: "424430",
    title: "Milk, fluid (except canned), merchant wholesalers",
  },
  {
    code: "424430",
    title: "Prepared foods, frozen dairy, merchant wholesalers",
  },
  {
    code: "424430",
    title: "Raw milk merchant wholesalers",
  },
  {
    code: "424430",
    title: "Yogurt merchant wholesalers",
  },
  {
    code: "424440",
    title:
      "Chicken and chicken products (except canned and packaged frozen) merchant wholesalers",
  },
  {
    code: "424440",
    title: "Deli meats, poultry, merchant wholesalers",
  },
  {
    code: "424440",
    title: "Eggs merchant wholesalers",
  },
  {
    code: "424440",
    title: "Fresh poultry merchant wholesalers",
  },
  {
    code: "424440",
    title: "Frozen poultry (except packaged) merchant wholesalers",
  },
  {
    code: "424440",
    title: "Packaged poultry (except canned and frozen) merchant wholesalers",
  },
  {
    code: "424440",
    title:
      "Poultry and poultry products (except canned, packaged frozen) merchant wholesalers",
  },
  {
    code: "424440",
    title: "Poultry pies (except packaged frozen) merchant wholesalers",
  },
  {
    code: "424440",
    title: "Poultry, live and dressed, merchant wholesalers",
  },
  {
    code: "424440",
    title: "Processed poultry (e.g., luncheon) merchant wholesalers",
  },
  {
    code: "424440",
    title:
      "Turkey and turkey products (except canned and packaged frozen) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Candy merchant wholesalers",
  },
  {
    code: "424450",
    title: "Cheese confections (e.g., curls, puffs) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Chewing gum merchant wholesalers",
  },
  {
    code: "424450",
    title: "Chips (e.g., corn, potato) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Chocolate candy merchant wholesalers",
  },
  {
    code: "424450",
    title: "Concentrates, fountain (except soft drink), merchant wholesalers",
  },
  {
    code: "424450",
    title: "Confectionery merchant wholesalers",
  },
  {
    code: "424450",
    title: "Corn chips and related corn snacks merchant wholesalers",
  },
  {
    code: "424450",
    title:
      "Fountain fruits and syrups (except soft drink) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Fountain syrups (except soft drink) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Fruit concentrates, fountain, merchant wholesalers",
  },
  {
    code: "424450",
    title: "Gum, chewing, merchant wholesalers",
  },
  {
    code: "424450",
    title: "Nuts (e.g., canned, roasted, salted) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Popcorn merchant wholesalers",
  },
  {
    code: "424450",
    title: "Potato chips and related snacks merchant wholesalers",
  },
  {
    code: "424450",
    title: "Seeds (e.g., canned, roasted, salted) merchant wholesalers",
  },
  {
    code: "424450",
    title: "Syrups, fountain (except soft drink), merchant wholesalers",
  },
  {
    code: "424450",
    title: "Toppings, fountain, merchant wholesalers",
  },
  {
    code: "424460",
    title: "Cured fish merchant wholesalers",
  },
  {
    code: "424460",
    title: "Fish (except canned, packaged frozen) merchant wholesalers",
  },
  {
    code: "424460",
    title: "Fish, salted or preserved (except canned), merchant wholesalers",
  },
  {
    code: "424460",
    title: "Fresh fish merchant wholesalers",
  },
  {
    code: "424460",
    title: "Fresh seafood merchant wholesalers",
  },
  {
    code: "424460",
    title: "Frozen fish (except packaged) merchant wholesalers",
  },
  {
    code: "424460",
    title: "Frozen seafood (except packaged) merchant wholesalers",
  },
  {
    code: "424460",
    title: "Seafood (except canned, packaged frozen) merchant wholesalers",
  },
  {
    code: "424470",
    title:
      "Cutting of purchased carcasses (except boxed meat cut on an assembly line basis) merchant wholesalers",
  },
  {
    code: "424470",
    title: "Deli meats (except poultry) merchant wholesalers",
  },
  {
    code: "424470",
    title: "Fresh meats merchant wholesalers",
  },
  {
    code: "424470",
    title: "Frozen meats (except packaged) merchant wholesalers",
  },
  {
    code: "424470",
    title: "Lard merchant wholesalers",
  },
  {
    code: "424470",
    title:
      "Meats and meat products (except canned, packaged frozen) merchant wholesalers",
  },
  {
    code: "424470",
    title: "Meats, cured or smoked, merchant wholesalers",
  },
  {
    code: "424470",
    title: "Meats, fresh, merchant wholesalers",
  },
  {
    code: "424470",
    title: "Meats, frozen (except packaged), merchant wholesalers",
  },
  {
    code: "424470",
    title: "Processed meats (e.g., luncheon, sausage) merchant wholesalers",
  },
  {
    code: "424480",
    title: "Berries, fresh, merchant wholesalers",
  },
  {
    code: "424480",
    title: "Fresh fruits, vegetables, and berries merchant wholesalers",
  },
  {
    code: "424480",
    title: "Fruits, fresh, merchant wholesalers",
  },
  {
    code: "424480",
    title: "Health foods, fresh fruits and vegetables, merchant wholesalers",
  },
  {
    code: "424480",
    title: "Produce, fresh, merchant wholesalers",
  },
  {
    code: "424480",
    title: "Salads, prepackaged, merchant wholesalers",
  },
  {
    code: "424480",
    title: "Vegetables, fresh, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Baby foods, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Bakery products (except frozen) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Beans, dry edible, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Beverage bases merchant wholesalers",
  },
  {
    code: "424490",
    title: "Beverage concentrates merchant wholesalers",
  },
  {
    code: "424490",
    title: "Bottled water (except water treating) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Bread, packaged (except frozen), merchant wholesalers",
  },
  {
    code: "424490",
    title: "Breakfast cereals merchant wholesalers",
  },
  {
    code: "424490",
    title: "Brewers' yeast merchant wholesalers",
  },
  {
    code: "424490",
    title: "Butter substitutes merchant wholesalers",
  },
  {
    code: "424490",
    title: "Cane sugar, refined, merchant wholesalers",
  },
  {
    code: "424490",
    title:
      "Canned foods (e.g., fish, meat, seafood, soups) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Carbonated beverages merchant wholesalers",
  },
  {
    code: "424490",
    title: "Cereal products merchant wholesalers",
  },
  {
    code: "424490",
    title: "Cheese, imitation or substitute, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Chocolate (except candy) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Chocolate coatings merchant wholesalers",
  },
  {
    code: "424490",
    title: "Chocolate syrups (except fountain) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Coffee merchant wholesalers",
  },
  {
    code: "424490",
    title: "Cookies merchant wholesalers",
  },
  {
    code: "424490",
    title: "Cooking oils merchant wholesalers",
  },
  {
    code: "424490",
    title:
      "Corn milling products (except pet and livestock feeds) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Cornmeal, edible, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Crackers merchant wholesalers",
  },
  {
    code: "424490",
    title: "Creamery products, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Dairy products, dried or canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Dessert powders merchant wholesalers",
  },
  {
    code: "424490",
    title: "Dried foods (e.g., fruits, milk, vegetables) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Egg substitutes merchant wholesalers",
  },
  {
    code: "424490",
    title: "Fish, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Flavoring extracts (except for fountain use) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Flour merchant wholesalers",
  },
  {
    code: "424490",
    title: "Fruits, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Gelatin, edible, merchant wholesalers",
  },
  {
    code: "424490",
    title:
      "Health foods (except fresh fruits, vegetables) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Honey merchant wholesalers",
  },
  {
    code: "424490",
    title: "Hop extract merchant wholesalers",
  },
  {
    code: "424490",
    title: "Ice cream cones merchant wholesalers",
  },
  {
    code: "424490",
    title: "Jellies and jams merchant wholesalers",
  },
  {
    code: "424490",
    title: "Juices, canned or fresh, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Macaroni merchant wholesalers",
  },
  {
    code: "424490",
    title: "Malt extract merchant wholesalers",
  },
  {
    code: "424490",
    title: "Malt merchant wholesalers",
  },
  {
    code: "424490",
    title: "Maple syrup merchant wholesalers",
  },
  {
    code: "424490",
    title: "Margarine merchant wholesalers",
  },
  {
    code: "424490",
    title: "Marmalade merchant wholesalers",
  },
  {
    code: "424490",
    title: "Meats, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Milk substitutes merchant wholesalers",
  },
  {
    code: "424490",
    title: "Milk, canned or dried, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Mixes (e.g., cake, dessert, pie) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Molasses merchant wholesalers",
  },
  {
    code: "424490",
    title: "Nondairy creamers merchant wholesalers",
  },
  {
    code: "424490",
    title: "Nondairy milk merchant wholesalers",
  },
  {
    code: "424490",
    title: "Nondairy yogurt merchant wholesalers",
  },
  {
    code: "424490",
    title: "Oils, cooking and salad, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Pet food merchant wholesalers",
  },
  {
    code: "424490",
    title: "Pizzas (except frozen) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Poultry, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Prepared foods (except frozen) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Pretzels (except frozen) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Rice, polished, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Salad dressings merchant wholesalers",
  },
  {
    code: "424490",
    title: "Salad oils merchant wholesalers",
  },
  {
    code: "424490",
    title: "Salt, table, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Sandwiches merchant wholesalers",
  },
  {
    code: "424490",
    title: "Sausage casings merchant wholesalers",
  },
  {
    code: "424490",
    title: "Seafood, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Shortening, vegetable, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Soft drinks merchant wholesalers",
  },
  {
    code: "424490",
    title: "Soups (except frozen) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Spaghetti merchant wholesalers",
  },
  {
    code: "424490",
    title: "Spices merchant wholesalers",
  },
  {
    code: "424490",
    title: "Sport energy drinks merchant wholesalers",
  },
  {
    code: "424490",
    title: "Sugar, refined, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Syrup (except fountain) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Tea merchant wholesalers",
  },
  {
    code: "424490",
    title: "Toppings (except fountain) merchant wholesalers",
  },
  {
    code: "424490",
    title: "Vegetables, canned, merchant wholesalers",
  },
  {
    code: "424490",
    title: "Water, bottled (except water treating), merchant wholesalers",
  },
  {
    code: "424490",
    title: "Yeast merchant wholesalers",
  },
  {
    code: "424510",
    title: "Beans, dry inedible, merchant wholesalers",
  },
  {
    code: "424510",
    title: "Corn, raw (except seed corn), merchant wholesalers",
  },
  {
    code: "424510",
    title: "Dry beans, inedible, merchant wholesalers",
  },
  {
    code: "424510",
    title: "Grain elevators merchant wholesalers",
  },
  {
    code: "424510",
    title: "Grain merchant wholesalers",
  },
  {
    code: "424510",
    title: "Rice, unpolished, merchant wholesalers",
  },
  {
    code: "424510",
    title: "Soybeans merchant wholesalers",
  },
  {
    code: "424510",
    title: "Wheat merchant wholesalers",
  },
  {
    code: "424520",
    title:
      "Auction markets, livestock (except horses, mules), merchant wholesalers",
  },
  {
    code: "424520",
    title: "Cattle merchant wholesalers",
  },
  {
    code: "424520",
    title: "Goats merchant wholesalers",
  },
  {
    code: "424520",
    title: "Hogs merchant wholesalers",
  },
  {
    code: "424520",
    title:
      "Livestock (except horses, mules, and feedlots) merchant wholesalers",
  },
  {
    code: "424520",
    title: "Sheep merchant wholesalers",
  },
  {
    code: "424520",
    title: "Swine merchant wholesalers",
  },
  {
    code: "424590",
    title: "Animal hair, wool, or mohair merchant wholesalers",
  },
  {
    code: "424590",
    title: "Auction markets, tobacco, horses, mules, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Bees merchant wholesalers",
  },
  {
    code: "424590",
    title: "Bovine semen merchant wholesalers",
  },
  {
    code: "424590",
    title: "Bristles merchant wholesalers",
  },
  {
    code: "424590",
    title: "Broomcorn merchant wholesalers",
  },
  {
    code: "424590",
    title: "Cannabis merchant wholesalers",
  },
  {
    code: "424590",
    title: "Chicks, live, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Cocoa beans merchant wholesalers",
  },
  {
    code: "424590",
    title: "Cotton, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Feathers merchant wholesalers",
  },
  {
    code: "424590",
    title: "Fibers, vegetable, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Furs, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Hemp merchant wholesalers",
  },
  {
    code: "424590",
    title: "Hides merchant wholesalers",
  },
  {
    code: "424590",
    title: "Hops merchant wholesalers",
  },
  {
    code: "424590",
    title: "Horses merchant wholesalers",
  },
  {
    code: "424590",
    title: "Leaf tobacco merchant wholesalers",
  },
  {
    code: "424590",
    title: "Marijuana merchant wholesalers",
  },
  {
    code: "424590",
    title: "Mohair, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Mules merchant wholesalers",
  },
  {
    code: "424590",
    title: "Nuts, unprocessed or shelled only, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Oil kernels merchant wholesalers",
  },
  {
    code: "424590",
    title: "Oil nuts merchant wholesalers",
  },
  {
    code: "424590",
    title: "Oilseeds merchant wholesalers",
  },
  {
    code: "424590",
    title: "Peanuts, bulk, unprocessed, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Pelts, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title:
      "Raw farm products (except field beans, grains) merchant wholesalers",
  },
  {
    code: "424590",
    title: "Semen, bovine, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Silk, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Skins, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Sod merchant wholesalers",
  },
  {
    code: "424590",
    title: "Spices, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Sugar, raw, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Tobacco, leaf, merchant wholesalers",
  },
  {
    code: "424590",
    title: "Wool tops and noils merchant wholesalers",
  },
  {
    code: "424590",
    title: "Wool, raw, merchant wholesalers",
  },
  {
    code: "424610",
    title: "Cellulose film merchant wholesalers",
  },
  {
    code: "424610",
    title: "Foam, plastics, resins and shapes, merchant wholesalers",
  },
  {
    code: "424610",
    title: "Nylon resins merchant wholesalers",
  },
  {
    code: "424610",
    title: "Plasticizers merchant wholesalers",
  },
  {
    code: "424610",
    title:
      "Plastics basic shapes (e.g., film, rod, sheet, sheeting, tubing) merchant wholesalers",
  },
  {
    code: "424610",
    title: "Plastics foam merchant wholesalers",
  },
  {
    code: "424610",
    title: "Plastics materials merchant wholesalers",
  },
  {
    code: "424610",
    title: "Plastics resins merchant wholesalers",
  },
  {
    code: "424610",
    title: "Polyester resins merchant wholesalers",
  },
  {
    code: "424610",
    title: "Resins, plastics, merchant wholesalers",
  },
  {
    code: "424610",
    title: "Stabilizers, plastic, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Acids merchant wholesalers",
  },
  {
    code: "424690",
    title: "Adhesives and sealants merchant wholesalers",
  },
  {
    code: "424690",
    title: "Alcohol, industrial, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Alkalies merchant wholesalers",
  },
  {
    code: "424690",
    title:
      "Alternative fuels, not blended with petroleum, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Ammonia (except fertilizer material) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Antifreeze merchant wholesalers",
  },
  {
    code: "424690",
    title: "Aromatic chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title:
      "Automotive chemicals (except lubricating greases, lubrication oils) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Biodiesel, not blended with petroleum, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Biofuels, not blended with petroleum, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Bleaches merchant wholesalers",
  },
  {
    code: "424690",
    title: "Cannabidiol (CBD oil) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Carbon black merchant wholesalers",
  },
  {
    code: "424690",
    title: "Caulking materials merchant wholesalers",
  },
  {
    code: "424690",
    title: "Caustic soda merchant wholesalers",
  },
  {
    code: "424690",
    title:
      "Chemical additives (e.g., concrete, food, fuel, oil) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Chemical gases merchant wholesalers",
  },
  {
    code: "424690",
    title:
      "Chemicals (except agriculture) (e.g., automotive, household, industrial, photographic) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Chlorine merchant wholesalers",
  },
  {
    code: "424690",
    title: "Cleaning compounds and preparations merchant wholesalers",
  },
  {
    code: "424690",
    title: "Coal tar distillates and resins merchant wholesalers",
  },
  {
    code: "424690",
    title: "Coal tar products, primary and intermediate, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Compressed gases (except LP gas) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Concrete additives merchant wholesalers",
  },
  {
    code: "424690",
    title: "Cyclic crudes and intermediates merchant wholesalers",
  },
  {
    code: "424690",
    title: "Deodorants (except personal) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Detergents merchant wholesalers",
  },
  {
    code: "424690",
    title: "Detonators (except ammunition) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Disinfectants (except agricultural) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Drilling muds merchant wholesalers",
  },
  {
    code: "424690",
    title: "Dry ice merchant wholesalers",
  },
  {
    code: "424690",
    title: "Drycleaning solvents and chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title: "Dyes, industrial, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Dyestuffs merchant wholesalers",
  },
  {
    code: "424690",
    title: "Dynamite merchant wholesalers",
  },
  {
    code: "424690",
    title: "Electronic cigarette vapor liquids merchant wholesalers",
  },
  {
    code: "424690",
    title: "Essential oils merchant wholesalers",
  },
  {
    code: "424690",
    title: "Ethanol, not blended with petroleum, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Explosives (except ammunition, fireworks) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Fabric softeners merchant wholesalers",
  },
  {
    code: "424690",
    title: "Fibers, manmade, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Fire extinguisher preparations merchant wholesalers",
  },
  {
    code: "424690",
    title: "Food additives, chemical, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Fuel additives merchant wholesalers",
  },
  {
    code: "424690",
    title:
      "Gases, compressed and liquefied (except liquefied petroleum gas), merchant wholesalers",
  },
  {
    code: "424690",
    title: "Gelatin, inedible, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Glues merchant wholesalers",
  },
  {
    code: "424690",
    title: "Gum and wood chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title: "Ice, dry, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Industrial chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title: "Industrial gases merchant wholesalers",
  },
  {
    code: "424690",
    title: "Industrial salts merchant wholesalers",
  },
  {
    code: "424690",
    title: "Inorganic chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title: "Insecticides (except lawn and agricultural) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Janitorial chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title: "Laundry soap, chips, and powder, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Liquefied gases (except LP) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Manmade fibers merchant wholesalers",
  },
  {
    code: "424690",
    title: "Mastics (except construction) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Medical gases merchant wholesalers",
  },
  {
    code: "424690",
    title: "Metal cyanides merchant wholesalers",
  },
  {
    code: "424690",
    title: "Metalworking compounds merchant wholesalers",
  },
  {
    code: "424690",
    title: "Nylon fibers merchant wholesalers",
  },
  {
    code: "424690",
    title: "Oil additives merchant wholesalers",
  },
  {
    code: "424690",
    title: "Oil drilling muds merchant wholesalers",
  },
  {
    code: "424690",
    title: "Organic chemicals merchant wholesalers",
  },
  {
    code: "424690",
    title: "Pesticides (except agricultural) merchant wholesalers",
  },
  {
    code: "424690",
    title:
      "Polishes (e.g., automobile, furniture, metal, shoe, stove) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Polyester fibers merchant wholesalers",
  },
  {
    code: "424690",
    title: "Refrigerants merchant wholesalers",
  },
  {
    code: "424690",
    title: "Resins, synthetic rubber, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Rosins merchant wholesalers",
  },
  {
    code: "424690",
    title: "Salts, industrial, merchant wholesalers",
  },
  {
    code: "424690",
    title: "Sealants merchant wholesalers",
  },
  {
    code: "424690",
    title: "Sulfuric acid merchant wholesalers",
  },
  {
    code: "424690",
    title: "Surface active agents merchant wholesalers",
  },
  {
    code: "424690",
    title: "Synthetic rubber merchant wholesalers",
  },
  {
    code: "424690",
    title: "Turpentine merchant wholesalers",
  },
  {
    code: "424690",
    title: "Water softening compounds merchant wholesalers",
  },
  {
    code: "424690",
    title: "Waxes (except petroleum) merchant wholesalers",
  },
  {
    code: "424690",
    title: "Welding gases merchant wholesalers",
  },
  {
    code: "424690",
    title: "Wood treating preparations merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Alternative fuels, blended with petroleum, bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Asphalt binder bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Asphalt, liquid, bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Biodiesel, blended with petroleum, bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Biofuels, blended with petroleum, bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Bulk gasoline stations, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Bulk stations, petroleum, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Compressed liquefied petroleum gas (LPG) bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Crude oil terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Diesel fuel bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Ethanol, blended with petroleum, bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Fuel oil bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Gasohol bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Gasoline bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Heating oil bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Jet fuel bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Kerosene bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Liquefied petroleum gas (LPG) bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Lubricating oils and greases bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Oil, petroleum, bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title:
      "Petroleum and petroleum products bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Propane bulk stations and terminals, merchant wholesalers",
  },
  {
    code: "424710",
    title: "Terminals, petroleum, merchant wholesalers",
  },
  {
    code: "424720",
    title:
      "Alternative fuels, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Asphalt binder merchant wholesalers (except bulk stations, terminals) ",
  },
  {
    code: "424720",
    title:
      "Asphalt, liquid, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Biodiesel, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Biofuels, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Butane gas merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Crude oil merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Diesel fuel merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Ethanol, blended with petroleum, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Fuel oil merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Fuel oil truck jobbers",
  },
  {
    code: "424720",
    title:
      "Fuel, aircraft, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Fueling aircraft (except on contract basis), merchant wholesalers",
  },
  {
    code: "424720",
    title: "Gasohol merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Gasoline merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Kerosene merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Liquefied petroleum gas (LPG) merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Lubricating oils and greases merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Oil, petroleum, merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title:
      "Petroleum and petroleum products merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424720",
    title: "Petroleum coke merchant wholesalers",
  },
  {
    code: "424720",
    title: "Propane merchant wholesalers (except bulk stations, terminals)",
  },
  {
    code: "424810",
    title:
      "Alcoholic beverages (except distilled spirits, wine) merchant wholesalers",
  },
  {
    code: "424810",
    title: "Ale merchant wholesalers",
  },
  {
    code: "424810",
    title: "Beer merchant wholesalers",
  },
  {
    code: "424810",
    title:
      "Beverages, alcoholic (except distilled spirits, wine), merchant wholesalers",
  },
  {
    code: "424810",
    title: "Fermented malt beverages merchant wholesalers",
  },
  {
    code: "424810",
    title: "Malt liquor merchant wholesalers",
  },
  {
    code: "424810",
    title: "Porter merchant wholesalers",
  },
  {
    code: "424820",
    title:
      "Alcoholic beverages, wine, and distilled spirits merchant wholesalers ",
  },
  {
    code: "424820",
    title: "Beverages, wine and distilled spirits, merchant wholesalers",
  },
  {
    code: "424820",
    title: "Brandy and brandy spirits merchant wholesalers",
  },
  {
    code: "424820",
    title: "Cocktails, alcoholic, premixed, merchant wholesalers",
  },
  {
    code: "424820",
    title: "Distilled alcoholic beverages merchant wholesalers",
  },
  {
    code: "424820",
    title: "Ethyl alcohol merchant wholesalers",
  },
  {
    code: "424820",
    title: "Hard cider merchant wholesalers",
  },
  {
    code: "424820",
    title: "Liquors merchant wholesalers",
  },
  {
    code: "424820",
    title: "Liquors, distilled, merchant wholesalers",
  },
  {
    code: "424820",
    title: "Neutral spirits merchant wholesalers",
  },
  {
    code: "424820",
    title: "Spirits, distilled, merchant wholesalers",
  },
  {
    code: "424820",
    title: "Wine coolers, alcoholic, merchant wholesalers",
  },
  {
    code: "424820",
    title: "Wines merchant wholesalers",
  },
  {
    code: "424910",
    title: "Agricultural chemicals merchant wholesalers",
  },
  {
    code: "424910",
    title: "Agricultural limestone merchant wholesalers",
  },
  {
    code: "424910",
    title: "Alfalfa merchant wholesalers",
  },
  {
    code: "424910",
    title: "Ammonia, fertilizer material, merchant wholesalers",
  },
  {
    code: "424910",
    title: "Animal feeds (except pet food) merchant wholesalers",
  },
  {
    code: "424910",
    title: "Beekeeping supplies merchant wholesalers",
  },
  {
    code: "424910",
    title: "Chemicals, agricultural, merchant wholesalers",
  },
  {
    code: "424910",
    title: "Farm supplies merchant wholesalers",
  },
  {
    code: "424910",
    title: "Feed additives merchant wholesalers",
  },
  {
    code: "424910",
    title: "Feeds (except pet) merchant wholesalers",
  },
  {
    code: "424910",
    title: "Fertilizer and fertilizer materials merchant wholesalers",
  },
  {
    code: "424910",
    title: "Flower bulbs merchant wholesalers",
  },
  {
    code: "424910",
    title: "Fungicides, agricultural, merchant wholesalers",
  },
  {
    code: "424910",
    title:
      "Garden supplies (e.g., fertilizers, pesticides) merchant wholesalers",
  },
  {
    code: "424910",
    title: "Harness equipment merchant wholesalers",
  },
  {
    code: "424910",
    title: "Hay merchant wholesalers",
  },
  {
    code: "424910",
    title: "Herbicides merchant wholesalers",
  },
  {
    code: "424910",
    title: "Horticultural products merchant wholesalers",
  },
  {
    code: "424910",
    title: "Insecticides, agricultural, merchant wholesalers",
  },
  {
    code: "424910",
    title:
      "Lawn care supplies (e.g., chemicals, fertilizers, pesticides) merchant wholesalers",
  },
  {
    code: "424910",
    title: "Lime, agricultural, merchant wholesalers",
  },
  {
    code: "424910",
    title: "Livestock feeds merchant wholesalers",
  },
  {
    code: "424910",
    title: "Mineral supplements, animal, merchant wholesalers",
  },
  {
    code: "424910",
    title: "Mulch merchant wholesalers",
  },
  {
    code: "424910",
    title: "Pesticides, agricultural, merchant wholesalers",
  },
  {
    code: "424910",
    title: "Phosphate rock, ground, merchant wholesalers",
  },
  {
    code: "424910",
    title: "Plant bulbs merchant wholesalers",
  },
  {
    code: "424910",
    title: "Produce containers merchant wholesalers",
  },
  {
    code: "424910",
    title: "Saddlery merchant wholesalers",
  },
  {
    code: "424910",
    title: "Seeds (e.g., field, flower, garden) merchant wholesalers",
  },
  {
    code: "424910",
    title: "Straw merchant wholesalers",
  },
  {
    code: "424910",
    title: "Tack (e.g., harnesses, saddlery) merchant wholesalers",
  },
  {
    code: "424910",
    title: "Vegetable dusts and sprays merchant wholesalers",
  },
  {
    code: "424910",
    title: "Weed killers merchant wholesalers",
  },
  {
    code: "424920",
    title: "Antique book merchant wholesalers",
  },
  {
    code: "424920",
    title: "Atlases merchant wholesalers",
  },
  {
    code: "424920",
    title: "Books merchant wholesalers",
  },
  {
    code: "424920",
    title: "Brochures merchant wholesalers",
  },
  {
    code: "424920",
    title: "Magazines merchant wholesalers",
  },
  {
    code: "424920",
    title: "Maps (except globe, school, wall) merchant wholesalers",
  },
  {
    code: "424920",
    title: "Newspaper agencies merchant wholesalers",
  },
  {
    code: "424920",
    title: "Newspapers merchant wholesalers",
  },
  {
    code: "424920",
    title: "Pamphlets merchant wholesalers",
  },
  {
    code: "424920",
    title: "Periodicals merchant wholesalers",
  },
  {
    code: "424920",
    title: "Textbooks merchant wholesalers",
  },
  {
    code: "424930",
    title: "Artificial flowers and plants merchant wholesalers",
  },
  {
    code: "424930",
    title: "Bedding plants merchant wholesalers",
  },
  {
    code: "424930",
    title: "Florist's supplies merchant wholesalers",
  },
  {
    code: "424930",
    title: "Flowers merchant wholesalers",
  },
  {
    code: "424930",
    title: "Nursery stock (except plant bulbs, seeds) merchant wholesalers",
  },
  {
    code: "424930",
    title: "Ornamental plants and flowers merchant wholesalers",
  },
  {
    code: "424930",
    title: "Plants, potted, merchant wholesalers",
  },
  {
    code: "424930",
    title: "Soil, top and potting, merchant wholesalers",
  },
  {
    code: "424930",
    title: "Trees merchant wholesalers",
  },
  {
    code: "424940",
    title: "Chewing tobacco merchant wholesalers",
  },
  {
    code: "424940",
    title: "Cigarettes merchant wholesalers",
  },
  {
    code: "424940",
    title: "Cigars merchant wholesalers",
  },
  {
    code: "424940",
    title: "Electronic cigarettes merchant wholesalers",
  },
  {
    code: "424940",
    title: "Pipe tobacco merchant wholesalers",
  },
  {
    code: "424940",
    title: "Snuff merchant wholesalers",
  },
  {
    code: "424940",
    title: "Tobacco (except leaf) merchant wholesalers",
  },
  {
    code: "424940",
    title: "Tobacco products merchant wholesalers",
  },
  {
    code: "424950",
    title: "Automotive paints merchant wholesalers",
  },
  {
    code: "424950",
    title: "Calcimines merchant wholesalers",
  },
  {
    code: "424950",
    title: "Enamels merchant wholesalers",
  },
  {
    code: "424950",
    title: "Lacquers merchant wholesalers",
  },
  {
    code: "424950",
    title: "Paint removers merchant wholesalers",
  },
  {
    code: "424950",
    title: "Paint rollers merchant wholesalers",
  },
  {
    code: "424950",
    title: "Paint thinners merchant wholesalers",
  },
  {
    code: "424950",
    title: "Paintbrushes merchant wholesalers",
  },
  {
    code: "424950",
    title:
      "Painter's supplies (except artists', turpentine) merchant wholesalers",
  },
  {
    code: "424950",
    title: "Paints (except artists') merchant wholesalers",
  },
  {
    code: "424950",
    title: "Pigments, paint, merchant wholesalers",
  },
  {
    code: "424950",
    title: "Shellac merchant wholesalers",
  },
  {
    code: "424950",
    title:
      "Spray painting equipment (except industrial-type) merchant wholesalers",
  },
  {
    code: "424950",
    title: "Stains merchant wholesalers",
  },
  {
    code: "424950",
    title: "Varnishes merchant wholesalers",
  },
  {
    code: "424950",
    title: "Wall coverings (e.g., fabric, plastics) merchant wholesalers",
  },
  {
    code: "424950",
    title: "Wallpaper merchant wholesalers",
  },
  {
    code: "424950",
    title: "Wood paste merchant wholesalers",
  },
  {
    code: "424990",
    title: "Aquarium fish and supplies merchant wholesalers",
  },
  {
    code: "424990",
    title: "Art goods merchant wholesalers",
  },
  {
    code: "424990",
    title: "Artificial Christmas trees merchant wholesalers",
  },
  {
    code: "424990",
    title: "Artists' supplies merchant wholesalers",
  },
  {
    code: "424990",
    title: "Awnings, canvas, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Backpacks, textile, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Bags, textile, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Bait, live, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Baskets merchant wholesalers",
  },
  {
    code: "424990",
    title: "Brushes, artists', merchant wholesalers",
  },
  {
    code: "424990",
    title: "Burlap merchant wholesalers",
  },
  {
    code: "424990",
    title: "Candles merchant wholesalers",
  },
  {
    code: "424990",
    title: "Canvas products merchant wholesalers",
  },
  {
    code: "424990",
    title: "Cats merchant wholesalers",
  },
  {
    code: "424990",
    title: "Chamois, leather, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Charcoal merchant wholesalers",
  },
  {
    code: "424990",
    title: "Christmas ornaments merchant wholesalers",
  },
  {
    code: "424990",
    title: "Christmas trees (e.g., artificial, cut) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Cigarette lighters merchant wholesalers",
  },
  {
    code: "424990",
    title: "Clothes hangers merchant wholesalers",
  },
  {
    code: "424990",
    title: "Cotton (except raw) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Crude rubber merchant wholesalers",
  },
  {
    code: "424990",
    title: "Curios merchant wholesalers",
  },
  {
    code: "424990",
    title: "Dogs merchant wholesalers",
  },
  {
    code: "424990",
    title: "Dressed furs and skins merchant wholesalers",
  },
  {
    code: "424990",
    title: "Felt merchant wholesalers",
  },
  {
    code: "424990",
    title: "Fish, tropical, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Foam rubber merchant wholesalers",
  },
  {
    code: "424990",
    title: "Furs, dressed, merchant wholesalers",
  },
  {
    code: "424990",
    title: "General merchandise, nondurable goods, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Greases, inedible animal and vegetable, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Hairbrushes merchant wholesalers",
  },
  {
    code: "424990",
    title: "Hairpieces (e.g., toupees, wigs, wiglets) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Handles (e.g., broom, mop, paint) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Ice (except dry ice) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Jewelry boxes merchant wholesalers",
  },
  {
    code: "424990",
    title: "Leather cut stock (except boot, shoe) merchant wholesalers",
  },
  {
    code: "424990",
    title:
      "Leather goods (except belting, footwear, handbags, gloves, luggage) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Lighters, cigar and cigarette, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Live bait merchant wholesalers",
  },
  {
    code: "424990",
    title: "Matches and match books merchant wholesalers",
  },
  {
    code: "424990",
    title: "Music, sheet, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Novelties merchant wholesalers",
  },
  {
    code: "424990",
    title: "Oils, inedible, animal or vegetable, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Oilseed cake and meal merchant wholesalers",
  },
  {
    code: "424990",
    title: "Paints, artist's, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Pet supplies (except pet food) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Pets merchant wholesalers",
  },
  {
    code: "424990",
    title: "Piece goods, burlap and felt, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Plant food merchant wholesalers",
  },
  {
    code: "424990",
    title:
      "Plastics foam products (except disposable and packaging) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Pottery, novelty, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Pre-paid calling card distribution, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Rennets merchant wholesalers",
  },
  {
    code: "424990",
    title: "Rubber, crude, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Sawdust merchant wholesalers",
  },
  {
    code: "424990",
    title: "Sheet music merchant wholesalers",
  },
  {
    code: "424990",
    title: "Ship chandler merchant wholesalers",
  },
  {
    code: "424990",
    title: "Skins, dressed, merchant wholesalers",
  },
  {
    code: "424990",
    title: "Smokers' supplies merchant wholesalers",
  },
  {
    code: "424990",
    title: "Sponges merchant wholesalers",
  },
  {
    code: "424990",
    title: "Statuary (except religious) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Tents (except camping) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Textile bags merchant wholesalers",
  },
  {
    code: "424990",
    title: "Toupees merchant wholesalers",
  },
  {
    code: "424990",
    title: "Tropical fish merchant wholesalers",
  },
  {
    code: "424990",
    title: "Vegetable cake and meal merchant wholesalers",
  },
  {
    code: "424990",
    title: "Vegetable oils (except cooking) merchant wholesalers",
  },
  {
    code: "424990",
    title: "Wigs merchant wholesalers",
  },
  {
    code: "424990",
    title: "Wood carvings merchant wholesalers",
  },
  {
    code: "424990",
    title: "Wood pulp merchant wholesalers",
  },
  {
    code: "424990",
    title: "Worms merchant wholesalers",
  },
  {
    code: "424990",
    title: "Yarns, industrial, merchant wholesalers",
  },
  {
    code: "425120",
    title: "Agents and brokers, durable goods, wholesale trade",
  },
  {
    code: "425120",
    title: "Agents and brokers, nondurable goods, wholesale trade",
  },
  {
    code: "425120",
    title: "Automobile auction agents and brokers, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Business to business electronic markets, durable goods, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Business to business electronic markets, nondurable goods, wholesale trade",
  },
  {
    code: "425120",
    title: "Durable goods agents and brokers, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Durable goods business to business electronic markets, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Electronic markets, durable goods, business to business, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Electronic markets, nondurable goods, business to business, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Group purchasing organizations (acting as agents for goods distribution)",
  },
  {
    code: "425120",
    title: "Nondurable goods agents and brokers, wholesale trade",
  },
  {
    code: "425120",
    title:
      "Nondurable goods business to business electronic markets, wholesale trade",
  },
  {
    code: "425120",
    title: "Petroleum brokers",
  },
  {
    code: "441110",
    title: "Automobile dealers, new only or new and used",
  },
  {
    code: "441110",
    title: "Light utility truck dealers, new only or new and used",
  },
  {
    code: "441110",
    title: "New car dealers",
  },
  {
    code: "441120",
    title: "Antique auto dealers",
  },
  {
    code: "441120",
    title: "Automobile dealers, used only",
  },
  {
    code: "441120",
    title: "Light utility truck dealers, used only",
  },
  {
    code: "441120",
    title: "Used car dealers",
  },
  {
    code: "441210",
    title: "Camper dealers, recreational",
  },
  {
    code: "441210",
    title: "Camper parts and accessories stores",
  },
  {
    code: "441210",
    title: "Motor home dealers",
  },
  {
    code: "441210",
    title: "Recreational vehicle (RV) dealers",
  },
  {
    code: "441210",
    title: "Recreational vehicle (RV) parts and accessories stores",
  },
  {
    code: "441210",
    title: "RV dealers",
  },
  {
    code: "441210",
    title: "Travel trailer dealers",
  },
  {
    code: "441210",
    title: "Used recreational vehicle (RV) dealers",
  },
  {
    code: "441222",
    title: "Boat dealers, new and used",
  },
  {
    code: "441222",
    title: "Boat trailer dealers",
  },
  {
    code: "441222",
    title: "Marine supply dealers",
  },
  {
    code: "441222",
    title: "Outboard motor dealers",
  },
  {
    code: "441222",
    title: "Power boat dealers",
  },
  {
    code: "441222",
    title: "Sailboat dealers",
  },
  {
    code: "441222",
    title: "Used boat dealers",
  },
  {
    code: "441227",
    title: "Aircraft dealers",
  },
  {
    code: "441227",
    title: "All-terrain vehicle (ATV) dealers",
  },
  {
    code: "441227",
    title: "Bicycle shops, motorized",
  },
  {
    code: "441227",
    title: "Golf cart dealers, powered",
  },
  {
    code: "441227",
    title: "Horse trailer dealers",
  },
  {
    code: "441227",
    title: "Moped dealers",
  },
  {
    code: "441227",
    title: "Motor scooters dealers",
  },
  {
    code: "441227",
    title: "Motorbike dealers",
  },
  {
    code: "441227",
    title: "Motorcycle dealers",
  },
  {
    code: "441227",
    title: "Motorcycle parts and accessories dealers",
  },
  {
    code: "441227",
    title: "Off-road all-terrain vehicles (ATVs), wheeled or tracked, dealers",
  },
  {
    code: "441227",
    title: "Personal watercraft dealers",
  },
  {
    code: "441227",
    title: "Snowmobile dealers",
  },
  {
    code: "441227",
    title: "Used aircraft dealers",
  },
  {
    code: "441227",
    title: "Used motorcycle dealers",
  },
  {
    code: "441227",
    title: "Used utility trailer dealers",
  },
  {
    code: "441227",
    title: "Utility trailer dealers",
  },
  {
    code: "441330",
    title: "Auto supply stores",
  },
  {
    code: "441330",
    title: "Automobile parts dealers",
  },
  {
    code: "441330",
    title: "Automotive audio equipment stores",
  },
  {
    code: "441330",
    title: "Automotive parts and supply stores",
  },
  {
    code: "441330",
    title: "Automotive parts dealers, used",
  },
  {
    code: "441330",
    title: "Batteries, automotive, dealers",
  },
  {
    code: "441330",
    title: "Parts and accessories dealers, automotive",
  },
  {
    code: "441330",
    title: "Stereo stores, automotive",
  },
  {
    code: "441330",
    title: "Truck cap stores",
  },
  {
    code: "441330",
    title: "Used automotive parts stores",
  },
  {
    code: "441340",
    title: "Automotive tire dealers",
  },
  {
    code: "441340",
    title: "Tire dealers, automotive",
  },
  {
    code: "441340",
    title: "Truck tires and tubes dealers (except heavy truck)",
  },
  {
    code: "441340",
    title: "Used automotive tire dealers",
  },
  {
    code: "441340",
    title: "Used tire dealers",
  },
  {
    code: "444110",
    title: "Home centers, building materials",
  },
  {
    code: "444110",
    title: "Home improvement centers",
  },
  {
    code: "444120",
    title: "Paint stores",
  },
  {
    code: "444120",
    title: "Wallpaper and wall coverings stores",
  },
  {
    code: "444140",
    title: "Handtools, power-driven, stores",
  },
  {
    code: "444140",
    title: "Hardware stores",
  },
  {
    code: "444140",
    title: "Tool stores, power and hand (except outdoor)",
  },
  {
    code: "444180",
    title: "Building materials supply dealers",
  },
  {
    code: "444180",
    title: "Cabinet stores, kitchen (except custom), to be installed",
  },
  {
    code: "444180",
    title: "Ceiling fan stores",
  },
  {
    code: "444180",
    title: "Ceramic tile stores",
  },
  {
    code: "444180",
    title: "Door stores",
  },
  {
    code: "444180",
    title: "Electrical supply stores",
  },
  {
    code: "444180",
    title: "Fencing dealers",
  },
  {
    code: "444180",
    title: "Floor covering stores, hardwood or ceramic tile only",
  },
  {
    code: "444180",
    title: "Garage door dealers",
  },
  {
    code: "444180",
    title: "Glass (except automotive) stores",
  },
  {
    code: "444180",
    title: "Hardwood flooring dealers",
  },
  {
    code: "444180",
    title: "Kitchen cabinet (except custom) stores",
  },
  {
    code: "444180",
    title: "Lighting fixture (except electric lamps) stores",
  },
  {
    code: "444180",
    title: "Lumber retailing yards",
  },
  {
    code: "444180",
    title: "Masonry (e.g., block, brick, stone) dealers",
  },
  {
    code: "444180",
    title: "Plumbing supply stores",
  },
  {
    code: "444180",
    title: "Prefabricated building (except manufactured home) dealers",
  },
  {
    code: "444180",
    title: "Prefabricated shed dealers",
  },
  {
    code: "444180",
    title: "Roofing material dealers",
  },
  {
    code: "444180",
    title: "Siding dealers",
  },
  {
    code: "444180",
    title: "Tile stores, ceramic",
  },
  {
    code: "444180",
    title: "Window stores",
  },
  {
    code: "444230",
    title: "Garden power equipment stores",
  },
  {
    code: "444230",
    title: "Lawn power equipment stores",
  },
  {
    code: "444230",
    title: "Power equipment stores, outdoor",
  },
  {
    code: "444240",
    title: "Christmas trees, cut, direct selling",
  },
  {
    code: "444240",
    title: "Farm supply stores",
  },
  {
    code: "444240",
    title: "Feed stores (except pet)",
  },
  {
    code: "444240",
    title: "Garden centers",
  },
  {
    code: "444240",
    title: "Lawn supply stores",
  },
  {
    code: "444240",
    title: "Nurseries, retail, stock primarily grown off premises",
  },
  {
    code: "444240",
    title: "Nursery and garden centers without tree production",
  },
  {
    code: "445110",
    title: "Commissaries, primarily groceries",
  },
  {
    code: "445110",
    title:
      "Delicatessens primarily retailing a range of grocery items and meats",
  },
  {
    code: "445110",
    title: "Food (i.e., groceries) stores",
  },
  {
    code: "445110",
    title: "Grocery stores",
  },
  {
    code: "445110",
    title: "Supermarkets",
  },
  {
    code: "445131",
    title: "Convenience food stores (except those with fuel pumps)",
  },
  {
    code: "445132",
    title: "Automatic merchandising machine operators",
  },
  {
    code: "445132",
    title: "Vending machine merchandisers, sale of products",
  },
  {
    code: "445230",
    title: "Fruit and vegetable stands, permanent",
  },
  {
    code: "445230",
    title: "Fruit markets",
  },
  {
    code: "445230",
    title: "Fruit stands, permanent",
  },
  {
    code: "445230",
    title: "Fruit stands, temporary",
  },
  {
    code: "445230",
    title: "Produce markets",
  },
  {
    code: "445230",
    title: "Produce stands, permanent",
  },
  {
    code: "445230",
    title: "Produce stands, temporary",
  },
  {
    code: "445230",
    title: "Vegetable markets",
  },
  {
    code: "445240",
    title: "Baked ham stores",
  },
  {
    code: "445240",
    title: "Butcher shops",
  },
  {
    code: "445240",
    title: "Delicatessens (except grocery store, restaurants)",
  },
  {
    code: "445240",
    title: "Frozen meat stores",
  },
  {
    code: "445240",
    title: "Locker meat provisioners, direct selling",
  },
  {
    code: "445240",
    title: "Meat markets",
  },
  {
    code: "445240",
    title: "Poultry dealers",
  },
  {
    code: "445250",
    title: "Fish markets",
  },
  {
    code: "445250",
    title: "Seafood markets",
  },
  {
    code: "445291",
    title: "Baked goods (not made on premises) stores",
  },
  {
    code: "445292",
    title: "Candy stores, packaged, retailing only",
  },
  {
    code: "445292",
    title: "Confectionery stores, packaged, retailing only",
  },
  {
    code: "445292",
    title: "Nut (i.e., packaged) stores",
  },
  {
    code: "445298",
    title: "Bottled water providers, direct selling",
  },
  {
    code: "445298",
    title: "Coffee and tea (i.e., packaged) stores",
  },
  {
    code: "445298",
    title: "Dairy product stores",
  },
  {
    code: "445298",
    title: "Fix-and-freeze meal stores",
  },
  {
    code: "445298",
    title: "Frozen food and freezer meal plan providers, direct selling",
  },
  {
    code: "445298",
    title: "Gourmet food stores",
  },
  {
    code: "445298",
    title: "Ice cream (i.e., packaged) stores",
  },
  {
    code: "445298",
    title: "Meal assembly retailers",
  },
  {
    code: "445298",
    title: "Soft drink stores, bottled",
  },
  {
    code: "445298",
    title: "Specialty food stores",
  },
  {
    code: "445298",
    title: "Spice stores",
  },
  {
    code: "445298",
    title: "Take-and-bake meal stores",
  },
  {
    code: "445298",
    title: "Take-and-bake pizza shops",
  },
  {
    code: "445298",
    title: "Tea and coffee (i.e., packaged) stores",
  },
  {
    code: "445298",
    title: "Water stores, bottled",
  },
  {
    code: "445320",
    title: "Beer stores, packaged",
  },
  {
    code: "445320",
    title: "Duty free liquor shops",
  },
  {
    code: "445320",
    title: "Liquor stores, package",
  },
  {
    code: "445320",
    title: "Package stores (i.e., liquor)",
  },
  {
    code: "445320",
    title: "Wine shops, packaged",
  },
  {
    code: "449110",
    title: "Bed stores, retail",
  },
  {
    code: "449110",
    title:
      "Furniture and appliance stores (i.e., primarily retailing furniture)",
  },
  {
    code: "449110",
    title: "Furniture stores (e.g., household, office, outdoor)",
  },
  {
    code: "449110",
    title: "Mattress stores (including waterbeds)",
  },
  {
    code: "449110",
    title: "Office furniture stores",
  },
  {
    code: "449121",
    title: "Carpet stores",
  },
  {
    code: "449121",
    title: "Floor covering stores (except hardwood or ceramic tile only)",
  },
  {
    code: "449121",
    title: "Rug stores",
  },
  {
    code: "449122",
    title: "Curtain and drapery stores, packaged",
  },
  {
    code: "449122",
    title: "Window treatment stores",
  },
  {
    code: "449129",
    title: "Bath shops",
  },
  {
    code: "449129",
    title: "Chinaware stores",
  },
  {
    code: "449129",
    title: "Custom picture frame shops",
  },
  {
    code: "449129",
    title: "Glassware stores",
  },
  {
    code: "449129",
    title: "Home furnishings stores",
  },
  {
    code: "449129",
    title: "Housewares stores",
  },
  {
    code: "449129",
    title: "Kitchenware stores",
  },
  {
    code: "449129",
    title: "Lamp shops, electric",
  },
  {
    code: "449129",
    title: "Linen stores",
  },
  {
    code: "449129",
    title: "Picture frame shops, custom",
  },
  {
    code: "449129",
    title: "Wood-burning stove stores",
  },
  {
    code: "449210",
    title: "Appliance stores, household-type",
  },
  {
    code: "449210",
    title: "Audio equipment stores (except automotive)",
  },
  {
    code: "449210",
    title: "Camera shops, photographic",
  },
  {
    code: "449210",
    title: "Cellular telephone accessories stores",
  },
  {
    code: "449210",
    title: "Citizens' band (CB) radio stores",
  },
  {
    code: "449210",
    title: "Computer equipment stores",
  },
  {
    code: "449210",
    title: "Computer software, prepackaged, new, mail-order houses",
  },
  {
    code: "449210",
    title: "Computer stores",
  },
  {
    code: "449210",
    title:
      "Consumer-type electronic stores (e.g., televisions, computers, cameras)",
  },
  {
    code: "449210",
    title: "Electronic part and component stores",
  },
  {
    code: "449210",
    title: "Household-type appliance stores",
  },
  {
    code: "449210",
    title:
      "Music retailers (e.g., downloadable digital music files (without production or publishing))",
  },
  {
    code: "449210",
    title: "Music stores (e.g., cassette, compact disc, record, tape)",
  },
  {
    code: "449210",
    title: "Photographic supply stores",
  },
  {
    code: "449210",
    title: "Prerecorded tape, compact disc, and record, new, mail-order houses",
  },
  {
    code: "449210",
    title: "Radio and television stores",
  },
  {
    code: "449210",
    title: "Record stores, new",
  },
  {
    code: "449210",
    title: "Sewing machine stores, household-type",
  },
  {
    code: "449210",
    title:
      "Software retailers (e.g., downloadable computer software (without publishing))",
  },
  {
    code: "449210",
    title: "Software stores, computer",
  },
  {
    code: "449210",
    title: "Stereo stores (except automotive)",
  },
  {
    code: "449210",
    title: "Television and radio stores",
  },
  {
    code: "449210",
    title: "TV (television) stores",
  },
  {
    code: "449210",
    title: "Vacuum cleaner stores, household-type",
  },
  {
    code: "449210",
    title: "Video game software stores",
  },
  {
    code: "449210",
    title: "Video tape stores",
  },
  {
    code: "455110",
    title: "Department stores",
  },
  {
    code: "455110",
    title: "Internet department store sites",
  },
  {
    code: "455211",
    title: "Internet supercenter sites",
  },
  {
    code: "455211",
    title: "Internet warehouse club sites",
  },
  {
    code: "455211",
    title: "Supercenters",
  },
  {
    code: "455211",
    title: "Superstores (i.e., food and general merchandise)",
  },
  {
    code: "455211",
    title: "Warehouse clubs (i.e., food and general merchandise)",
  },
  {
    code: "455219",
    title: "Auctions, general merchandise (new and used), Internet retail",
  },
  {
    code: "455219",
    title: "Dollar stores",
  },
  {
    code: "455219",
    title: "Electronic auctions, general merchandise (new and used), retail",
  },
  {
    code: "455219",
    title: "General merchandise (new and used) auction houses",
  },
  {
    code: "455219",
    title: "General stores",
  },
  {
    code: "455219",
    title: "Home and auto supply stores",
  },
  {
    code: "455219",
    title: "Internet auctions, general merchandise (new and used), retail",
  },
  {
    code: "455219",
    title:
      "Internet retail sales sites (except department store, warehouse club, and supercenter sites), new general merchandise",
  },
  {
    code: "455219",
    title: "Limited price variety stores",
  },
  {
    code: "455219",
    title: "Trading posts, general merchandise",
  },
  {
    code: "455219",
    title: "Variety stores",
  },
  {
    code: "456110",
    title: "Apothecaries",
  },
  {
    code: "456110",
    title: "Drug stores",
  },
  {
    code: "456110",
    title: "Institutional pharmacies, off-site, exclusively on Internet",
  },
  {
    code: "456110",
    title: "Institutional pharmacies, off-site, mail-order",
  },
  {
    code: "456110",
    title: "Institutional pharmacies, on-site",
  },
  {
    code: "456110",
    title: "Pharmacies",
  },
  {
    code: "456120",
    title: "Beauty supply stores",
  },
  {
    code: "456120",
    title: "Cosmetics stores",
  },
  {
    code: "456120",
    title: "Perfume stores",
  },
  {
    code: "456130",
    title: "Lens grinding, ophthalmic, in retail stores",
  },
  {
    code: "456130",
    title:
      "Optical goods stores (except offices of optometrists, ophthalmologists)",
  },
  {
    code: "456130",
    title: "Sunglass stores",
  },
  {
    code: "456191",
    title: "Herbal supplement stores",
  },
  {
    code: "456191",
    title: "Nutrition (i.e., food supplement) stores",
  },
  {
    code: "456191",
    title: "Vitamin stores",
  },
  {
    code: "456199",
    title: "Convalescent supply stores",
  },
  {
    code: "456199",
    title: "Hearing aid stores (except offices of audiologists)",
  },
  {
    code: "456199",
    title: "Home health equipment stores",
  },
  {
    code: "456199",
    title: "Medical equipment and supplies stores",
  },
  {
    code: "456199",
    title: "Personal mobility scooter dealers",
  },
  {
    code: "456199",
    title: "Prosthetic stores (except offices of prosthetists)",
  },
  {
    code: "456199",
    title: "Sick room supply stores",
  },
  {
    code: "456199",
    title: "Wheelchair stores",
  },
  {
    code: "457110",
    title: "Convenience food with gasoline stations",
  },
  {
    code: "457110",
    title: "Gasoline stations with convenience stores",
  },
  {
    code: "457120",
    title: "Gasoline stations without convenience stores",
  },
  {
    code: "457120",
    title: "Marine service stations",
  },
  {
    code: "457120",
    title: "Service stations, gasoline",
  },
  {
    code: "457120",
    title: "Truck stops",
  },
  {
    code: "457210",
    title: "Alternative fuels, direct selling",
  },
  {
    code: "457210",
    title: "Bottled gas dealers, direct selling",
  },
  {
    code: "457210",
    title: "Coal dealers, direct selling",
  },
  {
    code: "457210",
    title: "Firewood dealers, direct selling",
  },
  {
    code: "457210",
    title: "Fuel oil (i.e., heating) dealers, direct selling",
  },
  {
    code: "457210",
    title: "Heating oil dealers, direct selling",
  },
  {
    code: "457210",
    title: "Jet fuel bulk stations, selling for consumption",
  },
  {
    code: "457210",
    title: "Liquefied petroleum gas (LPG) dealers, direct selling",
  },
  {
    code: "458110",
    title: "Apparel accessory stores",
  },
  {
    code: "458110",
    title: "Apparel stores, children's and infants' clothing",
  },
  {
    code: "458110",
    title: "Apparel stores, men's and boys' clothing",
  },
  {
    code: "458110",
    title: "Apparel stores, women's and girls' clothing",
  },
  {
    code: "458110",
    title: "Baby clothing shops",
  },
  {
    code: "458110",
    title: "Bridal gown shops (except custom)",
  },
  {
    code: "458110",
    title: "Clothing accessories stores",
  },
  {
    code: "458110",
    title: "Clothing stores, children's and infants'",
  },
  {
    code: "458110",
    title: "Clothing stores, family",
  },
  {
    code: "458110",
    title: "Clothing stores, men's and boys'",
  },
  {
    code: "458110",
    title: "Clothing stores, women's and girls'",
  },
  {
    code: "458110",
    title: "Coat stores",
  },
  {
    code: "458110",
    title: "Costume jewelry stores",
  },
  {
    code: "458110",
    title: "Costume stores (including theatrical)",
  },
  {
    code: "458110",
    title: "Dress shops",
  },
  {
    code: "458110",
    title: "Family clothing stores",
  },
  {
    code: "458110",
    title: "Fur apparel stores",
  },
  {
    code: "458110",
    title: "Furnishings stores, men's and boys'",
  },
  {
    code: "458110",
    title: "Furnishings stores, women's and girls'",
  },
  {
    code: "458110",
    title: "Furriers",
  },
  {
    code: "458110",
    title: "Handbag stores",
  },
  {
    code: "458110",
    title: "Hat and cap stores",
  },
  {
    code: "458110",
    title: "Hosiery stores",
  },
  {
    code: "458110",
    title: "Jewelry stores, costume",
  },
  {
    code: "458110",
    title: "Leather coat stores",
  },
  {
    code: "458110",
    title: "Lingerie stores",
  },
  {
    code: "458110",
    title: "Maternity shops",
  },
  {
    code: "458110",
    title: "Neckwear stores",
  },
  {
    code: "458110",
    title: "School uniform stores",
  },
  {
    code: "458110",
    title: "Sock shops",
  },
  {
    code: "458110",
    title: "Sports apparel stores (except uniforms)",
  },
  {
    code: "458110",
    title: "Swimwear stores",
  },
  {
    code: "458110",
    title: "Tie shops",
  },
  {
    code: "458110",
    title: "T-shirt shops",
  },
  {
    code: "458110",
    title: "Uniform stores (except athletic)",
  },
  {
    code: "458110",
    title: "Unisex clothing stores",
  },
  {
    code: "458110",
    title: "Western wear stores",
  },
  {
    code: "458110",
    title: "Wig and hairpiece stores",
  },
  {
    code: "458210",
    title: "Athletic shoe (except bowling, golf, cleated) stores",
  },
  {
    code: "458210",
    title: "Children's shoe stores",
  },
  {
    code: "458210",
    title: "Orthopedic shoes stores",
  },
  {
    code: "458210",
    title: "Shoe (except bowling, golf, cleated) stores",
  },
  {
    code: "458210",
    title: "Shoe stores, orthopedic",
  },
  {
    code: "458310",
    title: "Clock shops",
  },
  {
    code: "458310",
    title: "Gem stone shops, precious and semiprecious",
  },
  {
    code: "458310",
    title: "Jewelry stores, precious",
  },
  {
    code: "458310",
    title: "Watch shops",
  },
  {
    code: "458320",
    title: "Leather goods stores",
  },
  {
    code: "458320",
    title: "Luggage stores",
  },
  {
    code: "459110",
    title: "Athletic equipment and supply stores (including uniforms)",
  },
  {
    code: "459110",
    title: "Bicycle (except motorized) shops",
  },
  {
    code: "459110",
    title: "Bowling equipment and supply stores",
  },
  {
    code: "459110",
    title: "Camping and hiking equipment stores",
  },
  {
    code: "459110",
    title: "Diving equipment stores",
  },
  {
    code: "459110",
    title: "Exercise equipment stores",
  },
  {
    code: "459110",
    title: "Fishing supply stores (e.g., bait)",
  },
  {
    code: "459110",
    title: "Footwear (e.g., bowling, golf, cleated), specialty sports, stores",
  },
  {
    code: "459110",
    title: "Golf pro shops",
  },
  {
    code: "459110",
    title: "Gun shops",
  },
  {
    code: "459110",
    title: "Hunting equipment stores",
  },
  {
    code: "459110",
    title: "Outdoor sporting equipment stores",
  },
  {
    code: "459110",
    title: "Pro shops (e.g., golf, skiing, tennis)",
  },
  {
    code: "459110",
    title: "Saddlery stores",
  },
  {
    code: "459110",
    title:
      "Shoe stores, specialty sports footwear (e.g., bowling, golf, cleated)",
  },
  {
    code: "459110",
    title: "Sporting goods stores",
  },
  {
    code: "459110",
    title: "Sports gear stores (e.g., outdoors, scuba, skiing)",
  },
  {
    code: "459110",
    title: "Tack (e.g., harnesses, saddlery) shops",
  },
  {
    code: "459110",
    title: "Tackle shops (i.e., fishing)",
  },
  {
    code: "459110",
    title: "Uniform stores, athletic",
  },
  {
    code: "459120",
    title: "Craft supply stores (except needlecraft)",
  },
  {
    code: "459120",
    title: "Hobby shops",
  },
  {
    code: "459120",
    title: "Magic supply stores",
  },
  {
    code: "459120",
    title:
      "Pottery (unfinished pottery to be painted by customer on premises) stores",
  },
  {
    code: "459120",
    title: "Toy stores",
  },
  {
    code: "459120",
    title: "Toy stores, electronic",
  },
  {
    code: "459130",
    title: "Fabric shops",
  },
  {
    code: "459130",
    title: "Needlecraft sewing supply stores",
  },
  {
    code: "459130",
    title: "Piece goods stores",
  },
  {
    code: "459130",
    title: "Quilting supply stores",
  },
  {
    code: "459130",
    title: "Sewing supply stores",
  },
  {
    code: "459130",
    title: "Upholstery materials stores",
  },
  {
    code: "459140",
    title: "Music stores (i.e., instrument)",
  },
  {
    code: "459140",
    title: "Musical instrument stores",
  },
  {
    code: "459140",
    title: "Piano stores",
  },
  {
    code: "459140",
    title: "Sheet music stores",
  },
  {
    code: "459210",
    title: "Book clubs, not publishing, new books, mail-order",
  },
  {
    code: "459210",
    title: "Book stores",
  },
  {
    code: "459210",
    title: "Comic book stores",
  },
  {
    code: "459210",
    title: "Home delivery newspaper routes, direct selling",
  },
  {
    code: "459210",
    title: "Magazine stands (i.e., permanent)",
  },
  {
    code: "459210",
    title: "News dealers",
  },
  {
    code: "459210",
    title: "Newsstands (i.e., permanent)",
  },
  {
    code: "459210",
    title: "Religious book stores",
  },
  {
    code: "459310",
    title: "Florists",
  },
  {
    code: "459310",
    title: "Flower shops, fresh",
  },
  {
    code: "459410",
    title: "Office supply stores",
  },
  {
    code: "459410",
    title: "School supply stores",
  },
  {
    code: "459410",
    title: "Stationery stores",
  },
  {
    code: "459420",
    title: "Balloon shops",
  },
  {
    code: "459420",
    title: "Card shops, greeting",
  },
  {
    code: "459420",
    title: "Christmas stores",
  },
  {
    code: "459420",
    title: "Collectible gift shops (e.g., crystal, pewter, porcelain)",
  },
  {
    code: "459420",
    title: "Craft (except craft supply) stores",
  },
  {
    code: "459420",
    title: "Curio shops",
  },
  {
    code: "459420",
    title: "Fruit basket or fruit bouquet stores",
  },
  {
    code: "459420",
    title: "Gift shops",
  },
  {
    code: "459420",
    title: "Gift stands, permanent location",
  },
  {
    code: "459420",
    title: "Greeting card shops",
  },
  {
    code: "459420",
    title: "Novelty shops",
  },
  {
    code: "459420",
    title: "Party goods (e.g., paper supplies, decorations, novelties) stores",
  },
  {
    code: "459420",
    title: "Seasonal and holiday decoration stores",
  },
  {
    code: "459420",
    title: "Souvenir shops",
  },
  {
    code: "459510",
    title: "Antique dealers (except motor vehicles)",
  },
  {
    code: "459510",
    title: "Antique shops",
  },
  {
    code: "459510",
    title: "Apparel stores, used clothing",
  },
  {
    code: "459510",
    title: "Appliance stores, household, used",
  },
  {
    code: "459510",
    title: "Architectural salvage dealers",
  },
  {
    code: "459510",
    title: "Auctions, general merchandise (used), Internet retail",
  },
  {
    code: "459510",
    title: "Bicycle (except motorized) shops, used",
  },
  {
    code: "459510",
    title: "Book clubs, not publishing, used books, mail-order",
  },
  {
    code: "459510",
    title: "Book stores, used",
  },
  {
    code: "459510",
    title: "Clothing stores, used",
  },
  {
    code: "459510",
    title: "Computer software, prepackaged, used, mail-order houses",
  },
  {
    code: "459510",
    title: "Consignment shops, used merchandise",
  },
  {
    code: "459510",
    title: "Electronic auctions, general merchandise (used), retail",
  },
  {
    code: "459510",
    title: "Flea markets, used merchandise, permanent",
  },
  {
    code: "459510",
    title: "Furniture stores, used",
  },
  {
    code: "459510",
    title: "General merchandise (used) auction houses",
  },
  {
    code: "459510",
    title: "Internet auctions, general merchandise (used), retail",
  },
  {
    code: "459510",
    title: "Internet retail sales sites, used general merchandise",
  },
  {
    code: "459510",
    title: "Music stores (e.g., cassette, instrument, record, tape), used",
  },
  {
    code: "459510",
    title:
      "Prerecorded tape, compact disc, and record, used, mail-order houses",
  },
  {
    code: "459510",
    title: "Rare manuscript stores",
  },
  {
    code: "459510",
    title: "Record stores, used",
  },
  {
    code: "459510",
    title: "Secondhand merchandise stores",
  },
  {
    code: "459510",
    title: "Sporting goods stores, used",
  },
  {
    code: "459510",
    title: "Thrift shops, used merchandise",
  },
  {
    code: "459510",
    title: "Used bicycle (except motorized) shops",
  },
  {
    code: "459510",
    title: "Used merchandise dealers (except motor vehicles and parts)",
  },
  {
    code: "459510",
    title: "Used merchandise stores",
  },
  {
    code: "459510",
    title:
      "Used rare collectors' items (e.g., autograph, coin, card, stamps) shops",
  },
  {
    code: "459510",
    title:
      "Used rare collectors' items (e.g., autograph, coin, card, stamps), mail-order houses",
  },
  {
    code: "459910",
    title: "Feed stores, pet",
  },
  {
    code: "459910",
    title: "Pet shops",
  },
  {
    code: "459910",
    title: "Pet supply stores",
  },
  {
    code: "459920",
    title: "Art auctions",
  },
  {
    code: "459920",
    title: "Art dealers",
  },
  {
    code: "459920",
    title: "Art galleries retailing art",
  },
  {
    code: "459920",
    title: "Galleries, art, retail",
  },
  {
    code: "459930",
    title: "Manufactured (mobile) home dealers",
  },
  {
    code: "459930",
    title: "Mobile home dealers, manufactured",
  },
  {
    code: "459930",
    title: "Used manufactured (mobile) home dealers",
  },
  {
    code: "459991",
    title: "Cigar stores",
  },
  {
    code: "459991",
    title: "Cigarette stands, permanent",
  },
  {
    code: "459991",
    title: "Cigarette stands, temporary",
  },
  {
    code: "459991",
    title: "E-cigarette stores",
  },
  {
    code: "459991",
    title: "Electronic cigarette stores",
  },
  {
    code: "459991",
    title: "Marijuana stores, medical or recreational",
  },
  {
    code: "459991",
    title: "Smokers' supply stores",
  },
  {
    code: "459991",
    title: "Tobacco stores",
  },
  {
    code: "459991",
    title: "Vape shops",
  },
  {
    code: "459999",
    title: "Architectural supply stores",
  },
  {
    code: "459999",
    title: "Art supply stores",
  },
  {
    code: "459999",
    title: "Batteries, except automotive, dealers",
  },
  {
    code: "459999",
    title: "Beer making supply stores",
  },
  {
    code: "459999",
    title: "Binocular stores",
  },
  {
    code: "459999",
    title: "Cake decorating supply stores",
  },
  {
    code: "459999",
    title: "Calendar shops",
  },
  {
    code: "459999",
    title: "Candle shops",
  },
  {
    code: "459999",
    title: "Cannabidiol (CBD oil) retailers",
  },
  {
    code: "459999",
    title: "Cemetery memorial dealers (e.g., headstones, markers, vaults)",
  },
  {
    code: "459999",
    title: "Closet organizer stores",
  },
  {
    code: "459999",
    title:
      "Collectors' items (e.g., autograph, card, coin, stamp) shops (except used rare items)",
  },
  {
    code: "459999",
    title:
      "Collectors' items (e.g., autograph, card, coin, stamp), mail-order houses (except used rare items)",
  },
  {
    code: "459999",
    title: "Emergency preparedness supply stores",
  },
  {
    code: "459999",
    title: "Fireworks shops (i.e., permanent location)",
  },
  {
    code: "459999",
    title: "Flag and banner shops",
  },
  {
    code: "459999",
    title: "Flower shops, artificial or dried",
  },
  {
    code: "459999",
    title: "Home security equipment stores",
  },
  {
    code: "459999",
    title: "Hot tub stores",
  },
  {
    code: "459999",
    title: "Janitorial equipment and supplies stores",
  },
  {
    code: "459999",
    title: "Monument (i.e., burial marker) dealers",
  },
  {
    code: "459999",
    title: "Police supply stores",
  },
  {
    code: "459999",
    title: "Religious goods (except books) stores",
  },
  {
    code: "459999",
    title: "Swimming pool (above-ground) and supply stores",
  },
  {
    code: "459999",
    title: "Trophy (including awards and plaques) shops",
  },
  {
    code: "459999",
    title: "Wine making supply stores",
  },
  {
    code: "481111",
    title: "Air commuter carriers, scheduled",
  },
  {
    code: "481111",
    title: "Air passenger carriers, scheduled",
  },
  {
    code: "481111",
    title: "Commuter air carriers, scheduled",
  },
  {
    code: "481111",
    title: "Helicopter passenger carriers, scheduled",
  },
  {
    code: "481111",
    title: "Passenger air transportation, scheduled",
  },
  {
    code: "481111",
    title: "Passenger carriers, air, scheduled",
  },
  {
    code: "481111",
    title: "Scheduled air passenger carriers",
  },
  {
    code: "481111",
    title: "Scheduled air passenger transportation",
  },
  {
    code: "481112",
    title: "Air cargo carriers (except air couriers), scheduled",
  },
  {
    code: "481112",
    title: "Airmail carriers, scheduled",
  },
  {
    code: "481112",
    title: "Cargo carriers, air, scheduled",
  },
  {
    code: "481112",
    title: "Freight carriers (except air couriers), air, scheduled",
  },
  {
    code: "481112",
    title: "Helicopter freight carriers, scheduled",
  },
  {
    code: "481112",
    title: "Scheduled air freight carriers",
  },
  {
    code: "481112",
    title: "Scheduled air freight transportation",
  },
  {
    code: "481211",
    title: "Air passenger carriers, nonscheduled",
  },
  {
    code: "481211",
    title: "Air taxi services",
  },
  {
    code: "481211",
    title: "Aircraft charter services, passenger",
  },
  {
    code: "481211",
    title: "Charter air passenger services",
  },
  {
    code: "481211",
    title:
      "Helicopter passenger carriers (except scenic, sightseeing), nonscheduled",
  },
  {
    code: "481211",
    title: "Nonscheduled air passenger transportation",
  },
  {
    code: "481211",
    title: "Passenger air transportation, nonscheduled",
  },
  {
    code: "481211",
    title: "Passenger carriers, air, nonscheduled",
  },
  {
    code: "481211",
    title: "Space transportation, passenger, nonscheduled",
  },
  {
    code: "481212",
    title: "Air cargo carriers (except air couriers), nonscheduled",
  },
  {
    code: "481212",
    title: "Charter air freight services",
  },
  {
    code: "481212",
    title: "Freight charter services, air",
  },
  {
    code: "481212",
    title: "Freight transportation, air, charter services",
  },
  {
    code: "481212",
    title: "Freight transportation, air, nonscheduled",
  },
  {
    code: "481212",
    title: "Helicopter carriers, freight, nonscheduled",
  },
  {
    code: "481212",
    title: "Nonscheduled air freight transportation",
  },
  {
    code: "481212",
    title: "Space transportation, freight, nonscheduled",
  },
  {
    code: "481212",
    title: "Transportation by spacecraft, freight",
  },
  {
    code: "481219",
    title:
      "Aircraft charter services (i.e., general purpose aircraft used for a variety of specialty air and flying services)",
  },
  {
    code: "481219",
    title:
      "Aviation clubs providing a variety of air transportation activities to the general public",
  },
  {
    code: "482111",
    title: "Freight railways, line-haul",
  },
  {
    code: "482111",
    title: "Passenger railways, line-haul",
  },
  {
    code: "482111",
    title: "Railroad transportation, line-haul",
  },
  {
    code: "482111",
    title: "Railroads, line-haul",
  },
  {
    code: "482111",
    title: "Railway transportation, line-haul",
  },
  {
    code: "482112",
    title: "Beltline railroads",
  },
  {
    code: "482112",
    title: "Freight railways, short-line or beltline",
  },
  {
    code: "482112",
    title: "Logging railroads",
  },
  {
    code: "482112",
    title: "Railroad transportation, short-line or beltline",
  },
  {
    code: "482112",
    title: "Railroads, short-line or beltline",
  },
  {
    code: "482112",
    title: "Railway transportation, short-line or beltline",
  },
  {
    code: "482112",
    title: "Short-line railroads",
  },
  {
    code: "483111",
    title: "Deep sea freight transportation to or from foreign ports",
  },
  {
    code: "483111",
    title: "Freight transportation, deep sea, to or from foreign ports",
  },
  {
    code: "483111",
    title:
      "Ship chartering with crew, deep sea freight transportation to or from foreign ports",
  },
  {
    code: "483111",
    title: "Shipping freight to or from foreign ports, deep sea",
  },
  {
    code: "483111",
    title: "Transporting freight to or from foreign ports, deep sea",
  },
  {
    code: "483112",
    title:
      "Cruise lines (i.e., deep sea passenger transportation to or from foreign ports)",
  },
  {
    code: "483112",
    title: "Deep sea passenger transportation to or from foreign ports",
  },
  {
    code: "483112",
    title: "Passenger transportation, deep sea, to or from foreign ports",
  },
  {
    code: "483112",
    title:
      "Ship chartering with crew, deep sea passenger transportation to or from foreign ports",
  },
  {
    code: "483112",
    title: "Transporting passengers to or from foreign ports, deep sea",
  },
  {
    code: "483113",
    title:
      "Barge transportation, coastal or Great Lakes (including St. Lawrence Seaway)",
  },
  {
    code: "483113",
    title: "Coastal freight transportation to and from domestic ports",
  },
  {
    code: "483113",
    title: "Coastal shipping of freight to and from domestic ports",
  },
  {
    code: "483113",
    title:
      "Deep sea freight transportation to or from domestic ports (including Puerto Rico)",
  },
  {
    code: "483113",
    title:
      "Freight shipping on the Great Lakes system (including St. Lawrence Seaway)",
  },
  {
    code: "483113",
    title: "Freight transportation, deep sea, to and from domestic ports",
  },
  {
    code: "483113",
    title: "Great Lakes freight transportation (including St. Lawrence Seaway)",
  },
  {
    code: "483113",
    title: "Intercoastal freight transportation to and from domestic ports",
  },
  {
    code: "483113",
    title:
      "Lake freight transportation, Great Lakes (including St. Lawrence Seaway)",
  },
  {
    code: "483113",
    title:
      "Ship chartering with crew, coastal or Great Lakes freight transportation (including St. Lawrence Seaway)",
  },
  {
    code: "483113",
    title:
      "Shipping freight to and from domestic ports (i.e., coastal, deep sea (including Puerto Rico), Great Lakes system (including St. Lawrence Seaway))",
  },
  {
    code: "483114",
    title: "Coastal passenger transportation to and from domestic ports",
  },
  {
    code: "483114",
    title:
      "Cruise lines (i.e., deep sea passenger transportation to and from domestic ports, including Puerto Rico)",
  },
  {
    code: "483114",
    title:
      "Deep sea passenger transportation to and from domestic ports (including Puerto Rico)",
  },
  {
    code: "483114",
    title:
      "Ferry passenger transportation, Great Lakes (including St. Lawrence Seaway)",
  },
  {
    code: "483114",
    title:
      "Great Lakes passenger transportation (including St. Lawrence Seaway)",
  },
  {
    code: "483114",
    title:
      "Intercoastal transportation of passengers to and from domestic ports",
  },
  {
    code: "483114",
    title:
      "Lake passenger transportation, Great Lakes (including St. Lawrence Seaway)",
  },
  {
    code: "483114",
    title:
      "Passenger transportation, coastal or Great Lakes (including St. Lawrence Seaway)",
  },
  {
    code: "483114",
    title:
      "Passenger transportation, deep sea, to and from domestic ports (including Puerto Rico)",
  },
  {
    code: "483114",
    title:
      "Ship chartering with crew, coastal or Great Lakes passenger transportation (including St. Lawrence Seaway)",
  },
  {
    code: "483211",
    title: "Barge transportation, canal (freight)",
  },
  {
    code: "483211",
    title: "Canal barge transportation (freight)",
  },
  {
    code: "483211",
    title:
      "Freight transportation, inland waters (except on Great Lakes system)",
  },
  {
    code: "483211",
    title: "Intracoastal transportation of freight",
  },
  {
    code: "483211",
    title: "Lake freight transportation (except on Great Lakes system)",
  },
  {
    code: "483211",
    title:
      "Lighterage (i.e., freight transportation except vessel supply services)",
  },
  {
    code: "483211",
    title: "River freight transportation",
  },
  {
    code: "483211",
    title:
      "Ship chartering with crew, freight transportation, inland waters (except on Great Lakes system)",
  },
  {
    code: "483211",
    title: "Shipping freight, inland waters (except on Great Lakes system)",
  },
  {
    code: "483211",
    title: "Towing service, inland waters (except on Great Lakes system)",
  },
  {
    code: "483212",
    title: "Canal passenger transportation",
  },
  {
    code: "483212",
    title:
      "Car lighters (i.e., ferries), inland waters (except on Great Lakes system)",
  },
  {
    code: "483212",
    title: "Intracoastal transportation of passengers",
  },
  {
    code: "483212",
    title: "Lake passenger transportation (except on Great Lakes system)",
  },
  {
    code: "483212",
    title:
      "Passenger transportation, inland waters (except on Great Lakes system)",
  },
  {
    code: "483212",
    title: "River passenger transportation",
  },
  {
    code: "483212",
    title:
      "Ship chartering with crew, passenger transportation, inland waters (except on Great Lakes system)",
  },
  {
    code: "483212",
    title: "Water shuttle services",
  },
  {
    code: "483212",
    title: "Water taxi services",
  },
  {
    code: "484110",
    title: "Bulk mail truck transportation, contract, local",
  },
  {
    code: "484110",
    title: "Container trucking services, local",
  },
  {
    code: "484110",
    title: "General freight trucking, local",
  },
  {
    code: "484110",
    title: "Motor freight carrier, general, local",
  },
  {
    code: "484110",
    title: "Transfer (trucking) services, general freight, local",
  },
  {
    code: "484110",
    title: "Trucking, general freight, local",
  },
  {
    code: "484121",
    title: "Bulk mail truck transportation, contract, long-distance (TL)",
  },
  {
    code: "484121",
    title: "Container trucking services, long-distance (TL)",
  },
  {
    code: "484121",
    title: "General freight trucking, long-distance, truckload (TL)",
  },
  {
    code: "484121",
    title: "Motor freight carrier, general, long-distance, truckload (TL)",
  },
  {
    code: "484121",
    title: "Trucking, general freight, long-distance, truckload (TL)",
  },
  {
    code: "484122",
    title: "General freight trucking, long-distance, less-than-truckload (LTL)",
  },
  {
    code: "484122",
    title: "LTL (less-than-truckload) long-distance freight trucking",
  },
  {
    code: "484122",
    title:
      "Motor freight carrier, general, long-distance, less-than-truckload (LTL)",
  },
  {
    code: "484122",
    title:
      "Trucking, general freight, long-distance, less-than-truckload (LTL)",
  },
  {
    code: "484210",
    title: "Furniture moving, used",
  },
  {
    code: "484210",
    title: "Motor freight carrier, used household goods",
  },
  {
    code: "484210",
    title:
      "Trucking used household, office, or institutional furniture and equipment",
  },
  {
    code: "484210",
    title: "Used household and office goods moving",
  },
  {
    code: "484210",
    title: "Van lines, moving and storage services",
  },
  {
    code: "484220",
    title: "Agricultural products trucking, local",
  },
  {
    code: "484220",
    title:
      "Ash, garbage, recyclable material, refuse, rubbish, trash, or waste hauling (except collection or disposal)",
  },
  {
    code: "484220",
    title: "Automobile carrier trucking, local",
  },
  {
    code: "484220",
    title: "Boat hauling, truck, local",
  },
  {
    code: "484220",
    title: "Bulk liquids trucking, local",
  },
  {
    code: "484220",
    title: "Coal hauling, truck, local",
  },
  {
    code: "484220",
    title:
      "Dry bulk trucking (except garbage collection, garbage hauling), local",
  },
  {
    code: "484220",
    title: "Dump trucking (e.g., gravel, sand, top-soil)",
  },
  {
    code: "484220",
    title: "Farm products hauling, local",
  },
  {
    code: "484220",
    title: "Flatbed trucking, local",
  },
  {
    code: "484220",
    title: "Grain hauling, local",
  },
  {
    code: "484220",
    title: "Gravel hauling, local",
  },
  {
    code: "484220",
    title: "Livestock trucking, local",
  },
  {
    code: "484220",
    title: "Log hauling, local",
  },
  {
    code: "484220",
    title: "Milk hauling, local",
  },
  {
    code: "484220",
    title: "Mobile home towing services, local",
  },
  {
    code: "484220",
    title: "Oil and gas field equipment trucking, local",
  },
  {
    code: "484220",
    title: "Refrigerated products trucking, local",
  },
  {
    code: "484220",
    title: "Sand hauling, local",
  },
  {
    code: "484220",
    title: "Tanker trucking (e.g., chemical, juice, milk, petroleum), local",
  },
  {
    code: "484220",
    title: "Top-soil hauling, local",
  },
  {
    code: "484220",
    title: "Tracked vehicle freight transportation, local",
  },
  {
    code: "484220",
    title: "Trucking, specialized freight (except used goods), local",
  },
  {
    code: "484230",
    title: "Automobile carrier trucking, long-distance",
  },
  {
    code: "484230",
    title: "Boat hauling, truck, long-distance",
  },
  {
    code: "484230",
    title: "Bulk liquids trucking, long-distance",
  },
  {
    code: "484230",
    title: "Dry bulk carrier, truck, long-distance",
  },
  {
    code: "484230",
    title: "Farm products trucking, long-distance",
  },
  {
    code: "484230",
    title: "Flatbed trucking, long-distance",
  },
  {
    code: "484230",
    title: "Forest products trucking, long-distance",
  },
  {
    code: "484230",
    title: "Grain hauling, long-distance",
  },
  {
    code: "484230",
    title: "Gravel hauling, long-distance",
  },
  {
    code: "484230",
    title: "Livestock trucking, long-distance",
  },
  {
    code: "484230",
    title: "Log hauling, long-distance",
  },
  {
    code: "484230",
    title: "Mobile home towing services, long-distance",
  },
  {
    code: "484230",
    title: "Oil and gas field equipment trucking, long-distance",
  },
  {
    code: "484230",
    title: "Radioactive waste hauling, long-distance",
  },
  {
    code: "484230",
    title: "Recyclable material hauling, long-distance",
  },
  {
    code: "484230",
    title: "Refrigerated products trucking, long-distance",
  },
  {
    code: "484230",
    title: "Refuse hauling, long-distance",
  },
  {
    code: "484230",
    title:
      "Rubbish hauling without collection or disposal, truck, long-distance",
  },
  {
    code: "484230",
    title: "Sand hauling, long-distance",
  },
  {
    code: "484230",
    title:
      "Tanker trucking (e.g., chemical, juice, milk, petroleum), long-distance",
  },
  {
    code: "484230",
    title: "Tracked vehicle freight transportation, long-distance",
  },
  {
    code: "484230",
    title: "Trash hauling, long-distance",
  },
  {
    code: "484230",
    title: "Trucking, specialized freight (except used goods), long-distance",
  },
  {
    code: "484230",
    title: "Waste hauling, hazardous, long-distance",
  },
  {
    code: "484230",
    title: "Waste hauling, nonhazardous, long-distance",
  },
  {
    code: "485111",
    title:
      "Commuter transit systems, mixed mode (e.g., bus, commuter rail, subway combination)",
  },
  {
    code: "485111",
    title:
      "Local transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
  },
  {
    code: "485111",
    title:
      "Mixed mode transit systems (e.g., bus, commuter rail, subway combinations)",
  },
  {
    code: "485111",
    title:
      "Suburban transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
  },
  {
    code: "485111",
    title:
      "Transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
  },
  {
    code: "485111",
    title:
      "Urban transit systems, mixed mode (e.g., bus, commuter rail, subway combinations)",
  },
  {
    code: "485112",
    title: "Commuter rail systems (except mixed mode)",
  },
  {
    code: "485112",
    title: "Local passenger rail systems (except mixed mode)",
  },
  {
    code: "485112",
    title: "Rail transportation (except mixed mode), commuter",
  },
  {
    code: "485112",
    title: "Railway systems (except mixed mode), commuter",
  },
  {
    code: "485112",
    title: "Suburban commuter rail systems (except mixed mode)",
  },
  {
    code: "485112",
    title: "Urban commuter rail systems (except mixed mode)",
  },
  {
    code: "485113",
    title: "Bus line, local (except mixed mode)",
  },
  {
    code: "485113",
    title: "Bus services, urban and suburban (except mixed mode)",
  },
  {
    code: "485113",
    title: "Bus transit systems (except mixed mode)",
  },
  {
    code: "485113",
    title: "City bus services (except mixed mode)",
  },
  {
    code: "485113",
    title: "Commuter bus operation (except mixed mode)",
  },
  {
    code: "485113",
    title: "Local bus services (except mixed mode)",
  },
  {
    code: "485113",
    title: "Suburban bus line services (except mixed mode)",
  },
  {
    code: "485113",
    title: "Urban bus line services (except mixed mode)",
  },
  {
    code: "485119",
    title: "Cable car systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Light rail systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Monorail transit systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Street railway systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Streetcar systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Subway systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Tramway systems (except mixed mode), commuter",
  },
  {
    code: "485119",
    title: "Trolley systems (except mixed mode), commuter",
  },
  {
    code: "485210",
    title: "Bus line operation, intercity",
  },
  {
    code: "485210",
    title: "Intercity bus line operation",
  },
  {
    code: "485210",
    title: "Interstate bus line operation",
  },
  {
    code: "485210",
    title: "Interurban bus line operation",
  },
  {
    code: "485210",
    title: "Motor coach operation, interurban and rural",
  },
  {
    code: "485210",
    title: "Rural bus services",
  },
  {
    code: "485310",
    title: "Cab (i.e., taxi) services",
  },
  {
    code: "485310",
    title: "Ride hailing arrangement services",
  },
  {
    code: "485310",
    title: "Ride hailing services",
  },
  {
    code: "485310",
    title: "Ridesharing arrangement services",
  },
  {
    code: "485310",
    title: "Ridesharing services",
  },
  {
    code: "485310",
    title: "Taxicab dispatch services",
  },
  {
    code: "485310",
    title: "Taxicab fleet operators",
  },
  {
    code: "485310",
    title: "Taxicab organizations",
  },
  {
    code: "485310",
    title: "Taxicab owner-operators",
  },
  {
    code: "485310",
    title: "Taxicab services",
  },
  {
    code: "485320",
    title: "Automobile rental with driver (except shuttle service, taxis)",
  },
  {
    code: "485320",
    title: "Hearse rental with driver",
  },
  {
    code: "485320",
    title: "Limousine services (except shuttle services)",
  },
  {
    code: "485320",
    title: "Limousines for hire with driver (except taxis)",
  },
  {
    code: "485320",
    title: "Luxury automobiles for hire with driver (except taxis)",
  },
  {
    code: "485320",
    title:
      "Passenger limousine rental with driver (except shuttle service, taxi)",
  },
  {
    code: "485320",
    title: "Passenger van rental with driver (except shuttle service, taxi)",
  },
  {
    code: "485410",
    title: "Bus operation, school and employee",
  },
  {
    code: "485410",
    title: "Employee bus services",
  },
  {
    code: "485410",
    title: "School bus services",
  },
  {
    code: "485410",
    title: "School or employee bus transportation for the disabled or elderly",
  },
  {
    code: "485510",
    title: "Bus charter services (except scenic, sightseeing)",
  },
  {
    code: "485510",
    title: "Charter bus services (except scenic, sightseeing)",
  },
  {
    code: "485991",
    title: "Disabled or elderly passenger transportation services",
  },
  {
    code: "485991",
    title:
      "Nonemergency medical transportation services (except ambulance services)",
  },
  {
    code: "485991",
    title: "Paratransit transportation services",
  },
  {
    code: "485991",
    title: "Pet transportation services",
  },
  {
    code: "485991",
    title: "Senior citizens transportation services",
  },
  {
    code: "485991",
    title: "Special needs passenger transportation services",
  },
  {
    code: "485999",
    title: "Airport limousine services (i.e., shuttle)",
  },
  {
    code: "485999",
    title: "Airport shuttle services",
  },
  {
    code: "485999",
    title:
      "Car pool operation (except ridesharing and ridesharing arrangement services)",
  },
  {
    code: "485999",
    title: "Shuttle services (except employee bus)",
  },
  {
    code: "485999",
    title:
      "Vanpool operation (except ridesharing and ridesharing arrangement services)",
  },
  {
    code: "486110",
    title: "Booster pumping station, crude oil transportation",
  },
  {
    code: "486110",
    title: "Crude oil pipeline transportation",
  },
  {
    code: "486110",
    title: "Petroleum pipelines, crude",
  },
  {
    code: "486110",
    title: "Pipeline transportation, crude oil",
  },
  {
    code: "486210",
    title: "Booster pumping station, natural gas transportation",
  },
  {
    code: "486210",
    title: "Gas, natural, pipeline operation",
  },
  {
    code: "486210",
    title: "Natural gas pipeline transportation",
  },
  {
    code: "486210",
    title:
      "Natural gas transmission (i.e., processing plants to local distribution systems)",
  },
  {
    code: "486210",
    title: "Pipeline transportation, natural gas",
  },
  {
    code: "486210",
    title: "Storage of natural gas",
  },
  {
    code: "486210",
    title:
      "Transmission of natural gas via pipeline (i.e., processing plants to local distribution systems)",
  },
  {
    code: "486910",
    title: "Booster pumping station, refined petroleum products transportation",
  },
  {
    code: "486910",
    title: "Gasoline pipeline transportation",
  },
  {
    code: "486910",
    title: "Natural gas liquids pipeline transportation",
  },
  {
    code: "486910",
    title: "Petroleum pipelines, refined",
  },
  {
    code: "486910",
    title:
      "Pipeline transportation, gasoline and other refined petroleum products",
  },
  {
    code: "486910",
    title: "Refined petroleum products pipeline transportation",
  },
  {
    code: "486990",
    title: "Booster pumping station (except natural gas, petroleum)",
  },
  {
    code: "486990",
    title: "Coal pipeline transportation",
  },
  {
    code: "486990",
    title:
      "Pipeline transportation (except crude oil, natural gas, refined petroleum products)",
  },
  {
    code: "486990",
    title: "Slurry pipeline transportation",
  },
  {
    code: "487110",
    title: "Buses, scenic and sightseeing operation",
  },
  {
    code: "487110",
    title: "Cable car, land, scenic and sightseeing operation",
  },
  {
    code: "487110",
    title: "Carriage, horse-drawn, operation",
  },
  {
    code: "487110",
    title: "Cog railway, scenic and sightseeing, operation",
  },
  {
    code: "487110",
    title: "Horse-drawn carriage operation",
  },
  {
    code: "487110",
    title: "Monorail, scenic and sightseeing, operation",
  },
  {
    code: "487110",
    title: "Railroad transportation, scenic and sightseeing",
  },
  {
    code: "487110",
    title: "Railroad, scenic and sightseeing, operation",
  },
  {
    code: "487110",
    title: "Railway transportation, scenic and sightseeing",
  },
  {
    code: "487110",
    title: "Scenic and sightseeing excursions, land",
  },
  {
    code: "487110",
    title: "Sightseeing bus operation",
  },
  {
    code: "487110",
    title: "Sightseeing operation, human-drawn vehicle",
  },
  {
    code: "487110",
    title: "Steam train excursions",
  },
  {
    code: "487110",
    title: "Tour bus, scenic and sightseeing, operation",
  },
  {
    code: "487110",
    title: "Tracked vehicle sightseeing operation",
  },
  {
    code: "487110",
    title: "Trolley, scenic and sightseeing, operation",
  },
  {
    code: "487210",
    title: "Airboat (i.e., swamp buggy) operation",
  },
  {
    code: "487210",
    title: "Boat, fishing charter, operation",
  },
  {
    code: "487210",
    title: "Charter fishing boat operation",
  },
  {
    code: "487210",
    title: "Dinner cruises",
  },
  {
    code: "487210",
    title: "Excursion boat operation",
  },
  {
    code: "487210",
    title: "Fishing boat charter operation",
  },
  {
    code: "487210",
    title: "Harbor sightseeing tours",
  },
  {
    code: "487210",
    title: "Hovercraft sightseeing operation",
  },
  {
    code: "487210",
    title: "Scenic and sightseeing excursions, water",
  },
  {
    code: "487210",
    title: "Sightseeing boat operation",
  },
  {
    code: "487210",
    title: "Swamp buggy operation",
  },
  {
    code: "487210",
    title: "Whale watching excursions",
  },
  {
    code: "487990",
    title: "Aerial cable car, scenic and sightseeing, operation",
  },
  {
    code: "487990",
    title: "Aerial tramway, scenic and sightseeing, operation",
  },
  {
    code: "487990",
    title: "Glider excursions",
  },
  {
    code: "487990",
    title: "Helicopter ride, scenic and sightseeing, operation",
  },
  {
    code: "487990",
    title: "Hot air balloon ride, scenic and sightseeing, operation",
  },
  {
    code: "487990",
    title: "Scenic and sightseeing excursions, aerial",
  },
  {
    code: "487990",
    title: "Tramway, aerial, scenic and sightseeing operation",
  },
  {
    code: "488111",
    title: "Air traffic control services (except military)",
  },
  {
    code: "488119",
    title: "Aircraft hangar rental",
  },
  {
    code: "488119",
    title: "Aircraft parking service",
  },
  {
    code: "488119",
    title: "Airport baggage handling services",
  },
  {
    code: "488119",
    title: "Airport cargo handling services",
  },
  {
    code: "488119",
    title: "Airport operators (e.g., civil, international, national)",
  },
  {
    code: "488119",
    title: "Airport runway maintenance services",
  },
  {
    code: "488119",
    title: "Airports, civil, operation and maintenance",
  },
  {
    code: "488119",
    title:
      "Aviation clubs, primarily providing flying field services to the general public",
  },
  {
    code: "488119",
    title: "Fixed base operators",
  },
  {
    code: "488119",
    title: "Flying field operators",
  },
  {
    code: "488119",
    title: "Hangar rental, aircraft",
  },
  {
    code: "488119",
    title: "Maintenance services, runway",
  },
  {
    code: "488119",
    title: "Parking services, aircraft",
  },
  {
    code: "488119",
    title: "Runway maintenance services",
  },
  {
    code: "488119",
    title: "Vacuuming of airport runways",
  },
  {
    code: "488190",
    title: "Aircraft ferrying services",
  },
  {
    code: "488190",
    title: "Aircraft inspection services",
  },
  {
    code: "488190",
    title:
      "Aircraft maintenance and repair services (except factory conversion, factory overhaul, factory rebuilding)",
  },
  {
    code: "488190",
    title: "Aircraft testing services",
  },
  {
    code: "488190",
    title: "Airport passenger screening security services",
  },
  {
    code: "488190",
    title: "Fueling aircraft on a contract or fee basis",
  },
  {
    code: "488190",
    title: "Independent pilot, air (except owner-operators)",
  },
  {
    code: "488190",
    title: "Inspection services, aircraft",
  },
  {
    code: "488190",
    title:
      "Maintenance and repair services, aircraft (except factory conversion, factory overhaul, factory rebuilding)",
  },
  {
    code: "488190",
    title: "Testing services, aircraft",
  },
  {
    code: "488210",
    title: "Freight car cleaning services",
  },
  {
    code: "488210",
    title: "Grain leveling and trimming in railroad cars",
  },
  {
    code: "488210",
    title: "Loading and unloading services at rail terminals",
  },
  {
    code: "488210",
    title:
      "Locomotive and rail car repair (except factory conversion, factory overhaul, factory rebuilding)",
  },
  {
    code: "488210",
    title: "Maintenance of rights of way and structures, railway",
  },
  {
    code: "488210",
    title: "Railroad switching services",
  },
  {
    code: "488210",
    title: "Railroad terminals, independent operation",
  },
  {
    code: "488210",
    title: "Railway terminals, independent operation",
  },
  {
    code: "488210",
    title: "Shunting trailers in rail terminals",
  },
  {
    code: "488210",
    title: "Switching services, railroad",
  },
  {
    code: "488310",
    title: "Canal maintenance services (except dredging)",
  },
  {
    code: "488310",
    title: "Canal operation",
  },
  {
    code: "488310",
    title: "Docking facility operations",
  },
  {
    code: "488310",
    title: "Harbor maintenance services (except dredging)",
  },
  {
    code: "488310",
    title: "Harbor operation",
  },
  {
    code: "488310",
    title: "Lighthouse operation",
  },
  {
    code: "488310",
    title: "Maintenance services, waterfront terminal (except dredging)",
  },
  {
    code: "488310",
    title: "Port facility operation",
  },
  {
    code: "488310",
    title: "Seaway operation",
  },
  {
    code: "488310",
    title: "Waterfront terminal operation (e.g., docks, piers, wharves)",
  },
  {
    code: "488310",
    title: "Wharf operation",
  },
  {
    code: "488320",
    title: "Loading and unloading services at ports and harbors",
  },
  {
    code: "488320",
    title: "Longshoremen services",
  },
  {
    code: "488320",
    title: "Marine cargo handling services",
  },
  {
    code: "488320",
    title: "Ship hold cleaning services",
  },
  {
    code: "488320",
    title: "Stevedoring services",
  },
  {
    code: "488330",
    title: "Cargo salvaging, marine",
  },
  {
    code: "488330",
    title: "Docking and undocking marine vessel services",
  },
  {
    code: "488330",
    title: "Harbor tugboat services",
  },
  {
    code: "488330",
    title: "Marine salvaging services",
  },
  {
    code: "488330",
    title: "Marine vessel traffic reporting services",
  },
  {
    code: "488330",
    title: "Piloting services, water transportation",
  },
  {
    code: "488330",
    title: "Radio beacon (i.e., ship navigation) services",
  },
  {
    code: "488330",
    title: "Tugboat services, harbor operation",
  },
  {
    code: "488390",
    title: "Cargo checkers, marine",
  },
  {
    code: "488390",
    title: "Cargo surveyors, marine",
  },
  {
    code: "488390",
    title: "Drydocks, floating (i.e., routine repair and maintenance of ships)",
  },
  {
    code: "488390",
    title: "Marine cargo checkers and surveyors",
  },
  {
    code: "488390",
    title: "Ship dismantling at floating drydock",
  },
  {
    code: "488390",
    title: "Ship scaling services not done at a shipyard",
  },
  {
    code: "488410",
    title: "Emergency road services (i.e., tow service)",
  },
  {
    code: "488410",
    title: "Motor vehicle towing services",
  },
  {
    code: "488410",
    title: "Tow truck services",
  },
  {
    code: "488410",
    title: "Towing services, motor vehicle",
  },
  {
    code: "488410",
    title: "Wrecker services (i.e., towing services), motor vehicle",
  },
  {
    code: "488490",
    title: "Bridge, tunnel, and highway operations",
  },
  {
    code: "488490",
    title: "Bus terminal operation, independent",
  },
  {
    code: "488490",
    title: "Cargo surveyors, truck transportation",
  },
  {
    code: "488490",
    title: "Driving services, independent (e.g., automobile, truck delivery)",
  },
  {
    code: "488490",
    title: "Independent truck driver (except owner-operators)",
  },
  {
    code: "488490",
    title: "Inspection or weighing services, truck transportation",
  },
  {
    code: "488490",
    title: "Loading and unloading at truck terminals",
  },
  {
    code: "488490",
    title: "Pilot car services (i.e., wide load warning services)",
  },
  {
    code: "488490",
    title: "Shunting of trailers in truck terminals",
  },
  {
    code: "488490",
    title: "Snow clearing, highways and bridges, road transportation",
  },
  {
    code: "488490",
    title: "Snow removal, highway",
  },
  {
    code: "488490",
    title: "Street cleaning service",
  },
  {
    code: "488490",
    title: "Toll road operations, highway",
  },
  {
    code: "488490",
    title: "Truck weighing station operation",
  },
  {
    code: "488490",
    title: "Trucking terminals, independently operated",
  },
  {
    code: "488510",
    title: "Agents, shipping",
  },
  {
    code: "488510",
    title: "Customs brokers",
  },
  {
    code: "488510",
    title: "Freight forwarding",
  },
  {
    code: "488510",
    title: "Marine shipping agency",
  },
  {
    code: "488510",
    title: "Shipping agents (freight forwarding)",
  },
  {
    code: "488991",
    title: "Crating goods for shipping",
  },
  {
    code: "488991",
    title: "Packing and preparing goods for shipping",
  },
  {
    code: "488991",
    title: "Preparing goods for transportation (i.e., crating, packing)",
  },
  {
    code: "488999",
    title:
      "Arrangement of car pools and vanpools (except ridesharing arrangement services)",
  },
  {
    code: "488999",
    title:
      "Arrangement of nonemergency medical transportation, without providing social assistance services",
  },
  {
    code: "488999",
    title:
      "Car pools, arrangement of (except ridesharing arrangement services)",
  },
  {
    code: "488999",
    title:
      "Liquefied natural gas (LNG) terminals (liquefaction and regasification)",
  },
  {
    code: "488999",
    title: "Pipeline terminal facilities, independently operated",
  },
  {
    code: "488999",
    title:
      "Precooling of fruits and vegetables in connection with transportation",
  },
  {
    code: "488999",
    title:
      "Stockyards (i.e., not for fattening or selling livestock), transportation",
  },
  {
    code: "488999",
    title: "Vanpools, arrangement of (except ridesharing arrangement services)",
  },
  {
    code: "491110",
    title: "Postal delivery services, local, operated by U.S. Postal Service",
  },
  {
    code: "491110",
    title: "Postal delivery services, local, operated on a contract basis",
  },
  {
    code: "491110",
    title: "Postal services operated by U.S. Postal Service",
  },
  {
    code: "491110",
    title: "Postal stations operated by U.S. Postal Service",
  },
  {
    code: "491110",
    title: "Postal stations operated on a contract basis",
  },
  {
    code: "492110",
    title:
      "Air courier services (except establishments operating under a universal service obligation)",
  },
  {
    code: "492110",
    title:
      "Courier services (i.e., intercity network) (except establishments operating under a universal service obligation)",
  },
  {
    code: "492110",
    title:
      "Express delivery services (except establishments operating under a universal service obligation)",
  },
  {
    code: "492110",
    title:
      "Local letter and parcel delivery services as part of intercity courier network",
  },
  {
    code: "492210",
    title: "Alcoholic beverage delivery service",
  },
  {
    code: "492210",
    title: "Bicycle courier",
  },
  {
    code: "492210",
    title:
      "Delivery service (except as part of intercity courier network, U.S. Postal Service)",
  },
  {
    code: "492210",
    title:
      "Grocery delivery services (i.e., independent service from grocery store)",
  },
  {
    code: "492210",
    title:
      "Local letter and parcel delivery services (except as part of intercity courier network, U.S. Postal Service)",
  },
  {
    code: "492210",
    title: "Messenger service",
  },
  {
    code: "492210",
    title:
      "Restaurant meals order and delivery services (i.e., independent order and delivery services)",
  },
  {
    code: "493110",
    title: "Bonded warehousing, general merchandise",
  },
  {
    code: "493110",
    title: "General warehousing and storage",
  },
  {
    code: "493110",
    title: "Private warehousing and storage, general merchandise",
  },
  {
    code: "493110",
    title:
      "Public warehousing and storage (except self-storage), general merchandise",
  },
  {
    code: "493110",
    title: "Warehousing (including foreign trade zones), general merchandise",
  },
  {
    code: "493110",
    title: "Warehousing and storage, general merchandise",
  },
  {
    code: "493120",
    title: "Bonded warehousing, refrigerated",
  },
  {
    code: "493120",
    title: "Cold storage locker services",
  },
  {
    code: "493120",
    title: "Cold storage warehousing",
  },
  {
    code: "493120",
    title: "Farm product warehousing and storage, refrigerated",
  },
  {
    code: "493120",
    title: "Fur storage warehousing for the trade",
  },
  {
    code: "493120",
    title: "Private warehousing and storage, refrigerated",
  },
  {
    code: "493120",
    title: "Public warehousing and storage, refrigerated",
  },
  {
    code: "493120",
    title: "Refrigerated warehousing",
  },
  {
    code: "493120",
    title: "Warehousing, refrigerated",
  },
  {
    code: "493130",
    title: "Bonded warehousing, farm products (except refrigerated)",
  },
  {
    code: "493130",
    title: "Farm product warehousing and storage (except refrigerated)",
  },
  {
    code: "493130",
    title: "Grain elevators, storage only",
  },
  {
    code: "493130",
    title:
      "Private warehousing and storage, farm products (except refrigerated)",
  },
  {
    code: "493130",
    title:
      "Public warehousing and storage, farm products (except refrigerated)",
  },
  {
    code: "493130",
    title: "Warehousing, farm products (except refrigerated)",
  },
  {
    code: "493190",
    title: "Automobile dead storage",
  },
  {
    code: "493190",
    title:
      "Bonded warehousing (except farm products, general merchandise, refrigerated)",
  },
  {
    code: "493190",
    title: "Bulk petroleum storage",
  },
  {
    code: "493190",
    title: "Document storage and warehousing",
  },
  {
    code: "493190",
    title: "Lumber storage terminals",
  },
  {
    code: "493190",
    title:
      "Private warehousing and storage (except farm products, general merchandise, refrigerated)",
  },
  {
    code: "493190",
    title:
      "Public warehousing and storage (except farm products, general merchandise, refrigerated, self-storage)",
  },
  {
    code: "493190",
    title:
      "Warehousing (except farm products, general merchandise, refrigerated)",
  },
  {
    code: "493190",
    title: "Whiskey warehousing",
  },
  {
    code: "512110",
    title: "Animated cartoon production",
  },
  {
    code: "512110",
    title: "Animated cartoon production and distribution",
  },
  {
    code: "512110",
    title: "Commercials, television, production",
  },
  {
    code: "512110",
    title: "Film studios producing films",
  },
  {
    code: "512110",
    title: "Films, motion picture production",
  },
  {
    code: "512110",
    title: "Films, motion picture production and distribution",
  },
  {
    code: "512110",
    title: "Instructional video production",
  },
  {
    code: "512110",
    title: "Motion picture and video production",
  },
  {
    code: "512110",
    title: "Motion picture and video production and distribution",
  },
  {
    code: "512110",
    title: "Motion picture production",
  },
  {
    code: "512110",
    title: "Motion picture production and distribution",
  },
  {
    code: "512110",
    title: "Motion picture production payroll agents",
  },
  {
    code: "512110",
    title: "Motion picture studios, producing motion pictures",
  },
  {
    code: "512110",
    title: "Movie production and distribution",
  },
  {
    code: "512110",
    title: "Music video production",
  },
  {
    code: "512110",
    title: "Music video production and distribution",
  },
  {
    code: "512110",
    title: "Program producing, television",
  },
  {
    code: "512110",
    title: "Television commercial production",
  },
  {
    code: "512110",
    title: "Television show production",
  },
  {
    code: "512110",
    title: "Video production",
  },
  {
    code: "512110",
    title: "Video production and distribution",
  },
  {
    code: "512120",
    title: "Animated cartoon distribution",
  },
  {
    code: "512120",
    title: "Film distribution agencies",
  },
  {
    code: "512120",
    title: "Film distribution, motion picture and video",
  },
  {
    code: "512120",
    title: "Film libraries, commercial distribution",
  },
  {
    code: "512120",
    title: "Motion picture distribution exclusive of production",
  },
  {
    code: "512120",
    title: "Motion picture film distributors",
  },
  {
    code: "512120",
    title: "Motion picture film libraries, commercial distribution",
  },
  {
    code: "512120",
    title: "Tape distribution for television",
  },
  {
    code: "512120",
    title: "Television show syndicators",
  },
  {
    code: "512131",
    title: "Cinemas",
  },
  {
    code: "512131",
    title: "Film festivals exhibitors",
  },
  {
    code: "512131",
    title: "Motion picture exhibition",
  },
  {
    code: "512131",
    title: "Motion picture exhibitors for airlines",
  },
  {
    code: "512131",
    title: "Motion picture exhibitors, itinerant",
  },
  {
    code: "512131",
    title: "Motion picture theaters, indoor",
  },
  {
    code: "512131",
    title: "Movie theaters (except drive-in)",
  },
  {
    code: "512131",
    title: "Theaters, motion picture (except drive-in)",
  },
  {
    code: "512131",
    title: "Theaters, motion picture, indoor",
  },
  {
    code: "512132",
    title: "Drive-in motion picture theaters",
  },
  {
    code: "512132",
    title: "Motion picture theaters, drive-in",
  },
  {
    code: "512132",
    title: "Movie theaters, drive-in",
  },
  {
    code: "512132",
    title: "Open air motion picture theaters",
  },
  {
    code: "512132",
    title: "Theaters, motion picture, drive-in",
  },
  {
    code: "512132",
    title: "Theaters, outdoor motion picture",
  },
  {
    code: "512191",
    title: "Closed captioning services, taped material",
  },
  {
    code: "512191",
    title: "Film or tape closed captioning",
  },
  {
    code: "512191",
    title: "Film or video transfer services",
  },
  {
    code: "512191",
    title: "Motion picture animation, postproduction",
  },
  {
    code: "512191",
    title: "Motion picture or video editing services",
  },
  {
    code: "512191",
    title: "Motion picture or video postproduction services",
  },
  {
    code: "512191",
    title: "Motion picture or video titling",
  },
  {
    code: "512191",
    title: "Motion picture production special effects, postproduction",
  },
  {
    code: "512191",
    title: "Postproduction facilities, motion picture or video",
  },
  {
    code: "512191",
    title: "Post-synchronization sound dubbing",
  },
  {
    code: "512191",
    title: "Sound dubbing services, motion picture",
  },
  {
    code: "512191",
    title: "Special effects for motion picture production, postproduction",
  },
  {
    code: "512191",
    title: "Subtitling of motion picture film or video",
  },
  {
    code: "512191",
    title: "Tape transfer service",
  },
  {
    code: "512191",
    title: "Teleproduction services",
  },
  {
    code: "512191",
    title: "Titling of motion picture film or video",
  },
  {
    code: "512191",
    title:
      "Video conversion services (i.e., between formats, except technical streaming support services)",
  },
  {
    code: "512191",
    title: "Video postproduction services",
  },
  {
    code: "512191",
    title:
      "Video tape and film stock digitization services (except technical streaming support services)",
  },
  {
    code: "512199",
    title: "Booking agencies, motion picture",
  },
  {
    code: "512199",
    title: "Booking agencies, motion picture or video productions",
  },
  {
    code: "512199",
    title: "Film libraries, motion picture or video, stock footage",
  },
  {
    code: "512199",
    title: "Film preservation services",
  },
  {
    code: "512199",
    title: "Film processing laboratories, motion picture",
  },
  {
    code: "512199",
    title: "Film restoration services",
  },
  {
    code: "512199",
    title: "Laboratory services, motion picture",
  },
  {
    code: "512199",
    title: "Libraries, motion picture stock footage film",
  },
  {
    code: "512199",
    title: "Libraries, video tape, stock footage",
  },
  {
    code: "512199",
    title: "Motion picture booking agencies",
  },
  {
    code: "512199",
    title: "Motion picture film laboratories",
  },
  {
    code: "512199",
    title: "Motion picture film libraries, stock footage",
  },
  {
    code: "512199",
    title: "Motion picture film reproduction for theatrical distribution",
  },
  {
    code: "512199",
    title: "Motion picture laboratories",
  },
  {
    code: "512199",
    title: "Reproduction of motion picture films for theatrical distribution",
  },
  {
    code: "512199",
    title: "Stock footage film libraries",
  },
  {
    code: "512199",
    title: "Video tape libraries, stock footage",
  },
  {
    code: "512230",
    title: "Music book (i.e., bound sheet music) publishers",
  },
  {
    code: "512230",
    title:
      "Music book (i.e., bound sheet music) publishers and printing combined",
  },
  {
    code: "512230",
    title: "Music copyright authorizing use",
  },
  {
    code: "512230",
    title: "Music copyright buying and licensing",
  },
  {
    code: "512230",
    title: "Music publishers",
  },
  {
    code: "512230",
    title: "Music, sheet, publishers and printing combined",
  },
  {
    code: "512230",
    title: "Publishers, music",
  },
  {
    code: "512230",
    title: "Sheet music publishers",
  },
  {
    code: "512230",
    title: "Sheet music publishers and printing combined",
  },
  {
    code: "512230",
    title: "Song publishers",
  },
  {
    code: "512230",
    title: "Song publishers and printing combined",
  },
  {
    code: "512240",
    title: "Audio recording postproduction services",
  },
  {
    code: "512240",
    title: "Audio recording restoration services",
  },
  {
    code: "512240",
    title: "Recording studios, sound, operating on a contract or fee basis",
  },
  {
    code: "512240",
    title: "Sound recording studios (except integrated record companies)",
  },
  {
    code: "512250",
    title:
      "Integrated record companies (i.e., releasing, promoting, distributing)",
  },
  {
    code: "512250",
    title: "Integrated record production and distribution",
  },
  {
    code: "512250",
    title: "Master recording leasing and licensing",
  },
  {
    code: "512250",
    title: "Musical recording, releasing, promoting, and distributing",
  },
  {
    code: "512250",
    title:
      "Prerecorded audio tapes and compact discs integrated manufacture, release, and distribution",
  },
  {
    code: "512250",
    title: "Record producers (except independent)",
  },
  {
    code: "512250",
    title:
      "Record production (except independent record producers) without duplication or distribution",
  },
  {
    code: "512250",
    title:
      "Record releasing, promoting, and distributing combined with mass duplication",
  },
  {
    code: "512250",
    title:
      "Sound recording, integrated production, reproduction, release, and distribution",
  },
  {
    code: "512250",
    title: "Sound recording, releasing, promoting, and distributing",
  },
  {
    code: "512290",
    title: "Audio recording of meetings or conferences",
  },
  {
    code: "512290",
    title: "Producers, recorded radio shows (except independent producers)",
  },
  {
    code: "512290",
    title: "Radio program recording production (except independent producers) ",
  },
  {
    code: "512290",
    title: "Recording books on tape or disc (except publishers)",
  },
  {
    code: "512290",
    title: "Recording seminars and conferences, audio",
  },
  {
    code: "512290",
    title: "Stock music and other audio services",
  },
  {
    code: "512290",
    title: "Stock sound library (e.g., general background sounds, stock music)",
  },
  {
    code: "513110",
    title: "Internet newspaper publishing",
  },
  {
    code: "513110",
    title: "Newspaper branch offices",
  },
  {
    code: "513110",
    title: "Newspaper publishers",
  },
  {
    code: "513110",
    title: "Newspaper publishers (except exclusive Internet publishing)",
  },
  {
    code: "513110",
    title: "Newspaper publishers and printing combined",
  },
  {
    code: "513110",
    title: "Newspaper publishing, exclusively on Internet",
  },
  {
    code: "513110",
    title: "Publishers, newspaper",
  },
  {
    code: "513110",
    title: "Publishers, newspaper (except exclusive Internet publishing)",
  },
  {
    code: "513110",
    title: "Publishers, newspaper, combined with printing",
  },
  {
    code: "513120",
    title: "Advertising periodical publishers",
  },
  {
    code: "513120",
    title:
      "Advertising periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Advertising periodical publishers and printing combined",
  },
  {
    code: "513120",
    title: "Advertising periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Agricultural magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Agricultural magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title:
      "Agricultural magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Agricultural magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Comic book publishers",
  },
  {
    code: "513120",
    title: "Comic book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Comic book publishers and printing combined",
  },
  {
    code: "513120",
    title: "Comic book publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Financial magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Financial magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Financial magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Financial magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Internet comic book publishing",
  },
  {
    code: "513120",
    title: "Internet magazine publishing",
  },
  {
    code: "513120",
    title: "Internet newsletter publishing",
  },
  {
    code: "513120",
    title: "Internet periodical publishers",
  },
  {
    code: "513120",
    title: "Juvenile magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Juvenile magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Juvenile magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Juvenile magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Magazine publishers",
  },
  {
    code: "513120",
    title: "Magazine publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Magazine publishers and printing combined",
  },
  {
    code: "513120",
    title: "Magazine publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Medical journal and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Medical journal and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Medical journal and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Medical journal and periodical publishers, exclusively on Internet ",
  },
  {
    code: "513120",
    title: "Newsletter publishers",
  },
  {
    code: "513120",
    title: "Newsletter publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Newsletter publishers and printing combined",
  },
  {
    code: "513120",
    title: "Newsletter publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Periodical publishers",
  },
  {
    code: "513120",
    title: "Periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Periodical publishers and printing combined",
  },
  {
    code: "513120",
    title: "Periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Professional magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Professional magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title:
      "Professional magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Professional magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Publishers (except exclusive Internet publishing), magazine",
  },
  {
    code: "513120",
    title: "Publishers (except exclusive Internet publishing), periodical",
  },
  {
    code: "513120",
    title: "Publishers, magazine",
  },
  {
    code: "513120",
    title: "Publishers, magazine, combined with printing",
  },
  {
    code: "513120",
    title: "Publishers, periodical",
  },
  {
    code: "513120",
    title: "Publishers, periodical, combined with printing",
  },
  {
    code: "513120",
    title: "Radio guide publishers",
  },
  {
    code: "513120",
    title: "Radio guide publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Radio guide publishers and printing combined",
  },
  {
    code: "513120",
    title: "Radio guide publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Radio schedule publishers",
  },
  {
    code: "513120",
    title: "Radio schedule publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Radio schedule publishers and printing combined",
  },
  {
    code: "513120",
    title: "Radio schedule publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Religious magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Religious magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Religious magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Religious magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Scholarly journal publishers",
  },
  {
    code: "513120",
    title:
      "Scholarly journal publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Scholarly journal publishers and printing combined",
  },
  {
    code: "513120",
    title: "Scholarly journal publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Scholastic magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Scholastic magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title:
      "Scholastic magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Scholastic magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Scientific journal and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Scientific journal and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Scientific journal and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Scientific journal and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Technical magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Technical magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Technical magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title:
      "Technical magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Television guide publishers",
  },
  {
    code: "513120",
    title: "Television guide publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Television guide publishers and printing combined",
  },
  {
    code: "513120",
    title: "Television guide publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Trade journal publishers",
  },
  {
    code: "513120",
    title: "Trade journal publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Trade journal publishers and printing combined",
  },
  {
    code: "513120",
    title: "Trade journal publishers, exclusively on Internet",
  },
  {
    code: "513120",
    title: "Trade magazine and periodical publishers",
  },
  {
    code: "513120",
    title:
      "Trade magazine and periodical publishers (except exclusive Internet publishing)",
  },
  {
    code: "513120",
    title: "Trade magazine and periodical publishers and printing combined",
  },
  {
    code: "513120",
    title: "Trade magazine and periodical publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Almanac publishers",
  },
  {
    code: "513130",
    title: "Almanac publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Almanac publishers and printing combined",
  },
  {
    code: "513130",
    title: "Almanac publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Atlas publishers",
  },
  {
    code: "513130",
    title: "Atlas publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Atlas publishers and printing combined",
  },
  {
    code: "513130",
    title: "Atlas publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Book (e.g., hardback, paperback, audio) publishers",
  },
  {
    code: "513130",
    title:
      "Book (e.g., hardback, paperback, audio) publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Book publishers, university press",
  },
  {
    code: "513130",
    title:
      "Book publishers, university press (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Dictionary publishers",
  },
  {
    code: "513130",
    title: "Dictionary publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Dictionary publishers and printing combined",
  },
  {
    code: "513130",
    title: "Dictionary publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Encyclopedia publishers",
  },
  {
    code: "513130",
    title: "Encyclopedia publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Encyclopedia publishers and printing combined",
  },
  {
    code: "513130",
    title: "Encyclopedia publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Fiction book publishers",
  },
  {
    code: "513130",
    title: "Fiction book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Fiction book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Fiction book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Globe cover publishers",
  },
  {
    code: "513130",
    title: "Globe cover publishers and printing combined",
  },
  {
    code: "513130",
    title: "Graphic novel publishers",
  },
  {
    code: "513130",
    title: "Guide, street map, publishers",
  },
  {
    code: "513130",
    title:
      "Guide, street map, publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Guide, street map, publishers and printing combined",
  },
  {
    code: "513130",
    title: "Guide, street map, publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Internet book publishers",
  },
  {
    code: "513130",
    title: "Map publishers",
  },
  {
    code: "513130",
    title: "Map publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Map publishers and printing combined",
  },
  {
    code: "513130",
    title: "Map publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Nonfiction book publishers",
  },
  {
    code: "513130",
    title: "Nonfiction book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Nonfiction book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Nonfiction book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Pamphlet publishers",
  },
  {
    code: "513130",
    title: "Pamphlet publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Pamphlet publishers and printing combined",
  },
  {
    code: "513130",
    title: "Pamphlet publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Professional book publishers",
  },
  {
    code: "513130",
    title:
      "Professional book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Professional book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Professional book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Publishers (except exclusive Internet publishing), book",
  },
  {
    code: "513130",
    title: "Publishers (except exclusive Internet publishing), map",
  },
  {
    code: "513130",
    title: "Publishers, book",
  },
  {
    code: "513130",
    title: "Publishers, book, combined with printing",
  },
  {
    code: "513130",
    title: "Publishers, Internet map",
  },
  {
    code: "513130",
    title: "Publishers, map",
  },
  {
    code: "513130",
    title: "Religious book publishers",
  },
  {
    code: "513130",
    title: "Religious book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Religious book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Religious book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "School book publishers",
  },
  {
    code: "513130",
    title: "School book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "School book publishers and printing combined",
  },
  {
    code: "513130",
    title: "School book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "School textbook publishers",
  },
  {
    code: "513130",
    title: "School textbook publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "School textbook publishers and printing combined",
  },
  {
    code: "513130",
    title: "School textbook publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Street map guide publishers",
  },
  {
    code: "513130",
    title: "Street map guide publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Street map guide publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Technical manual and paperback book publishers",
  },
  {
    code: "513130",
    title:
      "Technical manual and paperback book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title:
      "Technical manual and paperback book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Technical manual publishers",
  },
  {
    code: "513130",
    title: "Technical manual publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Technical manual publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "Travel guide book publishers",
  },
  {
    code: "513130",
    title:
      "Travel guide book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "Travel guide book publishers and printing combined",
  },
  {
    code: "513130",
    title: "Travel guide book publishers, exclusively on Internet",
  },
  {
    code: "513130",
    title: "University press publishers",
  },
  {
    code: "513130",
    title: "University press publishers (except exclusive Internet publishing)",
  },
  {
    code: "513130",
    title: "University press publishers, exclusively on Internet",
  },
  {
    code: "513140",
    title: "Address list publishers",
  },
  {
    code: "513140",
    title: "Address list publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Address list publishers and printing combined",
  },
  {
    code: "513140",
    title: "Business directory publishers",
  },
  {
    code: "513140",
    title:
      "Business directory publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Business directory publishers and printing combined",
  },
  {
    code: "513140",
    title: "Business directory publishers, exclusively on Internet",
  },
  {
    code: "513140",
    title: "Catalog of collections publishers",
  },
  {
    code: "513140",
    title:
      "Catalog of collections publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Catalog of collections publishers and printing combined",
  },
  {
    code: "513140",
    title: "Catalog of collections publishers, exclusively on Internet",
  },
  {
    code: "513140",
    title: "Directory and mailing list publishers",
  },
  {
    code: "513140",
    title:
      "Directory and mailing list publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Directory and mailing list publishers and printing combined",
  },
  {
    code: "513140",
    title: "Directory publishers",
  },
  {
    code: "513140",
    title: "Directory publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Directory publishers and printing combined",
  },
  {
    code: "513140",
    title: "Directory publishers, exclusively on Internet",
  },
  {
    code: "513140",
    title: "Electronic directory publishers",
  },
  {
    code: "513140",
    title:
      "Electronic directory publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Electronic directory publishers, exclusively on Internet",
  },
  {
    code: "513140",
    title: "Mailing list publishers",
  },
  {
    code: "513140",
    title: "Mailing list publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Publishers (except exclusive Internet publishing), directory",
  },
  {
    code: "513140",
    title: "Publishers, directory",
  },
  {
    code: "513140",
    title: "Subscription directory publishers",
  },
  {
    code: "513140",
    title: "Telephone directory publishers",
  },
  {
    code: "513140",
    title:
      "Telephone directory publishers (except exclusive Internet publishing)",
  },
  {
    code: "513140",
    title: "Telephone directory publishers and printing combined",
  },
  {
    code: "513140",
    title: "Telephone directory publishers, exclusively on Internet",
  },
  {
    code: "513191",
    title: "Greeting card publishers",
  },
  {
    code: "513191",
    title: "Greeting card publishers (except exclusive Internet publishing)",
  },
  {
    code: "513191",
    title: "Greeting card publishers and printing combined",
  },
  {
    code: "513191",
    title: "Greeting card publishers, exclusively on Internet",
  },
  {
    code: "513191",
    title: "Publishers (except exclusive Internet publishing), greeting card",
  },
  {
    code: "513191",
    title: "Publishers, greeting card",
  },
  {
    code: "513191",
    title: "Publishers, greeting card, combined with printing",
  },
  {
    code: "513191",
    title: "Publishers, Internet greeting card",
  },
  {
    code: "513199",
    title: "Art print (except exclusive Internet publishing) publishers",
  },
  {
    code: "513199",
    title: "Art print publishers",
  },
  {
    code: "513199",
    title: "Art print publishers and printing combined",
  },
  {
    code: "513199",
    title: "Art publishers",
  },
  {
    code: "513199",
    title: "Art publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Art publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Calendar publishers",
  },
  {
    code: "513199",
    title: "Calendar publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Calendar publishers and printing combined",
  },
  {
    code: "513199",
    title: "Calendar publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Catalog (i.e., mail-order, store merchandise) publishers",
  },
  {
    code: "513199",
    title:
      "Catalog (i.e., mail-order, store merchandise) publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title:
      "Catalog (i.e., mail-order, store merchandise) publishers and printing combined",
  },
  {
    code: "513199",
    title: "Children's coloring book publishers",
  },
  {
    code: "513199",
    title:
      "Children's coloring book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Children's coloring book publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Diary and time scheduler publishers",
  },
  {
    code: "513199",
    title:
      "Diary and time scheduler publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Diary and time scheduler publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Discount coupon book publishers",
  },
  {
    code: "513199",
    title:
      "Discount coupon book publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Discount coupon book publishers and printing combined",
  },
  {
    code: "513199",
    title: "Discount coupon book publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Limited editions art print publishers",
  },
  {
    code: "513199",
    title:
      "Limited editions art print publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Pattern and plan (e.g., clothing patterns) publishers",
  },
  {
    code: "513199",
    title:
      "Pattern and plan (e.g., clothing patterns) publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title:
      "Pattern and plan (e.g., clothing patterns) publishers and printing combined",
  },
  {
    code: "513199",
    title:
      "Pattern and plan (e.g., clothing patterns) publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Postcard publishers",
  },
  {
    code: "513199",
    title: "Postcard publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Postcard publishers and printing combined",
  },
  {
    code: "513199",
    title: "Postcard publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Poster publishers",
  },
  {
    code: "513199",
    title: "Poster publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Poster publishers and printing combined",
  },
  {
    code: "513199",
    title: "Poster publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Publishers (except exclusive Internet publishing), racing form",
  },
  {
    code: "513199",
    title: "Publishers, Internet racing form",
  },
  {
    code: "513199",
    title: "Publishers, racing form",
  },
  {
    code: "513199",
    title: "Racetrack program publishers",
  },
  {
    code: "513199",
    title: "Racetrack program publishers and printing combined",
  },
  {
    code: "513199",
    title: "Racetrack program publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Racing form publishers",
  },
  {
    code: "513199",
    title: "Racing form publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title: "Racing form publishers and printing combined",
  },
  {
    code: "513199",
    title: "Racing form publishers, exclusively on Internet",
  },
  {
    code: "513199",
    title: "Yearbook (e.g., high school, college, university) publishers",
  },
  {
    code: "513199",
    title:
      "Yearbook (e.g., high school, college, university) publishers (except exclusive Internet publishing)",
  },
  {
    code: "513199",
    title:
      "Yearbook (e.g., high school, college, university) publishers and printing combined",
  },
  {
    code: "513199",
    title:
      "Yearbook (e.g., high school, college, university) publishers, exclusively on Internet",
  },
  {
    code: "513210",
    title: "Applications development and publishing, except on a custom basis",
  },
  {
    code: "513210",
    title: "Applications software, computer, packaged",
  },
  {
    code: "513210",
    title: "Computer software publishers, packaged",
  },
  {
    code: "513210",
    title: "Computer software publishing and reproduction",
  },
  {
    code: "513210",
    title: "Games, computer software, publishing",
  },
  {
    code: "513210",
    title: "Gaming site publishers",
  },
  {
    code: "513210",
    title:
      "Mobile applications development and publishing, except on a custom basis",
  },
  {
    code: "513210",
    title: "Operating systems software, computer, packaged",
  },
  {
    code: "513210",
    title: "Packaged computer software publishers",
  },
  {
    code: "513210",
    title: "Programming language and compiler software publishers, packaged",
  },
  {
    code: "513210",
    title: "Publishers, packaged computer software",
  },
  {
    code: "513210",
    title: "Software computer, packaged, publishers",
  },
  {
    code: "513210",
    title: "Software publishers",
  },
  {
    code: "513210",
    title: "Software publishers, packaged",
  },
  {
    code: "513210",
    title: "Utility software, computer, packaged",
  },
  {
    code: "516110",
    title:
      "Advertising sales offices of independent and public radio broadcast stations",
  },
  {
    code: "516110",
    title: "AM radio stations",
  },
  {
    code: "516110",
    title: "Broadcasting stations (except exclusively on Internet), radio",
  },
  {
    code: "516110",
    title: "Broadcasting studio, radio station",
  },
  {
    code: "516110",
    title: "FM radio stations",
  },
  {
    code: "516110",
    title:
      "Music program distribution, broadcasting stations (except exclusively on Internet), radio",
  },
  {
    code: "516110",
    title: "Piped-in music services, radio transmitted",
  },
  {
    code: "516110",
    title:
      "Radio broadcasting (except exclusively on Internet) stations (e.g., AM, FM, shortwave)",
  },
  {
    code: "516110",
    title: "Radio stations (except exclusively on Internet)",
  },
  {
    code: "516110",
    title: "Rebroadcast radio stations (except exclusively on Internet)",
  },
  {
    code: "516120",
    title: "Broadcasting stations, television",
  },
  {
    code: "516120",
    title: "Television broadcasting stations",
  },
  {
    code: "516210",
    title: "Blog sites, Internet",
  },
  {
    code: "516210",
    title: "Broadcasting exclusively on Internet, audio",
  },
  {
    code: "516210",
    title: "Broadcasting exclusively on Internet, video",
  },
  {
    code: "516210",
    title: "Broadcasting networks, radio",
  },
  {
    code: "516210",
    title: "Broadcasting networks, television",
  },
  {
    code: "516210",
    title: "Cable broadcasting networks",
  },
  {
    code: "516210",
    title: "Cable television networks",
  },
  {
    code: "516210",
    title: "Entertainment broadcasting sites, Internet",
  },
  {
    code: "516210",
    title: "Feature syndicates (i.e., advice columns, comic, news)",
  },
  {
    code: "516210",
    title: "Gaming sites, Internet (except publishers)",
  },
  {
    code: "516210",
    title: "Internet broadcasting",
  },
  {
    code: "516210",
    title: "Internet entertainment broadcasting sites",
  },
  {
    code: "516210",
    title: "Internet radio stations",
  },
  {
    code: "516210",
    title: "Internet sports broadcasting sites",
  },
  {
    code: "516210",
    title: "Internet video broadcast sites",
  },
  {
    code: "516210",
    title: "Media (e.g., audio, video) streaming distribution services",
  },
  {
    code: "516210",
    title: "Network broadcasting service, radio",
  },
  {
    code: "516210",
    title: "Network radio broadcasting",
  },
  {
    code: "516210",
    title: "Network television broadcasting",
  },
  {
    code: "516210",
    title: "Networks, cable television",
  },
  {
    code: "516210",
    title: "News picture gathering and distributing services",
  },
  {
    code: "516210",
    title: "News reporting services",
  },
  {
    code: "516210",
    title: "News service syndicates",
  },
  {
    code: "516210",
    title: "News ticker services",
  },
  {
    code: "516210",
    title: "Newspaper feature syndicates",
  },
  {
    code: "516210",
    title: "Pay television networks",
  },
  {
    code: "516210",
    title: "Pay-per-view cable programming",
  },
  {
    code: "516210",
    title: "Radio broadcasting network services",
  },
  {
    code: "516210",
    title: "Radio broadcasting networks",
  },
  {
    code: "516210",
    title: "Radio broadcasting syndicates",
  },
  {
    code: "516210",
    title: "Road traffic reporting services",
  },
  {
    code: "516210",
    title: "Satellite radio networks",
  },
  {
    code: "516210",
    title: "Satellite television networks",
  },
  {
    code: "516210",
    title: "Social network sites, Internet",
  },
  {
    code: "516210",
    title: "Specialty television (e.g., music, sports, news) cable networks",
  },
  {
    code: "516210",
    title: "Stand-alone streaming services",
  },
  {
    code: "516210",
    title: "Subscription television networks",
  },
  {
    code: "516210",
    title: "Subscription Video on Demand (SVOD) services",
  },
  {
    code: "516210",
    title: "Syndicates, news",
  },
  {
    code: "516210",
    title: "Television broadcasting networks",
  },
  {
    code: "516210",
    title: "Television subscription services",
  },
  {
    code: "516210",
    title: "Video broadcasting, exclusively on Internet",
  },
  {
    code: "516210",
    title: "Video on Demand (VOD) programming",
  },
  {
    code: "516210",
    title: "Video on Demand (VOD) streaming distribution services",
  },
  {
    code: "516210",
    title: "Virtual Multichannel Video Programming Distributors (vMVPDs)",
  },
  {
    code: "516210",
    title: "Web broadcasting",
  },
  {
    code: "516210",
    title: "Wiki sites, Internet",
  },
  {
    code: "516210",
    title: "Wire photo services",
  },
  {
    code: "516210",
    title: "Wire services, news",
  },
  {
    code: "517111",
    title: "Cable program distribution operators",
  },
  {
    code: "517111",
    title: "Cable television distribution services",
  },
  {
    code: "517111",
    title: "Cable TV providers (except networks)",
  },
  {
    code: "517111",
    title: "Closed-circuit television (CCTV) services",
  },
  {
    code: "517111",
    title: "Direct broadcast satellite (DBS) services",
  },
  {
    code: "517111",
    title: "Direct-to-home satellite system (DTH) services",
  },
  {
    code: "517111",
    title:
      "Internet service providers, using own operated wired telecommunications infrastructure (e.g., cable, DSL)",
  },
  {
    code: "517111",
    title: "Local telephone carriers, wired",
  },
  {
    code: "517111",
    title: "Long-distance telephone carriers, wired",
  },
  {
    code: "517111",
    title: "Multichannel multipoint distribution services (MMDS)",
  },
  {
    code: "517111",
    title:
      "Online access service providers, using own operated wired telecommunications infrastructure",
  },
  {
    code: "517111",
    title: "Satellite master antenna television service (SMATV)",
  },
  {
    code: "517111",
    title: "Satellite television distribution systems",
  },
  {
    code: "517111",
    title: "Telecommunications carriers, wired",
  },
  {
    code: "517111",
    title: "Television operations, closed-circuit",
  },
  {
    code: "517111",
    title:
      "VoIP service providers, using own operated wired telecommunications infrastructure ",
  },
  {
    code: "517112",
    title: "Beeper (i.e., radio pager) communication carriers",
  },
  {
    code: "517112",
    title: "Cellular telephone communication carriers",
  },
  {
    code: "517112",
    title: "Cellular telephone service carriers",
  },
  {
    code: "517112",
    title: "Mobile telephone communication carriers (except satellite)",
  },
  {
    code: "517112",
    title: "Paging services (except satellite)",
  },
  {
    code: "517112",
    title: "Radio paging services communications carriers",
  },
  {
    code: "517112",
    title:
      "Ship-to-shore broadcasting communication carriers (except satellite)",
  },
  {
    code: "517112",
    title: "Telecommunications carriers, cellular telephone",
  },
  {
    code: "517112",
    title: "Telephone communications carriers, wireless (except satellite)",
  },
  {
    code: "517112",
    title: "Two-way paging communication carriers (except satellite)",
  },
  {
    code: "517112",
    title: "Wireless data communication carriers (except satellite)",
  },
  {
    code: "517112",
    title: "Wireless Internet service providers (except satellite)",
  },
  {
    code: "517112",
    title: "Wireless telephone communications carriers (except satellite)",
  },
  {
    code: "517121",
    title:
      "Long-distance telecommunication resellers (except satellite telecommunications)",
  },
  {
    code: "517121",
    title: "Microwave telecommunication resellers",
  },
  {
    code: "517121",
    title: "Mobile virtual network operators (MVNOs) (except agents)",
  },
  {
    code: "517121",
    title: "Pre-paid calling cards, telecommunications resellers",
  },
  {
    code: "517121",
    title:
      "Resellers, telecommunication (except satellite telecommunications and agents for wireless telecommunications services)",
  },
  {
    code: "517121",
    title:
      "Telecommunications resellers (except satellite telecommunications and agents for wireless telecommunications services)",
  },
  {
    code: "517121",
    title:
      "Telephone communications resellers (except satellite telecommunications and agents for wireless telecommunications services)",
  },
  {
    code: "517121",
    title: "Wired telecommunication resellers",
  },
  {
    code: "517121",
    title:
      "Wireless telecommunications resellers (except satellite telecommunications and agents)",
  },
  {
    code: "517122",
    title: "Agents for mobile virtual network operators (MVNOs)",
  },
  {
    code: "517122",
    title: "Agents for wireless telecommunications carriers",
  },
  {
    code: "517122",
    title:
      "Cellular telephone stores, selling cellular phone service plans on an agent basis",
  },
  {
    code: "517122",
    title:
      "Mobile phone stores, selling mobile phone service plans on an agent basis",
  },
  {
    code: "517122",
    title:
      "Wireless phone service plan sales agents, selling on behalf of wireless telecommunications carriers",
  },
  {
    code: "517122",
    title:
      "Wireless phone stores, selling wireless phone service plans on an agent basis",
  },
  {
    code: "517410",
    title: "Earth stations for satellite communication carriers",
  },
  {
    code: "517410",
    title: "Long-distance telephone satellite communication carriers",
  },
  {
    code: "517410",
    title: "Resellers, satellite telecommunication",
  },
  {
    code: "517410",
    title: "Satellite telecommunication carriers",
  },
  {
    code: "517410",
    title: "Satellite telecommunication resellers",
  },
  {
    code: "517410",
    title: "Telephone communications carriers, satellite",
  },
  {
    code: "517810",
    title:
      "Dial-up Internet service providers, using client-supplied telecommunications connections",
  },
  {
    code: "517810",
    title: "Earth stations (except satellite telecommunication carriers)",
  },
  {
    code: "517810",
    title:
      "Internet service providers, using client-supplied telecommunications (e.g., dial-up ISPs)",
  },
  {
    code: "517810",
    title:
      "Online access service providers, using client-supplied telecommunications (e.g., dial-up ISPs)",
  },
  {
    code: "517810",
    title: "Radar station operations",
  },
  {
    code: "517810",
    title: "Satellite telemetry operations on a contract or fee basis",
  },
  {
    code: "517810",
    title: "Satellite tracking stations",
  },
  {
    code: "517810",
    title:
      "Telemetry and tracking system operations on a contract or fee basis",
  },
  {
    code: "517810",
    title:
      "VoIP service providers, using client-supplied telecommunications connections",
  },
  {
    code: "518210",
    title: "Application hosting (excluding software publishing)",
  },
  {
    code: "518210",
    title: "Automated data processing services",
  },
  {
    code: "518210",
    title:
      "Cloud computing services (except software publishing and computer systems design)",
  },
  {
    code: "518210",
    title: "Cloud storage services",
  },
  {
    code: "518210",
    title:
      "Colocation services (i.e., rental of server and networking space in data centers)",
  },
  {
    code: "518210",
    title: "Computer data storage services",
  },
  {
    code: "518210",
    title: "Computer input preparation services",
  },
  {
    code: "518210",
    title: "Computer time leasing",
  },
  {
    code: "518210",
    title: "Computer time rental",
  },
  {
    code: "518210",
    title: "Computer time sharing services",
  },
  {
    code: "518210",
    title: "Computing infrastructure provision",
  },
  {
    code: "518210",
    title: "Computing platform infrastructure provision",
  },
  {
    code: "518210",
    title: "Data capture imaging services",
  },
  {
    code: "518210",
    title: "Data entry services",
  },
  {
    code: "518210",
    title: "Data processing computer services",
  },
  {
    code: "518210",
    title:
      "Data processing services (except payroll services, financial transaction processing services)",
  },
  {
    code: "518210",
    title: "Disk and diskette conversion services",
  },
  {
    code: "518210",
    title: "Disk and diskette recertification services",
  },
  {
    code: "518210",
    title: "Electronic data processing services",
  },
  {
    code: "518210",
    title: "Game server hosting providers",
  },
  {
    code: "518210",
    title: "Infrastructure as a service (IaaS)",
  },
  {
    code: "518210",
    title: "Media streaming data storage services",
  },
  {
    code: "518210",
    title: "Media streaming technical support services",
  },
  {
    code: "518210",
    title: "Microfiche recording and imaging services",
  },
  {
    code: "518210",
    title: "Microfilm recording and imaging services",
  },
  {
    code: "518210",
    title: "Optical scanning services",
  },
  {
    code: "518210",
    title: "Platform as a service (PaaS)",
  },
  {
    code: "518210",
    title: "Scanning services, optical",
  },
  {
    code: "518210",
    title: "Video and audio technical streaming support services",
  },
  {
    code: "518210",
    title: "Video tape and film stock technical streaming support services",
  },
  {
    code: "518210",
    title: "Virtual currency (cryptocurrency) mining",
  },
  {
    code: "518210",
    title: "Web hosting (excluding software publishing)",
  },
  {
    code: "519210",
    title: "Archives",
  },
  {
    code: "519210",
    title: "Bookmobiles",
  },
  {
    code: "519210",
    title: "Centers for documentation (i.e., archives)",
  },
  {
    code: "519210",
    title: "Circulating libraries",
  },
  {
    code: "519210",
    title: "Film archives",
  },
  {
    code: "519210",
    title: "Lending libraries",
  },
  {
    code: "519210",
    title:
      "Libraries (except motion picture stock footage, motion picture commercial distribution)",
  },
  {
    code: "519210",
    title: "Motion picture film libraries, archives",
  },
  {
    code: "519210",
    title: "Music archives",
  },
  {
    code: "519210",
    title: "Reference libraries",
  },
  {
    code: "519290",
    title: "Clipping services, news",
  },
  {
    code: "519290",
    title: "Internet search portals",
  },
  {
    code: "519290",
    title: "Internet search Web sites",
  },
  {
    code: "519290",
    title: "News clipping services",
  },
  {
    code: "519290",
    title: "Portals, web search",
  },
  {
    code: "519290",
    title: "Press clipping services",
  },
  {
    code: "519290",
    title: "Search portals, Internet",
  },
  {
    code: "519290",
    title: "Stock photo agencies",
  },
  {
    code: "519290",
    title: "Telephone-based recorded information services",
  },
  {
    code: "519290",
    title: "Title search services (except real estate)",
  },
  {
    code: "519290",
    title: "Web search portals",
  },
  {
    code: "521110",
    title: "Banking, central",
  },
  {
    code: "521110",
    title: "Banks, Federal Reserve",
  },
  {
    code: "521110",
    title: "Branches, Federal Reserve Bank",
  },
  {
    code: "521110",
    title: "Central bank, monetary authorities",
  },
  {
    code: "521110",
    title: "Check clearing activities of the central bank",
  },
  {
    code: "521110",
    title: "Federal Reserve Banks or Branches",
  },
  {
    code: "521110",
    title: "Financial transactions processing of the central bank",
  },
  {
    code: "521110",
    title: "Monetary authorities, central bank",
  },
  {
    code: "522110",
    title: "Banks, commercial",
  },
  {
    code: "522110",
    title: "Branches of foreign banks",
  },
  {
    code: "522110",
    title: "Commercial banking",
  },
  {
    code: "522110",
    title: "Commercial banks",
  },
  {
    code: "522110",
    title: "Depository trust companies",
  },
  {
    code: "522110",
    title: "National commercial banks",
  },
  {
    code: "522110",
    title: "State commercial banks",
  },
  {
    code: "522130",
    title: "Corporate credit unions",
  },
  {
    code: "522130",
    title: "Credit unions",
  },
  {
    code: "522130",
    title: "Federal credit unions",
  },
  {
    code: "522130",
    title: "State credit unions",
  },
  {
    code: "522130",
    title: "Unions, credit",
  },
  {
    code: "522180",
    title: "Associations, savings and loan",
  },
  {
    code: "522180",
    title: "Banks, industrial (i.e., known as), depository",
  },
  {
    code: "522180",
    title: "Banks, private (i.e., unincorporated)",
  },
  {
    code: "522180",
    title: "Banks, savings",
  },
  {
    code: "522180",
    title: "Federal savings and loan associations (S&L)",
  },
  {
    code: "522180",
    title: "Federal savings banks",
  },
  {
    code: "522180",
    title: "Industrial banks (i.e., known as), depository",
  },
  {
    code: "522180",
    title: "Institutions, savings",
  },
  {
    code: "522180",
    title: "Morris Plans (i.e., known as), depository",
  },
  {
    code: "522180",
    title: "Mutual savings banks",
  },
  {
    code: "522180",
    title: "Plans, Morris (i.e., known as), depository",
  },
  {
    code: "522180",
    title: "Private banks (i.e., unincorporated)",
  },
  {
    code: "522180",
    title: "Savings and loan associations (S&L)",
  },
  {
    code: "522180",
    title: "Savings banks",
  },
  {
    code: "522180",
    title: "Savings institutions",
  },
  {
    code: "522180",
    title: "State savings and loan associations",
  },
  {
    code: "522180",
    title: "State savings banks",
  },
  {
    code: "522210",
    title: "Banks, credit card",
  },
  {
    code: "522210",
    title: "Charge card issuing",
  },
  {
    code: "522210",
    title: "Credit card banks",
  },
  {
    code: "522210",
    title: "Credit card issuing",
  },
  {
    code: "522210",
    title: "Issuing, credit card",
  },
  {
    code: "522220",
    title: "Automobile finance leasing companies",
  },
  {
    code: "522220",
    title: "Automobile financing",
  },
  {
    code: "522220",
    title:
      "Commercial and inventory financing (except international trade financing)",
  },
  {
    code: "522220",
    title: "Equipment finance leasing",
  },
  {
    code: "522220",
    title: "Financing, sales",
  },
  {
    code: "522220",
    title: "Installment sales financing",
  },
  {
    code: "522220",
    title: "Insurance premium financing",
  },
  {
    code: "522220",
    title: "Leasing in combination with sales financing",
  },
  {
    code: "522220",
    title: "Machinery finance leasing",
  },
  {
    code: "522220",
    title: "Sales financing",
  },
  {
    code: "522220",
    title: "Truck finance leasing",
  },
  {
    code: "522291",
    title: "Consumer finance companies (i.e., unsecured cash loans)",
  },
  {
    code: "522291",
    title: "Consumer lending",
  },
  {
    code: "522291",
    title: "Finance companies (i.e., unsecured cash loans)",
  },
  {
    code: "522291",
    title: "Loan companies (i.e., consumer, personal, small, student)",
  },
  {
    code: "522291",
    title: "Personal credit institutions (i.e., unsecured cash loans)",
  },
  {
    code: "522291",
    title: "Personal finance companies (i.e., unsecured cash loans)",
  },
  {
    code: "522291",
    title: "Small loan companies (i.e., unsecured cash loans)",
  },
  {
    code: "522291",
    title: "Student loan companies",
  },
  {
    code: "522292",
    title: "Construction lending",
  },
  {
    code: "522292",
    title: "Farm mortgage lending",
  },
  {
    code: "522292",
    title: "Federal Land Banks",
  },
  {
    code: "522292",
    title: "Home equity credit lending",
  },
  {
    code: "522292",
    title:
      "Loan correspondents (i.e., lending funds with real estate as collateral)",
  },
  {
    code: "522292",
    title: "Mortgage banking (i.e., nondepository mortgage lending)",
  },
  {
    code: "522292",
    title: "Mortgage companies",
  },
  {
    code: "522292",
    title: "Real estate credit lending",
  },
  {
    code: "522292",
    title: "Reverse mortgage lending",
  },
  {
    code: "522299",
    title: "Agencies of foreign banks (i.e., trade financing)",
  },
  {
    code: "522299",
    title: "Agreement corporations (i.e., international trade financing)",
  },
  {
    code: "522299",
    title:
      "Agricultural credit institutions, making loans or extending credit (except real estate, sales financing)",
  },
  {
    code: "522299",
    title: "Agricultural lending (except real estate, sales financing)",
  },
  {
    code: "522299",
    title: "Banks, industrial (i.e., known as), nondepository",
  },
  {
    code: "522299",
    title: "Banks, trade (i.e., international trade financing)",
  },
  {
    code: "522299",
    title: "Car title lending",
  },
  {
    code: "522299",
    title: "Collateralized mortgage obligation (CMO) issuing, private",
  },
  {
    code: "522299",
    title: "Commodity Credit Corporation",
  },
  {
    code: "522299",
    title: "Edge Act corporations",
  },
  {
    code: "522299",
    title: "Export trading companies (i.e., international trade financing)",
  },
  {
    code: "522299",
    title: "Export-Import banks",
  },
  {
    code: "522299",
    title: "Factoring accounts receivable",
  },
  {
    code: "522299",
    title: "Federal Agricultural Mortgage Corporation",
  },
  {
    code: "522299",
    title: "Federal Home Loan Banks (FHLB)",
  },
  {
    code: "522299",
    title: "Federal Home Loan Mortgage Corporation (FHLMC)",
  },
  {
    code: "522299",
    title: "Federal Intermediate Credit Bank",
  },
  {
    code: "522299",
    title: "Federal National Mortgage Association (FNMA)",
  },
  {
    code: "522299",
    title: "FHLMC (Federal Home Loan Mortgage Corporation)",
  },
  {
    code: "522299",
    title: "Financing, secondary market",
  },
  {
    code: "522299",
    title: "FNMA (Federal National Mortgage Association)",
  },
  {
    code: "522299",
    title: "GNMA (Government National Mortgage Association)",
  },
  {
    code: "522299",
    title: "Government National Mortgage Association (GNMA)",
  },
  {
    code: "522299",
    title:
      "Government-sponsored enterprises providing secondary market financing",
  },
  {
    code: "522299",
    title: "Industrial banks (i.e., known as), nondepository",
  },
  {
    code: "522299",
    title: "Industrial loan companies, nondepository",
  },
  {
    code: "522299",
    title: "International trade financing",
  },
  {
    code: "522299",
    title: "Morris Plans (i.e., known as), nondepository",
  },
  {
    code: "522299",
    title: "National Credit Union Administration (NCUA)",
  },
  {
    code: "522299",
    title: "Pawnshops",
  },
  {
    code: "522299",
    title: "Plans, Morris (i.e., known as), nondepository",
  },
  {
    code: "522299",
    title: "Purchasing of accounts receivable",
  },
  {
    code: "522299",
    title: "Real estate mortgage investment conduits (REMICs) issuing, private",
  },
  {
    code: "522299",
    title: "REMICs (real estate mortgage investment conduits) issuing, private",
  },
  {
    code: "522299",
    title: "Repackaging loans for sale to others (i.e., private conduits)",
  },
  {
    code: "522299",
    title:
      "Secondary market financing (i.e., buying, pooling, repackaging loans for sale to others)",
  },
  {
    code: "522299",
    title: "Short-term inventory credit lending",
  },
  {
    code: "522299",
    title: "SLMA (Student Loan Marketing Association)",
  },
  {
    code: "522299",
    title: "Student Loan Marketing Association (SLMA)",
  },
  {
    code: "522299",
    title: "Trade banks (i.e., international trade financing)",
  },
  {
    code: "522299",
    title: "Trade financing, international",
  },
  {
    code: "522310",
    title: "Agencies, loan",
  },
  {
    code: "522310",
    title: "Brokerages, loan",
  },
  {
    code: "522310",
    title: "Brokerages, mortgage",
  },
  {
    code: "522310",
    title: "Brokers' offices, loan",
  },
  {
    code: "522310",
    title: "Brokers' offices, mortgage",
  },
  {
    code: "522310",
    title: "Loan brokerages",
  },
  {
    code: "522310",
    title: "Loan brokers' or agents' offices (i.e., independent)",
  },
  {
    code: "522310",
    title: "Mortgage brokerages",
  },
  {
    code: "522310",
    title: "Mortgage brokers' or agents' offices (i.e., independent)",
  },
  {
    code: "522320",
    title: "Automated clearinghouses, bank or check (except central bank)",
  },
  {
    code: "522320",
    title:
      "Automated Teller Machine (ATM) or Automated Loan Machine (ALM) network operation",
  },
  {
    code: "522320",
    title: "Bank clearinghouse associations",
  },
  {
    code: "522320",
    title: "Central reserve financial institutions (except central bank)",
  },
  {
    code: "522320",
    title: "Check clearing services (except central banks)",
  },
  {
    code: "522320",
    title: "Check clearinghouse services (except central banks)",
  },
  {
    code: "522320",
    title: "Check validation services",
  },
  {
    code: "522320",
    title: "Clearinghouses, bank or check",
  },
  {
    code: "522320",
    title: "Credit card processing services",
  },
  {
    code: "522320",
    title: "Electronic financial payment services",
  },
  {
    code: "522320",
    title:
      "Electronic funds transfer services, including peer-to-peer payment services",
  },
  {
    code: "522320",
    title: "Financial transactions processing (except central bank)",
  },
  {
    code: "522320",
    title: "Processing financial transactions",
  },
  {
    code: "522320",
    title: "Reserve and liquidity services (except central bank)",
  },
  {
    code: "522390",
    title: "Check cashing services",
  },
  {
    code: "522390",
    title: "Loan servicing",
  },
  {
    code: "522390",
    title: "Money order issuance services",
  },
  {
    code: "522390",
    title: "Money transmission services",
  },
  {
    code: "522390",
    title: "Payday lending services",
  },
  {
    code: "522390",
    title: "Travelers' check issuance services",
  },
  {
    code: "523150",
    title: "Banking, investment",
  },
  {
    code: "523150",
    title: "Bond brokerages",
  },
  {
    code: "523150",
    title:
      "Bond dealing (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Brokerages, securities",
  },
  {
    code: "523150",
    title: "Certificate of deposit (CD) brokers' offices",
  },
  {
    code: "523150",
    title: "Commercial note brokers' offices",
  },
  {
    code: "523150",
    title:
      "Commercial paper dealing (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Discount securities brokerages",
  },
  {
    code: "523150",
    title: "Investment banking",
  },
  {
    code: "523150",
    title: "Making markets for securities",
  },
  {
    code: "523150",
    title: "Market making for securities",
  },
  {
    code: "523150",
    title: "Mutual fund agencies (i.e., brokerages)",
  },
  {
    code: "523150",
    title: "Mutual fund agents' (i.e., brokers') offices",
  },
  {
    code: "523150",
    title: "Online securities brokerages",
  },
  {
    code: "523150",
    title:
      "Paper, dealing of commercial (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Securities brokerages",
  },
  {
    code: "523150",
    title: "Securities brokers' offices",
  },
  {
    code: "523150",
    title:
      "Securities dealers (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title:
      "Securities dealing (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title:
      "Securities distributing (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Securities floor brokers",
  },
  {
    code: "523150",
    title:
      "Securities floor traders (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Securities flotation companies",
  },
  {
    code: "523150",
    title:
      "Securities originating (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title:
      "Securities trading (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Securities underwriting",
  },
  {
    code: "523150",
    title: "Stock brokerages",
  },
  {
    code: "523150",
    title: "Stock brokers' offices",
  },
  {
    code: "523150",
    title: "Stock options brokerages",
  },
  {
    code: "523150",
    title:
      "Stock options dealing (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title:
      "Trading securities (i.e., acting as a principal in dealing securities to investors)",
  },
  {
    code: "523150",
    title: "Underwriting securities",
  },
  {
    code: "523160",
    title: "Brokerages, commodity contracts",
  },
  {
    code: "523160",
    title: "Commodity contract pool operators",
  },
  {
    code: "523160",
    title: "Commodity contract trading companies",
  },
  {
    code: "523160",
    title: "Commodity contracts brokerages",
  },
  {
    code: "523160",
    title: "Commodity contracts brokers' offices",
  },
  {
    code: "523160",
    title:
      "Commodity contracts dealing (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title: "Commodity contracts floor brokers",
  },
  {
    code: "523160",
    title:
      "Commodity contracts floor traders (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title:
      "Commodity contracts floor trading (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title: "Commodity contracts options brokerages",
  },
  {
    code: "523160",
    title:
      "Commodity contracts options dealing (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title:
      "Commodity contracts traders (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title: "Commodity futures brokerages",
  },
  {
    code: "523160",
    title: "Financial futures brokerages",
  },
  {
    code: "523160",
    title: "Foreign currency exchange brokering services",
  },
  {
    code: "523160",
    title:
      "Foreign currency exchange dealing (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title: "Foreign currency exchange services (i.e., selling to the public)",
  },
  {
    code: "523160",
    title: "Futures commodity contracts brokerages",
  },
  {
    code: "523160",
    title: "Futures commodity contracts brokers' offices",
  },
  {
    code: "523160",
    title:
      "Futures commodity contracts dealing (i.e., acting as a principal in dealing commodities to investors)",
  },
  {
    code: "523160",
    title: "Trading companies, commodity contracts",
  },
  {
    code: "523160",
    title: "Virtual currency (cryptocurrency) brokering",
  },
  {
    code: "523160",
    title: "Virtual currency (cryptocurrency) dealing",
  },
  {
    code: "523160",
    title: "Virtual currency exchange services (i.e., selling to the public)",
  },
  {
    code: "523210",
    title: "Commodity contracts exchanges",
  },
  {
    code: "523210",
    title: "Exchanges, commodity contracts",
  },
  {
    code: "523210",
    title: "Exchanges, securities",
  },
  {
    code: "523210",
    title: "Futures commodity contracts exchanges",
  },
  {
    code: "523210",
    title: "Securities exchanges",
  },
  {
    code: "523210",
    title: "Stock exchanges",
  },
  {
    code: "523210",
    title: "Stock or commodity options exchanges",
  },
  {
    code: "523910",
    title: "Individuals investing in financial contracts on own account",
  },
  {
    code: "523910",
    title: "Investment clubs",
  },
  {
    code: "523910",
    title:
      "Mineral royalties or leases dealing (i.e., acting as a principal in dealing royalties or leases to investors)",
  },
  {
    code: "523910",
    title: "Mortgage dealers, buying and selling",
  },
  {
    code: "523910",
    title:
      "Oil royalty dealing (i.e., acting as a principal in dealing royalties to investors)",
  },
  {
    code: "523910",
    title: "Securities speculators for own account",
  },
  {
    code: "523910",
    title:
      "Tax liens dealing (i.e., acting as a principal in dealing tax liens to investors)",
  },
  {
    code: "523910",
    title: "Venture capital companies",
  },
  {
    code: "523910",
    title: "Viatical settlement companies",
  },
  {
    code: "523940",
    title: "Certified financial planners, customized, fees paid by client",
  },
  {
    code: "523940",
    title:
      "Financial investment advice services, customized, fees paid by client",
  },
  {
    code: "523940",
    title: "Financial planning services, customized, fees paid by client",
  },
  {
    code: "523940",
    title:
      "Investment advice consulting services, customized, fees paid by client",
  },
  {
    code: "523940",
    title:
      "Investment advice counseling services, customized, fees paid by client",
  },
  {
    code: "523940",
    title: "Investment advisory services, customized, fees paid by client",
  },
  {
    code: "523940",
    title: "Investment management",
  },
  {
    code: "523940",
    title: "Managing investment funds",
  },
  {
    code: "523940",
    title: "Managing mutual funds",
  },
  {
    code: "523940",
    title: "Managing personal investment trusts",
  },
  {
    code: "523940",
    title: "Managing trusts",
  },
  {
    code: "523940",
    title: "Mutual fund managing",
  },
  {
    code: "523940",
    title: "Pension fund managing",
  },
  {
    code: "523940",
    title: "Personal investments trusts, managing",
  },
  {
    code: "523940",
    title: "Portfolio fund managing",
  },
  {
    code: "523940",
    title: "Private equity fund managing",
  },
  {
    code: "523991",
    title: "Administrators of private estates",
  },
  {
    code: "523991",
    title: "Bank trust offices",
  },
  {
    code: "523991",
    title: "Escrow agencies (except real estate)",
  },
  {
    code: "523991",
    title: "Fiduciary agencies (except real estate)",
  },
  {
    code: "523991",
    title: "Personal investments trust administration",
  },
  {
    code: "523991",
    title: "Securities custodians",
  },
  {
    code: "523991",
    title: "Trust administration, personal investment",
  },
  {
    code: "523991",
    title: "Trust companies, nondepository",
  },
  {
    code: "523999",
    title: "Business start-up fundraising using a crowdfunding platform",
  },
  {
    code: "523999",
    title: "Clearinghouses, commodity exchange or securities exchange",
  },
  {
    code: "523999",
    title: "Deposit brokers",
  },
  {
    code: "523999",
    title: "Exchange clearinghouses, commodities or securities",
  },
  {
    code: "523999",
    title: "Gas lease brokers' offices",
  },
  {
    code: "523999",
    title: "Oil lease brokers' offices",
  },
  {
    code: "523999",
    title: "Protective committees, security holders",
  },
  {
    code: "523999",
    title: "Quotation services, securities",
  },
  {
    code: "523999",
    title: "Quotation services, stock",
  },
  {
    code: "523999",
    title: "Securities holders' protective services",
  },
  {
    code: "523999",
    title: "Securities transfer agencies",
  },
  {
    code: "523999",
    title: "Stock quotation services",
  },
  {
    code: "523999",
    title: "Stock transfer agencies",
  },
  {
    code: "523999",
    title: "Transfer agencies, securities",
  },
  {
    code: "523999",
    title: "Virtual currency trading exchange clearinghouses",
  },
  {
    code: "524113",
    title: "Accidental death and dismemberment insurance carriers, direct",
  },
  {
    code: "524113",
    title: "Accidental death and dismemberment insurance underwriting, direct",
  },
  {
    code: "524113",
    title: "Annuities underwriting",
  },
  {
    code: "524113",
    title: "Cooperative life insurance organizations",
  },
  {
    code: "524113",
    title: "Credit life insurance carriers, direct",
  },
  {
    code: "524113",
    title: "Disability insurance carriers, direct",
  },
  {
    code: "524113",
    title: "Disability insurance underwriting, direct",
  },
  {
    code: "524113",
    title: "Fraternal life insurance organizations",
  },
  {
    code: "524113",
    title: "Insurance carriers, disability, direct",
  },
  {
    code: "524113",
    title: "Insurance carriers, life, direct",
  },
  {
    code: "524113",
    title: "Insurance underwriting, disability, direct",
  },
  {
    code: "524113",
    title: "Insurance underwriting, life, direct",
  },
  {
    code: "524113",
    title: "Life insurance carriers, direct",
  },
  {
    code: "524113",
    title: "Savings bank life insurance carriers, direct",
  },
  {
    code: "524114",
    title: "Dental insurance carriers, direct",
  },
  {
    code: "524114",
    title: "Group hospitalization plans without providing health care services",
  },
  {
    code: "524114",
    title: "Health insurance carriers, direct",
  },
  {
    code: "524114",
    title:
      "Hospital and medical service plans, direct, without providing health care services",
  },
  {
    code: "524114",
    title:
      "Hospitalization insurance carriers, direct, without providing health care services",
  },
  {
    code: "524114",
    title: "Insurance carriers, health, direct",
  },
  {
    code: "524114",
    title: "Insurance underwriting, health and medical, direct",
  },
  {
    code: "524114",
    title: "Medical insurance carriers, direct",
  },
  {
    code: "524114",
    title: "Medical service plans without providing health care services",
  },
  {
    code: "524126",
    title: "Agricultural (i.e., crop, livestock) insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Automobile insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Bonding, fidelity or surety insurance, direct",
  },
  {
    code: "524126",
    title: "Burglary and theft insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Casualty insurance carriers, direct",
  },
  {
    code: "524126",
    title:
      "Credit and other financial responsibility insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Crop insurance carrier, direct",
  },
  {
    code: "524126",
    title: "Fidelity insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Fire insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Guaranteeing international trade loans",
  },
  {
    code: "524126",
    title: "Homeowners' insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Insurance carriers, fidelity, direct",
  },
  {
    code: "524126",
    title: "Insurance carriers, property and casualty, direct",
  },
  {
    code: "524126",
    title: "Insurance carriers, surety, direct",
  },
  {
    code: "524126",
    title: "Insurance underwriting, property and casualty, direct",
  },
  {
    code: "524126",
    title: "Liability insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Malpractice insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Marine insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Mortgage guaranty insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Plate glass insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Property and casualty insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Property damage insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Surety insurance carriers, direct",
  },
  {
    code: "524126",
    title: "Workers' compensation insurance underwriting",
  },
  {
    code: "524127",
    title: "Guaranteeing titles",
  },
  {
    code: "524127",
    title: "Insurance carriers, title, direct",
  },
  {
    code: "524127",
    title: "Insurance underwriting, title, direct",
  },
  {
    code: "524127",
    title: "Real estate title insurance carriers, direct",
  },
  {
    code: "524127",
    title: "Title insurance carriers, real estate, direct",
  },
  {
    code: "524128",
    title: "Bank deposit insurance carriers, direct",
  },
  {
    code: "524128",
    title: "Burial insurance carriers, direct",
  },
  {
    code: "524128",
    title: "Contact lens insurance, direct",
  },
  {
    code: "524128",
    title: "Deposit or share insurance carriers, direct",
  },
  {
    code: "524128",
    title: "Funeral insurance carriers, direct",
  },
  {
    code: "524128",
    title: "Homeowners' warranty insurance carriers, direct",
  },
  {
    code: "524128",
    title: "Pet health insurance carriers, direct",
  },
  {
    code: "524128",
    title: "Product warranty insurance carriers, direct",
  },
  {
    code: "524128",
    title:
      "Warranty insurance carriers (e.g., appliance, automobile, homeowners', product), direct",
  },
  {
    code: "524130",
    title: "Accidental and health reinsurance carriers",
  },
  {
    code: "524130",
    title: "Life reinsurance carriers",
  },
  {
    code: "524130",
    title: "Marine reinsurance carriers",
  },
  {
    code: "524130",
    title: "Medical reinsurance carriers",
  },
  {
    code: "524130",
    title: "Property and casualty reinsurance carriers",
  },
  {
    code: "524130",
    title: "Reinsurance carriers",
  },
  {
    code: "524210",
    title: "Agencies, insurance",
  },
  {
    code: "524210",
    title: "Brokerages, insurance",
  },
  {
    code: "524210",
    title: "Brokers' offices, insurance",
  },
  {
    code: "524210",
    title: "Insurance agencies",
  },
  {
    code: "524210",
    title: "Insurance brokerages",
  },
  {
    code: "524210",
    title: "Life insurance agencies",
  },
  {
    code: "524291",
    title: "Cause-of-loss investigators, insurance",
  },
  {
    code: "524291",
    title: "Claims adjusting, insurance",
  },
  {
    code: "524291",
    title: "Fire investigators",
  },
  {
    code: "524291",
    title: "Insurance claims adjusting",
  },
  {
    code: "524291",
    title: "Insurance claims investigation services",
  },
  {
    code: "524291",
    title: "Insurance settlement offices",
  },
  {
    code: "524291",
    title: "Loss control consultants",
  },
  {
    code: "524292",
    title: "Claims processing services, insurance, third party",
  },
  {
    code: "524292",
    title:
      "Employee benefit plans, third party administrative processing services",
  },
  {
    code: "524292",
    title: "Insurance claims processing services, third party",
  },
  {
    code: "524292",
    title:
      "Insurance fund, third party administrative services (except claims adjusting only)",
  },
  {
    code: "524292",
    title:
      "Insurance plan administrative services (except claims adjusting only), third party",
  },
  {
    code: "524292",
    title: "Pension fund, third party administrative services",
  },
  {
    code: "524292",
    title: "Pharmacy Benefit Management (PBM) services",
  },
  {
    code: "524298",
    title: "Actuarial services, insurance",
  },
  {
    code: "524298",
    title: "Insurance actuarial services",
  },
  {
    code: "524298",
    title: "Insurance advisory services",
  },
  {
    code: "524298",
    title: "Insurance coverage consulting services",
  },
  {
    code: "524298",
    title: "Insurance exchanges",
  },
  {
    code: "524298",
    title: "Insurance investigation services (except claims investigation)",
  },
  {
    code: "524298",
    title: "Insurance loss prevention services",
  },
  {
    code: "524298",
    title: "Insurance ratemaking services",
  },
  {
    code: "524298",
    title: "Insurance reporting services",
  },
  {
    code: "524298",
    title: "Insurance underwriters laboratories and standards services",
  },
  {
    code: "524298",
    title: "Medical cost evaluation services",
  },
  {
    code: "524298",
    title: "Ratemaking services, insurance",
  },
  {
    code: "525110",
    title: "Employee benefit pension plans",
  },
  {
    code: "525110",
    title: "Funds, employee benefit pension",
  },
  {
    code: "525110",
    title: "Funds, pension",
  },
  {
    code: "525110",
    title: "Pension funds",
  },
  {
    code: "525110",
    title: "Pension plans (e.g., employee benefit, retirement)",
  },
  {
    code: "525110",
    title: "Plans, pension",
  },
  {
    code: "525110",
    title: "Retirement pension plans",
  },
  {
    code: "525110",
    title: "Union pension funds",
  },
  {
    code: "525120",
    title: "Employee benefit plans (except pension)",
  },
  {
    code: "525120",
    title: "Funds, health and welfare",
  },
  {
    code: "525120",
    title: "Health and welfare funds",
  },
  {
    code: "525120",
    title: "Plans, health- and welfare-related employee benefit",
  },
  {
    code: "525120",
    title: "Union health and welfare funds",
  },
  {
    code: "525190",
    title: "Compensation, workers, insurance funds",
  },
  {
    code: "525190",
    title: "Funds, self-insurance (except employee benefit funds)",
  },
  {
    code: "525190",
    title: "Self-insurance funds (except employee benefit funds)",
  },
  {
    code: "525190",
    title: "Workers' compensation insurance funds",
  },
  {
    code: "525910",
    title: "Funds, mutual, open-ended",
  },
  {
    code: "525910",
    title: "Investment funds, open-ended",
  },
  {
    code: "525910",
    title: "Management investment offices, open-ended",
  },
  {
    code: "525910",
    title: "Money market mutual funds, open-ended",
  },
  {
    code: "525910",
    title: "Mutual funds, open-ended",
  },
  {
    code: "525920",
    title: "Bankruptcy estates",
  },
  {
    code: "525920",
    title: "Personal estates (i.e., managing assets)",
  },
  {
    code: "525920",
    title: "Personal investment trusts",
  },
  {
    code: "525920",
    title: "Personal trusts",
  },
  {
    code: "525920",
    title: "Private estates (i.e., administering on behalf of beneficiaries)",
  },
  {
    code: "525920",
    title: "Settlement trust funds",
  },
  {
    code: "525920",
    title: "Testamentary trusts",
  },
  {
    code: "525920",
    title: "Trusts, estates, and agency accounts",
  },
  {
    code: "525990",
    title: "Closed-end investment funds",
  },
  {
    code: "525990",
    title: "CMOs (collateralized mortgage obligations)",
  },
  {
    code: "525990",
    title: "Collateralized mortgage obligations (CMOs)",
  },
  {
    code: "525990",
    title: "Face-amount certificate funds",
  },
  {
    code: "525990",
    title: "Funds, mutual, closed-end",
  },
  {
    code: "525990",
    title: "Investment funds, closed-end",
  },
  {
    code: "525990",
    title: "Money market mutual funds, closed-end",
  },
  {
    code: "525990",
    title: "Mortgage real estate investment trusts (REITs)",
  },
  {
    code: "525990",
    title: "Mortgage-backed securities",
  },
  {
    code: "525990",
    title: "Mutual funds, closed-end",
  },
  {
    code: "525990",
    title: "Pooled investment vehicle (PIV) funds, closed-end",
  },
  {
    code: "525990",
    title: "Profit-sharing funds",
  },
  {
    code: "525990",
    title: "Real estate mortgage investment conduits (REMICs)",
  },
  {
    code: "525990",
    title: "REMICs (real estate mortgage investment conduits)",
  },
  {
    code: "525990",
    title: "Special purpose financial vehicles",
  },
  {
    code: "525990",
    title: "Unit investment trust funds",
  },
  {
    code: "531110",
    title: "Apartment building rental or leasing",
  },
  {
    code: "531110",
    title: "Apartment hotel rental or leasing",
  },
  {
    code: "531110",
    title: "Apartment rental or leasing",
  },
  {
    code: "531110",
    title: "Building, apartment, rental or leasing",
  },
  {
    code: "531110",
    title: "Building, residential, rental or leasing",
  },
  {
    code: "531110",
    title: "Cottage rental or leasing",
  },
  {
    code: "531110",
    title: "Duplex houses (i.e., single-family) rental or leasing",
  },
  {
    code: "531110",
    title: "Dwelling rental or leasing",
  },
  {
    code: "531110",
    title:
      "Equity real estate investment trusts (REITs), primarily leasing residential buildings and dwellings",
  },
  {
    code: "531110",
    title: "Houses rental or leasing",
  },
  {
    code: "531110",
    title: "Housing authorities owning and operating residential buildings",
  },
  {
    code: "531110",
    title: "Lessors of residential buildings and dwellings",
  },
  {
    code: "531110",
    title: "Mobile (manufactured) home rental or leasing, on-site",
  },
  {
    code: "531110",
    title: "Real estate rental or leasing of residential building",
  },
  {
    code: "531110",
    title: "Residential building rental or leasing",
  },
  {
    code: "531110",
    title: "Residential hotel rental or leasing",
  },
  {
    code: "531110",
    title: "Retirement hotel rental or leasing",
  },
  {
    code: "531110",
    title: "Single-family house rental or leasing",
  },
  {
    code: "531110",
    title: "Town house rental or leasing",
  },
  {
    code: "531120",
    title: "Amusement facility rental or leasing",
  },
  {
    code: "531120",
    title: "Arena, no promotion of events, rental or leasing",
  },
  {
    code: "531120",
    title: "Auditorium rental or leasing",
  },
  {
    code: "531120",
    title: "Bank building rental or leasing",
  },
  {
    code: "531120",
    title: "Banquet hall rental or leasing",
  },
  {
    code: "531120",
    title: "Building, nonresidential (except miniwarehouse), rental or leasing",
  },
  {
    code: "531120",
    title: "Commercial building rental or leasing",
  },
  {
    code: "531120",
    title: "Concert hall, no promotion of events, rental or leasing",
  },
  {
    code: "531120",
    title: "Conference center, no promotion of events, rental or leasing",
  },
  {
    code: "531120",
    title: "Convention center, no promotion of events, rental or leasing",
  },
  {
    code: "531120",
    title: "Coworking space rental or leasing",
  },
  {
    code: "531120",
    title: "Dance hall rental or leasing",
  },
  {
    code: "531120",
    title: "Dock and associated building rental or leasing",
  },
  {
    code: "531120",
    title:
      "Equity real estate investment trusts (REITs), primarily leasing nonresidential buildings (except miniwarehouses)",
  },
  {
    code: "531120",
    title: "Executive suites (i.e., full service office space provision)",
  },
  {
    code: "531120",
    title: "Exhibition hall, no promotion of events, rental or leasing",
  },
  {
    code: "531120",
    title: "Flea market space, under roof, rental or leasing",
  },
  {
    code: "531120",
    title: "Full service office space provision",
  },
  {
    code: "531120",
    title: "Hall and banquet room, nonresidential, rental or leasing",
  },
  {
    code: "531120",
    title: "Hall, nonresidential, rental or leasing",
  },
  {
    code: "531120",
    title: "Hotel building rental or leasing, not operating hotel",
  },
  {
    code: "531120",
    title: "Industrial building rental or leasing",
  },
  {
    code: "531120",
    title: "Insurance building rental or leasing",
  },
  {
    code: "531120",
    title: "Lessors of nonresidential buildings (except miniwarehouses)",
  },
  {
    code: "531120",
    title:
      "Mall property operation (i.e., not operating contained businesses) rental or leasing",
  },
  {
    code: "531120",
    title: "Manufacturing building rental or leasing",
  },
  {
    code: "531120",
    title: "Medical building rental or leasing",
  },
  {
    code: "531120",
    title: "Meeting hall and room rental or leasing",
  },
  {
    code: "531120",
    title: "Mobile office building rental or leasing, on-site",
  },
  {
    code: "531120",
    title: "Motel building rental or leasing, not operating motel",
  },
  {
    code: "531120",
    title: "Nonresidential building (except miniwarehouse) rental or leasing",
  },
  {
    code: "531120",
    title: "Office building rental or leasing",
  },
  {
    code: "531120",
    title: "Piers and associated building rental or leasing",
  },
  {
    code: "531120",
    title: "Professional office building rental or leasing",
  },
  {
    code: "531120",
    title:
      "Real estate rental or leasing of nonresidential building (except miniwarehouse)",
  },
  {
    code: "531120",
    title: "Reception hall rental or leasing",
  },
  {
    code: "531120",
    title: "Shared workspace provision",
  },
  {
    code: "531120",
    title:
      "Shopping center (i.e., not operating contained businesses) rental or leasing",
  },
  {
    code: "531120",
    title: "Stadium rental or leasing without promotion of events",
  },
  {
    code: "531120",
    title: "Theater property rental or leasing, not operating theater",
  },
  {
    code: "531130",
    title:
      "Equity real estate investment trusts (REITs), primarily leasing miniwarehouses and self-storage units",
  },
  {
    code: "531130",
    title: "Lessors of miniwarehouses",
  },
  {
    code: "531130",
    title: "Lessors of self-storage units",
  },
  {
    code: "531130",
    title: "Miniwarehouse rental or leasing",
  },
  {
    code: "531130",
    title:
      "Real estate rental or leasing of miniwarehouses and self-storage units",
  },
  {
    code: "531130",
    title: "Self-storage unit rental or leasing",
  },
  {
    code: "531130",
    title: "Self-storage warehousing",
  },
  {
    code: "531130",
    title: "U-lock storage",
  },
  {
    code: "531130",
    title: "Warehousing, self-storage",
  },
  {
    code: "531190",
    title: "Agricultural property rental or leasing ",
  },
  {
    code: "531190",
    title: "Airport leasing, not operating airport, rental or leasing",
  },
  {
    code: "531190",
    title:
      "Equity real estate investment trusts (REITs), primarily leasing real estate (except residential buildings and dwellings, nonresidential buildings, miniwarehouses, and self-storage units)",
  },
  {
    code: "531190",
    title: "Farmland rental or leasing",
  },
  {
    code: "531190",
    title: "Flea market space (except under roof) rental or leasing",
  },
  {
    code: "531190",
    title: "Forest land rental or leasing",
  },
  {
    code: "531190",
    title: "Grazing land rental or leasing",
  },
  {
    code: "531190",
    title: "Land rental or leasing",
  },
  {
    code: "531190",
    title: "Manufactured (mobile) home parks",
  },
  {
    code: "531190",
    title: "Manufactured (mobile) home sites rental or leasing",
  },
  {
    code: "531190",
    title: "Mining property leasing",
  },
  {
    code: "531190",
    title: "Mobile (manufactured) home parks",
  },
  {
    code: "531190",
    title: "Mobile (manufactured) home sites rental or leasing",
  },
  {
    code: "531190",
    title: "Railroad right of way leasing",
  },
  {
    code: "531190",
    title: "Real estate (except building) rental or leasing",
  },
  {
    code: "531190",
    title: "Residential trailer parks",
  },
  {
    code: "531190",
    title: "Trailer park or court, residential",
  },
  {
    code: "531190",
    title: "Vacant lot rental or leasing",
  },
  {
    code: "531190",
    title: "Vacation and recreation land rental or leasing",
  },
  {
    code: "531210",
    title: "Agencies, real estate",
  },
  {
    code: "531210",
    title: "Agents, real estate",
  },
  {
    code: "531210",
    title: "Auctioning real estate for others (i.e., agents, brokers)",
  },
  {
    code: "531210",
    title: "Brokerages, real estate",
  },
  {
    code: "531210",
    title: "Brokers' offices, real estate",
  },
  {
    code: "531210",
    title: "Buyers' agents, real estate, offices",
  },
  {
    code: "531210",
    title: "Buying agencies, real estate",
  },
  {
    code: "531210",
    title: "Buying real estate for others (i.e., agents, brokers)",
  },
  {
    code: "531210",
    title: "Commercial real estate agencies",
  },
  {
    code: "531210",
    title: "Commercial real estate agents' offices",
  },
  {
    code: "531210",
    title: "Exclusive buyers' agencies",
  },
  {
    code: "531210",
    title: "Exclusive buyers' agents, offices of",
  },
  {
    code: "531210",
    title: "Real estate agencies",
  },
  {
    code: "531210",
    title: "Real estate agents' offices",
  },
  {
    code: "531210",
    title: "Real estate brokerages",
  },
  {
    code: "531210",
    title: "Real estate brokers' offices",
  },
  {
    code: "531210",
    title: "Renting real estate for others (i.e., agents, brokers)",
  },
  {
    code: "531210",
    title: "Residential real estate agencies",
  },
  {
    code: "531210",
    title: "Residential real estate agents' offices",
  },
  {
    code: "531210",
    title: "Residential real estate brokerages",
  },
  {
    code: "531210",
    title: "Residential real estate brokers' offices",
  },
  {
    code: "531210",
    title: "Selling real estate for others (i.e., agents, brokers)",
  },
  {
    code: "531210",
    title: "Selling time-share condominiums for others (i.e., agents, brokers)",
  },
  {
    code: "531311",
    title: "Apartment managers' offices",
  },
  {
    code: "531311",
    title: "Condominium managers' offices, residential",
  },
  {
    code: "531311",
    title: "Cooperative apartment managers' offices",
  },
  {
    code: "531311",
    title: "Managers' offices, residential condominium",
  },
  {
    code: "531311",
    title: "Managers' offices, residential real estate",
  },
  {
    code: "531311",
    title: "Managing cooperative apartments",
  },
  {
    code: "531311",
    title: "Managing residential condominiums",
  },
  {
    code: "531311",
    title: "Managing residential real estate",
  },
  {
    code: "531311",
    title: "Property managers' offices, residential real estate",
  },
  {
    code: "531311",
    title: "Property managing, residential real estate",
  },
  {
    code: "531311",
    title: "Real estate property managers' offices, residential",
  },
  {
    code: "531311",
    title: "Residential property managing",
  },
  {
    code: "531311",
    title: "Residential real estate property managers' offices",
  },
  {
    code: "531311",
    title: "Resort or vacation property managers' offices",
  },
  {
    code: "531312",
    title: "Commercial property managing",
  },
  {
    code: "531312",
    title: "Commercial real estate property managers' offices",
  },
  {
    code: "531312",
    title: "Condominium managers' offices, commercial",
  },
  {
    code: "531312",
    title: "Managers' offices, commercial condominium",
  },
  {
    code: "531312",
    title: "Managers' offices, commercial real estate",
  },
  {
    code: "531312",
    title: "Managers' offices, nonresidential real estate",
  },
  {
    code: "531312",
    title: "Managing commercial condominiums",
  },
  {
    code: "531312",
    title: "Managing commercial real estate",
  },
  {
    code: "531312",
    title: "Nonresidential property managing",
  },
  {
    code: "531312",
    title: "Property managers' offices, commercial real estate",
  },
  {
    code: "531312",
    title: "Property managers' offices, nonresidential real estate",
  },
  {
    code: "531312",
    title: "Property managing, commercial real estate",
  },
  {
    code: "531312",
    title: "Property managing, nonresidential real estate",
  },
  {
    code: "531312",
    title: "Real estate property managers' offices, commercial",
  },
  {
    code: "531320",
    title: "Appraisal services, real estate",
  },
  {
    code: "531320",
    title: "Appraisers' offices, real estate",
  },
  {
    code: "531320",
    title: "Real estate appraisal services",
  },
  {
    code: "531320",
    title: "Real estate appraisers' offices",
  },
  {
    code: "531390",
    title: "Agencies, real estate escrow",
  },
  {
    code: "531390",
    title: "Agents' offices, real estate escrow",
  },
  {
    code: "531390",
    title: "Consultants', real estate (except appraisers), offices",
  },
  {
    code: "531390",
    title: "Escrow agencies, real estate",
  },
  {
    code: "531390",
    title: "Fiduciaries', real estate, offices",
  },
  {
    code: "531390",
    title: "Landman services",
  },
  {
    code: "531390",
    title: "Listing services, real estate",
  },
  {
    code: "531390",
    title: "Real estate asset management services (except property management)",
  },
  {
    code: "531390",
    title: "Real estate consultants' (except agents, appraisers) offices",
  },
  {
    code: "531390",
    title: "Real estate escrow agencies",
  },
  {
    code: "531390",
    title: "Real estate escrow agents' offices",
  },
  {
    code: "531390",
    title: "Real estate fiduciaries' offices",
  },
  {
    code: "531390",
    title: "Real estate listing services",
  },
  {
    code: "532111",
    title: "Automobile rental",
  },
  {
    code: "532111",
    title: "Car rental",
  },
  {
    code: "532111",
    title: "Car rental agencies",
  },
  {
    code: "532111",
    title: "Hearse rental without driver",
  },
  {
    code: "532111",
    title: "Limousine rental without driver",
  },
  {
    code: "532111",
    title: "Luxury automobile rental without driver",
  },
  {
    code: "532111",
    title: "Passenger car rental",
  },
  {
    code: "532111",
    title: "Passenger truck (light duty) rental",
  },
  {
    code: "532111",
    title: "Passenger van rental",
  },
  {
    code: "532111",
    title: "Passenger van rental agencies",
  },
  {
    code: "532111",
    title: "Sport utility vehicle rental",
  },
  {
    code: "532111",
    title: "Van (passenger) rental",
  },
  {
    code: "532112",
    title: "Automobile leasing",
  },
  {
    code: "532112",
    title: "Car leasing",
  },
  {
    code: "532112",
    title: "Fleet leasing, passenger vehicle",
  },
  {
    code: "532112",
    title: "Passenger car leasing",
  },
  {
    code: "532112",
    title: "Passenger truck (light duty) leasing",
  },
  {
    code: "532112",
    title: "Passenger van leasing",
  },
  {
    code: "532112",
    title: "Passenger vehicle fleet leasing",
  },
  {
    code: "532112",
    title: "Sport utility vehicle leasing",
  },
  {
    code: "532112",
    title: "Van (passenger) leasing",
  },
  {
    code: "532120",
    title: "Bus rental or leasing",
  },
  {
    code: "532120",
    title: "Camper rental",
  },
  {
    code: "532120",
    title: "Dump truck rental or leasing without operator",
  },
  {
    code: "532120",
    title: "Mobile home rental, off-site",
  },
  {
    code: "532120",
    title: "Motor home rental, off-site",
  },
  {
    code: "532120",
    title: "Popup camper rental",
  },
  {
    code: "532120",
    title: "Recreational trailer rental",
  },
  {
    code: "532120",
    title: "Recreational vehicle (RV) rental or leasing",
  },
  {
    code: "532120",
    title: "RV (recreational vehicle) rental or leasing",
  },
  {
    code: "532120",
    title: "School bus rental or leasing",
  },
  {
    code: "532120",
    title: "Semi-trailer rental or leasing",
  },
  {
    code: "532120",
    title: "Trailer rental or leasing",
  },
  {
    code: "532120",
    title: "Truck (except industrial, light duty passenger) rental or leasing",
  },
  {
    code: "532120",
    title: "Truck tractor rental or leasing without driver",
  },
  {
    code: "532120",
    title: "Utility trailer rental or leasing",
  },
  {
    code: "532120",
    title: "Van (except passenger) rental or leasing without driver",
  },
  {
    code: "532210",
    title: "Air-conditioner rental",
  },
  {
    code: "532210",
    title: "Appliance rental",
  },
  {
    code: "532210",
    title: "Camcorder rental",
  },
  {
    code: "532210",
    title: "Consumer electronics rental",
  },
  {
    code: "532210",
    title: "Dryer, clothes, rental",
  },
  {
    code: "532210",
    title: "Photographic equipment rental",
  },
  {
    code: "532210",
    title: "Refrigerator rental",
  },
  {
    code: "532210",
    title: "Stereo equipment rental",
  },
  {
    code: "532210",
    title: "Tape recorder rental",
  },
  {
    code: "532210",
    title: "Television rental",
  },
  {
    code: "532210",
    title: "Video cassette recorder rental",
  },
  {
    code: "532210",
    title: "Video disc player rental",
  },
  {
    code: "532210",
    title: "Video recorder rental",
  },
  {
    code: "532210",
    title: "Video tape player rental",
  },
  {
    code: "532210",
    title: "Washer, clothes, rental",
  },
  {
    code: "532281",
    title: "Bridal wear rental",
  },
  {
    code: "532281",
    title: "Clothing rental (except industrial launderer, linen supply)",
  },
  {
    code: "532281",
    title: "Costume rental",
  },
  {
    code: "532281",
    title: "Dress suit rental",
  },
  {
    code: "532281",
    title: "Formal wear rental",
  },
  {
    code: "532281",
    title: "Fur rental",
  },
  {
    code: "532281",
    title: "Gown rental",
  },
  {
    code: "532281",
    title: "Graduation cap and gown rental",
  },
  {
    code: "532281",
    title: "Motion picture wardrobe and costume rental",
  },
  {
    code: "532281",
    title: "Suit rental",
  },
  {
    code: "532281",
    title: "Theatrical wardrobe and costume rental",
  },
  {
    code: "532281",
    title: "Tuxedo rental",
  },
  {
    code: "532281",
    title: "Wardrobe rental",
  },
  {
    code: "532282",
    title: "Cassette, prerecorded video, rental",
  },
  {
    code: "532282",
    title: "Computer video game rental",
  },
  {
    code: "532282",
    title: "Laser disc, video, rental",
  },
  {
    code: "532282",
    title: "Video disc rental for home electronic equipment (e.g., DVD)",
  },
  {
    code: "532282",
    title: "Video game rental",
  },
  {
    code: "532282",
    title: "Video tape rental for home electronic equipment (e.g., VCR)",
  },
  {
    code: "532282",
    title: "Video tape rental stores",
  },
  {
    code: "532283",
    title: "Crutches, invalid, rental",
  },
  {
    code: "532283",
    title: "Furniture, home health, rental",
  },
  {
    code: "532283",
    title: "Home health furniture and equipment rental",
  },
  {
    code: "532283",
    title: "Hospital bed rental and leasing (i.e., home use)",
  },
  {
    code: "532283",
    title: "Hospital equipment rental (i.e. home use)",
  },
  {
    code: "532283",
    title: "Hospital furniture and equipment rental (i.e. home use)",
  },
  {
    code: "532283",
    title: "Invalid equipment rental (i.e., home use)",
  },
  {
    code: "532283",
    title: "Oxygen equipment rental (i.e., home use)",
  },
  {
    code: "532283",
    title: "Walker, invalid, rental",
  },
  {
    code: "532283",
    title: "Wheelchair rental",
  },
  {
    code: "532284",
    title: "Beach chair rental",
  },
  {
    code: "532284",
    title: "Beach umbrella rental",
  },
  {
    code: "532284",
    title: "Bicycle rental",
  },
  {
    code: "532284",
    title: "Bicycle sharing services",
  },
  {
    code: "532284",
    title: "Boat rental, pleasure",
  },
  {
    code: "532284",
    title: "Canoe rental",
  },
  {
    code: "532284",
    title: "Exercise equipment rental",
  },
  {
    code: "532284",
    title: "Golf cart rental",
  },
  {
    code: "532284",
    title: "Houseboat rental",
  },
  {
    code: "532284",
    title: "Moped rental",
  },
  {
    code: "532284",
    title: "Motorcycle rental",
  },
  {
    code: "532284",
    title: "Personal watercraft rental",
  },
  {
    code: "532284",
    title: "Pleasure boat rental",
  },
  {
    code: "532284",
    title: "Recreational goods rental",
  },
  {
    code: "532284",
    title: "Rowboat rental",
  },
  {
    code: "532284",
    title: "Sailboat rental",
  },
  {
    code: "532284",
    title: "Ski equipment rental",
  },
  {
    code: "532284",
    title: "Snow ski equipment rental",
  },
  {
    code: "532284",
    title: "Sporting goods rental",
  },
  {
    code: "532284",
    title: "Sports equipment rental",
  },
  {
    code: "532284",
    title: "Surfboard rental",
  },
  {
    code: "532284",
    title: "Tent, camping, rental",
  },
  {
    code: "532284",
    title: "Water ski rental",
  },
  {
    code: "532284",
    title: "Yacht rental without crew",
  },
  {
    code: "532289",
    title: "Carpet and rug, residential, rental",
  },
  {
    code: "532289",
    title: "Furniture (i.e., residential) rental centers",
  },
  {
    code: "532289",
    title: "Furniture, residential, rental or leasing",
  },
  {
    code: "532289",
    title: "Musical instrument rental",
  },
  {
    code: "532289",
    title: "Party (i.e., banquet) equipment rental",
  },
  {
    code: "532289",
    title: "Party rental supply centers",
  },
  {
    code: "532289",
    title: "Piano rental",
  },
  {
    code: "532289",
    title: "Rug and carpet rental",
  },
  {
    code: "532289",
    title: "Silverware rental",
  },
  {
    code: "532289",
    title: "Table and banquet accessory rental",
  },
  {
    code: "532289",
    title: "Tableware rental",
  },
  {
    code: "532289",
    title: "Tent, party, rental",
  },
  {
    code: "532289",
    title: "Tool rental or leasing for home use",
  },
  {
    code: "532310",
    title: "General rental centers",
  },
  {
    code: "532310",
    title: "Home and garden equipment rental centers",
  },
  {
    code: "532310",
    title: "Rent-all centers",
  },
  {
    code: "532411",
    title: "Aircraft rental or leasing without operator",
  },
  {
    code: "532411",
    title: "Airplane rental or leasing without operator",
  },
  {
    code: "532411",
    title: "Barge rental or leasing without crew",
  },
  {
    code: "532411",
    title: "Boat rental (except pleasure) without crew",
  },
  {
    code: "532411",
    title: "Boat rental or leasing, commercial",
  },
  {
    code: "532411",
    title: "Railroad car rental or leasing",
  },
  {
    code: "532411",
    title: "Ship rental or leasing without crew",
  },
  {
    code: "532411",
    title: "Steamship rental or leasing without crew",
  },
  {
    code: "532411",
    title: "Tanker (boat) rental or leasing without crew",
  },
  {
    code: "532411",
    title: "Towboat rental or leasing without crew",
  },
  {
    code: "532411",
    title: "Tugboat rental or leasing without crew",
  },
  {
    code: "532412",
    title: "Bulldozer rental or leasing without operator",
  },
  {
    code: "532412",
    title: "Construction form rental",
  },
  {
    code: "532412",
    title:
      "Construction machinery and equipment rental or leasing without operator",
  },
  {
    code: "532412",
    title: "Crane rental or leasing without operator",
  },
  {
    code: "532412",
    title: "Earthmoving equipment rental or leasing without operator",
  },
  {
    code: "532412",
    title: "Forestry machinery and equipment rental or leasing",
  },
  {
    code: "532412",
    title: "Heavy construction equipment rental without operator",
  },
  {
    code: "532412",
    title: "Logging equipment rental or leasing without operator",
  },
  {
    code: "532412",
    title: "Mining machinery and equipment rental or leasing",
  },
  {
    code: "532412",
    title: "Oil field machinery and equipment rental or leasing",
  },
  {
    code: "532412",
    title: "Oil well drilling machinery and equipment rental or leasing",
  },
  {
    code: "532412",
    title: "Welding equipment rental or leasing",
  },
  {
    code: "532412",
    title: "Well drilling machinery and equipment rental or leasing",
  },
  {
    code: "532420",
    title: "Cash register rental or leasing",
  },
  {
    code: "532420",
    title: "Computer peripheral equipment rental or leasing",
  },
  {
    code: "532420",
    title: "Computer rental or leasing",
  },
  {
    code: "532420",
    title: "Copier rental or leasing",
  },
  {
    code: "532420",
    title: "Duplicating machine (e.g., copier) rental or leasing",
  },
  {
    code: "532420",
    title: "Facsimile machine rental or leasing",
  },
  {
    code: "532420",
    title: "Fax machine rental or leasing",
  },
  {
    code: "532420",
    title: "Furniture, office, rental or leasing",
  },
  {
    code: "532420",
    title: "Mailing equipment rental or leasing",
  },
  {
    code: "532420",
    title: "Office furniture rental or leasing",
  },
  {
    code: "532420",
    title: "Office machinery and equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Agricultural machinery and equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Audio visual equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Carpentry equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Carpet and rug cleaning equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Compressor, air and gas, rental or leasing",
  },
  {
    code: "532490",
    title: "Farm equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Farm tractor rental or leasing",
  },
  {
    code: "532490",
    title: "Floor sanding machine rental or leasing",
  },
  {
    code: "532490",
    title: "Floor waxing equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Furniture, institutional (i.e. public building), rental or leasing",
  },
  {
    code: "532490",
    title: "Garden tractor rental or leasing",
  },
  {
    code: "532490",
    title: "Generator rental or leasing",
  },
  {
    code: "532490",
    title: "Industrial truck rental or leasing",
  },
  {
    code: "532490",
    title: "Lawnmower rental or leasing",
  },
  {
    code: "532490",
    title: "Manufacturing machinery and equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Material handling machinery and equipment rental or leasing",
  },
  {
    code: "532490",
    title:
      "Medical equipment (except home health furniture and equipment) rental or leasing",
  },
  {
    code: "532490",
    title: "Metalworking machinery and equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Mobile office building rental or leasing, off-site",
  },
  {
    code: "532490",
    title: "Modular building rental or leasing, off-site",
  },
  {
    code: "532490",
    title: "Motion picture equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Pallet rental or leasing",
  },
  {
    code: "532490",
    title: "Plumbing equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Power washer rental or leasing",
  },
  {
    code: "532490",
    title: "Public address system rental or leasing",
  },
  {
    code: "532490",
    title:
      "Renting coin- or card-operated amusement devices (except concession operators)",
  },
  {
    code: "532490",
    title: "Sawmill machinery rental or leasing",
  },
  {
    code: "532490",
    title: "Scaffolding rental or leasing",
  },
  {
    code: "532490",
    title: "Scenery, theatrical, rental or leasing",
  },
  {
    code: "532490",
    title: "Skid rental or leasing",
  },
  {
    code: "532490",
    title: "Sound and lighting equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Telecommunications equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Textile machinery rental or leasing",
  },
  {
    code: "532490",
    title: "Theatrical equipment (except costumes) rental or leasing",
  },
  {
    code: "532490",
    title: "Tractor, farm, rental or leasing",
  },
  {
    code: "532490",
    title: "Tractor, garden, rental or leasing",
  },
  {
    code: "532490",
    title:
      "Traffic control equipment (e.g., barricades, cones, traffic signs) rental or leasing",
  },
  {
    code: "532490",
    title: "Truck, industrial, rental or leasing",
  },
  {
    code: "532490",
    title: "TV broadcasting and studio equipment rental or leasing",
  },
  {
    code: "532490",
    title: "Vending machine rental",
  },
  {
    code: "532490",
    title: "Woodworking machinery and equipment rental or leasing",
  },
  {
    code: "533110",
    title: "Brand name licensing",
  },
  {
    code: "533110",
    title:
      "Franchise agreements, leasing, selling or licensing, without providing other services",
  },
  {
    code: "533110",
    title: "Industrial design licensing",
  },
  {
    code: "533110",
    title: "Oil royalty companies",
  },
  {
    code: "533110",
    title: "Oil royalty leasing",
  },
  {
    code: "533110",
    title: "Oil royalty traders (except for own account)",
  },
  {
    code: "533110",
    title: "Patent buying and licensing",
  },
  {
    code: "533110",
    title: "Patent leasing",
  },
  {
    code: "533110",
    title: "Performance rights, licensing of",
  },
  {
    code: "533110",
    title: "Trademark licensing",
  },
  {
    code: "541110",
    title: "Attorneys' offices",
  },
  {
    code: "541110",
    title: "Attorneys' private practices",
  },
  {
    code: "541110",
    title: "Barristers' offices",
  },
  {
    code: "541110",
    title: "Barristers' private practices",
  },
  {
    code: "541110",
    title: "Corporate law offices",
  },
  {
    code: "541110",
    title: "Counselors' at law offices",
  },
  {
    code: "541110",
    title: "Counselors' at law private practices",
  },
  {
    code: "541110",
    title: "Criminal law offices",
  },
  {
    code: "541110",
    title: "Estate law offices",
  },
  {
    code: "541110",
    title: "Family law offices",
  },
  {
    code: "541110",
    title: "Law firms",
  },
  {
    code: "541110",
    title: "Law offices",
  },
  {
    code: "541110",
    title: "Law practices",
  },
  {
    code: "541110",
    title: "Lawyers' offices",
  },
  {
    code: "541110",
    title: "Lawyers' private practices",
  },
  {
    code: "541110",
    title: "Legal aid services",
  },
  {
    code: "541110",
    title: "Patent attorneys' offices",
  },
  {
    code: "541110",
    title: "Patent attorneys' private practices",
  },
  {
    code: "541110",
    title: "Real estate law offices",
  },
  {
    code: "541110",
    title: "Solicitors' offices, private",
  },
  {
    code: "541110",
    title: "Solicitors' private practices",
  },
  {
    code: "541110",
    title: "Tax law attorneys' offices",
  },
  {
    code: "541110",
    title: "Tax law attorneys' private practices",
  },
  {
    code: "541191",
    title: "Settlement offices, real estate",
  },
  {
    code: "541191",
    title: "Title abstract companies, real estate",
  },
  {
    code: "541191",
    title: "Title companies, real estate",
  },
  {
    code: "541191",
    title: "Title search companies, real estate",
  },
  {
    code: "541199",
    title: "Jury consulting services",
  },
  {
    code: "541199",
    title: "Notary public services",
  },
  {
    code: "541199",
    title: "Notary publics' private practices",
  },
  {
    code: "541199",
    title: "Paralegal services",
  },
  {
    code: "541199",
    title: "Patent agent services (i.e., patent filing and searching services)",
  },
  {
    code: "541199",
    title: "Process server services",
  },
  {
    code: "541199",
    title: "Process serving services",
  },
  {
    code: "541199",
    title: "Trial consulting services",
  },
  {
    code: "541211",
    title: "Accountants' (i.e., CPAs) offices, certified public",
  },
  {
    code: "541211",
    title: "Accountants' (i.e., CPAs) private practices, certified public",
  },
  {
    code: "541211",
    title: "Accounting (i.e., CPAs) services, certified public",
  },
  {
    code: "541211",
    title: "Auditing accountants' (i.e., CPAs) offices",
  },
  {
    code: "541211",
    title: "Auditing accountants' (i.e., CPAs) private practices",
  },
  {
    code: "541211",
    title: "Auditing services (i.e., CPA services), accounts",
  },
  {
    code: "541211",
    title: "Auditors' (i.e., CPAs) offices, accounts",
  },
  {
    code: "541211",
    title: "Auditors' (i.e., CPAs) private practices, accounts",
  },
  {
    code: "541211",
    title: "Certified accountants' offices",
  },
  {
    code: "541211",
    title: "Certified public accountants' (CPAs) offices",
  },
  {
    code: "541211",
    title: "CPAs' (certified public accountants) offices",
  },
  {
    code: "541211",
    title: "Public accountants' (CPAs) offices, certified",
  },
  {
    code: "541211",
    title: "Public accountants' (CPAs) private practices, certified",
  },
  {
    code: "541213",
    title: "Income tax compilation services",
  },
  {
    code: "541213",
    title: "Income tax return preparation services",
  },
  {
    code: "541213",
    title: "Tax return preparation services",
  },
  {
    code: "541214",
    title: "Motion picture production payroll services",
  },
  {
    code: "541214",
    title: "Payroll processing services",
  },
  {
    code: "541214",
    title: "Talent payment services",
  },
  {
    code: "541219",
    title: "Accountants' (except CPAs) offices",
  },
  {
    code: "541219",
    title: "Accountants' (except CPAs) private practices",
  },
  {
    code: "541219",
    title: "Accounting services (except CPAs)",
  },
  {
    code: "541219",
    title: "Billing services",
  },
  {
    code: "541219",
    title: "Bookkeepers' offices",
  },
  {
    code: "541219",
    title: "Bookkeepers' private practices",
  },
  {
    code: "541219",
    title: "Bookkeeping services",
  },
  {
    code: "541219",
    title:
      "Medical coding services combined with accounting services (except CPA services)",
  },
  {
    code: "541219",
    title: "Public accountants' (except CPAs) offices",
  },
  {
    code: "541219",
    title: "Public accountants' (except CPAs) private practices",
  },
  {
    code: "541310",
    title: "Architects' (except landscape) offices",
  },
  {
    code: "541310",
    title: "Architects' (except landscape) private practices",
  },
  {
    code: "541310",
    title: "Architectural (except landscape) consultants' offices",
  },
  {
    code: "541310",
    title: "Architectural (except landscape) design services",
  },
  {
    code: "541310",
    title: "Architectural (except landscape) services",
  },
  {
    code: "541310",
    title: "Architectural construction specifications consulting services",
  },
  {
    code: "541310",
    title: "Building architectural design services",
  },
  {
    code: "541320",
    title: "Architects' offices, landscape",
  },
  {
    code: "541320",
    title: "Architects' private practices, landscape",
  },
  {
    code: "541320",
    title: "Architectural services, landscape",
  },
  {
    code: "541320",
    title: "City planning services",
  },
  {
    code: "541320",
    title: "Garden planning services",
  },
  {
    code: "541320",
    title: "Golf course design services",
  },
  {
    code: "541320",
    title: "Industrial land use planning services",
  },
  {
    code: "541320",
    title: "Land use design services",
  },
  {
    code: "541320",
    title: "Land use planning services",
  },
  {
    code: "541320",
    title: "Landscape architects' offices",
  },
  {
    code: "541320",
    title: "Landscape architects' private practices",
  },
  {
    code: "541320",
    title: "Landscape architectural services",
  },
  {
    code: "541320",
    title: "Landscape consulting services",
  },
  {
    code: "541320",
    title: "Landscape design services",
  },
  {
    code: "541320",
    title: "Landscape planning services",
  },
  {
    code: "541320",
    title: "Ski area design services",
  },
  {
    code: "541320",
    title: "Ski area planning services",
  },
  {
    code: "541320",
    title: "Town planners' offices",
  },
  {
    code: "541320",
    title: "Town planning services",
  },
  {
    code: "541320",
    title: "Urban planners' offices",
  },
  {
    code: "541320",
    title: "Urban planning services",
  },
  {
    code: "541330",
    title: "Acoustical engineering consulting services",
  },
  {
    code: "541330",
    title: "Acoustical system engineering design services",
  },
  {
    code: "541330",
    title: "Audio visual system engineering design services",
  },
  {
    code: "541330",
    title: "Boat engineering design services",
  },
  {
    code: "541330",
    title: "Chemical engineering services",
  },
  {
    code: "541330",
    title: "Civil engineering services",
  },
  {
    code: "541330",
    title: "Combustion engineering consulting services",
  },
  {
    code: "541330",
    title: "Construction engineering services",
  },
  {
    code: "541330",
    title: "Consulting engineers' offices",
  },
  {
    code: "541330",
    title: "Consulting engineers' private practices",
  },
  {
    code: "541330",
    title: "Electrical engineering services",
  },
  {
    code: "541330",
    title: "Engineering consulting services",
  },
  {
    code: "541330",
    title: "Engineering design services",
  },
  {
    code: "541330",
    title: "Engineering services",
  },
  {
    code: "541330",
    title: "Engineers' offices",
  },
  {
    code: "541330",
    title: "Engineers' private practices",
  },
  {
    code: "541330",
    title: "Environmental engineering services",
  },
  {
    code: "541330",
    title: "Erosion control engineering services",
  },
  {
    code: "541330",
    title: "Geological engineering services",
  },
  {
    code: "541330",
    title: "Geophysical engineering services",
  },
  {
    code: "541330",
    title: "Heating engineering consulting services",
  },
  {
    code: "541330",
    title: "Industrial engineering services",
  },
  {
    code: "541330",
    title: "Logging engineering services",
  },
  {
    code: "541330",
    title: "Marine engineering services",
  },
  {
    code: "541330",
    title: "Maritime technology engineering services",
  },
  {
    code: "541330",
    title: "Mechanical engineering services",
  },
  {
    code: "541330",
    title: "Mining engineering services",
  },
  {
    code: "541330",
    title: "Petroleum engineering services",
  },
  {
    code: "541330",
    title: "Robotics automation engineering services",
  },
  {
    code: "541330",
    title: "Robotics engineering design and integration services",
  },
  {
    code: "541330",
    title: "Traffic engineering consulting services",
  },
  {
    code: "541340",
    title: "Blueprint drafting services",
  },
  {
    code: "541340",
    title: "Computer-aided design drafting (CADD) services",
  },
  {
    code: "541340",
    title: "Drafting services",
  },
  {
    code: "541340",
    title: "Draftsmen's offices",
  },
  {
    code: "541350",
    title: "Building inspection bureaus",
  },
  {
    code: "541350",
    title: "Building inspection services",
  },
  {
    code: "541350",
    title: "Energy efficiency inspection services",
  },
  {
    code: "541350",
    title: "Home inspection services",
  },
  {
    code: "541350",
    title: "Inspection bureaus, building",
  },
  {
    code: "541350",
    title: "Inspection services, building or home",
  },
  {
    code: "541350",
    title: "Prepurchase home inspection services",
  },
  {
    code: "541360",
    title: "Aerial geophysical surveying services",
  },
  {
    code: "541360",
    title: "Electrical geophysical surveying services",
  },
  {
    code: "541360",
    title: "Electromagnetic geophysical surveying services",
  },
  {
    code: "541360",
    title: "Geological surveying services",
  },
  {
    code: "541360",
    title: "Geophysical mapping services",
  },
  {
    code: "541360",
    title: "Geophysical surveying services",
  },
  {
    code: "541360",
    title: "Gravity geophysical surveying services",
  },
  {
    code: "541360",
    title: "Magnetic geophysical surveying services",
  },
  {
    code: "541360",
    title: "Mapping services, geophysical",
  },
  {
    code: "541360",
    title: "Radioactive geophysical surveying services",
  },
  {
    code: "541360",
    title: "Remote sensing geophysical surveying services",
  },
  {
    code: "541360",
    title: "Seismic geophysical surveying services",
  },
  {
    code: "541360",
    title: "Surveying services, geophysical",
  },
  {
    code: "541370",
    title: "Aerial surveying (except geophysical) services",
  },
  {
    code: "541370",
    title: "Cadastral surveying services",
  },
  {
    code: "541370",
    title: "Cartographic surveying services",
  },
  {
    code: "541370",
    title: "Construction surveying services",
  },
  {
    code: "541370",
    title: "Geodetic surveying services",
  },
  {
    code: "541370",
    title: "Geographic information system (GIS) base mapping services",
  },
  {
    code: "541370",
    title: "Geospatial mapping services",
  },
  {
    code: "541370",
    title: "Hydrographic mapping services",
  },
  {
    code: "541370",
    title: "Hydrographic surveying services",
  },
  {
    code: "541370",
    title: "Land surveying services",
  },
  {
    code: "541370",
    title: "Mapping (except geophysical) services",
  },
  {
    code: "541370",
    title: "Photogrammetric mapping services",
  },
  {
    code: "541370",
    title: "Surveying and mapping services (except geophysical)",
  },
  {
    code: "541370",
    title: "Topographic mapping services",
  },
  {
    code: "541370",
    title: "Topographic surveying services",
  },
  {
    code: "541380",
    title: "Acoustics testing laboratories or services",
  },
  {
    code: "541380",
    title: "Assaying services",
  },
  {
    code: "541380",
    title: "Automobile proving and testing grounds",
  },
  {
    code: "541380",
    title:
      "Biological (except medical, veterinary) testing laboratories or services",
  },
  {
    code: "541380",
    title: "Calibration and certification testing laboratories or services",
  },
  {
    code: "541380",
    title: "Electrical testing laboratories or services",
  },
  {
    code: "541380",
    title: "Electronic testing laboratories or services",
  },
  {
    code: "541380",
    title: "Environmental testing laboratories or services",
  },
  {
    code: "541380",
    title:
      "Film badge testing (i.e., radiation testing) laboratories or services",
  },
  {
    code: "541380",
    title: "Fire insurance underwriters' laboratories",
  },
  {
    code: "541380",
    title: "Food testing laboratories or services",
  },
  {
    code: "541380",
    title: "Forensic (except medical) laboratories or services",
  },
  {
    code: "541380",
    title: "Geotechnical testing laboratories or services",
  },
  {
    code: "541380",
    title: "Hydrostatic testing laboratories or services",
  },
  {
    code: "541380",
    title: "Industrial testing laboratories or services",
  },
  {
    code: "541380",
    title: "Laboratory testing (except medical, veterinary) services",
  },
  {
    code: "541380",
    title: "Mechanical testing laboratories or services",
  },
  {
    code: "541380",
    title: "Metallurgical testing laboratories or services",
  },
  {
    code: "541380",
    title: "Nondestructive testing laboratories or services",
  },
  {
    code: "541380",
    title: "Pollution testing (except automotive emissions testing) services",
  },
  {
    code: "541380",
    title: "Product testing laboratories or services",
  },
  {
    code: "541380",
    title:
      "Radiation dosimetry (i.e., radiation testing) laboratories or services",
  },
  {
    code: "541380",
    title: "Radiation testing laboratories or services",
  },
  {
    code: "541380",
    title: "Radiographic testing laboratories or services",
  },
  {
    code: "541380",
    title: "Radiographing welded joints on pipes and fittings",
  },
  {
    code: "541380",
    title: "Radiography inspection services",
  },
  {
    code: "541380",
    title: "Radon testing laboratories or services",
  },
  {
    code: "541380",
    title: "Seed testing laboratories or services",
  },
  {
    code: "541380",
    title: "Soil testing laboratories or services",
  },
  {
    code: "541380",
    title: "Testing laboratories (except medical, veterinary)",
  },
  {
    code: "541380",
    title: "Thermal testing laboratories or services",
  },
  {
    code: "541380",
    title: "Vibration testing laboratories or services",
  },
  {
    code: "541380",
    title: "X-ray inspection services",
  },
  {
    code: "541410",
    title: "Decorating consulting services, interior",
  },
  {
    code: "541410",
    title: "Decoration services for special events",
  },
  {
    code: "541410",
    title: "Interior decorating consultant services",
  },
  {
    code: "541410",
    title: "Interior decorating consulting services",
  },
  {
    code: "541410",
    title: "Interior design consulting services",
  },
  {
    code: "541410",
    title: "Interior design services",
  },
  {
    code: "541410",
    title: "Interior designer services",
  },
  {
    code: "541420",
    title: "Automobile industrial design services",
  },
  {
    code: "541420",
    title: "Furniture design services",
  },
  {
    code: "541420",
    title: "Handtool industrial design services",
  },
  {
    code: "541420",
    title: "Industrial design consulting services",
  },
  {
    code: "541420",
    title: "Industrial design services",
  },
  {
    code: "541420",
    title: "Packaging industrial design services",
  },
  {
    code: "541420",
    title: "Tool industrial design services",
  },
  {
    code: "541430",
    title: "Art services, commercial",
  },
  {
    code: "541430",
    title: "Art services, graphic",
  },
  {
    code: "541430",
    title: "Art studios, commercial",
  },
  {
    code: "541430",
    title: "Artists, independent commercial",
  },
  {
    code: "541430",
    title: "Artists, independent graphic",
  },
  {
    code: "541430",
    title: "Artists, independent medical",
  },
  {
    code: "541430",
    title: "Commercial art services",
  },
  {
    code: "541430",
    title: "Commercial artists, independent",
  },
  {
    code: "541430",
    title: "Commercial illustration services",
  },
  {
    code: "541430",
    title: "Commercial illustrators, independent",
  },
  {
    code: "541430",
    title: "Communication design services, visual",
  },
  {
    code: "541430",
    title: "Corporate identification (i.e., logo) design services",
  },
  {
    code: "541430",
    title: "Graphic art and related design services",
  },
  {
    code: "541430",
    title: "Graphic artists, independent",
  },
  {
    code: "541430",
    title: "Graphic design services",
  },
  {
    code: "541430",
    title: "Illustrators, independent commercial",
  },
  {
    code: "541430",
    title: "Medical art services",
  },
  {
    code: "541430",
    title: "Medical artists, independent",
  },
  {
    code: "541430",
    title: "Medical illustration services",
  },
  {
    code: "541430",
    title: "Medical illustrators, independent",
  },
  {
    code: "541430",
    title: "Silk screen design services",
  },
  {
    code: "541430",
    title: "Studios, commercial art",
  },
  {
    code: "541490",
    title: "Clothing design services",
  },
  {
    code: "541490",
    title:
      "Costume design services (except independent theatrical costume designers)",
  },
  {
    code: "541490",
    title: "Fashion design services",
  },
  {
    code: "541490",
    title: "Fashion designer services",
  },
  {
    code: "541490",
    title: "Float design services",
  },
  {
    code: "541490",
    title: "Fur design services",
  },
  {
    code: "541490",
    title: "Jewelry design services",
  },
  {
    code: "541490",
    title: "Lighting design services",
  },
  {
    code: "541490",
    title: "Shoe design services",
  },
  {
    code: "541490",
    title: "Textile design services",
  },
  {
    code: "541511",
    title: "Applications software programming services, custom computer",
  },
  {
    code: "541511",
    title: "Computer program or software development, custom",
  },
  {
    code: "541511",
    title: "Computer programming services, custom",
  },
  {
    code: "541511",
    title: "Computer software analysis and design services, custom",
  },
  {
    code: "541511",
    title: "Computer software programming services, custom",
  },
  {
    code: "541511",
    title: "Computer software support services, custom",
  },
  {
    code: "541511",
    title:
      "Industrial robot automation applications/software design and development services",
  },
  {
    code: "541511",
    title: "Industrial robot programming services",
  },
  {
    code: "541511",
    title: "Machine vision software design and development services",
  },
  {
    code: "541511",
    title:
      "Material handling robot applications/software design and development services",
  },
  {
    code: "541511",
    title: "Programming services, custom computer",
  },
  {
    code: "541511",
    title: "Robotics applications/software design and development services",
  },
  {
    code: "541511",
    title:
      "Robotics process automation software design and development services",
  },
  {
    code: "541511",
    title:
      "Search engine optimization (SEO) services, custom (except hosting and infrastructure support services)",
  },
  {
    code: "541511",
    title: "Software analysis and design services, custom computer",
  },
  {
    code: "541511",
    title: "Software programming services, custom computer",
  },
  {
    code: "541511",
    title: "Web (i.e., Internet) page design services, custom",
  },
  {
    code: "541511",
    title:
      "Welding robot applications/software design and development services",
  },
  {
    code: "541512",
    title:
      "Audio visual and IT (information technology) systems integration design services",
  },
  {
    code: "541512",
    title: "CAD (computer-aided design) systems integration design services",
  },
  {
    code: "541512",
    title:
      "CAE (computer-aided engineering) systems integration design services",
  },
  {
    code: "541512",
    title:
      "CAM (computer-aided manufacturing) systems integration design services",
  },
  {
    code: "541512",
    title: "Computer hardware consulting services or consultants",
  },
  {
    code: "541512",
    title: "Computer software consulting services or consultants",
  },
  {
    code: "541512",
    title: "Computer systems integration analysis and design services",
  },
  {
    code: "541512",
    title: "Computer systems integration design consulting services",
  },
  {
    code: "541512",
    title: "Computer systems integrator services",
  },
  {
    code: "541512",
    title: "Computer-aided design (CAD) systems integration design services",
  },
  {
    code: "541512",
    title:
      "Computer-aided engineering (CAE) systems integration design services",
  },
  {
    code: "541512",
    title:
      "Computer-aided manufacturing (CAM) systems integration design services",
  },
  {
    code: "541512",
    title:
      "Information management computer systems integration design services",
  },
  {
    code: "541512",
    title:
      "Local area network (LAN) computer systems integration design services",
  },
  {
    code: "541512",
    title: "Network systems integration design services, computer",
  },
  {
    code: "541512",
    title: "Office automation computer systems integration design services",
  },
  {
    code: "541512",
    title: "Systems integration design consulting services, computer",
  },
  {
    code: "541512",
    title: "Systems integration design services, computer",
  },
  {
    code: "541513",
    title:
      "Computer systems facilities (i.e., clients' facilities) management and operation services",
  },
  {
    code: "541513",
    title:
      "Data processing facilities (i.e., clients' facilities) management and operation services",
  },
  {
    code: "541513",
    title:
      "Facilities (i.e., clients' facilities) management and operation services, computer systems or data processing",
  },
  {
    code: "541513",
    title:
      "Facilities (i.e., clients' facilities) support services, computer systems or data processing",
  },
  {
    code: "541519",
    title: "Computer disaster recovery services",
  },
  {
    code: "541519",
    title: "Software installation services, computer",
  },
  {
    code: "541611",
    title: "Administrative management consulting services",
  },
  {
    code: "541611",
    title: "Business management consulting services",
  },
  {
    code: "541611",
    title: "Business start-up consulting services",
  },
  {
    code: "541611",
    title:
      "Financial management consulting (except investment advice) services",
  },
  {
    code: "541611",
    title: "General management consulting services",
  },
  {
    code: "541611",
    title: "Medical office management consulting services or consultants",
  },
  {
    code: "541611",
    title: "Records management consulting services",
  },
  {
    code: "541611",
    title: "Reorganizational consulting services",
  },
  {
    code: "541611",
    title: "Site location consulting services",
  },
  {
    code: "541611",
    title: "Site selection consulting services",
  },
  {
    code: "541611",
    title: "Strategic planning consulting services",
  },
  {
    code: "541612",
    title:
      "Actuarial consulting services (except insurance actuarial services)",
  },
  {
    code: "541612",
    title: "Benefit consulting services",
  },
  {
    code: "541612",
    title: "Compensation consulting services",
  },
  {
    code: "541612",
    title: "Compensation planning services",
  },
  {
    code: "541612",
    title: "Employee assessment consulting services",
  },
  {
    code: "541612",
    title: "Employee benefit consulting services",
  },
  {
    code: "541612",
    title: "Employee compensation consulting services",
  },
  {
    code: "541612",
    title: "Human resource consulting services",
  },
  {
    code: "541612",
    title: "Labor relations consulting services",
  },
  {
    code: "541612",
    title: "Organization development consulting services",
  },
  {
    code: "541612",
    title: "Personnel management consulting services",
  },
  {
    code: "541613",
    title: "Customer service management consulting services",
  },
  {
    code: "541613",
    title: "Marketing consulting services",
  },
  {
    code: "541613",
    title: "Marketing management consulting services",
  },
  {
    code: "541613",
    title: "New product development consulting services",
  },
  {
    code: "541613",
    title: "Sales management consulting services",
  },
  {
    code: "541614",
    title: "Customs consulting services",
  },
  {
    code: "541614",
    title:
      "Efficiency management (i.e., efficiency expert) consulting services",
  },
  {
    code: "541614",
    title: "Freight rate auditor services",
  },
  {
    code: "541614",
    title: "Freight rate consulting services",
  },
  {
    code: "541614",
    title: "Freight traffic consulting services",
  },
  {
    code: "541614",
    title: "Inventory planning and control management consulting services",
  },
  {
    code: "541614",
    title:
      "Logistics and integrated supply chain management consulting services",
  },
  {
    code: "541614",
    title: "Logistics management consulting services",
  },
  {
    code: "541614",
    title: "Manufacturing management consulting services",
  },
  {
    code: "541614",
    title: "Manufacturing operations improvement consulting services",
  },
  {
    code: "541614",
    title: "Materials management consulting services",
  },
  {
    code: "541614",
    title: "Operations research consulting services",
  },
  {
    code: "541614",
    title: "Physical distribution consulting services",
  },
  {
    code: "541614",
    title: "Production planning and control consulting services",
  },
  {
    code: "541614",
    title: "Productivity improvement consulting services",
  },
  {
    code: "541614",
    title: "Tariff rate consulting services",
  },
  {
    code: "541614",
    title: "Tariff rate information services",
  },
  {
    code: "541614",
    title: "Transportation management consulting services",
  },
  {
    code: "541618",
    title: "Telecommunications management consulting services",
  },
  {
    code: "541618",
    title: "Utilities management consulting services",
  },
  {
    code: "541620",
    title: "Ecological restoration consulting services",
  },
  {
    code: "541620",
    title: "Environmental consulting services",
  },
  {
    code: "541620",
    title: "Environmental reclamation planning services",
  },
  {
    code: "541620",
    title: "Sanitation consulting services",
  },
  {
    code: "541620",
    title: "Site remediation consulting services",
  },
  {
    code: "541620",
    title: "Wetland restoration planning services",
  },
  {
    code: "541690",
    title: "Agricultural consulting services",
  },
  {
    code: "541690",
    title: "Agrology consulting services",
  },
  {
    code: "541690",
    title: "Agronomy consulting services",
  },
  {
    code: "541690",
    title: "Biological consulting services",
  },
  {
    code: "541690",
    title: "Building envelope consulting services",
  },
  {
    code: "541690",
    title: "Chemical consulting services",
  },
  {
    code: "541690",
    title: "Dairy herd consulting services",
  },
  {
    code: "541690",
    title: "Economic consulting services",
  },
  {
    code: "541690",
    title: "Energy consulting services",
  },
  {
    code: "541690",
    title: "Entomology consulting services",
  },
  {
    code: "541690",
    title: "Geochemical consulting services",
  },
  {
    code: "541690",
    title: "Horticultural consulting services",
  },
  {
    code: "541690",
    title: "Hydrology consulting services",
  },
  {
    code: "541690",
    title: "Livestock breeding consulting services",
  },
  {
    code: "541690",
    title: "Motion picture consulting services",
  },
  {
    code: "541690",
    title: "Nuclear energy consulting services",
  },
  {
    code: "541690",
    title: "Physics consulting services",
  },
  {
    code: "541690",
    title: "Radio consulting services",
  },
  {
    code: "541690",
    title: "Roof consulting services",
  },
  {
    code: "541690",
    title: "Safety consulting services",
  },
  {
    code: "541690",
    title: "Security consulting services",
  },
  {
    code: "541690",
    title: "Veterinary consulting services",
  },
  {
    code: "541690",
    title: "Waterproof consulting services",
  },
  {
    code: "541713",
    title:
      "Nanobiotechnologies research and experimental development laboratories",
  },
  {
    code: "541713",
    title:
      "Nanotechnology research and development laboratories or services, all fields of science",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in agriculture (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in bacteriology (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in biology (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in botany (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in chemical sciences (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in entomology (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in environmental science (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in food science (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in genetics (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in health sciences (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in industrial research (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in the medical sciences (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in the physical sciences (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title:
      "Biotechnology research and development laboratories or services in the veterinary sciences (except nanobiotechnology research and development)",
  },
  {
    code: "541714",
    title: "Cloning research and experimental development laboratories ",
  },
  {
    code: "541714",
    title:
      "DNA technologies (e.g., microarrays) research and experimental development laboratories ",
  },
  {
    code: "541714",
    title:
      "Nucleic acid chemistry research and experimental development laboratories ",
  },
  {
    code: "541714",
    title:
      "Protein engineering research and experimental development laboratories ",
  },
  {
    code: "541714",
    title: "Recombinant DNA research and experimental development laboratories",
  },
  {
    code: "541715",
    title: "Aerospace research and development (except prototype production)",
  },
  {
    code: "541715",
    title:
      "Agriculture research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Artificial intelligence research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Bacteriological research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Biology research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Botany research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Chemical research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Computer and related hardware research and development laboratories or services (except nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Dental research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Electronic research and development laboratories or services (except nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Engineering research and development laboratories or services (except nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Entomological research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Environmental research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Experimental farms",
  },
  {
    code: "541715",
    title: "Fisheries research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Food research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Forestry research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Genetics research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Geological research and development laboratories or services (except nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Guided missile and space vehicle engine research and development",
  },
  {
    code: "541715",
    title:
      "Guided missile and space vehicle parts (except engines) research and development",
  },
  {
    code: "541715",
    title:
      "Health research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Industrial research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Life sciences research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Mathematics research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Medical research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Observatories, research institutions",
  },
  {
    code: "541715",
    title: "Oceanographic research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Photonics research and development services (except nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Physical science research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541715",
    title:
      "Physics research and development laboratories or services (except nanotechnology research and development)",
  },
  {
    code: "541715",
    title: "Robotics research and development laboratories or services",
  },
  {
    code: "541715",
    title:
      "Veterinary research and development laboratories or services (except biotechnology and nanotechnology research and development)",
  },
  {
    code: "541720",
    title: "Archeological research and development services",
  },
  {
    code: "541720",
    title: "Behavioral research and development services",
  },
  {
    code: "541720",
    title: "Business research and development services",
  },
  {
    code: "541720",
    title: "Cognitive research and development services",
  },
  {
    code: "541720",
    title: "Demographic research and development services",
  },
  {
    code: "541720",
    title: "Economic research and development services",
  },
  {
    code: "541720",
    title:
      "Historic and cultural preservation research and development services",
  },
  {
    code: "541720",
    title: "Humanities research and development services",
  },
  {
    code: "541720",
    title: "Language research and development services",
  },
  {
    code: "541720",
    title: "Learning disabilities research and development services",
  },
  {
    code: "541720",
    title: "Psychology research and development services",
  },
  {
    code: "541720",
    title: "Social science research and development services",
  },
  {
    code: "541720",
    title: "Sociological research and development services",
  },
  {
    code: "541720",
    title: "Sociology research and development services",
  },
  {
    code: "541810",
    title: "Advertising agencies",
  },
  {
    code: "541810",
    title: "Advertising agency consulting services",
  },
  {
    code: "541810",
    title: "Digital advertising agencies",
  },
  {
    code: "541810",
    title: "Internet advertising agencies",
  },
  {
    code: "541810",
    title: "Online advertising agencies",
  },
  {
    code: "541820",
    title: "Lobbying services",
  },
  {
    code: "541820",
    title: "Lobbyists' offices",
  },
  {
    code: "541820",
    title: "Political consulting services",
  },
  {
    code: "541820",
    title: "Public relations agencies",
  },
  {
    code: "541820",
    title: "Public relations consulting services",
  },
  {
    code: "541820",
    title: "Public relations services",
  },
  {
    code: "541830",
    title: "Media buying agencies",
  },
  {
    code: "541830",
    title: "Media buying services",
  },
  {
    code: "541840",
    title:
      "Advertising media representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title:
      "Magazine advertising representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title:
      "Media advertising representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title: "Media representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title:
      "Newspaper advertising representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title:
      "Publishers' advertising representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title:
      "Radio advertising representatives (i.e., independent of media owners)",
  },
  {
    code: "541840",
    title:
      "Television advertising representatives (i.e., independent of media owners)",
  },
  {
    code: "541850",
    title: "Advertising services, indoor or outdoor display",
  },
  {
    code: "541850",
    title: "Advertising, aerial",
  },
  {
    code: "541850",
    title: "Billboard display advertising services",
  },
  {
    code: "541850",
    title: "Bus card advertising services",
  },
  {
    code: "541850",
    title: "Bus display advertising services",
  },
  {
    code: "541850",
    title: "Indoor display advertising services",
  },
  {
    code: "541850",
    title: "Outdoor display advertising services",
  },
  {
    code: "541850",
    title: "Out-of-home media (i.e., display) advertising services",
  },
  {
    code: "541850",
    title: "Store display advertising services",
  },
  {
    code: "541850",
    title: "Subway card display advertising services",
  },
  {
    code: "541850",
    title: "Taxicab card advertising services",
  },
  {
    code: "541850",
    title: "Transit advertising services",
  },
  {
    code: "541860",
    title:
      "Advertising material preparation services for mailing or other direct distribution",
  },
  {
    code: "541860",
    title: "Direct mail advertising services",
  },
  {
    code: "541860",
    title:
      "Direct mail or other direct distribution advertising campaign services",
  },
  {
    code: "541870",
    title:
      "Advertising material (e.g., coupons, flyers, samples) direct distribution services",
  },
  {
    code: "541870",
    title: "Circular direct distribution services",
  },
  {
    code: "541870",
    title: "Coupon direct distribution services",
  },
  {
    code: "541870",
    title: "Directory, telephone, distribution on a contract basis",
  },
  {
    code: "541870",
    title:
      "Door-to-door distribution of advertising materials (e.g., coupons, flyers, samples)",
  },
  {
    code: "541870",
    title: "Flyer direct distribution (except direct mail) services",
  },
  {
    code: "541870",
    title: "Handbill direct distribution services",
  },
  {
    code: "541870",
    title: "Sample direct distribution services",
  },
  {
    code: "541870",
    title: "Telephone directory distribution services, door-to-door",
  },
  {
    code: "541890",
    title:
      "Advertising specialty (e.g., keychain, magnet, pen) distribution services",
  },
  {
    code: "541890",
    title: "Demonstration services, merchandise",
  },
  {
    code: "541890",
    title: "Display lettering services",
  },
  {
    code: "541890",
    title: "Mannequin decorating services",
  },
  {
    code: "541890",
    title: "Sign lettering and painting services",
  },
  {
    code: "541890",
    title: "Welcoming services (i.e., advertising services)",
  },
  {
    code: "541890",
    title: "Window dressing or trimming services, store",
  },
  {
    code: "541910",
    title: "Broadcast media rating services",
  },
  {
    code: "541910",
    title: "Internet media audience research services",
  },
  {
    code: "541910",
    title: "Internet traffic monitoring research services",
  },
  {
    code: "541910",
    title: "Marketing analysis services",
  },
  {
    code: "541910",
    title: "Marketing research services",
  },
  {
    code: "541910",
    title: "Opinion research services",
  },
  {
    code: "541910",
    title: "Political opinion polling services",
  },
  {
    code: "541910",
    title: "Public opinion polling services",
  },
  {
    code: "541910",
    title: "Public opinion research services",
  },
  {
    code: "541910",
    title: "Sampling services, statistical",
  },
  {
    code: "541921",
    title: "Passport photography services",
  },
  {
    code: "541921",
    title: "Photography services, portrait (e.g., still, video)",
  },
  {
    code: "541921",
    title: "Photography studios, portrait",
  },
  {
    code: "541921",
    title: "Portrait photography services",
  },
  {
    code: "541921",
    title: "Portrait photography studios",
  },
  {
    code: "541921",
    title: "School photography (i.e., portrait photography) services",
  },
  {
    code: "541921",
    title: "Video photography services, portrait",
  },
  {
    code: "541921",
    title: "Video taping services, special events (e.g., birthdays, weddings)",
  },
  {
    code: "541921",
    title: "Wedding photography services",
  },
  {
    code: "541922",
    title: "Commercial event videography services",
  },
  {
    code: "541922",
    title: "Commercial photography services",
  },
  {
    code: "541922",
    title: "Medical photography services",
  },
  {
    code: "541922",
    title: "Photographers specializing in aerial photography",
  },
  {
    code: "541922",
    title: "Photography services, commercial",
  },
  {
    code: "541922",
    title: "Photography studios, commercial",
  },
  {
    code: "541922",
    title: "Video taping services for legal depositions",
  },
  {
    code: "541930",
    title: "Interpretation services, language",
  },
  {
    code: "541930",
    title: "Language interpretation services",
  },
  {
    code: "541930",
    title: "Language services (e.g., interpretation, sign, translation)",
  },
  {
    code: "541930",
    title: "Language translation services",
  },
  {
    code: "541930",
    title: "Sign language services",
  },
  {
    code: "541930",
    title: "Speech (i.e., language) interpretation services",
  },
  {
    code: "541930",
    title: "Translation services, language",
  },
  {
    code: "541940",
    title: "Animal hospitals",
  },
  {
    code: "541940",
    title: "Disease testing services, veterinary",
  },
  {
    code: "541940",
    title: "Hospitals, animal",
  },
  {
    code: "541940",
    title: "Internists' offices, veterinary",
  },
  {
    code: "541940",
    title: "Laboratory testing services, veterinary",
  },
  {
    code: "541940",
    title: "Livestock inspecting and testing services, veterinary",
  },
  {
    code: "541940",
    title: "Livestock veterinary services",
  },
  {
    code: "541940",
    title: "Pet hospitals",
  },
  {
    code: "541940",
    title: "Small animal veterinary services",
  },
  {
    code: "541940",
    title: "Surgeons' offices, veterinary",
  },
  {
    code: "541940",
    title: "Surgery services, veterinary",
  },
  {
    code: "541940",
    title: "Testing laboratories, veterinary",
  },
  {
    code: "541940",
    title: "Testing services for veterinarians",
  },
  {
    code: "541940",
    title: "Vaccination services, veterinary",
  },
  {
    code: "541940",
    title: "Veterinarians' offices",
  },
  {
    code: "541940",
    title: "Veterinarians' practices",
  },
  {
    code: "541940",
    title: "Veterinary clinics",
  },
  {
    code: "541940",
    title: "Veterinary services",
  },
  {
    code: "541940",
    title: "Veterinary services, livestock",
  },
  {
    code: "541940",
    title: "Veterinary services, pets and other animal specialties",
  },
  {
    code: "541940",
    title: "Veterinary testing laboratories",
  },
  {
    code: "541990",
    title: "Appraisal (except real estate) services",
  },
  {
    code: "541990",
    title:
      "Arbitration and conciliation services (except by attorney, paralegal)",
  },
  {
    code: "541990",
    title: "Business brokers (except real estate brokers)",
  },
  {
    code: "541990",
    title: "Commodity inspection services",
  },
  {
    code: "541990",
    title: "Construction estimation services",
  },
  {
    code: "541990",
    title: "Consumer credit counseling services",
  },
  {
    code: "541990",
    title: "Credit repair (i.e., counseling) services, consumer",
  },
  {
    code: "541990",
    title: "Electronic communication content verification services ",
  },
  {
    code: "541990",
    title: "Estate assessment (i.e., appraisal) services",
  },
  {
    code: "541990",
    title:
      "Fire extinguisher testing and/or inspection, without sales, service, or installation",
  },
  {
    code: "541990",
    title: "Handwriting analysis services",
  },
  {
    code: "541990",
    title: "Handwriting expert services",
  },
  {
    code: "541990",
    title: "Marine forecasting services",
  },
  {
    code: "541990",
    title: "Marine surveyor (i.e., ship appraiser) services",
  },
  {
    code: "541990",
    title:
      "Mediation product services (except by lawyer, attorney, paralegal offices, family and social services)",
  },
  {
    code: "541990",
    title: "Meteorological services",
  },
  {
    code: "541990",
    title: "Patent broker services (i.e., patent marketing services)",
  },
  {
    code: "541990",
    title:
      "Patrolling (i.e., visual inspection) of electric transmission or gas lines",
  },
  {
    code: "541990",
    title: "Pipeline inspection (i.e., visual) services",
  },
  {
    code: "541990",
    title: "Power line inspection (i.e., visual) services",
  },
  {
    code: "541990",
    title: "Quantity surveyor services",
  },
  {
    code: "541990",
    title:
      "Waterless fire suppression system testing and/or inspection, without sales, service, or installation",
  },
  {
    code: "541990",
    title: "Weather forecasting services",
  },
  {
    code: "551111",
    title: "Bank holding companies (except managing)",
  },
  {
    code: "551111",
    title: "Holding companies, bank (except managing)",
  },
  {
    code: "551111",
    title: "Offices of bank holding companies",
  },
  {
    code: "551112",
    title: "Agreement corporation (except international trade financing)",
  },
  {
    code: "551112",
    title: "Financial holding companies",
  },
  {
    code: "551112",
    title: "Holding companies (except bank, managing)",
  },
  {
    code: "551112",
    title: "Insurance holding companies",
  },
  {
    code: "551112",
    title: "Nonbank holding companies (except managing)",
  },
  {
    code: "551112",
    title: "Personal holding companies",
  },
  {
    code: "551112",
    title: "Public utility holding companies",
  },
  {
    code: "551112",
    title: "Railroad holding companies",
  },
  {
    code: "551112",
    title: "Savings and loan holding companies",
  },
  {
    code: "551112",
    title: "Thrift holding companies",
  },
  {
    code: "551114",
    title: "Centralized administrative offices",
  },
  {
    code: "551114",
    title: "Corporate offices",
  },
  {
    code: "551114",
    title: "District and regional offices",
  },
  {
    code: "551114",
    title: "Head offices",
  },
  {
    code: "551114",
    title: "Headquarters offices",
  },
  {
    code: "551114",
    title: "Holding companies that manage",
  },
  {
    code: "551114",
    title: "Subsidiary management offices",
  },
  {
    code: "561110",
    title: "Administrative management services",
  },
  {
    code: "561110",
    title: "Business management services",
  },
  {
    code: "561110",
    title: "Executive management services",
  },
  {
    code: "561110",
    title:
      "Hotel management services (except complete operation of client's business)",
  },
  {
    code: "561110",
    title: "Industrial management services",
  },
  {
    code: "561110",
    title:
      "Management services (except complete operation of client's business)",
  },
  {
    code: "561110",
    title: "Managing offices of dentists",
  },
  {
    code: "561110",
    title: "Managing offices of physicians and surgeons",
  },
  {
    code: "561110",
    title:
      "Managing offices of professionals (e.g., dentists, physicians, surgeons)",
  },
  {
    code: "561110",
    title: "Medical office management services",
  },
  {
    code: "561110",
    title:
      "Motel management services (except complete operation of client's business)",
  },
  {
    code: "561110",
    title: "Office administration services",
  },
  {
    code: "561110",
    title: "Office management services",
  },
  {
    code: "561210",
    title: "Base facilities operation support services",
  },
  {
    code: "561210",
    title: "Correctional facilities, privately operated",
  },
  {
    code: "561210",
    title: "Correctional facility operation on a contract or fee basis",
  },
  {
    code: "561210",
    title: "Facilities (except computer operation) support services",
  },
  {
    code: "561210",
    title: "Government base facilities operation support services",
  },
  {
    code: "561210",
    title: "Jail operation on a contract or fee basis",
  },
  {
    code: "561210",
    title: "Jails, privately operated",
  },
  {
    code: "561210",
    title: "Military base support services",
  },
  {
    code: "561210",
    title: "Prison operation on a contract or fee basis",
  },
  {
    code: "561210",
    title: "Prisons, privately operated",
  },
  {
    code: "561311",
    title: "Babysitting bureaus (i.e., registries)",
  },
  {
    code: "561311",
    title: "Casting agencies (i.e., motion picture, theatrical, video)",
  },
  {
    code: "561311",
    title: "Casting agencies, motion picture or video",
  },
  {
    code: "561311",
    title: "Casting agencies, theatrical",
  },
  {
    code: "561311",
    title: "Casting bureaus (e.g., motion picture, theatrical, video)",
  },
  {
    code: "561311",
    title: "Casting bureaus, motion picture or video",
  },
  {
    code: "561311",
    title: "Casting bureaus, theatrical",
  },
  {
    code: "561311",
    title: "Chauffeur registries",
  },
  {
    code: "561311",
    title: "Employee recruitment services (non-executive)",
  },
  {
    code: "561311",
    title: "Employment agencies",
  },
  {
    code: "561311",
    title: "Employment agencies, motion picture or video",
  },
  {
    code: "561311",
    title: "Employment agencies, radio or television",
  },
  {
    code: "561311",
    title: "Employment agencies, theatrical",
  },
  {
    code: "561311",
    title: "Employment placement agencies or services",
  },
  {
    code: "561311",
    title: "Employment referral agencies or services",
  },
  {
    code: "561311",
    title: "Employment registries",
  },
  {
    code: "561311",
    title:
      "Internet job listing services, including intermediary platform services",
  },
  {
    code: "561311",
    title:
      "Internet resume listing services, including intermediary platform services",
  },
  {
    code: "561311",
    title: "Maid registries",
  },
  {
    code: "561311",
    title: "Model registries",
  },
  {
    code: "561311",
    title: "Nurse registries",
  },
  {
    code: "561311",
    title:
      "Online employment registries or listing services, including intermediary platform services",
  },
  {
    code: "561311",
    title: "Placement agencies or services, employment",
  },
  {
    code: "561311",
    title: "Referral agencies or services, employment",
  },
  {
    code: "561311",
    title: "Registries, employment",
  },
  {
    code: "561311",
    title: "Registries, teacher",
  },
  {
    code: "561311",
    title: "Ship crew employment agencies",
  },
  {
    code: "561311",
    title: "Ship crew registries",
  },
  {
    code: "561311",
    title: "State operated employment job services offices",
  },
  {
    code: "561311",
    title: "Teacher registries",
  },
  {
    code: "561311",
    title: "Television employment agencies",
  },
  {
    code: "561311",
    title: "Theatrical employment agencies",
  },
  {
    code: "561312",
    title: "Executive placement consulting services",
  },
  {
    code: "561312",
    title: "Executive placement services",
  },
  {
    code: "561312",
    title: "Executive search consulting services",
  },
  {
    code: "561312",
    title: "Executive search services",
  },
  {
    code: "561312",
    title: "Senior executive search services",
  },
  {
    code: "561320",
    title: "Construction labor supply services",
  },
  {
    code: "561320",
    title: "Contract staffing services",
  },
  {
    code: "561320",
    title: "Help supply services",
  },
  {
    code: "561320",
    title: "Labor (except farm) contractors (i.e., personnel suppliers)",
  },
  {
    code: "561320",
    title: "Labor (except farm) pools",
  },
  {
    code: "561320",
    title: "Manpower pools",
  },
  {
    code: "561320",
    title: "Model supply services",
  },
  {
    code: "561320",
    title: "Office help supply services",
  },
  {
    code: "561320",
    title: "Office supply pools",
  },
  {
    code: "561320",
    title:
      "Online temporary staffing services, including intermediary platform services",
  },
  {
    code: "561320",
    title: "Outplacement consulting services",
  },
  {
    code: "561320",
    title: "Outplacement services",
  },
  {
    code: "561320",
    title:
      "Personnel (e.g., industrial, office, health care, legal, construction) suppliers",
  },
  {
    code: "561320",
    title: "Temporary employment services",
  },
  {
    code: "561320",
    title: "Temporary help services",
  },
  {
    code: "561320",
    title: "Temporary staffing services",
  },
  {
    code: "561330",
    title: "Co-employment staffing services",
  },
  {
    code: "561330",
    title: "Employee leasing services",
  },
  {
    code: "561330",
    title: "Labor leasing services",
  },
  {
    code: "561330",
    title: "PEO (professional employer organizations)",
  },
  {
    code: "561330",
    title: "Professional employer organizations (PEO)",
  },
  {
    code: "561330",
    title: "Staff leasing services",
  },
  {
    code: "561410",
    title: "Desktop publishing services (i.e., document preparation services)",
  },
  {
    code: "561410",
    title: "Dictation services",
  },
  {
    code: "561410",
    title: "Document preparation services",
  },
  {
    code: "561410",
    title: "Document transcription services",
  },
  {
    code: "561410",
    title: "Editing services",
  },
  {
    code: "561410",
    title: "Letter writing services",
  },
  {
    code: "561410",
    title: "Proofreading services",
  },
  {
    code: "561410",
    title: "Radio transcription services",
  },
  {
    code: "561410",
    title: "Resume writing services",
  },
  {
    code: "561410",
    title: "Secretarial services",
  },
  {
    code: "561410",
    title: "Stenographic services (except court or stenographic reporting)",
  },
  {
    code: "561410",
    title: "Technical editing services",
  },
  {
    code: "561410",
    title: "Transcription services",
  },
  {
    code: "561410",
    title: "Typing services",
  },
  {
    code: "561410",
    title: "Word processing services",
  },
  {
    code: "561421",
    title: "Answering services, telephone",
  },
  {
    code: "561421",
    title: "Emergency telephone dispatch (i.e., contractor) services",
  },
  {
    code: "561421",
    title: "Local call centers (e.g., answering services, message services)",
  },
  {
    code: "561421",
    title: "Message services, telephone answering",
  },
  {
    code: "561421",
    title: "Telephone answering services",
  },
  {
    code: "561421",
    title: "Telephone call forwarding services",
  },
  {
    code: "561421",
    title: "Voice mailbox services",
  },
  {
    code: "561421",
    title: "Wakeup call services",
  },
  {
    code: "561422",
    title: "Customer service call centers",
  },
  {
    code: "561422",
    title: "Floral wire services (i.e., telemarketing services)",
  },
  {
    code: "561422",
    title: "Online customer service centers",
  },
  {
    code: "561422",
    title: "Telemarketing bureaus",
  },
  {
    code: "561422",
    title: "Telemarketing services on a contract or fee basis",
  },
  {
    code: "561422",
    title:
      "Telephone call centers (e.g., customer service centers, telemarketing services)",
  },
  {
    code: "561422",
    title: "Telephone solicitation services on a contract or fee basis",
  },
  {
    code: "561422",
    title: "Wire services (i.e., telemarketing services), floral",
  },
  {
    code: "561431",
    title: "Mailbox rental centers, private",
  },
  {
    code: "561431",
    title:
      "Mailbox rental services combined with one or more other office support services, private",
  },
  {
    code: "561431",
    title:
      "Parcel mailing services combined with one or more other office support services, private",
  },
  {
    code: "561431",
    title: "Parcel mailing services, private",
  },
  {
    code: "561431",
    title: "Private mail centers",
  },
  {
    code: "561431",
    title: "Private mailbox rental centers",
  },
  {
    code: "561439",
    title: "Blueprinting services",
  },
  {
    code: "561439",
    title: "Business service centers (except private mail centers)",
  },
  {
    code: "561439",
    title:
      "Business service centers (except private mail centers) providing range of office support services (except printing)",
  },
  {
    code: "561439",
    title: "Copy centers (except combined with printing services)",
  },
  {
    code: "561439",
    title: "Copy shops (except combined with printing services)",
  },
  {
    code: "561439",
    title: "Document copying services (except combined with printing services)",
  },
  {
    code: "561439",
    title:
      "Document duplicating services (except combined with printing services)",
  },
  {
    code: "561439",
    title: "Internet cafes (i.e., not serving food and beverages)",
  },
  {
    code: "561439",
    title: "Photocopying services (except combined with printing services)",
  },
  {
    code: "561439",
    title: "Reprographic services",
  },
  {
    code: "561440",
    title: "Account collection services",
  },
  {
    code: "561440",
    title: "Adjustment agencies (except insurance)",
  },
  {
    code: "561440",
    title: "Bill collection services",
  },
  {
    code: "561440",
    title: "Collection agencies",
  },
  {
    code: "561440",
    title: "Collection agencies, accounts",
  },
  {
    code: "561440",
    title: "Credit arrears collection services",
  },
  {
    code: "561440",
    title: "Debt collection services",
  },
  {
    code: "561440",
    title: "Delinquent account collection services",
  },
  {
    code: "561440",
    title: "Tax collection services on a contract or fee basis",
  },
  {
    code: "561450",
    title: "Commercial credit reporting bureaus",
  },
  {
    code: "561450",
    title: "Consumer credit reporting bureaus",
  },
  {
    code: "561450",
    title: "Credit agencies",
  },
  {
    code: "561450",
    title: "Credit bureaus",
  },
  {
    code: "561450",
    title: "Credit clearinghouses",
  },
  {
    code: "561450",
    title: "Credit investigation services",
  },
  {
    code: "561450",
    title: "Credit rating services",
  },
  {
    code: "561450",
    title: "Credit reporting bureaus",
  },
  {
    code: "561450",
    title: "Investigation services, credit",
  },
  {
    code: "561450",
    title: "Mercantile credit reporting bureaus",
  },
  {
    code: "561491",
    title: "Automobile repossession services",
  },
  {
    code: "561491",
    title: "Repossession services",
  },
  {
    code: "561492",
    title: "Closed captioning services, real-time (i.e., simultaneous)",
  },
  {
    code: "561492",
    title: "Court reporting services",
  },
  {
    code: "561492",
    title: "Deposition services",
  },
  {
    code: "561492",
    title: "Public stenography services",
  },
  {
    code: "561492",
    title:
      "Real-time (i.e., simultaneous) closed captioning of live television performances, meetings, conferences, and so forth",
  },
  {
    code: "561492",
    title: "Stenography services, public",
  },
  {
    code: "561492",
    title: "Stenotype recording services",
  },
  {
    code: "561499",
    title: "Address bar coding services",
  },
  {
    code: "561499",
    title: "Bar code imprinting services",
  },
  {
    code: "561499",
    title:
      "Charitable fundraising campaign organization services on a contract or fee basis",
  },
  {
    code: "561499",
    title:
      "Charitable fundraising using a crowdfunding platform, on a contract or fee basis",
  },
  {
    code: "561499",
    title: "Mail consolidation services",
  },
  {
    code: "561499",
    title: "Mail presorting services",
  },
  {
    code: "561499",
    title: "Medical coding services, not combined with accounting services",
  },
  {
    code: "561499",
    title: "Teleconferencing services",
  },
  {
    code: "561499",
    title: "Videoconferencing services",
  },
  {
    code: "561510",
    title: "Online travel agencies",
  },
  {
    code: "561510",
    title: "Travel agencies",
  },
  {
    code: "561510",
    title: "Travel management services",
  },
  {
    code: "561520",
    title: "Tour operators (i.e., arranging and assembling tours)",
  },
  {
    code: "561520",
    title: "Travel tour operators",
  },
  {
    code: "561520",
    title: "Wholesale tour operators",
  },
  {
    code: "561591",
    title: "Convention and visitors bureaus",
  },
  {
    code: "561591",
    title: "Convention bureaus",
  },
  {
    code: "561591",
    title: "Tourism bureaus",
  },
  {
    code: "561591",
    title: "Tourist information bureaus",
  },
  {
    code: "561591",
    title: "Visitor information centers",
  },
  {
    code: "561591",
    title: "Visitors bureaus",
  },
  {
    code: "561599",
    title: "Airline reservation services",
  },
  {
    code: "561599",
    title: "Airline ticket offices",
  },
  {
    code: "561599",
    title: "Automobile clubs, road and travel services",
  },
  {
    code: "561599",
    title: "Booking (e.g., airline, car rental, hotel, restaurant) services",
  },
  {
    code: "561599",
    title: "Bus ticket offices",
  },
  {
    code: "561599",
    title: "Car rental reservation services",
  },
  {
    code: "561599",
    title: "Concert ticket offices",
  },
  {
    code: "561599",
    title: "Condominium time-share exchange services",
  },
  {
    code: "561599",
    title: "Cruise reservation services",
  },
  {
    code: "561599",
    title: "Cruise ship ticket offices",
  },
  {
    code: "561599",
    title: "Hotel reservation services",
  },
  {
    code: "561599",
    title: "Motor travel clubs",
  },
  {
    code: "561599",
    title:
      "Online accommodations reservation services (through a website or mobile application)",
  },
  {
    code: "561599",
    title:
      "Online airline reservation services (through a website or mobile application)",
  },
  {
    code: "561599",
    title:
      "Online cruise reservation services (through a website or mobile application)",
  },
  {
    code: "561599",
    title:
      "Online motor vehicle rental reservation services (through a website or mobile application)",
  },
  {
    code: "561599",
    title:
      "Online ticket (e.g., airline, bus, cruise ship, sports, theatrical) agencies (through a website or mobile application)",
  },
  {
    code: "561599",
    title: "Performing arts ticket offices",
  },
  {
    code: "561599",
    title: "Railroad ticket offices",
  },
  {
    code: "561599",
    title:
      "Reservation (e.g., airline, car rental, hotel, restaurant) services",
  },
  {
    code: "561599",
    title: "Sports ticket offices",
  },
  {
    code: "561599",
    title: "Theatrical ticket offices",
  },
  {
    code: "561599",
    title:
      "Ticket (e.g., airline, bus, cruise ship, sports, theatrical) offices",
  },
  {
    code: "561599",
    title:
      "Ticket (e.g., airline, bus, cruise ship, sports, theatrical) sales offices",
  },
  {
    code: "561599",
    title: "Ticket (e.g., amusement, sports, theatrical) agencies",
  },
  {
    code: "561599",
    title: "Ticket (e.g., amusement, sports, theatrical) sales agencies",
  },
  {
    code: "561599",
    title: "Ticket agencies, amusement",
  },
  {
    code: "561599",
    title: "Ticket agencies, sports",
  },
  {
    code: "561599",
    title: "Ticket agencies, theatrical",
  },
  {
    code: "561599",
    title: "Ticket offices for foreign cruise ship companies",
  },
  {
    code: "561599",
    title: "Time-share exchange services, condominium",
  },
  {
    code: "561611",
    title: "Background check services",
  },
  {
    code: "561611",
    title: "Bounty hunting services",
  },
  {
    code: "561611",
    title: "Detective agencies",
  },
  {
    code: "561611",
    title: "Fingerprint services",
  },
  {
    code: "561611",
    title: "Investigation services (except credit), private",
  },
  {
    code: "561611",
    title: "Investigators, private",
  },
  {
    code: "561611",
    title: "Lie detection services",
  },
  {
    code: "561611",
    title: "Missing person tracing services",
  },
  {
    code: "561611",
    title: "Polygraph services",
  },
  {
    code: "561611",
    title: "Private detective services",
  },
  {
    code: "561611",
    title: "Private investigation services (except credit)",
  },
  {
    code: "561611",
    title: "Skip tracing services",
  },
  {
    code: "561612",
    title: "Body guard services",
  },
  {
    code: "561612",
    title: "Guard dog services",
  },
  {
    code: "561612",
    title: "Guard services",
  },
  {
    code: "561612",
    title: "Parking security services",
  },
  {
    code: "561612",
    title: "Patrol services, security",
  },
  {
    code: "561612",
    title: "Personal protection services (except security systems services)",
  },
  {
    code: "561612",
    title: "Private police services",
  },
  {
    code: "561612",
    title:
      "Property protection services (except armored car, security systems)",
  },
  {
    code: "561612",
    title:
      "Protection services (except armored car, security systems), personal or property",
  },
  {
    code: "561612",
    title: "Protective guard services",
  },
  {
    code: "561612",
    title: "Security guard services",
  },
  {
    code: "561612",
    title: "Security patrol services",
  },
  {
    code: "561613",
    title: "Armored car services",
  },
  {
    code: "561621",
    title: "Alarm system monitoring services",
  },
  {
    code: "561621",
    title:
      "Alarm systems sales combined with installation, repair, or monitoring services",
  },
  {
    code: "561621",
    title: "Burglar alarm monitoring services",
  },
  {
    code: "561621",
    title:
      "Burglar alarm sales combined with installation, repair, or monitoring services",
  },
  {
    code: "561621",
    title: "Fire alarm monitoring services",
  },
  {
    code: "561621",
    title:
      "Fire alarm sales combined with installation, repair, or monitoring services",
  },
  {
    code: "561621",
    title:
      "Security alarm systems sales combined with installation, repair, or monitoring services",
  },
  {
    code: "561621",
    title: "Security system monitoring services",
  },
  {
    code: "561622",
    title: "Lock rekeying services",
  },
  {
    code: "561622",
    title: "Locksmith services",
  },
  {
    code: "561622",
    title:
      "Locksmith services with or without sales of locking devices, safes, and security vaults",
  },
  {
    code: "561622",
    title: "Locksmith shops",
  },
  {
    code: "561710",
    title: "Bird proofing services",
  },
  {
    code: "561710",
    title: "Exterminating services",
  },
  {
    code: "561710",
    title: "Fumigating services (except crop fumigating)",
  },
  {
    code: "561710",
    title: "Mosquito eradication services",
  },
  {
    code: "561710",
    title: "Pest (e.g., termite) inspection services",
  },
  {
    code: "561710",
    title: "Pest control (except agricultural, forestry) services",
  },
  {
    code: "561710",
    title: "Termite control services",
  },
  {
    code: "561720",
    title: "Aircraft janitorial services",
  },
  {
    code: "561720",
    title: "Building cleaning services, interior",
  },
  {
    code: "561720",
    title: "Building cleaning services, janitorial",
  },
  {
    code: "561720",
    title: "Cleaning homes",
  },
  {
    code: "561720",
    title: "Cleaning offices",
  },
  {
    code: "561720",
    title: "Cleaning shopping centers",
  },
  {
    code: "561720",
    title: "Custodial services",
  },
  {
    code: "561720",
    title: "Deodorant servicing of rest rooms",
  },
  {
    code: "561720",
    title: "Deodorizing services",
  },
  {
    code: "561720",
    title: "Disinfecting services",
  },
  {
    code: "561720",
    title: "Housekeeping services (i.e., cleaning services)",
  },
  {
    code: "561720",
    title: "Janitorial services",
  },
  {
    code: "561720",
    title: "Janitorial services, aircraft",
  },
  {
    code: "561720",
    title: "Maid services (i.e., cleaning services)",
  },
  {
    code: "561720",
    title: "Office cleaning services",
  },
  {
    code: "561720",
    title: "Residential cleaning services",
  },
  {
    code: "561720",
    title: "Rest room cleaning services",
  },
  {
    code: "561720",
    title: "Restaurant kitchen cleaning services",
  },
  {
    code: "561720",
    title: "Service station cleaning and degreasing services",
  },
  {
    code: "561720",
    title: "Venetian blind cleaning services",
  },
  {
    code: "561720",
    title: "Washroom sanitation services",
  },
  {
    code: "561720",
    title: "Window cleaning services",
  },
  {
    code: "561730",
    title: "Arborist services",
  },
  {
    code: "561730",
    title: "Cemetery plot care services",
  },
  {
    code: "561730",
    title: "Fertilizing lawns",
  },
  {
    code: "561730",
    title: "Garden maintenance services",
  },
  {
    code: "561730",
    title: "Hydroseeding services (e.g., decorative, erosion control purposes)",
  },
  {
    code: "561730",
    title: "Interior landscaping services",
  },
  {
    code: "561730",
    title: "Landscape care and maintenance services",
  },
  {
    code: "561730",
    title: "Landscape contractors (except construction)",
  },
  {
    code: "561730",
    title: "Landscape installation services",
  },
  {
    code: "561730",
    title: "Landscaping services (except planning)",
  },
  {
    code: "561730",
    title: "Lawn care services (e.g., fertilizing, mowing, seeding, spraying)",
  },
  {
    code: "561730",
    title: "Lawn fertilizing services",
  },
  {
    code: "561730",
    title: "Lawn irrigation services",
  },
  {
    code: "561730",
    title: "Lawn maintenance services",
  },
  {
    code: "561730",
    title: "Lawn mowing services",
  },
  {
    code: "561730",
    title: "Lawn mulching services",
  },
  {
    code: "561730",
    title: "Lawn seeding services",
  },
  {
    code: "561730",
    title: "Lawn spraying services",
  },
  {
    code: "561730",
    title: "Line slash (i.e., rights of way) maintenance services",
  },
  {
    code: "561730",
    title: "Maintenance of plants and shrubs in buildings",
  },
  {
    code: "561730",
    title: "Mowing services (e.g., highway, lawn, road strip)",
  },
  {
    code: "561730",
    title: "Ornamental tree and shrub services",
  },
  {
    code: "561730",
    title: "Plant and shrub maintenance in buildings",
  },
  {
    code: "561730",
    title: "Plant maintenance services",
  },
  {
    code: "561730",
    title: "Pruning services, ornamental tree and shrub",
  },
  {
    code: "561730",
    title:
      "Seasonal property maintenance services (i.e., snow plowing in winter, landscaping during other seasons)",
  },
  {
    code: "561730",
    title: "Seeding lawns",
  },
  {
    code: "561730",
    title:
      "Shrub services (e.g., bracing, planting, pruning, removal, spraying, surgery, trimming)",
  },
  {
    code: "561730",
    title:
      "Snow plowing services combined with landscaping services (i.e., seasonal property maintenance services)",
  },
  {
    code: "561730",
    title: "Sod laying services",
  },
  {
    code: "561730",
    title: "Spraying lawns",
  },
  {
    code: "561730",
    title: "Tree and brush trimming, overhead utility line",
  },
  {
    code: "561730",
    title: "Tree pruning services",
  },
  {
    code: "561730",
    title: "Tree removal services",
  },
  {
    code: "561730",
    title:
      "Tree services (e.g., bracing, planting, pruning, removal, spraying, surgery, trimming)",
  },
  {
    code: "561730",
    title: "Tree surgery services",
  },
  {
    code: "561730",
    title: "Tree trimming services",
  },
  {
    code: "561730",
    title: "Tropical plant maintenance services",
  },
  {
    code: "561730",
    title: "Turf (except artificial) installation services",
  },
  {
    code: "561730",
    title: "Weed control and fertilizing services (except crop)",
  },
  {
    code: "561740",
    title: "Carpet cleaning on customers' premises",
  },
  {
    code: "561740",
    title: "Carpet cleaning plants",
  },
  {
    code: "561740",
    title: "Carpet cleaning services",
  },
  {
    code: "561740",
    title: "Cleaning carpets",
  },
  {
    code: "561740",
    title: "Cleaning plants, carpet and rug",
  },
  {
    code: "561740",
    title: "Cleaning rugs",
  },
  {
    code: "561740",
    title: "Cleaning services, carpet and rug",
  },
  {
    code: "561740",
    title: "Furniture cleaning on customers' premises",
  },
  {
    code: "561740",
    title: "Furniture cleaning services",
  },
  {
    code: "561740",
    title: "Rug cleaning plants",
  },
  {
    code: "561740",
    title: "Rug cleaning services",
  },
  {
    code: "561740",
    title: "Upholstery cleaning on customers' premises",
  },
  {
    code: "561740",
    title: "Upholstery cleaning services",
  },
  {
    code: "561790",
    title:
      "Building exterior cleaning services (except sandblasting, window cleaning) ",
  },
  {
    code: "561790",
    title:
      "Building gas systems conversion (e.g., from manufactured to natural gas) services",
  },
  {
    code: "561790",
    title: "Chimney cleaning services",
  },
  {
    code: "561790",
    title: "Chimney sweep (i.e., cleaning) services",
  },
  {
    code: "561790",
    title:
      "Cleaning (e.g., power sweeping, washing) driveways and parking lots",
  },
  {
    code: "561790",
    title:
      "Cleaning building exteriors (except sandblasting, window cleaning) ",
  },
  {
    code: "561790",
    title: "Cleaning swimming pools",
  },
  {
    code: "561790",
    title: "Commercial kitchen exhaust hood cleaning services",
  },
  {
    code: "561790",
    title: "Drain cleaning services",
  },
  {
    code: "561790",
    title: "Driveway cleaning (e.g., power sweeping, washing) services",
  },
  {
    code: "561790",
    title: "Duct cleaning services",
  },
  {
    code: "561790",
    title: "Gutter cleaning services",
  },
  {
    code: "561790",
    title:
      "Lighting maintenance services (e.g., bulb and fuse replacement and cleaning)",
  },
  {
    code: "561790",
    title: "Parking lot cleaning (e.g., power sweeping, washing) services",
  },
  {
    code: "561790",
    title: "Power washing building exteriors",
  },
  {
    code: "561790",
    title: "Pressure washing (e.g., buildings, decks, fences)",
  },
  {
    code: "561790",
    title:
      "Snow plowing driveways and parking lots (i.e., not combined with any other service)",
  },
  {
    code: "561790",
    title: "Steam cleaning building exteriors",
  },
  {
    code: "561790",
    title: "Swimming pool cleaning and maintenance services",
  },
  {
    code: "561790",
    title: "Ventilation duct cleaning services",
  },
  {
    code: "561910",
    title: "Apparel folding and packaging services",
  },
  {
    code: "561910",
    title: "Blister packaging services",
  },
  {
    code: "561910",
    title: "Cosmetic kit assembling and packaging services",
  },
  {
    code: "561910",
    title: "Folding and packaging services, textile and apparel",
  },
  {
    code: "561910",
    title: "Gift wrapping services",
  },
  {
    code: "561910",
    title: "Kit assembling and packaging services",
  },
  {
    code: "561910",
    title: "Labeling services",
  },
  {
    code: "561910",
    title: "Mounting merchandise on cards",
  },
  {
    code: "561910",
    title: "Packaging services (except packing and crating for transportation)",
  },
  {
    code: "561910",
    title: "Parcel packing services",
  },
  {
    code: "561910",
    title: "Product sterilization and packaging services",
  },
  {
    code: "561910",
    title: "Shrink wrapping services",
  },
  {
    code: "561910",
    title: "Skin blister packaging services",
  },
  {
    code: "561910",
    title: "Textile folding and packaging services",
  },
  {
    code: "561920",
    title: "Automobile show managers",
  },
  {
    code: "561920",
    title: "Automobile show organizers",
  },
  {
    code: "561920",
    title: "Automobile show promoters",
  },
  {
    code: "561920",
    title: "Convention managers",
  },
  {
    code: "561920",
    title: "Convention or trade show event planners",
  },
  {
    code: "561920",
    title: "Convention organizers",
  },
  {
    code: "561920",
    title: "Convention promoters",
  },
  {
    code: "561920",
    title: "Convention services",
  },
  {
    code: "561920",
    title: "Craft fair managers",
  },
  {
    code: "561920",
    title: "Craft fair organizers",
  },
  {
    code: "561920",
    title: "Craft fair promoters",
  },
  {
    code: "561920",
    title: "Event and meeting planning services",
  },
  {
    code: "561920",
    title: "Flower show managers",
  },
  {
    code: "561920",
    title: "Flower show organizers",
  },
  {
    code: "561920",
    title: "Flower show promoters",
  },
  {
    code: "561920",
    title: "Home show managers",
  },
  {
    code: "561920",
    title: "Home show organizers",
  },
  {
    code: "561920",
    title: "Home show promoters",
  },
  {
    code: "561920",
    title: "Managers, convention",
  },
  {
    code: "561920",
    title: "Managers, trade fair or show",
  },
  {
    code: "561920",
    title: "Promoters of conventions with or without facilities",
  },
  {
    code: "561920",
    title: "Promoters of trade fairs or shows with or without facilities",
  },
  {
    code: "561920",
    title: "Trade fair managers",
  },
  {
    code: "561920",
    title: "Trade fair organizers",
  },
  {
    code: "561920",
    title: "Trade fair promoters",
  },
  {
    code: "561920",
    title: "Trade show managers",
  },
  {
    code: "561920",
    title: "Trade show organizers",
  },
  {
    code: "561920",
    title: "Trade show promoters",
  },
  {
    code: "561990",
    title: "Auctioneers, independent",
  },
  {
    code: "561990",
    title: "Bartering services",
  },
  {
    code: "561990",
    title: "Bottle exchanges",
  },
  {
    code: "561990",
    title: "Coin pick-up services, parking meter",
  },
  {
    code: "561990",
    title: "Coupon processing services",
  },
  {
    code: "561990",
    title: "Coupon redemption services (i.e., clearinghouse)",
  },
  {
    code: "561990",
    title: "Diving services on a contract or fee basis",
  },
  {
    code: "561990",
    title: "Document shredding services",
  },
  {
    code: "561990",
    title: "Electrical meter reading services, contract",
  },
  {
    code: "561990",
    title: "Firefighting services as a commercial activity",
  },
  {
    code: "561990",
    title: "Flagging (i.e., traffic control) services",
  },
  {
    code: "561990",
    title: "Float decorating services",
  },
  {
    code: "561990",
    title: "Gas meter reading services, contract",
  },
  {
    code: "561990",
    title: "Inventory computing services",
  },
  {
    code: "561990",
    title: "Inventory taking services",
  },
  {
    code: "561990",
    title: "License issuing services (except government), motor vehicle",
  },
  {
    code: "561990",
    title: "Locating underground utility lines prior to digging",
  },
  {
    code: "561990",
    title: "Lumber grading services",
  },
  {
    code: "561990",
    title: "Meter reading services, contract",
  },
  {
    code: "561990",
    title: "Motor vehicle license issuing services, private franchise",
  },
  {
    code: "561990",
    title: "Museum cataloging services",
  },
  {
    code: "561990",
    title: "Printing brokers",
  },
  {
    code: "561990",
    title: "Private volunteer firefighting",
  },
  {
    code: "561990",
    title: "Trading stamp promotion and sale to stores",
  },
  {
    code: "561990",
    title: "Trading stamp redemption services",
  },
  {
    code: "561990",
    title: "Water softening and conditioning services",
  },
  {
    code: "562111",
    title: "Ash collection services",
  },
  {
    code: "562111",
    title: "Ash hauling, local",
  },
  {
    code: "562111",
    title: "Garbage collection services",
  },
  {
    code: "562111",
    title: "Garbage hauling, local",
  },
  {
    code: "562111",
    title: "Garbage pick-up services",
  },
  {
    code: "562111",
    title: "Recyclable material collection services",
  },
  {
    code: "562111",
    title: "Recyclable material hauling, local",
  },
  {
    code: "562111",
    title: "Refuse collection services",
  },
  {
    code: "562111",
    title: "Refuse hauling, local",
  },
  {
    code: "562111",
    title: "Rubbish (i.e., nonhazardous solid waste) hauling, local",
  },
  {
    code: "562111",
    title: "Rubbish collection services",
  },
  {
    code: "562111",
    title: "Trash collection services",
  },
  {
    code: "562111",
    title: "Trash hauling, local",
  },
  {
    code: "562111",
    title: "Waste collection services, nonhazardous solid",
  },
  {
    code: "562111",
    title: "Waste hauling, local, nonhazardous solid",
  },
  {
    code: "562111",
    title: "Waste transfer stations, nonhazardous solid",
  },
  {
    code: "562112",
    title: "Hazardous waste collection services",
  },
  {
    code: "562112",
    title: "Radioactive waste collecting and/or local hauling",
  },
  {
    code: "562112",
    title: "Waste collection services, hazardous",
  },
  {
    code: "562112",
    title: "Waste hauling, local, hazardous",
  },
  {
    code: "562112",
    title: "Waste transfer stations, hazardous",
  },
  {
    code: "562119",
    title: "Brush collection services",
  },
  {
    code: "562119",
    title: "Brush hauling, local",
  },
  {
    code: "562119",
    title: "Brush removal services",
  },
  {
    code: "562119",
    title: "Debris removal services",
  },
  {
    code: "562119",
    title: "Dump trucking of rubble or brush with collection or disposal",
  },
  {
    code: "562119",
    title: "Rubble hauling, local",
  },
  {
    code: "562119",
    title: "Rubble removal services",
  },
  {
    code: "562119",
    title: "Waste (except solid and hazardous) collection services",
  },
  {
    code: "562119",
    title: "Waste (except solid and hazardous) hauling, local",
  },
  {
    code: "562211",
    title: "Acid waste disposal facilities",
  },
  {
    code: "562211",
    title: "Acid waste treatment facilities",
  },
  {
    code: "562211",
    title: "Combustors, hazardous waste",
  },
  {
    code: "562211",
    title: "Hazardous waste disposal facilities",
  },
  {
    code: "562211",
    title:
      "Hazardous waste disposal facilities combined with collection and/or local hauling of hazardous waste",
  },
  {
    code: "562211",
    title: "Hazardous waste material disposal facilities",
  },
  {
    code: "562211",
    title: "Hazardous waste material treatment facilities",
  },
  {
    code: "562211",
    title: "Hazardous waste treatment facilities",
  },
  {
    code: "562211",
    title:
      "Hazardous waste treatment facilities combined with collection and/or local hauling of hazardous waste",
  },
  {
    code: "562211",
    title: "Incinerators, hazardous waste, operating",
  },
  {
    code: "562211",
    title: "Medical waste treatment facilities, hazardous",
  },
  {
    code: "562211",
    title:
      "Radioactive waste collecting and/or local hauling in combination with disposal and/or treatment facilities",
  },
  {
    code: "562211",
    title: "Radioactive waste disposal facilities",
  },
  {
    code: "562211",
    title: "Radioactive waste treatment facilities",
  },
  {
    code: "562211",
    title: "Waste disposal facilities, hazardous",
  },
  {
    code: "562211",
    title: "Waste treatment facilities, hazardous",
  },
  {
    code: "562211",
    title: "Waste treatment plants, hazardous",
  },
  {
    code: "562212",
    title: "Dumps, nonhazardous solid waste (e.g., trash)",
  },
  {
    code: "562212",
    title: "Garbage disposal landfills",
  },
  {
    code: "562212",
    title: "Garbage dumps",
  },
  {
    code: "562212",
    title: "Landfills",
  },
  {
    code: "562212",
    title: "Refuse collecting and operating solid waste landfills",
  },
  {
    code: "562212",
    title: "Refuse disposal landfills",
  },
  {
    code: "562212",
    title: "Rubbish disposal landfills",
  },
  {
    code: "562212",
    title: "Sanitary landfills",
  },
  {
    code: "562212",
    title: "Sludge disposal sites",
  },
  {
    code: "562212",
    title:
      "Solid waste landfills combined with collection and/or local hauling of nonhazardous waste materials",
  },
  {
    code: "562212",
    title: "Solid waste landfills, nonhazardous",
  },
  {
    code: "562212",
    title: "Trash disposal landfills",
  },
  {
    code: "562212",
    title: "Waste disposal landfills, nonhazardous solid",
  },
  {
    code: "562213",
    title: "Combustors, nonhazardous solid waste",
  },
  {
    code: "562213",
    title: "Garbage disposal combustors or incinerators",
  },
  {
    code: "562213",
    title: "Incinerators, nonhazardous solid waste",
  },
  {
    code: "562213",
    title:
      "Power generation, nonhazardous solid waste combustor or incinerator electric",
  },
  {
    code: "562213",
    title: "Refuse disposal combustors or incinerators",
  },
  {
    code: "562213",
    title: "Rubbish disposal combustors or incinerators",
  },
  {
    code: "562213",
    title: "Solid waste combustors or incinerators, nonhazardous",
  },
  {
    code: "562213",
    title: "Trash disposal combustors or incinerators",
  },
  {
    code: "562213",
    title: "Waste disposal combustors or incinerators, nonhazardous solid",
  },
  {
    code: "562219",
    title: "Compost dumps",
  },
  {
    code: "562219",
    title: "Dumps, compost",
  },
  {
    code: "562219",
    title: "Lawn waste disposal facilities",
  },
  {
    code: "562219",
    title:
      "Nonhazardous waste treatment and disposal facilities (except combustors, incinerators, landfills, sewer systems, sewage treatment facilities)",
  },
  {
    code: "562219",
    title: "Waste (except sewage) treatment facilities, nonhazardous",
  },
  {
    code: "562910",
    title: "Asbestos abatement services",
  },
  {
    code: "562910",
    title: "Asbestos removal contractors",
  },
  {
    code: "562910",
    title: "Biohazard cleanup services",
  },
  {
    code: "562910",
    title: "Crime scene cleanup services",
  },
  {
    code: "562910",
    title: "Environmental remediation services",
  },
  {
    code: "562910",
    title: "Hazardous material storage tank removal and disposal services",
  },
  {
    code: "562910",
    title: "Lead paint abatement services",
  },
  {
    code: "562910",
    title: "Lead paint removal contractors",
  },
  {
    code: "562910",
    title:
      "Mine reclamation services, integrated (e.g., demolition, hazardous material removal, soil remediation, revegetation)",
  },
  {
    code: "562910",
    title: "Mold remediation services",
  },
  {
    code: "562910",
    title: "Oil spill cleanup services",
  },
  {
    code: "562910",
    title: "Radon remediation cleanup services",
  },
  {
    code: "562910",
    title:
      "Remediation and cleanup of contaminated buildings, mine sites, soil, or ground water",
  },
  {
    code: "562910",
    title: "Remediation services, environmental",
  },
  {
    code: "562910",
    title: "Site remediation services",
  },
  {
    code: "562910",
    title: "Soil remediation services",
  },
  {
    code: "562910",
    title: "Toxic material abatement services",
  },
  {
    code: "562910",
    title: "Toxic material removal contractors",
  },
  {
    code: "562920",
    title: "Materials recovery facilities (MRF)",
  },
  {
    code: "562920",
    title: "MRF (materials recovery facilities)",
  },
  {
    code: "562920",
    title: "Recyclable materials recovery facilities",
  },
  {
    code: "562920",
    title: "Removal of recyclable materials from a waste stream",
  },
  {
    code: "562920",
    title: "Waste recovery facilities",
  },
  {
    code: "562991",
    title: "Cesspool cleaning services",
  },
  {
    code: "562991",
    title: "Portable toilet pumping (i.e., cleaning) services",
  },
  {
    code: "562991",
    title: "Portable toilet renting and/or servicing",
  },
  {
    code: "562991",
    title: "Pumping (i.e., cleaning) cesspools and septic tanks",
  },
  {
    code: "562991",
    title: "Pumping (i.e., cleaning) portable toilets",
  },
  {
    code: "562991",
    title: "Septic tank cleaning services",
  },
  {
    code: "562991",
    title: "Septic tank pumping (i.e., cleaning) services",
  },
  {
    code: "562991",
    title: "Tank cleaning services, septic",
  },
  {
    code: "562991",
    title: "Toilet renting and/or servicing, portable",
  },
  {
    code: "562998",
    title: "Beach maintenance and cleaning services",
  },
  {
    code: "562998",
    title: "Catch basin cleaning services",
  },
  {
    code: "562998",
    title:
      "Disaster recovery services (i.e., cleanup, salvaging), without providing remediation services",
  },
  {
    code: "562998",
    title: "Grease trap cleaning",
  },
  {
    code: "562998",
    title: "Lake maintenance and cleaning services",
  },
  {
    code: "562998",
    title: "Pond maintenance and cleaning services",
  },
  {
    code: "562998",
    title: "Reservoir maintenance and cleaning services",
  },
  {
    code: "562998",
    title: "Sewer cleaning and rodding services",
  },
  {
    code: "562998",
    title: "Sewer cleanout services",
  },
  {
    code: "562998",
    title: "Storm basin cleanout services",
  },
  {
    code: "562998",
    title: "Tank cleaning and disposal services, commercial or industrial",
  },
  {
    code: "611110",
    title: "Academies, elementary or secondary",
  },
  {
    code: "611110",
    title: "Boarding schools, elementary or secondary",
  },
  {
    code: "611110",
    title: "Charter schools",
  },
  {
    code: "611110",
    title: "Elementary and secondary schools",
  },
  {
    code: "611110",
    title: "Elementary schools",
  },
  {
    code: "611110",
    title: "Finishing schools, secondary",
  },
  {
    code: "611110",
    title: "High schools",
  },
  {
    code: "611110",
    title: "High schools offering both academic and technical courses",
  },
  {
    code: "611110",
    title: "High schools offering both academic and vocational courses",
  },
  {
    code: "611110",
    title: "Junior high schools",
  },
  {
    code: "611110",
    title: "Kindergartens",
  },
  {
    code: "611110",
    title: "Kindergartens, combined with preschools",
  },
  {
    code: "611110",
    title: "Middle schools",
  },
  {
    code: "611110",
    title: "Military academies, elementary or secondary",
  },
  {
    code: "611110",
    title: "Montessori schools, elementary or secondary",
  },
  {
    code: "611110",
    title: "Parochial schools, elementary or secondary",
  },
  {
    code: "611110",
    title: "Preparatory schools, elementary or secondary",
  },
  {
    code: "611110",
    title: "Primary schools",
  },
  {
    code: "611110",
    title: "Private schools, elementary or secondary",
  },
  {
    code: "611110",
    title: "Public schools, elementary or secondary",
  },
  {
    code: "611110",
    title: "School boards, elementary and secondary",
  },
  {
    code: "611110",
    title: "School districts, elementary or secondary",
  },
  {
    code: "611110",
    title:
      "Schools for the intellectually and developmentally disabled (except preschool, job training, vocational rehabilitation)",
  },
  {
    code: "611110",
    title: "Schools for the physically disabled, elementary or secondary",
  },
  {
    code: "611110",
    title: "Schools, elementary",
  },
  {
    code: "611110",
    title:
      "Schools, online, elementary- or secondary-level (through a website or mobile application)",
  },
  {
    code: "611110",
    title: "Schools, secondary",
  },
  {
    code: "611110",
    title: "Secondary schools offering both academic and technical courses",
  },
  {
    code: "611110",
    title: "Seminaries, below university grade",
  },
  {
    code: "611210",
    title: "Academies, junior college",
  },
  {
    code: "611210",
    title: "Colleges, community",
  },
  {
    code: "611210",
    title: "Colleges, junior",
  },
  {
    code: "611210",
    title: "Community colleges",
  },
  {
    code: "611210",
    title:
      "Community colleges offering a wide variety of academic and technical training",
  },
  {
    code: "611210",
    title: "Junior colleges",
  },
  {
    code: "611210",
    title:
      "Junior colleges offering a wide variety of academic and technical training",
  },
  {
    code: "611210",
    title: "Schools, junior college",
  },
  {
    code: "611210",
    title: "Schools, junior college vocational",
  },
  {
    code: "611210",
    title:
      "Schools, online, junior college-level (through a website or mobile application)",
  },
  {
    code: "611310",
    title: "Academies, college or university",
  },
  {
    code: "611310",
    title: "Academies, military service (college)",
  },
  {
    code: "611310",
    title: "Bible colleges offering baccalaureate degrees",
  },
  {
    code: "611310",
    title:
      "Business colleges or schools offering baccalaureate or graduate degrees",
  },
  {
    code: "611310",
    title: "Coast Guard Academy",
  },
  {
    code: "611310",
    title: "Colleges (except junior colleges)",
  },
  {
    code: "611310",
    title: "Colleges, universities, and professional schools",
  },
  {
    code: "611310",
    title: "Conservatories of music (colleges or universities)",
  },
  {
    code: "611310",
    title: "Dental schools",
  },
  {
    code: "611310",
    title:
      "Hospital management schools offering baccalaureate or graduate degrees",
  },
  {
    code: "611310",
    title:
      "Hospitality management schools offering baccalaureate or graduate degrees",
  },
  {
    code: "611310",
    title: "Law schools",
  },
  {
    code: "611310",
    title: "Medical schools",
  },
  {
    code: "611310",
    title: "Military academies, college-level",
  },
  {
    code: "611310",
    title: "Military service academies (college)",
  },
  {
    code: "611310",
    title: "Parochial schools, college-level",
  },
  {
    code: "611310",
    title: "Private colleges (except community or junior college)",
  },
  {
    code: "611310",
    title:
      "Professional schools (e.g., business administration, dental, law, medical)",
  },
  {
    code: "611310",
    title: "Schools, correspondence, college-level",
  },
  {
    code: "611310",
    title: "Schools, medical",
  },
  {
    code: "611310",
    title: "Schools, music (colleges or universities)",
  },
  {
    code: "611310",
    title:
      "Schools, online, college-level (through a website or mobile application)",
  },
  {
    code: "611310",
    title: "Schools, professional (colleges or universities)",
  },
  {
    code: "611310",
    title:
      "Seminaries, theological, offering baccalaureate or graduate degrees",
  },
  {
    code: "611310",
    title: "Theological seminaries offering baccalaureate or graduate degrees",
  },
  {
    code: "611310",
    title: "Universities",
  },
  {
    code: "611410",
    title: "Business colleges or schools not offering academic degrees",
  },
  {
    code: "611410",
    title: "Business schools not offering academic degrees",
  },
  {
    code: "611410",
    title: "Clerical schools ",
  },
  {
    code: "611410",
    title: "Court reporting schools",
  },
  {
    code: "611410",
    title: "Schools, business, not offering academic degrees",
  },
  {
    code: "611410",
    title: "Secretarial schools",
  },
  {
    code: "611420",
    title: "Computer operator training",
  },
  {
    code: "611420",
    title: "Computer programming schools",
  },
  {
    code: "611420",
    title:
      "Computer programming, software, and systems training, online (through a website or mobile application)",
  },
  {
    code: "611420",
    title:
      "Computer programming, software, and systems training, online learning marketplace services (through a website or mobile application)",
  },
  {
    code: "611420",
    title: "Computer software training",
  },
  {
    code: "611420",
    title: "Computer training (except repair)",
  },
  {
    code: "611420",
    title: "Local area network (LAN) management training",
  },
  {
    code: "611420",
    title: "Software application training",
  },
  {
    code: "611430",
    title:
      "Continuing education online learning marketplace services (through a website or mobile application)",
  },
  {
    code: "611430",
    title: "Continuing education seminars or conferences",
  },
  {
    code: "611430",
    title:
      "Continuing education training, online (through a website or mobile application)",
  },
  {
    code: "611430",
    title: "Management development training",
  },
  {
    code: "611430",
    title: "Professional development training",
  },
  {
    code: "611430",
    title: "Quality assurance training",
  },
  {
    code: "611511",
    title: "Barber colleges",
  },
  {
    code: "611511",
    title: "Beauty schools",
  },
  {
    code: "611511",
    title: "Colleges, barber and beauty",
  },
  {
    code: "611511",
    title: "Cosmetic art schools (e.g., makeup, skin care)",
  },
  {
    code: "611511",
    title: "Cosmetology schools",
  },
  {
    code: "611511",
    title: "Manicure and pedicure schools",
  },
  {
    code: "611511",
    title: "Schools, barber",
  },
  {
    code: "611511",
    title: "Schools, beauty",
  },
  {
    code: "611511",
    title: "Schools, cosmetology",
  },
  {
    code: "611512",
    title: "Aviation schools",
  },
  {
    code: "611512",
    title: "Flight simulation training",
  },
  {
    code: "611512",
    title: "Flight training schools",
  },
  {
    code: "611512",
    title: "Flying instruction",
  },
  {
    code: "611512",
    title: "Military flight instruction training",
  },
  {
    code: "611512",
    title: "Schools, aviation",
  },
  {
    code: "611513",
    title: "Apprenticeship training programs",
  },
  {
    code: "611513",
    title: "Carpenters' apprenticeship training",
  },
  {
    code: "611513",
    title: "Craft union apprenticeship training programs",
  },
  {
    code: "611513",
    title: "Electricians' apprenticeship training",
  },
  {
    code: "611513",
    title: "Mechanic's apprenticeship training",
  },
  {
    code: "611513",
    title: "Plumbers' apprenticeship training",
  },
  {
    code: "611513",
    title: "Sheet metal workers' apprenticeship training",
  },
  {
    code: "611513",
    title: "Steam fitters' apprenticeship training",
  },
  {
    code: "611513",
    title: "Trade union apprenticeship training programs",
  },
  {
    code: "611513",
    title: "Vocational apprenticeship training",
  },
  {
    code: "611519",
    title: "Acupuncture training",
  },
  {
    code: "611519",
    title: "Air traffic control schools",
  },
  {
    code: "611519",
    title: "Art schools, commercial or graphic",
  },
  {
    code: "611519",
    title: "Banking schools (training in banking)",
  },
  {
    code: "611519",
    title: "Bartending schools",
  },
  {
    code: "611519",
    title: "Broadcasting schools",
  },
  {
    code: "611519",
    title: "Bus driver training",
  },
  {
    code: "611519",
    title: "Chauffeur training",
  },
  {
    code: "611519",
    title: "Computer repair training",
  },
  {
    code: "611519",
    title: "Cooking schools",
  },
  {
    code: "611519",
    title: "Culinary arts schools",
  },
  {
    code: "611519",
    title: "Dental hygienist schools",
  },
  {
    code: "611519",
    title: "Dental technician schools",
  },
  {
    code: "611519",
    title: "Electronic equipment repair training",
  },
  {
    code: "611519",
    title: "Firefighter training schools",
  },
  {
    code: "611519",
    title: "Flight attendant schools",
  },
  {
    code: "611519",
    title: "Graphic arts schools",
  },
  {
    code: "611519",
    title: "Heavy equipment operation schools",
  },
  {
    code: "611519",
    title: "Heavy equipment repair training",
  },
  {
    code: "611519",
    title: "Home health aid schools",
  },
  {
    code: "611519",
    title: "Hospital management schools (except academic)",
  },
  {
    code: "611519",
    title: "Hospitality management schools (except academic)",
  },
  {
    code: "611519",
    title: "Marine navigational schools",
  },
  {
    code: "611519",
    title: "Massage therapist instruction",
  },
  {
    code: "611519",
    title: "Mechanic's schools (except apprenticeship)",
  },
  {
    code: "611519",
    title: "Medical technician schools",
  },
  {
    code: "611519",
    title: "Modeling schools",
  },
  {
    code: "611519",
    title: "Nurse's aides schools",
  },
  {
    code: "611519",
    title: "Nursing schools (except academic)",
  },
  {
    code: "611519",
    title: "Personal fitness instructor training",
  },
  {
    code: "611519",
    title: "Photography schools, commercial",
  },
  {
    code: "611519",
    title: "Police training schools",
  },
  {
    code: "611519",
    title: "Real estate schools",
  },
  {
    code: "611519",
    title: "Restaurant management schools (except academic)",
  },
  {
    code: "611519",
    title: "Security guard training",
  },
  {
    code: "611519",
    title:
      "Specialized military training (except flight instruction, academies, and basic training)",
  },
  {
    code: "611519",
    title: "Truck driving schools",
  },
  {
    code: "611519",
    title: "Yoga instructor training",
  },
  {
    code: "611610",
    title: "Art (except commercial or graphic) instruction",
  },
  {
    code: "611610",
    title: "Art schools (except academic), fine",
  },
  {
    code: "611610",
    title: "Ballet schools (except academic)",
  },
  {
    code: "611610",
    title: "Ceramics instruction",
  },
  {
    code: "611610",
    title: "Conservatory of music (except academic)",
  },
  {
    code: "611610",
    title: "Dance instruction",
  },
  {
    code: "611610",
    title: "Dance schools",
  },
  {
    code: "611610",
    title: "Dance studios",
  },
  {
    code: "611610",
    title: "Drama schools (except academic)",
  },
  {
    code: "611610",
    title: "Fine arts schools (except academic)",
  },
  {
    code: "611610",
    title: "Handicrafts instruction",
  },
  {
    code: "611610",
    title: "Music instruction (e.g., guitar, piano)",
  },
  {
    code: "611610",
    title: "Music schools (except academic)",
  },
  {
    code: "611610",
    title: "Painting instruction",
  },
  {
    code: "611610",
    title: "Performing arts schools (except academic)",
  },
  {
    code: "611610",
    title: "Photography schools, art",
  },
  {
    code: "611610",
    title: "Schools, drama (except academic)",
  },
  {
    code: "611610",
    title: "Schools, music (except academic)",
  },
  {
    code: "611610",
    title: "Sculpture instruction",
  },
  {
    code: "611610",
    title: "Singing instruction",
  },
  {
    code: "611610",
    title: "Theater schools",
  },
  {
    code: "611610",
    title: "Voice instruction",
  },
  {
    code: "611620",
    title: "Academies, riding instruction",
  },
  {
    code: "611620",
    title: "Aerobic dance and exercise instruction",
  },
  {
    code: "611620",
    title: "Automobile racing schools",
  },
  {
    code: "611620",
    title: "Baseball instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Basketball instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Baton instruction",
  },
  {
    code: "611620",
    title: "Bowling instruction",
  },
  {
    code: "611620",
    title: "Boys' camps, sports instruction",
  },
  {
    code: "611620",
    title: "Boys' camps, sports instructor",
  },
  {
    code: "611620",
    title: "Camps, sports instruction",
  },
  {
    code: "611620",
    title: "Cheerleading instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Football instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Girls' camps, sports instruction",
  },
  {
    code: "611620",
    title: "Golf instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Gymnastics instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Hockey instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Jai alai instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Judo instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Karate instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Martial arts instruction, camps or schools",
  },
  {
    code: "611620",
    title:
      "Professional sports (e.g., golf, skiing, swimming, tennis) instructors (i.e., not participating in sporting events)",
  },
  {
    code: "611620",
    title: "Riding instruction academies or schools",
  },
  {
    code: "611620",
    title: "Schools, sports instruction",
  },
  {
    code: "611620",
    title: "Scuba instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Skiing instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Skin diving instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Sky diving instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Soccer instruction, camps or schools",
  },
  {
    code: "611620",
    title: "Sports camps (e.g., baseball, basketball, football), instructional",
  },
  {
    code: "611620",
    title: "Sports instruction, camps or schools",
  },
  {
    code: "611620",
    title:
      "Sports instructors, independent (i.e., not participating in sporting events)",
  },
  {
    code: "611620",
    title: "Swimming instruction",
  },
  {
    code: "611620",
    title: "Tennis instruction, camps or schools",
  },
  {
    code: "611630",
    title: "Foreign language schools",
  },
  {
    code: "611630",
    title: "Language schools",
  },
  {
    code: "611630",
    title: "Schools, language",
  },
  {
    code: "611630",
    title: "Second language instruction",
  },
  {
    code: "611630",
    title: "Sign language instruction",
  },
  {
    code: "611630",
    title: "Sign language schools",
  },
  {
    code: "611691",
    title: "Academic tutoring services",
  },
  {
    code: "611691",
    title: "Adult literacy instruction",
  },
  {
    code: "611691",
    title: "College board preparation centers",
  },
  {
    code: "611691",
    title: "College entrance exam preparation instruction",
  },
  {
    code: "611691",
    title:
      "Exam preparation and tutoring online learning marketplace services (through a website or mobile application)",
  },
  {
    code: "611691",
    title:
      "Exam preparation and tutoring services, online (through a website or mobile application)",
  },
  {
    code: "611691",
    title: "Exam preparation services",
  },
  {
    code: "611691",
    title: "High school equivalency (e.g., GED) exam instruction",
  },
  {
    code: "611691",
    title: "Learning centers offering remedial courses",
  },
  {
    code: "611691",
    title: "Professional examination review instruction",
  },
  {
    code: "611691",
    title: "Tutoring,  academic",
  },
  {
    code: "611692",
    title: "Automobile driving schools",
  },
  {
    code: "611692",
    title: "Driver education",
  },
  {
    code: "611692",
    title: "Driver training schools (except bus, heavy equipment, truck)",
  },
  {
    code: "611692",
    title: "Motorcycle driving schools",
  },
  {
    code: "611699",
    title: "Bible schools (except degree granting)",
  },
  {
    code: "611699",
    title: "Bridge and other card game instruction",
  },
  {
    code: "611699",
    title: "Charm schools",
  },
  {
    code: "611699",
    title: "Chess instruction",
  },
  {
    code: "611699",
    title: "CPR (cardiopulmonary resuscitation) training and certification",
  },
  {
    code: "611699",
    title: "Diction schools",
  },
  {
    code: "611699",
    title: "Firearms training",
  },
  {
    code: "611699",
    title: "First-aid instruction",
  },
  {
    code: "611699",
    title: "Life guard training",
  },
  {
    code: "611699",
    title: "Personal development schools",
  },
  {
    code: "611699",
    title: "Pilates instruction, camps or schools",
  },
  {
    code: "611699",
    title: "Public speaking training",
  },
  {
    code: "611699",
    title: "Self defense (except martial arts) instruction",
  },
  {
    code: "611699",
    title: "Speed reading instruction",
  },
  {
    code: "611699",
    title: "Survival training instruction",
  },
  {
    code: "611699",
    title: "Yoga instruction, camps or schools",
  },
  {
    code: "611710",
    title: "Career and vocational counseling services (except rehabilitative)",
  },
  {
    code: "611710",
    title: "College selection services",
  },
  {
    code: "611710",
    title: "Educational consultants",
  },
  {
    code: "611710",
    title: "Educational curriculum development services",
  },
  {
    code: "611710",
    title: "Educational guidance counseling services",
  },
  {
    code: "611710",
    title: "Educational support services",
  },
  {
    code: "611710",
    title: "Educational testing evaluation services",
  },
  {
    code: "611710",
    title: "Educational testing services",
  },
  {
    code: "611710",
    title: "School bus attendant services",
  },
  {
    code: "611710",
    title: "Student exchange programs",
  },
  {
    code: "611710",
    title: "Study abroad programs",
  },
  {
    code: "611710",
    title: "Test development and evaluation services, educational",
  },
  {
    code: "611710",
    title: "Testing services, educational",
  },
  {
    code: "621111",
    title: "Acupuncturists' (MDs or DOs) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Allergists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Anesthesiologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Cardiologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Clinical pathologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Dermatologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "Doctors of osteopathic medicine (DOs, except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "DOs' (doctors of osteopathic medicine, except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Family physicians' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Forensic pathologists' offices ",
  },
  {
    code: "621111",
    title: "Gastroenterologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Gynecologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Health screening services in physicians' offices",
  },
  {
    code: "621111",
    title: "Immunologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Internists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "MDs' (medical doctors, except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "Medical doctors' (MDs, except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Nephrologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Neurologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Neuropathologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Obstetricians' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Oncologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Ophthalmologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Orthopedic physicians' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Orthopedic surgeons' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "Osteopathic physicians' (except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Otolaryngologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "Pathologists' (except oral, speech, voice) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Pathologists', forensic, offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Pathologists', neuropathological, offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Pathologists', surgical, offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "Pediatricians' (except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title:
      "Physicians' (except mental health) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Plastic surgeons' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Proctologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Pulmonary specialists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Radiologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Surgeons' (except dental) offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Surgical pathologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Urologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621111",
    title: "Walk-in physicians' offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title:
      "Doctors of osteopathic medicine (DOs), mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title:
      "DOs' (doctors of osteopathic medicine), mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title:
      "MDs' (medical doctors), mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title:
      "Medical doctors' (MDs), mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title: "Mental health physicians' offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title: "Pediatricians', mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title: "Physicians', mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title: "Psychiatrists' offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title: "Psychoanalysts' (MDs or DOs) offices (e.g., centers, clinics)",
  },
  {
    code: "621112",
    title: "Psychotherapists' (MDs or DOs) offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "DDSs' (doctors of dental surgery) offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Dental surgeons' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Dentists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title:
      "DMDs' (doctors of dental medicine) offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Doctors of dental medicine (DMDs) offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Doctors of dental surgery (DDSs) offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Endodontists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Family dentists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Oral and maxillofacial surgeons' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Oral pathologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Orthodontists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Pathologists', oral, offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Periodontists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Prosthodontists' offices (e.g., centers, clinics)",
  },
  {
    code: "621210",
    title: "Surgeons', dental, offices (e.g., centers, clinics)",
  },
  {
    code: "621310",
    title: "Chiropractors' offices (e.g., centers, clinics)",
  },
  {
    code: "621310",
    title: "DCs' (doctors of chiropractic) offices (e.g., centers, clinics)",
  },
  {
    code: "621310",
    title: "Doctors of chiropractic (DCs) offices (e.g., centers, clinics)",
  },
  {
    code: "621320",
    title: "Doctors of optometry (ODs) offices (e.g., centers, clinics)",
  },
  {
    code: "621320",
    title: "ODs' (doctors of optometry) offices (e.g., centers, clinics)",
  },
  {
    code: "621320",
    title: "Optometrists' offices (e.g., centers, clinics)",
  },
  {
    code: "621330",
    title: "Clinical psychologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621330",
    title: "Doctors of psychology offices (e.g., centers, clinics)",
  },
  {
    code: "621330",
    title:
      "Psychoanalysts' (except MDs or DOs) offices (e.g., centers, clinics)",
  },
  {
    code: "621330",
    title: "Psychologists' offices (e.g., centers, clinics), clinical",
  },
  {
    code: "621330",
    title:
      "Psychotherapists' (except MDs or DOs) offices (e.g., centers, clinics)",
  },
  {
    code: "621330",
    title: "Social workers', mental health, offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Art therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Audiologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Dance therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Equestrian physical therapists' offices (e.g., centers, clinics) ",
  },
  {
    code: "621340",
    title: "Exercise physiologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Hearing testing services by offices of audiologists",
  },
  {
    code: "621340",
    title: "Industrial therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Music therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Occupational therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Pathologists', speech or voice, offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Physical therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Physical therapy offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title:
      "Physical-integration practitioners' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Physiotherapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title:
      "Recreational (e.g., art, dance, music) therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Speech clinicians' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Speech defect clinics",
  },
  {
    code: "621340",
    title: "Speech pathologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Speech therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Sports physical therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621340",
    title: "Voice pathologists' offices (e.g., centers, clinics)",
  },
  {
    code: "621391",
    title: "Doctors of podiatry (DPs) offices (e.g., centers, clinics)",
  },
  {
    code: "621391",
    title: "DPs' (doctors of podiatry) offices (e.g., centers, clinics)",
  },
  {
    code: "621391",
    title: "Foot specialists' (podiatry) offices (e.g., centers, clinics)",
  },
  {
    code: "621391",
    title: "Podiatrists' offices (e.g., centers, clinics)",
  },
  {
    code: "621391",
    title: "Popopediatricians' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title:
      "Acupuncturists' (except MDs or DOs) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title:
      "Advanced practicing registered nurses’ (APRNs) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title:
      "Certified registered nurse anesthetists’ (CRNAs) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Christian Science practitioners' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title:
      "Clinical nurse specialists’ (CNSs) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Clinical pharmacists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Dental hygienists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Denturists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Dietitians' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Herbalists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Home nursing services, private practice",
  },
  {
    code: "621399",
    title: "Homeopaths' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Hypnotherapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Inhalation therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Licensed practical nurses' (LPNs) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "LPNs' (licensed practical nurses) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Manual-arts therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Massage therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Midwives' offices (e.g., clinics)",
  },
  {
    code: "621399",
    title: "Naturopaths' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Nurse practitioners’ offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title:
      "Nurses', licensed practical or registered, offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Nursing call centers",
  },
  {
    code: "621399",
    title: "Nutritionists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Ocularists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Orthotists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Paramedics' offices (e.g.,  centers, clinics)",
  },
  {
    code: "621399",
    title: "Pedorthics' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Physicians' assistants' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Practical nurses' offices (e.g., centers, clinics), licensed",
  },
  {
    code: "621399",
    title: "Prosthetists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Registered nurses' (RNs) offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "Respiratory therapists' offices (e.g., centers, clinics)",
  },
  {
    code: "621399",
    title: "RNs' (registered nurses) offices (e.g., centers, clinics)",
  },
  {
    code: "621410",
    title: "Abortion clinics",
  },
  {
    code: "621410",
    title: "Birth control clinics",
  },
  {
    code: "621410",
    title: "Childbirth preparation classes",
  },
  {
    code: "621410",
    title: "Counseling services, family planning",
  },
  {
    code: "621410",
    title: "Family planning centers",
  },
  {
    code: "621410",
    title: "Family planning counseling services",
  },
  {
    code: "621410",
    title: "Fertility clinics",
  },
  {
    code: "621410",
    title: "Pregnancy counseling centers",
  },
  {
    code: "621410",
    title: "Reproductive health services centers",
  },
  {
    code: "621420",
    title:
      "Alcoholism treatment centers and clinics (except hospitals), outpatient",
  },
  {
    code: "621420",
    title: "Detoxification centers and clinics (except hospitals), outpatient",
  },
  {
    code: "621420",
    title:
      "Drug addiction treatment centers and clinics (except hospitals), outpatient",
  },
  {
    code: "621420",
    title: "Mental health centers and clinics (except hospitals), outpatient",
  },
  {
    code: "621420",
    title: "Outpatient mental health centers and clinics (except hospitals)",
  },
  {
    code: "621420",
    title:
      "Outpatient treatment centers and clinics (except hospitals) for substance abuse (i.e., alcoholism, drug addiction)",
  },
  {
    code: "621420",
    title: "Outpatient treatment centers and clinics for alcoholism",
  },
  {
    code: "621420",
    title: "Outpatient treatment centers and clinics for drug addiction",
  },
  {
    code: "621420",
    title: "Psychiatric centers and clinics (except hospitals), outpatient",
  },
  {
    code: "621420",
    title:
      "Substance abuse treatment centers and clinics (except hospitals), outpatient",
  },
  {
    code: "621491",
    title: "Group hospitalization plans providing health care services",
  },
  {
    code: "621491",
    title: "Health maintenance organization (HMO) medical centers and clinics",
  },
  {
    code: "621491",
    title: "HMO (health maintenance organization) medical centers and clinics",
  },
  {
    code: "621492",
    title: "Dialysis centers and clinics",
  },
  {
    code: "621492",
    title: "Hemodialysis centers and clinics",
  },
  {
    code: "621492",
    title: "Kidney dialysis centers and clinics",
  },
  {
    code: "621492",
    title: "Renal dialysis centers and clinics",
  },
  {
    code: "621493",
    title: "Ambulatory surgical centers and clinics, freestanding",
  },
  {
    code: "621493",
    title: "Emergency medical centers and clinics, freestanding",
  },
  {
    code: "621493",
    title: "Freestanding ambulatory surgical centers and clinics",
  },
  {
    code: "621493",
    title: "Freestanding emergency medical centers and clinics",
  },
  {
    code: "621493",
    title: "Laser surgery centers, freestanding",
  },
  {
    code: "621493",
    title: "Trauma centers (except hospitals), freestanding",
  },
  {
    code: "621493",
    title:
      "Urgent medical care centers and clinics (except hospitals), freestanding",
  },
  {
    code: "621498",
    title: "Biofeedback centers and clinics, outpatient",
  },
  {
    code: "621498",
    title:
      "Clinics/centers of health practitioners from more than one industry practicing within the same establishment",
  },
  {
    code: "621498",
    title:
      "Clinics/centers of health practitioners with multi-industry degrees",
  },
  {
    code: "621498",
    title: "Community health centers and clinics, outpatient",
  },
  {
    code: "621498",
    title: "Freestanding birth centers, outpatient",
  },
  {
    code: "621498",
    title: "Infusion therapy centers and clinics, outpatient",
  },
  {
    code: "621498",
    title: "Pain therapy centers and clinics, outpatient",
  },
  {
    code: "621498",
    title: "Sleep disorder centers and clinics, outpatient",
  },
  {
    code: "621511",
    title: "Bacteriological laboratories, diagnostic",
  },
  {
    code: "621511",
    title: "Bacteriological laboratories, medical",
  },
  {
    code: "621511",
    title: "Biological laboratories, diagnostic",
  },
  {
    code: "621511",
    title: "Blood analysis laboratories",
  },
  {
    code: "621511",
    title: "Cytology health laboratories",
  },
  {
    code: "621511",
    title: "DNA testing laboratories",
  },
  {
    code: "621511",
    title: "Forensic laboratories, medical",
  },
  {
    code: "621511",
    title: "Genetic testing laboratories",
  },
  {
    code: "621511",
    title: "Laboratories, medical (except radiological, X-ray)",
  },
  {
    code: "621511",
    title: "Laboratory testing services, medical (except radiological, X-ray)",
  },
  {
    code: "621511",
    title: "Medical laboratories (except radiological, X-ray)",
  },
  {
    code: "621511",
    title: "Medical pathology laboratories",
  },
  {
    code: "621511",
    title: "Mycology health laboratories",
  },
  {
    code: "621511",
    title: "Parasitology health laboratories",
  },
  {
    code: "621511",
    title: "Pathological analysis laboratories",
  },
  {
    code: "621511",
    title: "Pathology laboratories, medical",
  },
  {
    code: "621511",
    title: "Testing laboratories, medical",
  },
  {
    code: "621511",
    title: "Toxicology health laboratories",
  },
  {
    code: "621511",
    title: "Urinalysis laboratories",
  },
  {
    code: "621512",
    title: "CAT (computerized axial tomography) scanner centers",
  },
  {
    code: "621512",
    title: "Computer tomography (CT-SCAN) centers",
  },
  {
    code: "621512",
    title: "CT-SCAN (computer tomography) centers",
  },
  {
    code: "621512",
    title: "Dental X-ray laboratories",
  },
  {
    code: "621512",
    title: "Diagnostic imaging centers (medical)",
  },
  {
    code: "621512",
    title: "Laboratories, dental X-ray",
  },
  {
    code: "621512",
    title: "Laboratories, medical radiological or X-ray",
  },
  {
    code: "621512",
    title: "Laboratory testing services, medical radiological or X-ray",
  },
  {
    code: "621512",
    title: "Magnetic resonance imaging (MRI) centers",
  },
  {
    code: "621512",
    title: "Mammogram (i.e., breast imaging) centers",
  },
  {
    code: "621512",
    title: "Medical laboratories, radiological or X-ray",
  },
  {
    code: "621512",
    title: "Medical radiological laboratories",
  },
  {
    code: "621512",
    title: "Medical X-ray laboratories",
  },
  {
    code: "621512",
    title: "Mobile breast imaging centers",
  },
  {
    code: "621512",
    title: "Mobile X-ray facilities (medical)",
  },
  {
    code: "621512",
    title: "MRI (magnetic resonance imaging) centers",
  },
  {
    code: "621512",
    title: "Positron emission tomography (PET) scanner centers",
  },
  {
    code: "621512",
    title: "Radiological laboratories, medical",
  },
  {
    code: "621512",
    title: "Radiological laboratory services, medical",
  },
  {
    code: "621512",
    title: "Single photon emission computerized tomography (SPECT) centers",
  },
  {
    code: "621512",
    title: "Ultrasound imaging centers",
  },
  {
    code: "621512",
    title: "X-ray laboratories, medical or dental",
  },
  {
    code: "621610",
    title: "Home care of elderly, medical",
  },
  {
    code: "621610",
    title: "Home health agencies",
  },
  {
    code: "621610",
    title: "Home health care agencies",
  },
  {
    code: "621610",
    title: "Home infusion therapy services",
  },
  {
    code: "621610",
    title: "Home nursing services (except private practices)",
  },
  {
    code: "621610",
    title: "Hospice care services, in-home",
  },
  {
    code: "621610",
    title: "Nurse associations, visiting",
  },
  {
    code: "621610",
    title: "Nursing agencies, primarily providing home nursing services",
  },
  {
    code: "621610",
    title: "Visiting nurse associations",
  },
  {
    code: "621910",
    title: "Air ambulance services",
  },
  {
    code: "621910",
    title: "Ambulance services, air or ground",
  },
  {
    code: "621910",
    title: "Emergency medical transportation services, air or ground",
  },
  {
    code: "621910",
    title: "Rescue services, air",
  },
  {
    code: "621910",
    title: "Rescue services, medical",
  },
  {
    code: "621991",
    title: "Blood banks",
  },
  {
    code: "621991",
    title: "Blood donor stations",
  },
  {
    code: "621991",
    title: "Eye banks",
  },
  {
    code: "621991",
    title: "Human egg or ova banks",
  },
  {
    code: "621991",
    title: "Human embryo storage services",
  },
  {
    code: "621991",
    title: "Organ banks, body",
  },
  {
    code: "621991",
    title: "Organ donor centers, body",
  },
  {
    code: "621991",
    title: "Placenta banks",
  },
  {
    code: "621991",
    title: "Plasma collection services",
  },
  {
    code: "621991",
    title: "Plasmapheresis centers",
  },
  {
    code: "621991",
    title: "Sperm banks, human",
  },
  {
    code: "621999",
    title: "Blood pressure screening facilities",
  },
  {
    code: "621999",
    title: "Blood pressure screening services",
  },
  {
    code: "621999",
    title: "Employee drug testing services",
  },
  {
    code: "621999",
    title:
      "Head lice removal services (except by offices of health practitioners)",
  },
  {
    code: "621999",
    title:
      "Health screening services (except by offices of health practitioners)",
  },
  {
    code: "621999",
    title: "Hearing testing services (except by offices of audiologists)",
  },
  {
    code: "621999",
    title: "Medical care management services",
  },
  {
    code: "621999",
    title: "Medical case management services",
  },
  {
    code: "621999",
    title: "Pacemaker monitoring services",
  },
  {
    code: "621999",
    title:
      "Physical fitness evaluation services (except by offices of health practitioners)",
  },
  {
    code: "621999",
    title: "Smoking cessation programs",
  },
  {
    code: "621999",
    title: "Stop smoking clinics",
  },
  {
    code: "622110",
    title: "Children's hospitals, general",
  },
  {
    code: "622110",
    title: "General medical and surgical hospitals",
  },
  {
    code: "622110",
    title: "Hospitals, general medical and surgical",
  },
  {
    code: "622110",
    title: "Hospitals, general pediatric",
  },
  {
    code: "622110",
    title: "Micro-hospitals",
  },
  {
    code: "622110",
    title: "Osteopathic hospitals",
  },
  {
    code: "622210",
    title: "Alcoholism rehabilitation hospitals",
  },
  {
    code: "622210",
    title: "Children's hospitals, psychiatric or substance abuse",
  },
  {
    code: "622210",
    title: "Detoxification hospitals",
  },
  {
    code: "622210",
    title: "Drug addiction rehabilitation hospitals",
  },
  {
    code: "622210",
    title: "Hospitals for alcoholics",
  },
  {
    code: "622210",
    title: "Hospitals, addiction",
  },
  {
    code: "622210",
    title:
      "Hospitals, mental (except intellectual and developmental disability)",
  },
  {
    code: "622210",
    title: "Hospitals, psychiatric (except convalescent)",
  },
  {
    code: "622210",
    title: "Hospitals, psychiatric pediatric",
  },
  {
    code: "622210",
    title: "Hospitals, substance abuse",
  },
  {
    code: "622210",
    title:
      "Mental (except intellectual and developmental disability) hospitals",
  },
  {
    code: "622210",
    title: "Mental health hospitals",
  },
  {
    code: "622210",
    title: "Psychiatric hospitals (except convalescent)",
  },
  {
    code: "622210",
    title: "Rehabilitation hospitals, alcoholism and drug addiction",
  },
  {
    code: "622310",
    title: "Cancer hospitals",
  },
  {
    code: "622310",
    title:
      "Children's hospitals, specialty (except psychiatric, substance abuse)",
  },
  {
    code: "622310",
    title: "Chronic disease hospitals",
  },
  {
    code: "622310",
    title: "Extended care hospitals (except mental, substance abuse)",
  },
  {
    code: "622310",
    title: "Eye, ear, nose, and throat hospitals",
  },
  {
    code: "622310",
    title: "Hospitals, specialty (except psychiatric, substance abuse)",
  },
  {
    code: "622310",
    title: "Leprosy hospitals",
  },
  {
    code: "622310",
    title: "Maternity hospitals",
  },
  {
    code: "622310",
    title: "Neurological hospitals",
  },
  {
    code: "622310",
    title: "Obstetrical hospital",
  },
  {
    code: "622310",
    title: "Orthopedic hospitals",
  },
  {
    code: "622310",
    title: "Physical rehabilitation hospitals",
  },
  {
    code: "622310",
    title: "Rehabilitation hospitals (except alcoholism, drug addiction)",
  },
  {
    code: "622310",
    title: "Tuberculosis and other respiratory illness hospitals",
  },
  {
    code: "623110",
    title:
      "Assisted living facilities (without nursing facilities) for the elderly with nursing care",
  },
  {
    code: "623110",
    title: "Convalescent homes or convalescent hospitals (except psychiatric)",
  },
  {
    code: "623110",
    title: "Group homes for the disabled with nursing care",
  },
  {
    code: "623110",
    title: "Homes for the aged with nursing care",
  },
  {
    code: "623110",
    title: "Homes for the elderly with nursing care",
  },
  {
    code: "623110",
    title: "Hospices, inpatient care",
  },
  {
    code: "623110",
    title: "Nursing homes",
  },
  {
    code: "623110",
    title: "Rest homes with nursing care",
  },
  {
    code: "623110",
    title: "Retirement homes with nursing care",
  },
  {
    code: "623110",
    title: "Skilled nursing facilities",
  },
  {
    code: "623210",
    title: "Group homes, intellectual and developmental disability",
  },
  {
    code: "623210",
    title:
      "Homes with or without health care, intellectual and developmental disability",
  },
  {
    code: "623210",
    title: "Hospitals, intellectual and developmental disability",
  },
  {
    code: "623210",
    title:
      "Intellectual and developmental disability facilities (e.g., homes, hospitals, intermediate care facilities), residential",
  },
  {
    code: "623210",
    title: "Intellectual and developmental disability homes",
  },
  {
    code: "623210",
    title: "Intellectual and developmental disability hospitals",
  },
  {
    code: "623210",
    title:
      "Intellectual and developmental disability intermediate care facilities",
  },
  {
    code: "623210",
    title:
      "Intermediate care facilities, intellectual and developmental disability",
  },
  {
    code: "623220",
    title:
      "Alcoholism rehabilitation facilities (except licensed hospitals), residential",
  },
  {
    code: "623220",
    title: "Convalescent homes or hospitals for psychiatric patients",
  },
  {
    code: "623220",
    title:
      "Drug addiction rehabilitation facilities (except licensed hospitals), residential",
  },
  {
    code: "623220",
    title: "Halfway houses for patients with mental health illnesses",
  },
  {
    code: "623220",
    title: "Halfway houses, substance abuse (e.g., alcoholism, drug addiction)",
  },
  {
    code: "623220",
    title: "Homes for emotionally disturbed adults or children",
  },
  {
    code: "623220",
    title: "Homes, psychiatric convalescent",
  },
  {
    code: "623220",
    title: "Hospitals, psychiatric convalescent",
  },
  {
    code: "623220",
    title: "Mental health facilities, residential",
  },
  {
    code: "623220",
    title: "Mental health halfway houses",
  },
  {
    code: "623220",
    title: "Psychiatric convalescent homes or hospitals",
  },
  {
    code: "623220",
    title: "Residential group homes for the emotionally disturbed",
  },
  {
    code: "623220",
    title: "Substance abuse (i.e., alcoholism, drug addiction) halfway houses",
  },
  {
    code: "623220",
    title: "Substance abuse facilities, residential",
  },
  {
    code: "623311",
    title: "Assisted living facilities with on-site nursing facilities",
  },
  {
    code: "623311",
    title: "Continuing care retirement communities",
  },
  {
    code: "623311",
    title: "Retirement communities, continuing care",
  },
  {
    code: "623312",
    title: "Assisted living facilities for the elderly without nursing care",
  },
  {
    code: "623312",
    title: "Homes for the aged without nursing care",
  },
  {
    code: "623312",
    title: "Homes for the elderly without nursing care",
  },
  {
    code: "623312",
    title: "Old age homes without nursing care",
  },
  {
    code: "623312",
    title: "Old soldiers' homes without nursing care",
  },
  {
    code: "623312",
    title: "Rest homes without nursing care",
  },
  {
    code: "623312",
    title: "Retirement homes without nursing care",
  },
  {
    code: "623312",
    title: "Senior citizens' homes without nursing care",
  },
  {
    code: "623990",
    title: "Boot camps for delinquent youth",
  },
  {
    code: "623990",
    title:
      "Boys' and girls' residential facilities (e.g., homes, ranches, villages)",
  },
  {
    code: "623990",
    title:
      "Camps, boot or disciplinary (except correctional), for delinquent youth",
  },
  {
    code: "623990",
    title: "Child group foster homes",
  },
  {
    code: "623990",
    title: "Children's villages",
  },
  {
    code: "623990",
    title: "Delinquent youth halfway group homes",
  },
  {
    code: "623990",
    title: "Disciplinary camps for delinquent youth",
  },
  {
    code: "623990",
    title: "Group foster homes for children",
  },
  {
    code: "623990",
    title: "Group homes for the hearing impaired",
  },
  {
    code: "623990",
    title: "Group homes for the visually impaired",
  },
  {
    code: "623990",
    title: "Halfway group homes for delinquents and ex-offenders",
  },
  {
    code: "623990",
    title: "Homes for children with health care incidental",
  },
  {
    code: "623990",
    title: "Homes for unwed mothers",
  },
  {
    code: "623990",
    title: "Juvenile halfway group homes",
  },
  {
    code: "623990",
    title: "Orphanages",
  },
  {
    code: "624110",
    title: "Adoption agencies",
  },
  {
    code: "624110",
    title: "Adoption services, child",
  },
  {
    code: "624110",
    title: "Aid to families with dependent children (AFDC)",
  },
  {
    code: "624110",
    title: "Child guidance agencies",
  },
  {
    code: "624110",
    title: "Child welfare services",
  },
  {
    code: "624110",
    title: "Community centers (except recreational only), youth",
  },
  {
    code: "624110",
    title: "Foster care placement agencies",
  },
  {
    code: "624110",
    title: "Foster home placement services",
  },
  {
    code: "624110",
    title: "Self-help organizations, youth",
  },
  {
    code: "624110",
    title: "Teen outreach services",
  },
  {
    code: "624110",
    title: "Youth centers (except recreational only)",
  },
  {
    code: "624110",
    title: "Youth guidance organizations",
  },
  {
    code: "624110",
    title: "Youth self-help organizations",
  },
  {
    code: "624120",
    title: "Activity centers for disabled persons and the elderly",
  },
  {
    code: "624120",
    title: "Adult day care centers",
  },
  {
    code: "624120",
    title: "Centers, senior citizens'",
  },
  {
    code: "624120",
    title: "Community centers (except recreational only), adult",
  },
  {
    code: "624120",
    title: "Companion services for disabled persons and the elderly",
  },
  {
    code: "624120",
    title: "Day care centers for disabled persons and the elderly",
  },
  {
    code: "624120",
    title: "Day care centers, adult",
  },
  {
    code: "624120",
    title: "Disability support groups",
  },
  {
    code: "624120",
    title: "Home care of elderly, non-medical",
  },
  {
    code: "624120",
    title: "Homemaker's service for elderly or disabled persons, non-medical",
  },
  {
    code: "624120",
    title: "Self-help organizations for disabled persons and the elderly",
  },
  {
    code: "624120",
    title: "Senior citizens activity centers",
  },
  {
    code: "624120",
    title: "Senior citizens centers",
  },
  {
    code: "624190",
    title: "Alcoholism and drug addiction self-help organizations",
  },
  {
    code: "624190",
    title: "Alcoholism counseling (except medical treatment), nonresidential",
  },
  {
    code: "624190",
    title: "Alcoholism self-help organizations",
  },
  {
    code: "624190",
    title: "Community action service agencies",
  },
  {
    code: "624190",
    title: "Community health education services (except health care services)",
  },
  {
    code: "624190",
    title:
      "Counseling services (except by psychiatrists, psychoanalysts, or psychotherapists)",
  },
  {
    code: "624190",
    title: "Crisis intervention centers",
  },
  {
    code: "624190",
    title: "Drug addiction self-help organizations",
  },
  {
    code: "624190",
    title: "Ex-offender rehabilitation agencies",
  },
  {
    code: "624190",
    title: "Ex-offender self-help organizations",
  },
  {
    code: "624190",
    title: "Family social service agencies",
  },
  {
    code: "624190",
    title: "Family welfare services",
  },
  {
    code: "624190",
    title: "Hotline centers",
  },
  {
    code: "624190",
    title: "Individual and family social services, multi-purpose",
  },
  {
    code: "624190",
    title:
      "Marriage counseling services (except by offices of mental health practitioners)",
  },
  {
    code: "624190",
    title: "Mediation, social service, family, agencies",
  },
  {
    code: "624190",
    title: "Multiservice centers, neighborhood",
  },
  {
    code: "624190",
    title: "Offender self-help organizations",
  },
  {
    code: "624190",
    title: "Parenting support services",
  },
  {
    code: "624190",
    title: "Parole offices, privately operated",
  },
  {
    code: "624190",
    title: "Probation offices, privately operated",
  },
  {
    code: "624190",
    title: "Rape crisis centers",
  },
  {
    code: "624190",
    title: "Referral services for personal and social problems",
  },
  {
    code: "624190",
    title: "Rehabilitation agencies for offenders",
  },
  {
    code: "624190",
    title: "Self-help organizations (except for disabled persons, the elderly)",
  },
  {
    code: "624190",
    title: "Social service agencies, family",
  },
  {
    code: "624190",
    title: "Social service centers, multi-purpose",
  },
  {
    code: "624190",
    title: "Suicide crisis centers",
  },
  {
    code: "624190",
    title: "Support group services",
  },
  {
    code: "624190",
    title: "Telephone counseling services",
  },
  {
    code: "624190",
    title: "Travelers' aid centers",
  },
  {
    code: "624190",
    title: "Welfare service centers, multi-program",
  },
  {
    code: "624210",
    title: "Community meals, social services",
  },
  {
    code: "624210",
    title: "Food banks",
  },
  {
    code: "624210",
    title: "Food pantries",
  },
  {
    code: "624210",
    title: "Meal delivery programs",
  },
  {
    code: "624210",
    title: "Mobile soup kitchens",
  },
  {
    code: "624210",
    title: "Soup kitchens",
  },
  {
    code: "624221",
    title: "Battered women's shelters",
  },
  {
    code: "624221",
    title:
      "Emergency shelters (except for victims of domestic or international disasters or conflicts)",
  },
  {
    code: "624221",
    title: "Homeless shelters",
  },
  {
    code: "624221",
    title: "Runaway youth shelters",
  },
  {
    code: "624221",
    title:
      "Shelters (except for victims of domestic or international disasters or conflicts), emergency",
  },
  {
    code: "624221",
    title: "Shelters, battered women's",
  },
  {
    code: "624221",
    title: "Shelters, homeless",
  },
  {
    code: "624221",
    title: "Shelters, runaway youth",
  },
  {
    code: "624221",
    title:
      "Shelters, temporary (e.g., battered women's, homeless, runaway youth)",
  },
  {
    code: "624221",
    title: "Temporary housing for families of medical patients",
  },
  {
    code: "624221",
    title:
      "Temporary shelters (e.g., battered women's, homeless, runaway youth)",
  },
  {
    code: "624221",
    title: "Women's shelters, battered",
  },
  {
    code: "624229",
    title: "Energy assistance programs",
  },
  {
    code: "624229",
    title: "Home construction organizations, work (sweat) equity",
  },
  {
    code: "624229",
    title: "Housing assistance agencies",
  },
  {
    code: "624229",
    title: "Housing repair organizations, volunteer",
  },
  {
    code: "624229",
    title: "Transitional housing agencies",
  },
  {
    code: "624229",
    title: "Volunteer housing repair organizations",
  },
  {
    code: "624229",
    title: "Work (sweat) equity home construction organizations",
  },
  {
    code: "624230",
    title: "Disaster relief services",
  },
  {
    code: "624230",
    title: "Emergency relief services",
  },
  {
    code: "624230",
    title:
      "Emergency shelters for victims of domestic or international disasters or conflicts",
  },
  {
    code: "624230",
    title: "Immigrant resettlement services",
  },
  {
    code: "624230",
    title: "Refugee settlement services",
  },
  {
    code: "624230",
    title: "Relief services, disaster",
  },
  {
    code: "624230",
    title: "Relief services, emergency",
  },
  {
    code: "624230",
    title:
      "Shelters for victims of domestic or international disasters or conflicts, emergency",
  },
  {
    code: "624310",
    title: "Habilitation job counseling and training, vocational",
  },
  {
    code: "624310",
    title: "Job counseling, vocational rehabilitation or habilitation",
  },
  {
    code: "624310",
    title: "Job training, vocational rehabilitation or habilitation",
  },
  {
    code: "624310",
    title: "Rehabilitation job counseling and training, vocational",
  },
  {
    code: "624310",
    title: "Sheltered workshops (i.e., work experience centers)",
  },
  {
    code: "624310",
    title: "Vocational habilitation job counseling",
  },
  {
    code: "624310",
    title: "Vocational habilitation job training facilities (except schools)",
  },
  {
    code: "624310",
    title: "Vocational rehabilitation agencies",
  },
  {
    code: "624310",
    title: "Vocational rehabilitation job counseling",
  },
  {
    code: "624310",
    title: "Vocational rehabilitation job training facilities (except schools)",
  },
  {
    code: "624310",
    title:
      "Vocational rehabilitation or habilitation services (e.g., job counseling, job training, work experience)",
  },
  {
    code: "624310",
    title: "Work experience centers (i.e., sheltered workshops)",
  },
  {
    code: "624310",
    title: "Workshops for persons with disabilities",
  },
  {
    code: "624410",
    title: "Babysitting services in provider's own home, child care",
  },
  {
    code: "624410",
    title: "Babysitting services, child care",
  },
  {
    code: "624410",
    title:
      "Before-school and after-school educational programs, separate from schools",
  },
  {
    code: "624410",
    title: "Child care babysitting services",
  },
  {
    code: "624410",
    title: "Child care services",
  },
  {
    code: "624410",
    title: "Child care services in provider's own home",
  },
  {
    code: "624410",
    title: "Child care, before or after school, separate from schools",
  },
  {
    code: "624410",
    title: "Child day care centers",
  },
  {
    code: "624410",
    title: "Day care centers, child or infant",
  },
  {
    code: "624410",
    title: "Day care services, child or infant",
  },
  {
    code: "624410",
    title:
      "Family child care homes (excluding private households employing nannies)",
  },
  {
    code: "624410",
    title: "Group day care centers, child or infant",
  },
  {
    code: "624410",
    title: "Head Start and Early Head Start programs, separate from schools",
  },
  {
    code: "624410",
    title: "Infant care services",
  },
  {
    code: "624410",
    title: "Infant day care centers",
  },
  {
    code: "624410",
    title: "Nursery schools",
  },
  {
    code: "624410",
    title: "Pre-kindergarten centers (except part of elementary school system)",
  },
  {
    code: "624410",
    title: "Preschool centers",
  },
  {
    code: "711110",
    title: "Broadway theaters",
  },
  {
    code: "711110",
    title: "Burlesque companies",
  },
  {
    code: "711110",
    title: "Comedy troupes",
  },
  {
    code: "711110",
    title: "Community theaters",
  },
  {
    code: "711110",
    title: "Dinner theaters",
  },
  {
    code: "711110",
    title: "Improvisational theaters",
  },
  {
    code: "711110",
    title: "Mime theaters",
  },
  {
    code: "711110",
    title: "Musical theater companies or groups",
  },
  {
    code: "711110",
    title: "Musical theater productions, live",
  },
  {
    code: "711110",
    title: "Opera companies",
  },
  {
    code: "711110",
    title: "Puppet theaters",
  },
  {
    code: "711110",
    title: "Repertory companies, theatrical",
  },
  {
    code: "711110",
    title: "Road companies, theatrical",
  },
  {
    code: "711110",
    title: "Stock companies, theatrical",
  },
  {
    code: "711110",
    title: "Summer theaters",
  },
  {
    code: "711110",
    title: "Theater companies (except dance)",
  },
  {
    code: "711110",
    title: "Theater companies (except dance), amateur",
  },
  {
    code: "711110",
    title: "Theaters, dinner",
  },
  {
    code: "711110",
    title: "Theaters, live theatrical production (except dance)",
  },
  {
    code: "711110",
    title: "Theaters, musical",
  },
  {
    code: "711110",
    title: "Theatrical repertory companies",
  },
  {
    code: "711110",
    title: "Theatrical road companies",
  },
  {
    code: "711110",
    title: "Theatrical stock companies",
  },
  {
    code: "711110",
    title: "Vaudeville companies",
  },
  {
    code: "711120",
    title: "Ballet companies",
  },
  {
    code: "711120",
    title: "Ballet productions, live theatrical",
  },
  {
    code: "711120",
    title: "Classical dance companies",
  },
  {
    code: "711120",
    title: "Contemporary dance companies",
  },
  {
    code: "711120",
    title: "Dance companies",
  },
  {
    code: "711120",
    title: "Dance productions, live theatrical",
  },
  {
    code: "711120",
    title: "Dance theaters",
  },
  {
    code: "711120",
    title: "Dance troupes",
  },
  {
    code: "711120",
    title: "Folk dance companies",
  },
  {
    code: "711120",
    title: "Interpretive dance companies",
  },
  {
    code: "711120",
    title: "Jazz dance companies",
  },
  {
    code: "711120",
    title: "Modern dance companies",
  },
  {
    code: "711120",
    title: "Tap dance companies",
  },
  {
    code: "711120",
    title: "Theater companies, dance",
  },
  {
    code: "711120",
    title: "Theaters, dance",
  },
  {
    code: "711120",
    title: "Theatrical dance productions, live",
  },
  {
    code: "711130",
    title: "Bands",
  },
  {
    code: "711130",
    title: "Bands, dance",
  },
  {
    code: "711130",
    title: "Bands, musical",
  },
  {
    code: "711130",
    title: "Chamber musical groups",
  },
  {
    code: "711130",
    title: "Chamber orchestras",
  },
  {
    code: "711130",
    title: "Choirs",
  },
  {
    code: "711130",
    title: "Classical musical artists, independent",
  },
  {
    code: "711130",
    title: "Classical musical groups",
  },
  {
    code: "711130",
    title: "Concert artists, independent",
  },
  {
    code: "711130",
    title: "Country musical artists, independent",
  },
  {
    code: "711130",
    title: "Country musical groups",
  },
  {
    code: "711130",
    title: "Dance bands",
  },
  {
    code: "711130",
    title: "Drum and bugle corps (i.e., drill teams)",
  },
  {
    code: "711130",
    title: "Ensembles, musical",
  },
  {
    code: "711130",
    title: "Jazz musical artists, independent",
  },
  {
    code: "711130",
    title: "Jazz musical groups",
  },
  {
    code: "711130",
    title: "Musical artists, independent",
  },
  {
    code: "711130",
    title: "Musical groups (except musical theater groups)",
  },
  {
    code: "711130",
    title: "Musical productions (except musical theater productions), live",
  },
  {
    code: "711130",
    title: "Musicians, independent",
  },
  {
    code: "711130",
    title: "Opera singers, independent",
  },
  {
    code: "711130",
    title: "Orchestras",
  },
  {
    code: "711130",
    title: "Popular musical artists, independent",
  },
  {
    code: "711130",
    title: "Popular musical groups",
  },
  {
    code: "711130",
    title: "Rock musical artists, independent",
  },
  {
    code: "711130",
    title: "Rock musical groups",
  },
  {
    code: "711130",
    title: "Singers, independent",
  },
  {
    code: "711130",
    title: "Soloists, independent musical",
  },
  {
    code: "711130",
    title: "Symphony orchestras",
  },
  {
    code: "711130",
    title: "Vocalists, independent",
  },
  {
    code: "711190",
    title: "Carnival traveling shows",
  },
  {
    code: "711190",
    title: "Circus companies",
  },
  {
    code: "711190",
    title: "Circuses",
  },
  {
    code: "711190",
    title: "Horse shows",
  },
  {
    code: "711190",
    title: "Ice skating companies",
  },
  {
    code: "711190",
    title: "Ice skating shows",
  },
  {
    code: "711190",
    title: "Magic shows",
  },
  {
    code: "711190",
    title: "Traveling shows, carnival",
  },
  {
    code: "711211",
    title: "Baseball clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Baseball teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Basketball clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Basketball teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Boxing clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title:
      "Esports video gaming clubs or teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Football clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Football teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Hockey clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Hockey teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Ice hockey clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Jai alai teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Major league baseball clubs",
  },
  {
    code: "711211",
    title: "Minor league baseball clubs",
  },
  {
    code: "711211",
    title: "Professional baseball clubs",
  },
  {
    code: "711211",
    title: "Professional football clubs",
  },
  {
    code: "711211",
    title: "Professional sports clubs",
  },
  {
    code: "711211",
    title: "Roller hockey clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Semiprofessional baseball clubs",
  },
  {
    code: "711211",
    title: "Semiprofessional football clubs",
  },
  {
    code: "711211",
    title: "Semiprofessional sports clubs",
  },
  {
    code: "711211",
    title: "Soccer clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Soccer teams, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Sports clubs, professional or semiprofessional",
  },
  {
    code: "711211",
    title: "Sports teams, professional or semiprofessional",
  },
  {
    code: "711212",
    title: "Automobile racetracks",
  },
  {
    code: "711212",
    title: "Dog racetracks",
  },
  {
    code: "711212",
    title: "Drag strips",
  },
  {
    code: "711212",
    title: "Greyhound dog racetracks",
  },
  {
    code: "711212",
    title: "Harness racetracks",
  },
  {
    code: "711212",
    title: "Horse racetracks",
  },
  {
    code: "711212",
    title: "Motorcycle racetracks",
  },
  {
    code: "711212",
    title: "Racetracks (e.g., automobile, dog, horse)",
  },
  {
    code: "711212",
    title: "Snowmobile racetracks",
  },
  {
    code: "711212",
    title: "Speedways",
  },
  {
    code: "711212",
    title: "Stock car racetracks",
  },
  {
    code: "711212",
    title: "Thoroughbred racetracks",
  },
  {
    code: "711219",
    title: "Athletes, amateur, independent",
  },
  {
    code: "711219",
    title: "Athletes, independent (i.e., participating in live sports events)",
  },
  {
    code: "711219",
    title: "Automobile racing teams",
  },
  {
    code: "711219",
    title: "Boxers, independent professional",
  },
  {
    code: "711219",
    title: "Dog owners, race (i.e., racing dogs)",
  },
  {
    code: "711219",
    title: "Dog racing kennels",
  },
  {
    code: "711219",
    title: "Drivers, harness or race car",
  },
  {
    code: "711219",
    title: "Figure skaters, independent",
  },
  {
    code: "711219",
    title:
      "Golfers, independent professional (i.e., participating in sports events)",
  },
  {
    code: "711219",
    title: "Harness drivers",
  },
  {
    code: "711219",
    title: "Horse racing stables",
  },
  {
    code: "711219",
    title: "Jockeys, horse racing",
  },
  {
    code: "711219",
    title: "Kennels, dog racing",
  },
  {
    code: "711219",
    title: "Mixed martial artists, independent professional",
  },
  {
    code: "711219",
    title: "Motorcycle racing teams",
  },
  {
    code: "711219",
    title:
      "Professional athletes, independent (i.e., participating in sports events)",
  },
  {
    code: "711219",
    title: "Race car drivers",
  },
  {
    code: "711219",
    title: "Race car owners (i.e., racing cars)",
  },
  {
    code: "711219",
    title: "Race dog owners (i.e., racing dogs)",
  },
  {
    code: "711219",
    title: "Racehorse owners (i.e., racing horses)",
  },
  {
    code: "711219",
    title: "Racehorse trainers",
  },
  {
    code: "711219",
    title: "Racehorse training",
  },
  {
    code: "711219",
    title: "Racing stables, horse",
  },
  {
    code: "711219",
    title: "Racing teams (e.g., automobile, motorcycle, snowmobile)",
  },
  {
    code: "711219",
    title: "Referees and umpires",
  },
  {
    code: "711219",
    title: "Skiers, independent (i.e., participating in sports events)",
  },
  {
    code: "711219",
    title: "Snowmobile racing teams",
  },
  {
    code: "711219",
    title:
      "Sports professionals, independent (i.e., participating in sports events)",
  },
  {
    code: "711219",
    title: "Sports team scouting services, independent",
  },
  {
    code: "711219",
    title: "Sports trainers, independent",
  },
  {
    code: "711219",
    title: "Stables, horse racing",
  },
  {
    code: "711219",
    title: "Stock car racing teams",
  },
  {
    code: "711219",
    title:
      "Tennis professionals, independent (i.e., participating in sports events)",
  },
  {
    code: "711219",
    title: "Training race dogs",
  },
  {
    code: "711219",
    title: "Training racehorses",
  },
  {
    code: "711219",
    title: "Wrestlers, independent professional",
  },
  {
    code: "711310",
    title: "Air show managers with facilities",
  },
  {
    code: "711310",
    title: "Air show organizers with facilities",
  },
  {
    code: "711310",
    title: "Air show promoters with facilities",
  },
  {
    code: "711310",
    title: "Arena operators",
  },
  {
    code: "711310",
    title: "Arts event managers with facilities",
  },
  {
    code: "711310",
    title: "Arts event organizers with facilities",
  },
  {
    code: "711310",
    title: "Arts event promoters with facilities",
  },
  {
    code: "711310",
    title: "Arts festival managers with facilities",
  },
  {
    code: "711310",
    title: "Arts festival organizers with facilities",
  },
  {
    code: "711310",
    title: "Arts festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Beauty pageant managers with facilities",
  },
  {
    code: "711310",
    title: "Beauty pageant organizers with facilities",
  },
  {
    code: "711310",
    title: "Beauty pageant promoters with facilities",
  },
  {
    code: "711310",
    title: "Boxing event managers with facilities",
  },
  {
    code: "711310",
    title: "Boxing event organizers with facilities",
  },
  {
    code: "711310",
    title: "Boxing event promoters with facilities",
  },
  {
    code: "711310",
    title: "Concert hall operators",
  },
  {
    code: "711310",
    title: "Concert managers with facilities",
  },
  {
    code: "711310",
    title: "Concert organizers with facilities",
  },
  {
    code: "711310",
    title: "Concert promoters with facilities",
  },
  {
    code: "711310",
    title: "Dance festival managers with facilities",
  },
  {
    code: "711310",
    title: "Dance festival organizers with facilities",
  },
  {
    code: "711310",
    title: "Dance festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Ethnic festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Fair managers with facilities, agricultural",
  },
  {
    code: "711310",
    title: "Fair organizers with facilities, agricultural",
  },
  {
    code: "711310",
    title: "Fair promoters with facilities",
  },
  {
    code: "711310",
    title: "Fair promoters with facilities, agricultural",
  },
  {
    code: "711310",
    title: "Festival managers with facilities",
  },
  {
    code: "711310",
    title: "Festival of arts managers with facilities",
  },
  {
    code: "711310",
    title: "Festival of arts organizers with facilities",
  },
  {
    code: "711310",
    title: "Festival of arts promoters with facilities",
  },
  {
    code: "711310",
    title: "Festival organizers with facilities",
  },
  {
    code: "711310",
    title: "Festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Heritage festival managers with facilities",
  },
  {
    code: "711310",
    title: "Heritage festival organizers with facilities",
  },
  {
    code: "711310",
    title: "Heritage festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Horse show managers with facilities",
  },
  {
    code: "711310",
    title: "Horse show organizers with facilities",
  },
  {
    code: "711310",
    title: "Horse show promoters with facilities",
  },
  {
    code: "711310",
    title: "Live arts center operators",
  },
  {
    code: "711310",
    title: "Live theater operators",
  },
  {
    code: "711310",
    title: "Managers of agricultural fairs with facilities",
  },
  {
    code: "711310",
    title: "Managers of arts events with facilities",
  },
  {
    code: "711310",
    title: "Managers of festivals with facilities",
  },
  {
    code: "711310",
    title:
      "Managers of live performing arts productions (e.g., concerts) with facilities",
  },
  {
    code: "711310",
    title: "Managers of sports events with facilities",
  },
  {
    code: "711310",
    title: "Music festival managers with facilities",
  },
  {
    code: "711310",
    title: "Music festival organizers with facilities",
  },
  {
    code: "711310",
    title: "Music festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Organizers of agricultural fairs with facilities",
  },
  {
    code: "711310",
    title: "Organizers of arts events with facilities",
  },
  {
    code: "711310",
    title: "Organizers of festivals with facilities",
  },
  {
    code: "711310",
    title:
      "Organizers of live performing arts productions (e.g., concerts) with facilities",
  },
  {
    code: "711310",
    title: "Organizers of sports events with facilities",
  },
  {
    code: "711310",
    title: "Performing arts center operators",
  },
  {
    code: "711310",
    title: "Professional sports promoters with facilities",
  },
  {
    code: "711310",
    title: "Promoters of agricultural fairs with facilities",
  },
  {
    code: "711310",
    title: "Promoters of arts events with facilities",
  },
  {
    code: "711310",
    title: "Promoters of festivals with facilities",
  },
  {
    code: "711310",
    title:
      "Promoters of live performing arts productions (e.g., concerts) with facilities",
  },
  {
    code: "711310",
    title: "Promoters of sports events with facilities",
  },
  {
    code: "711310",
    title: "Rodeo managers with facilities",
  },
  {
    code: "711310",
    title: "Rodeo organizers with facilities",
  },
  {
    code: "711310",
    title: "Rodeo promoters with facilities",
  },
  {
    code: "711310",
    title: "Sports arena operators",
  },
  {
    code: "711310",
    title: "Sports event managers with facilities",
  },
  {
    code: "711310",
    title: "Sports event organizers with facilities",
  },
  {
    code: "711310",
    title: "Sports event promoters with facilities",
  },
  {
    code: "711310",
    title: "Sports stadium operators",
  },
  {
    code: "711310",
    title: "Stadium operators",
  },
  {
    code: "711310",
    title: "Theater festival managers with facilities",
  },
  {
    code: "711310",
    title: "Theater festival organizers with facilities",
  },
  {
    code: "711310",
    title: "Theater festival promoters with facilities",
  },
  {
    code: "711310",
    title: "Theater operators",
  },
  {
    code: "711310",
    title: "Theatrical production managers with facilities",
  },
  {
    code: "711310",
    title: "Theatrical production organizers with facilities",
  },
  {
    code: "711310",
    title: "Theatrical production promoters with facilities",
  },
  {
    code: "711310",
    title: "Wrestling event managers with facilities",
  },
  {
    code: "711310",
    title: "Wrestling event organizers with facilities",
  },
  {
    code: "711310",
    title: "Wrestling event promoters with facilities",
  },
  {
    code: "711320",
    title: "Agricultural fair managers without facilities",
  },
  {
    code: "711320",
    title: "Agricultural fair organizers without facilities",
  },
  {
    code: "711320",
    title: "Agricultural fair promoters without facilities",
  },
  {
    code: "711320",
    title: "Air show managers without facilities",
  },
  {
    code: "711320",
    title: "Air show organizers without facilities",
  },
  {
    code: "711320",
    title: "Air show promoters without facilities",
  },
  {
    code: "711320",
    title: "Arts event managers without facilities",
  },
  {
    code: "711320",
    title: "Arts event organizers without facilities",
  },
  {
    code: "711320",
    title: "Arts event promoters without facilities",
  },
  {
    code: "711320",
    title: "Arts festival managers without facilities",
  },
  {
    code: "711320",
    title: "Arts festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Arts festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Beauty pageant managers without facilities",
  },
  {
    code: "711320",
    title: "Beauty pageant organizers without facilities",
  },
  {
    code: "711320",
    title: "Beauty pageant promoters without facilities",
  },
  {
    code: "711320",
    title: "Booking agencies, theatrical (except motion picture)",
  },
  {
    code: "711320",
    title: "Boxing event managers without facilities",
  },
  {
    code: "711320",
    title: "Boxing event organizers without facilities",
  },
  {
    code: "711320",
    title: "Boxing event promoters without facilities",
  },
  {
    code: "711320",
    title: "Concert booking agencies",
  },
  {
    code: "711320",
    title: "Concert managers without facilities",
  },
  {
    code: "711320",
    title: "Concert organizers without facilities",
  },
  {
    code: "711320",
    title: "Concert promoters without facilities",
  },
  {
    code: "711320",
    title: "Dance festival managers without facilities",
  },
  {
    code: "711320",
    title: "Dance festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Dance festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Ethnic festival managers without facilities",
  },
  {
    code: "711320",
    title: "Ethnic festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Ethnic festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Fair managers without facilities, agricultural",
  },
  {
    code: "711320",
    title: "Fair organizers without facilities, agricultural",
  },
  {
    code: "711320",
    title: "Fair promoters without facilities",
  },
  {
    code: "711320",
    title: "Fair promoters without facilities, agricultural",
  },
  {
    code: "711320",
    title: "Festival managers without facilities",
  },
  {
    code: "711320",
    title: "Festival of arts managers without facilities",
  },
  {
    code: "711320",
    title: "Festival of arts organizers without facilities",
  },
  {
    code: "711320",
    title: "Festival of arts promoters without facilities",
  },
  {
    code: "711320",
    title: "Festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Heritage festival managers without facilities",
  },
  {
    code: "711320",
    title: "Heritage festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Heritage festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Horse show managers without facilities",
  },
  {
    code: "711320",
    title: "Horse show organizers without facilities",
  },
  {
    code: "711320",
    title: "Horse show promoters without facilities",
  },
  {
    code: "711320",
    title: "Managers of agricultural fairs without facilities",
  },
  {
    code: "711320",
    title: "Managers of arts events without facilities",
  },
  {
    code: "711320",
    title: "Managers of festivals without facilities",
  },
  {
    code: "711320",
    title:
      "Managers of live performing arts productions (e.g., concerts) without facilities",
  },
  {
    code: "711320",
    title: "Managers of sports events without facilities",
  },
  {
    code: "711320",
    title: "Music festival managers without facilities",
  },
  {
    code: "711320",
    title: "Music festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Music festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Organizers of agricultural fairs without facilities",
  },
  {
    code: "711320",
    title: "Organizers of arts events without facilities",
  },
  {
    code: "711320",
    title: "Organizers of festivals without facilities",
  },
  {
    code: "711320",
    title:
      "Organizers of live performing arts productions (e.g., concerts) without facilities",
  },
  {
    code: "711320",
    title: "Organizers of sports events without facilities",
  },
  {
    code: "711320",
    title: "Professional sports promoters without facilities",
  },
  {
    code: "711320",
    title: "Promoters of agricultural fairs without facilities",
  },
  {
    code: "711320",
    title: "Promoters of arts events without facilities",
  },
  {
    code: "711320",
    title: "Promoters of festivals without facilities",
  },
  {
    code: "711320",
    title:
      "Promoters of live performing arts productions (e.g., concerts) without facilities",
  },
  {
    code: "711320",
    title: "Promoters of sports events without facilities",
  },
  {
    code: "711320",
    title: "Rodeo managers without facilities",
  },
  {
    code: "711320",
    title: "Rodeo organizers without facilities",
  },
  {
    code: "711320",
    title: "Rodeo promoters without facilities",
  },
  {
    code: "711320",
    title: "Sports event managers without facilities",
  },
  {
    code: "711320",
    title: "Sports event organizers without facilities",
  },
  {
    code: "711320",
    title: "Sports event promoters without facilities",
  },
  {
    code: "711320",
    title: "Theater festival managers without facilities",
  },
  {
    code: "711320",
    title: "Theater festival organizers without facilities",
  },
  {
    code: "711320",
    title: "Theater festival promoters without facilities",
  },
  {
    code: "711320",
    title: "Theatrical booking agencies (except motion picture)",
  },
  {
    code: "711320",
    title: "Theatrical production managers without facilities",
  },
  {
    code: "711320",
    title: "Theatrical production organizers without facilities",
  },
  {
    code: "711320",
    title: "Theatrical production promoters without facilities",
  },
  {
    code: "711320",
    title: "Wrestling event managers without facilities",
  },
  {
    code: "711320",
    title: "Wrestling event organizers without facilities",
  },
  {
    code: "711320",
    title: "Wrestling event promoters without facilities",
  },
  {
    code: "711410",
    title: "Agents, artists'",
  },
  {
    code: "711410",
    title: "Agents, authors'",
  },
  {
    code: "711410",
    title: "Agents, celebrities'",
  },
  {
    code: "711410",
    title: "Agents, entertainers'",
  },
  {
    code: "711410",
    title: "Agents, modeling",
  },
  {
    code: "711410",
    title: "Agents, public figures'",
  },
  {
    code: "711410",
    title: "Agents, sports figures'",
  },
  {
    code: "711410",
    title: "Agents, talent",
  },
  {
    code: "711410",
    title: "Agents, theatrical talent",
  },
  {
    code: "711410",
    title: "Artists' agents or managers",
  },
  {
    code: "711410",
    title: "Authors' agents or managers",
  },
  {
    code: "711410",
    title: "Celebrities' agents or managers",
  },
  {
    code: "711410",
    title: "Entertainers' agents or managers",
  },
  {
    code: "711410",
    title: "Lecture bureaus",
  },
  {
    code: "711410",
    title: "Literary agents",
  },
  {
    code: "711410",
    title:
      "Management agencies for artists, entertainers, and other public figures",
  },
  {
    code: "711410",
    title: "Managers, authors'",
  },
  {
    code: "711410",
    title: "Managers, celebrities'",
  },
  {
    code: "711410",
    title: "Managers, entertainers'",
  },
  {
    code: "711410",
    title: "Managers, public figures'",
  },
  {
    code: "711410",
    title: "Managers, sports figures'",
  },
  {
    code: "711410",
    title: "Modeling agents",
  },
  {
    code: "711410",
    title: "Models' agents or managers",
  },
  {
    code: "711410",
    title: "Public figures' agents or managers",
  },
  {
    code: "711410",
    title: "Speakers' bureaus",
  },
  {
    code: "711410",
    title: "Sports figures' agents or managers",
  },
  {
    code: "711410",
    title: "Talent agencies",
  },
  {
    code: "711410",
    title: "Talent agents",
  },
  {
    code: "711410",
    title: "Theatrical talent agents",
  },
  {
    code: "711510",
    title: "Actors, independent",
  },
  {
    code: "711510",
    title: "Actresses, independent",
  },
  {
    code: "711510",
    title: "Animated cartoon artists, independent",
  },
  {
    code: "711510",
    title: "Announcers, independent radio and television",
  },
  {
    code: "711510",
    title: "Art restorers, independent",
  },
  {
    code: "711510",
    title: "Artists (except musical, commercial, medical), independent",
  },
  {
    code: "711510",
    title: "Artists (i.e., painters), independent",
  },
  {
    code: "711510",
    title: "Authors, independent",
  },
  {
    code: "711510",
    title: "Ballet dancers, independent",
  },
  {
    code: "711510",
    title: "Cameramen, independent (freelance)",
  },
  {
    code: "711510",
    title: "Cartoonists, independent",
  },
  {
    code: "711510",
    title: "Celebrity spokespersons, independent",
  },
  {
    code: "711510",
    title: "Choreographers, independent",
  },
  {
    code: "711510",
    title: "Cinematographers, independent",
  },
  {
    code: "711510",
    title: "Comedians, independent",
  },
  {
    code: "711510",
    title: "Composers, independent",
  },
  {
    code: "711510",
    title: "Conductors, independent",
  },
  {
    code: "711510",
    title: "Conservators (i.e., art, artifact restorers), independent",
  },
  {
    code: "711510",
    title: "Costume designers, independent theatrical",
  },
  {
    code: "711510",
    title: "Dancers, independent",
  },
  {
    code: "711510",
    title:
      "Directors (i.e., film, motion picture, music, theatrical), independent",
  },
  {
    code: "711510",
    title: "Directors, independent motion picture",
  },
  {
    code: "711510",
    title: "Directors, independent music",
  },
  {
    code: "711510",
    title: "Disc jockeys, independent",
  },
  {
    code: "711510",
    title: "Entertainers, independent",
  },
  {
    code: "711510",
    title: "Ethnic dancers, independent",
  },
  {
    code: "711510",
    title: "Film actors, independent",
  },
  {
    code: "711510",
    title: "Film producers, independent",
  },
  {
    code: "711510",
    title: "Folk dancers, independent",
  },
  {
    code: "711510",
    title: "Ghost writers, independent",
  },
  {
    code: "711510",
    title: "Independent museum exhibit designers",
  },
  {
    code: "711510",
    title: "Independent technical writers",
  },
  {
    code: "711510",
    title: "Interpretive dancers, independent",
  },
  {
    code: "711510",
    title: "Jazz dancers, independent",
  },
  {
    code: "711510",
    title: "Journalists, independent (freelance)",
  },
  {
    code: "711510",
    title: "Lecturers, independent",
  },
  {
    code: "711510",
    title: "Lighting technicians, theatrical, independent",
  },
  {
    code: "711510",
    title: "Magicians, independent",
  },
  {
    code: "711510",
    title: "Models, independent",
  },
  {
    code: "711510",
    title: "Motion picture directors, independent",
  },
  {
    code: "711510",
    title: "Motion picture producers, independent",
  },
  {
    code: "711510",
    title: "Motivational speakers, independent",
  },
  {
    code: "711510",
    title: "Music arrangers, independent",
  },
  {
    code: "711510",
    title: "Music directors, independent",
  },
  {
    code: "711510",
    title: "News correspondents, independent (freelance)",
  },
  {
    code: "711510",
    title: "Newspaper columnists, independent (freelance)",
  },
  {
    code: "711510",
    title: "Orchestra conductors, independent",
  },
  {
    code: "711510",
    title: "Painters (i.e., artists), independent",
  },
  {
    code: "711510",
    title: "Painting restorers, independent",
  },
  {
    code: "711510",
    title: "Performers (i.e., entertainers), independent",
  },
  {
    code: "711510",
    title: "Performing artists, independent",
  },
  {
    code: "711510",
    title: "Photographers, independent artistic",
  },
  {
    code: "711510",
    title: "Photojournalists, independent (freelance)",
  },
  {
    code: "711510",
    title: "Playwrights, independent",
  },
  {
    code: "711510",
    title: "Poets, independent",
  },
  {
    code: "711510",
    title: "Political cartoonists, independent",
  },
  {
    code: "711510",
    title: "Producers, independent",
  },
  {
    code: "711510",
    title: "Radio commentators, independent",
  },
  {
    code: "711510",
    title: "Record producers, independent",
  },
  {
    code: "711510",
    title: "Recording technicians, independent",
  },
  {
    code: "711510",
    title: "Reporters, independent (freelance)",
  },
  {
    code: "711510",
    title: "Scenery designers, independent theatrical",
  },
  {
    code: "711510",
    title: "Screenplay writers, independent",
  },
  {
    code: "711510",
    title: "Script writers, independent",
  },
  {
    code: "711510",
    title: "Sculptors, independent",
  },
  {
    code: "711510",
    title: "Set designers, independent theatrical",
  },
  {
    code: "711510",
    title: "Sketch artists, independent",
  },
  {
    code: "711510",
    title: "Song writers, independent",
  },
  {
    code: "711510",
    title: "Speakers, independent",
  },
  {
    code: "711510",
    title: "Special effect technicians, independent",
  },
  {
    code: "711510",
    title: "Sports announcers, independent",
  },
  {
    code: "711510",
    title:
      "Stage set (e.g., concert, motion picture, television) erecting and dismantling, independent",
  },
  {
    code: "711510",
    title: "Standup comedians, independent",
  },
  {
    code: "711510",
    title: "Storytellers, independent",
  },
  {
    code: "711510",
    title: "Taxidermists, independent",
  },
  {
    code: "711510",
    title: "Technical writers, independent",
  },
  {
    code: "711510",
    title: "Television producers, independent",
  },
  {
    code: "711510",
    title: "Wildlife artists, independent",
  },
  {
    code: "711510",
    title: "Writers of advertising copy, independent",
  },
  {
    code: "711510",
    title: "Writers, independent (freelance)",
  },
  {
    code: "712110",
    title: "Art galleries (except retail)",
  },
  {
    code: "712110",
    title: "Art museums",
  },
  {
    code: "712110",
    title: "Community museums",
  },
  {
    code: "712110",
    title: "Contemporary art museums",
  },
  {
    code: "712110",
    title: "Decorative art museums",
  },
  {
    code: "712110",
    title: "Fine arts museums",
  },
  {
    code: "712110",
    title: "Galleries, art (except retail)",
  },
  {
    code: "712110",
    title: "Halls of fame",
  },
  {
    code: "712110",
    title: "Herbariums",
  },
  {
    code: "712110",
    title: "Historical museums",
  },
  {
    code: "712110",
    title: "Human history museums",
  },
  {
    code: "712110",
    title: "Interactive museums",
  },
  {
    code: "712110",
    title: "Marine museums",
  },
  {
    code: "712110",
    title: "Military museums",
  },
  {
    code: "712110",
    title: "Mobile museums",
  },
  {
    code: "712110",
    title: "Multidisciplinary museums",
  },
  {
    code: "712110",
    title: "Museums",
  },
  {
    code: "712110",
    title: "Natural history museums",
  },
  {
    code: "712110",
    title: "Natural science museums",
  },
  {
    code: "712110",
    title: "Observatories (except research institutions)",
  },
  {
    code: "712110",
    title: "Planetariums",
  },
  {
    code: "712110",
    title: "Science and technology museums",
  },
  {
    code: "712110",
    title: "Sports halls of fame",
  },
  {
    code: "712110",
    title: "Traveling museum exhibits",
  },
  {
    code: "712110",
    title: "War museums",
  },
  {
    code: "712110",
    title: "Wax museums",
  },
  {
    code: "712120",
    title: "Archeological sites (i.e., public display)",
  },
  {
    code: "712120",
    title: "Battlefields",
  },
  {
    code: "712120",
    title: "Heritage villages",
  },
  {
    code: "712120",
    title: "Historical forts",
  },
  {
    code: "712120",
    title: "Historical ships",
  },
  {
    code: "712120",
    title: "Historical sites",
  },
  {
    code: "712120",
    title: "Pioneer villages",
  },
  {
    code: "712130",
    title: "Animal exhibits, live",
  },
  {
    code: "712130",
    title: "Animal safari parks",
  },
  {
    code: "712130",
    title: "Aquariums",
  },
  {
    code: "712130",
    title: "Arboreta",
  },
  {
    code: "712130",
    title: "Arboretums",
  },
  {
    code: "712130",
    title: "Aviaries",
  },
  {
    code: "712130",
    title: "Botanical gardens",
  },
  {
    code: "712130",
    title: "Conservatories, botanical",
  },
  {
    code: "712130",
    title: "Gardens, zoological or botanical",
  },
  {
    code: "712130",
    title: "Menageries",
  },
  {
    code: "712130",
    title: "Parks, wild animal",
  },
  {
    code: "712130",
    title: "Petting zoos",
  },
  {
    code: "712130",
    title: "Reptile exhibits, live",
  },
  {
    code: "712130",
    title: "Wild animal parks",
  },
  {
    code: "712130",
    title: "Zoological gardens",
  },
  {
    code: "712130",
    title: "Zoos",
  },
  {
    code: "712190",
    title: "Bird sanctuaries",
  },
  {
    code: "712190",
    title: "Caverns (i.e., natural wonder tourist attractions)",
  },
  {
    code: "712190",
    title: "Conservation areas",
  },
  {
    code: "712190",
    title: "Interpretive centers, nature",
  },
  {
    code: "712190",
    title: "National parks",
  },
  {
    code: "712190",
    title: "Natural wonder tourist attractions (e.g., caverns, waterfalls)",
  },
  {
    code: "712190",
    title: "Nature centers",
  },
  {
    code: "712190",
    title: "Nature parks",
  },
  {
    code: "712190",
    title: "Nature preserves",
  },
  {
    code: "712190",
    title: "Nature reserves",
  },
  {
    code: "712190",
    title: "Parks, national",
  },
  {
    code: "712190",
    title: "Parks, nature",
  },
  {
    code: "712190",
    title: "Provincial parks",
  },
  {
    code: "712190",
    title: "Waterfalls (i.e., natural wonder tourist attractions)",
  },
  {
    code: "712190",
    title: "Wildlife sanctuaries",
  },
  {
    code: "713110",
    title: "Amusement parks (e.g., theme, water)",
  },
  {
    code: "713110",
    title: "Parks (e.g., theme, water), amusement",
  },
  {
    code: "713110",
    title: "Piers, amusement",
  },
  {
    code: "713110",
    title: "Theme parks, amusement",
  },
  {
    code: "713110",
    title: "Water parks, amusement",
  },
  {
    code: "713120",
    title: "Amusement arcades",
  },
  {
    code: "713120",
    title: "Amusement device (except gambling) parlors, coin- or card-operated",
  },
  {
    code: "713120",
    title: "Amusement devices (except gambling) operated in own facilities",
  },
  {
    code: "713120",
    title: "Arcades, amusement",
  },
  {
    code: "713120",
    title: "Electronic game arcades",
  },
  {
    code: "713120",
    title: "Family fun centers",
  },
  {
    code: "713120",
    title: "Game rooms (except gambling)",
  },
  {
    code: "713120",
    title: "Indoor play areas",
  },
  {
    code: "713120",
    title: "Pinball arcades",
  },
  {
    code: "713120",
    title: "Video game arcades (except gambling)",
  },
  {
    code: "713210",
    title: "Casinos (except casino hotels)",
  },
  {
    code: "713210",
    title: "Casinos (except casino hotels) with racetrack",
  },
  {
    code: "713210",
    title: "Cruises, gambling",
  },
  {
    code: "713210",
    title: "Floating casinos (i.e., gambling cruises, riverboat casinos)",
  },
  {
    code: "713210",
    title: "Gambling cruises",
  },
  {
    code: "713210",
    title: "Riverboat casinos",
  },
  {
    code: "713210",
    title: "Stand-alone casinos (except slot machine parlors)",
  },
  {
    code: "713290",
    title: "Betting information services",
  },
  {
    code: "713290",
    title: "Bingo halls",
  },
  {
    code: "713290",
    title: "Bingo parlors",
  },
  {
    code: "713290",
    title: "Bookies",
  },
  {
    code: "713290",
    title: "Bookmakers",
  },
  {
    code: "713290",
    title: "Card rooms (e.g., poker rooms)",
  },
  {
    code: "713290",
    title:
      "Coin- or card-operated gambling device concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713290",
    title: "Gambling control boards, operating gambling activities",
  },
  {
    code: "713290",
    title: "Gambling device arcades or parlors, coin- or card-operated",
  },
  {
    code: "713290",
    title:
      "Gambling device concession operators (i.e., supplying and servicing in others' facilities), coin- or card-operated",
  },
  {
    code: "713290",
    title: "Lottery control boards (i.e., operating lotteries)",
  },
  {
    code: "713290",
    title: "Lottery corporations",
  },
  {
    code: "713290",
    title: "Lottery ticket sales agents (except retail stores)",
  },
  {
    code: "713290",
    title: "Lottery ticket vendors (except retail stores)",
  },
  {
    code: "713290",
    title: "Off-track betting parlors",
  },
  {
    code: "713290",
    title: "Online gambling sites",
  },
  {
    code: "713290",
    title: "Online sports betting sites",
  },
  {
    code: "713290",
    title:
      "Slot machine concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713290",
    title: "Slot machine parlors",
  },
  {
    code: "713290",
    title:
      "Video gambling device concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713290",
    title:
      "Video gaming device concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713910",
    title: "Country clubs",
  },
  {
    code: "713910",
    title: "Golf and country clubs",
  },
  {
    code: "713910",
    title: "Golf courses (except miniature, pitch-n-putt)",
  },
  {
    code: "713920",
    title: "Alpine skiing facilities without accommodations",
  },
  {
    code: "713920",
    title: "Cross country skiing facilities without accommodations",
  },
  {
    code: "713920",
    title: "Downhill skiing facilities without accommodations",
  },
  {
    code: "713920",
    title: "Four season ski resorts without accommodations",
  },
  {
    code: "713920",
    title: "Ski lift and tow operators",
  },
  {
    code: "713920",
    title: "Ski resorts without accommodations",
  },
  {
    code: "713920",
    title: "Skiing facilities, cross country, without accommodations",
  },
  {
    code: "713920",
    title: "Skiing facilities, downhill, without accommodations",
  },
  {
    code: "713930",
    title: "Boating clubs with marinas",
  },
  {
    code: "713930",
    title: "Marinas",
  },
  {
    code: "713930",
    title: "Marine basins, operation of",
  },
  {
    code: "713930",
    title: "Sailing clubs with marinas",
  },
  {
    code: "713930",
    title: "Yacht basins",
  },
  {
    code: "713930",
    title: "Yacht clubs with marinas",
  },
  {
    code: "713940",
    title: "Aerobic dance and exercise centers",
  },
  {
    code: "713940",
    title: "Athletic club facilities, physical fitness",
  },
  {
    code: "713940",
    title: "Body building studios, physical fitness",
  },
  {
    code: "713940",
    title: "Dance centers, aerobic",
  },
  {
    code: "713940",
    title: "Exercise centers",
  },
  {
    code: "713940",
    title: "Fitness centers",
  },
  {
    code: "713940",
    title: "Fitness salons",
  },
  {
    code: "713940",
    title: "Fitness spas without accommodations",
  },
  {
    code: "713940",
    title: "Gymnasiums",
  },
  {
    code: "713940",
    title: "Gyms, physical fitness",
  },
  {
    code: "713940",
    title: "Handball club facilities",
  },
  {
    code: "713940",
    title: "Health club facilities, physical fitness",
  },
  {
    code: "713940",
    title: "Health spas without accommodations, physical fitness",
  },
  {
    code: "713940",
    title: "Health studios, physical fitness",
  },
  {
    code: "713940",
    title: "Ice skating rinks",
  },
  {
    code: "713940",
    title: "Physical fitness centers",
  },
  {
    code: "713940",
    title: "Physical fitness facilities",
  },
  {
    code: "713940",
    title: "Physical fitness studios",
  },
  {
    code: "713940",
    title: "Pilates fitness studios or centers",
  },
  {
    code: "713940",
    title: "Racquetball club facilities",
  },
  {
    code: "713940",
    title: "Recreational sports club facilities",
  },
  {
    code: "713940",
    title: "Rinks, ice or roller skating",
  },
  {
    code: "713940",
    title: "Roller skating rinks",
  },
  {
    code: "713940",
    title: "Spas without accommodations, fitness",
  },
  {
    code: "713940",
    title: "Sports club facilities, physical fitness",
  },
  {
    code: "713940",
    title: "Squash club facilities",
  },
  {
    code: "713940",
    title: "Strength development centers",
  },
  {
    code: "713940",
    title: "Swimming pools",
  },
  {
    code: "713940",
    title: "Tennis club facilities",
  },
  {
    code: "713940",
    title: "Tennis courts",
  },
  {
    code: "713940",
    title: "Wave pools",
  },
  {
    code: "713940",
    title: "Weight training centers",
  },
  {
    code: "713940",
    title: "Yoga fitness studios or centers",
  },
  {
    code: "713950",
    title: "Bowling alleys",
  },
  {
    code: "713950",
    title: "Bowling centers",
  },
  {
    code: "713950",
    title: "Candle pin bowling alleys",
  },
  {
    code: "713950",
    title: "Candle pin bowling centers",
  },
  {
    code: "713950",
    title: "Duck pin bowling alleys",
  },
  {
    code: "713950",
    title: "Duck pin bowling centers",
  },
  {
    code: "713950",
    title: "Five pin bowling centers",
  },
  {
    code: "713950",
    title: "Ten pin bowling alleys",
  },
  {
    code: "713950",
    title: "Ten pin bowling centers",
  },
  {
    code: "713990",
    title: "Amateur sports teams, recreational",
  },
  {
    code: "713990",
    title:
      "Amusement device (except gambling) concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title:
      "Amusement ride concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title: "Archery ranges",
  },
  {
    code: "713990",
    title:
      "Athletic clubs (i.e., sports teams) not operating sports facilities, recreational",
  },
  {
    code: "713990",
    title: "Aviation clubs, recreational",
  },
  {
    code: "713990",
    title: "Axe throwing clubs",
  },
  {
    code: "713990",
    title: "Ballrooms",
  },
  {
    code: "713990",
    title: "Baseball clubs, recreational",
  },
  {
    code: "713990",
    title: "Basketball clubs, recreational",
  },
  {
    code: "713990",
    title: "Bathing beaches",
  },
  {
    code: "713990",
    title: "Beach clubs, recreational",
  },
  {
    code: "713990",
    title: "Beaches, bathing",
  },
  {
    code: "713990",
    title: "Billiard parlors",
  },
  {
    code: "713990",
    title: "Billiard rooms",
  },
  {
    code: "713990",
    title: "Boating clubs without marinas",
  },
  {
    code: "713990",
    title: "Boccie ball courts",
  },
  {
    code: "713990",
    title: "Bowling leagues or teams, recreational",
  },
  {
    code: "713990",
    title: "Boxing clubs, recreational",
  },
  {
    code: "713990",
    title: "Boys' day camps (except instructional)",
  },
  {
    code: "713990",
    title: "Bridge clubs, recreational",
  },
  {
    code: "713990",
    title: "Camps (except instructional), day",
  },
  {
    code: "713990",
    title: "Canoeing, recreational",
  },
  {
    code: "713990",
    title:
      "Carnival ride concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title: "Chess or bridge clubs, recreational",
  },
  {
    code: "713990",
    title:
      "Coin- or card-operated nongambling amusement device concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title: "Concession operators, amusement device (except gambling) and ride",
  },
  {
    code: "713990",
    title: "Curling facilities",
  },
  {
    code: "713990",
    title: "Dance halls",
  },
  {
    code: "713990",
    title: "Discotheques (except those serving alcoholic beverages)",
  },
  {
    code: "713990",
    title: "Driving ranges, golf",
  },
  {
    code: "713990",
    title: "Escape game rooms",
  },
  {
    code: "713990",
    title: "Escape rooms",
  },
  {
    code: "713990",
    title: "Esports video gaming clubs, teams, or leagues, recreational",
  },
  {
    code: "713990",
    title: "Fireworks display services",
  },
  {
    code: "713990",
    title: "Fishing clubs, recreational",
  },
  {
    code: "713990",
    title: "Fishing guide services",
  },
  {
    code: "713990",
    title: "Fishing piers",
  },
  {
    code: "713990",
    title: "Flying clubs, recreational",
  },
  {
    code: "713990",
    title: "Football clubs, recreational",
  },
  {
    code: "713990",
    title: "Galleries, shooting",
  },
  {
    code: "713990",
    title: "Girls' day camps (except instructional)",
  },
  {
    code: "713990",
    title: "Gocart raceways (i.e., amusement rides)",
  },
  {
    code: "713990",
    title: "Gocart tracks (i.e., amusement rides)",
  },
  {
    code: "713990",
    title: "Golf courses, miniature",
  },
  {
    code: "713990",
    title: "Golf courses, pitch-n-putt",
  },
  {
    code: "713990",
    title: "Golf driving ranges",
  },
  {
    code: "713990",
    title: "Golf practice ranges",
  },
  {
    code: "713990",
    title: "Guide services (i.e., fishing, hunting, tourist)",
  },
  {
    code: "713990",
    title: "Guide services, fishing",
  },
  {
    code: "713990",
    title: "Guide services, hunting",
  },
  {
    code: "713990",
    title: "Guide services, tourist",
  },
  {
    code: "713990",
    title: "Gun clubs, recreational",
  },
  {
    code: "713990",
    title:
      "Haunted houses and similar fright attractions, concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title: "Hockey clubs, recreational",
  },
  {
    code: "713990",
    title: "Hockey teams, recreational",
  },
  {
    code: "713990",
    title: "Hookah lounges (except primarily selling food and beverages)",
  },
  {
    code: "713990",
    title: "Horse rental services, recreational saddle",
  },
  {
    code: "713990",
    title: "Horseback riding, recreational",
  },
  {
    code: "713990",
    title: "Hunting clubs, recreational",
  },
  {
    code: "713990",
    title: "Hunting guide services",
  },
  {
    code: "713990",
    title: "Ice hockey clubs, recreational",
  },
  {
    code: "713990",
    title:
      "Jukebox concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title: "Kayaking, recreational",
  },
  {
    code: "713990",
    title: "Lawn bowling clubs",
  },
  {
    code: "713990",
    title: "Miniature golf courses",
  },
  {
    code: "713990",
    title: "Mountain hiking, recreational",
  },
  {
    code: "713990",
    title: "Nightclubs without alcoholic beverages",
  },
  {
    code: "713990",
    title: "Nudist camps without accommodations",
  },
  {
    code: "713990",
    title: "Observation towers",
  },
  {
    code: "713990",
    title:
      "Outdoor adventure operations (e.g., white water rafting) without accommodations",
  },
  {
    code: "713990",
    title: "Outfitters (i.e., providing trips and equipment)",
  },
  {
    code: "713990",
    title: "Pack trains (i.e., trail riding), recreational",
  },
  {
    code: "713990",
    title: "Paintball, laser tag, and similar fields and arenas",
  },
  {
    code: "713990",
    title: "Parasailing, recreational",
  },
  {
    code: "713990",
    title: "Pickleball clubs, recreational",
  },
  {
    code: "713990",
    title: "Picnic grounds",
  },
  {
    code: "713990",
    title:
      "Pinball machine concession operators (i.e., supplying and servicing in others' facilities)",
  },
  {
    code: "713990",
    title: "Ping pong parlors",
  },
  {
    code: "713990",
    title: "Pool halls",
  },
  {
    code: "713990",
    title: "Pool parlors",
  },
  {
    code: "713990",
    title: "Pool rooms",
  },
  {
    code: "713990",
    title: "Racetracks, slot car (i.e., amusement devices)",
  },
  {
    code: "713990",
    title: "Raceways, gocart (i.e., amusement rides)",
  },
  {
    code: "713990",
    title: "Recreational camps without accommodations",
  },
  {
    code: "713990",
    title: "Recreational day camps (except instructional)",
  },
  {
    code: "713990",
    title:
      "Recreational sports clubs (i.e., sports teams) not operating sports facilities",
  },
  {
    code: "713990",
    title: "Recreational sports teams and leagues",
  },
  {
    code: "713990",
    title: "Riding clubs, recreational",
  },
  {
    code: "713990",
    title: "Riding stables (except boarding horses)",
  },
  {
    code: "713990",
    title: "Rifle clubs, recreational",
  },
  {
    code: "713990",
    title: "River rafting, recreational",
  },
  {
    code: "713990",
    title: "Rowing clubs, recreational",
  },
  {
    code: "713990",
    title: "Saddle horse rental services, recreational",
  },
  {
    code: "713990",
    title: "Sailing clubs without marinas",
  },
  {
    code: "713990",
    title: "Sea kayaking, recreational",
  },
  {
    code: "713990",
    title: "Shooting clubs, recreational",
  },
  {
    code: "713990",
    title: "Shooting galleries",
  },
  {
    code: "713990",
    title: "Shooting ranges",
  },
  {
    code: "713990",
    title: "Skeet shooting facilities",
  },
  {
    code: "713990",
    title: "Slot car racetracks (i.e., amusement devices)",
  },
  {
    code: "713990",
    title: "Snowmobiling, recreational",
  },
  {
    code: "713990",
    title: "Soccer clubs, recreational",
  },
  {
    code: "713990",
    title:
      "Sports clubs (i.e., sports teams) not operating sports facilities, recreational",
  },
  {
    code: "713990",
    title: "Sports teams and leagues, recreational or youth",
  },
  {
    code: "713990",
    title: "Stables, riding",
  },
  {
    code: "713990",
    title: "Summer day camps (except instructional)",
  },
  {
    code: "713990",
    title: "Tourist guide services",
  },
  {
    code: "713990",
    title: "Trail riding, recreational",
  },
  {
    code: "713990",
    title: "Trampoline facilities, recreational",
  },
  {
    code: "713990",
    title: "Trapshooting facilities, recreational",
  },
  {
    code: "713990",
    title: "Waterslides (i.e., amusement rides)",
  },
  {
    code: "713990",
    title: "Wax figure exhibitions, amusement",
  },
  {
    code: "713990",
    title: "White water rafting, recreational",
  },
  {
    code: "713990",
    title: "Yacht clubs without marinas",
  },
  {
    code: "713990",
    title: "Youth sports league teams",
  },
  {
    code: "713990",
    title: "Zip-line courses (i.e., amusement rides)",
  },
  {
    code: "721110",
    title: "Alpine skiing facilities with accommodations (i.e., ski resorts)",
  },
  {
    code: "721110",
    title: "Auto courts, lodging",
  },
  {
    code: "721110",
    title: "Automobile courts, lodging",
  },
  {
    code: "721110",
    title:
      "Health spas (i.e., physical fitness facilities) with accommodations",
  },
  {
    code: "721110",
    title:
      "Hotel management services (i.e., providing management and operating staff to run hotel)",
  },
  {
    code: "721110",
    title: "Hotels (except casino hotels)",
  },
  {
    code: "721110",
    title:
      "Hotels (except casino hotels) with golf courses, tennis courts, and/or other health spa facilities (i.e., resorts)",
  },
  {
    code: "721110",
    title: "Hotels, membership",
  },
  {
    code: "721110",
    title: "Hotels, resort, without casinos",
  },
  {
    code: "721110",
    title: "Hotels, seasonal, without casinos",
  },
  {
    code: "721110",
    title: "Membership hotels",
  },
  {
    code: "721110",
    title: "Motels",
  },
  {
    code: "721110",
    title: "Motor courts",
  },
  {
    code: "721110",
    title: "Motor hotels without casinos",
  },
  {
    code: "721110",
    title: "Motor inns",
  },
  {
    code: "721110",
    title: "Motor lodges",
  },
  {
    code: "721110",
    title: "Resort hotels without casinos",
  },
  {
    code: "721110",
    title: "Seasonal hotels without casinos",
  },
  {
    code: "721110",
    title: "Ski lodges and resorts with accommodations",
  },
  {
    code: "721110",
    title: "Summer resort hotels without casinos",
  },
  {
    code: "721110",
    title: "Tourist lodges",
  },
  {
    code: "721120",
    title: "Casino hotels",
  },
  {
    code: "721120",
    title: "Hotels, casino",
  },
  {
    code: "721120",
    title: "Hotels, resort, with casinos",
  },
  {
    code: "721120",
    title: "Hotels, seasonal, with casinos",
  },
  {
    code: "721120",
    title: "Resort hotels with casinos",
  },
  {
    code: "721191",
    title: "Bed and breakfast inns",
  },
  {
    code: "721191",
    title: "Inns, bed and breakfast",
  },
  {
    code: "721199",
    title: "Cabins, housekeeping",
  },
  {
    code: "721199",
    title: "Cottages, housekeeping",
  },
  {
    code: "721199",
    title: "Guest houses",
  },
  {
    code: "721199",
    title: "Hostels",
  },
  {
    code: "721199",
    title: "Housekeeping cabins",
  },
  {
    code: "721199",
    title: "Housekeeping cottages",
  },
  {
    code: "721199",
    title: "Tourist courts",
  },
  {
    code: "721199",
    title: "Tourist homes",
  },
  {
    code: "721199",
    title: "Youth hostels",
  },
  {
    code: "721211",
    title: "Campgrounds",
  },
  {
    code: "721211",
    title: "Campsites",
  },
  {
    code: "721211",
    title: "Recreational vehicle parks",
  },
  {
    code: "721211",
    title: "RV (recreational vehicle) parks",
  },
  {
    code: "721211",
    title: "Travel trailer campsites",
  },
  {
    code: "721214",
    title: "Boys' camps (except day, instructional)",
  },
  {
    code: "721214",
    title: "Camps (except day, instructional)",
  },
  {
    code: "721214",
    title: "Children's camps (except day, instructional)",
  },
  {
    code: "721214",
    title: "Dude ranches",
  },
  {
    code: "721214",
    title: "Fishing camps with accommodation facilities",
  },
  {
    code: "721214",
    title: "Girls' camps (except day, instructional)",
  },
  {
    code: "721214",
    title: "Guest ranches with accommodation facilities",
  },
  {
    code: "721214",
    title: "Hunting camps with accommodation facilities",
  },
  {
    code: "721214",
    title: "Nudist camps with accommodation facilities",
  },
  {
    code: "721214",
    title: "Outdoor adventure retreats with accommodation facilities",
  },
  {
    code: "721214",
    title:
      "Recreational camps with accommodation facilities (except campgrounds)",
  },
  {
    code: "721214",
    title: "Summer camps (except day, instructional)",
  },
  {
    code: "721214",
    title: "Trail riding camps with accommodation facilities",
  },
  {
    code: "721214",
    title: "Vacation camps (except campgrounds, day, instructional)",
  },
  {
    code: "721214",
    title: "Wilderness camps",
  },
  {
    code: "721310",
    title: "Boarding houses",
  },
  {
    code: "721310",
    title: "Clubs, residential",
  },
  {
    code: "721310",
    title: "Corporate rooming and boarding houses",
  },
  {
    code: "721310",
    title: "Dormitories, off campus",
  },
  {
    code: "721310",
    title: "Fraternity houses",
  },
  {
    code: "721310",
    title: "Migrant workers' camps",
  },
  {
    code: "721310",
    title: "Off campus dormitories",
  },
  {
    code: "721310",
    title: "Residence clubs, organizational",
  },
  {
    code: "721310",
    title: "Residential clubs",
  },
  {
    code: "721310",
    title: "Rooming and boarding houses",
  },
  {
    code: "721310",
    title: "Sorority houses",
  },
  {
    code: "721310",
    title: "Workers' camps",
  },
  {
    code: "721310",
    title: "Workers' dormitories",
  },
  {
    code: "722310",
    title: "Airline food services contractors",
  },
  {
    code: "722310",
    title:
      "Cafeteria food services contractors (e.g., government office cafeterias, hospital cafeterias, school cafeterias)",
  },
  {
    code: "722310",
    title:
      "Food concession contractors (e.g., convention facilities, entertainment facilities, sporting facilities)",
  },
  {
    code: "722310",
    title: "Food service contractors, airline",
  },
  {
    code: "722310",
    title: "Food service contractors, cafeteria",
  },
  {
    code: "722310",
    title:
      "Food service contractors, concession operators (e.g., convention facilities, entertainment facilities, sporting facilities)",
  },
  {
    code: "722310",
    title: "Food service contractors, industrial",
  },
  {
    code: "722310",
    title: "Food service contractors, institutional",
  },
  {
    code: "722310",
    title:
      "Industrial caterers (i.e., providing food services on a contractual arrangement (except single-event basis))",
  },
  {
    code: "722320",
    title: "Banquet halls with catering staff",
  },
  {
    code: "722320",
    title: "Bartender services including supply of equipment and alcohol",
  },
  {
    code: "722320",
    title: "Bartender services on own account (serving only)",
  },
  {
    code: "722320",
    title: "Caterers",
  },
  {
    code: "722320",
    title: "Catering services, social",
  },
  {
    code: "722330",
    title: "Beverage stands, nonalcoholic, mobile",
  },
  {
    code: "722330",
    title: "Canteens, mobile",
  },
  {
    code: "722330",
    title: "Coffee carts, mobile",
  },
  {
    code: "722330",
    title: "Concession snack stands, mobile",
  },
  {
    code: "722330",
    title: "Food carts and trucks, mobile",
  },
  {
    code: "722330",
    title: "Food concession stands, mobile",
  },
  {
    code: "722330",
    title: "Ice cream truck vendors",
  },
  {
    code: "722330",
    title: "Lunch wagons",
  },
  {
    code: "722330",
    title: "Mobile food stands",
  },
  {
    code: "722330",
    title: "Refreshment stands, mobile",
  },
  {
    code: "722330",
    title: "Snack stands, mobile",
  },
  {
    code: "722330",
    title: "Street vendors, food",
  },
  {
    code: "722410",
    title: "Alcoholic beverage drinking places",
  },
  {
    code: "722410",
    title: "Bars (i.e., drinking places), alcoholic beverage",
  },
  {
    code: "722410",
    title:
      "Brew pubs, primarily serving alcoholic beverages for immediate consumption",
  },
  {
    code: "722410",
    title: "Cocktail lounges",
  },
  {
    code: "722410",
    title: "Discotheques, alcoholic beverage",
  },
  {
    code: "722410",
    title: "Drinking places (i.e., bars, lounges, taverns), alcoholic",
  },
  {
    code: "722410",
    title: "Lounges, cocktail",
  },
  {
    code: "722410",
    title: "Nightclubs, alcoholic beverage",
  },
  {
    code: "722410",
    title: "Tap rooms (i.e., drinking places)",
  },
  {
    code: "722410",
    title: "Taverns (i.e., drinking places)",
  },
  {
    code: "722511",
    title: "Bagel shops, full service",
  },
  {
    code: "722511",
    title: "Brew pub restaurants, primarily serving meals, full service",
  },
  {
    code: "722511",
    title: "Diners, full service",
  },
  {
    code: "722511",
    title: "Doughnut shops, full service",
  },
  {
    code: "722511",
    title: "Family restaurants, full service",
  },
  {
    code: "722511",
    title: "Fine dining restaurants, full service",
  },
  {
    code: "722511",
    title: "Full service restaurants",
  },
  {
    code: "722511",
    title: "Pizza parlors, full service",
  },
  {
    code: "722511",
    title: "Pizzerias, full service",
  },
  {
    code: "722511",
    title: "Restaurants, full service",
  },
  {
    code: "722511",
    title: "Steak houses, full service",
  },
  {
    code: "722513",
    title: "Cafes, limited-service",
  },
  {
    code: "722513",
    title: "Carryout restaurants",
  },
  {
    code: "722513",
    title: "Delicatessen restaurants",
  },
  {
    code: "722513",
    title: "Diners, limited-service",
  },
  {
    code: "722513",
    title: "Drive-in restaurants",
  },
  {
    code: "722513",
    title: "Family restaurants, limited-service",
  },
  {
    code: "722513",
    title: "Fast casual restaurants",
  },
  {
    code: "722513",
    title: "Fast-food restaurants",
  },
  {
    code: "722513",
    title: "Pizza delivery shops",
  },
  {
    code: "722513",
    title: "Pizza parlors, limited-service",
  },
  {
    code: "722513",
    title: "Pizzerias, limited-service (e.g., takeout)",
  },
  {
    code: "722513",
    title: "Restaurants, carryout",
  },
  {
    code: "722513",
    title: "Restaurants, fast-food",
  },
  {
    code: "722513",
    title: "Sandwich shops, limited-service",
  },
  {
    code: "722513",
    title: "Steak houses, limited-service",
  },
  {
    code: "722513",
    title: "Sub shops, limited-service",
  },
  {
    code: "722513",
    title: "Takeout eating places",
  },
  {
    code: "722514",
    title: "Buffet eating places",
  },
  {
    code: "722514",
    title: "Cafeterias",
  },
  {
    code: "722515",
    title: "Bagel shops, on premise baking and carryout service",
  },
  {
    code: "722515",
    title:
      "Bakery cafes, on premise baking and selling for immediate consumption",
  },
  {
    code: "722515",
    title:
      "Beverage (e.g., coffee, juice, soft drink) bars, nonalcoholic, fixed location",
  },
  {
    code: "722515",
    title: "Canteens, fixed location",
  },
  {
    code: "722515",
    title: "Coffee shops, on premise brewing",
  },
  {
    code: "722515",
    title: "Confectionery snack shops, made on premises with carryout services",
  },
  {
    code: "722515",
    title: "Cookie shops, on premise baking and carryout service",
  },
  {
    code: "722515",
    title: "Doughnut shops, on premise baking and carryout service",
  },
  {
    code: "722515",
    title: "Fixed location refreshment stands",
  },
  {
    code: "722515",
    title: "Frozen custard stands, fixed location",
  },
  {
    code: "722515",
    title: "Frozen yogurt shops",
  },
  {
    code: "722515",
    title: "Ice cream parlors",
  },
  {
    code: "722515",
    title: "Juice bars, nonalcoholic, fixed location",
  },
  {
    code: "722515",
    title: "Pretzel shops, on premise baking and carryout service",
  },
  {
    code: "722515",
    title: "Refreshment stands, fixed location",
  },
  {
    code: "722515",
    title: "Smoothie shops",
  },
  {
    code: "722515",
    title: "Snack bars (e.g., cookies, popcorn, pretzels), fixed location",
  },
  {
    code: "722515",
    title: "Soft drink beverage bars, nonalcoholic, fixed location",
  },
  {
    code: "811111",
    title: "Automotive engine repair and replacement shops",
  },
  {
    code: "811111",
    title: "Automotive fleet repair and maintenance services",
  },
  {
    code: "811111",
    title: "Automotive repair and replacement shops, general",
  },
  {
    code: "811111",
    title: "Car repair shops, general",
  },
  {
    code: "811111",
    title: "Diesel engine repair shops, automotive",
  },
  {
    code: "811111",
    title: "Engine repair and replacement shops, automotive",
  },
  {
    code: "811111",
    title:
      "Garages, general automotive repair (except gasoline service stations)",
  },
  {
    code: "811111",
    title: "General automotive repair shops",
  },
  {
    code: "811111",
    title: "Mobile automotive and truck repair services",
  },
  {
    code: "811111",
    title: "Recreational vehicle (RV) repair and maintenance services, general",
  },
  {
    code: "811111",
    title: "Truck repair shops, general",
  },
  {
    code: "811114",
    title: "Automotive brake repair shops",
  },
  {
    code: "811114",
    title: "Automotive electrical repair shops",
  },
  {
    code: "811114",
    title: "Automotive exhaust system repair and replacement shops",
  },
  {
    code: "811114",
    title: "Automotive front end alignment shops",
  },
  {
    code: "811114",
    title: "Automotive radiator repair shops",
  },
  {
    code: "811114",
    title: "Automotive suspension repair shops",
  },
  {
    code: "811114",
    title: "Automotive transmission repair shops",
  },
  {
    code: "811114",
    title: "Automotive tune-up shops",
  },
  {
    code: "811114",
    title: "Brake repair shops, automotive",
  },
  {
    code: "811114",
    title: "Drive shaft repair shops, automotive",
  },
  {
    code: "811114",
    title: "Electrical repair shops, automotive",
  },
  {
    code: "811114",
    title: "Exhaust system repair and replacement shops, automotive",
  },
  {
    code: "811114",
    title: "Front end alignment shops, automotive",
  },
  {
    code: "811114",
    title: "Ignition and battery repair shops, automotive",
  },
  {
    code: "811114",
    title: "Muffler repair and replacement shops",
  },
  {
    code: "811114",
    title: "Radiator repair shops, automotive",
  },
  {
    code: "811114",
    title: "Suspension repair shops, automotive",
  },
  {
    code: "811114",
    title: "Transmission repair shops, automotive",
  },
  {
    code: "811114",
    title: "Tune-up shops, automotive",
  },
  {
    code: "811114",
    title: "Wheel alignment shops, automotive",
  },
  {
    code: "811121",
    title: "Antique and classic automotive restoration",
  },
  {
    code: "811121",
    title: "Automotive body shops",
  },
  {
    code: "811121",
    title: "Automotive paint shops",
  },
  {
    code: "811121",
    title: "Automotive upholstery shops",
  },
  {
    code: "811121",
    title: "Body conversion services, automotive",
  },
  {
    code: "811121",
    title: "Body shops, automotive",
  },
  {
    code: "811121",
    title: "Interior repair shops, automotive",
  },
  {
    code: "811121",
    title: "Paint shops, automotive",
  },
  {
    code: "811121",
    title: "Restoration shops, antique and classic automotive",
  },
  {
    code: "811121",
    title: "Truck trailer body shops",
  },
  {
    code: "811121",
    title: "Truck trailer paint and body repair",
  },
  {
    code: "811121",
    title: "Upholstery shops, automotive",
  },
  {
    code: "811121",
    title: "Van conversion shops (except on assembly line or factory basis)",
  },
  {
    code: "811122",
    title: "Automotive glass shops",
  },
  {
    code: "811122",
    title: "Glass installation, automotive repair",
  },
  {
    code: "811122",
    title: "Glass shops, automotive",
  },
  {
    code: "811122",
    title: "Glass tinting, automotive",
  },
  {
    code: "811122",
    title: "Glass work, automotive",
  },
  {
    code: "811122",
    title: "Window tinting, automotive",
  },
  {
    code: "811122",
    title: "Windshield repair shops, automotive",
  },
  {
    code: "811191",
    title: "Automotive oil change and lubrication shops",
  },
  {
    code: "811191",
    title: "Lubrication shops, automotive",
  },
  {
    code: "811191",
    title: "Oil change and lubrication shops, automotive",
  },
  {
    code: "811191",
    title: "Quick-lube shops",
  },
  {
    code: "811192",
    title: "Automotive detail shops",
  },
  {
    code: "811192",
    title: "Automotive detailing services (i.e., cleaning, polishing)",
  },
  {
    code: "811192",
    title: "Automotive washing and polishing",
  },
  {
    code: "811192",
    title: "Car detailers",
  },
  {
    code: "811192",
    title: "Car washes",
  },
  {
    code: "811192",
    title: "Detailing services (i.e., cleaning and polishing), automotive",
  },
  {
    code: "811192",
    title: "Mobile car and truck washes",
  },
  {
    code: "811192",
    title: "Self-service car washes",
  },
  {
    code: "811192",
    title: "Truck and bus washes",
  },
  {
    code: "811198",
    title: "Automotive air-conditioning repair shops",
  },
  {
    code: "811198",
    title: "Automotive emissions testing services",
  },
  {
    code: "811198",
    title: "Automotive rustproofing and undercoating shops",
  },
  {
    code: "811198",
    title: "Automotive safety inspection services",
  },
  {
    code: "811198",
    title: "Automotive tire repair (except retreading) shops",
  },
  {
    code: "811198",
    title: "Diagnostic centers without repair, automotive",
  },
  {
    code: "811198",
    title: "Emissions testing without repair, automotive",
  },
  {
    code: "811198",
    title: "Garages, do-it-yourself automotive repair",
  },
  {
    code: "811198",
    title: "Rustproofing shops, automotive",
  },
  {
    code: "811198",
    title: "Spray-on bedliner installation for trucks",
  },
  {
    code: "811198",
    title: "Tire repair shops (except retreading), automotive",
  },
  {
    code: "811198",
    title: "Undercoating shops, automotive",
  },
  {
    code: "811210",
    title: "Broadcast equipment repair and maintenance services",
  },
  {
    code: "811210",
    title: "Camera repair shops without retailing new cameras",
  },
  {
    code: "811210",
    title:
      "Cellular telephone repair and maintenance services without retailing new cellular telephones",
  },
  {
    code: "811210",
    title: "Communication equipment repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Computer peripheral equipment repair and maintenance, without retailing new computer peripheral equipment",
  },
  {
    code: "811210",
    title:
      "Computer repair and maintenance services, without retailing new computers",
  },
  {
    code: "811210",
    title:
      "Consumer electronics repair and maintenance services without retailing new consumer electronics",
  },
  {
    code: "811210",
    title: "Dental equipment repair and maintenance services",
  },
  {
    code: "811210",
    title: "Diagnostic imaging equipment repair and maintenance services",
  },
  {
    code: "811210",
    title: "Electrical measuring instrument repair and maintenance services",
  },
  {
    code: "811210",
    title: "Facsimile machine repair and maintenance services",
  },
  {
    code: "811210",
    title: "Fax machine repair and maintenance services",
  },
  {
    code: "811210",
    title: "Laboratory instrument repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Laptop repair and maintenance services, without retailing new laptops",
  },
  {
    code: "811210",
    title: "Measuring instrument repair and maintenance services",
  },
  {
    code: "811210",
    title: "Medical and surgical equipment repair and maintenance services",
  },
  {
    code: "811210",
    title: "Meteorological instrument repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Navigational instruments (e.g., radar, sonar) repair and maintenance services",
  },
  {
    code: "811210",
    title: "Office machine repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Optical instrument repair and maintenance services (e.g., microscopes, telescopes)",
  },
  {
    code: "811210",
    title:
      "Photocopying machine repair and maintenance services without retailing new photocopying machines",
  },
  {
    code: "811210",
    title:
      "Photographic equipment repair shops without retailing new photographic equipment",
  },
  {
    code: "811210",
    title: "Precision equipment calibration",
  },
  {
    code: "811210",
    title: "Public address system repair and maintenance services",
  },
  {
    code: "811210",
    title: "Radar and sonar equipment repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Radio repair and maintenance services without retailing new radios ",
  },
  {
    code: "811210",
    title: "Radio repair, automotive, without retailing new",
  },
  {
    code: "811210",
    title:
      "Stereo equipment repair shops without retailing new stereo equipment",
  },
  {
    code: "811210",
    title: "Surgical instrument repair and maintenance services",
  },
  {
    code: "811210",
    title: "Surveying instrument repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Tablet repair and maintenance services, without retailing new tablets",
  },
  {
    code: "811210",
    title:
      "Telephone equipment repair and maintenance services without retailing new telephone equipment",
  },
  {
    code: "811210",
    title: "Television repair services without retailing new televisions",
  },
  {
    code: "811210",
    title: "Two-way radio repair and maintenance services",
  },
  {
    code: "811210",
    title: "Typewriter repair and maintenance services",
  },
  {
    code: "811210",
    title:
      "Video cassette recorder (VCR) repair services without retailing new video cassette recorders",
  },
  {
    code: "811210",
    title:
      "Weighing equipment (e.g., balance, scales) repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Agricultural machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Armature rewinding services (except on an assembly line or factory basis)",
  },
  {
    code: "811310",
    title:
      "Blade sharpening, commercial and industrial machinery and equipment",
  },
  {
    code: "811310",
    title: "Cargo container repair and maintenance services",
  },
  {
    code: "811310",
    title: "Coil rewinding (except on an assembly line or factory basis)",
  },
  {
    code: "811310",
    title:
      "Commercial and industrial machinery repair and maintenance services",
  },
  {
    code: "811310",
    title: "Commercial gaming machine repair and maintenance services",
  },
  {
    code: "811310",
    title: "Commercial refrigeration equipment repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Construction machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Electric motor repair and maintenance services, commercial or industrial",
  },
  {
    code: "811310",
    title:
      "Electrical generating and transmission equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Engine repair (except automotive, small engine)",
  },
  {
    code: "811310",
    title: "Farm machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Fire extinguisher repair and maintenance, without installation",
  },
  {
    code: "811310",
    title: "Food machinery repair and maintenance services",
  },
  {
    code: "811310",
    title: "Forestry machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Forklift repair and maintenance services",
  },
  {
    code: "811310",
    title: "Foundry machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Freezer, commercial, repair and maintenance services",
  },
  {
    code: "811310",
    title: "Heavy machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Hydraulic equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Industrial equipment and machinery repair and maintenance services",
  },
  {
    code: "811310",
    title: "Industrial truck (e.g., forklifts) repair and maintenance services",
  },
  {
    code: "811310",
    title: "Machine tools repair and maintenance services",
  },
  {
    code: "811310",
    title: "Material handling equipment repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Mechanical power transmission equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Mining machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Motor repair and maintenance services, commercial or industrial",
  },
  {
    code: "811310",
    title:
      "Oil and gas field machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Paper making machinery repair and maintenance services",
  },
  {
    code: "811310",
    title: "Printing trade machinery repair and maintenance services",
  },
  {
    code: "811310",
    title: "Reconditioning shipping barrels and drums",
  },
  {
    code: "811310",
    title:
      "Refrigeration equipment repair and maintenance services, industrial and commercial-type",
  },
  {
    code: "811310",
    title: "Restaurant fryer equipment cleaning services",
  },
  {
    code: "811310",
    title: "Rewinding armatures (except on an assembly line or factory basis)",
  },
  {
    code: "811310",
    title: "Service machinery and equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Textile machinery repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Tractor, farm or construction equipment repair and maintenance services",
  },
  {
    code: "811310",
    title: "Truck refrigeration repair and maintenance services",
  },
  {
    code: "811310",
    title:
      "Waterless fire suppression system repair and maintenance, without installation",
  },
  {
    code: "811310",
    title: "Welding repair services (e.g., automotive, general)",
  },
  {
    code: "811411",
    title: "Engine repair, small",
  },
  {
    code: "811411",
    title:
      "Garden equipment repair and maintenance services without retailing new garden equipment",
  },
  {
    code: "811411",
    title: "Garden tool sharpening and repair services",
  },
  {
    code: "811411",
    title:
      "Handtools, power-driven, repair and maintenance services without retailing new power-driven handtools",
  },
  {
    code: "811411",
    title:
      "Lawn and garden equipment repair and maintenance services without retailing new lawn and garden equipment",
  },
  {
    code: "811411",
    title:
      "Lawnmower repair and maintenance shops without retailing new lawnmowers ",
  },
  {
    code: "811411",
    title:
      "Saw repair and maintenance (except sawmills) without retailing new saws",
  },
  {
    code: "811411",
    title: "Small engine repair and maintenance shops",
  },
  {
    code: "811411",
    title:
      "Tool, home and garden, sharpening and repair services without retailing new home and garden tools",
  },
  {
    code: "811411",
    title:
      "Tractor, lawn and garden, repair and maintenance services without retailing new lawn and garden tractors",
  },
  {
    code: "811412",
    title: "Air-conditioner, window, repair and maintenance services",
  },
  {
    code: "811412",
    title:
      "Appliance, household-type, repair and maintenance services without retailing new appliances",
  },
  {
    code: "811412",
    title:
      "Clothes dryer, household-type, repair and maintenance services without retailing new clothes dryers",
  },
  {
    code: "811412",
    title:
      "Dishwasher, household-type, repair and maintenance services without retailing new dishwashers",
  },
  {
    code: "811412",
    title:
      "Microwave oven, household-type, repair and maintenance services, without retailing new microwave ovens",
  },
  {
    code: "811412",
    title:
      "Oven, household-type, repair and maintenance services without retailing new ovens",
  },
  {
    code: "811412",
    title:
      "Refrigerator, household-type, repair and maintenance services without retailing new refrigerators",
  },
  {
    code: "811412",
    title:
      "Sewing machine, household-type, repair shops without retailing new sewing machines",
  },
  {
    code: "811412",
    title:
      "Stove, household-type, repair and maintenance services without retailing new stoves",
  },
  {
    code: "811412",
    title:
      "Washing machine, household-type, repair and maintenance services without retailing new washing machine",
  },
  {
    code: "811412",
    title:
      "Water heater repair and maintenance services without retailing new water heaters",
  },
  {
    code: "811420",
    title: "Aircraft upholstery repair",
  },
  {
    code: "811420",
    title: "Antique furniture repair and restoration shops",
  },
  {
    code: "811420",
    title: "Furniture refinishing shops",
  },
  {
    code: "811420",
    title: "Furniture repair shops",
  },
  {
    code: "811420",
    title: "Furniture reupholstering shops",
  },
  {
    code: "811420",
    title: "Restoration and repair of antique furniture",
  },
  {
    code: "811420",
    title: "Reupholstery shops, furniture",
  },
  {
    code: "811420",
    title: "Upholstery (except motor vehicle) repair services",
  },
  {
    code: "811430",
    title: "Boot repair shops without retailing new boots",
  },
  {
    code: "811430",
    title: "Leather goods repair shops without retailing new leather goods",
  },
  {
    code: "811430",
    title: "Luggage repair shops without retailing new luggage",
  },
  {
    code: "811430",
    title: "Saddlery repair shops without retailing new saddlery",
  },
  {
    code: "811430",
    title: "Shoe repair shops without retailing new shoes",
  },
  {
    code: "811490",
    title:
      "Bicycle repair and maintenance shops without retailing new bicycles",
  },
  {
    code: "811490",
    title:
      "Boat, pleasure, repair and maintenance services without retailing new boats",
  },
  {
    code: "811490",
    title: "China repair services",
  },
  {
    code: "811490",
    title: "Clock repair shops without retailing new clocks",
  },
  {
    code: "811490",
    title: "Clothing repair shops, alterations only",
  },
  {
    code: "811490",
    title: "Cutlery (e.g., knives, scissors) sharpening, household-type",
  },
  {
    code: "811490",
    title:
      "Exercise and athletic equipment repair and maintenance services without retailing new exercise and athletic equipment",
  },
  {
    code: "811490",
    title: "Fur garment repair shops without retailing new fur garments",
  },
  {
    code: "811490",
    title:
      "Garment alteration and/or repair shops without retailing new garments",
  },
  {
    code: "811490",
    title: "Gun repair and maintenance shops without retailing new guns",
  },
  {
    code: "811490",
    title: "Gunsmith shops without retailing new guns",
  },
  {
    code: "811490",
    title: "Jewelry repair shops without retailing new jewelry",
  },
  {
    code: "811490",
    title: "Key duplicating shops",
  },
  {
    code: "811490",
    title:
      "Motorboat (i.e., inboard and outboard) repair and maintenance services",
  },
  {
    code: "811490",
    title: "Motorcycle repair shops without retailing new motorcycles",
  },
  {
    code: "811490",
    title:
      "Musical instrument repair shops without retailing new musical instruments",
  },
  {
    code: "811490",
    title: "Outboard motor repair shops",
  },
  {
    code: "811490",
    title:
      "Pleasure boat maintenance services (e.g., cleaning, scaling, waxing)",
  },
  {
    code: "811490",
    title:
      "Sporting equipment repair and maintenance without retailing new sports equipment",
  },
  {
    code: "811490",
    title: "Tailor shops, alterations only",
  },
  {
    code: "811490",
    title: "Tuning and repair of musical instruments",
  },
  {
    code: "811490",
    title:
      "Venetian blind repair and maintenance shops without retailing new venetian blinds",
  },
  {
    code: "811490",
    title: "Watch repair shops without retailing new watches",
  },
  {
    code: "811490",
    title: "Window shade repair and maintenance shops",
  },
  {
    code: "812111",
    title: "Barber shops",
  },
  {
    code: "812111",
    title: "Hair stylist services, men's",
  },
  {
    code: "812111",
    title: "Hair stylist shops, men's",
  },
  {
    code: "812112",
    title: "Beautician services",
  },
  {
    code: "812112",
    title: "Beauty and barber shops, combined",
  },
  {
    code: "812112",
    title: "Beauty parlors",
  },
  {
    code: "812112",
    title: "Beauty salons",
  },
  {
    code: "812112",
    title: "Beauty shops",
  },
  {
    code: "812112",
    title: "Cosmetology salons or shops",
  },
  {
    code: "812112",
    title: "Esthetician (i.e., skin care) services",
  },
  {
    code: "812112",
    title: "Facial salons",
  },
  {
    code: "812112",
    title: "Hair stylist salons or shops, unisex or women's",
  },
  {
    code: "812112",
    title: "Hair stylist services, unisex or women's",
  },
  {
    code: "812112",
    title: "Hairdresser services",
  },
  {
    code: "812112",
    title: "Hairdressing salons or shops, unisex or women's",
  },
  {
    code: "812112",
    title: "Makeup (except permanent) salons",
  },
  {
    code: "812112",
    title: "Unisex hair stylist shops",
  },
  {
    code: "812113",
    title: "Manicure and pedicure salons",
  },
  {
    code: "812113",
    title: "Manicurist services",
  },
  {
    code: "812113",
    title: "Nail salons",
  },
  {
    code: "812113",
    title: "Pedicure and manicure salons",
  },
  {
    code: "812113",
    title: "Pedicurist services",
  },
  {
    code: "812191",
    title: "Diet centers, non-medical",
  },
  {
    code: "812191",
    title: "Diet workshops",
  },
  {
    code: "812191",
    title: "Weight loss centers, non-medical",
  },
  {
    code: "812191",
    title: "Weight reducing centers, non-medical",
  },
  {
    code: "812199",
    title: "Aqua therapy services, non-medical",
  },
  {
    code: "812199",
    title: "Baths, steam or turkish",
  },
  {
    code: "812199",
    title: "Color consulting services (i.e., personal care services)",
  },
  {
    code: "812199",
    title: "Day spas",
  },
  {
    code: "812199",
    title: "Depilatory (i.e., hair removal) salons",
  },
  {
    code: "812199",
    title: "Ear piercing services",
  },
  {
    code: "812199",
    title: "Electrolysis (i.e., hair removal) salons",
  },
  {
    code: "812199",
    title: "Eyebrow threading services",
  },
  {
    code: "812199",
    title:
      "Hair removal (i.e., depilatory, electrolysis, laser, waxing) services",
  },
  {
    code: "812199",
    title: "Hair replacement services (except by offices of physicians)",
  },
  {
    code: "812199",
    title: "Hair weaving services",
  },
  {
    code: "812199",
    title: "Makeup salons, permanent",
  },
  {
    code: "812199",
    title: "Massage wellness spas/centers",
  },
  {
    code: "812199",
    title: "Microblading tattoo services",
  },
  {
    code: "812199",
    title: "Saunas",
  },
  {
    code: "812199",
    title: "Scalp treating services",
  },
  {
    code: "812199",
    title: "Steam baths",
  },
  {
    code: "812199",
    title: "Sun tanning salons",
  },
  {
    code: "812199",
    title: "Tanning salons",
  },
  {
    code: "812199",
    title: "Tattoo parlors",
  },
  {
    code: "812199",
    title: "Turkish bathhouses",
  },
  {
    code: "812199",
    title: "Turkish baths",
  },
  {
    code: "812210",
    title: "Director services, funeral",
  },
  {
    code: "812210",
    title: "Embalming services",
  },
  {
    code: "812210",
    title: "Funeral director services",
  },
  {
    code: "812210",
    title: "Funeral homes",
  },
  {
    code: "812210",
    title: "Funeral homes combined with crematories",
  },
  {
    code: "812210",
    title: "Funeral parlors",
  },
  {
    code: "812210",
    title: "Human remains transportation services",
  },
  {
    code: "812210",
    title: "Mortician services",
  },
  {
    code: "812210",
    title: "Mortuaries",
  },
  {
    code: "812210",
    title: "Undertaker services",
  },
  {
    code: "812220",
    title: "Animal cemeteries",
  },
  {
    code: "812220",
    title: "Cemeteries",
  },
  {
    code: "812220",
    title: "Cemetery associations (i.e., operators)",
  },
  {
    code: "812220",
    title: "Cemetery management services",
  },
  {
    code: "812220",
    title: "Cemetery subdividers",
  },
  {
    code: "812220",
    title: "Columbariums",
  },
  {
    code: "812220",
    title: "Crematories (except combined with funeral homes)",
  },
  {
    code: "812220",
    title: "Mausoleums",
  },
  {
    code: "812220",
    title: "Memorial gardens (i.e., burial places)",
  },
  {
    code: "812220",
    title: "Pet cemeteries",
  },
  {
    code: "812220",
    title: "Pet crematories",
  },
  {
    code: "812310",
    title: "Automatic laundries, coin-operated",
  },
  {
    code: "812310",
    title: "Coin-operated drycleaners and laundries",
  },
  {
    code: "812310",
    title:
      "Coin-operated laundry and drycleaning routes (i.e., concession operators)",
  },
  {
    code: "812310",
    title:
      "Drycleaning machine routes (i.e., concession operators), coin-operated or similar self-service",
  },
  {
    code: "812310",
    title: "Drycleaning services, coin-operated or similar self-service",
  },
  {
    code: "812310",
    title: "Launderettes",
  },
  {
    code: "812310",
    title: "Laundries, coin-operated or similar self-service",
  },
  {
    code: "812310",
    title: "Laundromats",
  },
  {
    code: "812310",
    title:
      "Laundry machine routes (i.e., concession operators), coin-operated or similar self-service",
  },
  {
    code: "812310",
    title: "Laundry services, coin-operated or similar self-service",
  },
  {
    code: "812310",
    title: "Self-service drycleaners and laundries",
  },
  {
    code: "812320",
    title: "Agents, laundry and drycleaning",
  },
  {
    code: "812320",
    title: "Apparel pressing services",
  },
  {
    code: "812320",
    title: "Bobtailers, laundry and drycleaning",
  },
  {
    code: "812320",
    title: "Cleaners, drycleaning and laundry service (except coin-operated)",
  },
  {
    code: "812320",
    title: "Cleaning and dyeing plants (except rug cleaning plants)",
  },
  {
    code: "812320",
    title: "Collecting and distributing agents, laundry and drycleaning",
  },
  {
    code: "812320",
    title: "Curtain cleaning services",
  },
  {
    code: "812320",
    title: "Drapery cleaning services",
  },
  {
    code: "812320",
    title: "Drop-off and pick-up sites for laundries and drycleaners",
  },
  {
    code: "812320",
    title: "Drycleaner drop-off and pick-up sites",
  },
  {
    code: "812320",
    title: "Drycleaners (except coin-operated)",
  },
  {
    code: "812320",
    title: "Drycleaning plants (except rug cleaning plants)",
  },
  {
    code: "812320",
    title: "Drycleaning services (except coin-operated)",
  },
  {
    code: "812320",
    title: "Fur garment cleaning services",
  },
  {
    code: "812320",
    title: "Garment cleaning (e.g., fur, leather, suede) services",
  },
  {
    code: "812320",
    title: "Hand laundries",
  },
  {
    code: "812320",
    title: "Hat cleaning services",
  },
  {
    code: "812320",
    title: "Laundries (except coin-operated, linen supply, uniform supply)",
  },
  {
    code: "812320",
    title: "Laundry and drycleaning agents",
  },
  {
    code: "812320",
    title: "Laundry drop-off and pick-up sites",
  },
  {
    code: "812320",
    title:
      "Laundry services (except coin-operated, linen supply, uniform supply)",
  },
  {
    code: "812320",
    title: "Leather garment cleaning services",
  },
  {
    code: "812320",
    title: "Pick-up and drop-off sites for drycleaners and laundries",
  },
  {
    code: "812320",
    title: "Pillow cleaning services",
  },
  {
    code: "812320",
    title: "Power laundries, family",
  },
  {
    code: "812320",
    title: "Suede garment cleaning services",
  },
  {
    code: "812331",
    title: "Apron supply services",
  },
  {
    code: "812331",
    title: "Bed linen supply services",
  },
  {
    code: "812331",
    title:
      "Coat (e.g., barber's, beautician's, doctor's, nurse's) supply services",
  },
  {
    code: "812331",
    title: "Cooperative hospital laundries (i.e., linen supply services)",
  },
  {
    code: "812331",
    title: "Diaper supply services",
  },
  {
    code: "812331",
    title:
      "Gown (e.g., doctors, nurses, hospital, beauticians) supply services",
  },
  {
    code: "812331",
    title: "Laundries, linen and uniform supply",
  },
  {
    code: "812331",
    title: "Laundry services, linen supply",
  },
  {
    code: "812331",
    title: "Linen supply services",
  },
  {
    code: "812331",
    title: "Table linen supply services",
  },
  {
    code: "812331",
    title: "Towel (except shop, wiping) supply services",
  },
  {
    code: "812331",
    title: "Uniform (except industrial) supply services",
  },
  {
    code: "812332",
    title: "Clean room apparel supply services",
  },
  {
    code: "812332",
    title:
      "Dust control textile item (e.g., cloths, mats, mops, rugs, shop towels) supply services",
  },
  {
    code: "812332",
    title: "Flame resistant clothing supply services",
  },
  {
    code: "812332",
    title: "Industrial launderers",
  },
  {
    code: "812332",
    title: "Industrial uniform supply services",
  },
  {
    code: "812332",
    title: "Laundered mat and rug supply services",
  },
  {
    code: "812332",
    title: "Launderers, industrial",
  },
  {
    code: "812332",
    title: "Laundry services, industrial",
  },
  {
    code: "812332",
    title: "Mat and rug supply services",
  },
  {
    code: "812332",
    title: "Protective apparel supply services",
  },
  {
    code: "812332",
    title: "Radiation protection garment supply services",
  },
  {
    code: "812332",
    title: "Towel supply services, shop or wiping",
  },
  {
    code: "812332",
    title: "Uniform supply services, industrial",
  },
  {
    code: "812332",
    title: "Work clothing and uniform supply services, industrial",
  },
  {
    code: "812910",
    title: "Animal grooming services",
  },
  {
    code: "812910",
    title: "Animal shelters",
  },
  {
    code: "812910",
    title: "Boarding services, pet",
  },
  {
    code: "812910",
    title: "Dog pounds",
  },
  {
    code: "812910",
    title: "Grooming services, animal",
  },
  {
    code: "812910",
    title: "Guard dog training services",
  },
  {
    code: "812910",
    title: "Guide dog training services",
  },
  {
    code: "812910",
    title: "Kennels, pet boarding",
  },
  {
    code: "812910",
    title: "Obedience training services, pet",
  },
  {
    code: "812910",
    title: "Pedigree record services, pet",
  },
  {
    code: "812910",
    title: "Pet boarding services",
  },
  {
    code: "812910",
    title: "Pet grooming services",
  },
  {
    code: "812910",
    title: "Pet sitting services",
  },
  {
    code: "812910",
    title: "Pet training services",
  },
  {
    code: "812910",
    title: "Pet walking services",
  },
  {
    code: "812910",
    title: "Sitting services, pet",
  },
  {
    code: "812910",
    title: "Working, sporting, and service dog training services",
  },
  {
    code: "812921",
    title: "Film developing and printing (except motion picture, one-hour)",
  },
  {
    code: "812921",
    title: "Photofinishing labs (except one-hour)",
  },
  {
    code: "812921",
    title: "Photofinishing services (except one-hour)",
  },
  {
    code: "812922",
    title: "Film developing and printing, one-hour",
  },
  {
    code: "812922",
    title: "One-hour photofinishing services",
  },
  {
    code: "812922",
    title: "Photofinishing labs, one-hour",
  },
  {
    code: "812922",
    title: "Photofinishing services, one-hour",
  },
  {
    code: "812930",
    title: "Automobile parking garages or lots",
  },
  {
    code: "812930",
    title: "Garages, automobile parking",
  },
  {
    code: "812930",
    title: "Parking garages, automobile",
  },
  {
    code: "812930",
    title: "Parking lots, automobile",
  },
  {
    code: "812930",
    title: "Parking services, valet",
  },
  {
    code: "812930",
    title: "Valet parking services",
  },
  {
    code: "812990",
    title: "Astrology services",
  },
  {
    code: "812990",
    title: "Baby shoe bronzing services",
  },
  {
    code: "812990",
    title: "Bail bonding services",
  },
  {
    code: "812990",
    title: "Balloon-o-gram services",
  },
  {
    code: "812990",
    title:
      "Blood pressure testing machine concession operators, coin- or card-operated",
  },
  {
    code: "812990",
    title: "Bondsperson services",
  },
  {
    code: "812990",
    title: "Check room services",
  },
  {
    code: "812990",
    title:
      "Coin- or card-operated personal service machine (e.g., blood pressure, locker, photographic, scale, shoeshine) concession operators",
  },
  {
    code: "812990",
    title: "Comfort station operation",
  },
  {
    code: "812990",
    title: "Concierge services",
  },
  {
    code: "812990",
    title: "Consumer buying services",
  },
  {
    code: "812990",
    title:
      "Credit card notification services (i.e., lost or stolen card reporting)",
  },
  {
    code: "812990",
    title: "Dating services",
  },
  {
    code: "812990",
    title:
      "Discount buying services, including medical cards and similar negotiated discount plans for individuals",
  },
  {
    code: "812990",
    title: "Doula services (providing coaching and support during childbirth)",
  },
  {
    code: "812990",
    title: "Escort services, social",
  },
  {
    code: "812990",
    title: "Fortune-telling services",
  },
  {
    code: "812990",
    title: "Genealogical investigation services",
  },
  {
    code: "812990",
    title: "House sitting services",
  },
  {
    code: "812990",
    title: "Identity theft protection services",
  },
  {
    code: "812990",
    title: "Introduction services, social",
  },
  {
    code: "812990",
    title: "Lockers, coin- or card-operated, rental",
  },
  {
    code: "812990",
    title: "Numerology services",
  },
  {
    code: "812990",
    title: "Online dating services (through a website or mobile application)",
  },
  {
    code: "812990",
    title: "Organizer services, personal",
  },
  {
    code: "812990",
    title: "Palm reading services",
  },
  {
    code: "812990",
    title: "Party planning services",
  },
  {
    code: "812990",
    title: "Pay telephone equipment concession operators",
  },
  {
    code: "812990",
    title: "Personal chef services",
  },
  {
    code: "812990",
    title: "Personal fitness training services",
  },
  {
    code: "812990",
    title: "Personal organizer services",
  },
  {
    code: "812990",
    title: "Personal shopping services",
  },
  {
    code: "812990",
    title: "Photographic machine concession operators, coin- or card-operated",
  },
  {
    code: "812990",
    title: "Porter services",
  },
  {
    code: "812990",
    title: "Psychic services",
  },
  {
    code: "812990",
    title: "Rest room operation",
  },
  {
    code: "812990",
    title: "Shoeshine parlors",
  },
  {
    code: "812990",
    title: "Shoeshine services",
  },
  {
    code: "812990",
    title: "Shopping services, personal",
  },
  {
    code: "812990",
    title: "Singing telegram services",
  },
  {
    code: "812990",
    title: "Sitting services, house",
  },
  {
    code: "812990",
    title: "Social escort services",
  },
  {
    code: "812990",
    title: "Telegram services, singing",
  },
  {
    code: "812990",
    title: "Wedding chapels (except churches)",
  },
  {
    code: "812990",
    title: "Wedding planning services",
  },
  {
    code: "813110",
    title: "Bible societies",
  },
  {
    code: "813110",
    title: "Churches",
  },
  {
    code: "813110",
    title: "Convents (except schools)",
  },
  {
    code: "813110",
    title: "Ministries, religious",
  },
  {
    code: "813110",
    title: "Missions, religious organization",
  },
  {
    code: "813110",
    title: "Monasteries (except schools)",
  },
  {
    code: "813110",
    title: "Mosques, religious",
  },
  {
    code: "813110",
    title: "Places of worship",
  },
  {
    code: "813110",
    title: "Religious organizations",
  },
  {
    code: "813110",
    title: "Retreat houses, religious",
  },
  {
    code: "813110",
    title: "Shrines, religious",
  },
  {
    code: "813110",
    title: "Synagogues",
  },
  {
    code: "813110",
    title: "Temples, religious",
  },
  {
    code: "813211",
    title: "Charitable trusts, awarding grants",
  },
  {
    code: "813211",
    title: "Community foundations",
  },
  {
    code: "813211",
    title: "Corporate foundations, awarding grants",
  },
  {
    code: "813211",
    title: "Educational trusts, awarding grants",
  },
  {
    code: "813211",
    title: "Grantmaking foundations",
  },
  {
    code: "813211",
    title: "Philanthropic trusts, awarding grants",
  },
  {
    code: "813211",
    title:
      "Scholarship trusts (i.e., grantmaking, charitable trust foundations)",
  },
  {
    code: "813211",
    title: "Trusts, charitable, awarding grants",
  },
  {
    code: "813211",
    title: "Trusts, educational, awarding grants",
  },
  {
    code: "813211",
    title: "Trusts, religious, awarding grants",
  },
  {
    code: "813212",
    title: "Disease awareness fundraising organizations",
  },
  {
    code: "813212",
    title: "Disease research (e.g., cancer, heart) fundraising organizations",
  },
  {
    code: "813212",
    title: "Health research fundraising organizations",
  },
  {
    code: "813212",
    title:
      "Health research fundraising using a crowdfunding platform (except on a contract or fee basis)",
  },
  {
    code: "813212",
    title: "Voluntary health organizations",
  },
  {
    code: "813219",
    title:
      "Charitable fundraising using a crowdfunding platform (except on a contract or fee basis)",
  },
  {
    code: "813219",
    title: "Community chest fundraising organizations",
  },
  {
    code: "813219",
    title: "Federated charities",
  },
  {
    code: "813219",
    title: "United fund councils",
  },
  {
    code: "813219",
    title: "United funds for colleges",
  },
  {
    code: "813311",
    title: "Associations for retired persons, advocacy",
  },
  {
    code: "813311",
    title: "Civil liberties organizations",
  },
  {
    code: "813311",
    title: "Developmentally disabled advocacy organizations",
  },
  {
    code: "813311",
    title: "Human rights advocacy organizations",
  },
  {
    code: "813311",
    title: "Intellectually and developmentally disabled advocacy groups",
  },
  {
    code: "813311",
    title: "Senior citizens advocacy organizations",
  },
  {
    code: "813311",
    title: "Veterans' rights organizations",
  },
  {
    code: "813312",
    title: "Animal rights organizations",
  },
  {
    code: "813312",
    title: "Animal welfare associations or leagues",
  },
  {
    code: "813312",
    title: "Conservation advocacy organizations",
  },
  {
    code: "813312",
    title: "Environmental advocacy organizations",
  },
  {
    code: "813312",
    title: "Humane societies without animal shelters",
  },
  {
    code: "813312",
    title: "Natural resource preservation organizations",
  },
  {
    code: "813312",
    title: "Wildlife preservation organizations",
  },
  {
    code: "813319",
    title: "Accident prevention associations",
  },
  {
    code: "813319",
    title: "Antipoverty advocacy organizations",
  },
  {
    code: "813319",
    title: "Aviation advocacy organizations",
  },
  {
    code: "813319",
    title: "Community action advocacy organizations",
  },
  {
    code: "813319",
    title: "Drug abuse prevention advocacy organizations",
  },
  {
    code: "813319",
    title: "Drunk driving prevention advocacy organizations",
  },
  {
    code: "813319",
    title: "Firearms advocacy organizations",
  },
  {
    code: "813319",
    title: "Gun control organizations",
  },
  {
    code: "813319",
    title: "Hunting, fishing, and sport shooting advocacy organizations",
  },
  {
    code: "813319",
    title: "Neighborhood development advocacy organizations",
  },
  {
    code: "813319",
    title: "Peace advocacy organizations",
  },
  {
    code: "813319",
    title: "Public safety advocacy organizations",
  },
  {
    code: "813319",
    title: "Social change advocacy organizations",
  },
  {
    code: "813319",
    title: "Social service advocacy organizations",
  },
  {
    code: "813319",
    title: "Substance abuse prevention advocacy organizations",
  },
  {
    code: "813319",
    title: "Taxpayers' advocacy organizations",
  },
  {
    code: "813319",
    title: "Temperance organizations",
  },
  {
    code: "813319",
    title: "Tenants' advocacy associations",
  },
  {
    code: "813319",
    title: "Tenants' associations, advocacy",
  },
  {
    code: "813319",
    title: "World peace and understanding advocacy organizations",
  },
  {
    code: "813410",
    title: "Alumni associations",
  },
  {
    code: "813410",
    title: "Alumni clubs",
  },
  {
    code: "813410",
    title: "Automobile clubs (except road and travel services)",
  },
  {
    code: "813410",
    title: "Book discussion clubs",
  },
  {
    code: "813410",
    title: "Booster clubs",
  },
  {
    code: "813410",
    title: "Boy guiding organizations",
  },
  {
    code: "813410",
    title: "Civic associations",
  },
  {
    code: "813410",
    title: "Classic car clubs",
  },
  {
    code: "813410",
    title: "Computer enthusiasts clubs",
  },
  {
    code: "813410",
    title: "Ethnic associations",
  },
  {
    code: "813410",
    title: "Fan clubs",
  },
  {
    code: "813410",
    title: "Farm granges",
  },
  {
    code: "813410",
    title: "Fraternal associations or lodges, social or civic",
  },
  {
    code: "813410",
    title: "Fraternal lodges",
  },
  {
    code: "813410",
    title: "Fraternal organizations",
  },
  {
    code: "813410",
    title: "Fraternities (except residential)",
  },
  {
    code: "813410",
    title: "Garden clubs",
  },
  {
    code: "813410",
    title: "Girl guiding organizations",
  },
  {
    code: "813410",
    title: "Golden age clubs",
  },
  {
    code: "813410",
    title: "Granges",
  },
  {
    code: "813410",
    title: "Historical clubs",
  },
  {
    code: "813410",
    title: "Membership associations, civic or social",
  },
  {
    code: "813410",
    title: "Parent-teachers' associations",
  },
  {
    code: "813410",
    title: "Poetry clubs",
  },
  {
    code: "813410",
    title: "Public speaking improvement clubs",
  },
  {
    code: "813410",
    title: "Retirement associations, social",
  },
  {
    code: "813410",
    title: "Scouting organizations",
  },
  {
    code: "813410",
    title: "Senior citizens' associations, social",
  },
  {
    code: "813410",
    title: "Singing societies",
  },
  {
    code: "813410",
    title: "Social clubs",
  },
  {
    code: "813410",
    title: "Social organizations, civic and fraternal",
  },
  {
    code: "813410",
    title: "Sororities (except residential)",
  },
  {
    code: "813410",
    title: "Speakers' clubs",
  },
  {
    code: "813410",
    title: "Student clubs",
  },
  {
    code: "813410",
    title: "Students' associations",
  },
  {
    code: "813410",
    title: "Students' unions",
  },
  {
    code: "813410",
    title: "University clubs",
  },
  {
    code: "813410",
    title: "Veterans'  membership organizations",
  },
  {
    code: "813410",
    title: "Women's auxiliaries",
  },
  {
    code: "813410",
    title: "Women's clubs",
  },
  {
    code: "813410",
    title: "Writing clubs",
  },
  {
    code: "813410",
    title: "Youth civic clubs",
  },
  {
    code: "813410",
    title: "Youth clubs (except recreational only)",
  },
  {
    code: "813410",
    title: "Youth farming organizations",
  },
  {
    code: "813410",
    title: "Youth scouting organizations",
  },
  {
    code: "813410",
    title: "Youth social clubs",
  },
  {
    code: "813910",
    title:
      "Agricultural organizations (except youth farming organizations, farm granges)",
  },
  {
    code: "813910",
    title: "Animal breeders' associations",
  },
  {
    code: "813910",
    title: "Bankers' associations",
  },
  {
    code: "813910",
    title: "Better business bureaus",
  },
  {
    code: "813910",
    title: "Boards of trade",
  },
  {
    code: "813910",
    title: "Business associations",
  },
  {
    code: "813910",
    title: "Chambers of commerce",
  },
  {
    code: "813910",
    title: "Construction associations",
  },
  {
    code: "813910",
    title: "Contractors' associations",
  },
  {
    code: "813910",
    title: "Distributors' associations",
  },
  {
    code: "813910",
    title: "Farmers' associations",
  },
  {
    code: "813910",
    title: "Farmers' unions",
  },
  {
    code: "813910",
    title: "Growers' associations",
  },
  {
    code: "813910",
    title: "Hospital associations",
  },
  {
    code: "813910",
    title: "Industrial associations",
  },
  {
    code: "813910",
    title: "Insurers' associations",
  },
  {
    code: "813910",
    title: "Junior chambers of commerce",
  },
  {
    code: "813910",
    title: "Manufacturers' associations",
  },
  {
    code: "813910",
    title: "Merchants' associations",
  },
  {
    code: "813910",
    title: "Mining associations",
  },
  {
    code: "813910",
    title: "Producers' associations",
  },
  {
    code: "813910",
    title: "Public utility associations",
  },
  {
    code: "813910",
    title: "Real estate boards",
  },
  {
    code: "813910",
    title: "Restaurant associations",
  },
  {
    code: "813910",
    title: "Retailers' associations",
  },
  {
    code: "813910",
    title: "Service industries associations",
  },
  {
    code: "813910",
    title: "Shipping companies' associations",
  },
  {
    code: "813910",
    title: "Trade associations",
  },
  {
    code: "813910",
    title: "Warehousing associations",
  },
  {
    code: "813910",
    title: "Wholesalers' associations",
  },
  {
    code: "813920",
    title: "Accountants' associations",
  },
  {
    code: "813920",
    title: "Architects' associations",
  },
  {
    code: "813920",
    title: "Bar associations",
  },
  {
    code: "813920",
    title: "Consultants' associations",
  },
  {
    code: "813920",
    title: "Dentists' associations",
  },
  {
    code: "813920",
    title: "Dietitians' associations",
  },
  {
    code: "813920",
    title: "Educators' associations",
  },
  {
    code: "813920",
    title: "Engineers' associations",
  },
  {
    code: "813920",
    title: "Health professionals' associations",
  },
  {
    code: "813920",
    title: "Hospital administrators' associations",
  },
  {
    code: "813920",
    title: "Learned societies",
  },
  {
    code: "813920",
    title: "Medical associations",
  },
  {
    code: "813920",
    title: "Nurses' associations",
  },
  {
    code: "813920",
    title: "Occupational therapists' associations",
  },
  {
    code: "813920",
    title: "Optometrists' associations",
  },
  {
    code: "813920",
    title: "Peer review boards",
  },
  {
    code: "813920",
    title: "Personnel management associations",
  },
  {
    code: "813920",
    title: "Pharmacists' associations",
  },
  {
    code: "813920",
    title: "Professional associations",
  },
  {
    code: "813920",
    title: "Professional membership associations",
  },
  {
    code: "813920",
    title: "Professional standards review boards",
  },
  {
    code: "813920",
    title: "Psychologists' associations",
  },
  {
    code: "813920",
    title: "Scientific associations",
  },
  {
    code: "813920",
    title: "Social workers' associations",
  },
  {
    code: "813920",
    title: "Standards review committees, professional",
  },
  {
    code: "813930",
    title: "Collective bargaining units",
  },
  {
    code: "813930",
    title:
      "Employees' associations for improvement of wages and working conditions",
  },
  {
    code: "813930",
    title: "Federation of workers, labor organizations",
  },
  {
    code: "813930",
    title: "Federations of labor",
  },
  {
    code: "813930",
    title: "Industrial labor unions",
  },
  {
    code: "813930",
    title: "Labor federations",
  },
  {
    code: "813930",
    title: "Labor unions (except apprenticeship programs)",
  },
  {
    code: "813930",
    title: "Trade unions (except apprenticeship programs)",
  },
  {
    code: "813930",
    title: "Trade unions, local",
  },
  {
    code: "813930",
    title: "Unions (except apprenticeship programs), labor",
  },
  {
    code: "813940",
    title: "Campaign organizations, political",
  },
  {
    code: "813940",
    title: "Constituencies' associations, political party",
  },
  {
    code: "813940",
    title: "Local political organizations",
  },
  {
    code: "813940",
    title: "PACs (Political Action Committees)",
  },
  {
    code: "813940",
    title: "Political action committees (PACs)",
  },
  {
    code: "813940",
    title: "Political campaign organizations",
  },
  {
    code: "813940",
    title: "Political organizations or clubs",
  },
  {
    code: "813940",
    title: "Political parties",
  },
  {
    code: "813990",
    title: "Athletic associations, regulatory",
  },
  {
    code: "813990",
    title: "Athletic leagues (i.e., regulating bodies)",
  },
  {
    code: "813990",
    title: "Condominium corporations",
  },
  {
    code: "813990",
    title: "Condominium owners' associations",
  },
  {
    code: "813990",
    title: "Cooperative owners' associations",
  },
  {
    code: "813990",
    title: "Homeowners' associations",
  },
  {
    code: "813990",
    title: "Homeowners' associations, condominium",
  },
  {
    code: "813990",
    title: "Property owners' associations",
  },
  {
    code: "813990",
    title: "Sports governing bodies",
  },
  {
    code: "813990",
    title: "Sports leagues (i.e., regulating bodies)",
  },
  {
    code: "813990",
    title: "Tenants' associations (except advocacy)",
  },
  {
    code: "814110",
    title:
      "Households, private, employing (e.g., cooks, maids, chauffeurs, gardeners)",
  },
  {
    code: "814110",
    title: "Households, private, employing domestic personnel",
  },
  {
    code: "814110",
    title: "Private households employing domestic personnel",
  },
  {
    code: "814110",
    title: "Private households with employees",
  },
  {
    code: "921110",
    title: "Advisory commissions, executive government",
  },
  {
    code: "921110",
    title: "City and town managers' offices",
  },
  {
    code: "921110",
    title: "County supervisors' and executives' offices",
  },
  {
    code: "921110",
    title:
      "Executive offices, federal, state, and local (e.g., governor, mayor, president)",
  },
  {
    code: "921110",
    title: "Governors' offices",
  },
  {
    code: "921110",
    title: "Mayor's offices",
  },
  {
    code: "921110",
    title: "President's office, United States",
  },
  {
    code: "921120",
    title: "Advisory commissions, legislative",
  },
  {
    code: "921120",
    title: "Boards of supervisors, county and local",
  },
  {
    code: "921120",
    title: "City and town councils",
  },
  {
    code: "921120",
    title: "Congress of the United States",
  },
  {
    code: "921120",
    title: "County commissioners",
  },
  {
    code: "921120",
    title: "Legislative assemblies",
  },
  {
    code: "921120",
    title: "Legislative bodies (e.g., federal, local, and state)",
  },
  {
    code: "921120",
    title: "Legislative commissions",
  },
  {
    code: "921120",
    title: "Study commissions, legislative",
  },
  {
    code: "921130",
    title: "Assessor's offices, tax",
  },
  {
    code: "921130",
    title: "Board of Governors, Federal Reserve",
  },
  {
    code: "921130",
    title: "Budget agencies, government",
  },
  {
    code: "921130",
    title: "Controllers' and comptrollers' offices, government",
  },
  {
    code: "921130",
    title: "Customs bureaus",
  },
  {
    code: "921130",
    title: "Federal Reserve Board of Governors",
  },
  {
    code: "921130",
    title: "Gambling control boards, nonoperating",
  },
  {
    code: "921130",
    title: "Internal Revenue Service",
  },
  {
    code: "921130",
    title: "Lottery control boards, nonoperating",
  },
  {
    code: "921130",
    title: "Property tax assessors' offices",
  },
  {
    code: "921130",
    title: "State tax commissions",
  },
  {
    code: "921130",
    title: "Taxation departments",
  },
  {
    code: "921130",
    title: "Treasurers' offices, government",
  },
  {
    code: "921140",
    title: "Executive and legislative office combinations",
  },
  {
    code: "921140",
    title: "Legislative and executive office combinations",
  },
  {
    code: "921150",
    title: "American Indian or Alaska Native tribal councils",
  },
  {
    code: "921150",
    title: "American Indian or Alaska Native tribal courts",
  },
  {
    code: "921150",
    title:
      "American Indian or Alaska Native, tribal chief's or chairman's office",
  },
  {
    code: "921150",
    title: "Courts, American Indian or Alaska Native",
  },
  {
    code: "921150",
    title: "Police, American Indian or Alaska Native tribal",
  },
  {
    code: "921150",
    title:
      "Tribal chief's or chairman's office, American Indian or Alaska Native",
  },
  {
    code: "921150",
    title: "Tribal councils, American Indian or Alaska Native",
  },
  {
    code: "921150",
    title: "Tribal courts, American Indian or Alaska Native",
  },
  {
    code: "921190",
    title: "Auditor's offices, government",
  },
  {
    code: "921190",
    title: "Civil rights commissions",
  },
  {
    code: "921190",
    title: "Civil service commissions",
  },
  {
    code: "921190",
    title: "Election boards",
  },
  {
    code: "921190",
    title: "General accounting offices, government",
  },
  {
    code: "921190",
    title: "General public administration",
  },
  {
    code: "921190",
    title: "General services departments, government",
  },
  {
    code: "921190",
    title: "Human rights commissions, government",
  },
  {
    code: "921190",
    title: "Indian affairs programs, government",
  },
  {
    code: "921190",
    title: "Personnel offices, government",
  },
  {
    code: "921190",
    title: "Public property management services, government",
  },
  {
    code: "921190",
    title: "Purchasing and supply agencies, government",
  },
  {
    code: "921190",
    title: "Supply agencies, government",
  },
  {
    code: "922110",
    title: "Administrative courts",
  },
  {
    code: "922110",
    title: "Circuit courts",
  },
  {
    code: "922110",
    title: "City or county courts",
  },
  {
    code: "922110",
    title: "Courts of law, civilian (except American Indian or Alaska Native)",
  },
  {
    code: "922110",
    title: "Courts, civilian (except American Indian or Alaska Native)",
  },
  {
    code: "922110",
    title: "Courts, small claims",
  },
  {
    code: "922110",
    title: "Sheriffs' offices, court functions only",
  },
  {
    code: "922110",
    title: "Traffic courts",
  },
  {
    code: "922120",
    title: "Alcohol, tobacco, and firearms control",
  },
  {
    code: "922120",
    title: "Criminal investigation offices, government",
  },
  {
    code: "922120",
    title: "DEA (Drug Enforcement Administration)",
  },
  {
    code: "922120",
    title: "Drug enforcement agencies and offices",
  },
  {
    code: "922120",
    title: "Federal Bureau of Investigation (FBI)",
  },
  {
    code: "922120",
    title: "Federal police services",
  },
  {
    code: "922120",
    title: "Highway patrols, police",
  },
  {
    code: "922120",
    title: "Housing police, government",
  },
  {
    code: "922120",
    title: "Marshals' offices",
  },
  {
    code: "922120",
    title: "Park police",
  },
  {
    code: "922120",
    title: "Police academies",
  },
  {
    code: "922120",
    title: "Police and fire departments, combined",
  },
  {
    code: "922120",
    title: "Police departments (except American Indian or Alaska Native)",
  },
  {
    code: "922120",
    title: "Sheriffs' offices (except court functions only)",
  },
  {
    code: "922120",
    title: "State police",
  },
  {
    code: "922120",
    title: "Transit police",
  },
  {
    code: "922130",
    title: "Attorney generals' offices",
  },
  {
    code: "922130",
    title: "District attorneys' offices",
  },
  {
    code: "922130",
    title: "Legal counsel offices, government",
  },
  {
    code: "922130",
    title: "Public defenders' offices",
  },
  {
    code: "922130",
    title: "Public prosecutors' offices",
  },
  {
    code: "922130",
    title: "Solicitors' offices, government",
  },
  {
    code: "922130",
    title: "U.S. attorneys' offices",
  },
  {
    code: "922140",
    title: "Correctional boot camps (except private operation of)",
  },
  {
    code: "922140",
    title: "Correctional institutions (except private operation of)",
  },
  {
    code: "922140",
    title: "Detention centers (except private operation of)",
  },
  {
    code: "922140",
    title: "Honor camps, correctional (except private operation of)",
  },
  {
    code: "922140",
    title: "Houses of correction (except private operation of)",
  },
  {
    code: "922140",
    title: "Jails (except private operation of)",
  },
  {
    code: "922140",
    title: "Penitentiaries (except private operation of)",
  },
  {
    code: "922140",
    title: "Prison farms (except private operation of)",
  },
  {
    code: "922140",
    title: "Prisons (except private operation of)",
  },
  {
    code: "922140",
    title: "Reformatories (except private operation of)",
  },
  {
    code: "922150",
    title: "Pardon boards and offices",
  },
  {
    code: "922150",
    title: "Parole offices, publicly administered",
  },
  {
    code: "922150",
    title: "Probation offices, publicly administered",
  },
  {
    code: "922150",
    title: "Public parole offices",
  },
  {
    code: "922150",
    title: "Public probation offices",
  },
  {
    code: "922150",
    title: "Rehabilitation services, correctional, government",
  },
  {
    code: "922160",
    title: "Ambulance and fire service combined",
  },
  {
    code: "922160",
    title: "Fire and rescue service",
  },
  {
    code: "922160",
    title: "Fire departments (e.g., government, volunteer (except private))",
  },
  {
    code: "922160",
    title: "Fire marshals' offices",
  },
  {
    code: "922160",
    title: "Fire prevention offices, government",
  },
  {
    code: "922160",
    title:
      "Firefighting (except forest), government and volunteer (except private)",
  },
  {
    code: "922160",
    title: "Firefighting services (except forest and private)",
  },
  {
    code: "922190",
    title: "Consumer product safety commissions",
  },
  {
    code: "922190",
    title: "Criminal justice statistics centers, government",
  },
  {
    code: "922190",
    title: "Disaster preparedness and management offices, government",
  },
  {
    code: "922190",
    title: "Emergency planning and management offices, government",
  },
  {
    code: "922190",
    title: "Law enforcement statistics centers, government",
  },
  {
    code: "922190",
    title: "Public safety bureaus and statistics centers, government",
  },
  {
    code: "922190",
    title: "Public safety statistics centers, government",
  },
  {
    code: "923110",
    title: "Certification of schools and teachers",
  },
  {
    code: "923110",
    title: "County supervisors of education (except school boards)",
  },
  {
    code: "923110",
    title: "Education offices, nonoperating",
  },
  {
    code: "923110",
    title: "Education program administration",
  },
  {
    code: "923110",
    title: "Education statistics centers, government",
  },
  {
    code: "923110",
    title: "State education departments",
  },
  {
    code: "923110",
    title: "Teacher certification bureaus",
  },
  {
    code: "923110",
    title: "University regents or boards, government",
  },
  {
    code: "923120",
    title: "Cancer detection program administration",
  },
  {
    code: "923120",
    title: "Communicable disease program administration",
  },
  {
    code: "923120",
    title: "Community health programs administration",
  },
  {
    code: "923120",
    title: "Coroners' offices",
  },
  {
    code: "923120",
    title: "Environmental health program administration",
  },
  {
    code: "923120",
    title: "Food service health inspections",
  },
  {
    code: "923120",
    title: "Health planning and development agencies, government",
  },
  {
    code: "923120",
    title: "Health program administration",
  },
  {
    code: "923120",
    title: "Health statistics centers, government",
  },
  {
    code: "923120",
    title: "Immunization program administration",
  },
  {
    code: "923120",
    title: "Maternity and child health program administration",
  },
  {
    code: "923120",
    title: "Mental health program administration",
  },
  {
    code: "923120",
    title: "Public health program administration, nonoperating",
  },
  {
    code: "923130",
    title: "Community social service program administration",
  },
  {
    code: "923130",
    title: "Equal employment opportunity offices",
  },
  {
    code: "923130",
    title: "Food distribution program administration, government",
  },
  {
    code: "923130",
    title: "Medical assistance programs administration, government",
  },
  {
    code: "923130",
    title: "Medicare and Medicaid administration",
  },
  {
    code: "923130",
    title: "Old age survivors and disability programs",
  },
  {
    code: "923130",
    title: "Railroad Retirement Board",
  },
  {
    code: "923130",
    title: "Social assistance cost-sharing, government",
  },
  {
    code: "923130",
    title: "Social Security Administration (SSA), federal",
  },
  {
    code: "923130",
    title: "Unemployment insurance program administration",
  },
  {
    code: "923130",
    title: "Welfare administration, nonoperating",
  },
  {
    code: "923130",
    title: "Welfare programs administration",
  },
  {
    code: "923130",
    title: "Women's bureaus",
  },
  {
    code: "923130",
    title: "Workers' compensation program administration",
  },
  {
    code: "923140",
    title: "Veterans' affairs offices",
  },
  {
    code: "923140",
    title: "Veterans' benefits program administration, government",
  },
  {
    code: "924110",
    title: "Enforcement of environmental and pollution control regulations",
  },
  {
    code: "924110",
    title: "Environmental protection program administration",
  },
  {
    code: "924110",
    title: "NOAA (National Oceanic and Atmospheric Administration)",
  },
  {
    code: "924110",
    title: "Pollution control program administration",
  },
  {
    code: "924110",
    title: "Sanitation engineering agencies, government",
  },
  {
    code: "924110",
    title: "Waste management program administration",
  },
  {
    code: "924110",
    title: "Water control and quality program administration",
  },
  {
    code: "924120",
    title: "Community recreation programs, government",
  },
  {
    code: "924120",
    title: "Conservation and reclamation agencies",
  },
  {
    code: "924120",
    title: "Fish and game agencies",
  },
  {
    code: "924120",
    title: "Fish and wildlife conservation program administration",
  },
  {
    code: "924120",
    title: "Game and inland fish agencies",
  },
  {
    code: "924120",
    title: "Game wardens",
  },
  {
    code: "924120",
    title: "Geological research program administration",
  },
  {
    code: "924120",
    title: "Land management program administration",
  },
  {
    code: "924120",
    title: "Parks and recreation commission, government",
  },
  {
    code: "924120",
    title: "Recreational programs administration, government",
  },
  {
    code: "924120",
    title: "Soil conservation services, government",
  },
  {
    code: "924120",
    title: "Weather research program administration",
  },
  {
    code: "924120",
    title: "Wildlife conservation agencies",
  },
  {
    code: "924120",
    title: "Wind and water erosion control agencies, government",
  },
  {
    code: "925110",
    title: "Building standards agencies, government",
  },
  {
    code: "925110",
    title: "Housing authorities, nonoperating",
  },
  {
    code: "925110",
    title: "Housing programs, planning and development, government",
  },
  {
    code: "925120",
    title: "Community development agencies, government",
  },
  {
    code: "925120",
    title: "County development agencies",
  },
  {
    code: "925120",
    title: "Land redevelopment agencies, government",
  },
  {
    code: "925120",
    title: "Redevelopment land agencies, government",
  },
  {
    code: "925120",
    title: "Regional planning and development program administration",
  },
  {
    code: "925120",
    title: "Urban planning commissions, government",
  },
  {
    code: "925120",
    title: "Zoning boards and commissions",
  },
  {
    code: "926110",
    title: "Arts and cultural program administration, government",
  },
  {
    code: "926110",
    title: "Consumer protection offices",
  },
  {
    code: "926110",
    title: "Councils of Economic Advisers",
  },
  {
    code: "926110",
    title: "Cultural and arts development support program administration",
  },
  {
    code: "926110",
    title: "Development assistance program administration",
  },
  {
    code: "926110",
    title: "Economic development agencies, government",
  },
  {
    code: "926110",
    title: "Energy development and conservation agencies, nonoperating",
  },
  {
    code: "926110",
    title: "Energy program administration",
  },
  {
    code: "926110",
    title: "Enterprise development program administration",
  },
  {
    code: "926110",
    title: "General economics statistical agencies",
  },
  {
    code: "926110",
    title: "Industrial development program administration",
  },
  {
    code: "926110",
    title: "Labor statistics agencies",
  },
  {
    code: "926110",
    title: "Small business development agencies",
  },
  {
    code: "926110",
    title: "Tourism development offices, government",
  },
  {
    code: "926110",
    title: "Trade commissions, government",
  },
  {
    code: "926110",
    title: "Trade development program administration",
  },
  {
    code: "926110",
    title: "Workforce Development Boards, nonoperating",
  },
  {
    code: "926120",
    title: "Aircraft inspection, government",
  },
  {
    code: "926120",
    title: "Coast Guard (except academy)",
  },
  {
    code: "926120",
    title: "Federal Aviation Administration (except air traffic control)",
  },
  {
    code: "926120",
    title: "Licensing of transportation equipment, facilities, and services",
  },
  {
    code: "926120",
    title: "Merchant Marine (except academy)",
  },
  {
    code: "926120",
    title: "Motor carrier licensing and inspection offices",
  },
  {
    code: "926120",
    title: "Motor vehicle licensing offices, government",
  },
  {
    code: "926120",
    title: "National Transportation Safety Board",
  },
  {
    code: "926120",
    title: "Port authorities and districts, nonoperating",
  },
  {
    code: "926120",
    title: "Public transportation commissions, nonoperating",
  },
  {
    code: "926120",
    title: "Railroad and warehouse commissions, nonoperating",
  },
  {
    code: "926120",
    title: "Transit systems and authorities, nonoperating",
  },
  {
    code: "926120",
    title: "Transportation departments, nonoperating",
  },
  {
    code: "926120",
    title: "Transportation regulatory agencies",
  },
  {
    code: "926120",
    title: "Transportation safety programs, government",
  },
  {
    code: "926130",
    title: "Communications commissions",
  },
  {
    code: "926130",
    title: "Communications licensing commissions and agencies",
  },
  {
    code: "926130",
    title: "Energy development and conservation programs, government",
  },
  {
    code: "926130",
    title: "Federal Communications Commission (FCC)",
  },
  {
    code: "926130",
    title: "Irrigation districts, nonoperating",
  },
  {
    code: "926130",
    title: "Licensing and inspecting of utilities",
  },
  {
    code: "926130",
    title: "Mosquito eradication districts",
  },
  {
    code: "926130",
    title: "Nuclear energy inspection and regulation offices",
  },
  {
    code: "926130",
    title: "Public service (except transportation) commissions, nonoperating",
  },
  {
    code: "926130",
    title: "Public utility (except transportation) commissions, nonoperating",
  },
  {
    code: "926130",
    title: "Regulation of utilities",
  },
  {
    code: "926130",
    title: "Sanitation districts, nonoperating",
  },
  {
    code: "926130",
    title: "Solar energy  regulation",
  },
  {
    code: "926130",
    title: "Wind generated electrical power regulation",
  },
  {
    code: "926140",
    title: "Agricultural cooperative extension program administration",
  },
  {
    code: "926140",
    title: "Agricultural marketing services government",
  },
  {
    code: "926140",
    title: "Agricultural pest and weed regulation, government",
  },
  {
    code: "926140",
    title: "Agriculture fair boards administration",
  },
  {
    code: "926140",
    title: "Animal quarantine service, government",
  },
  {
    code: "926140",
    title: "Food inspection agencies",
  },
  {
    code: "926140",
    title: "Pest control programs, agriculture, government",
  },
  {
    code: "926140",
    title: "Regulation and inspection of agricultural products",
  },
  {
    code: "926140",
    title: "Weed control, agriculture, government",
  },
  {
    code: "926150",
    title: "Alcoholic beverage control boards",
  },
  {
    code: "926150",
    title: "Banking regulatory agencies",
  },
  {
    code: "926150",
    title: "Building inspections, government",
  },
  {
    code: "926150",
    title: "Conciliation and mediation services, government",
  },
  {
    code: "926150",
    title: "Health professions licensure agencies",
  },
  {
    code: "926150",
    title: "Hospital licensure agencies",
  },
  {
    code: "926150",
    title: "Inspection for labor standards",
  },
  {
    code: "926150",
    title: "Insurance commissions, government",
  },
  {
    code: "926150",
    title: "Labor management negotiations boards, government",
  },
  {
    code: "926150",
    title: "Licensing and permit issuance for business operations, government",
  },
  {
    code: "926150",
    title:
      "Licensing and permit issuance for professional occupations, government",
  },
  {
    code: "926150",
    title: "Mediation and conciliation services, government",
  },
  {
    code: "926150",
    title: "Minimum wage program administration",
  },
  {
    code: "926150",
    title: "Occupational safety and health administration",
  },
  {
    code: "926150",
    title: "Occupational safety and health standards agencies",
  },
  {
    code: "926150",
    title: "Pet licensing",
  },
  {
    code: "926150",
    title: "Price control agencies",
  },
  {
    code: "926150",
    title: "Rent control agencies",
  },
  {
    code: "926150",
    title: "Securities regulation commissions",
  },
  {
    code: "926150",
    title: "Standards, setting and management, agencies, government",
  },
  {
    code: "926150",
    title: "Wage control agencies, government",
  },
  {
    code: "927110",
    title: "National Aeronautics and Space Administration",
  },
  {
    code: "927110",
    title: "Operating and launching government satellites",
  },
  {
    code: "927110",
    title: "Space flight operations, government",
  },
  {
    code: "927110",
    title: "Space research services, government",
  },
  {
    code: "928110",
    title: "Air Force",
  },
  {
    code: "928110",
    title: "Air traffic control, military",
  },
  {
    code: "928110",
    title: "Armed forces",
  },
  {
    code: "928110",
    title: "Army",
  },
  {
    code: "928110",
    title: "Courts, military",
  },
  {
    code: "928110",
    title: "Marine Corps",
  },
  {
    code: "928110",
    title: "Military bases and camps",
  },
  {
    code: "928110",
    title: "Military police",
  },
  {
    code: "928110",
    title: "Military reserve armories and bases",
  },
  {
    code: "928110",
    title: "Military training schools (except academies)",
  },
  {
    code: "928110",
    title: "National Guard",
  },
  {
    code: "928110",
    title: "Navy",
  },
  {
    code: "928110",
    title: "Space Force",
  },
  {
    code: "928120",
    title: "Consulates",
  },
  {
    code: "928120",
    title: "Diplomatic services",
  },
  {
    code: "928120",
    title: "Economic development assistance (i.e., international), government",
  },
  {
    code: "928120",
    title: "Embassies",
  },
  {
    code: "928120",
    title: "Foreign economic and social development services, government",
  },
  {
    code: "928120",
    title: "Foreign government service",
  },
  {
    code: "928120",
    title: "Foreign missions",
  },
  {
    code: "928120",
    title: "Immigration services",
  },
  {
    code: "928120",
    title: "International Monetary Fund",
  },
  {
    code: "928120",
    title: "Organization for Economic Cooperation and Development",
  },
  {
    code: "928120",
    title: "Organization of American States",
  },
  {
    code: "928120",
    title: "Passport issuing services",
  },
  {
    code: "928120",
    title: "Peace Corps",
  },
  {
    code: "928120",
    title: "State Department",
  },
  {
    code: "928120",
    title: "United Nations",
  },
  {
    code: "928120",
    title: "World Bank",
  },
  {
    code: "******",
    title: "Cards, publishing -- see specific product ",
  },
  {
    code: "******",
    title: "Clinics, medical -- see type ",
  },
  {
    code: "******",
    title: "Consultants -- see specific activity ",
  },
  {
    code: "******",
    title: "Contractors -- see specific activity ",
  },
  {
    code: "******",
    title: "Day camps, instructional -- see type of instruction ",
  },
  {
    code: "******",
    title: "Dealers -- see type ",
  },
  {
    code: "******",
    title: "Farming -- see type ",
  },
  {
    code: "******",
    title: "Hospitals -- see type ",
  },
  {
    code: "******",
    title: "Instruction -- see type of training ",
  },
  {
    code: "******",
    title: "Laboratories -- see specific type ",
  },
  {
    code: "******",
    title: "Leasing -- see type of property or article being leased ",
  },
  {
    code: "******",
    title:
      "Lessors -- see specific type of asset or property being rented or leased ",
  },
  {
    code: "******",
    title: "Mining -- see type ",
  },
  {
    code: "******",
    title: "Publishers -- see specific type ",
  },
  {
    code: "******",
    title:
      "Publishers and printing combined -- see specific type of publisher ",
  },
  {
    code: "******",
    title: "Publishers or publishing -- see specific type ",
  },
  {
    code: "******",
    title: "Rental -- see type of article or property being rented ",
  },
  {
    code: "******",
    title: "Repair -- see type of article being repaired ",
  },
  {
    code: "******",
    title: "Retail -- see type of dealer, shop, or store ",
  },
  {
    code: "******",
    title: "Shops -- see type ",
  },
  {
    code: "******",
    title: "Stores -- see type ",
  },
  {
    code: "******",
    title: "Tailors -- see specific apparel manufacturing ",
  },
  {
    code: "******",
    title: "Therapists' offices -- see type ",
  },
  {
    code: "******",
    title: "Transportation -- see mode ",
  },
  {
    code: "******",
    title: "Wholesale -- see type of product ",
  },
];
